export default {
  'pages.layouts.userLayout.title': 'TaoExpress 管理系统',
  'pages.layouts.adminPanel.title': '管理面板',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': 
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.login.adminCenter': '管理中心',
  'pages.login.adminSystem': '管理系统',
  'pages.login.signInTitle': '管理员登录',
  'pages.login.signInDescription': '登录 TodayMall 管理面板',
  'pages.login.identifier.label': '邮箱或 ID',
  'pages.login.password.label': '密码',
  'pages.login.email.placeholder': '邮箱地址',
  'pages.login.email.required': '请输入邮箱',
  'pages.login.email.invalid': '邮箱格式不正确',
  'pages.login.identifier.placeholder': '邮箱或用户 ID',
  'pages.login.identifier.required': '请输入邮箱或用户 ID',
  'pages.login.keepLoggedIn': '保持登录状态',
  'pages.login.secureAccessNotice': '仅限已授权的管理员访问。',
  'pages.login.forgotPasswordQuestion': '忘记密码？',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.searchTable.selectItemsToDelete': '请选择删除项',
  
  // Home Dashboard
  'pages.home.todayOrders': '今日订单数',
  'pages.home.todaySales': '今日销售额',
  'pages.home.processingRate': '配送处理率',
  'pages.home.newMembers': '新增会员',
  'pages.home.orderStatus': '当前订单状态',
  'pages.home.pendingPayment': '待付款',
  'pages.home.pendingAddress': '待填写地址',
  'pages.home.inChinaWarehouse': '中国仓库',
  'pages.home.inKoreaDelivery': '配送中',
  'pages.home.recentOrders': '实时订单记录',
  'pages.home.pendingTasks': '待处理任务',
  'pages.home.pendingInquiries': '未回复咨询',
  'pages.home.salesGrowth': '今日销售增长率',
  'pages.home.comparedYesterday': '较昨日上升',
  'pages.home.goTo': '前往',
  'pages.home.count': '件',
  'pages.home.people': '人',
  'pages.home.won': '元',
  
  // Common
  'pages.common.search': '搜索',
  'pages.common.reset': '重置',
  'pages.common.yearN': '{n}年',
  'pages.common.monthN': '{n}月',
  'pages.common.add': '添加',
  'pages.common.edit': '编辑',
  'pages.common.delete': '删除',
  'pages.common.save': '保存',
  'pages.common.cancel': '取消',
  'pages.common.upload': '上传',
  'pages.common.uploadSuccess': '上传成功。',
  'pages.common.uploadFailed': '上传失败。',
  'pages.common.change': '更换',
  'pages.common.confirm': '确认',
  'pages.common.pagination.total': '共 {total} 条，显示 {range0}-{range1}',
  'pages.common.actions': '操作',
  'pages.common.id': 'ID',
  'pages.common.status': '状态',
  'pages.common.createdAt': '创建时间',
  'pages.common.updatedAt': '更新时间',
  'pages.common.clearFilter': '清除筛选',
  'pages.common.export': '导出',
  /** 列表 / 筛选工具栏 Excel 下载按钮共用文案 */
  'pages.common.exportExcel': '导出 Excel',
  'pages.common.exportSuccess': '数据导出成功',
  'pages.common.operate': '操作',
  'pages.common.yes': '是',
  'pages.common.no': '否',
  'pages.common.won': '₩',
  'pages.common.count': 'ea',
  'pages.common.unit': '个',
  'pages.common.people': '人',
  'pages.common.detail': '详情',
  'pages.common.close': '关闭',
  'pages.common.visible': '可见',
  'pages.common.hidden': '隐藏',
  'pages.common.preview': '预览',
  'pages.common.view': '查看',
  'pages.common.active': '激活',
  'pages.common.inactive': '未激活',
  'pages.common.refresh': '刷新',
  'pages.common.required': '此字段为必填项',
  'pages.common.bold': '粗体',
  'pages.common.italic': '斜体',
  'pages.common.underline': '下划线',
  'pages.common.alignLeft': '左对齐',
  'pages.common.alignCenter': '居中对齐',
  'pages.common.alignRight': '右对齐',
  'pages.common.image': '图片',
  'pages.common.link': '链接',
  'pages.common.chooseFile': '选择文件',
  'pages.common.list': '列表',
  'pages.common.use': '使用',
  'pages.common.notUse': '不使用',
  'pages.common.correction': '修改',
  'pages.common.addSuccess': '添加成功',
  'pages.common.createSuccess': '创建成功',
  'pages.common.createFailed': '创建失败',
  'pages.common.updateSuccess': '更新成功',
  'pages.common.updateFailed': '更新失败',
  'pages.common.deleteSuccess': '删除成功',
  'pages.common.deleteFailed': '删除失败',
  'pages.common.saveSuccess': '保存成功',
  'pages.common.deleteConfirm': '删除确认',
  
  // Order Status
  'pages.home.status.paymentComplete': '付款完成',
  'pages.home.status.pendingAddress': '待填写地址',
  'pages.home.status.inChinaWarehouse': '中国仓库入库',
  'pages.home.status.inTransit': '配送中',
  'pages.home.status.delivered': '配送完成',
  
  // Time
  'pages.home.time.minutesAgo': '{minutes}分钟前',
  'pages.home.time.hoursAgo': '{hours}小时前',
  
  // Products List Page
  // Products Operation Data
  'pages.products.operationData.title': '运营数据',
  'pages.products.operationData.todayOrderAmount': '今日订单金额',
  'pages.products.operationData.todayOrderCount': '今日订单数量',
  'pages.products.operationData.todayPayingUsers': '今日支付人数',
  'pages.products.operationData.yesterday': '昨日',
  'pages.products.operationData.monthOnMonthChange': '环比变化',
  'pages.products.operationData.transactionOverview': '交易概览',
  'pages.products.operationData.query': '查询',
  'pages.products.operationData.reset': '重置',
  'pages.products.operationData.orderSales': '订单销售额',
  'pages.products.operationData.totalGoodsPaid': '商品支付总额',
  'pages.products.operationData.orderCouponDeduction': '订单优惠券抵扣金额',
  'pages.products.operationData.orderPointsDeduction': '订单积分抵扣金额',
  'pages.products.operationData.orderRefundAmount': '订单退款金额',
  'pages.products.operationData.orderBalance': '订单余额',
  'pages.products.operationData.waybillSales': '运单销售额',
  'pages.products.operationData.waybillCouponDeduction': '运单优惠券抵扣金额',
  'pages.products.operationData.waybillRefundAmount': '运单退款金额',
  'pages.products.operationData.waybillSupplementAmount': '运单补款金额',
  'pages.products.operationData.totalRechargeAmount': '总充值金额',
  'pages.products.operationData.commissionRebateAmount': '佣金返利金额',
  'pages.products.operationData.commissionWithdrawalAmount': '佣金提现金额',
  // New Operation Data Metrics
  'pages.products.operationData.productPayment': '商品支付',
  'pages.products.operationData.couponDiscount': '优惠券折扣金额',
  'pages.products.operationData.logisticsAmount': '物流金额',
  'pages.products.operationData.rechargeAmount': '充值金额',
  'pages.products.operationData.refundAmount': '退款金额',
  'pages.products.operationData.rebateAmount': '返利金额',
  'pages.products.operationData.couponEarned': '优惠券获得金额',
  'pages.products.operationData.paymentCount': '支付笔数',
  'pages.products.operationData.couponUsageCount': '优惠券使用笔数',
  'pages.products.operationData.logisticsCount': '物流笔数',
  'pages.products.operationData.withdrawalAmount': '提现金额',
  'pages.products.operationData.refundCount': '退款笔数',
  'pages.products.operationData.rebateCount': '返利笔数',
  'pages.products.operationData.couponEarnedCount': '优惠券获得笔数',
  'pages.products.operationData.visitCount': '访问量',
  'pages.products.operationData.pointUsage': '积分使用',
  'pages.products.operationData.pointUsageCount': '积分使用笔数',
  // Charts
  'pages.products.operationData.websiteRevenue': '网站收入',
  'pages.products.operationData.websiteExpenses': '网站支出',
  'pages.products.operationData.procurementAnalysis': '采购分析',
  'pages.products.operationData.commissionTransactions': '佣金交易',
  'pages.products.operationData.orderStatistics': '订单统计',
  'pages.products.operationData.waybillStatistics': '运单统计',
  'pages.products.operationData.salesAmount': '销售额',
  'pages.products.operationData.paymentOrders': '支付单量',
  'pages.products.operationData.payingUsers': '支付人数',
  'pages.products.operationData.replenishmentAmount': '补款金额',
  'pages.products.operationData.totalRebateCommission': '返利总佣金',
  'pages.products.operationData.purchaseOrderCost': '采购订单成本',
  'pages.products.operationData.numberOfPurchasedItems': '采购商品数',
  'pages.products.operationData.totalPaymentAmountForItems': '付款商品总额',
  'pages.products.operationData.numberOfPromotedUsers': '推广用户数量',
  'pages.products.operationData.numberOfPromotedUserOrders': '推广用户订单数',
  'pages.products.list.title': '商品列表',
  'pages.products.list.storeListTitle': '商店列表',
  'pages.products.list.productsListTitle': '商品列表',
  'pages.products.list.backToStores': '返回商店',
  'pages.products.list.priceUpdateSuccess': '价格更新成功',
  'pages.products.list.priceUpdateFailed': '价格更新失败',
  'pages.products.list.importTaobao': '淘宝导入',
  'pages.products.list.importExcel': '导入Excel',
  'pages.products.list.exportExcel': '导出Excel',
  'pages.products.list.addProduct': '添加商品',
  'pages.products.list.thumbnail': '商品图片',
  'pages.products.list.copyOfferIdHint': '复制的商品。上方为原商品编号，括号内 {offerId} 为本商品内部编号（订单中显示的编号）。库存与原商品同步。',
  'pages.products.list.productName': '商品名称',
  'pages.products.list.category': '分类',
  'pages.products.list.price': '售价',
  'pages.products.list.stock': '库存',
  'pages.products.list.amountOnSale': '可售数量',
  'pages.products.list.salesCount': '销量',
  'pages.products.list.productNo': '货号',
  'pages.products.list.productNoHint': '顾客页面显示的货号。为空时显示 OfferId。',
  'pages.products.list.sellingSellers': '在售卖家',
  'pages.products.list.status': '状态',
  'pages.products.list.createdAt': '创建时间',
  'pages.products.list.brand': '品牌',
  'pages.products.list.priceCny': '人民币单价',
  'pages.products.list.salePrice': '销售价格',
  'pages.products.list.salesPeriod': '销售期间',
  'pages.products.list.categoryType': '产品类别类型',
  'pages.products.list.event': '活动',
  'pages.products.list.actions': '操作',
  'pages.products.list.edit': '编辑',
  'pages.products.list.delete': '删除',
  'pages.products.list.deleteConfirm': '确定要删除吗？',
  'pages.products.list.deleteSuccess': '删除成功',
  'pages.products.list.copySuccess': '商品复制成功',
  'pages.products.list.copyError': '商品复制失败',
  'pages.products.list.batchDelete': '批量删除',
  'pages.products.list.batchDeleteConfirm': '删除{count}个商品？',
  'pages.products.list.batchDeleteSuccess': '已删除选中商品',
  'pages.products.list.batchUpdatePrice': '批量更新价格',
  'pages.products.list.batchUpdateCategory': '批量更新分类',
  'pages.products.list.batchUpdatePriceTitle': '批量更新销售价格',
  'pages.products.list.batchUpdateCategoryTitle': '批量更新分类',
  'pages.products.list.batchUpdatePriceSuccess': '销售价格更新成功',
  'pages.products.list.batchUpdateCategorySuccess': '分类更新成功',
  // 把选中的商品一次性添加到多个卖家页面
  'pages.products.list.addToSellerPages': '添加到卖家页面',
  'pages.products.list.addToSellerPages.title': '将商品添加到卖家页面',
  'pages.products.list.addToSellerPages.confirm': '添加',
  'pages.products.list.addToSellerPages.description': '已选择的 {count} 个商品将添加到下面选中的每个卖家页面。',
  'pages.products.list.addToSellerPages.selectProduct': '请至少选择一个商品。',
  'pages.products.list.addToSellerPages.selectSeller': '请至少选择一位卖家。',
  'pages.products.list.addToSellerPages.result':
    '已在 {sellers} 个卖家页面添加 {count} 条。{skipped, plural, =0 {} other { 已存在的 # 条已跳过。}}',
  'pages.products.list.addToSellerPages.partialResult':
    '成功 {count} 条{skipped, plural, =0 {} other {，跳过 # 条}}，失败 {failed} 条（{reasons}）',
  'pages.products.list.addToSellerPages.failed': '登记失败。',
  'pages.products.list.addToSellerPages.failReason.item': '{label} {count} 个',
  'pages.products.list.addToSellerPages.failReason.ownedByOtherSeller': '属于其他卖家的商品',
  'pages.products.list.addToSellerPages.failReason.notFound': '商品不存在',
  'pages.products.list.addToSellerPages.failReason.createFailed': '登记出错',
  // 在"销售中卖家"列把单个商品关联到多个卖家
  'pages.products.list.linkSellers': '关联卖家',
  'pages.products.list.linkSellers.title': '选择销售该商品的卖家',
  'pages.products.list.linkSellers.confirm': '关联',
  'pages.products.list.linkSellers.description':
    '{title} — 当前有 {count} 位卖家在售。请选择要新增关联的卖家；取消关联请在卖家页面操作。',
  'pages.products.list.linkSellers.alreadyLinked': '已关联',
  'pages.products.list.linkSellers.noNewSeller': '只选择了已关联的卖家。请选择要新增的卖家。',
  'pages.products.list.batchUpdatePriceNote': '注意：价格计算基于每个产品的当前销售价格。',
  'pages.products.list.priceOperation': '价格操作',
  'pages.products.list.multiply': '乘以',
  'pages.products.list.add': '加上',
  'pages.products.list.amount': '金额',
  'pages.products.list.amountHint': '乘以: 2 = ×2, 3 = ×3. 加上: 1000 = +1000',
  'pages.products.list.selectedProducts': '已选择 {count} 个商品',
  'pages.products.list.selectCategory': '选择分类',
  'pages.products.list.selectCategoryPlaceholder': '请选择分类',
  'pages.products.list.totalProducts': '共{total}个商品',
  'pages.products.list.preview': '预览',
  'pages.products.list.lowStock': '库存不足 ({stock})',
  'pages.products.list.status.selling': '销售中',
  'pages.products.list.status.stopped': '已停售',
  'pages.products.list.status.outOfStock': '缺货',
  'pages.products.list.status.reviewing': '审核中',
  'pages.products.list.status.active': '销售中',
  'pages.products.list.status.onSale': '在售',
  'pages.products.list.status.offSale': '停售',
  'pages.products.list.status.draft': '草稿',
  'pages.products.list.displayStatus': '显示状态',
  'pages.products.list.displayStatus.visible': '可见',
  'pages.products.list.displayStatus.hidden': '隐藏',
  'pages.products.list.store.title': '店铺列表',
  'pages.products.list.store.name': '店铺名称',
  'pages.products.list.store.count': '数量',
  'pages.products.list.store.image': '图片',
  'pages.products.list.store.status': '状态',
  'pages.products.list.store.active': '激活',
  'pages.products.list.store.inactive': '未激活',
  'pages.products.list.store.sortOrder': '排序',
  'pages.products.list.store.viewProducts': '查看商品',
  'pages.products.list.store.backToStores': '返回店铺列表',
  'pages.products.list.store.totalStores': '共 {total} 个店铺',
  'pages.products.list.store.selectStoreToViewProducts': '请选择店铺以查看商品列表',
  'pages.products.list.searchProductName': '搜索产品名称',
  'pages.products.list.category.fashion': '时尚',
  'pages.products.list.category.beauty': '美妆',
  'pages.products.list.category.living': '生活',
  'pages.products.list.category.digital': '数码',
  'pages.products.list.category.food': '食品',
  'pages.products.list.category.sports': '运动',
  'pages.products.list.category.toy': '玩具',
  'pages.products.list.category.appliance': '家电',
  
  // Product Form Modal
  'pages.products.form.title': '商品登记',
  'pages.products.form.category': '分类',
  'pages.products.form.brand': '品牌',
  'pages.products.form.productName': '商品名称',
  'pages.products.form.originalPrice': '商品原价',
  'pages.products.form.salePrice': '销售价格',
  'pages.products.form.productType': '商品类型',
  'pages.products.form.productType.own': '公司商城',
  'pages.products.form.productType.live': '直播',
  'pages.products.form.salesPeriod': '销售期间',
  'pages.products.form.startDate': '开始日期',
  'pages.products.form.endDate': '结束日期',
  'pages.products.form.thumbnailImage': '代表图片',
  'pages.products.form.productImages': '商品图片',
  'pages.products.form.color': '颜色',
  'pages.products.form.size': '尺寸',
  'pages.products.form.siteUrl': '网站',
  'pages.products.form.originalPlace': '原始商品',
  'pages.products.form.recommendedCategory': '推荐商品分类',
  'pages.products.form.recommendedType': '推荐商品类型',
  'pages.products.form.event': '推荐商品活动',
  'pages.products.form.shortDescription': '简要说明',
  'pages.products.form.siteAddress': '网站地址',
  'pages.products.form.useStatus': '使用状态',
  'pages.products.form.detailDescription': '详细说明',
  'pages.products.form.save': '保存',
  'pages.products.form.close': '关闭',
  'pages.products.form.use': '使用',
  'pages.products.form.notUse': '不使用',
  'pages.products.form.colorSizeHint': '* 输入多个颜色和尺寸时，用 | 分隔 例如) Black|White|Blue|Green',
  
  // Products Add Page
  'pages.products.add.title': '添加商品',
  'pages.products.add.addAttribute': '添加属性',
  'pages.products.add.preview': '预览',
  'pages.products.add.submit': '添加商品',
  'pages.products.add.uploadSuccess': '上传成功',
  'pages.products.add.uploadFailed': '上传失败',
  'pages.products.add.descImageUploadHint':
    '可一次选择多张图片上传，或在下方填写一张图片 URL（可选）。',
  'pages.products.add.descImageUpload': '上传图片',
  'pages.products.add.descImageUploadBtn': '上传',
  'pages.products.add.descImageUrlLabel': '或填写一张图片 URL（可选）',
  'pages.products.add.descImagePreview': '预览',
  'pages.products.add.descImageWaitUpload': '请等待所有图片上传完成。',
  'pages.products.add.descImageNeedOne': '请至少上传一张图片或填写图片 URL。',
  'pages.products.add.descImageInserted': '已成功插入 {count} 张图片。',
  'pages.products.add.saveProduct': '保存商品',
  'pages.products.add.cancel': '取消',
  'pages.products.add.scrollToTop': '回到顶部',
  'pages.products.add.success': '商品添加成功',
  'pages.products.add.error': '请填写必填项',
  'pages.products.add.basicInfo': '基本信息',
  'pages.products.add.productName': '商品名称',
  'pages.products.add.productNamePlaceholder': '输入商品名称',
  'pages.products.add.productNameRequired': '请输入商品名称',
  'pages.products.add.category': '分类',
  'pages.products.add.categoryPlaceholder': '选择分类',
  'pages.products.add.categoryRequired': '请选择分类',
  'pages.products.add.brand': '品牌',
  'pages.products.add.brandPlaceholder': '品牌名称',
  'pages.products.add.description': '商品描述',
  'pages.products.add.descriptionPlaceholder': '输入详细商品描述',
  'pages.products.add.descriptionRequired': '请输入描述',
  'pages.products.add.price': '售价',
  'pages.products.add.pricePlaceholder': '0',
  'pages.products.add.priceRequired': '请输入价格',
  'pages.products.add.originalPrice': '原价',
  'pages.products.add.stock': '库存',
  'pages.products.add.sku': 'SKU代码',
  'pages.products.add.skuPlaceholder': 'SKU-001',
  'pages.products.add.barcode': '条形码',
  'pages.products.add.barcodePlaceholder': '条形码号',
  'pages.products.add.options': '商品选项',
  'pages.products.add.addOption': '添加选项',
  'pages.products.add.optionName': '选项名称',
  'pages.products.add.optionNamePlaceholder': '例如：黑色/M',
  'pages.products.add.optionImage': '选项图片',
  'pages.products.add.optionImageUrlPlaceholder': '输入图片URL',
  'pages.products.add.bulkUploadImage': '批量上传',
  'pages.products.add.bulkClearImage': '批量清除',
  'pages.products.add.imageBulkUpdated': '图片已批量更新',
  'pages.products.add.imageBulkCleared': '图片已批量清除',
  'pages.products.add.deleteSelected': '删除所选',
  'pages.products.add.confirmDeleteSelected': '确定删除所选行吗？',
  'pages.products.add.noRowsSelected': '请选择要删除的行',
  'pages.products.add.rowsDeleted': '已删除所选行',
  'pages.products.add.tempSave': '暂存',
  'pages.products.add.tempSaveSuccess': '已暂存',
  'pages.products.add.tempSaveError': '暂存失败',
  'pages.products.add.optionPrice': '附加价格',
  'pages.products.add.optionStock': '库存',
  'pages.products.add.optionSku': 'SKU',
  'pages.products.add.inputSellingPrice': '输入销售价格',
  'pages.products.add.tagPrice': '标签价格',
  'pages.products.add.inputTagPrice': '输入标签价格',
  'pages.products.add.save': '保存',
  'pages.products.add.salePriceTooLow': '售价不能低于成本价 (₩{min})',
  'pages.products.add.tagPriceTooLow': '标签价不能低于售价 (₩{min})',
  'pages.products.add.shippingInfo': '配送信息',
  'pages.products.add.weight': '重量 (kg)',
  'pages.products.add.width': '宽度 (cm)',
  'pages.products.add.height': '高度 (cm)',
  'pages.products.add.depth': '深度 (cm)',
  'pages.products.add.shippingMethod': '配送方式',
  'pages.products.add.shippingMethodPlaceholder': '选择配送方式',
  'pages.products.add.additionalInfo': '附加信息',
  'pages.products.add.tags': '标签',
  'pages.products.add.tagsPlaceholder': '输入标签（按Enter添加）',
  'pages.products.add.keywords': '搜索关键词',
  'pages.products.add.keywordsPlaceholder': '搜索关键词（逗号分隔）',
  'pages.products.add.keywordsTooltip': '输入关键词后按 Enter 或逗号添加',
  'pages.products.add.memo': '管理员备注',
  'pages.products.add.memoPlaceholder': '管理员备注',
  'pages.products.add.images': '商品图片',
  'pages.products.add.uploadImage': '上传图片',
  'pages.products.add.imageRequired': '请至少上传1张图片',
  'pages.products.add.imageNote1': '最多10张图片',
  'pages.products.add.imageNote2': '推荐尺寸：800x800px',
  'pages.products.add.imageNote3': '第一张图片将作为主图',
  'pages.products.add.salesSettings': '销售设置',
  'pages.products.add.salesStatus': '销售状态',
  'pages.products.add.displayStatus': '显示状态',
  'pages.products.add.featured': '推荐商品',
  'pages.products.add.newArrival': '新品',
  'pages.products.add.bestSeller': '畅销品',
  'pages.products.add.originInfo': '原产地信息',
  'pages.products.add.origin': '制造国',
  'pages.products.add.originPlaceholder': '选择国家',
  'pages.products.add.manufacturer': '制造商',
  'pages.products.add.manufacturerPlaceholder': '制造商名称',
  'pages.products.add.importDate': '进口日期',
  'pages.products.add.storeInfo': '店铺信息',
  'pages.products.add.storeName': '店铺名称',
  'pages.products.add.storeNamePlaceholder': '请输入店铺名称',
  'pages.products.add.storeSelect': '选择店铺',
  'pages.products.add.storeSelectPlaceholder': '请选择店铺',
  'pages.products.add.storeRequired': '请选择店铺',
  'pages.products.add.review': '评价',
  'pages.products.add.reviewPlaceholder': '评价评分 (0-5)',
  'pages.products.add.soldout': '销量',
  'pages.products.add.soldoutPlaceholder': '已售商品数量',
  'pages.products.add.previewModal': '商品预览',
  'pages.products.add.previewDev': '预览功能正在开发中。',
  'pages.products.add.yes': '是',
  'pages.products.add.no': '否',
  'pages.products.add.show': '显示',
  'pages.products.add.hide': '隐藏',
  'pages.products.add.category.clothing': '服装',
  'pages.products.add.category.shoes': '鞋类',
  'pages.products.add.category.bags': '包类',
  'pages.products.add.category.accessories': '配饰',
  'pages.products.add.category.electronics': '电子产品',
  'pages.products.add.category.home': '家居/生活',
  'pages.products.add.status.active': '销售中',
  'pages.products.add.status.inactive': '已停售',
  'pages.products.add.status.soldout': '缺货',
  'pages.products.add.status.preparing': '准备中',
  'pages.products.add.addSpecification': '添加规格',
  'pages.products.add.attributeNameCn': '属性名称 (中文)',
  'pages.products.add.attributeNameKo': '属性名称 (韩文)',
  'pages.products.add.attributeNameEn': '属性名称 (英文)',
  'pages.products.add.attributePlaceholderCn': '例如: 颜色',
  'pages.products.add.attributePlaceholderKo': '例如: 색상',
  'pages.products.add.attributePlaceholderEn': '例如: Color',
  'pages.products.add.attributeValueCn': '属性值 (中文)',
  'pages.products.add.attributeValueKo': '属性值 (韩文)',
  'pages.products.add.attributeValueEn': '属性值 (英文)',
  'pages.products.add.attributeValuePlaceholderCn': '例如: 红色,蓝色,绿色',
  'pages.products.add.attributeValuePlaceholderKo': '例如: 빨강,파랑,초록',
  'pages.products.add.attributeValuePlaceholderEn': '例如: Red,Blue,Green',
  'pages.products.add.fillAllAttributes': '请至少填写一种语言的属性名称和值',
  'pages.products.add.attributeSync.result':
    '属性列表已同步 — 新增 {added} 个,删除 {removed} 个,共 {total} 个',
  'pages.products.add.atLeastOneLanguageRequired': '属性名称和值至少需要填写一种语言',
  'pages.products.add.optionRequired': '请至少添加一个选项',
  'pages.products.add.optionCategoryRequired': '请先设置选项类别名称',
  'pages.products.add.optionCategoryName': '选项类别名称',
  'pages.products.add.specificationRequired': '请至少添加一个规格',
  'pages.products.add.shipping.air': '航空',
  'pages.products.add.shipping.airExpress': '航空快递',
  'pages.products.add.shipping.sea': '海运',
  'pages.products.add.shipping.seaExpress': '海运快递',
  'pages.products.add.country.CN': '中国',
  'pages.products.add.country.KR': '韩国',
  'pages.products.add.country.US': '美国',
  'pages.products.add.country.JP': '日本',
  'pages.products.add.country.EU': '欧洲',
  'pages.products.add.tag.new': '新品',
  'pages.products.add.tag.popular': '热门',
  'pages.products.add.tag.sale': '促销',
  'pages.products.add.tag.recommended': '推荐',
  'pages.products.add.promotionLink': '促销链接',
  'pages.products.add.promotionLinkPlaceholder': '输入促销链接（例如淘宝/1688商品URL）',
  'pages.products.add.offerId': '商品编号（Offer ID）',
  'pages.products.add.offerIdPlaceholder': '输入商品编号（Offer ID）',
  'pages.products.add.offerIdTooltip': '可从促销链接自动填充，也可手动输入',
  'pages.products.add.titleKoRequired': '请输入韩文商品名称',
  'pages.products.add.specifications': '商品规格',
  'pages.products.add.productDetail': '商品详情',
  'pages.products.add.sellerInfo': '卖家信息',
  'pages.products.add.displayMetrics': '展示数值',
  'pages.products.add.displayMetricsNotice':
    '仅用于展示给客户的数值，与真实订单和评价数据无关。',
  'pages.products.add.reviewCount': '评价数量',
  'pages.products.add.reviewCountPlaceholder': '输入评价数量',
  'pages.products.add.reviewScore': '评分',
  'pages.products.add.reviewScorePlaceholder': '输入评分 (0-5)',
  'pages.products.add.repurchaseRate': '复购率 (%)',
  'pages.products.add.repurchaseRatePlaceholder': '输入复购率 (0-100)',
  'pages.products.add.copy': '复制',
  'pages.products.add.paste': '粘贴',
  'pages.products.add.companyNamePlaceholder': '公司名称',
  'pages.products.add.sellerAddressPlaceholder': '卖家地址',
  'pages.products.add.sellerPhonePlaceholder': '卖家电话',
  'pages.products.add.sellerOpenIdPlaceholder': '卖家 Open ID / Shop ID',
  'pages.products.add.editor.bold': '加粗',
  'pages.products.add.editor.italic': '斜体',
  'pages.products.add.editor.underline': '下划线',
  'pages.products.add.editor.alignLeft': '左对齐',
  'pages.products.add.editor.alignCenter': '居中',
  'pages.products.add.editor.alignRight': '右对齐',
  'pages.products.add.editor.orderedList': '有序列表',
  'pages.products.add.editor.unorderedList': '无序列表',
  'pages.products.add.editor.insertImage': '插入图片',
  'pages.products.add.editor.insertLink': '插入链接',
  'pages.products.add.editor.insertUrl': '请输入 URL：',
  'pages.products.add.editor.normal': '正文',
  'pages.products.add.editor.heading1': '标题 1',
  'pages.products.add.editor.heading2': '标题 2',
  'pages.products.add.editor.heading3': '标题 3',
  'pages.products.add.editor.heading4': '标题 4',

  // Products Edit Page
  'pages.products.edit.title': '编辑商品',
  'pages.products.edit.submit': '更新商品',
  'pages.products.edit.saveProduct': '更新商品',
  'pages.products.edit.updateSuccess': '商品更新成功',
  'pages.products.edit.success': '商品更新成功',
  'pages.products.edit.error': '请填写必填项',
  'pages.products.edit.productIdRequired': '需要商品ID',
  'pages.products.edit.productNotFound': '未找到商品',
  'pages.products.edit.loadSuccess': '商品加载成功',
  'pages.products.edit.loadError': '加载商品数据失败',
  'pages.products.edit.loading': '加载商品数据...',
  'pages.products.edit.back': '返回',
  'pages.products.edit.reset': '恢复原值',
  'pages.products.edit.resetSuccess': '商品数据已恢复为原始值',
  'pages.products.edit.noOriginalData': '没有可恢复的原始数据',

  // Products Preview
  'pages.products.preview.close': '关闭',
  'pages.products.preview.images': '商品图片',
  'pages.products.preview.basicInfo': '基本信息',
  'pages.products.preview.productName': '商品名称',
  'pages.products.preview.category': '分类',
  'pages.products.preview.brand': '品牌',
  'pages.products.preview.description': '商品描述',
  'pages.products.preview.priceStock': '价格和库存',
  'pages.products.preview.price': '售价',
  'pages.products.preview.originalPrice': '原价',
  'pages.products.preview.stock': '库存',
  'pages.products.preview.sku': 'SKU代码',
  'pages.products.preview.barcode': '条形码',
  'pages.products.preview.options': '商品选项',
  'pages.products.preview.optionName': '选项名称',
  'pages.products.preview.optionPrice': '附加价格',
  'pages.products.preview.optionStock': '库存',
  'pages.products.preview.optionSku': 'SKU',
  'pages.products.preview.shippingInfo': '配送信息',
  'pages.products.preview.weight': '重量',
  'pages.products.preview.dimensions': '尺寸',
  'pages.products.preview.shippingMethod': '配送方式',
  'pages.products.preview.salesSettings': '销售设置',
  'pages.products.preview.status': '销售状态',
  'pages.products.preview.displayStatus': '显示状态',
  'pages.products.preview.featured': '推荐商品',
  'pages.products.preview.newArrival': '新品',
  'pages.products.preview.bestSeller': '畅销品',
  'pages.products.preview.additionalInfo': '附加信息',
  'pages.products.preview.tags': '标签',
  'pages.products.preview.keywords': '搜索关键词',
  'pages.products.preview.memo': '管理员备注',
  'pages.products.preview.originInfo': '原产地信息',
  'pages.products.preview.origin': '制造国',
  'pages.products.preview.manufacturer': '制造商',
  'pages.products.preview.importDate': '进口日期',

  // Products Category Management
  'pages.products.category.title': '分类管理',
  'pages.products.companymallCategory.title': '自营商城分类管理',
  'pages.products.category.storeName': '店铺名称',
  'pages.products.category.selectStore': '选择店铺',
  'pages.products.category.selectCategory': '选择分类',
  'pages.products.category.storeRequired': '店铺是必选的',
  'pages.products.category.categoryRequired': '分类是必选的',
  'pages.products.category.id': 'ID',
  'pages.products.store.add': '添加商店',
  'pages.products.store.addTitle': '添加商店',
  'pages.products.store.name': '商店名称',
  'pages.products.category.name': '分类名称',
  'pages.products.category.level1Placeholder': '一级分类（必选）',
  'pages.products.category.level2Placeholder': '二级分类（必选）',
  'pages.products.category.level2Required': '二级分类是必选的',
  'pages.products.category.level3Placeholder': '三级分类（可选）',
  'pages.products.category.nameEn': '英文名',
  'pages.products.category.nameCn': '中文名',
  'pages.products.category.parent': '上级分类',
  'pages.products.category.level': '级别',
  'pages.products.category.order': '显示顺序',
  'pages.products.category.productCount': '商品数',
  'pages.products.category.status': '状态',
  'pages.products.category.createdAt': '创建时间',
  'pages.products.category.actions': '操作',
  'pages.products.category.add': '添加分类',
  'pages.products.category.edit': '编辑',
  'pages.products.category.delete': '删除',
  'pages.products.category.treeView': '树形视图',
  'pages.products.category.tableView': '表格视图',
  'pages.products.category.addTitle': '添加分类',
  'pages.products.category.editTitle': '编辑分类',
  'pages.products.category.deleteConfirm': '删除分类',
  'pages.products.category.deleteContent': '确定要删除"{name}"分类吗？{count}',
  'pages.products.category.deleteSuccess': '分类已删除',
  'pages.products.category.updateSuccess': '分类已更新',
  'pages.products.category.createSuccess': '分类已创建',
  'pages.products.category.loadedFromLocalStorage': '从本地存储加载分类（API不可用）',
  'pages.products.category.platform': '平台',
  'pages.products.category.platformTaobao': '淘宝',
  'pages.products.category.platformVip': 'VVIC',
  'pages.products.category.platformMyCompany': '自营商城',
  'pages.products.category.includeInactive': '包含非活动',
  'pages.products.category.editImage': '编辑图片',
  'pages.products.category.editName': '编辑名称',
  'pages.products.category.editStatus': '编辑状态',
  'pages.products.category.editRecommend': '编辑推荐',
  'pages.products.category.clickToEditImage': '点击图片进行编辑',
  'pages.products.category.clickToEditName': '点击名称进行编辑',
  'pages.products.category.clickToEditStatus': '点击状态进行编辑',
  'pages.products.category.clickToEditRecommend': '点击推荐进行编辑',
  'pages.products.category.totalCategories': '总分类数',
  'pages.products.category.upload': '上传',
  'pages.products.category.uploadImageOnly': '只能上传图片文件',
  'pages.products.category.imageSizeLimit': '图片大小必须小于10MB',
  'pages.products.category.uploadSuccess': '图片上传成功',
  'pages.products.category.uploadFailed': '图片上传失败',
  'pages.products.category.image': '图片',
  'pages.products.category.externalId': '外部ID',
  
  // Todayggigu Category Management
  'pages.products.todayggigu.category.title': '分类管理',
  'pages.products.todayggigu.category.addLevel1': '注册一级分类',
  'pages.products.todayggigu.category.sortLevel1': '排序一级分类',
  'pages.products.todayggigu.category.level1Title': '一级分类注册/修改',
  'pages.products.todayggigu.category.level2Title': '二级分类注册/修改',
  'pages.products.todayggigu.category.orderTitle': '更改分类顺序',
  'pages.products.todayggigu.category.parentCategory': '父分类',
  'pages.products.todayggigu.category.categoryName': '分类名称',
  'pages.products.todayggigu.category.categoryNamePlaceholder': '请输入分类名称',
  'pages.products.todayggigu.category.categoryNameRequired': '请输入分类名称',
  'pages.products.todayggigu.category.usage': '使用状态',
  'pages.products.todayggigu.category.use': '使用',
  'pages.products.todayggigu.category.notUse': '不使用',
  'pages.products.todayggigu.category.no': 'No',
  'pages.products.todayggigu.category.name': '分类名称',
  'pages.products.todayggigu.category.usageStatus': '使用状态',
  'pages.products.todayggigu.category.registeredAt': '注册时间',
  'pages.products.todayggigu.category.actions': '操作',
  'pages.products.todayggigu.category.register': '注册',
  'pages.products.todayggigu.category.edit': '修改',
  'pages.products.todayggigu.category.order': '顺序',
  'pages.products.todayggigu.category.delete': '删除',
  'pages.products.todayggigu.category.save': '保存',
  'pages.products.todayggigu.category.close': '关闭',
  'pages.products.todayggigu.category.deleteConfirm': '删除分类',
  'pages.products.todayggigu.category.deleteContent': '确定要删除"{name}"分类吗？',
  'pages.products.todayggigu.category.deleteSuccess': '分类删除成功',
  'pages.products.todayggigu.category.deleteFailed': '分类删除失败',
  'pages.products.todayggigu.category.createSuccess': '分类创建成功',
  'pages.products.todayggigu.category.updateSuccess': '分类修改成功',
  'pages.products.todayggigu.category.saveFailed': '分类保存失败',
  'pages.products.todayggigu.category.loadFailed': '分类加载失败',
  'pages.products.todayggigu.category.orderSuccess': '顺序更改成功',
  'pages.products.todayggigu.category.orderFailed': '顺序更改失败',
  'pages.products.todayggigu.category.noSubcategories': '没有子分类',
  'pages.products.todayggigu.category.dragToReorder': '拖动以重新排序',
  
  'pages.products.category.nameKo': '分类名称（韩文）',
  'pages.products.category.nameKoPlaceholder': '例如：服装',
  'pages.products.category.nameKoRequired': '请输入分类名称',
  'pages.products.category.nameEnLabel': '分类名称（英文）',
  'pages.products.category.nameEnPlaceholder': '例如：Clothing',
  'pages.products.category.nameCnLabel': '分类名称（中文）',
  'pages.products.category.nameCnPlaceholder': '例如：服装',
  'pages.products.category.parentLabel': '上级分类',
  'pages.products.category.parentPlaceholder': '顶级分类请不要选择',
  'pages.products.category.icon': '图标',
  'pages.products.category.iconPlaceholder': '例如：👔（表情符号或图标类）',
  'pages.products.category.orderLabel': '显示顺序',
  'pages.products.category.orderPlaceholder': '数字越小越靠前',
  'pages.products.category.description': '描述',
  'pages.products.category.descriptionPlaceholder': '分类描述',
  'pages.products.category.statusLabel': '状态',
  'pages.products.category.statusAll': '全部',
  'pages.products.category.active': '激活',
  'pages.products.category.inactive': '未激活',
  'pages.products.category.levelRequired': '请选择级别',
  'pages.products.category.levelPlaceholder': '请选择级别',
  'pages.products.category.parentRequired': '请选择上级分类',
  'pages.products.category.topLevel': '顶级',
  'pages.products.category.level1': '一级分类',
  'pages.products.category.store': '店铺',
  'pages.products.category.level2': '二级分类',
  'pages.products.category.level3': '三级分类',
  'pages.products.category.level4': '四级分类',
  'pages.products.category.orderUp': '上移',
  'pages.products.category.orderDown': '下移',
  'pages.products.category.orderMoved': '"{name}"分类顺序已{direction}移动',
  'pages.products.category.reorderSaved': '分类顺序已保存',
  'pages.products.category.reorderSameParentOnly': '只能在同一上级分类（同一层级）内调整顺序',
  'pages.products.category.dragToReorder': '拖拽调整顺序',
  'pages.products.category.countUnit': '个',
  'pages.products.category.imageUrl': '图片URL',
  'pages.products.category.imageUrlPlaceholder': '例如：https://example.com/image.jpg',
  'pages.products.category.imageUrlDesktop': '桌面图片URL',
  'pages.products.category.imageUrlMobile': '移动图片URL',
  'pages.products.category.imageUrlDesktopPlaceholder': '例如：https://example.com/desktop-image.jpg',
  'pages.products.category.imageUrlMobilePlaceholder': '例如：https://example.com/mobile-image.jpg',
  'pages.products.category.updateFailed': '分类更新失败',
  'pages.products.category.selectCategoryFirst': '请先选择分类',
  'pages.products.category.categoryNotFound': '找不到分类',
  'pages.products.category.searchNamePlaceholder': '按类别名称搜索',
  'pages.products.category.statusRecommend': '状态/推荐',
  'pages.products.category.recommended': '推荐',
  'pages.products.category.notRecommended': '不推荐',
  'pages.products.category.clickToEdit': '点击编辑',
  'pages.products.category.validationError': '验证错误',
  'pages.products.category.unauthorized': '需要身份验证',
  
  // Products Import Taobao
  'pages.products.import.title': '淘宝/1688/速卖通/Temu商品导入',
  'pages.products.import.noSpecifications': '无规格',
  'pages.products.import.subtitle': '输入商品URL自动获取信息',
  'pages.products.import.platforms': '支持平台',
  'pages.products.import.urlPlaceholder': '请输入商品URL（例如：https://item.taobao.com/item.htm?id=123456789）',
  'pages.products.import.fetch': '获取商品',
  'pages.products.import.fetching': '正在获取商品信息...',
  'pages.products.import.fetchSuccess': '商品信息获取成功',
  'pages.products.import.urlRequired': '请输入URL',
  'pages.products.import.invalidUrl': '支持平台：淘宝（天猫）、1688、VVIC',
  'pages.products.import.productIdNotFound': '无法从URL中提取商品ID。请检查URL格式。',
  'pages.products.import.fetchError': '获取商品信息失败。请重试。',
  'pages.products.import.productInfo': '商品信息',
  'pages.products.import.translate': '自动翻译',
  'pages.products.import.translateSuccess': '自动翻译完成',
  'pages.products.import.translateError': '翻译失败',
  'pages.products.import.save': '保存商品',
  'pages.products.import.saveSuccess': '商品已保存',
  'pages.products.import.saveError': '请填写必填项',
  'pages.products.import.basicInfo': '基本信息',
  'pages.products.import.optionsInfo': '选项信息',
  'pages.products.import.specsInfo': '详细规格',
  'pages.products.import.titleCn': '商品名称（中文）',
  'pages.products.import.titleCnPlaceholder': '请输入中文商品名称',
  'pages.products.import.titleKo': '商品名称（韩文）',
  'pages.products.import.titleKoPlaceholder': '请输入韩文商品名称',
  'pages.products.import.titleEn': '商品名称（英文）',
  'pages.products.import.titleEnPlaceholder': '请输入英文商品名称',
  'pages.products.import.originalPrice': '原价（₩）',
  'pages.products.import.sellingPrice': '售价（₩）',
  'pages.products.import.realPrice': '实际价格',
  'pages.products.import.otherPrice': '其他价格',
  'pages.products.import.tagPrice': '标签价格',
  'pages.products.import.margin': '利润率',
  'pages.products.import.productType': '产品类型',
  'pages.products.import.productTypeSelf': '自营',
  'pages.products.import.productTypeLabang': '拉帮',
  'pages.products.import.labangEndDate': '拉帮结束日期',
  'pages.products.import.labangEndDateRequired': '请输入拉帮结束日期',
  'pages.products.import.labangPeriod': '拉帮期限',
  'pages.products.import.labangPeriodRequired': '请输入拉帮期限',
  'pages.products.import.days': '天',
  'pages.products.list.productType': '产品类型',
  'pages.products.import.description': '商品描述（HTML）',
  'pages.products.import.descriptionHint': '支持HTML内容。您可以直接编辑描述。',
  'pages.products.import.category': '分类',
  'pages.products.import.categoryPlaceholder': '选择分类',
  'pages.products.import.optionNameCn': '选项名称（中文）',
  'pages.products.import.optionNameKo': '选项名称（韩文）',
  'pages.products.import.optionNameEn': '选项名称（英文）',
  'pages.products.import.optionImage': '选项图片',
  'pages.products.import.optionImageUrlPlaceholder': '输入图片URL',
  'pages.products.import.selectStore': '选择店铺',
  'pages.products.import.inputAttributes': '输入属性',
  'pages.products.import.attributeName': '属性名称',
  'pages.products.import.attributeValue': '属性值',
  'pages.products.import.synchronizeToPropertyList': '同步到属性列表',
  'pages.products.import.attributeList': '属性列表',
  'pages.products.import.multipleAttributes': '多个属性',
  'pages.products.import.rmbCostPrice': '人民币成本价',
  'pages.products.import.koreanWonCostPrice': '韩元成本价',
  'pages.products.import.originalPriceRMB': '原价（人民币）',
  'pages.products.import.originalPriceKoreanWon': '原价（韩元）',
  'pages.products.import.rmbPrice': '人民币价格',
  'pages.products.import.salesPrice': '销售价',
  'pages.products.import.inStock': '库存',
  'pages.products.import.rebatePercentage': '返利百分比',
  'pages.products.import.attributeImages': '属性图片',
  'pages.products.import.attributesInfo': '属性信息',
  'pages.products.import.optionPrice': '报价',
  'pages.products.import.optionPriceCny': '价格（人民币）',
  'pages.products.import.optionPriceKrw': '价格（韩元）',
  'pages.products.import.optionStock': '库存',
  'pages.products.import.optionSkuId': 'SKU ID',
  'pages.products.import.optionSpecId': 'Spec ID',
  'pages.products.import.specId': '规格ID',
  'pages.products.import.descriptionTab': '商品描述',
  'pages.products.import.specKeyCn': '属性名称（中文）',
  'pages.products.import.specKeyKo': '属性名称（韩文）',
  'pages.products.import.specKeyEn': '属性名称（英文）',
  'pages.products.import.specValueCn': '值（中文）',
  'pages.products.import.specValueKo': '值（韩文）',
  'pages.products.import.specValueEn': '值（英文）',
  'pages.products.import.noImagesSelected': '未选择图片',
  'pages.products.import.downloading': '正在下载 {count} 张图片...',
  'pages.products.import.downloadSuccess': '成功下载 {count} 张图片',
  'pages.products.import.downloadPartial': '已下载 {total} 张中的 {success} 张图片。由于CORS限制，部分图片可能在新标签页中打开。',
  'pages.products.import.downloadError': '下载图片失败',
  'pages.products.import.availableProducts': '可用商品数量',
  'pages.products.import.unit': '件',
  'pages.products.import.category.clothing': '服装',
  'pages.products.import.category.shoes': '鞋类',
  'pages.products.import.category.bags': '箱包',
  'pages.products.import.category.accessories': '配饰',
  'pages.products.import.category.electronics': '电子产品',
  'pages.products.import.category.home': '家居用品',
  'pages.products.import.currency.cny': '人民币',
  'pages.products.import.currency.krw': '韩元',
  'pages.products.import.platform.taobao': '淘宝',
  'pages.products.import.platform.1688': '1688',
  'pages.products.import.platform.tmall': '天猫',
  'pages.products.import.platform.aliexpress': '速卖通',
  'pages.products.import.platform.temu': 'Temu',
  'pages.products.import.platform.vvic': 'VVIC',
  'pages.products.import.ratingMax': '5.0',
  'pages.products.import.sellerInfo': '卖家信息',
  'pages.products.import.seller': '卖家',
  'pages.products.import.rating': '评分',
  'pages.products.import.sales': '销量',
  'pages.products.import.sellerAddress': '卖家地址',
  'pages.products.import.sellerPhone': '卖家电话',
  'pages.products.import.sellerMailbox': '卖家邮箱',
  'pages.products.import.sellerOpenId': '卖家开放ID',
  'pages.products.import.productRating': '商品评分',
  'pages.products.import.soldAmount': '销量',
  'pages.products.import.salesUnit': '笔',
  'pages.products.import.images': '商品图片',
  'pages.products.import.imagesCount': '商品图片（{count}张）',
  'pages.products.import.download': '下载',
  'pages.products.import.downloadStart': '开始下载{count}张图片',
  'pages.products.import.imageSelectInfo': '拖拽图片可调整顺序，第一张图片自动设为主图。',
  'pages.products.import.mainImage': '主图',
  'pages.products.imageTranslate.button': '翻译全部图片',
  'pages.products.imageTranslate.descriptionButton': '翻译详情图片文字',
  'pages.products.imageTranslate.title': '图片文字翻译审核',
  'pages.products.imageTranslate.useTranslated': '使用翻译图',
  'pages.products.imageTranslate.noText': '无可翻译文字',
  'pages.products.imageTranslate.original': '原图',
  'pages.products.imageTranslate.translated': '翻译图',
  'pages.products.imageTranslate.erased': '已擦除',
  'pages.products.imageTranslate.editHint': '可为每条文字选择翻译、保留或擦除，并可直接修改译文。',
  'pages.products.imageTranslate.rerender': '重新生成',
  'pages.products.imageTranslate.actTranslate': '翻译',
  'pages.products.imageTranslate.actKeep': '保留',
  'pages.products.imageTranslate.actErase': '擦除',
  'pages.products.imageTranslate.autoPlaceholder': '留空则自动翻译',
  'pages.products.imageTranslate.keptPlaceholder': '保留原文',
  'pages.products.imageTranslate.tilted': '倾斜',
  'pages.products.imageTranslate.tiltedHint': '倾斜的文字（道具上的字）默认保留原样。',
  'pages.products.imageTranslate.truncated': '被截断',
  'pages.products.imageTranslate.truncatedHint': '文字放不下，已用"…"截断。请改短一些。',
  'pages.products.imageTranslate.staleHint': '有图片的修改尚未重新生成，请先点击"重新生成"。',
  'pages.products.imageTranslate.reopened': '重新打开已应用的译图',
  'pages.products.imageTranslate.reopenedHint': '该图片已应用过译图。已恢复原图和上次的选择，可继续修改。取消"使用译图"并应用即可恢复原图。',
  'pages.products.imageTranslate.selectAll': '全选已翻译',
  'pages.products.imageTranslate.selected': '已选',
  'pages.products.imageTranslate.shortcutHint': '← → 切换 · 空格选择',
  'pages.products.imageTranslate.failedHint': '{count} 张失败，请在列表中确认并重试。',
  'pages.products.imageTranslate.viewLarge': '大图',
  'pages.products.imageTranslate.viewCompact': '小图',
  'pages.products.imageTranslate.failed': '失败',
  'pages.products.imageTranslate.retry': '重试',
  'pages.products.imageTranslate.apply': '应用 ({count})',
  'pages.products.imageTranslate.cancel': '取消',
  'pages.products.imageTranslate.applied': '已替换 {count} 张图片',
  'pages.products.imageTranslate.noImages': '没有可翻译的图片',
  'pages.products.import.mainImageSet': '主图设置成功',
  'pages.products.import.imagePreview': '图片预览',
  'pages.products.import.close': '关闭',

  // Orders Common
  'pages.orders.common.orderNumber': '订单号',
  'pages.orders.common.manual': '手动结算',
  'pages.orders.common.auto': '自动结算',
  'pages.orders.common.productType': '[产品分类]',
  'pages.orders.common.platformType': '平台类型',
  'pages.orders.common.shippingMethod': '运输方式',
  'pages.orders.common.shippingMethodNormal': '普通',
  'pages.orders.common.shippingMethodFast': '快速',
  'pages.orders.common.shippingMethodExpress': '特快',
  'pages.orders.common.shippingStatus': '出库状态',
  'pages.orders.common.warehouseAndTransferMethod': '仓库/运输方式',
  'pages.orders.common.paymentMethodShort': '支付方式',
  'pages.orders.common.memberNameWithMailbox': '会员名/(会员信箱)',
  'pages.orders.common.receiverName': '收件人名',
  'pages.orders.common.sellerName': '卖家名',
  'pages.orders.common.sellerMailbox': '卖家信箱',
  'pages.orders.common.sellerNameWithMailbox': '卖家名/(卖家信箱)',
  'pages.orders.common.unpaid': '未付款',
  'pages.orders.common.paymentMethod': '付款方式',
  'pages.orders.common.shipped': '已出库',
  'pages.orders.common.notShipped': '未出库',
  'pages.orders.common.membershipCode': '会员名',
  'pages.orders.common.userId': '用户ID',
  'pages.orders.common.userUniqueId': '会员编号',
  'pages.orders.common.receiver': '收件人',
  'pages.orders.common.trackingCount': '跟踪数',
  'pages.orders.common.warehousedCount': '入库数',
  'pages.orders.common.quantity': '数量',
  'pages.orders.common.totalAmount': '总金额',
  'pages.orders.common.chineseTransportationCost': '[中国运输成本]',
  'pages.orders.common.RealCost': '[实际成本]',
  'pages.orders.common.internationalShippingCost': '主要成本',
  'pages.orders.common.firstCost': '第1次费用',
  'pages.orders.common.secondCost': '第2次费用',
  'pages.orders.common.firstInternationalShippingCost': '第1次国际运输成本',
  'pages.orders.common.appliedWeight': '应用重量',
  'pages.orders.common.realWeight': '实重量',
  'pages.orders.common.extraInternationalShippingCost': '次要成本',
  'pages.orders.common.paymentPending': '待付款',
  'pages.orders.common.paymentComplete': '付款完成',
  'pages.orders.common.total': '共 {count} 笔',
  'pages.orders.common.paidAmount': '支付金额',
  'pages.orders.common.weight': '重量',
  'pages.orders.common.trackingNumber': '运单号',
  'pages.orders.common.shipDate': '出库日期',
  'pages.orders.common.rackNumber': '货架号',
  'pages.orders.common.warehouseStatus': '入库状态',
  'pages.orders.common.progressStatus': '进度状态',
  'pages.orders.common.createdAt': '创建时间',
  'pages.orders.common.updatedAt': '更新时间',
  'pages.orders.common.inquiryResponder': '咨询回复者',
  'pages.orders.common.buyer': '采购负责人',
  'pages.orders.common.warehouseHandler': '仓库处理人',
  'pages.orders.common.actions': '操作',
  'pages.orders.common.paymentStatus': '付款状态',
  'pages.orders.common.transferMethod': '运输方式',
  'pages.orders.common.waybillNumber': '运单号',
  'pages.orders.common.none': '无',
  'pages.orders.common.notRegistered': '未登记',
  'pages.orders.common.kdexpCarrier': '庆东快递',
  'pages.orders.common.kdexpShort': '庆东',
  'pages.orders.common.kdexpSentDate': '发货',
  'pages.orders.common.kdexpMore': '另{count}件',
  'pages.orders.common.items': '个',
  'pages.orders.common.won': '韩元',
  'pages.orders.common.cny': '人民币',
  'pages.orders.common.count': '笔',
  'pages.orders.filter.sellerId': '卖家ID',
  'pages.orders.filter.sellerIdPlaceholder': '直播卖家ID (sellerId)',
  'pages.orders.filter.memberMailbox': '会员信箱',
  'pages.orders.filter.sellerMailbox': '卖家信箱',
  
  // Order Status Groups
  'pages.orders.status.purchaseAgency': '代购',
  'pages.orders.status.vvicHighpass': 'VVIC快速通道',
  'pages.orders.status.shippingAgency': '代运',
  'pages.orders.status.warehouse': '入/出库',
  'pages.orders.status.error': '错误',
  'pages.orders.status.return': '退货管理',
  'pages.orders.status.inventory': '库存管理',
  'pages.orders.status.warehoused': '已入库',
  'pages.orders.status.done': '已完成',
  
  // Order Status Items
  'pages.orders.status.tempSave': '临时保存',
  'pages.orders.status.purchaseQuote': '采购报价',
  'pages.orders.status.paymentPending': '待付款',
  'pages.orders.status.paymentComplete': '已付款',
  'pages.orders.status.purchasing': '采购中',
  'pages.orders.status.automaticProcurement': '自动采购',
  'pages.orders.status.manualProcurement': '手动采购',
  'pages.orders.status.financialSettlement': '财务结算',
  'pages.orders.status.problemProduct': '问题商品',
  'pages.orders.status.purchaseFinalComplete': '采购完成',
  'pages.orders.status.centerArrivalExpected': '预计到达中心',
  'pages.orders.status.warehouseInProgress': '入库处理中',
  'pages.orders.status.warehouseInComplete': '入库完成',
  'pages.orders.status.processing': '处理中',
  'pages.orders.status.notWarehoused': '未入库',
  'pages.orders.status.additionalFeePending': '附加费用待付',
  'pages.orders.status.additionalFeeComplete': '附加费用已付',
  'pages.orders.status.shipmentPending': '待出库',
  'pages.orders.status.shipmentComplete': '已出库',
  'pages.orders.status.waitingSettlement': '等待结算',
  'pages.orders.status.settlementComplete': '结算完成',
  'pages.orders.status.deliveryException': '配送异常',
  'pages.orders.status.expectedWarehouseIn': '预计入库',
  'pages.orders.status.domesticWarehousePacking': '仓打包中',
  'pages.orders.status.errorWarehouse': '错误入库',
  'pages.orders.status.noOrderInfo': '无订单信息',
  'pages.orders.status.userRefundRequest': '用户退款申请',  
  'pages.orders.status.userRefundProgress': '用户退款处理中',
  'pages.orders.status.userRefundComplete': '用户退款完成',
  'pages.orders.status.platformRefundRequest': '平台退款申请',
  'pages.orders.status.platformRefundComplete': '平台退款完成',
  'pages.orders.status.localRefundRequest': '平台退款申请',
  'pages.orders.status.localRefundProgress': '平台退款中',
  'pages.orders.status.localRefundComplete': '平台退款完成',
  'pages.orders.status.orderCancelled': '废弃订单',
  'pages.orders.status.errorIgnore': '忽略错误',
  'pages.orders.status.returnMove': '退货转移',
  'pages.orders.status.refundProcessing': '退款处理中',
  'pages.orders.status.refundRequest': '退款申请',
  'pages.orders.status.cancelRequest': '取消申请',
  'pages.orders.status.refunded': '已退款',
  'pages.orders.status.shipmentHold': '出库保留',
  'pages.orders.status.internationalShipping': '国际运输',
  'pages.orders.status.internationalInOut': '国际入/出库',
  'pages.orders.status.internationalShippingInProgress': '国际运输中',
  'pages.orders.status.internationalShippingComplete': '国际运输完成',
  'pages.orders.status.orderReceived': "订单已收到",
  'pages.orders.status.finalRefundRequest': '最终退款申请',
  'pages.orders.status.finalRefundProgress': '最终退款处理中',
  'pages.orders.status.finalRefundComplete': '最终退款完成',
  'pages.orders.status.returnRequest': '退货申请',
  'pages.orders.status.returnComplete': '退货完成',
  'pages.orders.status.inventoryRequest': '库存申请',
  'pages.orders.status.inventoryAvailable': '可用',
  'pages.orders.status.inventoryOut': '缺货',
  'pages.orders.status.applicationReceived': '已接收申请',
  'pages.orders.status.receiptApplication': '接收申请',
  'pages.orders.status.deliveryApply': '配送申请',
  
  // In China Warehouse Page
  'pages.orders.inChinaWarehouse.title': '中国仓库入库',
  'pages.orders.inChinaWarehouse.regularMember': '普通会员',
  'pages.orders.inChinaWarehouse.businessMember': '企业会员',
  'pages.orders.inChinaWarehouse.waiting': '待入库',
  'pages.orders.inChinaWarehouse.arrived': '已入库',
  'pages.orders.inChinaWarehouse.inspecting': '检验中',
  'pages.orders.inChinaWarehouse.count': '笔',
  'pages.orders.inChinaWarehouse.warehouseDate': '入库日期',
  'pages.orders.inChinaWarehouse.warehouseStatus': '入库状态',
  'pages.orders.inChinaWarehouse.inspectionStatus': '检验状态',
  'pages.orders.inChinaWarehouse.weight': '重量',
  'pages.orders.inChinaWarehouse.volume': '体积',
  'pages.orders.inChinaWarehouse.packageCount': '包裹数',
  'pages.orders.inChinaWarehouse.inspectionComplete': '检验完成',
  'pages.orders.inChinaWarehouse.shipmentRequest': '出库请求',
  'pages.orders.inChinaWarehouse.memoNormal': '正常入库',
  'pages.orders.inChinaWarehouse.memoFragile': '注意损坏',
  'pages.orders.inChinaWarehouse.memoReinspect': '需要重新检验',
  
  // Pending Address Page
  'pages.orders.pendingAddress.title': '待填写地址',
  'pages.orders.pendingAddress.regularMember': '普通会员',
  'pages.orders.pendingAddress.businessMember': '企业会员',
  'pages.orders.pendingAddress.noAddress': '未填写地址',
  'pages.orders.pendingAddress.addressCompleted': '地址已填写',
  'pages.orders.pendingAddress.filterApplied': '{group} > {label} 筛选已应用',
  'pages.orders.pendingAddress.filterCleared': '筛选已清除',
  'pages.orders.pendingAddress.addressStatus': '地址状态',
  'pages.orders.pendingAddress.receiverName': '收件人姓名',
  'pages.orders.pendingAddress.phone': '联系电话',
  'pages.orders.pendingAddress.address': '地址',
  'pages.orders.pendingAddress.zipCode': '邮政编码',
  'pages.orders.pendingAddress.memo': '配送备注',
  'pages.orders.pendingAddress.editAddress': '编辑地址',
  'pages.orders.pendingAddress.saveAddress': '保存',
  'pages.orders.pendingAddress.addressSaved': '地址信息已保存',
  'pages.orders.pendingAddress.count': '笔',
  'pages.orders.pendingAddress.pending': '待填写',
  'pages.orders.pendingAddress.completed': '已完成',
  
  // Pending Payment Page
  'pages.orders.pendingPayment.title': '付款确认',
  'pages.orders.pendingPayment.regularMember': '普通会员',
  'pages.orders.pendingPayment.businessMember': '企业会员',
  'pages.orders.pendingPayment.paymentPending': '待付款',
  'pages.orders.pendingPayment.paymentCompleted': '已付款',
  'pages.orders.pendingPayment.filterApplied': '{group} > {label} 筛选已应用',
  'pages.orders.pendingPayment.filterCleared': '筛选已清除',
  'pages.orders.pendingPayment.paymentPhaseLabel': '付款阶段',
  'pages.orders.pendingPayment.paymentPhaseAll': '全部（第1次+第2次）',
  'pages.orders.pendingPayment.paymentPhaseFirst': '第1次付款',
  'pages.orders.pendingPayment.paymentPhaseSecond': '第2次付款',
  'pages.orders.pendingPayment.clearPaymentPhase': '重置付款阶段',
  'pages.orders.pendingPayment.unmatchedBankOnlyHint': '仅显示未匹配的银行转账订单。',
  'pages.orders.pendingPayment.paymentAmount': '付款金额',
  'pages.orders.pendingPayment.totalAmount': '总计金额',
  'pages.orders.pendingPayment.payerName': '付款人姓名',
  'pages.orders.pendingPayment.paymentMethod': '付款方式',
  'pages.orders.pendingPayment.paymentDate': '付款日期',
  'pages.orders.pendingPayment.orderDetails': '订单详情',
  'pages.orders.pendingPayment.paymentStatus': '付款状态',
  'pages.orders.pendingPayment.actions': '操作',
  'pages.orders.pendingPayment.confirmPayment': '确认付款',
  'pages.orders.pendingPayment.cancelPayment': '取消付款',
  'pages.orders.pendingPayment.viewDetails': '查看详情',
  'pages.orders.pendingPayment.paymentConfirmed': '订单 {orderNo} 的付款已确认',
  'pages.orders.pendingPayment.paymentConfirmError': '订单 {orderNo} 的付款确认失败',
  'pages.orders.pendingPayment.orderIdNotFound': '找不到订单ID',
  'pages.orders.pendingPayment.confirmPaymentTitle': '确认付款',
  'pages.orders.pendingPayment.confirmPaymentContent': '您确定要确认订单 {orderNo} 的付款吗？',
  'pages.orders.pendingPayment.cancelPaymentTitle': '取消付款',
  'pages.orders.pendingPayment.cancelPaymentContent': '您确定要取消订单 {orderNo} 的付款吗？',
  'pages.orders.pendingPayment.paymentCancelled': '订单 {orderNo} 的付款已取消',
  'pages.orders.pendingPayment.paymentCancelError': '订单 {orderNo} 的付款取消失败',
  'pages.orders.pendingPayment.invalidOrderId': '无效的订单ID。无法确认付款。',
  'pages.orders.pendingPayment.depositDiscount': '押金',
  'pages.orders.pendingPayment.deposit': '押金',
  'pages.orders.pendingPayment.point': '积分',
  'pages.orders.pendingPayment.coupon': '优惠券',
  'pages.orders.pendingPayment.discount': '折扣使用',
  'pages.orders.pendingPayment.pointCoupon': '(押金/积分/优惠券)',
  'pages.orders.pendingPayment.regularMemberTag': '普通',
  'pages.orders.pendingPayment.businessMemberTag': '企业',
  'pages.orders.pendingPayment.count': '笔',
  'pages.orders.pendingPayment.paymentMethodCard': '信用卡',
  'pages.orders.pendingPayment.paymentMethodTransfer': '银行转账',
  'pages.orders.pendingPayment.paymentMethodDeposit': '存款',
  'pages.orders.pendingPayment.paymentMethodBillgate': 'Billgate',
  'pages.orders.pendingPayment.memberName': '会员名',
  'pages.orders.pendingPayment.applicationDate': '申请日期',
  'pages.orders.pendingPayment.paymentCost': '支付金额',
  'pages.orders.pendingPayment.depositForUse': '使用存款',
  'pages.orders.pendingPayment.paymentOrderNumber': '支付订单号',
  
  // Order Statistics Page
  'pages.orders.statistics.title': '订单统计',
  'pages.orders.statistics.dateRange': '查询期间',
  'pages.orders.statistics.last7Days': '最近7天',
  'pages.orders.statistics.last30Days': '最近30天',
  'pages.orders.statistics.last90Days': '最近90天',
  'pages.orders.statistics.totalOrders': '总订单数量',
  'pages.orders.statistics.purchaseComplete': '采购完成',
  'pages.orders.statistics.shipped': '已出库',
  'pages.orders.statistics.totalSales': '销售额',
  'pages.orders.statistics.refundCount': '退款商品数',
  'pages.orders.statistics.refundAmount': '退款金额',
  'pages.orders.statistics.trendChart': '营业趋势图',
  'pages.orders.statistics.dailyStats': '每日统计',
  'pages.orders.statistics.chart.orders': '订单数',
  'pages.orders.statistics.chart.purchaseComplete': '采购完成',
  'pages.orders.statistics.chart.shipped': '已出库',
  'pages.orders.statistics.chart.revenue': '销售额',
  'pages.orders.statistics.chart.refunds': '退款数',
  'pages.orders.statistics.chart.refundAmount': '退款金额',
  'pages.orders.statistics.table.date': '日期',
  'pages.orders.statistics.table.orderCount': '订单数',
  'pages.orders.statistics.table.purchaseComplete': '采购完成',
  'pages.orders.statistics.table.shipped': '已出库',
  'pages.orders.statistics.table.revenue': '销售额',
  'pages.orders.statistics.table.refundCount': '退款数',
  'pages.orders.statistics.table.refundAmount': '退款金额',
  'pages.orders.statistics.table.total': '共 {total} 项',
  'pages.orders.statistics.sourceFilter': '销售来源',
  'pages.orders.statistics.source.all': '全部',
  'pages.orders.statistics.source.live': '直播',
  'pages.orders.statistics.source.ownmall': '自营商城',
  'pages.orders.statistics.source.1688': '1688',
  'pages.orders.statistics.source.taobao': '淘宝',
  'pages.orders.statistics.source.vvic': 'VVIC',
  'pages.orders.statistics.sourceBreakdown': '按来源销售构成',
  'pages.orders.statistics.sourceOrderCount': '订单 {count} 单',
  'pages.orders.statistics.amountChart': '金额走势（按来源销售额·退款）',
  'pages.orders.statistics.countChart': '单量走势',
  'pages.orders.statistics.sellerTop': '直播卖家销售 TOP 10',
  'pages.orders.statistics.sellerTop.rank': '排名',
  'pages.orders.statistics.sellerTop.seller': '卖家',
  'pages.orders.statistics.sellerTop.orderCount': '已支付订单数',
  'pages.orders.statistics.sellerTop.saleAmount': '销售额',
  'pages.orders.statistics.sellerTop.refundAmount': '退款金额',
  'pages.orders.statistics.avgOrderValue': '客单价 (₩)',
  'pages.orders.statistics.refundRate': '退款率',
  'pages.orders.statistics.vsPrevPeriod': '较上一周期',
  'pages.orders.statistics.backlog.title': '实时处理现况',
  'pages.orders.statistics.backlog.asOf': '截至',
  'pages.orders.statistics.backlog.stage.payWait': '待付款',
  'pages.orders.statistics.backlog.stage.purchasing': '采购中',
  'pages.orders.statistics.backlog.stage.inbound': '待入库',
  'pages.orders.statistics.backlog.stage.warehouse': '仓库作业中',
  'pages.orders.statistics.backlog.stage.shipReady': '待出库',
  'pages.orders.statistics.backlog.stage.shipping': '运输中',
  'pages.orders.statistics.backlog.stage.problem': '问题·错误',
  'pages.orders.statistics.backlog.stage.refundInProgress': '退款进行中',
  'pages.orders.statistics.backlog.stale': '滞留 {count}',
  'pages.orders.statistics.backlog.staleTooltip': '状态超过 {hours} 小时未变化的订单',
  'pages.orders.statistics.backlog.needsAction': '需要处理的订单',
  'pages.orders.statistics.backlog.status.domesticPacking': '本地打包',
  
  // All Orders Page
  'pages.orders.all.title': '全部订单',
  'pages.orders.all.count': '笔',
  'pages.orders.all.filterApplied': '筛选已应用',
  'pages.orders.all.filterCleared': '筛选已清除',
  'pages.orders.all.bulkProcess': '笔批量处理',
  'pages.orders.all.selected': '已选择',
  'pages.orders.all.group.purchase': '购买代理',
  'pages.orders.all.group.vvic': 'VVIC快速通道',
  'pages.orders.all.group.shipping': '配送代理',
  'pages.orders.all.group.warehouse': '入/出库',
  'pages.orders.all.group.error': '错误',
  'pages.orders.all.group.return': '退货管理',
  'pages.orders.all.group.stock': '库存管理',
  'pages.orders.all.status.tempSave': '临时保存',
  'pages.orders.all.status.estimate': '购买报价',
  'pages.orders.all.status.paymentWaiting': '待付款',
  'pages.orders.all.status.paymentComplete': '付款完成',
  'pages.orders.all.status.purchasing': '购买中',
  'pages.orders.all.status.purchaseComplete': '购买最终完成',
  'pages.orders.all.status.applicationSubmit': '申请提交',
  'pages.orders.all.status.centerArrival': '中心到达预定',
  'pages.orders.all.status.warehouseProcessing': '入库处理中',
  'pages.orders.all.status.warehouseComplete': '入库完成',
  'pages.orders.all.status.shipmentWaiting': '待出库',
  'pages.orders.all.status.shipmentComplete': '出库完成',
  'pages.orders.all.status.extraFeeWaiting': '额外费用待付款',
  'pages.orders.all.status.extraFeeComplete': '额外费用已付款',
  'pages.orders.all.status.errorWarehouse': '错误入库',
  'pages.orders.all.status.noOrderInfo': '无订单信息',
  'pages.orders.all.status.errorIgnore': '错误忽略',
  'pages.orders.all.status.returnMove': '退货移动',
  'pages.orders.all.status.refundProcessing': '退款处理中',
  'pages.orders.all.status.refundRequest': '退款申请',
  'pages.orders.all.status.cancelRequest': '取消申请',
  'pages.orders.all.status.refundComplete': '退款完成',
  'pages.orders.all.status.shipmentHold': '出库保留',
  'pages.orders.all.status.returnRequest': '退货申请',
  'pages.orders.all.status.returnComplete': '退货完成',
  'pages.orders.all.status.stockRequest': '库存申请',
  'pages.orders.all.status.stockAvailable': '可用',
  'pages.orders.all.status.stockOut': '库存耗尽',
  'pages.orders.all.pageSize': '每页条数',
  'pages.orders.all.center': '中心',
  'pages.orders.all.centerAll': '全部',
  'pages.orders.all.centerWeihai': '(中国)威海',
  'pages.orders.all.centerQingdao': '(中国)青岛',
  'pages.orders.all.centerGuangzhou': '(中国)广州',
  'pages.orders.all.shippingMethod': '运输方式',
  'pages.orders.all.shippingAir': '航空',
  'pages.orders.all.shippingAirExpress': '航空特快',
  'pages.orders.all.shippingSea': '海运',
  'pages.orders.all.shippingSeaExpress': '海运特快',
  'pages.orders.all.isShipped': '出库状态',
  'pages.orders.all.autoPayment': '自动付款',
  'pages.orders.all.manualPayment': '手动付款',
  'pages.orders.all.registrationDate': '注册日期',
  'pages.orders.all.warehouseStatus': '入库状态',
  'pages.orders.all.warehouseExpected': '入库预定',
  'pages.orders.all.warehousePartial': '部分入库',
  'pages.orders.all.warehouseDone': '入库完成',
  'pages.orders.all.receiverType': '收件人类型',
  'pages.orders.all.receiverPersonal': '个人',
  'pages.orders.all.receiverBusiness': '企业',
  'pages.orders.all.mailbox': '邮箱',
  'pages.orders.all.mailboxPlaceholder': '邮箱号码',
  'pages.orders.all.receiver': '收件人',
  'pages.orders.all.receiverPlaceholder': '收件人姓名',
  'pages.orders.all.productNo': '商品编号',
  'pages.orders.all.trackingNo': '跟踪号',
  'pages.orders.all.trackingNoPlaceholder': '中国/国内跟踪号',
  'pages.orders.all.orderNoPlaceholder': 'TM2025...',
  'pages.orders.all.krTrackPlaceholder': '国内运单号',
  'pages.orders.all.orderType': '申请类型',
  'pages.orders.all.shippingMethodCol': '运输方式',
  'pages.orders.all.shippedStatus': '出库状态',
  'pages.orders.all.shipped': '已出库',
  'pages.orders.all.notShipped': '未出库',
  'pages.orders.all.trackingCount': '跟踪数',
  'pages.orders.all.warehousedCount': '入库数',
  'pages.orders.all.totalAmount': '总金额',
  'pages.orders.all.paidAmount': '已付金额',
  'pages.orders.all.weightLabel': '重量',
  'pages.orders.all.krTrackingNumber': '运单号',
  'pages.orders.all.shipDateRack': '出库日期/货架',
  'pages.orders.all.notRegistered': '未注册',
  'pages.orders.all.progressStatus': '进度状态',
  'pages.orders.all.createdAt': '创建时间',
  'pages.orders.all.updatedAt': '更新时间',
  'pages.orders.all.inquiryResponder': '咨询回复者',
  'pages.orders.all.purchaseManager': '采购经理',
  'pages.orders.all.none': '无',
  'pages.orders.all.copyOrder': '复制订单',
  'pages.orders.all.additionalCost': '额外费用',
  'pages.orders.all.orderInquiry': '订单咨询',
  'pages.orders.all.registerTracking': '注册运单',
  'pages.orders.all.changeBoxCount': '更改箱数',
  'pages.orders.all.printTracking': '打印运单',
  'pages.orders.all.reissueTracking': '重新发行运单',
  'pages.orders.all.coupangLabel': 'Coupang标签',
  'pages.orders.all.return': '退货',
  'pages.orders.all.bulkRegisterTracking': '批量注册运单',
  
  // User Orders Page
  'pages.orders.user.title': '普通会员订单',
  'pages.orders.user.filterApplied': '{group} > {label} 筛选已应用（普通会员）',
  'pages.orders.user.filterCleared': '筛选已清除',
  'pages.orders.user.newOrderNotification': '收到新订单: {orderNumber}',
  'pages.orders.user.paymentCompletedNotification': '付款完成订单增加了 {count} 笔',
  'pages.orders.user.purchasingNotification': '采购中订单增加了 {count} 笔',
  'pages.orders.user.viewAll': '查看全部',
  'pages.orders.user.viewOrdersWithoutTrackingNumber': '查看无运单号订单',
  'pages.orders.user.viewOrder': '查看订单',
  'pages.orders.user.copied': '已复制',
  'pages.orders.user.log': '日志',
  'pages.orders.user.buyingOrder': '购买订单:',
  'pages.orders.user.deliveryOrderNumber': '配送订单号:',
  'pages.orders.user.unreadInquiry': '未读咨询: {count} (订单: {orderNo})',
  'pages.orders.user.regularMember': '普通',
  'pages.orders.user.orderCopy': '复制订单',
  'pages.orders.user.delete': '删除',
  'pages.orders.user.editQuantity': '编辑数量',
  'pages.orders.user.quantityUpdated': '数量已更新',
  'pages.orders.user.quantityUpdateFailed': '更新数量失败',
  'pages.orders.user.quantityRequired': '请输入数量',
  'pages.orders.user.quantityMin': '数量必须至少为1',
  'pages.orders.user.quantityPlaceholder': '输入数量',
  'pages.orders.user.deleteCartItem': '删除购物车项目',
  'pages.orders.user.deleteCartItemConfirm': '确定要删除此购物车项目吗？',
  'pages.orders.user.cartItemDeleted': '购物车项目已删除',
  'pages.orders.user.cartItemDeleteFailed': '删除购物车项目失败',
  'pages.orders.user.split': '拆分',
  'pages.orders.user.waybillRegistration': '运单登记',
  'pages.orders.user.waybillIssuance': '发行运单',
  'pages.orders.user.waybillReIssuance': '重新发行运单',
  'pages.orders.user.waybillIssuanceSuccess': '运单已发行',
  'pages.orders.user.waybillReIssuanceSuccess': '运单已重新发行',
  'pages.orders.user.waybillIssuanceFailed': '发行运单失败',
  'pages.orders.user.orderNumberRequired': '需要订单号',
  'pages.orders.user.additionalCost': '代理附加费用',
  'pages.orders.user.purchaseCost': '购买费用',
  'pages.orders.user.orderInquiry': '订单咨询',
  'pages.orders.user.trackingRegister': '登记运单',
  'pages.orders.user.trackingIssue': '运单签发',
  'pages.orders.user.noTrackingNumber': '未填写快递单号',
  'pages.orders.user.trackingBoxChange': '更改箱数',
  'pages.orders.user.trackingPrint': '打印运单',
  'pages.orders.user.trackingReissue': '重新发行运单',
  'pages.orders.user.invoiceDownload': '下载发票',
  'pages.orders.user.coupangLabel': 'Coupang标签',
  'pages.orders.user.inpackingUpload': '内包装上传',
  'pages.orders.user.hanjinTrackingPrint': '韩进运单打印',
  'pages.orders.user.hjNotSent': 'HJ未发送',
  'pages.orders.user.hjSuccess': 'HJ成功',
  'pages.orders.user.purchaseCostReset': '重置购买费用',
  'pages.orders.user.purchaseCostBankTransfer': '购买费用银行转账',
  'pages.orders.user.fullRefund': '全额退款',
  'pages.orders.user.refund': '退款',
  'pages.orders.user.refundCancel': '取消退款',
  'pages.orders.user.refundCancelConfirm': '确认取消此退款申请？',
  'pages.orders.user.refundCancelSuccess': '退款申请已取消',
  'pages.orders.user.refundCancelFailed': '取消退款申请失败',
  'pages.orders.user.confirmFullRefund': '确定要进行全额退款吗？订单状态将变更为平台退款申请。',
  'pages.orders.user.returnCost': '退货费用',
  'pages.orders.user.returnCostReset': '退货费用重置',
  'pages.orders.user.returnCostBankTransfer': '退货费用无存折处理',
  'pages.orders.user.refundSplit': '退款分拆',
  'pages.orders.user.mergeSplitOrders': '合并分单订单',
  'pages.orders.user.noSplitOrdersSelected': '请选择分单订单（格式：{ordernumber}-S{splitnumber}）',
  'pages.orders.user.mergeRequiresTwoOrders': '请至少选择2个分单订单进行合并',
  'pages.orders.user.mergeSplitOrdersConfirm': '确认合并分单订单',
  'pages.orders.user.mergeSplitOrdersMessage': '确定要合并 {count} 个分单订单吗？',
  'pages.orders.user.mergeSplitOrdersSuccess': '成功合并 {count} 个分单订单',
  'pages.orders.user.mergeSplitOrdersError': '合并分单订单失败',
  'pages.orders.user.noValidOrderIds': '未找到有效的订单ID',
  'pages.orders.user.confirmSubOrderRefund': '确定要退款子订单吗？',
  'pages.orders.user.subOrderRefundSuccess': '子订单退款已处理',
  'pages.orders.user.subOrderRefundError': '子订单退款失败，请重试',
  'pages.orders.user.orderIdRequired': '需要订单ID',
  'pages.orders.user.confirmReturnCostReset': '确定要重置退货费用吗？',
  'pages.orders.user.returnCostResetSuccess': '退货费用已重置',
  'pages.orders.user.confirmReturnCostBankTransfer': '确定要无存折处理退货费用吗？',
  'pages.orders.user.returnCostBankTransferSuccess': '退货费用无存折处理完成',
  'pages.orders.user.viewNoTrackingNumber': '查看未输入运单号的订单',
  'pages.orders.user.purchaseFinalComplete': '购买最终完成',
  'pages.orders.user.trackingNumberPrint': '运单号打印',
  'pages.orders.user.purchaseForm': '购买表单',
  'pages.orders.user.settlementOrders': '结算订单',
  'pages.orders.user.redfAir': 'REDF 航空',
  'pages.orders.user.purchaseFinalCompleteSuccess': '购买完成订单已导出',
  'pages.orders.user.noPurchaseCompletedOrders': '未找到购买完成的订单',
  'pages.orders.user.selectOrdersToPrint': '请选择要打印运单号的订单',
  'pages.orders.user.noSelectedOrders': '未选择订单',
  'pages.orders.user.trackingNumbersPrinted': '运单号已打印',
  'pages.orders.user.printWaybill': '打印运单',
  'pages.orders.user.ManiProducts': '_MANI_产品',
  'pages.orders.user.printWaybillSelectOrders': '请至少选择一个订单或打开订单详情以打印运单',
  'pages.orders.user.printWaybillGenerating': '正在生成运单...',
  'pages.orders.user.printWaybillSuccess': '运单已生成，打印对话框已打开。',
  'pages.orders.user.printWaybillPopupBlocked': '弹窗被阻止，请允许弹窗后重试。',
  'pages.orders.user.printWaybillNoData': '生成运单失败：未收到PDF数据。',
  'pages.orders.user.printWaybillError': '生成运单失败，请重试。',
  'pages.orders.user.printWaybillOrderIdNotFound': '未找到订单ID',
  'pages.orders.user.noOrdersToExport': '没有要导出的订单',
  'pages.orders.user.purchaseFormExported': '购买表单已导出',
  'pages.orders.user.exportError': '导出时发生错误',
  'pages.orders.user.bundle': '捆绑',
  'pages.orders.user.merge': '合并',
  'pages.orders.user.shippingCost': '运费',
  'pages.orders.user.packing': '包装',
  'pages.orders.user.additionalCostReset': '重置附加费用',
  'pages.orders.user.additionalCostBankTransfer': '附加费用银行转账',
  'pages.orders.user.customsCost': '清关费用',
  'pages.orders.user.additionalFee': '附加费用',
  'pages.orders.user.vvicLabelPrint': 'VVIC标签打印',
  'pages.orders.user.subTrackingEdit': '编辑子运单',
  'pages.orders.user.packingSplit': '包装拆分',
  'pages.orders.user.subOrderRefund': '子订单退款',
  'pages.orders.user.labelPrint': '面单打印',
  'pages.orders.user.labelUpload': '面单上传',
  'pages.orders.user.labelGenerate': '面单生成',
  'pages.orders.user.labelRegenerate': '面单再次生成',
  'pages.orders.user.labelBoxChange': '面单箱数修改',
  'pages.orders.user.internationalShippingCostReset': '国际配送费用重置',
  'pages.orders.user.internationalShippingCostBankTransfer': '国际配送费用无存折处理',
  'pages.orders.user.confirmInternationalShippingCostReset': '确定要重置国际配送费用吗？',
  'pages.orders.user.confirmInternationalShippingCostBankTransfer': '确定要无存折处理国际配送费用吗？',
  'pages.orders.user.internationalShippingCostResetSuccess': '国际配送费用已重置',
  'pages.orders.user.internationalShippingCostResetFailed': '重置国际配送费用失败',
  'pages.orders.user.internationalShippingCostBankTransferSuccess': '国际配送费用无存折处理完成',
  'pages.orders.user.confirmPurchaseCostBankTransfer': '确认购买费用无存折处理？',
  'pages.orders.user.purchaseCostBankTransferSuccess': '购买费用无存折处理已确认',
  'pages.orders.user.confirmPurchaseCostReset': '确认重置购买费用？',
  'pages.orders.user.purchaseCostResetSuccess': '购买费用已重置',
  'pages.orders.user.confirmCopyOrder': '确认复制此订单？',
  'pages.orders.user.copyOrderSuccess': '订单已复制',
  'pages.orders.user.confirmDelete': '确认删除此订单？',
  'pages.orders.user.confirmDeleteDescription': '此操作不可撤销。',
  'pages.orders.user.deleteSuccess': '订单已删除',
  'pages.orders.user.confirm': '确认',
  'pages.orders.user.cancel': '取消',
  'pages.orders.user.confirmOrderCancelled': '确认取消订单',
  'pages.orders.user.confirmOrderCancelledMessage': '确定要取消此订单吗？此操作将把订单标记为已取消。',
  'pages.orders.user.confirmBatchOrderCancelled': '确认批量取消订单',
  'pages.orders.user.confirmBatchOrderCancelledMessage': '确定要取消 {count} 笔订单吗？此操作将把订单标记为已取消。',
  'pages.orders.user.confirmLabelGenerate': '确认生成面单？',
  'pages.orders.user.labelGenerateSuccess': '面单已生成',
  'pages.orders.user.confirmLabelRegenerate': '确认再次生成面单？',
  'pages.orders.user.labelRegenerateSuccess': '面单已再次生成',
  'pages.orders.user.return': '退货',
  'pages.orders.user.additionalService': '附加服务',
  'pages.orders.user.logisticsRequest': '物流中心要求',
  'pages.orders.user.adminMemo': '管理员备注',
  'pages.orders.user.orderMemo': '订单备注',
  'pages.orders.user.adminMemoPlaceholder': '请输入管理员备注...',
  'pages.orders.user.register': '登记',
  'pages.orders.user.adminMemoRegistered': '管理员备注已登记',
  'pages.orders.user.statusChanged': '订单 {orderNo} 状态已更改为 {status}',
  'pages.orders.user.statusChangeNotAllowed': '无法将状态从 {current} 更改为 {new}',
  'pages.orders.user.noStatusChangesAllowed': '此筛选器不允许状态更改',
  'pages.orders.user.invoiceDownloaded': '发票已下载',
  'pages.orders.user.boxInvoiceDownloaded': '装箱单发票已下载',
  'pages.orders.user.trackingSearch': '使用跟踪号 {value} 搜索',
  'pages.orders.user.warehouseScan': '入库扫描',
  'pages.orders.user.lsBatchPrintSs': '批量打印SS码',
  'pages.orders.user.lsPrintSs': '打印SS码',
  'pages.orders.user.lsPrintVv': '打印VV码',
  'pages.orders.user.lsFeeReport': 'LS订单费用报表',
  'pages.orders.user.lsShippingList': 'LS订单发货清单',
  'pages.orders.user.lsSelectLsOrders': '请选择订单号以 LS 开头的订单',
  'pages.orders.user.lsBatchPrintSsLoading': '生成中…',
  'pages.orders.user.lsBatchPrintSsSuccess': '已打开链接',
  'pages.orders.user.lsBatchPrintSsFailed': '批量打印SS码失败',
  'pages.orders.user.lsPrintSsLoading': '生成中…',
  'pages.orders.user.lsPrintSsSuccess': '已打开链接',
  'pages.orders.user.lsPrintSsFailed': '打印SS码失败',
  'pages.orders.user.lsPrintVvFailed': '打印VV码失败',
  'pages.orders.user.lsReportLoading': '加载中…',
  'pages.orders.user.lsReportOpened': '已在新标签页打开',
  'pages.orders.user.lsReportFailed': '打开LS订单费用报表失败',
  'pages.orders.user.lsShippingListFailed': '打开LS订单发货清单失败',
  'pages.orders.user.rackManagement': '货架管理',
  'pages.orders.user.noUserId': '用户ID不可用',

  // Warehouse Receipt Modal
  'pages.orders.warehouseReceipt.loadWarehousesFailed': '加载仓库列表失败',
  'pages.orders.warehouseReceipt.enterTrackingNumber': '请输入运单号',
  'pages.orders.warehouseReceipt.selectWarehouse': '请选择仓库',
  'pages.orders.warehouseReceipt.selectWarehousePlaceholder': '选择仓库',
  'pages.orders.warehouseReceipt.scanFailed': '扫描运单号失败',
  'pages.orders.warehouseReceipt.loadingComplete': '上架已完成',
  'pages.orders.warehouseReceipt.loadingFailed': '上架失败',
  'pages.orders.warehouseReceipt.rackOccupied': '该货架位置已被占用',
  'pages.orders.warehouseReceipt.cameraNotReady': '相机尚未准备好',
  'pages.orders.warehouseReceipt.captureFailed': '拍照失败',
  'pages.orders.warehouseReceipt.captureSuccess': '拍照成功',
  'pages.orders.warehouseReceipt.onlyImagesAllowed': '只能上传图片文件',
  'pages.orders.warehouseReceipt.imageTooLarge': '图片大小需小于 10MB',
  'pages.orders.warehouseReceipt.noWaybillImage': '请至少上传一张运单图片',
  'pages.orders.warehouseReceipt.receiptRegistered': '入库登记成功',
  'pages.orders.warehouseReceipt.receiptRegisterFailed': '入库登记失败',
  'pages.orders.warehouseReceipt.chooseUploadMethod': '选择上传方式',
  'pages.orders.warehouseReceipt.takePhotoWithCamera': '使用相机拍照',
  'pages.orders.warehouseReceipt.uploadFromFiles': '从文件上传',
  'pages.orders.warehouseReceipt.capture': '拍照',
  'pages.orders.warehouseReceipt.trackingNumber': '运单号',
  'pages.orders.warehouseReceipt.trackingNumberPlaceholder': '请输入运单号',
  'pages.orders.warehouseReceipt.scan': '扫描',
  'pages.orders.warehouseReceipt.noMatchedOrder': '未找到匹配的订单',
  'pages.orders.warehouseReceipt.orderNumber': '订单号：',
  'pages.orders.warehouseReceipt.products': '商品列表：',
  'pages.orders.warehouseReceipt.quantity': '数量',
  'pages.orders.warehouseReceipt.notes': '备注',
  'pages.orders.warehouseReceipt.designatedShooting': '指定拍照',
  'pages.orders.warehouseReceipt.designatedShootingPhoto': '照片',
  'pages.orders.warehouseReceipt.registerNoData': '无订单入库登记',
  'pages.orders.warehouseReceipt.register': '入库登记',
  'pages.orders.warehouseReceipt.reinspection': '重新检验',
  'pages.orders.warehouseReceipt.rackDesignation': '货架分配',
  'pages.orders.warehouseReceipt.rackDesignationTitle': '货架分配',
  'pages.orders.warehouseReceipt.rackDesignationTracking': '运单号：{trackingNumber}',
  'pages.orders.warehouseReceipt.locationCode': '位置编码',
  'pages.orders.warehouseReceipt.locationCodePlaceholder': '请输入位置编码（例如：S-01-01-012）',
  'pages.orders.warehouseReceipt.waybillImagesRequired': '运单图片（必填）',
  'pages.orders.warehouseReceipt.uploadWaybillImage': '上传运单图片',
  'pages.orders.warehouseReceipt.hasIssue': '是否有问题',
  'pages.orders.warehouseReceipt.issueImages': '问题图片',
  'pages.orders.warehouseReceipt.productImages': '商品图片',
  'pages.orders.warehouseReceipt.uploadIssueImage': '上传问题图片',
  'pages.orders.warehouseReceipt.uploadProductImage': '上传商品图片',
  'pages.orders.warehouseReceipt.adminMemo': '管理员备注',
  'pages.orders.warehouseReceipt.adminMemoPlaceholder': '请输入备注...',
  'pages.orders.warehouseReceipt.cashOnDeliveryOptional': '货到付款金额（可选）',
  'pages.orders.warehouseReceipt.cashOnDeliveryPlaceholder': '请输入货到付款金额',

  // Picking Modal
  'pages.orders.picking.title': '拣货',
  'pages.orders.picking.trackingNumber': '运单号',
  'pages.orders.picking.trackingNumberPlaceholder': '请输入运单号',
  'pages.orders.picking.scan': '扫描',
  'pages.orders.picking.pick': '拣货',
  'pages.orders.picking.orderNumber': '订单号：',
  'pages.orders.picking.rackNumber': '货架号：',
  'pages.orders.picking.itemsToPick': '待拣货商品：',
  'pages.orders.picking.productInformation': '商品信息',
  'pages.orders.picking.quantity': '数量',
  'pages.orders.picking.noOrdersReady': '暂无可拣货的订单',
  'pages.orders.picking.fetchFailed': '获取待拣货订单失败',
  'pages.orders.picking.enterTrackingNumber': '请输入运单号',
  'pages.orders.picking.noMatchedProduct': '未找到可拣货的商品',
  'pages.orders.picking.noMatchedProductWithTracking':
    '根据该运单号未找到可拣货的商品',
  'pages.orders.picking.orderFound': '已找到可拣货的订单',
  'pages.orders.picking.scanFailed': '扫描运单号失败',
  'pages.orders.picking.noOrderSelected': '未选择要拣货的订单',
  'pages.orders.picking.completed': '拣货完成',
  'pages.orders.picking.completeFailed': '拣货失败',

  'pages.orders.user.packagingManagement': '包装管理',
  'pages.orders.user.shipmentScan': '出库扫描',
  'pages.orders.user.batchProcess': '批量处理选中的 {count} 笔',
  'pages.orders.user.excelDownload': 'Excel下载',
  'pages.orders.user.selectOrdersFirst': '请先选择订单。',
  'pages.orders.user.chimingtongNote': '选择订单后点击下载',
  'pages.orders.user.lsShippingManifest': '红空运',
  'pages.orders.user.silutongSeaManifest': '丝路通海运',
  'pages.orders.user.chimingtong': '驰名通',
  'pages.orders.user.chimingtongEnCn': '驰名通EN+CN',
  'pages.orders.user.chimingtongKr': '驰名通KR',
  'pages.orders.user.exportingOrders': '正在导出订单...',
  'pages.orders.user.exportSuccess': '成功导出 {count} 个订单',
  'pages.orders.user.trackingBatchRegister': '批量登记运单',
  'pages.orders.user.statusChange': '更改状态',
  'pages.orders.user.statusChangeSelect': '= 更改状态',
  'pages.orders.user.totalSelectedPrice': '选中总额',
  'pages.orders.user.productPrice': '商品',
  'pages.orders.user.shippingPrice': '运费',
  'pages.orders.user.smsNotSend': '不发送短信',
  'pages.orders.user.smsSend': '发送短信',
  'pages.orders.user.statusChangeConfirm': '正在更改选中的 {count} 笔订单状态',
  'pages.orders.user.batchStatusChangeConfirm': '确认批量状态更改',
  'pages.orders.user.batchStatusChangeMessage': '确定要将 {count} 笔订单更改为 "{status}" 吗？',
  'pages.orders.user.batchStatusChangeSuccess': '成功更新 {count} 笔订单',
  'pages.orders.user.batchStatusChangeError': '部分订单更新失败',
  'pages.orders.user.noOrdersSelected': '请至少选择一笔订单',
  'pages.orders.user.someStatusChangesNotAllowed': '{count} 笔订单无法更改为此状态',
  'pages.orders.user.search': '搜索',
  'pages.orders.user.reset': '重置',
  'pages.orders.user.showMore': '显示更多 ▼',
  'pages.orders.user.searchFilterSelectTemplate': '{label} — 请选择',
  'pages.orders.user.searchFilterTextTemplate': '{label} — {hint}',
  'pages.orders.user.searchFilterDateStartTemplate': '{label} 开始',
  'pages.orders.user.searchFilterDateEndTemplate': '{label} 结束',
  'pages.orders.user.collapse': '收起 ▲',
  'pages.orders.user.total': '共 {total} 笔',
  'pages.orders.user.Picking': '拣货处理',
  // Inpacking Upload Modal
  'pages.orders.inpackingUpload.title': '内包装上传 - 订单: {orderNo}',
  'pages.orders.inpackingUpload.orderNo': '订单号',
  'pages.orders.inpackingUpload.fileLabel': '文件登记',
  'pages.orders.inpackingUpload.chooseFile': '选择文件',
  'pages.orders.inpackingUpload.register': '登记',
  'pages.orders.inpackingUpload.fileRequired': '请选择要上传的文件',
  'pages.orders.inpackingUpload.registered': '内包装文件已登记',
  // Purchase Cost Modal
  'pages.orders.purchaseCost.title': '采购成本 - 订单: {orderNo}',
  'pages.orders.purchaseCost.orderInfo': '订单信息',
  'pages.orders.purchaseCost.orderNoTracking': '订单号 / 运单号',
  'pages.orders.purchaseCost.totalQuantityCenterReceiver': '总数量 / 中心 / 收件人',
  'pages.orders.purchaseCost.totalQuantity': '总数量',
  'pages.orders.purchaseCost.center': '中心',
  'pages.orders.purchaseCost.receiver': '收件人',
  'pages.orders.purchaseCost.totalPrice': '商品总金额',
  'pages.orders.purchaseCost.productInfo': '商品信息',
  'pages.orders.purchaseCost.productNo': '商品编号',
  'pages.orders.purchaseCost.productImage': '图片',
  'pages.orders.purchaseCost.productName': '商品名称',
  'pages.orders.purchaseCost.quantity': '数量',
  'pages.orders.purchaseCost.unitPrice': '单价',
  'pages.orders.purchaseCost.localShippingFee': '当地运费',
  'pages.orders.purchaseCost.localShippingFeeTotal': '当地运费合计',
  'pages.orders.purchaseCost.adminNote': '管理员备注',
  'pages.orders.purchaseCost.adminNotePlaceholder': '请输入管理员备注...',
  'pages.orders.purchaseCost.estimate': '采购成本预估',
  'pages.orders.purchaseCost.exchangeRate': '适用汇率',
  'pages.orders.purchaseCost.exchangeRateSuffix': '每¥1的韩元',
  'pages.orders.purchaseCost.productPurchaseCost': '商品采购成本',
  'pages.orders.purchaseCost.purchaseFee': '代购手续费',
  'pages.orders.purchaseCost.additionalCosts': '附加费用',
  'pages.orders.purchaseCost.excessCost': '商品超额费用',
  'pages.orders.purchaseCost.totalAmount': '总金额',
  'pages.orders.purchaseCost.currentDeposit': '当前预存款',
  'pages.orders.purchaseCost.remainingDeposit': '剩余预存款',
  'pages.orders.purchaseCost.smsNotSend': '不发送短信',
  'pages.orders.purchaseCost.smsSend': '发送短信',
  
  // Business Orders Page
  'pages.orders.business.title': '企业会员订单',
  'pages.orders.business.filterApplied': '{group} > {label} 筛选已应用（企业）',
  'pages.orders.business.businessMember': '企业',
  'pages.orders.business.businessNumber': '企业编号',
  'pages.orders.business.businessNumberPlaceholder': '企业注册号',
  'pages.orders.business.orderDetails': '订单详情',
  'pages.orders.business.orderDate': '订单日期',
  'pages.orders.business.paymentMethod': '支付方式',
  'pages.orders.business.deliveryMemo': '配送备注',
  'pages.orders.business.productList': '商品列表',
  'pages.orders.business.image': '图片',
  'pages.orders.business.productName': '商品名称',
  'pages.orders.business.option': '选项',
  'pages.orders.business.unitPrice': '单价',
  'pages.orders.business.total': '合计',
  
  // Search Filters
  'pages.orders.filter.center': '中心',
  'pages.orders.filter.centerAll': '全部',
  'pages.orders.filter.centerWeihai': '(中国)威海',
  'pages.orders.filter.centerQingdao': '(中国)青岛',
  'pages.orders.filter.centerGuangzhou': '(中国)广州',
  'pages.orders.filter.typeAll': '全部',
  'pages.orders.filter.typeShipping': '代运',
  'pages.orders.filter.typePurchase': '代购',
  'pages.orders.filter.typeVVIC': 'VVIC快速通道',
  'pages.orders.filter.typeReturn': '退货代理',
  'pages.orders.filter.typeMinimall': '迷你商城',
  'pages.orders.filter.platformTypeAll': '全部',
  'pages.orders.filter.platformType1688': '1688',
  'pages.orders.filter.platformTypeTaobao': '淘宝',
  'pages.orders.filter.platformTypeVVIC': 'VVIC',
  'pages.orders.filter.platformTypeWSY': 'WSY',
  'pages.orders.filter.platformTypeVIP': 'VIP',
  'pages.orders.filter.platformTypeSelf': '自营商城',
  'pages.orders.filter.platformTypeLive': '直播',
  'pages.orders.filter.shippingMethodAll': '全部',
  'pages.orders.filter.shippingMethodAir': '空运',
  'pages.orders.filter.shippingMethodAirExpress': '空运快递',
  'pages.orders.filter.shippingMethodSea': '海运',
  'pages.orders.filter.shippingMethodSeaExpress': '海运快递',
  'pages.orders.filter.shippedAll': '全部',
  'pages.orders.filter.shippedAuto': '自动付款',
  'pages.orders.filter.shippedAutoNote': '使用系统钱包自动付款',
  'pages.orders.filter.shippedManual': '手动付款',
  'pages.orders.filter.shippedManualNote': '系统钱包没钱，客户需要自行付款',
  'pages.orders.filter.dateRange': '日期范围',
  'pages.orders.filter.selectDate': '选择日期',
  'pages.orders.filter.registrationDate': '注册日期',
  'pages.orders.filter.startDatePlaceholder': '开始日期',
  'pages.orders.filter.endDatePlaceholder': '结束日期',
  'pages.orders.filter.warehouseStatusAll': '全部',
  'pages.orders.filter.warehouseStatusExpected': '预计入库',
  'pages.orders.filter.warehouseStatusPartial': '部分入库',
  'pages.orders.filter.warehouseStatusDone': '入库完成',
  'pages.orders.filter.userNamePlaceholder': '会员名',
  'pages.orders.filter.mailboxPlaceholder': '邮箱号',
  'pages.orders.filter.receiverPlaceholder': '收件人姓名',
  'pages.orders.filter.productNo': '商品编号',
  'pages.orders.filter.productNoPlaceholder': '商品编号/子订单号',
  'pages.orders.filter.memberUniqueNo': 'UID',
  'pages.orders.filter.memberUniqueNoPlaceholder': '请输入会员UID',
  'pages.orders.filter.customerPhone': '客户电话号码',
  'pages.orders.filter.customerPhonePlaceholder': '请输入客户电话号码',
  'pages.orders.filter.trackingNo': '跟踪号',
  'pages.orders.filter.trackingNoPlaceholder': '中国/韩国跟踪号',
  'pages.orders.filter.orderNoPlaceholder': 'TM2025...',
  'pages.orders.filter.krTrackPlaceholder': '韩国运单号',
  'pages.orders.filter.internationalTrackingNo': '国际运单号',
  'pages.orders.filter.paidStart': '结算开始时间',
  'pages.orders.filter.paidEnd': '结算截止时间',
  'pages.orders.filter.orderType': '订单类型',
  'pages.orders.filter.orderTypeAll': '全部',
  'pages.orders.filter.orderTypeGeneral': '普通',
  'pages.orders.filter.orderTypeBuy': '购买',
  'pages.orders.filter.orderTypeDel': '配送',
  'pages.orders.filter.orderTypeVvic': 'VVIC',
  'pages.orders.filter.orderTypeReturn': '退货',
  'pages.orders.filter.orderTypeMinimall': 'Minimall',
  'pages.orders.filter.shippingStatus': '配送状态',
  'pages.orders.filter.shippingStatusAll': '全部',
  'pages.orders.filter.shippingStatusNotShipped': '未发货',
  'pages.orders.filter.shippingStatusShipped': '已发货',
  'pages.orders.filter.shippingStatusAuto': '自动',
  'pages.orders.filter.shippingStatusManual': '手动',
  'pages.orders.filter.warehouseStatusNotWarehoused': '未入库',
  'pages.orders.filter.warehouseStatusProcessing': '处理中',
  'pages.orders.filter.warehouseStatusWarehoused': '已入库',
  'pages.orders.filter.paymentStatusAll': '全部',
  'pages.orders.filter.paymentStatusPending': '待付款',
  'pages.orders.filter.paymentStatusProcessing': '处理中',
  'pages.orders.filter.paymentStatusPaid': '已付款',
  'pages.orders.filter.paymentStatusFailed': '失败',
  'pages.orders.filter.paymentStatusRefunded': '已退款',
  'pages.orders.filter.transferMethodAll': '全部',
  'pages.orders.filter.transferMethodShip': '海运',
  'pages.orders.filter.transferMethodAir': '空运',
  'pages.orders.filter.transferMethodShipExpress': '海运快递',
  'pages.orders.filter.transferMethodAirExpress': '空运快递',
  'pages.orders.filter.gyeongdongCod': '京东货到付款',
  'pages.orders.filter.closedArea': '封闭区域',

  // User Profile
  'pages.userProfile.editInfo': '编辑信息',
  'pages.userProfile.logout': '退出登录',
  'pages.userProfile.modalTitle': '编辑用户信息',
  'pages.userProfile.userId': '用户ID',
  'pages.userProfile.grade': '等级',
  'pages.userProfile.name': '姓名',
  'pages.userProfile.namePlaceholder': '请输入姓名',
  'pages.userProfile.nameRequired': '请输入姓名',
  'pages.userProfile.email': '邮箱',
  'pages.userProfile.emailPlaceholder': '请输入邮箱',
  'pages.userProfile.emailRequired': '请输入邮箱',
  'pages.userProfile.emailInvalid': '邮箱格式不正确',
  'pages.userProfile.phone': '电话',
  'pages.userProfile.phonePlaceholder': '请输入电话号码',
  'pages.userProfile.phoneRequired': '请输入电话号码',
  'pages.userProfile.newPassword': '新密码',
  'pages.userProfile.newPasswordPlaceholder': '请输入新密码（可选）',
  'pages.userProfile.passwordMinLength': '密码至少需要6个字符',
  'pages.userProfile.confirmPassword': '确认密码',
  'pages.userProfile.confirmPasswordPlaceholder': '请再次输入密码',
  'pages.userProfile.passwordMismatch': '密码不匹配',
  'pages.userProfile.updateSuccess': '信息更新成功。',
  'pages.userProfile.updateFailed': '信息更新失败。',

  // Members List Page
  'pages.members.list.title': '会员管理',
  'pages.members.list.memberInfo': '会员信息',
  'pages.members.list.level': '等级',
  'pages.members.list.levelAll': '全部',
  'pages.members.list.levelGeneral': '普通',
  'pages.members.list.levelVIP': 'VIP',
  'pages.members.list.levelVVIP': 'VVIP',
  'pages.members.list.levelBlack': '黑名单',
  'pages.members.list.levelDormant': '休眠',
  'pages.members.list.levelChanged': '会员等级已更改',
  'pages.members.list.levelChangeError': '更改会员等级失败',
  'pages.members.list.mailbox': '私信函',
  'pages.members.list.totalAmount': '累计金额',
  'pages.members.list.unpaidAmount': '未付款',
  'pages.members.list.orderCount': '订单数',
  'pages.members.list.lastOrder': '最近订单',
  'pages.members.list.lastLogin': '最近登录',
  'pages.members.list.joinedAt': '加入日期',
  'pages.members.list.registrationTime': '注册时间',
  'pages.members.list.actions': '操作',
  'pages.members.list.detail': '详情',
  'pages.members.list.edit': '编辑',
  'pages.members.list.delete': '删除',
  'pages.members.list.more': '更多',
  'pages.members.list.deleteConfirm': '确定要删除此会员吗？',
  'pages.members.list.deleteConfirmDesc': '此操作无法撤销。',
  'pages.members.list.deleteSuccess': '会员已删除',
  'pages.members.list.deleteError': '删除会员失败',
  'pages.members.list.cancel': '取消',
  'pages.members.list.adjustDeposit': '预存款调整',
  'pages.members.list.adjustDeposit.amount': '调整金额',
  'pages.members.list.adjustDeposit.amountHelp': '正数为增加，负数为扣减。',
  'pages.members.list.adjustDeposit.amountPlaceholder': '例如：5000',
  'pages.members.list.adjustDeposit.amountRequired': '请输入大于零的金额。',
  'pages.members.list.adjustDeposit.direction': '调整方向',
  'pages.members.list.adjustDeposit.direction.add': '增加',
  'pages.members.list.adjustDeposit.direction.subtract': '扣减',
  'pages.members.list.adjustDeposit.preview': '调整后余额',
  'pages.members.list.adjustDeposit.negativeWarning': '扣减后余额将为负数，服务器会拒绝此操作。',
  'pages.members.list.batchAdjustDeposit': '批量调整预存款',
  'pages.members.list.batchAdjustDepositTitle': '批量调整 {count} 名会员的预存款',
  'pages.members.list.batchAdjustDeposit.targets': '目标',
  'pages.members.list.batchAdjustDeposit.targetsCount': '{count} 名会员',
  'pages.members.list.batchAdjustDeposit.amountHelp': '所选所有会员将应用相同的调整金额与原因。',
  'pages.members.list.batchAdjustDeposit.noSelection': '请先选择会员。',
  'pages.members.list.batchAdjustDeposit.success': '已为 {count} 名会员调整预存款。',
  'pages.members.list.batchAdjustDeposit.partial': '成功 {ok} 条，失败 {fail} 条。',
  'pages.members.list.batchAdjustDeposit.failuresTitle': '部分会员调整失败',
  'pages.members.list.adjustDeposit.reason': '调整原因',
  'pages.members.list.adjustDeposit.reasonPlaceholder': '例如：活动奖励、错误扣减等',
  'pages.members.list.adjustDeposit.reasonRequired': '请输入调整原因。',
  'pages.members.list.adjustDeposit.submit': '调整',
  'pages.members.list.adjustDeposit.success': '预存款已调整。',
  'pages.members.list.adjustDeposit.failed': '预存款调整失败。',
  'pages.members.list.nickname': '昵称',
  'pages.members.list.country': '国家',
  'pages.members.list.accountBalance': '账户余额',
  'pages.members.list.status': '状态',
  'pages.members.list.statusActive': '活跃',
  'pages.members.list.statusDormant': '休眠',
  'pages.members.list.statusBlacklisted': '黑名单',
  'pages.members.list.notes': '备注',
  'pages.members.list.more.orders': '前往订单页面',
  'pages.members.list.more.recharge': '前往余额充值页面',
  'pages.members.list.more.points': '前往积分充值页面',
  'pages.members.list.editMember': '编辑会员信息',
  'pages.members.list.updateSuccess': '会员信息已更新',
  'pages.members.list.updateError': '更新会员信息失败',
  'pages.members.list.totalConsumption': '总消费金额',
  'pages.members.list.monthlyOrderCount': '当月订单数',
  'pages.members.list.monthlyConsumption': '当月消费金额',
  'pages.members.list.purchaseHistory': '购买历史',
  'pages.members.list.orderNo': '订单号',
  'pages.members.list.orderDate': '订单日期',
  'pages.members.list.orderAmount': '订单金额',
  'pages.members.list.orderStatus': '状态',
  'pages.members.list.message': '消息',
  'pages.members.list.black': '拉黑',
  'pages.members.list.unblack': '解除',
  'pages.members.list.blackConfirm': '确定拉黑此会员？',
  'pages.members.list.unblackConfirm': '确定解除拉黑？',
  'pages.members.list.blackSuccess': '已拉黑',
  'pages.members.list.unblackSuccess': '已解除拉黑',
  'pages.members.list.totalMembers': '全部会员',
  'pages.members.list.vipMembers': 'VIP会员',
  'pages.members.list.newThisMonth': '本月新增',
  'pages.members.list.blackMembers': '黑名单会员',
  'pages.members.list.excelDownload': 'Excel下载',
  'pages.members.list.exportingSelected': '正在导出选中的{count}个会员...',
  'pages.members.list.exportingAll': '正在导出当前页会员...',
  'pages.members.list.noDataToExport': '没有数据可导出',
  'pages.members.list.exportSuccess': '成功导出{count}个会员',
  'pages.members.list.exportError': '导出Excel失败',
  'pages.members.list.blackManagement': '黑名单管理',
  'pages.members.list.sendSelectedMessage': '发送消息给选中',
  'pages.members.list.bulkBlack': '批量拉黑',
  'pages.members.list.bulkBlackConfirm': '确定拉黑{count}名会员？',
  'pages.members.list.detailTitle': '会员详情',
  'pages.members.list.close': '关闭',
  'pages.members.list.sendMessage': '发送消息',
  'pages.members.list.tabBasic': '基本信息',
  'pages.members.list.tabOrder': '订单信息',
  'pages.members.list.tabMemo': '管理员备注',
  'pages.members.list.memberId': '会员ID',
  'pages.members.list.memberIdEmail': '会员ID / 邮箱',
  'pages.members.list.id': 'ID',
  'pages.members.list.membershipCode': '会员代码',
  'pages.members.list.memberName': '会员名',
  'pages.members.list.recipientName': '收件人姓名',
  'pages.members.list.userId': 'ID',
  'pages.members.list.startNumber': '起始编号',
  'pages.members.list.endNumber': '结束编号',
  'pages.members.list.applicationAcceptance': '申请接受',
  'pages.members.list.referralCode': '推荐码',
  'pages.members.list.referredBy': '推荐人',
  'pages.members.list.referredByPlaceholder': '推荐人会员ID、唯一标识或接口要求的值',
  'pages.members.list.batchUpdateReferredBy': '批量设置推荐人',
  'pages.members.list.batchUpdateReferredByTitle': '批量设置推荐人（已选 {count} 人）',
  'pages.members.list.batchUpdateReferredByRequired': '请填写推荐人',
  'pages.members.list.batchUpdateReferredByNoSelection': '未选择会员',
  'pages.members.list.batchUpdateReferredByResult': '成功 {success} 人；失败 {failed} 人',
  'pages.members.list.batchUpdateReferredByAllFailed': '全部更新失败',
  'pages.members.list.recommendationPointsAccumulated': '累计积分',
  'pages.members.list.personInCharge': '负责人',
  'pages.members.list.adminDesignatedDate': '管理员指定日期',
  'pages.members.list.adminDateSaved': '管理员指定日期保存成功',
  'pages.members.list.adminDateSaveError': '管理员指定日期保存失败',
  'pages.members.list.personalCustomsCode': '个人清关代码',
  'pages.members.list.memo': '备注',
  'pages.members.list.smsNotification': '短信通知',
  'pages.members.list.smsNotificationAgreement': '短信通知协议',
  'pages.members.list.kakaotalkAgree': 'Kakaotalk同意',
  'pages.members.list.smsAgree': '短信同意',
  'pages.members.list.emailAgree': '电子邮件同意',
  'pages.members.list.orderInquiryAgree': '订单查询同意',
  'pages.members.list.receiveOrderSMS': '订单短信',
  'pages.members.list.receive2000SMS': '2000短信',
  'pages.members.list.receiveShippingSMS': '发货短信',
  'pages.members.list.receiveDeliverySMS': '送达短信',
  'pages.members.list.shippingAddress': '配送地址',
  'pages.members.list.registrationDate': '注册日期',
  'pages.members.list.lastAccessDate': '最近访问日期',
  'pages.members.list.completedOrders': '完成订单数',
  'pages.members.list.totalShippingCost': '总运费',
  'pages.members.list.totalAdditionalCost': '总附加费用',
  'pages.members.list.noDataCount': '无数据数量',
  'pages.members.list.totalPointsUsed': '总积分使用',
  'pages.members.list.totalProductCost': '总商品费用',
  'pages.members.list.totalProductRefund': '总商品退款',
  'pages.members.list.totalCouponDiscount': '总优惠券折扣',
  'pages.members.list.totalShippingRefund': '总运费退款',
  'pages.members.list.smsNotificationPlaceholder': '短信通知设置',
  'pages.members.list.memoPlaceholder': '输入备注',
  'pages.members.list.changePassword': '更改密码',
  'pages.members.list.changePasswordPlaceholder': '输入新密码',
  'pages.members.list.accumulatedPoints': '累计积分',
  'pages.members.list.basicInfo': '基本信息',
  'pages.members.list.memberStatistics': '会员统计',
  'pages.members.list.lastLoginDate': '最近登录日期',
  'pages.members.list.shippedOrders': '已发货订单',
  'pages.members.list.purchaseOrders': '购买订单',
  'pages.members.list.noData': '无数据',
  'pages.members.list.totalTransportationPaid': '总运费支付',
  'pages.members.list.totalPurchasingPaid': '总购买支付',
  'pages.members.list.totalAdditionalPaid': '总附加支付',
  'pages.members.list.totalCouponUsage': '总优惠券使用',
  'pages.members.list.notPaidOrders': '未付款订单',
  'pages.members.list.totalNotPaidAmount': '总未付款金额',
  'pages.members.list.name': '姓名',
  'pages.members.list.email': '电子邮件',
  'pages.members.list.phone': '电话',
  'pages.members.list.memberLevel': '会员等级',
  'pages.members.list.totalOrders': '总订单数',
  'pages.members.list.lastOrderDate': '最近订单日期',
  'pages.members.list.totalPayment': '累计付款',
  'pages.members.list.unpaid': '未付款',
  'pages.members.list.averageOrder': '平均订单',
  'pages.members.list.points': '积分',
  'pages.members.list.pointsUpdated': '积分更新成功',
  'pages.members.list.pointsUpdateError': '积分更新失败',
  'pages.members.list.userUpdated': '用户信息更新成功',
  'pages.members.list.adminMemo': '管理员备注',
  'pages.members.list.adminMemoPlaceholder': '输入管理员备注',
  'pages.members.list.save': '保存',
  'pages.members.list.memoSaved': '备注已保存',
  'pages.members.list.sendMessageTitle': '发送消息',
  'pages.members.list.sendMethod': '发送方式',
  'pages.members.list.sms': '短信',
  'pages.members.list.emailMethod': '电子邮件',
  'pages.members.list.both': '短信+电子邮件',
  'pages.members.list.subject': '主题',
  'pages.members.list.subjectPlaceholder': '消息主题',
  'pages.members.list.content': '内容',
  'pages.members.list.contentPlaceholder': '输入消息内容',
  'pages.members.list.messageSent': '消息已发送',
  'pages.members.list.count': '笔',
  'pages.members.list.currency': '¥',
  'pages.members.list.userUniqueId': 'UID',

  // General Members Page
  'pages.members.general.title': '普通会员',
  'pages.members.general.total': '共 {total} 名会员',
  'pages.members.general.memberType': '会员类型',
  'pages.members.general.memberTypeTag': '普通',
  'pages.members.general.totalGeneral': '全部普通会员',
  'pages.members.general.dormantMembers': '休眠会员',
  'pages.members.general.memberTypeLabel': '普通会员',
  'pages.members.general.memberName': '会员名',
  'pages.members.general.memberNameSearch': '按会员名搜索',
  'pages.members.general.allLevels': '全部',
  'pages.members.general.emailVerification': '邮箱验证',
  'pages.members.general.emailVerified': '已验证',
  'pages.members.general.emailUnverified': '未验证',
  'pages.members.general.loadMemberDetailsError': '加载会员详细信息失败',
  'pages.members.general.loadMemberListError': '加载会员列表失败',
  'pages.members.general.searchMemberName': '会员名',
  'pages.members.general.searchMemberNamePlaceholder': '按会员名搜索',

  // Member Document Management Page
  'pages.members.documents.title': '会员文件管理',
  'pages.members.documents.documentName': '文件名称',
  'pages.members.documents.fileName': '文件名',
  'pages.members.documents.fileUrl': '文件',
  'pages.members.documents.download': '下载',
  'pages.members.documents.createdAt': '创建时间',
  'pages.members.documents.updatedAt': '更新时间',
  'pages.members.documents.register': '登记文件',
  'pages.members.documents.documentTemplate': '文件模板',
  'pages.members.documents.selectFile': '选择文件',
  'pages.members.documents.documentNamePlaceholder': '请输入文件名称',
  'pages.members.documents.documentNameKo': '文件名称（韩语）',
  'pages.members.documents.documentNameEn': '文件名称（英语）',
  'pages.members.documents.documentNameZh': '文件名称（中文）',
  'pages.members.documents.atLeastOneNameRequired': '请至少输入一种语言的文件名称',
  'pages.members.documents.fileRequired': '请选择要上传的文件',
  'pages.members.documents.deleteConfirm': '确定要删除此文件吗？',

  // Order Detail Page
  'pages.orders.detail.title': '订单详情',
  'pages.orders.shippingMethod.sea': '海运',
  'pages.orders.shippingMethod.air': '空运',
  'pages.orders.shippingMethod.standard': '普通',
  'pages.orders.detail.close': '关闭',
  'pages.orders.detail.error': '加载订单详情失败',
  'pages.orders.detail.paymentAddress': '支付地址',
  'pages.orders.detail.depositorName': '汇款人',
  'pages.orders.detail.paymentAmount': '支付金额',
  'pages.orders.detail.paymentMethod': '支付方式',
  'pages.orders.detail.paymentTime': '支付时间',
  'pages.orders.detail.notFound': '找不到订单',
  'pages.orders.detail.goBack': '返回',
  'pages.orders.detail.basicInfo': '订单基本信息',
  'pages.orders.detail.orderNumber': '订单号 / 会员名 / 邮箱',
  'pages.orders.detail.product.orderNumber': '订单号',
  'pages.orders.detail.orderType': '中心',
  'pages.orders.detail.depositAutoPay': '押金自动支付',
  'pages.orders.detail.depositManualPay': '押金手动支付',
  'pages.orders.detail.AutoPay': '自动支付',
  'pages.orders.detail.ManualPay': '手动支付',
  'pages.orders.detail.switchToAutoPay': '切换到自动支付',
  'pages.orders.detail.switchToManualPay': '切换到手动支付',
  'pages.orders.detail.switchedToAutoPay': '已成功切换到自动支付',
  'pages.orders.detail.switchedToManualPay': '已成功切换到手动支付',
  'pages.orders.detail.updateFailed': '更新支付方式失败',
  'pages.orders.detail.progressStatus': '进度状态(商品入库状态)',
  'pages.orders.detail.shippingMethod': '运输方式',
  'pages.orders.detail.orderMemo': '订单备注',
  'pages.orders.detail.registrationDate': '注册日期',
  'pages.orders.detail.modifiedDate': '修改日期',
  'pages.orders.detail.purchaseManager': '采购经理',
  'pages.orders.detail.rackNumber': '货架号',
  'pages.orders.detail.externalOrderId': '外部订单ID',
  'pages.orders.detail.editExternalOrderId': '编辑外部订单ID',
  'pages.orders.detail.edit': '编辑',
  'pages.orders.detail.externalOrderIdPlaceholder': '请输入外部订单ID',
  'pages.orders.detail.externalOrderIdUpdated': '外部订单ID更新成功',
  'pages.orders.detail.externalOrderIdUpdateFailed': '外部订单ID更新失败',
  'pages.orders.detail.memberInfo': '会员信息',
  'pages.orders.detail.memberName': '会员名',
  'pages.orders.detail.memberId': '会员ID',
  'pages.orders.detail.receiver': '收件人',
  'pages.orders.detail.contact': '联系方式',
  'pages.orders.detail.deliveryAddress': '配送地址',
  'pages.orders.detail.shippingInfo': '配送中心及服务类型',
  'pages.orders.detail.centerAndTransferMethodChange': '配送中心及转运方式变更',
  'pages.orders.detail.trackingCount': '跟踪数',
  'pages.orders.detail.warehousedCount': '入库数',
  'pages.orders.detail.trackingNumber': '运单号',
  'pages.orders.detail.notRegistered': '未注册',
  'pages.orders.detail.waybillNumberPlaceholder': '请输入运单号',
  'pages.orders.detail.waybillNumberRequired': '请输入运单号',
  'pages.orders.detail.waybillNumberUpdated': '运单号已修改',
  'pages.orders.detail.waybillNumberUnchanged': '运单号与之前相同',
  'pages.orders.detail.waybillNumberUpdateFailed': '运单号修改失败',
  'pages.orders.detail.waybillNumberDuplicateTitle': '该运单号已被登记',
  'pages.orders.detail.waybillNumberDuplicateConfirm': '仍要使用此运单号保存吗？',
  'pages.orders.detail.shipmentDate': '出库日期',
  'pages.orders.detail.productInfo': '商品信息',
  'pages.orders.detail.preview': '预览',
  'pages.orders.detail.trackingNo': '跟踪号',
  'pages.orders.detail.orderSite': '订单网站',
  'pages.orders.detail.productName': '商品名称',
  'pages.orders.detail.productNumber': '商品编号',
  'pages.orders.detail.orderNo': '订单号',
  'pages.orders.detail.color': '颜色',
  'pages.orders.detail.brandManufacturer': '品牌/制造商',
  'pages.orders.detail.size': '尺寸',
  'pages.orders.detail.warehouseDate': '入库日期',
  'pages.orders.detail.quantityPriceTotal': '数量 × 单价 = 总计',
  'pages.orders.detail.product': '产品',
  'pages.orders.detail.memberProductName': '会员商品名称',
  'pages.orders.detail.productStorage': '商品存储',
  'pages.orders.detail.noStorage': '不存储',
  'pages.orders.detail.inspectionStorage': '检验存储',
  'pages.orders.detail.noInspection': '不检验',
  'pages.orders.detail.totalProductPrice': '总商品价格',
  'pages.orders.detail.realProductAmount': '实际使用金额',
  'pages.orders.detail.shippingCost': '运输费用',
  'pages.orders.detail.otherPrice': '其他费用',
  'pages.orders.detail.additionalCost': '附加服务费用',
  'pages.orders.detail.couponDiscount': '优惠券使用',
  'pages.orders.detail.pointsUsed': '积分使用',
  'pages.orders.detail.consumerPrice': '消费者价格',
  'pages.orders.detail.offerId': '报价ID',
  'pages.orders.detail.customerRequest': '客户要求',
  'pages.orders.detail.addButton': '添加',
  'pages.orders.detail.copyButton': '复制',
  'pages.orders.detail.copiedToClipboard': '已复制到剪贴板',
  'pages.orders.detail.editButton': '编辑',
  'pages.orders.detail.deleteButton': '删除',
  'pages.orders.detail.totalQuantity': '总数量',
  'pages.orders.detail.totalAmount': '总金额',
  'pages.orders.detail.items': '件',
  'pages.orders.detail.shipped': '出库',
  'pages.orders.detail.notShipped': '未出库',
  'pages.orders.detail.shipmentComplete': '出库完成',
  'pages.orders.detail.shipmentCompleteSuccess': '出库完成处理成功',
  'pages.orders.detail.returnProduct': '退货',
  'pages.orders.detail.returnInfo': '前往退货处理页面',
  'pages.orders.detail.receiverInfo': '收件人信息',
  'pages.orders.detail.nameCompany': '姓名（海关编码）',
  'pages.orders.detail.addressContact': '联系方式',
  'pages.orders.detail.businessAddress': '地址',
  'pages.orders.detail.deliveryRequest': '配送要求',
  'pages.orders.detail.centerRequest': '中心要求',
  'pages.orders.detail.paymentInfo': '支付信息',
  'pages.orders.detail.totalProductAmount': '总商品金额',
  'pages.orders.detail.paidAmount': '支付金额',
  'pages.orders.detail.additionalInfo': '附加信息',
  'pages.orders.detail.additionalService': '附加服务',
  'pages.orders.detail.logisticsRequest': '物流中心要求',
  'pages.orders.detail.adminMemo': '管理员备忘录',
  'pages.orders.detail.none': '无',
  'pages.orders.detail.selectAll': '全选',
  'pages.orders.detail.englishProductName': '英文商品名称',
  'pages.orders.detail.hsCode': 'HS编码',
  'pages.orders.detail.noExternalOrderId': '没有可复制的外部订单ID',
  'pages.orders.detail.warehouse': '仓库',
  'pages.orders.detail.selectWarehouse': '选择仓库',
  'pages.orders.detail.selectShippingMethod': '选择运输方式',
  'pages.orders.detail.centerChangeSuccess': '配送中心及运输方式更新成功',
  'pages.orders.detail.centerChangeError': '配送中心及运输方式更新失败',
  'pages.orders.detail.productInfoEdit': '商品信息编辑',
  'pages.orders.detail.statusChangeSuccess': '商品状态更新成功',
  'pages.orders.detail.statusChangeError': '商品状态更新失败',
  'pages.orders.detail.redFieldsRequired': '红色输入项必须填写。',
  'pages.orders.detail.yellowFieldsOptional': '黄色输入项不能修改。',
  'pages.orders.detail.imageReplace': '上传图片',
  'pages.orders.detail.deliveryType': '物品类型',
  'pages.orders.detail.selectDeliveryType': '搜索物品类型',
  'pages.orders.detail.category.clothing': '服装',
  'pages.orders.detail.category.electronics': '电子产品',
  'pages.orders.detail.inputType': '入库状态',
  'pages.orders.detail.quantityPrice': '数量 / 单价',
  'pages.orders.detail.productUrl': '商品URL',
  'pages.orders.detail.colorSize': '颜色',
  'pages.orders.detail.brandSeller': '品牌 / 卖家',
  'pages.orders.detail.material': '材质',
  'pages.orders.detail.managementInfo': '管理信息',
  'pages.orders.detail.sellerAddress': '卖家地址',
  'pages.orders.detail.option': '选项',
  'pages.orders.detail.customsClearance': '清关信息',
  'pages.orders.detail.customsClearancePlaceholder': '请输入清关信息',
  'pages.orders.detail.coEnglishName': 'C/O 英文名称',
  'pages.orders.detail.coHsCode': 'C/O HS编码',
  'pages.orders.type.vvicHighpass': 'VVIC高速通道',
  'pages.orders.type.minimall': '迷你商城',
  'pages.orders.detail.trackingNumberUpdated': '跟踪号更新成功',
  'pages.orders.detail.trackingNumberUpdateFailed': '跟踪号更新失败',
  'pages.orders.detail.trackingNoPlaceholder': '请输入跟踪号',
  'pages.orders.detail.additionalServiceChange': '附加服务变更',
  'pages.orders.detail.simplifiedCustomClearance': '简易通关',
  'pages.orders.detail.designatedShooting': '指定拍摄',
  'pages.orders.detail.additionalServiceUpdated': '附加服务更新成功',
  'pages.orders.detail.additionalServiceUpdateFailed': '附加服务更新失败',
  'pages.orders.detail.changeRecipientAddress': '更改收件人地址',
  'pages.orders.detail.recipientName': '姓名',
  'pages.orders.detail.koreanName': '韩文',
  'pages.orders.detail.englishName': '英文',
  'pages.orders.detail.personalIdNote': '* 个人身份证必须与姓名完全匹配（包括空格）',
  'pages.orders.detail.recipientType': '收件人类型',
  'pages.orders.detail.personal': '个人',
  'pages.orders.detail.business': '企业',
  'pages.orders.detail.foreigner': '外国人',
  'pages.orders.detail.phoneNumber': '电话号码',
  'pages.orders.detail.addressAndContact': '地址和联系方式',
  'pages.orders.detail.zipCodeSearch': '邮编搜索',
  'pages.orders.detail.zipCodeLabel': '邮编',
  'pages.orders.detail.addressLabel': '地址',
  'pages.orders.detail.detailAddress': '详细地址',
  'pages.orders.detail.addressNote': '* 仅限国内地址。国际运输请使用国际运输服务。',
  'pages.orders.detail.deliveryMessageLabel': '配送留言',
  'pages.orders.detail.selectDeliveryMessage': '选择配送留言',
  'pages.orders.detail.leaveAtDoor': '放在门口',
  'pages.orders.detail.leaveWithSecurity': '交给保安',
  'pages.orders.detail.callBeforeDelivery': '配送前联系',
  'pages.orders.detail.deliveryMessagePlaceholder': '输入配送留言',
  'pages.orders.detail.deliveryMessageNote': '* 国内配送服务可能无法满足所有配送要求。',
  'pages.orders.detail.recipientAddressUpdated': '收件人地址更新成功',
  'pages.orders.detail.recipientAddressUpdateFailed': '收件人地址更新失败',
  'pages.orders.detail.orderInquiry': '订单咨询',
  'pages.orders.detail.orderInquiryButton': '订单咨询',
  'pages.orders.detail.orderInquiryRedirect': '正在跳转到订单咨询页面...',
  'pages.orders.detail.orderInquiryModalTitle': '订单咨询',
  'pages.orders.detail.orderInformation': '订单信息',
  'pages.orders.detail.inquiryTitle': '咨询标题',
  'pages.orders.detail.inquiryTitlePlaceholder': '请输入咨询标题',
  'pages.orders.detail.inquiryTitleRequired': '请输入咨询标题',
  'pages.orders.detail.inquiryContent': '咨询内容',
  'pages.orders.detail.inquiryContentPlaceholder': '请详细描述您的咨询内容',
  'pages.orders.detail.inquiryContentRequired': '请输入咨询内容',
  'pages.orders.detail.inquirySubmitted': '咨询提交成功',
  'pages.orders.detail.inquirySubmitFailed': '咨询提交失败',
  'pages.orders.detail.inquiryNote': '* 我们将尽快回复您的咨询。您可以在 CS > 咨询 菜单中查看回复。',
  'pages.common.submit': '提交',
  
  // Product Table
  'pages.orders.productTable.trackingNumber': '追踪号码',  
  'pages.orders.productTable.designatedShooting': '指定拍摄',  
  'pages.orders.productTable.note': '备注',
  'pages.orders.productTable.viewInRealLife': '查看实拍图片',
  'pages.orders.productTable.actualImage': '检验数据',
  'pages.orders.productTable.inspectionData': '检验数据',
  'pages.orders.productTable.statusUpdated': '商品状态已更新为 {status}',
  'pages.orders.productTable.inspectionNumber': '编号',
  'pages.orders.productTable.inspectionImage': '图像',
  'pages.orders.productTable.inspectionDetail': '检验详情',
  'pages.orders.productTable.customsClearanceList': '通关清单',
  'pages.orders.productTable.worker': '作业者',
  'pages.orders.productTable.inspectionTime': '检验时间',
  'pages.orders.productTable.actualDateConfirmationDate': '实拍日期/确认日期',
  'pages.orders.productTable.date': '日期',
  'pages.orders.productTable.preview': '预览',
  'pages.orders.productTable.enterTrackingNumber': '输入追踪号码',
  'pages.orders.productTable.batchSave': '批量保存',
  'pages.orders.productTable.checkbox': '复选框',
  'pages.orders.productTable.number': '编号',
  'pages.orders.productTable.productStatus': '商品状态',
  'pages.orders.productTable.productLog': '商品日志',
  'pages.orders.productTable.image': '图片',
  'pages.orders.productTable.customsItem': '海关项目',
  'pages.orders.productTable.productImage': '商品图片',
  'pages.orders.productTable.productName': '商品名称',
  'pages.orders.productTable.productNumber': '商品编号',
  'pages.orders.productTable.typeOwnmall': 'B - 公司商城',
  'pages.orders.productTable.color': '颜色',
  'pages.orders.productTable.size': '尺寸',
  'pages.orders.productTable.option': '选项',
  'pages.orders.productTable.attribute': '属性',
  'pages.orders.productTable.material': '材质',
  'pages.orders.productTable.sellerInfo': '卖家信息',
  'pages.orders.productTable.orderNo': '订单号',
  'pages.orders.productTable.externalOrderNo': '外部订单号',
  'pages.orders.productTable.exposureOX': '曝光OX',
  'pages.orders.productTable.shippingCost': '配送费用',
  'pages.orders.productTable.actual': '实际',
  'pages.orders.productTable.seller': '卖家',
  'pages.orders.productTable.refundCost': '退款费用',
  'pages.orders.productTable.productType': '商品类型',
  'pages.orders.productTable.member': '会员',
  'pages.orders.productTable.internationalShippingCost': '国际运输成本',
  'pages.orders.productTable.extraInternationalShippingCost': '额外国际运输成本',
  'pages.orders.productTable.unitPrice': '单价',
  'pages.orders.productTable.quantity': '数量',
  'pages.orders.productTable.totalAmount': '总金额',
  'pages.orders.productTable.actualPaidAmount': '实际支付金额',
  'pages.orders.productTable.actualQuantity': '实际数量',
  'pages.orders.productTable.rackNumber': '货架号',
  'pages.orders.productTable.rackNumberSaved': '货架号已保存',
  'pages.orders.productTable.rackNumberSaveError': '货架号保存失败',
  'pages.orders.productTable.rackNumberRequired': '请输入货架号',
  'pages.orders.productTable.trackingRequiredForRack': '该商品没有运单号，无法保存货架号。请先登记运单号',
  'pages.orders.productTable.itemAmountSaved': '商品金额已保存',
  'pages.orders.productTable.itemAmountSaveError': '商品金额保存失败',
  'pages.orders.productTable.productMemoSaveError': '商品备注保存失败',
  'pages.orders.productTable.orderIdRequired': '需要订单ID',
  'pages.orders.productTable.itemIdRequired': '需要商品ID',
  'pages.orders.productTable.externalOrderIdRequired': '更新物流单号需要外部订单ID',
  'pages.orders.productTable.previousRackNumber': '之前货架号',
  'pages.orders.productTable.shipped': '已发货',
  'pages.orders.productTable.notShipped': '未发货',
  'pages.orders.productTable.log': '日志',
  'pages.orders.productTable.reorder.button': '更换规格下单',
  'pages.orders.productTable.reorder.title': '更换规格下单',
  'pages.orders.productTable.reorder.current': '当前商品行',
  'pages.orders.productTable.reorder.quantity': '数量 {quantity}',
  'pages.orders.productTable.reorder.unitPrice': '单价',
  'pages.orders.productTable.reorder.rule': '只能选择单价相同的规格下单，数量不变。不会通知客户。',
  'pages.orders.productTable.reorder.offerIdPlaceholder': '其他商品的商品编号（offerId）',
  'pages.orders.productTable.reorder.loadProduct': '加载商品',
  'pages.orders.productTable.reorder.offerIdInvalid': '请输入数字商品编号。',
  'pages.orders.productTable.reorder.colImage': '图片',
  'pages.orders.productTable.reorder.colOption': '规格',
  'pages.orders.productTable.reorder.colPrice': '单价',
  'pages.orders.productTable.reorder.colStock': '库存',
  'pages.orders.productTable.reorder.samePrice': '价格相同',
  'pages.orders.productTable.reorder.otherPrice': '价格不同',
  'pages.orders.productTable.reorder.preview': '预检',
  'pages.orders.productTable.reorder.place': '下单',
  'pages.orders.productTable.reorder.cancel': '取消',
  'pages.orders.productTable.reorder.previewOk': '可以下单 — 单价 {price}（原 {original}），卖家运费 {shipping}',
  'pages.orders.productTable.reorder.previewFailed': '预检失败。',
  'pages.orders.productTable.reorder.loadFailed': '无法加载商品规格。',
  'pages.orders.productTable.reorder.confirmTitle': '将实际下单',
  'pages.orders.productTable.reorder.confirmBody': '将在 {platform} 以单价 {price} 下单 {option} {quantity} 件，无法撤销。',
  'pages.orders.productTable.reorder.confirmOk': '下单',
  'pages.orders.productTable.reorder.placed': '下单完成 — 订单号 {orderNo}',
  'pages.orders.productTable.reorder.placeFailed': '下单失败。',
  'pages.orders.productTable.reorder.unitAlert': '卖家只按 {unit} 件的倍数销售（起订 {min} 件），客户的 {customer} 件无法下单。',
  'pages.orders.productTable.reorder.unitRaise': '按卖家销售单位下单 {quantity} 件（多出的 {extra} 件由公司承担）',
  'pages.orders.productTable.reorder.previewOkRaised': '可以下单 — {quantity} 件（客户 {customer} 件，多出 {extra} 件）· 单价 {price}（原 {original}）· 追加费用 {extraCost} · 卖家运费 {shipping}',
  'pages.orders.productTable.reorder.confirmBodyRaised': '将在 {platform} 以单价 {price} 下单 {option} {quantity} 件。客户订购 {customer} 件，多出的 {extra} 件（追加费用 {extraCost}）由公司承担。无法撤销。',
  'pages.orders.productTable.marketplaceQuantity': '下单 {quantity} 件（多出 {extra} 件）',
  'pages.orders.productTable.furniture': '家具',
  'pages.orders.productTable.cotton': '棉花',
  'pages.orders.productTable.sellerA': '卖家A',
  'pages.orders.productTable.exposureO': '曝光O',
  'pages.orders.productTable.actualPaid': '实际支付',
  'pages.orders.productTable.totalActualPaid': '总实际支付',
  'pages.orders.productTable.coupon': '优惠券',
  'pages.orders.productTable.points': '积分',
  
  // Product Price Modal
  'pages.orders.productPriceModal.title': '第1次支付详情',
  'pages.orders.productPriceModal.serviceFee': '服务费',
  'pages.orders.productPriceModal.quantity': '数量',
  'pages.orders.productPriceModal.price': '价格',
  'pages.orders.productPriceModal.realPrice': '实际价格',
  'pages.orders.productPriceModal.chineseTransportation': '中国境内运费',
  'pages.orders.productPriceModal.realChineseTransportation': '实际中国境内运费',
  'pages.orders.productPriceModal.miscellaneousExpenses': '杂费',
  'pages.orders.productPriceModal.firstInternationalShippingCost': '第1次国际运费',
  'pages.orders.productPriceModal.ruralShippingCost': '岛屿山区运费',
  'pages.orders.productPriceModal.coupon': '优惠券',
  'pages.orders.productPriceModal.couponDiscount': '优惠券折扣',
  'pages.orders.productPriceModal.deliveryCoupon': '配送优惠券',
  'pages.orders.productPriceModal.deliveryCouponDiscount': '配送优惠券折扣',
  'pages.orders.productPriceModal.costSection': '费用构成',
  'pages.orders.productPriceModal.costSubtotal': '费用合计',
  'pages.orders.productPriceModal.deductionSection': '扣减',
  'pages.orders.productPriceModal.deposit': '预存款',
  'pages.orders.productPriceModal.depositUsed': '使用预存款',
  'pages.orders.productPriceModal.notApplied': '未使用',
  'pages.orders.productPriceModal.paymentMethod': '支付方式',
  'pages.orders.productPriceModal.totalDeduction': '扣减合计',
  'pages.orders.productPriceModal.bankDepositAmount': '银行转账金额',
  'pages.orders.productPriceModal.cardPaymentAmount': '银行卡支付金额',
  'pages.orders.productPriceModal.depositOnlyPayment': '预存款支付',
  'pages.orders.productPriceModal.sellerReference': '卖家参考',
  'pages.orders.productPriceModal.points': '积分',
  'pages.orders.productPriceModal.pointsUsed': '使用积分',
  'pages.orders.productPriceModal.firstCostTotal': '第1次费用总计',
  
  // International Shipping Modal
  'pages.orders.internationalShippingModal.title': '国际运费详情',
  'pages.orders.internationalShippingModal.weight': '重量',
  'pages.orders.internationalShippingModal.firstCost': '第1次费用 (总计)',
  'pages.orders.internationalShippingModal.productPrice': '商品价格',
  'pages.orders.internationalShippingModal.chineseShippingCost': '中国运费',
  'pages.orders.internationalShippingModal.coupon': '优惠券',
  'pages.orders.internationalShippingModal.points': '积分',
  'pages.orders.internationalShippingModal.internationalShippingCost': '国际运费',
  'pages.orders.internationalShippingModal.extraInternationalShippingCost': '额外国际运费',
  'pages.orders.internationalShippingModal.internationalCouponsUsed': '国际运费优惠券使用',
  'pages.orders.internationalShippingModal.internationalPointsUsed': '国际运费积分使用',
  'pages.orders.internationalShippingModal.couponsUsed': '已使用优惠券',
  'pages.orders.internationalShippingModal.pointsUsed': '已使用积分',
  
  'pages.orders.extraInternationalShippingModal.title': '额外国际运费详情（第2次费用）',
  'pages.orders.extraInternationalShippingModal.ezpassFee': 'EZ-pass费用',
  'pages.orders.extraInternationalShippingModal.additionalCost': '额外费用',
  'pages.orders.extraInternationalShippingModal.extraInternationalShippingCost': '国际运费',
  'pages.orders.extraInternationalShippingModal.ruralShippingCost': '岛屿山区运费',
  'pages.orders.extraInternationalShippingModal.addOnServices': '附加服务',
  'pages.orders.extraInternationalShippingModal.serviceName': '服务名称',
  'pages.orders.extraInternationalShippingModal.quantity': '数量',
  'pages.orders.extraInternationalShippingModal.unitPrice': '单价',
  'pages.orders.extraInternationalShippingModal.serviceTotal': '合计',
  'pages.orders.extraInternationalShippingModal.subtotal': '小计',
  'pages.orders.extraInternationalShippingModal.couponDiscount': '配送优惠券折扣',
  'pages.orders.extraInternationalShippingModal.couponsUsed': '已使用优惠券',
  'pages.orders.extraInternationalShippingModal.pointsUsed': '已使用积分',
  'pages.orders.extraInternationalShippingModal.total': '总计（第2次费用）',
  'pages.orders.extraInternationalShippingModal.cashOnDelivery': '货到付款',
  'pages.orders.productTable.paidInputCny': '实付 (CNY)',
  'pages.orders.productTable.previous': '之前',
  'pages.orders.productTable.error': '错误',
  'pages.orders.productTable.errorReasonTitle': '输入错误原因',
  'pages.orders.productTable.errorReason': '错误原因',
  'pages.orders.productTable.errorReasonPlaceholder': '请输入错误原因',
  'pages.orders.productTable.errorReasonRequired': '错误原因是必填项',
  'pages.orders.productTable.errorStatusUpdated': '错误状态更新成功',
  'pages.orders.productTable.confirmErrorStatus': '确认状态变更',
  'pages.orders.productTable.confirmErrorStatusMessage': '确定要将产品状态更改为错误吗？',
  'pages.orders.productTable.arrivalExpected': '预计到达',
  'pages.orders.productTable.warehoused': '已入库',
  'pages.orders.productTable.notWarehoused': '未入库',
  'pages.orders.productTable.processing': '处理中',
  'pages.orders.productTable.partial': '部分入库',
  'pages.orders.productTable.done': '完成',
  'pages.orders.productTable.warehouseStatusUpdated': '入库状态已更新为 {status}',
  'pages.orders.productTable.productMemo': '商品备注',
  'pages.orders.productTable.enterProductMemo': '输入商品备注',
  'pages.orders.productTable.userMemo': '用户备注',
  'pages.orders.productTable.enterUserMemo': '输入用户备注',
  'pages.orders.productTable.sellerAddress': '卖家地址',
  'pages.orders.productTable.enterSellerAddress': '输入卖家地址',
  'pages.orders.productTable.noTrackingNumber': '请输入追踪号码',
  'pages.orders.productTable.trackingNumbersSaved': '已保存 {count} 个追踪号码',
  'pages.orders.productTable.pleaseEnterAmount': '请输入金额',
  'pages.orders.productTable.shippingCostSaved': '已保存配送费用: ¥{value}',
  'pages.orders.productTable.pleaseEnterValue': '请输入值',
  'pages.orders.productTable.actualPriceSaved': '已保存实际支付金额',
  'pages.orders.productTable.actualQuantitySaved': '已保存实际数量',
  'pages.orders.productTable.invalidNumber': '无效的数字',
  'pages.orders.productTable.saveFailed': '保存失败',
  'pages.orders.productTable.productNoteSaved': '已保存商品备注',
  'pages.orders.productTable.productMemoSaved': '已保存商品备忘录',
  'pages.orders.productTable.userMemoSaved': '已保存用户备忘录',
  'pages.orders.productTable.sellerAddressSaved': '已保存卖家地址',
  'pages.orders.productTable.pleaseEnterTrackingNumber': '请输入追踪号码',
  'pages.orders.productTable.selectProductsToUpdateTracking': '请至少选择一个商品以更新追踪号码。',
  'pages.orders.productTable.trackingNumberAppliedToAll': '追踪号码 "{trackingNumber}" 已应用到所有商品',
  'pages.orders.productTable.save': '保存',
  'pages.orders.productTable.trackingNumberSaved': '追踪号码 "{trackingNumber}" 已保存',
  'pages.orders.productTable.trackingNumberRemoved': '追踪号码已移除',
  'pages.orders.productTable.noInspectionData': '没有检查数据可用。',

  // Inventory Management
  'pages.inventory.title': '库存管理',
  'pages.inventory.logistics': '物流管理',
  'pages.inventory.stockNumber': '库存号',
  'pages.inventory.inquiry': '库存咨询',
  'pages.inventory.center': '中心',
  'pages.inventory.productImage': '商品图片',
  'pages.inventory.mailbox': '信箱',
  'pages.inventory.memberName': '会员名',
  'pages.inventory.customsItem': '通关物品',
  'pages.inventory.productName': '商品名称',
  'pages.inventory.trackingNumber': '运单号',
  'pages.inventory.color': '颜色',
  'pages.inventory.size': '尺寸',
  'pages.inventory.quantity': '数量',
  'pages.inventory.unitPrice': '单价',
  'pages.inventory.totalAmount': '合计',
  'pages.inventory.rackNumber': '货架号',
  'pages.inventory.previousRackNumber': '原货架号',
  'pages.inventory.previous': '原',
  'pages.inventory.registrationDate': '注册日期',
  'pages.inventory.modificationDate': '修改日期',
  'pages.inventory.stockStatus': '库存状态',
  'pages.inventory.productStatus': '商品状态',
  'pages.inventory.mock.center.weihei': '威海',
  'pages.inventory.mock.center.qingdao': '青岛',
  'pages.inventory.mock.center.guangzhou': '广州',
  'pages.inventory.mock.memberName1': '金哲洙',
  'pages.inventory.mock.memberName2': '李英姬',
  'pages.inventory.mock.memberName3': '朴敏洙',
  'pages.inventory.mock.customsItem.doorbell': '【门铃】',
  'pages.inventory.mock.customsItem.furniture': '【家具】',
  'pages.inventory.mock.customsItem.clothing': '【服装】',
  'pages.inventory.mock.color.black': '黑色',
  'pages.inventory.mock.color.white': '白色',
  'pages.inventory.mock.color.red': '红色',
  'pages.inventory.stockStatus.available': '可用',
  'pages.inventory.stockStatus.inUse': '使用中',
  'pages.inventory.stockStatus.onHold': '保留',
  'pages.inventory.productStatus.normal': '正常',
  'pages.inventory.productStatus.problem': '问题',

  // Business Members Page
  'pages.members.business.title': '企业会员',
  'pages.members.business.memberType': '会员类型',
  'pages.members.business.memberTypeTag': '企业',
  'pages.members.business.businessNumber': '企业编号',
  'pages.members.business.representative': '代表',
  'pages.members.business.businessType': '业务类型',
  'pages.members.business.businessTypeWholesale': '批发',
  'pages.members.business.businessTypeRetail': '零售',
  'pages.members.business.businessTypeImport': '进口',
  'pages.members.business.businessTypeExport': '出口',
  'pages.members.business.totalBusiness': '全部企业会员',
  'pages.members.business.memberTypeLabel': '企业会员',
  'pages.members.business.companyName': '公司名称',
  'pages.members.business.monthlyAverage': '月平均订单',
  'pages.members.business.mock.memberType': '企业',
  'pages.members.business.memberCode': '会员代码',
  'pages.members.business.memberName': '会员姓名',
  'pages.members.business.userId': 'ID',
  'pages.members.business.mailboxNumber': '邮箱号码',
  'pages.members.business.mobilePhone': '手机号码',
  'pages.members.business.deposit': '押金(￦)',
  'pages.members.business.businessRegistration': '营业执照',
  'pages.members.business.applicationApproval': '申请批准',
  'pages.members.business.referralCode': '推荐人代码',
  'pages.members.business.email': '电子邮件',
  'pages.members.business.referralPointsAccumulation': '推荐积分累积',
  'pages.members.business.managerName': '负责人姓名',
  'pages.members.business.applicationCount': '申请数量',
  'pages.members.business.adminAssignmentDate': '管理员指定日期',
  'pages.members.business.lastLogin': '最后登录',
  'pages.members.business.joinDate': '加入日期',
  'pages.members.business.actions': '操作',

  'pages.members.list.memberNameSearchPlaceholder': '按会员名搜索',
  'pages.members.list.male': '男性',
  'pages.members.list.female': '女性',
  'pages.members.list.other': '其他',
  'pages.members.list.emailVerification': '电子邮件验证',
  'pages.members.list.emailVerified': '已验证',
  'pages.members.list.emailUnverified': '未验证',
  'pages.members.list.loadMemberDetailsError': '加载会员详细信息失败',
  'pages.members.list.loadMemberListError': '加载会员列表失败',
  'pages.members.list.birthday': '生日',
  'pages.members.list.gender': '性别',
  'pages.members.list.genderMale': '男性',
  'pages.members.list.genderFemale': '女性',
  'pages.members.list.genderOther': '其他',
  'pages.members.list.deposit': '押金',
  'pages.members.list.address': '地址',
  'pages.members.list.defaultAddress': '默认',
  'pages.members.list.zipCode': '邮政编码',
  'pages.members.list.contact': '联系方式',

  // Blacklist Members Page
  'pages.members.blacklist.title': '黑名单会员管理',
  'pages.members.blacklist.totalBlacklist': '全部黑名单',
  'pages.members.blacklist.generalMembers': '普通会员',
  'pages.members.blacklist.businessMembers': '企业会员',
  'pages.members.blacklist.addedThisMonth': '本月新增',
  'pages.members.blacklist.unblacklistConfirm': '从黑名单中移除？',
  'pages.members.blacklist.unblacklistSuccess': '已从黑名单中移除',
  'pages.members.blacklist.unblacklistError': '从黑名单移除失败',
  'pages.members.blacklist.unblacklist': '移除',
  'pages.members.blacklist.bulkUnblacklistConfirm': '将选中的{count}名会员从黑名单中移除？',
  'pages.members.blacklist.bulkUnblacklistSuccess': '{count}名会员已从黑名单中移除',
  'pages.members.blacklist.bulkUnblacklist': '批量移除',
  'pages.members.blacklist.unblacklistButton': '从黑名单移除',
  'pages.members.blacklist.loadError': '加载黑名单会员失败',
  'pages.members.blacklist.memberType': '会员类型',
  'pages.members.blacklist.general': '普通',
  'pages.members.blacklist.business': '企业',
  'pages.members.blacklist.blacklisted': '黑名单',
  'pages.members.blacklist.birthday': '生日',
  'pages.members.blacklist.gender': '性别',
  'pages.members.blacklist.genderMale': '男',
  'pages.members.blacklist.genderFemale': '女',
  'pages.members.blacklist.genderOther': '其他',
  'pages.members.blacklist.points': '积分',
  'pages.members.blacklist.deposit': '押金余额',
  'pages.members.blacklist.address': '地址',
  'pages.members.blacklist.zipCode': '邮政编码',
  'pages.members.blacklist.contact': '联系方式',
  'pages.members.blacklist.default': '默认',
  'pages.members.blacklist.levelChanged': '会员等级已更改',
  'pages.members.blacklist.levelChangeError': '更改会员等级失败',
  'pages.members.blacklist.emailVerification': '邮箱验证',
  'pages.members.blacklist.emailVerified': '已验证',
  'pages.members.blacklist.emailUnverified': '未验证',
  'pages.members.blacklist.searchPlaceholder': '按会员名称搜索',

  // Deposit Management Pages
  'pages.members.depositApplication.description': '押金申请详情管理',
  'pages.members.depositApplication.subDescription': '查看和管理会员押金申请详情',
  'pages.members.depositUsage.description': '押金使用详情管理',
  'pages.members.depositUsage.subDescription': '查看和管理会员押金使用详情',
  'pages.members.bankbookVerification.description': '银行账户自动验证管理',
  'pages.members.bankbookVerification.subDescription': '配置和管理会员银行账户自动验证',
  'pages.members.forexDepositApplication.description': '外汇押金申请详情管理',
  'pages.members.forexDepositApplication.subDescription': '查看和管理会员外汇押金申请详情',
  'pages.members.forexDepositUsage.description': '外汇押金使用详情管理',
  'pages.members.forexDepositUsage.subDescription': '查看和管理会员外汇押金使用详情',
  'pages.members.forexDepositPayment.description': '外汇押金支付详情管理',
  'pages.members.forexDepositPayment.subDescription': '查看和管理会员外汇押金支付详情',

  // Deposit Application Detailed
  'pages.members.depositApplication.memberName': '会员名',
  'pages.members.depositApplication.applicationType': '申请类型',
  'pages.members.depositApplication.typeDeposit': '存款',
  'pages.members.depositApplication.typeRefund': '退款',
  'pages.members.depositApplication.depositAmount': '存款金额',
  'pages.members.depositApplication.refundAmount': '退款金额',
  'pages.members.depositApplication.amount': '申请金额',
  'pages.members.depositApplication.bankInfo': '银行信息',
  'pages.members.depositApplication.depositor': '存款人（账户持有人）',
  'pages.members.depositApplication.status': '状态',
  'pages.members.depositApplication.statusPending': '待处理',
  'pages.members.depositApplication.statusApproved': '已批准',
  'pages.members.depositApplication.statusRejected': '已拒绝',
  'pages.members.depositApplication.applicationDate': '申请日期',
  'pages.members.depositApplication.expectedDepositDate': '预计存款日期',
  'pages.members.depositApplication.actions': '操作',
  'pages.members.depositApplication.approve': '批准',
  'pages.members.depositApplication.complete': '完成',
  'pages.members.depositApplication.reject': '拒绝',
  'pages.members.depositApplication.cancellation': '取消',
  'pages.members.depositApplication.viewDetails': '查看详情',
  'pages.members.depositApplication.approveConfirm': '批准押金申请',
  'pages.members.depositApplication.approveContent': '您要批准{name}的{amount}元押金申请吗？',
  'pages.members.depositApplication.approved': '押金申请已批准',
  'pages.members.depositApplication.rejectConfirm': '拒绝押金申请',
  'pages.members.depositApplication.rejectContent': '您要拒绝{name}的押金申请吗？',
  'pages.members.depositApplication.rejected': '押金申请已拒绝',
  'pages.members.depositApplication.totalApplications': '总申请数',
  'pages.members.depositApplication.pendingApplications': '待处理',
  'pages.members.depositApplication.approvedApplications': '已批准',
  'pages.members.depositApplication.totalAmount': '总金额',
  'pages.members.depositApplication.reasonRecharge': '押金充值',
  'pages.members.depositApplication.mock.companyName': '贸易公司（股份）',
  'pages.members.depositApplication.mock.personName': '张三',
  'pages.members.depositApplication.mock.bank.kb': 'KB国民银行',
  'pages.members.depositApplication.mock.bank.shinhan': '新韩银行',
  'pages.members.depositApplication.mock.bank.hana': '韩亚银行',
  'pages.members.depositApplication.mock.bank.woori': '友利银行',
  'pages.members.depositApplication.mock.accountHolder': '李代表',
  'pages.members.depositApplication.mock.admin': '管理员1',
  'pages.members.depositApplication.mock.memo': '优质客户',
  'pages.members.forexDepositPayment.mock.adminMemo': '这是管理员备忘录内容',

  // Recharge Review
  'pages.members.rechargeReview.title': '充值审核',
  'pages.members.rechargeReview.filter.group.title': '状态筛选',
  'pages.members.rechargeReview.filter.pendingReview': '待审核',
  'pages.members.rechargeReview.filter.approvalSuccessful': '审核成功',
  'pages.members.rechargeReview.filter.reviewFailed': '审核失败',
  'pages.members.rechargeReview.column.userId': '用户ID',
  'pages.members.rechargeReview.column.user': '用户',
  'pages.members.rechargeReview.column.remittanceMethod': '汇款方式',
  'pages.members.rechargeReview.column.remitterName': '汇款人姓名',
  'pages.members.rechargeReview.column.rechargeCurrencyAndAmount': '充值货币和金额',
  'pages.members.rechargeReview.column.receivedCurrencyAndAmount': '收到货币和金额',
  'pages.members.rechargeReview.column.serviceFee': '服务费',
  'pages.members.rechargeReview.column.receivingBankInformation': '收款银行信息',
  'pages.members.rechargeReview.column.addTime': '添加时间',
  'pages.members.rechargeReview.column.operate': '操作',
  'pages.members.rechargeReview.memberName': '会员名称',
  'pages.members.rechargeReview.memberId': '会员ID',
  'pages.members.rechargeReview.amount': '金额',
  'pages.members.rechargeReview.paymentMethod': '支付方式',
  'pages.members.rechargeReview.status': '状态',
  'pages.members.rechargeReview.status.pending': '待处理',
  'pages.members.rechargeReview.status.approved': '已批准',
  'pages.members.rechargeReview.status.rejected': '已拒绝',
  'pages.members.rechargeReview.applicationDate': '申请日期',
  'pages.members.rechargeReview.approvalDate': '批准日期',
  'pages.members.rechargeReview.transactionId': '交易ID',
  'pages.members.rechargeReview.admin': '管理员',
  'pages.members.rechargeReview.approve': '批准',
  'pages.members.rechargeReview.reject': '拒绝',
  'pages.members.rechargeReview.approveConfirm': '批准充值申请',
  'pages.members.rechargeReview.approveContent': '确定要批准 {name} 的 {amount}元 充值申请吗？',
  'pages.members.rechargeReview.approved': '充值申请已批准',
  'pages.members.rechargeReview.rejectConfirm': '拒绝充值申请',
  'pages.members.rechargeReview.rejectContent': '确定要拒绝 {name} 的充值申请吗？',
  'pages.members.rechargeReview.rejected': '充值申请已拒绝',
  'pages.members.rechargeReview.statistics.total': '总申请数',
  'pages.members.rechargeReview.statistics.pending': '待处理',
  'pages.members.rechargeReview.statistics.approved': '已批准',
  'pages.members.rechargeReview.statistics.totalAmount': '总金额',
  'pages.members.rechargeReview.exportSuccess': '数据导出成功',
  'pages.members.rechargeReview.remittanceCurrency': '汇款货币',
  'pages.members.rechargeReview.remittanceCurrencyAndAmount': '汇款货币和金额',
  'pages.members.rechargeReview.receivingBankName': '收款银行名称',
  'pages.members.rechargeReview.receivingAccountNumber': '收款账户号码',
  'pages.members.rechargeReview.receivingAccountHolder': '收款账户持有人',

  // Withdraw Review
  'pages.members.withdrawReview.title': '提现审核',
  'pages.members.withdrawReview.filter.group.title': '状态筛选',
  'pages.members.withdrawReview.filter.pendingReview': '待审核',
  'pages.members.withdrawReview.filter.approvalSuccessful': '审核成功',
  'pages.members.withdrawReview.filter.reviewFailed': '审核失败',
  'pages.members.withdrawReview.column.id': 'ID',
  'pages.members.withdrawReview.column.userId': '用户ID',
  'pages.members.withdrawReview.column.user': '用户',
  'pages.members.withdrawReview.column.handlingFee': '手续费',
  'pages.members.withdrawReview.column.withdrawalAmount': '提现金额',
  'pages.members.withdrawReview.column.amountReceived': '收到金额',
  'pages.members.withdrawReview.column.bankCardName': '银行卡名称',
  'pages.members.withdrawReview.column.bankCardNumber': '银行卡号码',
  'pages.members.withdrawReview.column.bankCardHolder': '银行卡持有人',
  'pages.members.withdrawReview.column.withdrawalTime': '提现时间',
  'pages.members.withdrawReview.column.operate': '操作',
  'pages.members.withdrawReview.memberName': '会员名称',
  'pages.members.withdrawReview.memberId': '会员ID',
  'pages.members.withdrawReview.amount': '金额',
  'pages.members.withdrawReview.status': '状态',
  'pages.members.withdrawReview.status.pending': '待处理',
  'pages.members.withdrawReview.status.approved': '已批准',
  'pages.members.withdrawReview.status.rejected': '已拒绝',
  'pages.members.withdrawReview.bankName': '银行名称',
  'pages.members.withdrawReview.accountNumber': '账户号码',
  'pages.members.withdrawReview.accountHolder': '账户持有人',
  'pages.members.withdrawReview.applicationDate': '申请日期',
  'pages.members.withdrawReview.approvalDate': '批准日期',
  'pages.members.withdrawReview.admin': '管理员',
  'pages.members.withdrawReview.approve': '批准',
  'pages.members.withdrawReview.reject': '拒绝',
  'pages.members.withdrawReview.approveConfirm': '批准提现申请',
  'pages.members.withdrawReview.approveContent': '确定要批准 {name} 的 {amount}元 提现申请吗？',
  'pages.members.withdrawReview.approved': '提现申请已批准',
  'pages.members.withdrawReview.rejectConfirm': '拒绝提现申请',
  'pages.members.withdrawReview.rejectContent': '确定要拒绝 {name} 的提现申请吗？',
  'pages.members.withdrawReview.rejected': '提现申请已拒绝',
  'pages.members.withdrawReview.statistics.total': '总申请数',
  'pages.members.withdrawReview.statistics.pending': '待处理',
  'pages.members.withdrawReview.statistics.approved': '已批准',
  'pages.members.withdrawReview.statistics.totalAmount': '总金额',
  'pages.members.withdrawReview.exportSuccess': '数据导出成功',

  // Financial Record
  'pages.members.financialRecord.title': '财务记录',
  'pages.members.financialRecord.filter.group.title': '记录筛选',
  'pages.members.financialRecord.filter.financialRecords': '财务记录',
  'pages.members.financialRecord.filter.consumptionRecords': '消费记录',
  'pages.members.financialRecord.filter.refundRecords': '退款记录',
  'pages.members.financialRecord.filter.rebateRecords': '返利记录',
  'pages.members.financialRecord.filter.pointsRecord': '积分记录',
  'pages.members.financialRecord.filter.couponUsageHistory': '优惠券使用历史',
  'pages.members.financialRecord.filter.taxSettlement': '税务结算管理',
  'pages.members.financialRecord.tab.financial': '财务记录',
  'pages.members.financialRecord.tab.consumption': '消费记录',
  'pages.members.financialRecord.tab.refundRecords': '退款记录',
  'pages.members.financialRecord.tab.rebate': '返利记录',
  'pages.members.financialRecord.tab.points': '积分记录',
  'pages.members.financialRecord.tab.coupon': '优惠券使用历史',
  'pages.members.financialRecord.tab.tax': '税务结算管理',
  /** 财务记录各标签页共用 — 与结算等页筛选文案一致 */
  'pages.members.financialRecord.tabsFilter.startTime': '开始时间',
  'pages.members.financialRecord.tabsFilter.endTime': '结束时间',
  'pages.members.financialRecord.tabsFilter.paymentDateStart': '付款日期起',
  'pages.members.financialRecord.tabsFilter.paymentDateEnd': '付款日期止',
  // Financial Records Columns
  'pages.members.financialRecord.financial.column.orderNumber': '订单号',
  'pages.members.financialRecord.financial.column.purchaseOrderNumber': '采购订单号',
  'pages.members.financialRecord.financial.column.userIdUserName': '用户ID/用户名',
  'pages.members.financialRecord.financial.column.productUnitPrice': '商品单价',
  'pages.members.financialRecord.financial.column.productTotalPrice': '商品总价',
  'pages.members.financialRecord.financial.column.handlingFee': '手续费 (1%)',
  'pages.members.financialRecord.financial.column.designatedShootingFee': '指定拍摄费用',
  'pages.members.financialRecord.financial.column.firstInternationalShippingFee': '第一次国际运费',
  'pages.members.financialRecord.financial.column.secondInternationalShippingFee': '第二次国际运费',
  'pages.members.financialRecord.financial.column.paymentMethod': '支付方式',
  'pages.members.financialRecord.financial.column.transactionNumber': '交易流水号',
  'pages.members.financialRecord.financial.column.secondPaymentMethod': '第二次支付方式',
  'pages.members.financialRecord.financial.column.secondPaymentTransactionNumber': '第二次支付流水号',
  'pages.members.financialRecord.financial.column.orderPointsUsed': '订单使用积分',
  'pages.members.financialRecord.financial.column.deliveryPointsUsed': '配送使用积分',
  'pages.members.financialRecord.financial.column.orderCouponsUsed': '订单使用优惠券',
  'pages.members.financialRecord.financial.column.deliveryCouponsUsed': '配送使用优惠券',
  'pages.members.financialRecord.financial.column.paymentType': '支付类型',
  'pages.members.financialRecord.financial.column.amountBeforeChange': '变更前金额',
  'pages.members.financialRecord.financial.column.changeAmount': '变更金额',
  'pages.members.financialRecord.financial.column.amountAfterChange': '变更后金额',
  'pages.members.financialRecord.financial.column.paidTime': '已付款时间',
  'pages.members.financialRecord.financial.column.financialSettlementTime': '财务结算时间',
  'pages.members.financialRecord.financial.column.operatingTime': '操作时间',
  'pages.members.financialRecord.financial.column.remarks': '备注',
  // Consumption Records Columns
  'pages.members.financialRecord.consumption.column.orderNumber': '订单号',
  'pages.members.financialRecord.consumption.column.purchaseOrderNumber': '采购订单号',
  'pages.members.financialRecord.consumption.column.userId': '用户ID',
  'pages.members.financialRecord.consumption.column.recipientName': '收件人姓名',
  'pages.members.financialRecord.consumption.column.productUnitPrice': '商品单价',
  'pages.members.financialRecord.consumption.column.productTotalPrice': '商品总价',
  'pages.members.financialRecord.consumption.column.handlingFee': '手续费 (1%)',
  'pages.members.financialRecord.consumption.column.designatedShootingFee': '指定拍摄费用',
  'pages.members.financialRecord.consumption.column.firstInternationalShippingFee': '第一次国际运费',
  'pages.members.financialRecord.consumption.column.secondInternationalShippingFee': '第二次国际运费',
  'pages.members.financialRecord.consumption.column.paymentMethod': '支付方式',
  'pages.members.financialRecord.consumption.column.transactionNumber': '交易流水号',
  'pages.members.financialRecord.consumption.column.secondPaymentMethod': '第二次支付方式',
  'pages.members.financialRecord.consumption.column.secondPaymentTransactionNumber': '第二次支付流水号',
  'pages.members.financialRecord.consumption.column.orderPointsUsed': '订单使用积分',
  'pages.members.financialRecord.consumption.column.deliveryPointsUsed': '配送使用积分',
  'pages.members.financialRecord.consumption.column.orderCouponsUsed': '订单使用优惠券',
  'pages.members.financialRecord.consumption.column.deliveryCouponsUsed': '配送使用优惠券',
  'pages.members.financialRecord.consumption.column.userAction': '用户操作',
  'pages.members.financialRecord.consumption.column.paymentType': '支付类型',
  'pages.members.financialRecord.consumption.column.amountBeforeChange': '变更前金额',
  'pages.members.financialRecord.consumption.column.changeAmount': '变动金额',
  'pages.members.financialRecord.consumption.column.amountAfterChange': '变更后金额',
  'pages.members.financialRecord.consumption.column.paidTime': '已付款时间',
  'pages.members.financialRecord.consumption.column.financialSettlementTime': '财务结算时间',
  'pages.members.financialRecord.consumption.column.addTime': '添加时间',
  'pages.members.financialRecord.consumption.column.changedTime': '变更时间',
  // Rebate Records Columns
  'pages.members.financialRecord.rebate.column.userInfo': '用户信息',
  'pages.members.financialRecord.rebate.column.memberName': '会员名',
  'pages.members.financialRecord.rebate.column.mailbox': '会员邮箱号',
  'pages.members.financialRecord.rebate.column.orderNumber': '订单号',
  'pages.members.financialRecord.rebate.column.shippingRebate': '运费返利',
  'pages.members.financialRecord.rebate.column.serviceFeeRebate': '服务费返利',
  'pages.members.financialRecord.rebate.column.totalRebateAmount': '返利额',
  'pages.members.financialRecord.rebate.column.amountBeforeChange': '变动前金额',
  'pages.members.financialRecord.rebate.column.amountAfterChange': '变动后金额',
  'pages.members.financialRecord.rebate.column.operatingTime': '操作时间',
  'pages.members.financialRecord.rebate.column.sellerName': '卖家名',
  'pages.members.financialRecord.rebate.column.sellerMailbox': '卖家邮箱号',
  'pages.members.financialRecord.rebate.column.productNo': '商品编号',
  'pages.members.financialRecord.rebate.column.productName': '商品名',
  'pages.members.financialRecord.rebate.column.supplierName': '供应商名称',
  'pages.members.financialRecord.rebate.column.quantity': '数量',
  'pages.members.financialRecord.rebate.column.buyerMailbox': '会员邮箱',
  'pages.members.financialRecord.rebate.column.recipient': '收件人',
  'pages.members.financialRecord.rebate.column.paymentAmount': '支付金额',
  'pages.members.financialRecord.rebate.column.productCost': '商品原价',
  'pages.members.financialRecord.rebate.column.intlShipping': '国际运费',
  'pages.members.financialRecord.rebate.column.rebate': '返利',
  'pages.members.financialRecord.rebate.column.intlTrackingNo': '国际运单号',
  'pages.members.financialRecord.rebate.column.orderCreatedAt': '订单创建时间',
  'pages.members.financialRecord.rebate.column.downlineSellerUserId': '下级卖家',
  'pages.members.financialRecord.rebate.filter.sellerMailbox': '卖家邮箱号',
  'pages.members.financialRecord.rebate.filter.dateRangeFrom': '查询开始时间',
  'pages.members.financialRecord.rebate.filter.dateRangeTo': '查询结束时间',
  // Coupon Usage History Columns
  'pages.members.financialRecord.coupon.column.id': 'No',
  'pages.members.financialRecord.coupon.column.userNameId': '用户名(ID)',
  'pages.members.financialRecord.coupon.column.orderNumber': '订单号',
  'pages.members.financialRecord.coupon.column.couponName': '优惠券名称',
  'pages.members.financialRecord.coupon.column.couponCode': '优惠券码',
  'pages.members.financialRecord.coupon.column.couponAmount': '优惠券面额',
  'pages.members.financialRecord.coupon.column.minimalUsageAmount': '最低使用金额',
  'pages.members.financialRecord.coupon.column.receiptMethod': '领取方式',
  'pages.members.financialRecord.coupon.column.availablePeriod': '有效期',
  'pages.members.financialRecord.coupon.column.status': '状态',
  'pages.members.financialRecord.coupon.column.receiveTime': '领取时间',
  'pages.members.financialRecord.coupon.status.used': '已使用',
  'pages.members.financialRecord.coupon.status.available': '可用',
  'pages.members.financialRecord.coupon.status.expired': '已过期',
  'pages.members.financialRecord.coupon.status.unused': '未使用',

  // Deposit (formerly Advanced Deposit)
  'pages.members.deposit.title': '存款管理',
  'pages.members.deposit.column.paymentMethods': '支付方式',
  'pages.members.deposit.column.userId': '用户ID',
  'pages.members.deposit.column.tr': 'TR',
  'pages.members.deposit.column.orderCreationTime': '订单创建时间',
  'pages.members.deposit.column.payerName': '付款人姓名',
  'pages.members.deposit.column.paymentAmountKRW': '支付金额(韩元)',
  'pages.members.deposit.column.amountUsedKRW': '已使用金额(韩元)',
  'pages.members.deposit.column.remainingAmountKRW': '存款余额(韩元)',

  // Membership Level Management
  'pages.members.membershipLevel.title': '会员等级',
  'pages.members.membershipLevel.column.level': '等级',
  'pages.members.membershipLevel.column.availablePointsRange': '可用积分范围',
  'pages.members.membershipLevel.column.pointsAcquisitionRatio': '积分获得比例',
  'pages.members.membershipLevel.column.pointsDiscountRatio': '积分折扣比例',
  'pages.members.membershipLevel.column.orderAmountDiscountRatio': '订单金额折扣比例',
  'pages.members.membershipLevel.column.freeStorageDays': '免费仓库保管天数',
  'pages.members.membershipLevel.column.status': '状态',
  'pages.members.membershipLevel.column.ruleSettingTime': '规则设置时间',
  'pages.members.membershipLevel.status.active': '激活',
  'pages.members.membershipLevel.status.inactive': '未激活',
  'pages.members.membershipLevel.column.id': 'ID',
  'pages.members.membershipLevel.column.grade': '等级',
  'pages.members.membershipLevel.column.integral': '积分',
  'pages.members.membershipLevel.column.maxPointsUsable': '可使用最大积分',
  'pages.members.membershipLevel.column.minPointsAvailable': '可用最小积分',
  'pages.members.membershipLevel.column.discountOnTotalOrderAmount': '总订单金额折扣',
  'pages.members.membershipLevel.column.freeStorageValidityPeriod': '免费仓储有效期(天)',
  'pages.members.membershipLevel.column.remark': '备注',
  'pages.members.membershipLevel.column.addTime': '添加时间',
  'pages.members.membershipLevel.disable': '停用',
  'pages.members.membershipLevel.enable': '启用',
  'pages.members.membershipLevel.disableConfirm': '确定要停用此规则吗？',
  'pages.members.membershipLevel.disableSuccess': '规则已停用',
  'pages.members.membershipLevel.disableError': '停用失败',
  'pages.members.membershipLevel.enableSuccess': '规则已启用',
  'pages.members.membershipLevel.enableError': '启用失败',
  'pages.members.membershipLevel.deleteConfirmDesc': '此操作无法撤销。',
  'pages.members.membershipLevel.deleteTitle': '删除等级',
  'pages.members.membershipLevel.deleteConfirm': '确定要删除 {name} 等级吗？',
  'pages.members.membershipLevel.deleteSuccess': '等级已删除',
  'pages.members.membershipLevel.updateSuccess': '等级已更新',
  'pages.members.membershipLevel.createSuccess': '等级已创建',
  'pages.members.membershipLevel.modal.addTitle': '添加等级',
  'pages.members.membershipLevel.modal.editTitle': '编辑等级',
  'pages.members.membershipLevel.form.level': '等级',
  'pages.members.membershipLevel.form.levelPlaceholder': '请输入等级',
  'pages.members.membershipLevel.form.grade': '等级',
  'pages.members.membershipLevel.form.gradePlaceholder': '请输入等级',
  'pages.members.membershipLevel.form.integral': '积分',
  'pages.members.membershipLevel.form.integralPlaceholder': '请输入积分',
  'pages.members.membershipLevel.form.orderAmountDiscountRatio': '订单金额折扣比例',
  'pages.members.membershipLevel.form.orderAmountDiscountRatioPlaceholder': '请输入订单金额折扣比例',
  'pages.members.membershipLevel.form.freeStorageDays': '免费仓库保管天数',
  'pages.members.membershipLevel.form.freeStorageDaysPlaceholder': '请输入免费仓库保管天数',
  'pages.members.membershipLevel.form.maxPointsUsable': '可使用最大积分',
  'pages.members.membershipLevel.form.maxPointsUsablePlaceholder': '请输入可使用最大积分',
  'pages.members.membershipLevel.form.minPointsAvailable': '可用最小积分',
  'pages.members.membershipLevel.form.minPointsAvailablePlaceholder': '请输入可用最小积分',
  'pages.members.membershipLevel.form.pointsAcquisitionRatio': '积分获得比例',
  'pages.members.membershipLevel.form.pointsAcquisitionRatioPlaceholder': '请输入积分获得比例',
  'pages.members.membershipLevel.form.pointsDiscountRatio': '积分折扣比例',
  'pages.members.membershipLevel.form.pointsDiscountRatioPlaceholder': '请输入积分折扣比例 (%)',
  'pages.members.membershipLevel.form.discountOnTotalOrderAmount': '总订单金额折扣',
  'pages.members.membershipLevel.form.discountOnTotalOrderAmountPlaceholder': '请输入总订单金额折扣 (%)',
  'pages.members.membershipLevel.form.freeStorageValidityPeriod': '免费仓储有效期',
  'pages.members.membershipLevel.form.freeStorageValidityPeriodPlaceholder': '请输入免费仓储有效期',
  'pages.members.membershipLevel.form.days': '天',
  'pages.members.membershipLevel.form.remark': '备注',
  'pages.members.membershipLevel.form.remarkPlaceholder': '请输入备注',

  // Rebate Level
  'pages.members.rebateLevel.title': '返利等级',
  'pages.members.rebateLevel.column.grade': '等级',
  'pages.members.rebateLevel.column.rebatePercentage': '一般返利率',
  'pages.members.rebateLevel.column.labangRebatePercentage': '拉帮返利率',
  'pages.members.rebateLevel.column.addTime': '添加时间',
  'pages.members.rebateLevel.column.levelName': '等级名称',
  'pages.members.rebateLevel.column.levelCode': '等级代码',
  'pages.members.rebateLevel.column.rebateRate': '返利率',
  'pages.members.rebateLevel.column.minPurchaseAmount': '最低购买金额',
  'pages.members.rebateLevel.column.maxPurchaseAmount': '最高购买金额',
  'pages.members.rebateLevel.column.description': '描述',
  'pages.members.rebateLevel.column.isActive': '激活',
  'pages.members.rebateLevel.deleteTitle': '删除返利等级',
  'pages.members.rebateLevel.deleteConfirm': '确定要删除 {name} 返利等级吗？',
  'pages.members.rebateLevel.deleteSuccess': '返利等级已删除',
  'pages.members.rebateLevel.updateSuccess': '返利等级已更新',
  'pages.members.rebateLevel.createSuccess': '返利等级已创建',
  'pages.members.rebateLevel.modal.addTitle': '添加返利等级',
  'pages.members.rebateLevel.modal.editTitle': '编辑返利等级',
  'pages.members.rebateLevel.form.grade': '等级',
  'pages.members.rebateLevel.form.gradePlaceholder': '请输入等级',
  'pages.members.rebateLevel.form.gradeRequired': '请输入等级',
  'pages.members.rebateLevel.form.rebatePercentage': '返利率',
  'pages.members.rebateLevel.form.rebatePercentagePlaceholder': '请输入返利率 (%)',
  'pages.members.rebateLevel.form.rebatePercentageRequired': '请输入返利率',
  'pages.members.rebateLevel.form.levelName': '等级名称',
  'pages.members.rebateLevel.form.levelNamePlaceholder': '请输入等级名称',
  'pages.members.rebateLevel.form.levelCode': '等级代码',
  'pages.members.rebateLevel.form.levelCodePlaceholder': '请输入等级代码',
  'pages.members.rebateLevel.form.rebateRate': '返利率',
  'pages.members.rebateLevel.form.rebateRatePlaceholder': '请输入返利率 (%)',
  'pages.members.rebateLevel.form.minPurchaseAmount': '最低购买金额',
  'pages.members.rebateLevel.form.minPurchaseAmountPlaceholder': '请输入最低购买金额',
  'pages.members.rebateLevel.form.maxPurchaseAmount': '最高购买金额',
  'pages.members.rebateLevel.form.maxPurchaseAmountPlaceholder': '请输入最高购买金额（可选）',
  'pages.members.rebateLevel.form.description': '描述',
  'pages.members.rebateLevel.form.descriptionPlaceholder': '请输入描述',
  'pages.members.rebateLevel.form.isActive': '激活',

  // Todaymall Rebate Level
  'pages.products.rebateLevel.title': '返利等级',
  'pages.products.rebateLevel.addButton': '添加返利等级',
  'pages.products.rebateLevel.column.layer': '层级',
  'pages.products.rebateLevel.column.type': '类型',
  'pages.products.rebateLevel.column.rebatePercentage': '返利百分比 (%)',
  'pages.products.rebateLevel.column.createdAt': '创建时间',
  'pages.products.rebateLevel.column.actions': '操作',
  'pages.products.rebateLevel.type.regular': '普通',
  'pages.products.rebateLevel.type.labang': '拉帮',
  'pages.products.rebateLevel.action.edit': '编辑',
  'pages.products.rebateLevel.action.delete': '删除',
  'pages.products.rebateLevel.deleteConfirm': '确定要删除此返利等级吗？',
  'pages.products.rebateLevel.deleteConfirmYes': '是',
  'pages.products.rebateLevel.deleteConfirmNo': '否',
  'pages.products.rebateLevel.deleteSuccess': '返利等级删除成功',
  'pages.products.rebateLevel.deleteFailed': '删除返利等级失败',
  'pages.products.rebateLevel.updateSuccess': '返利等级更新成功',
  'pages.products.rebateLevel.createSuccess': '返利等级创建成功',
  'pages.products.rebateLevel.saveFailed': '保存返利等级失败',
  'pages.products.rebateLevel.modal.addTitle': '添加返利等级',
  'pages.products.rebateLevel.modal.editTitle': '编辑返利等级',
  'pages.products.rebateLevel.form.layer': '层级',
  'pages.products.rebateLevel.form.layerPlaceholder': '选择层级',
  'pages.products.rebateLevel.form.layerRequired': '请选择层级',
  'pages.products.rebateLevel.form.layer1': '层级 1',
  'pages.products.rebateLevel.form.layer2': '层级 2',
  'pages.products.rebateLevel.form.layer3': '层级 3',
  'pages.products.rebateLevel.form.layer4': '层级 4',
  'pages.products.rebateLevel.form.layer5': '层级 5',
  'pages.products.rebateLevel.form.lecturer': '讲师',
  'pages.products.rebateLevel.form.type': '类型',
  'pages.products.rebateLevel.form.typeRequired': '请选择类型',
  'pages.products.rebateLevel.form.rebatePercentage': '返利百分比 (%)',
  'pages.products.rebateLevel.form.rebatePercentagePlaceholder': '例如：70',
  'pages.products.rebateLevel.form.rebatePercentageRequired': '请输入百分比',
  'pages.products.rebateLevel.form.rebatePercentageRange': '必须在0到100之间',
  'pages.products.rebateLevel.form.example': '示例：',
  'pages.products.rebateLevel.form.exampleText': '层级 {layer} {type} 会员将获得 {percentage}% 返利。',

  // Todaymall Rebate Rules
  'pages.products.rebateRules.title': '返利规则',
  'pages.products.rebateRules.addButton': '添加返利规则',
  'pages.products.rebateRules.column.lowerLimit': '下限 (₩)',
  'pages.products.rebateRules.column.upperLimit': '上限 (₩)',
  'pages.products.rebateRules.column.percentage': '返利百分比 (%)',
  'pages.products.rebateRules.column.createdAt': '创建时间',
  'pages.products.rebateRules.column.actions': '操作',
  'pages.products.rebateRules.action.edit': '编辑',
  'pages.products.rebateRules.action.delete': '删除',
  'pages.products.rebateRules.deleteConfirm': '确定要删除此返利规则吗？',
  'pages.products.rebateRules.deleteConfirmYes': '是',
  'pages.products.rebateRules.deleteConfirmNo': '否',
  'pages.products.rebateRules.deleteSuccess': '返利规则删除成功',
  'pages.products.rebateRules.deleteFailed': '删除返利规则失败',
  'pages.products.rebateRules.updateSuccess': '返利规则更新成功',
  'pages.products.rebateRules.createSuccess': '返利规则创建成功',
  'pages.products.rebateRules.saveFailed': '保存返利规则失败',
  'pages.products.rebateRules.modal.addTitle': '添加返利规则',
  'pages.products.rebateRules.modal.editTitle': '编辑返利规则',
  'pages.products.rebateRules.form.lowerLimit': '下限 (₩)',
  'pages.products.rebateRules.form.lowerLimitPlaceholder': '例如：0',
  'pages.products.rebateRules.form.lowerLimitRequired': '请输入下限',
  'pages.products.rebateRules.form.lowerLimitMin': '必须大于等于0',
  'pages.products.rebateRules.form.upperLimit': '上限 (₩)',
  'pages.products.rebateRules.form.upperLimitPlaceholder': '例如：100000',
  'pages.products.rebateRules.form.upperLimitRequired': '请输入上限',
  'pages.products.rebateRules.form.upperLimitMin': '必须大于0',
  'pages.products.rebateRules.form.upperLimitGreater': '上限必须大于下限',
  'pages.products.rebateRules.form.percentage': '返利百分比 (%)',
  'pages.products.rebateRules.form.percentagePlaceholder': '例如：5',
  'pages.products.rebateRules.form.percentageRequired': '请输入百分比',
  'pages.products.rebateRules.form.percentageRange': '必须在0到100之间',
  'pages.products.rebateRules.form.example': '示例：',
  'pages.products.rebateRules.form.exampleText': '购买金额在 ₩{lower} 到 ₩{upper} 之间，客户将获得 {percentage}% 返利。',

  // Rebate Rules
  'pages.members.rebateRules.title': '返利规则',
  'pages.members.rebateRules.column.lowerLimit': '价格差范围下限',
  'pages.members.rebateRules.column.upperLimit': '价格差范围上限',
  'pages.members.rebateRules.column.rebatePercentage': '一般返利率',
  'pages.members.rebateRules.column.labangRebatePercentage': '拉帮返利率',
  'pages.members.rebateRules.column.addTime': '添加时间',
  'pages.members.rebateRules.column.ruleName': '规则名称',
  'pages.members.rebateRules.column.ruleType': '规则类型',
  'pages.members.rebateRules.column.targetName': '目标名称',
  'pages.members.rebateRules.column.rebateRate': '返利率',
  'pages.members.rebateRules.column.minOrderAmount': '最低订单金额',
  'pages.members.rebateRules.column.maxRebateAmount': '最高返利金额',
  'pages.members.rebateRules.column.startDate': '开始日期',
  'pages.members.rebateRules.column.endDate': '结束日期',
  'pages.members.rebateRules.column.isActive': '激活',
  'pages.members.rebateRules.ruleType.product': '商品',
  'pages.members.rebateRules.ruleType.category': '类别',
  'pages.members.rebateRules.ruleType.order': '订单',
  'pages.members.rebateRules.deleteTitle': '删除返利规则',
  'pages.members.rebateRules.deleteConfirm': '确定要删除此返利规则吗？',
  'pages.members.rebateRules.deleteSuccess': '返利规则已删除',
  'pages.members.rebateRules.updateSuccess': '返利规则已更新',
  'pages.members.rebateRules.createSuccess': '返利规则已创建',
  'pages.members.rebateRules.modal.addTitle': '添加返利规则',
  'pages.members.rebateRules.modal.editTitle': '编辑返利规则',
  'pages.members.rebateRules.form.lowerLimit': '价格差范围下限',
  'pages.members.rebateRules.form.lowerLimitPlaceholder': '请输入价格差范围下限',
  'pages.members.rebateRules.form.lowerLimitRequired': '请输入价格差范围下限',
  'pages.members.rebateRules.form.upperLimit': '价格差范围上限',
  'pages.members.rebateRules.form.upperLimitPlaceholder': '请输入价格差范围上限',
  'pages.members.rebateRules.form.upperLimitRequired': '请输入价格差范围上限',
  'pages.members.rebateRules.form.rebatePercentage': '返利率',
  'pages.members.rebateRules.form.rebatePercentagePlaceholder': '请输入返利率 (%)',
  'pages.members.rebateRules.form.rebatePercentageRequired': '请输入返利率',
  'pages.members.rebateRules.form.ruleType': '规则类型',
  'pages.members.rebateRules.form.ruleTypePlaceholder': '请选择规则类型',
  'pages.members.rebateRules.form.ruleTypeRequired': '请选择规则类型',
  'pages.members.rebateRules.form.ruleName': '规则名称',
  'pages.members.rebateRules.form.ruleNamePlaceholder': '请输入规则名称',
  'pages.members.rebateRules.form.targetName': '目标名称',
  'pages.members.rebateRules.form.targetNamePlaceholder': '请输入目标名称',
  'pages.members.rebateRules.form.rebateRate': '返利率',
  'pages.members.rebateRules.form.rebateRatePlaceholder': '请输入返利率 (%)',
  'pages.members.rebateRules.form.minOrderAmount': '最低订单金额',
  'pages.members.rebateRules.form.minOrderAmountPlaceholder': '请输入最低订单金额（可选）',
  'pages.members.rebateRules.form.maxRebateAmount': '最高返利金额',
  'pages.members.rebateRules.form.maxRebateAmountPlaceholder': '请输入最高返利金额（可选）',
  'pages.members.rebateRules.form.startDate': '开始日期',
  'pages.members.rebateRules.form.endDate': '结束日期',
  'pages.members.rebateRules.form.isActive': '激活',

  // User Promotion Detail
  'pages.members.userPromotionDetail.title': '会员推荐',
  'pages.members.userPromotionDetail.column.userInfo': '用户信息',
  'pages.members.userPromotionDetail.column.userUniqueId': '邮箱',
  'pages.members.userPromotionDetail.column.invitationInfo': '邀请信息',
  'pages.members.userPromotionDetail.expand.warehouseAddresses': '收货地址（仓库）信息',
  'pages.members.userPromotionDetail.expand.invitedUsers': '该会员邀请的会员（不含卖家）',
  'pages.members.userPromotionDetail.expand.noAddresses': '暂无收货地址。',
  'pages.members.userPromotionDetail.expand.noInvitedUsers': '暂无邀请的普通会员。',
  'pages.members.userPromotionDetail.expand.inviteeAddresses': '被邀请会员地址',
  'pages.members.userPromotionDetail.column.inviterUid': '邀请者UID',
  'pages.members.userPromotionDetail.column.numberOfInvitees': '邀请人数',
  'pages.members.userPromotionDetail.column.totalPoints': '总分',
  'pages.members.userPromotionDetail.column.totalPointsWithdrawal': '积分提现',
  'pages.members.userPromotionDetail.column.remainingPoints': '剩余积分',
  'pages.members.userPromotionDetail.column.userId': '用户ID',
  'pages.members.userPromotionDetail.column.userName': '用户名称',
  'pages.members.userPromotionDetail.column.email': '邮箱',
  'pages.members.userPromotionDetail.column.referralCode': '推荐码',
  'pages.members.userPromotionDetail.fetchError': '获取会员推荐信息失败',
  'pages.members.userPromotionDetail.column.level': '等级',
  'pages.members.userPromotionDetail.column.rebatePercentage': '返利比例',
  'pages.members.userPromotionDetail.column.settingTime': '规则设置时间',
  'pages.members.userPromotionDetail.column.lowerLimit': '下限',
  'pages.members.userPromotionDetail.column.upperLimit': '上限',
  'pages.members.userPromotionDetail.column.ruleType': '规则类型',
  'pages.members.userPromotionDetail.rebateLevel': '返利等级',
  'pages.members.userPromotionDetail.rebateRule': '返利规则',
  'pages.members.userPromotionDetail.editRebateLevel': '编辑返利等级',
  'pages.members.userPromotionDetail.editRebateRule': '编辑返利规则',
  'pages.members.userPromotionDetail.rebateLevelManagement': '返利等级管理',
  'pages.members.userPromotionDetail.rebateRuleManagement': '返利规则管理',
  'pages.members.userPromotionDetail.deleteRebateLevel': '删除返利等级',
  'pages.members.userPromotionDetail.deleteRebateLevelConfirm': '确定要删除此返利等级吗？',
  'pages.members.userPromotionDetail.deleteRebateRule': '删除返利规则',
  'pages.members.userPromotionDetail.deleteRebateRuleConfirm': '确定要删除此返利规则吗？',
  'pages.members.userPromotionDetail.deleteConfirm': '确定要删除吗？',
  'pages.members.userPromotionDetail.deleteSuccess': '删除成功',
  'pages.members.userPromotionDetail.updateSuccess': '更新成功',
  'pages.members.userPromotionDetail.createSuccess': '创建成功',
  'pages.members.userPromotionDetail.form.level': '等级',
  'pages.members.userPromotionDetail.form.rebatePercentage': '返利比例',
  'pages.members.userPromotionDetail.form.lowerLimit': '下限',
  'pages.members.userPromotionDetail.form.upperLimit': '上限',
  'pages.members.userPromotionDetail.form.ruleType': '规则类型',
  'pages.members.userPromotionDetail.ruleType.priceDifference': '价格差异',
  'pages.members.userPromotionDetail.column.promotionType': '促销类型',
  'pages.members.userPromotionDetail.column.promotionName': '促销名称',
  'pages.members.userPromotionDetail.column.promotionCode': '促销代码',
  'pages.members.userPromotionDetail.column.amount': '金额',
  'pages.members.userPromotionDetail.column.status': '状态',
  'pages.members.userPromotionDetail.column.startDate': '开始日期',
  'pages.members.userPromotionDetail.column.endDate': '结束日期',
  'pages.members.userPromotionDetail.column.usedDate': '使用日期',
  'pages.members.userPromotionDetail.column.orderNumber': '订单号',
  'pages.members.userPromotionDetail.promotionType.rebate': '返利',
  'pages.members.userPromotionDetail.promotionType.discount': '折扣',
  'pages.members.userPromotionDetail.promotionType.points': '积分',
  'pages.members.userPromotionDetail.promotionType.coupon': '优惠券',
  'pages.members.userPromotionDetail.status.active': '激活',
  'pages.members.userPromotionDetail.status.used': '已使用',
  'pages.members.userPromotionDetail.status.expired': '已过期',
  'pages.members.userPromotionDetail.status.cancelled': '已取消',

  // Deposit Usage Detailed
  'pages.members.depositUsage.memberName': '会员名',
  'pages.members.depositUsage.usageClassification': '使用分类',
  'pages.members.depositUsage.classificationPaymentCost': '使用支付费用',
  'pages.members.depositUsage.classificationDepositTopup': '押金充值',
  'pages.members.depositUsage.classificationAdminAccrual': '管理员押金累积',
  'pages.members.depositUsage.classificationAdminDeduction': '管理员押金扣除',
  'pages.members.depositUsage.classificationRefund': '购买商品退款',
  'pages.members.depositUsage.content': '内容',
  'pages.members.depositUsage.amount': '使用金额',
  'pages.members.depositUsage.balance': '余额',
  'pages.members.depositUsage.usageDate': '使用日期',
  'pages.members.depositUsage.paymentOrderNumber': 'Payment OrderNumber',
  'pages.members.depositUsage.depositPaymentOrderNumber': 'Deposit Payment Order Number',
  'pages.members.depositUsage.usageType': '使用类型',
  'pages.members.depositUsage.typeOrder': '订单',
  'pages.members.depositUsage.typeRefund': '退款',
  'pages.members.depositUsage.typeWithdrawal': '提款',
  'pages.members.depositUsage.orderNo': '订单号',
  'pages.members.depositUsage.actions': '操作',
  'pages.members.depositUsage.viewDetails': '查看详情',
  'pages.members.depositUsage.totalUsage': '总使用',
  'pages.members.depositUsage.totalAmount': '总金额',
  'pages.members.depositUsage.averageAmount': '平均金额',
  'pages.members.depositUsage.descriptionOrder': '订单支付',
  'pages.members.depositUsage.mock.companyName': '贸易有限公司',
  'pages.members.depositUsage.mock.memberName': '洪吉童',
  'pages.members.depositUsage.mock.paymentContent': '订单支付相关内容',
  'pages.members.depositUsage.depositRegistration': '押金登记',
  'pages.members.depositUsage.memberSearch': '会员搜索',
  'pages.members.depositUsage.searchByMemberId': '会员ID',
  'pages.members.depositUsage.searchByMemberName': '会员名',
  'pages.members.depositUsage.searchRequired': '请输入搜索值',
  'pages.members.depositUsage.searchPlaceholder': '搜索',
  'pages.members.depositUsage.search': '搜索',
  'pages.members.depositUsage.memberSelect': '会员选择',
  'pages.members.depositUsage.contentRequired': '请输入内容',
  'pages.members.depositUsage.contentPlaceholder': '请输入内容',
  'pages.members.depositUsage.amountRequired': '请输入金额',
  'pages.members.depositUsage.amountMin': '金额必须大于0',
  'pages.members.depositUsage.amountPlaceholder': '0',
  'pages.members.depositUsage.registrationSuccess': '押金登记成功',

  // Bankbook Verification Detailed
  'pages.members.bankbookVerification.depositDate': '存款日期',
  'pages.members.bankbookVerification.accountNumber': '账户号码',
  'pages.members.bankbookVerification.depositor': '存款人',
  'pages.members.bankbookVerification.amount': '金额',
  'pages.members.bankbookVerification.completionStatus': '完成状态',
  'pages.members.bankbookVerification.completed': '已完成',
  'pages.members.bankbookVerification.notCompleted': '未完成',
  'pages.members.bankbookVerification.status': '状态',
  'pages.members.bankbookVerification.statusVerified': '已验证',
  'pages.members.bankbookVerification.statusPending': '待处理',
  'pages.members.bankbookVerification.statusFailed': '失败',
  'pages.members.bankbookVerification.processingDate': '处理日期',
  'pages.members.bankbookVerification.memberName': '会员名',
  'pages.members.bankbookVerification.bankInfo': '银行信息',
  'pages.members.bankbookVerification.autoVerify': '自动验证',
  'pages.members.bankbookVerification.enabled': '启用',
  'pages.members.bankbookVerification.disabled': '禁用',
  'pages.members.bankbookVerification.lastVerifiedDate': '最后验证日期',
  'pages.members.bankbookVerification.actions': '操作',
  'pages.members.bankbookVerification.verify': '验证',
  'pages.members.bankbookVerification.autoVerifyUpdated': '{name}的自动验证已{status}',
  'pages.members.bankbookVerification.verificationStarted': '开始为{name}验证银行账户',
  'pages.members.bankbookVerification.totalAccounts': '总账户数',
  'pages.members.bankbookVerification.autoVerified': '自动验证',
  'pages.members.bankbookVerification.verified': '已验证',
  'pages.members.bankbookVerification.failureReasonMismatch': '账户信息不匹配',
  'pages.members.bankbookVerification.mock.depositor1': '李代表',
  'pages.members.bankbookVerification.mock.depositor2': '洪吉童',
  'pages.members.bankbookVerification.mock.additionalInfo': '附加信息',

  // Forex Deposit Application Detailed
  'pages.members.forexDepositApplication.memberName': '会员名',
  'pages.members.forexDepositApplication.depositorCompanyName': '存款人公司名称',
  'pages.members.forexDepositApplication.applicationAmountUSD': '申请金额($)',
  'pages.members.forexDepositApplication.usdDepositAmount': '美元存款金额($)',
  'pages.members.forexDepositApplication.actualDepositAmountCNY': '实际存款金额(¥)',
  'pages.members.forexDepositApplication.feeRatePercent': '手续费率(%)',
  'pages.members.forexDepositApplication.actualFeeCNY': '实际手续费(¥)',
  'pages.members.forexDepositApplication.actualRechargeAmountCNY': '实际充值金额(¥)',
  'pages.members.forexDepositApplication.remittanceDate': '汇款日期',
  'pages.members.forexDepositApplication.completionStatus': '完成状态',
  'pages.members.forexDepositApplication.completed': '已完成',
  'pages.members.forexDepositApplication.notCompleted': '未完成',
  'pages.members.forexDepositApplication.applicationDate': '申请日期',
  'pages.members.forexDepositApplication.completionDate': '完成日期',
  'pages.members.forexDepositApplication.adminDesignatedDate': '管理员指定日期',
  'pages.members.forexDepositApplication.smsNotSent': '未发送短信',
  'pages.members.forexDepositApplication.smsSent': '已发送短信',
  'pages.members.forexDepositApplication.memo': '备注',
  'pages.members.forexDepositApplication.memoPlaceholder': '输入备注',
  'pages.members.forexDepositApplication.mock.companyName': '贸易有限公司',
  'pages.members.forexDepositApplication.mock.memberName': '洪吉童',
  'pages.members.forexDepositApplication.mock.companyNameWithNumber': '公司名称',
  'pages.members.forexDepositApplication.mock.memo': '备注内容',
  'pages.members.forexDepositApplication.memoRegistered': '备注已注册',
  'pages.members.forexDepositApplication.amount': '申请金额',
  'pages.members.forexDepositApplication.bankInfo': '银行信息',
  'pages.members.forexDepositApplication.status': '状态',
  'pages.members.forexDepositApplication.statusPending': '待处理',
  'pages.members.forexDepositApplication.statusApproved': '已批准',
  'pages.members.forexDepositApplication.statusRejected': '已拒绝',
  'pages.members.forexDepositApplication.actions': '操作',
  'pages.members.forexDepositApplication.approve': '批准',
  'pages.members.forexDepositApplication.reject': '拒绝',
  'pages.members.forexDepositApplication.viewDetails': '查看详情',
  'pages.members.forexDepositApplication.approveConfirm': '批准外汇押金申请',
  'pages.members.forexDepositApplication.approveContent': '您要批准{name}的{amount} {currency}外汇押金申请吗？',
  'pages.members.forexDepositApplication.approved': '外汇押金申请已批准',
  'pages.members.forexDepositApplication.rejectConfirm': '拒绝外汇押金申请',
  'pages.members.forexDepositApplication.rejectContent': '您要拒绝{name}的外汇押金申请吗？',
  'pages.members.forexDepositApplication.rejected': '外汇押金申请已拒绝',
  'pages.members.forexDepositApplication.totalApplications': '总申请数',
  'pages.members.forexDepositApplication.pendingApplications': '待处理',
  'pages.members.forexDepositApplication.approvedApplications': '已批准',
  'pages.members.forexDepositApplication.totalAmount': '总金额',
  'pages.members.forexDepositApplication.exchangeRate': '汇率',
  'pages.members.forexDepositApplication.reasonRecharge': '外汇押金充值',

  // Forex Deposit Usage Detailed
  'pages.members.forexDepositUsage.memberNameWithMailbox': '会员名(信箱)',
  'pages.members.forexDepositUsage.usageClassification': '使用分类',
  'pages.members.forexDepositUsage.classificationPaymentCost': '使用支付费用',
  'pages.members.forexDepositUsage.classificationDepositTopup': '押金充值',
  'pages.members.forexDepositUsage.classificationAdminAccrual': '管理员押金累积',
  'pages.members.forexDepositUsage.classificationAdminDeduction': '管理员押金扣除',
  'pages.members.forexDepositUsage.classificationRefund': '购买商品退款',
  'pages.members.forexDepositUsage.content': '内容',
  'pages.members.forexDepositUsage.paymentNumber': '支付号码',
  'pages.members.forexDepositUsage.order1688Number': '1688订单号',
  'pages.members.forexDepositUsage.alipayPaymentNumber': '支付宝支付号码',
  'pages.members.forexDepositUsage.register': '注册',
  'pages.members.forexDepositUsage.registered': '已注册',
  'pages.members.forexDepositUsage.pleaseEnterValue': '请输入值',
  'pages.members.forexDepositUsage.enterOrder1688Number': '输入1688订单号',
  'pages.members.forexDepositUsage.enterAlipayPaymentNumber': '输入支付宝支付号码',
  'pages.members.forexDepositUsage.depositRegistration': '押金登记',
  'pages.members.forexDepositUsage.depositChangeExcel': '押金变动Excel',
  'pages.members.forexDepositUsage.depositRefundExcel': '押金退款Excel',
  'pages.members.forexDepositUsage.paymentCostExcel': '支付费用使用Excel',
  'pages.members.forexDepositUsage.accumulationDeductionExcel': '累积/扣除Excel',
  'pages.members.forexDepositUsage.memberSearch': '会员搜索',
  'pages.members.forexDepositUsage.searchByMemberId': '会员ID',
  'pages.members.forexDepositUsage.searchByMemberName': '会员名',
  'pages.members.forexDepositUsage.searchRequired': '请输入搜索值',
  'pages.members.forexDepositUsage.searchPlaceholder': '搜索',
  'pages.members.forexDepositUsage.search': '搜索',
  'pages.members.forexDepositUsage.memberSelect': '会员选择',
  'pages.members.forexDepositUsage.contentRequired': '请输入内容',
  'pages.members.forexDepositUsage.contentPlaceholder': '请输入内容',
  'pages.members.forexDepositUsage.amountRequired': '请输入金额',
  'pages.members.forexDepositUsage.amountMin': '金额必须大于0',
  'pages.members.forexDepositUsage.amountPlaceholder': '0',
  'pages.members.forexDepositUsage.registrationSuccess': '押金登记成功',
  'pages.members.forexDepositUsage.exportingDepositChange': '正在导出押金变动...',
  'pages.members.forexDepositUsage.exportingDepositRefund': '正在导出押金退款...',
  'pages.members.forexDepositUsage.exportingPaymentCost': '正在导出支付费用使用...',
  'pages.members.forexDepositUsage.exportingAccumulationDeduction': '正在导出累积/扣除...',
  'pages.members.forexDepositUsage.depositAmountCNY': '押金(¥)',
  'pages.members.forexDepositUsage.remainingDepositCNY': '剩余押金(¥)',
  'pages.members.forexDepositUsage.usageDate': '日期',
  'pages.members.forexDepositUsage.adminDesignatedDate': '管理员指定日期',
  'pages.members.forexDepositUsage.usageType': '使用类型',
  'pages.members.forexDepositUsage.typeOrder': '订单',
  'pages.members.forexDepositUsage.typeRefund': '退款',
  'pages.members.forexDepositUsage.typeWithdrawal': '提款',
  'pages.members.forexDepositUsage.orderNo': '订单号',
  'pages.members.forexDepositUsage.balance': '余额',
  'pages.members.forexDepositUsage.actions': '操作',
  'pages.members.forexDepositUsage.viewDetails': '查看详情',
  'pages.members.forexDepositUsage.totalUsage': '总使用',
  'pages.members.forexDepositUsage.totalAmount': '总金额',
  'pages.members.forexDepositUsage.averageAmount': '平均金额',
  'pages.members.forexDepositUsage.descriptionOrder': '订单支付',

  // Forex Deposit Payment Detailed
  'pages.members.forexDepositPayment.memberNameWithMailbox': '会员名(信箱)',
  'pages.members.forexDepositPayment.applicationClassification': '申请分类',
  'pages.members.forexDepositPayment.classificationDeposit': '存款',
  'pages.members.forexDepositPayment.classificationWithdrawal': '提款',
  'pages.members.forexDepositPayment.classificationRefund': '退款',
  'pages.members.forexDepositPayment.applicationInfo': '申请信息',
  'pages.members.forexDepositPayment.siteId': 'Site ID',
  'pages.members.forexDepositPayment.request': 'Request',
  'pages.members.forexDepositPayment.enterSiteId': '输入Site ID',
  'pages.members.forexDepositPayment.enterRequest': '输入Request',
  'pages.members.forexDepositPayment.applicationAmount': '申请金额',
  'pages.members.forexDepositPayment.status': '状态',
  'pages.members.forexDepositPayment.statusCompleted': '完成',
  'pages.members.forexDepositPayment.statusPending': '待处理',
  'pages.members.forexDepositPayment.statusFailed': '失败',
  'pages.members.forexDepositPayment.applicationDate': '日期',
  'pages.members.forexDepositPayment.adminDesignatedDate': '管理员指定日期',
  'pages.members.forexDepositPayment.smsNotSent': '未发送短信',
  'pages.members.forexDepositPayment.smsSent': '已发送短信',
  'pages.members.forexDepositPayment.all': '全部',
  'pages.members.forexDepositPayment.progressing': '进行中',
  'pages.members.forexDepositPayment.progressingSuccess': '进行已成功完成',
  'pages.members.forexDepositPayment.adminMemo': '管理员备注',
  'pages.members.forexDepositPayment.adminMemoPlaceholder': '输入管理员备注',
  'pages.members.forexDepositPayment.adminMemoRegistered': '管理员备注已注册',
  'pages.members.forexDepositPayment.memberName': '会员名',
  'pages.members.forexDepositPayment.paymentAmount': '支付金额',
  'pages.members.forexDepositPayment.paymentMethod': '支付方式',
  'pages.members.forexDepositPayment.methodBank': '银行',
  'pages.members.forexDepositPayment.methodCard': '卡',
  'pages.members.forexDepositPayment.methodTransfer': '转账',
  'pages.members.forexDepositPayment.paymentStatus': '支付状态',
  'pages.members.forexDepositPayment.transactionId': '交易号',
  'pages.members.forexDepositPayment.paymentDate': '支付日期',
  'pages.members.forexDepositPayment.actions': '操作',
  'pages.members.forexDepositPayment.viewDetails': '查看详情',
  'pages.members.forexDepositPayment.totalPayments': '总支付数',
  'pages.members.forexDepositPayment.completedPayments': '已完成',
  'pages.members.forexDepositPayment.totalAmount': '总金额',
  'pages.members.forexDepositPayment.totalFee': '总手续费',
  'pages.members.forexDepositPayment.exchangeRate': '汇率',
  'pages.members.forexDepositPayment.fee': '手续费',

  // CS Pages
  'pages.cs.banners.description': '主横幅、弹窗和活动页面管理',
  'pages.cs.lookingForOwner.description': '寻找业主管理页面',

  // Bulletin Board Settings
  'pages.cs.bulletinBoard.title': '公告板设置',
  'pages.cs.bulletinBoard.saveSuccess': '设置保存成功',
  'pages.cs.bulletinBoard.generalSettings': '常规设置',
  'pages.cs.bulletinBoard.postsPerPage': '每页帖子数',
  'pages.cs.bulletinBoard.allowAnonymous': '允许匿名发帖',
  'pages.cs.bulletinBoard.requireApproval': '需要管理员审批',
  'pages.cs.bulletinBoard.attachmentSettings': '附件设置',
  'pages.cs.bulletinBoard.allowAttachments': '允许附件',
  'pages.cs.bulletinBoard.maxAttachmentSize': '最大附件大小 (MB)',
  'pages.cs.bulletinBoard.allowedFileTypes': '允许的文件类型',
  'pages.cs.bulletinBoard.commentSettings': '评论设置',
  'pages.cs.bulletinBoard.allowComments': '允许评论',
  'pages.cs.bulletinBoard.notifyOnNewPost': '新帖子时通知管理员',
  'pages.cs.bulletinBoard.notificationEmail': '通知邮箱',
  'pages.cs.bulletinBoard.save': '保存设置',
  'pages.cs.bulletinBoard.reset': '重置',
  'pages.cs.bulletinBoard.number': '编号',
  'pages.cs.bulletinBoard.titleColumn': '标题',
  'pages.cs.bulletinBoard.category': '分类',
  'pages.cs.bulletinBoard.categoryNotice': '公告',
  'pages.cs.bulletinBoard.categoryEvent': '活动',
  'pages.cs.bulletinBoard.categoryFaq': '常见问题',
  'pages.cs.bulletinBoard.categoryUpdate': '更新',
  'pages.cs.bulletinBoard.status': '状态',
  'pages.cs.bulletinBoard.statusActive': '激活',
  'pages.cs.bulletinBoard.statusInactive': '未激活',
  'pages.cs.bulletinBoard.registrationDate': '注册日期',
  'pages.cs.bulletinBoard.views': '浏览次数',
  'pages.cs.bulletinBoard.actions': '操作',
  'pages.cs.bulletinBoard.edit': '编辑',
  'pages.cs.bulletinBoard.delete': '删除',
  'pages.cs.bulletinBoard.add': '添加',
  'pages.cs.bulletinBoard.addTitle': '添加公告板',
  'pages.cs.bulletinBoard.editTitle': '编辑公告板',
  'pages.cs.bulletinBoard.deleteConfirm': '删除公告板',
  'pages.cs.bulletinBoard.deleteContent': '确定要删除"{title}"吗？',
  'pages.cs.bulletinBoard.deleteSuccess': '删除成功',
  'pages.cs.bulletinBoard.updateSuccess': '更新成功',
  'pages.cs.bulletinBoard.createSuccess': '创建成功',
  'pages.cs.bulletinBoard.titleRequired': '请输入标题',
  'pages.cs.bulletinBoard.titlePlaceholder': '输入标题',
  'pages.cs.bulletinBoard.categoryRequired': '请选择分类',
  'pages.cs.bulletinBoard.categoryPlaceholder': '选择分类',
  'pages.cs.bulletinBoard.content': '内容',
  'pages.cs.bulletinBoard.contentRequired': '请输入内容',
  'pages.cs.bulletinBoard.contentPlaceholder': '输入内容',
  'pages.cs.bulletinBoard.cancel': '取消',
  'pages.cs.bulletinBoard.type': '类型',
  'pages.cs.bulletinBoard.typePlaceholder': '选择类型',
  'pages.cs.bulletinBoard.typeGeneral': '一般',
  'pages.cs.bulletinBoard.typeGallery': '画廊',
  'pages.cs.bulletinBoard.typeQA': 'Q&A',
  'pages.cs.bulletinBoard.secretPost': '秘密帖子',
  'pages.cs.bulletinBoard.headerPost': '标题帖子使用',
  'pages.cs.bulletinBoard.statusEnabled': '状态使用',
  'pages.cs.bulletinBoard.writePermission': '写入权限',
  'pages.cs.bulletinBoard.viewPermission': '查看权限',
  'pages.cs.bulletinBoard.commentPermission': '评论权限',
  'pages.cs.bulletinBoard.noticeCount': '公告数量',
  'pages.cs.bulletinBoard.enabled': '启用',

  'pages.reviews.title': '用户评论',
  'pages.reviews.number': '编号',
  'pages.reviews.author': '作者',
  'pages.reviews.views': '浏览次数',
  'pages.reviews.registrationDate': '注册日期',
  'pages.reviews.actions': '操作',
  'pages.reviews.view': '查看',
  'pages.reviews.edit': '编辑',
  'pages.reviews.delete': '删除',
  'pages.reviews.deleteConfirm': '确定要删除吗？',
  'pages.reviews.deleted': '已删除',
  'pages.reviews.searchSuccess': '搜索完成',
  'pages.reviews.imagesCount': '件',
  'pages.reviews.pageSize': '每页',
  'pages.reviews.date': '日期',
  'pages.reviews.memberName': '会员名称',
  'pages.reviews.memberNamePlaceholder': '会员名称',
  'pages.reviews.titlePlaceholder': '标题',
  'pages.reviews.content': '内容',
  'pages.reviews.contentPlaceholder': '内容',
  'pages.reviews.postNumber': '帖子编号',
  'pages.reviews.postNumberPlaceholder': '帖子编号',
  'pages.reviews.search': '搜索',
  'pages.reviews.reset': '重置',
  'pages.reviews.write': '写帖子',
  'pages.reviews.totalCount': '总数',
  'pages.reviews.page': '页',
  'pages.reviews.total': '共',
  'pages.reviews.viewDetail': '查看详情',
  'pages.reviews.titleRequired': '请输入标题',
  'pages.reviews.contentRequired': '请输入内容',
  'pages.reviews.isNotice': '是否为公告帖子？',
  'pages.reviews.attachments': '多个附件',
  'pages.reviews.attachments.count': '个',
  'pages.reviews.sequenceNumber': '序号',
  'pages.reviews.complaintType': '不满类型',
  'pages.reviews.complaintType.complaint': '不满',
  'pages.reviews.complaintType.suggestion': '建议',
  'pages.reviews.memberNumber': '会员编号',
  'pages.reviews.orderNumber': '订单编号',
  'pages.reviews.subOrderNumber': '子订单编号',
  'pages.reviews.processingStatus': '处理状态',
  'pages.reviews.processingStatus.unconfirmed': '未确认',
  'pages.reviews.processingStatus.processed': '处理完成',
  'pages.reviews.updatedAt': '最新更新时间',
  'pages.reviews.maxFiles': '最大数量：5个文件',
  'pages.reviews.maxFileSize': '每个文件最大大小：3MB',
  'pages.reviews.chooseFiles': '选择文件',
  'pages.reviews.cancel': '取消',
  'pages.reviews.save': '保存',
  'pages.reviews.createSuccess': '保存成功',
  'pages.reviews.updateSuccess': '更新成功',
  'pages.reviews.detail': '详情',
  'pages.reviews.postInfo': '帖子信息',
  'pages.reviews.list': '列表',
  'pages.reviews.policyWarning': '如果您发布违反运营政策的内容（如辱骂、刷屏、诽谤或谣言），您可能会受到不利影响，例如限制发帖。',
  'pages.reviews.comments': '评论',
  'pages.reviews.commentPlaceholder': '您好。这是今日直购。',
  'pages.reviews.writeComment': '写评论',
  'pages.reviews.commentRequired': '请输入评论',
  'pages.reviews.commentSubmitted': '评论已提交',
  'pages.reviews.totalComments': '共',
  'pages.reviews.commentsCount': '条评论',
  'pages.reviews.noComments': '暂无评论。',
  'pages.reviews.filter': '搜索筛选',

  // Inquiries Page
  'pages.cs.inquiries.title': '1对1咨询管理',
  'pages.cs.inquiries.stats.total': '全部咨询',
  'pages.cs.inquiries.stats.pending': '待处理',
  'pages.cs.inquiries.stats.answered': '已回答',
  'pages.cs.inquiries.stats.avgResponseTime': '平均响应时间',
  'pages.cs.inquiries.stats.hours': '小时',
  'pages.cs.inquiries.list': '咨询列表',
  'pages.cs.inquiries.export': '导出Excel',
  'pages.cs.inquiries.exportSuccess': 'Excel导出成功',
  'pages.cs.inquiries.id': 'ID',
  'pages.cs.inquiries.number': '编号',
  'pages.cs.inquiries.author': '作者',
  'pages.cs.inquiries.views': '浏览量',
  'pages.cs.inquiries.memberInfo': '会员信息',
  'pages.cs.inquiries.category': '类别',
  'pages.cs.inquiries.category.order': '订单咨询',
  'pages.cs.inquiries.category.product': '商品咨询',
  'pages.cs.inquiries.category.delivery': '配送咨询',
  'pages.cs.inquiries.category.payment': '支付咨询',
  'pages.cs.inquiries.category.etc': '其他',
  'pages.cs.inquiries.fieldTitle': '标题',
  'pages.cs.inquiries.priority': '优先级',
  'pages.cs.inquiries.priority.high': '高',
  'pages.cs.inquiries.priority.normal': '普通',
  'pages.cs.inquiries.priority.low': '低',
  'pages.cs.inquiries.status': '状态',
  'pages.cs.inquiries.status.pending': '待处理',
  'pages.cs.inquiries.status.answered': '已回答',
  'pages.cs.inquiries.status.closed': '已关闭',
  'pages.cs.inquiries.createdAt': '注册日期',
  'pages.cs.inquiries.answeredAt': '回答日期',
  'pages.cs.inquiries.actions': '操作',
  'pages.cs.inquiries.viewDetail': '详情',
  'pages.cs.inquiries.answer': '回答',
  'pages.cs.inquiries.detailTitle': '咨询详情',
  'pages.cs.inquiries.close': '关闭',
  'pages.cs.inquiries.answerButton': '回答',
  'pages.cs.inquiries.inquiryContent': '咨询内容',
  'pages.cs.inquiries.inquiryId': '咨询ID',
  'pages.cs.inquiries.memberName': '会员名',
  'pages.cs.inquiries.memberId': '会员ID',
  'pages.cs.inquiries.answerer': '回答者',
  'pages.cs.inquiries.answerContent': '回答',
  'pages.cs.inquiries.answerTitle': '写回答',
  'pages.cs.inquiries.answerContentField': '回答内容',
  'pages.cs.inquiries.answerContentPlaceholder': '请输入回答内容',
  'pages.cs.inquiries.submit': '提交',
  'pages.cs.inquiries.cancel': '取消',
  'pages.cs.inquiries.answerSuccess': '回答已注册',
  'pages.cs.inquiries.tab.all': '全部',
  'pages.cs.inquiries.tab.inProgress': '咨询中',
  'pages.cs.inquiries.tab.answered': '已回答',
  'pages.cs.inquiries.tab.onHold': '回答保留',
  'pages.cs.inquiries.isHeader': '头部帖子',
  'pages.cs.inquiries.content': '内容',
  'pages.cs.inquiries.addTitle': '添加咨询',
  'pages.cs.inquiries.addSuccess': '咨询添加成功',
  'pages.cs.inquiries.addError': '添加咨询失败',
  'pages.cs.inquiries.secret': '秘密帖子',
  'pages.cs.inquiries.selectCategory': '选择类别',
  'pages.cs.inquiries.contentPlaceholder': '请输入内容',
  'pages.cs.inquiries.attachments': '多个附件',
  'pages.cs.inquiries.attachmentInfo': '最多5个文件，每个5MB',
  'pages.cs.inquiries.loadError': '加载咨询失败',
  'pages.cs.inquiries.deleteSuccess': '咨询删除成功',
  'pages.cs.inquiries.deleteError': '删除咨询失败',
  'pages.cs.inquiries.deleteConfirm': '确定要删除吗？',
  'pages.cs.inquiries.notFound': '未找到咨询',
  'pages.cs.inquiries.replySection': '回复',
  'pages.cs.inquiries.replyRequired': '请输入回复内容',
  'pages.cs.inquiries.replySuccess': '回复发布成功',
  'pages.cs.inquiries.replyError': '发布回复失败',
  'pages.cs.inquiries.replyPlaceholder': '请输入回复内容',
  'pages.cs.inquiries.replyNote': '禁止发布列表、域名、密码等敏感信息',
  'pages.cs.inquiries.smsNotification': '短信通知',
  'pages.cs.inquiries.noNotification': '无通知',
  'pages.cs.inquiries.reply': '回复',

  // CS - Danger Management
  'pages.cs.dangerManagement.title': '危险词管理',
  'pages.cs.dangerManagement.addTitle': '添加危险词',
  'pages.cs.dangerManagement.editTitle': '编辑危险词',
  'pages.cs.dangerManagement.deleteConfirm': '删除危险词',
  'pages.cs.dangerManagement.deleteConfirmContent': '确定要删除危险词 "{term}" 吗？',
  'pages.cs.dangerManagement.deleteSuccess': '危险词已删除',
  'pages.cs.dangerManagement.updateSuccess': '危险词已更新',
  'pages.cs.dangerManagement.createSuccess': '危险词已创建',
  'pages.cs.dangerManagement.submitError': '保存危险词时出错',
  'pages.cs.dangerManagement.fetchError': '加载危险关键词失败',
  'pages.cs.dangerManagement.deleteError': '删除危险关键词失败',
  'pages.cs.dangerManagement.duplicateError': '危险关键词已存在',
  'pages.cs.dangerManagement.validationError': '验证错误',
  'pages.cs.dangerManagement.form.termLength': '术语长度必须在1到200个字符之间',
  'pages.cs.dangerManagement.column.id': 'ID',
  'pages.cs.dangerManagement.column.term': '术语',
  'pages.cs.dangerManagement.column.category': '类别',
  'pages.cs.dangerManagement.column.severity': '严重程度',
  'pages.cs.dangerManagement.column.action': '操作',
  'pages.cs.dangerManagement.column.description': '描述',
  'pages.cs.dangerManagement.column.isActive': '激活',
  'pages.cs.dangerManagement.category.prohibited': '禁止',
  'pages.cs.dangerManagement.category.restricted': '限制',
  'pages.cs.dangerManagement.category.sensitive': '敏感',
  'pages.cs.dangerManagement.severity.high': '高',
  'pages.cs.dangerManagement.severity.medium': '中',
  'pages.cs.dangerManagement.severity.low': '低',
  'pages.cs.dangerManagement.action.block': '阻止',
  'pages.cs.dangerManagement.action.warn': '警告',
  'pages.cs.dangerManagement.action.review': '审查',
  'pages.cs.dangerManagement.form.term': '术语',
  'pages.cs.dangerManagement.form.termRequired': '请输入术语',
  'pages.cs.dangerManagement.form.atLeastOneLang': '至少需要输入一种语言（英语、中文或韩语）',
  'pages.cs.dangerManagement.translate': '翻译',
  'pages.cs.dangerManagement.translateSuccess': '翻译完成',
  'pages.cs.dangerManagement.translateError': '翻译失败',
  'pages.cs.dangerManagement.form.category': '类别',
  'pages.cs.dangerManagement.form.categoryRequired': '请选择类别',
  'pages.cs.dangerManagement.form.severity': '严重程度',
  'pages.cs.dangerManagement.form.severityRequired': '请选择严重程度',
  'pages.cs.dangerManagement.form.action': '操作',
  'pages.cs.dangerManagement.form.actionRequired': '请选择操作',
  'pages.cs.dangerManagement.form.description': '描述',
  'pages.cs.dangerManagement.form.isActive': '激活',

  // CS - Edit Search Term
  'pages.cs.editSearchTerm.title': '编辑搜索词',
  'pages.cs.editSearchTerm.addTitle': '添加搜索词',
  'pages.cs.editSearchTerm.editTitle': '编辑搜索词',
  'pages.cs.editSearchTerm.deleteConfirm': '删除搜索词',
  'pages.cs.editSearchTerm.deleteConfirmContent': '确定要删除搜索词 "{term}" 吗？',
  'pages.cs.editSearchTerm.deleteSuccess': '搜索词已删除',
  'pages.cs.editSearchTerm.updateSuccess': '搜索词已更新',
  'pages.cs.editSearchTerm.createSuccess': '搜索词已创建',
  'pages.cs.editSearchTerm.submitError': '保存搜索词时出错',
  'pages.cs.editSearchTerm.fetchError': '加载搜索词失败',
  'pages.cs.editSearchTerm.deleteError': '删除搜索词失败',
  'pages.cs.editSearchTerm.createError': '创建搜索词失败',
  'pages.cs.editSearchTerm.updateError': '更新搜索词失败',
  'pages.cs.editSearchTerm.column.id': 'ID',
  'pages.cs.editSearchTerm.column.term': '搜索词',
  'pages.cs.editSearchTerm.column.category': '类别',
  'pages.cs.editSearchTerm.column.priority': '优先级',
  'pages.cs.editSearchTerm.column.synonyms': '同义词',
  'pages.cs.editSearchTerm.column.relatedTerms': '相关词',
  'pages.cs.editSearchTerm.column.searchCount': '搜索次数',
  'pages.cs.editSearchTerm.column.isActive': '激活',
  'pages.cs.editSearchTerm.column.correctTerm': '正确词',
  'pages.cs.editSearchTerm.form.term': '搜索词',
  'pages.cs.editSearchTerm.form.termRequired': '请输入搜索词',
  'pages.cs.editSearchTerm.form.atLeastOneLang': '至少需要输入一种语言（英语、中文或韩语）',
  'pages.cs.editSearchTerm.translate': '翻译',
  'pages.cs.editSearchTerm.translateSuccess': '翻译完成',
  'pages.cs.editSearchTerm.translateError': '翻译失败',
  'pages.cs.editSearchTerm.form.correctTerm': '正确词',
  'pages.cs.editSearchTerm.form.correctTermRequired': '请输入正确词',
  'pages.cs.editSearchTerm.form.isActive': '激活',
  'pages.cs.editSearchTerm.form.category': '类别',
  'pages.cs.editSearchTerm.form.categoryRequired': '请输入类别',
  'pages.cs.editSearchTerm.form.priority': '优先级',
  'pages.cs.editSearchTerm.form.priorityRequired': '请输入优先级',
  'pages.cs.editSearchTerm.form.synonyms': '同义词',
  'pages.cs.editSearchTerm.form.synonymsTooltip': '请输入逗号分隔的值',
  'pages.cs.editSearchTerm.form.synonymsPlaceholder': '例如：手机，移动电话',
  'pages.cs.editSearchTerm.form.relatedTerms': '相关词',
  'pages.cs.editSearchTerm.form.relatedTermsTooltip': '请输入逗号分隔的值',
  'pages.cs.editSearchTerm.form.relatedTermsPlaceholder': '例如：保护壳，屏幕保护膜',

  // CS - Suggestion
  'pages.cs.suggestion.title': '场地评估',
  'pages.cs.suggestion.list': '建议列表',
  'pages.cs.suggestion.detailTitle': '建议详情',
  'pages.cs.suggestion.responseTitle': '回复建议',
  'pages.cs.suggestion.column.sequenceNumber': '编号',
  'pages.cs.suggestion.column.category': '分类',
  'pages.cs.suggestion.column.title': '标题',
  'pages.cs.suggestion.column.content': '内容',
  'pages.cs.suggestion.column.userName': '作者',
  'pages.cs.suggestion.column.email': '邮箱',
  'pages.cs.suggestion.column.status': '状态',
  'pages.cs.suggestion.column.createdAt': '创建日期',
  'pages.cs.suggestion.column.actions': '操作',
  'pages.cs.suggestion.category.feature': '功能请求',
  'pages.cs.suggestion.category.improvement': '改进建议',
  'pages.cs.suggestion.category.bug': '错误报告',
  'pages.cs.suggestion.category.other': '其他',
  'pages.cs.suggestion.status.pending': '待处理',
  'pages.cs.suggestion.status.reviewing': '审核中',
  'pages.cs.suggestion.status.accepted': '已接受',
  'pages.cs.suggestion.status.rejected': '已拒绝',
  'pages.cs.suggestion.status.completed': '已完成',
  'pages.cs.suggestion.action.view': '查看',
  'pages.cs.suggestion.action.respond': '回复',
  'pages.cs.suggestion.action.delete': '删除',
  'pages.cs.suggestion.deleteConfirm': '确定要删除吗？',
  'pages.cs.suggestion.deleteSuccess': '删除成功',
  'pages.cs.suggestion.responseSuccess': '回复已保存',
  'pages.cs.suggestion.adminResponse': '管理员回复',
  'pages.cs.suggestion.respondedBy': '回复者',
  'pages.cs.suggestion.close': '关闭',
  'pages.cs.suggestion.submit': '保存',
  'pages.cs.suggestion.cancel': '取消',
  'pages.cs.suggestion.form.status': '状态',
  'pages.cs.suggestion.form.statusRequired': '请选择状态',
  'pages.cs.suggestion.form.response': '回复内容',
  'pages.cs.suggestion.form.responseRequired': '请输入回复内容',
  'pages.cs.suggestion.form.responsePlaceholder': '输入要发送给用户的回复内容',

  // Suggestion Header Options
  'pages.cs.suggestion.header.shippingAgency': '配送代理',
  'pages.cs.suggestion.header.purchaseAgency': '购买代理',
  'pages.cs.suggestion.header.payment': '支付',
  'pages.cs.suggestion.header.deposit': '押金',
  'pages.cs.suggestion.header.etc': '其他',

  // CS - Email Template
  'pages.cs.emailTemplate.title': '邮件模板',
  'pages.cs.emailTemplate.addTitle': '添加邮件模板',
  'pages.cs.emailTemplate.editTitle': '编辑邮件模板',
  'pages.cs.emailTemplate.deleteConfirm': '删除邮件模板',
  'pages.cs.emailTemplate.deleteConfirmContent': '确定要删除邮件模板 "{name}" 吗？',
  'pages.cs.emailTemplate.deleteSuccess': '邮件模板已删除',
  'pages.cs.emailTemplate.updateSuccess': '邮件模板已更新',
  'pages.cs.emailTemplate.createSuccess': '邮件模板已创建',
  'pages.cs.emailTemplate.submitError': '保存邮件模板时出错',
  'pages.cs.emailTemplate.previewTitle': '邮件模板预览',
  'pages.cs.emailTemplate.column.name': '模板名称',
  'pages.cs.emailTemplate.column.subject': '主题',
  'pages.cs.emailTemplate.column.category': '类别',
  'pages.cs.emailTemplate.column.variables': '变量',
  'pages.cs.emailTemplate.column.isActive': '激活',
  'pages.cs.emailTemplate.category.notification': '通知',
  'pages.cs.emailTemplate.category.marketing': '营销',
  'pages.cs.emailTemplate.category.transactional': '交易',
  'pages.cs.emailTemplate.category.system': '系统',
  'pages.cs.emailTemplate.form.name': '模板名称',
  'pages.cs.emailTemplate.form.nameRequired': '请输入模板名称',
  'pages.cs.emailTemplate.form.category': '类别',
  'pages.cs.emailTemplate.form.categoryRequired': '请选择类别',
  'pages.cs.emailTemplate.form.subject': '主题',
  'pages.cs.emailTemplate.form.subjectRequired': '请输入主题',
  'pages.cs.emailTemplate.form.subjectPlaceholder': '输入邮件主题',
  'pages.cs.emailTemplate.form.content': '内容',
  'pages.cs.emailTemplate.form.contentRequired': '请输入内容',
  'pages.cs.emailTemplate.form.contentTooltip': '使用 {变量名} 格式的变量（例如：{userName}, {orderNo}）',
  'pages.cs.emailTemplate.form.contentPlaceholder': '输入邮件内容。使用 {变量名} 格式的变量',
  'pages.cs.emailTemplate.form.isActive': '激活',

  // CS - SMS Template
  'pages.cs.smsTemplate.title': '短信模板',
  'pages.cs.smsTemplate.addTitle': '添加短信模板',
  'pages.cs.smsTemplate.editTitle': '编辑短信模板',
  'pages.cs.smsTemplate.deleteConfirm': '删除短信模板',
  'pages.cs.smsTemplate.deleteConfirmContent': '确定要删除短信模板 "{name}" 吗？',
  'pages.cs.smsTemplate.deleteSuccess': '短信模板已删除',
  'pages.cs.smsTemplate.updateSuccess': '短信模板已更新',
  'pages.cs.smsTemplate.createSuccess': '短信模板已创建',
  'pages.cs.smsTemplate.submitError': '保存短信模板时出错',
  'pages.cs.smsTemplate.previewTitle': '短信模板预览',
  'pages.cs.smsTemplate.column.name': '模板名称',
  'pages.cs.smsTemplate.column.category': '类别',
  'pages.cs.smsTemplate.column.content': '内容',
  'pages.cs.smsTemplate.column.variables': '变量',
  'pages.cs.smsTemplate.column.isActive': '激活',
  'pages.cs.smsTemplate.category.notification': '通知',
  'pages.cs.smsTemplate.category.marketing': '营销',
  'pages.cs.smsTemplate.category.transactional': '交易',
  'pages.cs.smsTemplate.category.system': '系统',
  'pages.cs.smsTemplate.form.name': '模板名称',
  'pages.cs.smsTemplate.form.nameRequired': '请输入模板名称',
  'pages.cs.smsTemplate.form.category': '类别',
  'pages.cs.smsTemplate.form.categoryRequired': '请选择类别',
  'pages.cs.smsTemplate.form.content': '内容',
  'pages.cs.smsTemplate.form.contentRequired': '请输入内容',
  'pages.cs.smsTemplate.form.contentTooltip': '使用 {变量名} 格式的变量。最多90个字符',
  'pages.cs.smsTemplate.form.contentPlaceholder': '输入短信内容。使用 {变量名} 格式的变量',
  'pages.cs.smsTemplate.form.isActive': '激活',

  // CS - Email Log
  'pages.cs.emailLog.title': '邮件日志',
  'pages.cs.emailLog.detailTitle': '邮件日志详情',
  'pages.cs.emailLog.column.templateName': '模板名称',
  'pages.cs.emailLog.column.recipient': '收件人',
  'pages.cs.emailLog.column.subject': '主题',
  'pages.cs.emailLog.column.status': '状态',
  'pages.cs.emailLog.column.sentAt': '发送时间',
  'pages.cs.emailLog.column.errorMessage': '错误消息',
  'pages.cs.emailLog.status.sent': '已发送',
  'pages.cs.emailLog.status.failed': '发送失败',
  'pages.cs.emailLog.status.pending': '待处理',
  'pages.cs.emailLog.detail.templateName': '模板名称',
  'pages.cs.emailLog.detail.recipient': '收件人',
  'pages.cs.emailLog.detail.subject': '主题',
  'pages.cs.emailLog.detail.status': '状态',
  'pages.cs.emailLog.detail.sentAt': '发送时间',
  'pages.cs.emailLog.detail.failedAt': '失败时间',
  'pages.cs.emailLog.detail.errorMessage': '错误消息',
  'pages.cs.emailLog.detail.createdAt': '创建时间',

  // CS - Push Message
  'pages.cs.pushMessage.title': '推送消息',
  'pages.cs.pushMessage.addTitle': '添加推送消息',
  'pages.cs.pushMessage.editTitle': '编辑推送消息',
  'pages.cs.pushMessage.deleteConfirm': '删除推送消息',
  'pages.cs.pushMessage.deleteConfirmContent': '确定要删除推送消息 "{title}" 吗？',
  'pages.cs.pushMessage.deleteSuccess': '推送消息已删除',
  'pages.cs.pushMessage.updateSuccess': '推送消息已更新',
  'pages.cs.pushMessage.createSuccess': '推送消息已创建',
  'pages.cs.pushMessage.submitError': '保存推送消息时出错',
  'pages.cs.pushMessage.send': '发送',
  'pages.cs.pushMessage.sendSuccess': '推送消息已发送',
  'pages.cs.pushMessage.column.title': '标题',
  'pages.cs.pushMessage.column.content': '内容',
  'pages.cs.pushMessage.column.targetType': '目标',
  'pages.cs.pushMessage.column.sendType': '发送类型',
  'pages.cs.pushMessage.column.status': '状态',
  'pages.cs.pushMessage.column.sentCount': '发送数',
  'pages.cs.pushMessage.column.readCount': '阅读数',
  'pages.cs.pushMessage.column.scheduledAt': '计划时间',
  'pages.cs.pushMessage.targetType.all': '全部',
  'pages.cs.pushMessage.targetType.specific': '特定用户',
  'pages.cs.pushMessage.targetType.segment': '细分',
  'pages.cs.pushMessage.sendType.immediate': '立即',
  'pages.cs.pushMessage.sendType.scheduled': '计划',
  'pages.cs.pushMessage.status.draft': '草稿',
  'pages.cs.pushMessage.status.scheduled': '已计划',
  'pages.cs.pushMessage.status.sent': '已发送',
  'pages.cs.pushMessage.status.failed': '发送失败',
  'pages.cs.pushMessage.form.title': '标题',
  'pages.cs.pushMessage.form.titleRequired': '请输入标题',
  'pages.cs.pushMessage.form.content': '内容',
  'pages.cs.pushMessage.form.contentRequired': '请输入内容',
  'pages.cs.pushMessage.form.targetType': '目标',
  'pages.cs.pushMessage.form.targetTypeRequired': '请选择目标',
  'pages.cs.pushMessage.form.sendType': '发送类型',
  'pages.cs.pushMessage.form.sendTypeRequired': '请选择发送类型',
  'pages.cs.pushMessage.form.scheduledAt': '计划时间',
  'pages.cs.pushMessage.form.scheduledAtRequired': '请选择计划时间',
  'pages.cs.inquiries.stats.open': '打开',
  'pages.cs.inquiries.stats.closed': '关闭',
  'pages.cs.inquiries.stats.resolved': '已解决',
  'pages.cs.inquiries.user': '用户',
  'pages.cs.inquiries.subject': '标题',
  'pages.cs.inquiries.subjectEmpty': '(无标题)',
  'pages.cs.inquiries.assignedAdmin': '分配的管理员',
  'pages.cs.inquiries.unassigned': '未分配',
  
  // Inquiry Header Options
  'pages.cs.inquiries.header.shippingAgency': '配送代理',
  'pages.cs.inquiries.header.purchaseAgency': '购买代理',
  'pages.cs.inquiries.header.payment': '支付',
  'pages.cs.inquiries.header.deposit': '押金',
  'pages.cs.inquiries.header.etc': '其他',
  'pages.cs.inquiries.header.ttIdApplication': 'TT ID 申请',  
  'pages.cs.inquiries.status.unconfirmed': '未确认',
  'pages.cs.inquiries.status.in_progress': '处理中',
  'pages.cs.inquiries.status.confirmed': '已确认',
  'pages.cs.inquiries.status.open': '打开',
  'pages.cs.inquiries.status.resolved': '已解决',
  'pages.cs.inquiries.messageCount': '消息数',
  'pages.cs.inquiries.createdDate': '创建日期',
  'pages.cs.inquiries.lastMessage': '最后消息',
  'pages.cs.inquiries.viewChat': '查看对话',
  'pages.cs.inquiries.assign': '分配',
  'pages.cs.inquiries.listTitle': '1对1咨询列表',
  'pages.cs.inquiries.chatTitle': '1对1咨询对话',
  'pages.cs.inquiries.assignToMe': '分配给我',
  'pages.cs.inquiries.admin': '管理员',
  'pages.cs.inquiries.userLabel': '用户',
  'pages.cs.inquiries.noMessages': '没有消息。',
  'pages.cs.inquiries.messageRequired': '请输入消息',
  'pages.cs.inquiries.messagePlaceholder': '输入消息...',
  'pages.cs.inquiries.send': '发送',
  'pages.cs.inquiries.reopen': '重新打开',
  'pages.cs.inquiries.assignSuccess': '咨询已分配。',
  'pages.cs.inquiries.assignError': '分配咨询失败。',
  'pages.cs.inquiries.sendSuccess': '消息已发送。',
  'pages.cs.inquiries.sendError': '发送消息失败。',
  'pages.cs.inquiries.userLoadError': '加载用户信息失败。',
  'pages.cs.inquiries.attachFile': '附件文件',
  'pages.cs.inquiries.uploadError': '文件上传失败。',
  'pages.cs.inquiries.fileSizeLimit': '文件大小必须小于10MB。',
  'pages.cs.inquiries.closeSuccess': '咨询已关闭。',
  'pages.cs.inquiries.closeError': '关闭咨询失败。',
  'pages.cs.inquiries.processingButton': '处理中',
  'pages.cs.inquiries.confirmButton': '确认',
  'pages.cs.inquiries.processingStarted': '已开始处理。',
  'pages.cs.inquiries.confirmedSuccess': '已确认。',
  'pages.cs.inquiries.processingError': '开始处理失败。',
  'pages.cs.inquiries.confirmError': '确认失败。',
  'pages.cs.inquiries.attachmentPlaceholder': '[附件]',
  'pages.cs.inquiries.reopenSuccess': '咨询已重新打开。',
  'pages.cs.inquiries.category.general': '一般',
  'pages.cs.inquiries.category.support': '支持',
  'pages.cs.inquiries.category.complaint': '投诉',
  'pages.cs.inquiries.category.suggestion': '建议',
  'pages.cs.inquiries.category.technical': '技术',
  'pages.cs.inquiries.unreadMessages': '{count}条未读消息',
  'pages.cs.inquiries.messageRead': '已读',

  // Notices Page
  'pages.cs.notices.stats.total': '全部公告',
  'pages.cs.notices.stats.published': '已发布',
  'pages.cs.notices.stats.draft': '草稿',
  'pages.cs.notices.stats.hidden': '隐藏',
  'pages.cs.notices.list': '公告列表',
  'pages.cs.notices.add': '创建公告',
  'pages.cs.notices.export': '导出Excel',
  'pages.cs.notices.id': 'ID',
  'pages.cs.notices.title': '标题',
  'pages.cs.notices.category': '类别',
  'pages.cs.notices.category.general': '一般',
  'pages.cs.notices.category.important': '重要',
  'pages.cs.notices.category.event': '活动',
  'pages.cs.notices.category.maintenance': '维护',
  'pages.cs.notices.status': '状态',
  'pages.cs.notices.status.published': '已发布',
  'pages.cs.notices.status.draft': '草稿',
  'pages.cs.notices.status.hidden': '隐藏',
  'pages.cs.notices.priority': '优先级',
  'pages.cs.notices.priority.high': '高',
  'pages.cs.notices.priority.normal': '普通',
  'pages.cs.notices.priority.low': '低',
  'pages.cs.notices.views': '浏览量',
  'pages.cs.notices.author': '作者',
  'pages.cs.notices.createdAt': '创建日期',  
  'pages.cs.notices.create': '创建',
  'pages.cs.notices.actions': '操作',
  'pages.cs.notices.viewDetail': '详情',
  'pages.cs.notices.edit': '编辑',
  'pages.cs.notices.delete': '删除',
  'pages.cs.notices.deleteConfirm': '确定要删除吗？',
  'pages.cs.notices.detailTitle': '公告详情',
  'pages.cs.notices.content': '内容',
  'pages.cs.notices.updatedAt': '更新日期',
  'pages.cs.notices.publishAt': '发布日期',
  'pages.cs.notices.tags': '标签',
  'pages.cs.notices.editTitle': '编辑公告',
  'pages.cs.notices.createTitle': '创建公告',
  'pages.cs.notices.titlePlaceholder': '请输入公告标题',
  'pages.cs.notices.contentPlaceholder': '请输入公告内容',
  'pages.cs.notices.titleRequired': '请输入标题',
  'pages.cs.notices.contentRequired': '请输入内容',
  'pages.cs.notices.updateSuccess': '公告已更新',
  'pages.cs.notices.createSuccess': '公告已创建',
  'pages.cs.notices.deleteSuccess': '公告已删除',
  'pages.cs.notices.close': '关闭',
  'pages.cs.notices.cancel': '取消',
  'pages.cs.notices.broadcastCreated': '已创建新公告',
  'pages.cs.notices.broadcastDeleted': '公告已删除',
  'pages.cs.notices.deleteFailed': '删除失败',
  'pages.cs.notices.updateFailed': '更新失败',
  'pages.cs.notices.createFailed': '创建失败',
  'pages.cs.notices.loadFailed': '加载公告失败',
  'pages.cs.notices.number': '编号',
  'pages.cs.notices.fieldTitle': '标题',
  'pages.cs.notices.isHeader': '头部帖子',
  'pages.cs.notices.tab.all': '全部',
  'pages.cs.notices.exportSuccess': 'Excel导出成功',
  'pages.cs.notices.addTitle': '添加公告',
  'pages.cs.notices.addSuccess': '公告添加成功',
  'pages.cs.notices.addError': '添加公告失败',
  'pages.cs.notices.secret': '秘密帖子',
  'pages.cs.notices.selectCategory': '选择类别',
  'pages.cs.notices.attachments': '多个附件',
  'pages.cs.notices.attachmentInfo': '最多5个文件，每个5MB',
  'pages.cs.notices.loadError': '加载公告失败',
  'pages.cs.notices.deleteError': '删除公告失败',
  'pages.cs.notices.notFound': '未找到公告',
  'pages.cs.notices.submit': '提交',
  'pages.cs.notices.category.order': '订单',
  'pages.cs.notices.category.product': '商品',
  'pages.cs.notices.category.delivery': '配送',
  'pages.cs.notices.category.payment': '支付',
  'pages.cs.notices.category.etc': '其他',
  
  // Notices Header Options
  'pages.cs.notices.header.joinMembership': '加入会员',
  'pages.cs.notices.header.applyShippingAgency': '申请配送代理',
  'pages.cs.notices.header.combinedPackaging': '合并包装申请',
  'pages.cs.notices.header.overseasReturn': '海外退货申请',
  'pages.cs.notices.header.incomingOutgoingDelivery': '进出货和配送',
  'pages.cs.notices.header.serviceCost': '服务费用',
  'pages.cs.notices.header.customsClearance': '清关和关税/增值税',
  'pages.cs.notices.header.compensation': '赔偿',
  
  'pages.cs.notices.type': '类型',
  'pages.cs.notices.type.announcement': '公告',
  'pages.cs.notices.type.maintenance': '维护',
  'pages.cs.notices.type.update': '更新',
  'pages.cs.notices.type.warning': '警告',
  'pages.cs.notices.type.info': '信息',
  'pages.cs.notices.type.promotion': '促销',
  'pages.cs.notices.status.active': '活跃',
  'pages.cs.notices.status.inactive': '非活跃',
  'pages.cs.notices.priority.urgent': '紧急',
  'pages.cs.notices.targetAudience': '目标受众',
  'pages.cs.notices.targetAudience.all': '全部',
  'pages.cs.notices.targetAudience.users': '用户',
  'pages.cs.notices.targetAudience.admins': '管理员',
  'pages.cs.notices.stats.active': '活跃',
  'pages.cs.notices.stats.expired': '已过期',
  'pages.cs.notices.stats.announcement': '公告',
  'pages.cs.notices.expiresAt': '过期日期',
  'pages.cs.notices.expiresAtOptional': '过期日期（可选）',
  'pages.cs.notices.expiresAtPlaceholder': '选择过期日期',
  'pages.cs.notices.typePlaceholder': '选择类型',
  'pages.cs.notices.typeRequired': '请选择类型',
  'pages.cs.notices.contentPlaceholderFull': '请输入公告内容（最多5000字符）',
  'pages.cs.notices.contentMaxLength': '内容最多可输入5000字符',
  'pages.cs.notices.priorityPlaceholder': '选择优先级',
  'pages.cs.notices.priorityRequired': '请选择优先级',
  'pages.cs.notices.targetAudiencePlaceholder': '选择目标受众',
  'pages.cs.notices.targetAudienceRequired': '请选择目标受众',

  // Looking For Owner Page
  'pages.cs.lookingForOwner.stats.total': '全部帖子',
  'pages.cs.lookingForOwner.stats.active': '进行中',
  'pages.cs.lookingForOwner.stats.completed': '已完成',
  'pages.cs.lookingForOwner.stats.closed': '已关闭',
  'pages.cs.lookingForOwner.list': '寻找业主列表',
  'pages.cs.lookingForOwner.add': '创建帖子',
  'pages.cs.lookingForOwner.export': '导出Excel',
  'pages.cs.lookingForOwner.id': 'ID',
  'pages.cs.lookingForOwner.memberInfo': '会员信息',
  'pages.cs.lookingForOwner.title': '标题',
  'pages.cs.lookingForOwner.category': '类别',
  'pages.cs.lookingForOwner.category.lost': '丢失',
  'pages.cs.lookingForOwner.category.found': '拾获',
  'pages.cs.lookingForOwner.category.exchange': '交换',
  'pages.cs.lookingForOwner.status': '状态',
  'pages.cs.lookingForOwner.status.active': '进行中',
  'pages.cs.lookingForOwner.status.completed': '已完成',
  'pages.cs.lookingForOwner.status.closed': '已关闭',
  'pages.cs.lookingForOwner.location': '位置',
  'pages.cs.lookingForOwner.views': '浏览量',
  'pages.cs.lookingForOwner.replies': '回复数',
  'pages.cs.lookingForOwner.createdAt': '创建日期',
  'pages.cs.lookingForOwner.actions': '操作',
  'pages.cs.lookingForOwner.viewDetail': '详情',
  'pages.cs.lookingForOwner.edit': '编辑',
  'pages.cs.lookingForOwner.complete': '完成',
  'pages.cs.lookingForOwner.delete': '删除',
  'pages.cs.lookingForOwner.deleteConfirm': '确定要删除吗？',
  'pages.cs.lookingForOwner.detailTitle': '帖子详情',
  'pages.cs.lookingForOwner.memberName': '会员名',
  'pages.cs.lookingForOwner.memberId': '会员ID',
  'pages.cs.lookingForOwner.contact': '联系方式',
  'pages.cs.lookingForOwner.descriptionField': '内容',
  'pages.cs.lookingForOwner.updatedAt': '更新日期',
  'pages.cs.lookingForOwner.completedAt': '完成日期',
  'pages.cs.lookingForOwner.images': '图片',
  'pages.cs.lookingForOwner.editTitle': '编辑帖子',
  'pages.cs.lookingForOwner.createTitle': '创建帖子',
  'pages.cs.lookingForOwner.titlePlaceholder': '请输入帖子标题',
  'pages.cs.lookingForOwner.descriptionPlaceholder': '请输入帖子内容',
  'pages.cs.lookingForOwner.locationPlaceholder': '请输入位置',
  'pages.cs.lookingForOwner.contactPlaceholder': '请输入联系方式',
  'pages.cs.lookingForOwner.titleRequired': '请输入标题',
  'pages.cs.lookingForOwner.descriptionRequired': '请输入内容',
  'pages.cs.lookingForOwner.updateSuccess': '帖子已更新',
  'pages.cs.lookingForOwner.createSuccess': '帖子已创建',
  'pages.cs.lookingForOwner.deleteSuccess': '帖子已删除',
  'pages.cs.lookingForOwner.statusChangeSuccess': '状态已更改',
  'pages.cs.lookingForOwner.close': '关闭',
  'pages.cs.lookingForOwner.cancel': '取消',

  // Event Page
  'pages.cs.event.number': '编号',
  'pages.cs.event.fieldTitle': '标题',
  'pages.cs.event.author': '作者',
  'pages.cs.event.views': '浏览量',
  'pages.cs.event.createdAt': '注册日期',
  'pages.cs.event.isHeader': '头部帖子',
  'pages.cs.event.content': '内容',
  'pages.cs.event.export': '导出Excel',
  'pages.cs.event.exportSuccess': 'Excel导出成功',
  'pages.cs.event.tab.all': '全部',
  'pages.cs.event.addTitle': '添加活动',
  'pages.cs.event.addSuccess': '活动添加成功',
  'pages.cs.event.addError': '添加活动失败',
  'pages.cs.event.secret': '秘密帖子',
  'pages.cs.event.selectCategory': '选择类别',
  'pages.cs.event.category': '类别',
  'pages.cs.event.category.general': '一般',
  'pages.cs.event.category.order': '订单',
  'pages.cs.event.category.product': '商品',
  'pages.cs.event.category.delivery': '配送',
  'pages.cs.event.category.payment': '支付',
  'pages.cs.event.category.etc': '其他',
  
  // Event Header Options
  'pages.cs.event.header.joinMembership': '加入会员',
  'pages.cs.event.header.applyShippingAgency': '申请配送代理',
  'pages.cs.event.header.combinedPackaging': '合并包装申请',
  'pages.cs.event.header.overseasReturn': '海外退货申请',
  'pages.cs.event.header.incomingOutgoingDelivery': '进出货和配送',
  'pages.cs.event.header.serviceCost': '服务费用',
  'pages.cs.event.header.customsClearance': '清关和关税/增值税',
  'pages.cs.event.header.compensation': '赔偿',
  
  'pages.cs.event.contentPlaceholder': '请输入内容',
  'pages.cs.event.attachments': '多个附件',
  'pages.cs.event.attachmentInfo': '最多5个文件，每个5MB',
  'pages.cs.event.submit': '提交',
  'pages.cs.event.cancel': '取消',
  'pages.cs.event.detailTitle': '活动详情',
  'pages.cs.event.loadError': '加载活动失败',
  'pages.cs.event.deleteSuccess': '活动删除成功',
  'pages.cs.event.deleteError': '删除活动失败',
  'pages.cs.event.deleteConfirm': '确定要删除吗？',
  'pages.cs.event.notFound': '未找到活动',

  // Suggestion Page (Service Inquiry/Suggestion)
  'pages.cs.suggestion.number': '编号',
  'pages.cs.suggestion.fieldTitle': '标题',
  'pages.cs.suggestion.author': '作者',
  'pages.cs.suggestion.views': '浏览量',
  'pages.cs.suggestion.createdAt': '注册日期',
  'pages.cs.suggestion.status': '状态',
  'pages.cs.suggestion.isHeader': '头部帖子',
  'pages.cs.suggestion.content': '内容',
  'pages.cs.suggestion.export': '导出Excel',
  'pages.cs.suggestion.exportSuccess': 'Excel导出成功',
  'pages.cs.suggestion.tab.all': '全部',
  'pages.cs.suggestion.tab.inProgress': '咨询中',
  'pages.cs.suggestion.tab.answered': '已回答',
  'pages.cs.suggestion.tab.onHold': '回答保留',
  'pages.cs.suggestion.addTitle': '添加建议',
  'pages.cs.suggestion.addSuccess': '建议添加成功',
  'pages.cs.suggestion.addError': '添加建议失败',
  'pages.cs.suggestion.secret': '秘密帖子',
  'pages.cs.suggestion.selectCategory': '选择类别',
  'pages.cs.suggestion.category': '类别',
  'pages.cs.suggestion.category.general': '一般',
  'pages.cs.suggestion.category.order': '订单',
  'pages.cs.suggestion.category.product': '商品',
  'pages.cs.suggestion.category.delivery': '配送',
  'pages.cs.suggestion.category.payment': '支付',
  'pages.cs.suggestion.category.etc': '其他',
  'pages.cs.suggestion.contentPlaceholder': '请输入内容',
  'pages.cs.suggestion.attachments': '多个附件',
  'pages.cs.suggestion.attachmentInfo': '最多5个文件，每个5MB',
  'pages.cs.suggestion.loadError': '加载建议失败',
  'pages.cs.suggestion.deleteError': '删除建议失败',
  'pages.cs.suggestion.notFound': '未找到建议',
  'pages.cs.suggestion.replySection': '回复',
  'pages.cs.suggestion.replyRequired': '请输入回复内容',
  'pages.cs.suggestion.replySuccess': '回复发布成功',
  'pages.cs.suggestion.replyError': '发布回复失败',
  'pages.cs.suggestion.replyPlaceholder': '请输入回复内容',
  'pages.cs.suggestion.replyNote': '禁止发布列表、域名、密码等敏感信息',
  'pages.cs.suggestion.smsNotification': '短信通知',
  'pages.cs.suggestion.noNotification': '无通知',
  'pages.cs.suggestion.reply': '回复',

  // FAQ Page
  'pages.cs.faq.number': '编号',
  'pages.cs.faq.fieldTitle': '标题',
  'pages.cs.faq.author': '作者',
  'pages.cs.faq.views': '浏览量',
  'pages.cs.faq.createdAt': '注册日期',
  'pages.cs.faq.isHeader': '头部帖子',
  'pages.cs.faq.content': '内容',
  'pages.cs.faq.export': '导出Excel',
  'pages.cs.faq.exportSuccess': 'Excel导出成功',
  'pages.cs.faq.tab.all': '全部',
  'pages.cs.faq.addTitle': '添加FAQ',
  'pages.cs.faq.addSuccess': 'FAQ添加成功',
  'pages.cs.faq.addError': '添加FAQ失败',
  'pages.cs.faq.secret': '秘密帖子',
  'pages.cs.faq.selectCategory': '选择类别',
  'pages.cs.faq.category': '类别',
  'pages.cs.faq.category.general': '一般',
  'pages.cs.faq.category.order': '订单',
  'pages.cs.faq.category.product': '商品',
  'pages.cs.faq.category.delivery': '配送',
  'pages.cs.faq.category.payment': '支付',
  'pages.cs.faq.category.etc': '其他',
  'pages.cs.faq.contentPlaceholder': '请输入内容',
  'pages.cs.faq.attachments': '多个附件',
  'pages.cs.faq.attachmentInfo': '最多5个文件，每个5MB',
  'pages.cs.faq.submit': '提交',
  'pages.cs.faq.cancel': '取消',
  
  // FAQ Header Options
  'pages.cs.faq.header.joinMembership': '加入会员',
  'pages.cs.faq.header.applyShippingAgency': '申请配送代理',
  'pages.cs.faq.header.combinedPackaging': '合并包装申请',
  'pages.cs.faq.header.overseasReturn': '海外退货申请',
  'pages.cs.faq.header.incomingOutgoingDelivery': '进出货和配送',
  'pages.cs.faq.header.serviceCost': '服务费用',
  'pages.cs.faq.header.customsClearance': '清关和关税/增值税',
  'pages.cs.faq.header.compensation': '赔偿',
  
  'pages.cs.faq.detailTitle': 'FAQ详情',
  'pages.cs.faq.loadError': '加载FAQ失败',
  'pages.cs.faq.deleteSuccess': 'FAQ删除成功',
  'pages.cs.faq.deleteError': '删除FAQ失败',
  'pages.cs.faq.deleteConfirm': '确定要删除吗？',
  'pages.cs.faq.notFound': '未找到FAQ',

  // Reviews Page
  'pages.cs.reviews.number': '编号',
  'pages.cs.reviews.fieldTitle': '标题',
  'pages.cs.reviews.author': '作者',
  'pages.cs.reviews.views': '浏览量',
  'pages.cs.reviews.createdAt': '注册日期',
  'pages.cs.reviews.isHeader': '头部帖子',
  'pages.cs.reviews.content': '内容',
  'pages.cs.reviews.export': '导出Excel',
  'pages.cs.reviews.exportSuccess': 'Excel导出成功',
  'pages.cs.reviews.tab.all': '全部',
  'pages.cs.reviews.addTitle': '添加评论',
  'pages.cs.reviews.addSuccess': '评论添加成功',
  'pages.cs.reviews.addError': '添加评论失败',
  'pages.cs.reviews.secret': '秘密帖子',
  'pages.cs.reviews.selectCategory': '选择类别',
  'pages.cs.reviews.category': '类别',
  'pages.cs.reviews.category.general': '一般',
  'pages.cs.reviews.category.order': '订单',
  'pages.cs.reviews.category.product': '商品',
  'pages.cs.reviews.category.delivery': '配送',
  'pages.cs.reviews.category.payment': '支付',
  'pages.cs.reviews.category.etc': '其他',
  
  // Reviews Header Options
  'pages.cs.reviews.header.joinMembership': '加入会员',
  'pages.cs.reviews.header.applyShippingAgency': '申请配送代理',
  'pages.cs.reviews.header.combinedPackaging': '合并包装申请',
  'pages.cs.reviews.header.overseasReturn': '海外退货申请',
  'pages.cs.reviews.header.incomingOutgoingDelivery': '进出货和配送',
  'pages.cs.reviews.header.serviceCost': '服务费用',
  'pages.cs.reviews.header.customsClearance': '清关和关税/增值税',
  'pages.cs.reviews.header.compensation': '赔偿',
  
  'pages.cs.reviews.contentPlaceholder': '请输入内容',
  'pages.cs.reviews.attachments': '多个附件',
  'pages.cs.reviews.attachmentInfo': '最多5个文件，每个5MB',
  'pages.cs.reviews.submit': '提交',
  'pages.cs.reviews.cancel': '取消',
  'pages.cs.reviews.detailTitle': '评论详情',
  'pages.cs.reviews.loadError': '加载评论失败',
  'pages.cs.reviews.deleteSuccess': '评论删除成功',
  'pages.cs.reviews.deleteError': '删除评论失败',
  'pages.cs.reviews.deleteConfirm': '确定要删除吗？',
  'pages.cs.reviews.notFound': '未找到评论',

  // Looking for Owner Page
  'pages.cs.looking-for-owner.number': '编号',
  'pages.cs.looking-for-owner.fieldTitle': '标题',
  'pages.cs.looking-for-owner.author': '作者',
  'pages.cs.looking-for-owner.views': '浏览量',
  'pages.cs.looking-for-owner.createdAt': '注册日期',
  'pages.cs.looking-for-owner.isHeader': '头部帖子',
  'pages.cs.looking-for-owner.content': '内容',
  'pages.cs.looking-for-owner.export': '导出Excel',
  'pages.cs.looking-for-owner.exportSuccess': 'Excel导出成功',
  'pages.cs.looking-for-owner.tab.all': '全部',
  'pages.cs.looking-for-owner.addTitle': '添加寻找主人',
  'pages.cs.looking-for-owner.addSuccess': '寻找主人添加成功',
  'pages.cs.looking-for-owner.addError': '添加寻找主人失败',
  'pages.cs.looking-for-owner.secret': '秘密帖子',
  'pages.cs.looking-for-owner.selectCategory': '选择类别',
  'pages.cs.looking-for-owner.category': '类别',
  'pages.cs.looking-for-owner.category.general': '一般',
  'pages.cs.looking-for-owner.category.order': '订单',
  'pages.cs.looking-for-owner.category.product': '商品',
  'pages.cs.looking-for-owner.category.delivery': '配送',
  'pages.cs.looking-for-owner.category.payment': '支付',
  'pages.cs.looking-for-owner.category.etc': '其他',
  
  // Looking for Owner Header Options
  'pages.cs.looking-for-owner.header.joinMembership': '加入会员',
  'pages.cs.looking-for-owner.header.applyShippingAgency': '申请配送代理',
  'pages.cs.looking-for-owner.header.combinedPackaging': '合并包装申请',
  'pages.cs.looking-for-owner.header.overseasReturn': '海外退货申请',
  'pages.cs.looking-for-owner.header.incomingOutgoingDelivery': '进出货和配送',
  'pages.cs.looking-for-owner.header.serviceCost': '服务费用',
  'pages.cs.looking-for-owner.header.customsClearance': '清关和关税/增值税',
  'pages.cs.looking-for-owner.header.compensation': '赔偿',
  
  'pages.cs.looking-for-owner.contentPlaceholder': '请输入内容',
  'pages.cs.looking-for-owner.attachments': '多个附件',
  'pages.cs.looking-for-owner.attachmentInfo': '最多5个文件，每个5MB',
  'pages.cs.looking-for-owner.submit': '提交',
  'pages.cs.looking-for-owner.cancel': '取消',
  'pages.cs.looking-for-owner.detailTitle': '寻找主人详情',
  'pages.cs.looking-for-owner.loadError': '加载寻找主人失败',
  'pages.cs.looking-for-owner.deleteSuccess': '寻找主人删除成功',
  'pages.cs.looking-for-owner.deleteError': '删除寻找主人失败',
  'pages.cs.looking-for-owner.deleteConfirm': '确定要删除吗？',
  'pages.cs.looking-for-owner.notFound': '未找到寻找主人',

  // In Transit (배송중) Pages
  'pages.orders.inKoreaDelivery.title': '配送中',
  'pages.orders.inKoreaDelivery.breadcrumb': '订单管理',
  'pages.orders.inKoreaDelivery.description': '国内配送中的订单',
  'pages.orders.inKoreaDelivery.subDescription': '查看和管理韩国境内正在配送的订单',
  'pages.orders.inKoreaDelivery.generalMember': '普通会员',
  'pages.orders.inKoreaDelivery.businessMember': '企业会员',
  'pages.orders.inKoreaDelivery.shipped': '已发货',
  'pages.orders.inKoreaDelivery.delivering': '配送中',
  'pages.orders.inKoreaDelivery.delayed': '配送延迟',
  'pages.orders.inKoreaDelivery.clearFilter': '清除筛选',
  'pages.orders.inKoreaDelivery.courier': '快递公司',
  'pages.orders.inKoreaDelivery.allCouriers': '全部',
  'pages.orders.inKoreaDelivery.cj': 'CJ大韩通运',
  'pages.orders.inKoreaDelivery.hanjin': '韩进快递',
  'pages.orders.inKoreaDelivery.lotte': '乐天快递',
  'pages.orders.inKoreaDelivery.shipDate': '发货日期',
  'pages.orders.inKoreaDelivery.deliveryDate': '配送完成日期',

  // Completed (배송완료) Pages
  'pages.orders.completed.title': '配送完成',
  'pages.orders.completed.breadcrumb': '订单管理',
  'pages.orders.completed.description': '已完成的订单',
  'pages.orders.completed.subDescription': '查看已完成订单的统计信息',
  'pages.orders.completed.completedDate': '完成日期',

  // No Data (노데이타) Pages
  'pages.orders.noData.title': '无数据',
  'pages.orders.noData.breadcrumb': '订单管理',
  'pages.orders.noData.description': '订单匹配管理',
  'pages.orders.noData.subDescription': '查看和处理未匹配的订单（普通/企业会员）',
  'pages.orders.noData.management': '无数据管理',

  // Order Inquiries (주문문의) Pages
  'pages.orders.orderQuestions.title': '订单咨询',
  'pages.orders.orderQuestions.breadcrumb': '订单管理',
  'pages.orders.orderQuestions.description': '订单咨询管理',
  'pages.orders.orderQuestions.subDescription': '查看和回复客户关于订单的咨询',
  'pages.orders.orderQuestions.orderNo': '订单号',
  'pages.orders.orderQuestions.memberNameId': '收件人名 / 邮箱',
  'pages.orders.orderQuestions.memberManager': '会员负责人',
  'pages.orders.orderQuestions.content': '内容',
  'pages.orders.orderQuestions.writer': '会员名',
  'pages.orders.orderQuestions.status': '状态',
  'pages.orders.orderQuestions.processingStatus': '处理状态',
  'pages.orders.orderQuestions.statusUnread': '未确认',
  'pages.orders.orderQuestions.statusRead': '处理中',
  'pages.orders.orderQuestions.statusProcessed': '确认完成',
  'pages.orders.orderQuestions.statusAll': '全部',
  'pages.orders.orderQuestions.searchByUserUniqueId': '用户唯一ID',
  'pages.orders.orderQuestions.answered': '已回复',
  'pages.orders.orderQuestions.unanswered': '未回复',
  'pages.orders.orderQuestions.answeredStatus': '回复状态',
  'pages.orders.orderQuestions.registeredDate': '注册日期 / 最后消息时间',
  'pages.orders.orderQuestions.answerer': '回复人',
  'pages.orders.orderQuestions.delete': '删除',
  'pages.orders.orderQuestions.all': '全部',
  'pages.orders.orderQuestions.searchBy': '搜索条件',
  'pages.orders.orderQuestions.searchByContent': '内容',
  'pages.orders.orderQuestions.searchByOrderNo': '订单号',
  'pages.orders.orderQuestions.searchByMemberName': '会员名',
  'pages.orders.orderQuestions.searchPlaceholder': '请输入搜索关键词',
  'pages.orders.orderQuestions.search': '搜索',
  'pages.orders.orderQuestions.category': '订单咨询',
  'pages.orders.orderQuestions.answerSubmitted': '答案已提交',
  'pages.orders.orderQuestions.messageCount': '{count} 条消息',
  'pages.orders.orderQuestions.messages': '消息',
  'pages.orders.orderQuestions.orderNoWithMessages': '订单号: {orderNumber} ({count} 条消息)',
  'pages.orders.orderQuestions.unreadMessages': '{count} 条未读消息',
  'pages.orders.orderQuestions.totalItems': '共 {total} 项',
  'pages.orders.orderQuestions.member': '会员',
  'pages.orders.orderQuestions.confirmDelete': '删除咨询',
  'pages.orders.orderQuestions.confirmDeleteDescription': '确定要删除此咨询吗？此操作无法撤销。',
  'pages.orders.orderQuestions.deleteSuccess': '咨询已成功删除',
  'pages.orders.orderQuestions.deleteError': '删除咨询失败',
  'pages.orders.orderQuestions.cancel': '取消',
  'pages.orders.orderQuestions.processingButton': '处理中',
  'pages.orders.orderQuestions.confirmButton': '确认完成',
  'pages.orders.orderQuestions.processingStarted': '已开始处理',
  'pages.orders.orderQuestions.processingError': '开始处理失败',
  'pages.orders.orderQuestions.confirmed': '咨询已确认完成',
  'pages.orders.orderQuestions.confirmError': '确认咨询失败',
  'questionModal.edit': '编辑',
  'questionModal.delete': '删除',
  'questionModal.messageDeleted': '消息已删除',
  'questionModal.messageDeleteFailed': '删除消息失败',
  'questionModal.messageUpdated': '消息已更新',
  'questionModal.messageUpdateFailed': '更新消息失败',
  'questionModal.editMessagePrompt': '编辑消息',
  'questionModal.deleteConfirmTitle': '删除消息',
  'questionModal.deleteConfirmContent': '确定要删除这条消息吗？',
  'questionModal.cancel': '取消',
  'questionModal.editingMessage': '正在编辑…',
  'questionModal.cancelEdit': '取消编辑',

  'pages.orders.userRefund.title': '用户退款申请',
  'pages.orders.userRefund.orderInfo': '订单信息',
  'pages.orders.userRefund.priceBreakdown': '价格明细',
  'pages.orders.userRefund.productPrice': '商品价格',
  'pages.orders.userRefund.chinaShipping': '中国运输',
  'pages.orders.userRefund.serviceFee': '服务费',
  'pages.orders.userRefund.addOnServices': '附加服务',
  'pages.orders.userRefund.selectRefundItems': '选择退款商品:',
  'pages.orders.userRefund.refundItems': '退款商品:',
  'pages.orders.userRefund.alwaysRefunded': '(始终退款)',
  'pages.orders.userRefund.refundSummary': '退款摘要',
  'pages.orders.userRefund.productPriceRefund': '商品价格退款',
  'pages.orders.userRefund.chinaShippingRefund': '中国运输退款',
  'pages.orders.userRefund.serviceFeeRefund': '服务费退款',
  'pages.orders.userRefund.totalRefund': '总退款',

  'pages.orders.platformRefund.title': '平台退款申请',
  'pages.orders.platformRefund.orderInfo': '订单信息',
  'pages.orders.platformRefund.priceBreakdown': '价格明细',
  'pages.orders.platformRefund.productPrice': '商品价格',
  'pages.orders.platformRefund.chinaShipping': '中国运输',
  'pages.orders.platformRefund.serviceFee': '服务费',
  'pages.orders.platformRefund.addOnServices': '附加服务',
  'pages.orders.platformRefund.selectRefundItems': '选择退款商品:',
  'pages.orders.platformRefund.refundItems': '退款商品:',
  'pages.orders.platformRefund.alwaysRefunded': '(始终退款)',
  'pages.orders.platformRefund.refundSummary': '退款摘要',
  'pages.orders.platformRefund.productPriceRefund': '商品价格退款',
  'pages.orders.platformRefund.serviceFeeRefund': '服务费退款',
  'pages.orders.platformRefund.chinaShippingRefund': '中国运输退款',
  'pages.orders.platformRefund.totalRefund': '总退款',
  'pages.orders.alreadyRefundedExternally.checkbox': '已在系统外退款（不取消支付、不退回押金）',
  'pages.orders.alreadyRefundedExternally.alertTitle': '不会取消支付，也不会退回押金',
  'pages.orders.alreadyRefundedExternally.alertDescription': '仅用于已通过银行汇款或PG管理后台给客户退款的订单。系统不会调用信用卡取消支付；无存折汇款和押金支付的订单也不会退回押金（仅与信用卡或无存折汇款一起使用的押金部分会退回押金）。只会进行退款记录、返利扣回、库存恢复和状态变更。如需像平时一样将无存折汇款订单退款到押金，请不要勾选此项。',

  'pages.orders.finalRefund.title': '最终退款申请',
  'pages.orders.finalRefund.orderInfo': '订单信息',
  'pages.orders.finalRefund.priceBreakdown': '价格明细',
  'pages.orders.finalRefund.paymentType': '支付类型',
  'pages.orders.finalRefund.paidPrice': '已付价格',
  'pages.orders.finalRefund.refundPrice': '退款价格',
  'pages.orders.finalRefund.ratio': '比例 (%)',
  'pages.orders.finalRefund.productPrice': '价格',
  'pages.orders.finalRefund.chinaShipping': '中国运输价格',
  'pages.orders.finalRefund.additionalInternational': '额外国际运输',
  'pages.orders.finalRefund.secondTierAddOnServices': '二级附加服务',
  'pages.orders.finalRefund.serviceFee': '服务费',
  'pages.orders.finalRefund.addOnServices': '附加服务',
  'pages.orders.finalRefund.totalRefund': '总退款',
  'pages.orders.finalRefund.refundExceedsPaid': '退款价格不能超过已付价格',
  'pages.orders.finalRefund.firstTierPayment': '一次支付',
  'pages.orders.finalRefund.secondTierPayment': '二次支付',
  'pages.orders.finalRefund.bundleOrder': '合包订单 (H01)',
  'pages.orders.finalRefund.bundleOrderHint': '请按原始父订单分别设置一次商品金额和服务费退款。',
  'pages.orders.finalRefund.noAmountSelected': '请至少输入一项退款金额。',
  'pages.orders.finalRefund.noRefundableItems': '该订单没有可退款项。',
  'pages.orders.finalRefund.grandTotal': '退款合计',
  'pages.orders.finalRefund.executeSuccess': '最终退款已执行。',
  'pages.orders.refundPayout.failedTitle': '退款未退还给客户',
  'pages.orders.refundPayout.failedBody': '支付网关拒绝了取消请求，退款仍处于待支付状态。请勿将状态改为完成，解决原因后重新执行退款。如已在支付网关后台手动取消，请以【已在外部退款】记录。',
  'pages.orders.refundPayout.gatewayReason': '支付网关响应',
  'pages.orders.common.exchangeRate': '汇率',

  // Inventory Inquiries (재고문의) Pages
  'pages.orders.inventoryQuestions.title': '库存咨询',
  'pages.orders.inventoryQuestions.breadcrumb': '订单管理',
  'pages.orders.inventoryQuestions.description': '库存咨询管理',
  'pages.orders.inventoryQuestions.subDescription': '确认库存并回复咨询',
  'pages.orders.inventoryQuestions.orderNo': '订单号',
  'pages.orders.inventoryQuestions.memberNameId': '会员名/ID',
  'pages.orders.inventoryQuestions.memberManager': '会员负责人',
  'pages.orders.inventoryQuestions.content': '内容',
  'pages.orders.inventoryQuestions.writer': '撰写人',
  'pages.orders.inventoryQuestions.status': '状态',
  'pages.orders.inventoryQuestions.answered': '已回复',
  'pages.orders.inventoryQuestions.unanswered': '未回复',
  'pages.orders.inventoryQuestions.registeredDate': '注册日期',
  'pages.orders.inventoryQuestions.answerer': '回复人',
  'pages.orders.inventoryQuestions.delete': '删除',
  'pages.orders.inventoryQuestions.all': '全部',
  'pages.orders.inventoryQuestions.searchBy': '搜索条件',
  'pages.orders.inventoryQuestions.searchByContent': '内容',
  'pages.orders.inventoryQuestions.searchByOrderNo': '订单号',
  'pages.orders.inventoryQuestions.searchByMemberName': '会员名',
  'pages.orders.inventoryQuestions.searchPlaceholder': '请输入搜索关键词',
  'pages.orders.inventoryQuestions.search': '搜索',
  'pages.orders.inventoryQuestions.category': '库存咨询',
  'pages.orders.inventoryQuestions.mock.name1': '张三',
  'pages.orders.inventoryQuestions.mock.name2': '李四',
  'pages.orders.inventoryQuestions.mock.name3': '王五',
  'pages.orders.inventoryQuestions.mock.question1': '订购的产品库存（板）何时到达？W823,077',
  'pages.orders.inventoryQuestions.mock.answer1': '根据库存检查，预计11月25日到货。',
  'pages.orders.inventoryQuestions.mock.question2': '请检查库存。',
  'pages.orders.inventoryQuestions.mock.question3': '产品预计何时到货？请尽快回复。',
  'pages.orders.inventoryQuestions.mock.answer3': '该产品预计11月30日到货。',

  // Additional keys for Completed and NoData pages
  'pages.orders.completed.reviewWritten': '已写评论',
  'pages.orders.completed.noReview': '未写评论',
  'pages.orders.completed.orderNo': '订单号',
  'pages.orders.completed.memberName': '会员名',
  'pages.orders.completed.memberType': '类型',
  'pages.orders.completed.receiver': '收件人',
  'pages.orders.completed.contact': '联系方式',
  'pages.orders.completed.address': '配送地址',
  'pages.orders.completed.trackingNo': '运单号',
  'pages.orders.completed.orderAmount': '订单金额',
  'pages.orders.completed.shippingFee': '配送费',
  'pages.orders.completed.deliveryDays': '配送天数',
  'pages.orders.completed.review': '评论',
  'pages.orders.completed.rating': '评分',
  'pages.orders.completed.reviewCompleted': '已完成',
  'pages.orders.completed.actions': '操作',
  'pages.orders.completed.viewDetails': '查看详情',
  'pages.orders.completed.requestReview': '请求评论',
  'pages.orders.completed.batchRequestReview': '批量请求已选 {count} 项评论',
  'pages.orders.completed.excelDownload': 'Excel下载',
  'pages.orders.completed.more': '更多 ▼',
  'pages.orders.completed.collapse': '收起 ▲',
  'pages.orders.completed.reset': '重置',
  'pages.orders.completed.search': '搜索',
  'pages.orders.completed.total': '共 {total} 项',
  'pages.orders.completed.reviewStatus': '评论状态',
  'pages.orders.completed.all': '全部',
  'pages.orders.completed.reviewed': '已评论',
  'pages.orders.completed.noReviewStatus': '未评论',
  'pages.orders.completed.viewAll': '查看全部',
  'pages.orders.completed.general': '普通',
  'pages.orders.completed.business': '企业',
  'pages.orders.noData.unmatched': '未匹配',
  'pages.orders.noData.matched': '匹配完成',
  'pages.orders.noData.unlinked': '匹配解除',
  'pages.orders.noData.applicationType': '申请类型',
  'pages.orders.noData.all': '全部',
  'pages.orders.noData.delivery': '配送代理',
  'pages.orders.noData.purchase': '购买代理',
  'pages.orders.noData.registrationDate': '注册日期',
  'pages.orders.noData.matchStatus': '匹配状态',
  'pages.orders.noData.product': '产品',
  'pages.orders.noData.image': '图片',
  'pages.orders.noData.center': '中心',
  'pages.orders.noData.mailbox': '邮箱',
  'pages.orders.noData.mailboxNo': '邮箱号',
  'pages.orders.noData.productName': '产品名称',
  'pages.orders.noData.quantity': '数量',
  'pages.orders.noData.codFee': '货到付款费',
  'pages.orders.noData.weight': '重量',
  'pages.orders.noData.wearer': '穿戴者',
  'pages.orders.noData.orderNo': '订单号',
  'pages.orders.noData.orderNumber': '订单号',
  'pages.orders.noData.registrationDateCol': '注册日期',
  'pages.orders.noData.rackNo': '货架号',
  'pages.orders.noData.rackNumber': '货架号',
  'pages.orders.noData.issue': '问题',
  'pages.orders.noData.issueNoOrderInfo': '无订单信息',
  'pages.orders.noData.result': '结果',
  'pages.orders.noData.actions': '操作',
  'pages.orders.noData.match': '匹配',
  'pages.orders.noData.unlink': '解除匹配',
  'pages.orders.noData.enterTrackingNumber': '输入运单号',
  'pages.orders.noData.trackingNumberRequired': '请输入运单号',
  'pages.orders.noData.trackingNumberSaved': '运单号保存成功',
  'pages.orders.noData.saveError': '保存运单号失败',
  'pages.orders.noData.save': '保存',
  'pages.orders.noData.return': '返回',
  'pages.orders.noData.returnFunctionality': '返回功能待实现',
  'pages.orders.noData.recordIdRequired': '需要记录ID',
  'pages.orders.noData.returnedSuccess': '状态已成功更新为已返回',
  'pages.orders.noData.returnError': '更新状态为已返回失败',
  'pages.orders.noData.batchMatch': '批量匹配已选 {count} 项',
  'pages.orders.noData.excelDownload': 'Excel下载',
  'pages.orders.noData.more': '更多 ▼',
  'pages.orders.noData.collapse': '收起 ▲',
  'pages.orders.noData.reset': '重置',
  'pages.orders.noData.search': '搜索',
  'pages.orders.noData.total': '共 {total} 项',
  'pages.orders.noData.refresh': '刷新',
  'pages.orders.noData.viewAll': '查看全部',
  'pages.orders.noData.previewImage': '预览',
  'pages.orders.noData.general': '普通',
  'pages.orders.noData.business': '企业',
  'pages.orders.noData.memberName': '会员名',
  'pages.orders.noData.trackingNo': '运单号',
  // 'pages.orders.inKoreaDelivery.shipped': '已发货',
  'pages.orders.inKoreaDelivery.viewAll': '查看全部',
  'pages.orders.inKoreaDelivery.trackDelivery': '配送查询',
  'pages.orders.inKoreaDelivery.viewDetails': '查看详情',
  'pages.orders.inKoreaDelivery.deliveryStatus': '配送状态',
  'pages.orders.inKoreaDelivery.shippedDate': '发货日期',
  'pages.orders.inKoreaDelivery.estimatedArrival': '预计到达',
  'pages.orders.inKoreaDelivery.receiver': '收件人',
  'pages.orders.inKoreaDelivery.address': '配送地址',
  'pages.orders.inKoreaDelivery.courierTracking': '快递公司/运单号',
  'pages.orders.inKoreaDelivery.orderNo': '订单号',
  'pages.orders.inKoreaDelivery.memberName': '会员名',
  'pages.orders.inKoreaDelivery.memberType': '类型',
  'pages.orders.inKoreaDelivery.contact': '联系方式',
  'pages.orders.inKoreaDelivery.trackingNo': '运单号',
  'pages.orders.inKoreaDelivery.actions': '操作',
  'pages.orders.inKoreaDelivery.batchTrack': '批量查询已选 {count} 项',
  'pages.orders.inKoreaDelivery.excelDownload': 'Excel下载',
  'pages.orders.inKoreaDelivery.more': '更多 ▼',
  'pages.orders.inKoreaDelivery.collapse': '收起 ▲',
  'pages.orders.inKoreaDelivery.reset': '重置',
  'pages.orders.inKoreaDelivery.search': '搜索',
  'pages.orders.inKoreaDelivery.total': '共 {total} 项',
  'pages.orders.inKoreaDelivery.general': '普通',
  'pages.orders.inKoreaDelivery.business': '企业',

  // Coupons Page
  'pages.members.coupons.title': '优惠券管理',
  'pages.members.coupons.couponList': '优惠券列表',
  'pages.members.coupons.usageHistory': '发放/使用记录',
  'pages.members.coupons.totalCoupons': '总优惠券',
  'pages.members.coupons.activeCoupons': '活跃优惠券',
  'pages.members.coupons.issuedCoupons': '已发放优惠券',
  'pages.members.coupons.usedCoupons': '已使用优惠券',
  'pages.members.coupons.id': 'ID',
  'pages.members.coupons.couponName': '优惠券名称',
  'pages.members.coupons.couponCode': '优惠券代码',
  'pages.members.coupons.discountType': '折扣类型',
  'pages.members.coupons.discountTypeFixed': '固定金额',
  'pages.members.coupons.discountTypePercent': '百分比',
  'pages.members.coupons.discountAmount': '折扣金额',
  'pages.members.coupons.minOrderAmount': '最低订单金额',
  'pages.members.coupons.usageStatus': '使用状态',
  'pages.members.coupons.usagePercent': '% 已使用',
  'pages.members.coupons.validPeriod': '有效期',
  'pages.members.coupons.status': '状态',
  'pages.members.coupons.statusActive': '活跃',
  'pages.members.coupons.statusInactive': '非活跃',
  'pages.members.coupons.statusExpired': '已过期',
  'pages.members.coupons.createdAt': '创建日期',
  'pages.members.coupons.actions': '操作',
  'pages.members.coupons.issue': '发放',
  'pages.members.coupons.edit': '编辑',
  'pages.members.coupons.delete': '删除',
  'pages.members.coupons.memberInfo': '会员信息',
  'pages.members.coupons.orderNo': '订单号',
  'pages.members.coupons.usedAt': '使用时间',
  'pages.members.coupons.statusUsed': '已使用',
  'pages.members.coupons.statusUnused': '未使用',
  'pages.members.coupons.excelDownload': 'Excel下载',
  'pages.members.coupons.createCoupon': '创建优惠券',
  'pages.members.coupons.deleteConfirm': '删除优惠券',
  'pages.members.coupons.deleteContent': '确定要删除优惠券 "{name}" 吗？',
  'pages.members.coupons.deleted': '优惠券已删除',
  'pages.members.coupons.updated': '优惠券已更新',
  'pages.members.coupons.created': '优惠券已创建',
  'pages.members.coupons.issued': '优惠券已发放',
  'pages.members.coupons.issuedSuccess': '优惠券发放成功。已发放: {issued}, 已跳过: {skipped}',
  'pages.members.coupons.issueFailed': '优惠券发放失败',
  'pages.members.coupons.modalEdit': '编辑优惠券',
  'pages.members.coupons.modalCreate': '创建优惠券',
  'pages.members.coupons.nameLabel': '优惠券名称',
  'pages.members.coupons.nameRequired': '请输入优惠券名称',
  'pages.members.coupons.namePlaceholder': '例如：新会员欢迎优惠券',
  'pages.members.coupons.codeLabel': '优惠券代码',
  'pages.members.coupons.codeRequired': '请输入优惠券代码',
  'pages.members.coupons.codePlaceholder': '例如：WELCOME2025',
  'pages.members.coupons.typeLabel': '折扣类型',
  'pages.members.coupons.typeFixed': '固定金额折扣',
  'pages.members.coupons.typePercent': '百分比折扣 (%)',
  'pages.members.coupons.discountValueLabel': '折扣金额/比率',
  'pages.members.coupons.minOrderAmountLabel': '最低订单金额',
  'pages.members.coupons.maxDiscountAmountLabel': '最大折扣金额（可选）',
  'pages.members.coupons.validPeriodLabel': '有效期',
  'pages.members.coupons.validPeriodRequired': '请选择有效期',
  'pages.members.coupons.totalCountLabel': '发放数量',
  'pages.members.coupons.descriptionLabel': '优惠券说明',
  'pages.members.coupons.descriptionPlaceholder': '请输入优惠券说明',
  'pages.members.coupons.statusLabel': '状态',
  'pages.members.coupons.statusActiveText': '活跃',
  'pages.members.coupons.statusInactiveText': '非活跃',
  'pages.members.coupons.issueModalTitle': '发放优惠券 - {name}',
  'pages.members.coupons.targetTypeLabel': '发放对象',
  'pages.members.coupons.targetTypeAll': '全体会员',
  'pages.members.coupons.targetTypeLevel': '按等级',
  'pages.members.coupons.memberLevelLabel': '会员等级',
  'pages.members.coupons.targetTypeSpecific': '特定会员',
  'pages.members.coupons.memberIdsLabel': '选择会员',
  'pages.members.coupons.memberIdsRequired': '请至少选择一位会员',
  'pages.members.coupons.memberIdsPlaceholder': '通过邮箱或电话搜索并选择会员',
  'pages.members.coupons.messageLabel': '发送消息（可选）',
  'pages.members.coupons.messagePlaceholder': '发放优惠券时发送的消息',
  'pages.members.coupons.currency': '元',
  'pages.members.coupons.unit': '个',
  'pages.members.coupons.couponIdLabel': '优惠券ID',
  'pages.members.coupons.couponIdTooltip': '每个优惠券集都会生成唯一ID',
  'pages.members.coupons.couponIdPlaceholder': '自动生成（例如：COUPON_SET_000001）',
  'pages.members.coupons.validityDaysLabel': '优惠券有效期（天）',
  'pages.members.coupons.validityDaysTooltip': '以天为单位输入优惠券有效期',
  'pages.members.coupons.validityDaysPlaceholder': '输入天数',
  'pages.members.coupons.days': '天',
  'pages.members.coupons.remainingQuantity': '剩余数量',
  'pages.members.coupons.usedCountLabel': '已使用的优惠券数量',
  'pages.members.coupons.issuanceMethod': '发放方式',
  'pages.members.coupons.issuanceMethodLabel': '发放方式',
  'pages.members.coupons.issuanceMethodTooltip': '选择优惠券分发方式：用户发放、系统发放或注册奖励',
  'pages.members.coupons.issuanceMethodUser': '用户领取',
  'pages.members.coupons.issuanceMethodSystem': '系统分发',
  'pages.members.coupons.issuanceMethodSignup': '注册并领取优惠券',
  'pages.members.coupons.signupCouponIdLabel': '注册完成后的优惠券ID',
  'pages.members.coupons.signupCouponIdTooltip': '选择注册完成后发放哪个优惠券。可以输入优惠券ID。',
  'pages.members.coupons.signupCouponIdPlaceholder': '输入注册后要发放的优惠券ID',
  'pages.members.coupons.distributionEnabledLabel': '分发系统优惠券',
  'pages.members.coupons.distributionEnabledTooltip': '可以选择在系统内均匀分发特定类型的优惠券',
  'pages.members.coupons.enabled': '启用',
  'pages.members.coupons.disabled': '禁用',
  'pages.members.coupons.issueButtonTooltipUser': '手动向选定用户发放此优惠券',
  'pages.members.coupons.issueButtonTooltipSystem': '向选定用户发放此优惠券',
  'pages.members.coupons.issueModalSystemHelp': '系统优惠券：您可以向所有用户或特定用户发放此优惠券。',
  'pages.members.coupons.issueModalUserHelp': '用户优惠券：此优惠券必须手动发放。请在下方选择目标用户。',
  'pages.members.coupons.issueToAll': '发放给所有用户',
  'pages.members.coupons.issueToAllTooltip': '自动向所有用户发放此优惠券',
  'pages.members.coupons.issueToAllConfirm': '发放给所有用户',
  'pages.members.coupons.issueToAllContent': '您确定要向所有用户发放"{name}"吗？',
  'pages.members.coupons.issuedToAll': '优惠券"{name}"已发放给所有用户',

  // Points Page
  'pages.members.points.title': '积分记录',
  'pages.members.points.totalEarned': '总获得积分',
  'pages.members.points.totalUsed': '总使用积分',
  'pages.members.points.currentBalance': '当前余额',
  'pages.members.points.expiringThisMonth': '本月即将过期',
  'pages.members.points.memberInfo': '会员信息',
  'pages.members.points.memberId': '会员ID',
  'pages.members.points.type': '类型',
  'pages.members.points.typeEarn': '获得',
  'pages.members.points.typeUse': '使用',
  'pages.members.points.typeExpire': '过期',
  'pages.members.points.typeAdmin': '管理员',
  'pages.members.points.points': '积分',
  'pages.members.points.balance': '余额',
  'pages.members.points.reason': '原因',
  'pages.members.points.content': '内容',
  'pages.members.points.orderNo': '订单号',
  'pages.members.points.processedAt': '处理时间',
  'pages.members.points.dateRange': '处理期间',
  'pages.members.points.expiryDate': '过期日期',
  'pages.members.points.processor': '处理人',
  'pages.members.points.excelDownload': 'Excel下载',
  'pages.members.points.addPoints': '发放积分',
  'pages.members.points.paid': '积分已发放',
  'pages.members.points.modalTitle': '发放积分',
  'pages.members.points.memberIdLabel': '会员ID',
  'pages.members.points.memberIdRequired': '请输入会员ID',
  'pages.members.points.memberIdPlaceholder': '会员ID或邮箱',
  'pages.members.points.typeLabel': '类型',
  // 'pages.members.points.typeAdmin': '管理员发放',
  // 'pages.members.points.typeEarn': '获得',
  'pages.members.points.typeDeduct': '扣除',
  'pages.members.points.amountLabel': '积分',
  'pages.members.points.amountRequired': '请输入积分',
  'pages.members.points.amountPlaceholder': '0',
  'pages.members.points.reasonLabel': '原因',
  'pages.members.points.reasonRequired': '请输入原因',
  'pages.members.points.reasonPlaceholder': '请输入发放/扣除积分的原因',
  'pages.members.points.expiryDateLabel': '过期日期（可选）',
  'pages.members.points.unit': 'P',
  // Points Record Table Columns
  'pages.members.points.column.id': 'ID',
  'pages.members.points.column.memberName': '会员姓名',
  'pages.members.points.column.mailbox': '邮箱',
  'pages.members.points.column.orderNumber': '订单号',
  'pages.members.points.column.paymentDetails': '支付详情',
  'pages.members.points.column.pointsBeforeChange': '变更前积分',
  'pages.members.points.column.pointsUsed': '已使用积分',
  'pages.members.points.column.pointsReceived': '已获得积分',
  'pages.members.points.column.pointsAfterChange': '变更后积分',
  'pages.members.points.column.pointsCurrencyExchangeRate': '积分与货币汇率',
  'pages.members.points.column.pointsCurrencyExchangeAmount': '积分与货币兑换金额',
  'pages.members.points.column.time': '时间',

  'pages.helpCenter.title': '帮助中心',
  'pages.helpCenter.subTitle': '网站帮助和内容管理',
  'pages.helpCenter.tabs.guides': '指南',
  'pages.helpCenter.tabs.faqs': '常见问题',
  'pages.helpCenter.tabs.payWith': '支付方式',
  'pages.helpCenter.tabs.socialLinks': '社交链接',
  'pages.helpCenter.tabs.viewHelp': '查看帮助',
  'pages.helpCenter.tabs.footer': '页脚信息',
  'pages.helpCenter.columns.order': '顺序',
  'pages.helpCenter.columns.chapter': '章节',
  'pages.helpCenter.columns.subChapterCount': '子章节数',
  'pages.helpCenter.columns.actions': '操作',
  'pages.helpCenter.columns.question': '问题',
  'pages.helpCenter.columns.category': '类别',
  'pages.helpCenter.columns.image': '图片',
  'pages.helpCenter.columns.title': '标题',
  'pages.helpCenter.columns.description': '描述',
  'pages.helpCenter.columns.platform': '平台',
  'pages.helpCenter.columns.url': 'URL',
  'pages.helpCenter.columns.content': '内容',
  'pages.helpCenter.columns.name': '名称',
  'pages.helpCenter.columns.value': '值',
  'pages.helpCenter.columns.visible': '显示',
  'pages.helpCenter.buttons.addGuide': '添加指南',
  'pages.helpCenter.buttons.manageCategory': '管理类别',
  'pages.helpCenter.buttons.addFAQ': '添加常见问题',
  'pages.helpCenter.buttons.addPayWith': '添加支付方式',
  'pages.helpCenter.buttons.addSocialLink': '添加社交链接',
  'pages.helpCenter.buttons.addViewHelpContent': '添加帮助内容',
  'pages.helpCenter.buttons.editFooter': '编辑页脚信息',
  'pages.helpCenter.buttons.edit': '编辑',
  'pages.helpCenter.buttons.delete': '删除',
  'pages.helpCenter.buttons.addCategory': '添加类别',
  'pages.helpCenter.buttons.addSubChapter': '添加子章节',
  'pages.helpCenter.modals.guide.add': '添加指南',
  'pages.helpCenter.modals.guide.edit': '编辑指南',
  'pages.helpCenter.modals.category.manage': '管理类别',
  'pages.helpCenter.modals.category.add': '添加类别',
  'pages.helpCenter.modals.category.edit': '编辑类别',
  'pages.helpCenter.modals.viewHelpContent.add': '添加帮助内容',
  'pages.helpCenter.modals.viewHelpContent.edit': '编辑帮助内容',
  'pages.helpCenter.modals.faq.add': '添加常见问题',
  'pages.helpCenter.modals.faq.edit': '编辑常见问题',
  'pages.helpCenter.modals.payWith.add': '添加支付方式',
  'pages.helpCenter.modals.payWith.edit': '编辑支付方式',
  'pages.helpCenter.modals.socialLink.add': '添加社交链接',
  'pages.helpCenter.modals.socialLink.edit': '编辑社交链接',
  'pages.helpCenter.modals.footer.edit': '编辑页脚信息',
  'pages.helpCenter.forms.chapter': '章节',
  'pages.helpCenter.forms.chapterRequired': '请输入章节',
  'pages.helpCenter.forms.chapterPlaceholder': '章节标题',
  'pages.helpCenter.forms.order': '顺序',
  'pages.helpCenter.forms.orderRequired': '请输入顺序',
  'pages.helpCenter.forms.orderPlaceholder': '顺序',
  'pages.helpCenter.forms.chapterContent': '章节内容',
  'pages.helpCenter.forms.chapterContentTooltip': '如果没有子章节，可以直接在章节中输入内容',
  'pages.helpCenter.forms.chapterContentPlaceholder': '请输入章节内容',
  'pages.helpCenter.forms.subChapters': '子章节（可选）',
  'pages.helpCenter.forms.subChaptersHint': '添加子章节将隐藏章节内容字段',
  'pages.helpCenter.forms.subChapterTitle': '子章节标题',
  'pages.helpCenter.forms.subChapterTitleRequired': '请输入子章节标题',
  'pages.helpCenter.forms.subChapterTitlePlaceholder': '子章节标题',
  'pages.helpCenter.forms.subChapterContent': '子章节内容',
  'pages.helpCenter.forms.subChapterContentRequired': '请输入子章节内容',
  'pages.helpCenter.forms.subChapterContentPlaceholder': '子章节内容',
  'pages.helpCenter.forms.categoryName': '类别名称',
  'pages.helpCenter.forms.categoryNameRequired': '请输入类别名称',
  'pages.helpCenter.forms.categoryNamePlaceholder': '例如：订单/购买',
  'pages.helpCenter.forms.categoryValue': '类别值（英文）',
  'pages.helpCenter.forms.categoryValueRequired': '请输入类别值',
  'pages.helpCenter.forms.categoryValuePlaceholder': '例如：order',
  'pages.helpCenter.forms.question': '问题',
  'pages.helpCenter.forms.questionRequired': '请输入问题',
  'pages.helpCenter.forms.questionPlaceholder': '问题',
  'pages.helpCenter.forms.answer': '答案',
  'pages.helpCenter.forms.answerRequired': '请输入答案',
  'pages.helpCenter.forms.answerPlaceholder': '答案',
  'pages.helpCenter.forms.category': '类别',
  'pages.helpCenter.forms.categoryRequired': '请选择类别',
  'pages.helpCenter.forms.categoryPlaceholder': '选择类别',
  'pages.helpCenter.forms.title': '标题',
  'pages.helpCenter.forms.titleRequired': '请输入标题',
  'pages.helpCenter.forms.titlePlaceholder': '支付方式标题',
  'pages.helpCenter.forms.description': '描述',
  'pages.helpCenter.forms.descriptionRequired': '请输入描述',
  'pages.helpCenter.forms.descriptionPlaceholder': '描述',
  'pages.helpCenter.forms.iconUrl': '图标URL',
  'pages.helpCenter.forms.iconUrlPlaceholder': '图标URL（可选）',
  'pages.helpCenter.forms.platform': '平台',
  'pages.helpCenter.forms.platformRequired': '请输入平台',
  'pages.helpCenter.forms.platformPlaceholder': '平台名称（例如：Facebook, Twitter）',
  'pages.helpCenter.forms.url': 'URL',
  'pages.helpCenter.forms.urlRequired': '请输入URL',
  'pages.helpCenter.forms.urlPlaceholder': 'https://...',
  'pages.helpCenter.forms.viewHelpTitlePlaceholder': '帮助标题',
  'pages.helpCenter.forms.content': '内容',
  'pages.helpCenter.forms.contentRequired': '请输入内容',
  'pages.helpCenter.forms.visible': '显示',
  'pages.helpCenter.messages.deleteConfirm': '确定要删除吗？',
  'pages.helpCenter.messages.noImage': '无',
  'pages.helpCenter.messages.currentFooterInfo': '当前页脚信息',
  'pages.helpCenter.messages.categoryList': '常见问题类别列表',
  'pages.helpCenter.footer.companyName': '公司名称',
  'pages.helpCenter.footer.representative': '代表',
  'pages.helpCenter.footer.address': '地址',
  'pages.helpCenter.footer.businessNumber': '营业执照号',
  'pages.helpCenter.footer.communicationNumber': '通信销售号',
  'pages.helpCenter.footer.phone': '电话',
  'pages.helpCenter.footer.email': '电子邮件',
  'pages.helpCenter.footer.complaintContact': '投诉联系人',
  'pages.helpCenter.footer.serviceDescription': '服务描述',
  'pages.helpCenter.footer.paymentDescription': '支付描述',
  'pages.helpCenter.footer.companyNamePlaceholder': 'TaoExpress有限公司',
  'pages.helpCenter.footer.representativePlaceholder': '代表姓名',
  'pages.helpCenter.footer.addressPlaceholder': '地址',
  'pages.helpCenter.footer.businessNumberPlaceholder': '营业执照号',
  'pages.helpCenter.footer.communicationNumberPlaceholder': '通信销售号',
  'pages.helpCenter.footer.phonePlaceholder': '电话号码',
  'pages.helpCenter.footer.emailPlaceholder': '电子邮件地址',
  'pages.helpCenter.footer.complaintContactPlaceholder': '投诉联系人',
  'pages.helpCenter.footer.serviceDescriptionPlaceholder': '服务描述',
  'pages.helpCenter.footer.paymentDescriptionPlaceholder': '支付描述',
  'pages.helpCenter.footer.showHideOptions': '显示/隐藏选项',
  'pages.helpCenter.footer.showCompanyName': '显示公司名称',
  'pages.helpCenter.footer.showRepresentative': '显示代表',
  'pages.helpCenter.footer.showAddress': '显示地址',
  'pages.helpCenter.footer.showBusinessNumber': '显示营业执照号',
  'pages.helpCenter.footer.showCommunicationNumber': '显示通信销售号',
  'pages.helpCenter.footer.showPhone': '显示电话',
  'pages.helpCenter.footer.showEmail': '显示电子邮件',
  'pages.helpCenter.footer.showComplaintContact': '显示投诉联系人',
  'pages.helpCenter.footer.showServiceDescription': '显示服务描述',
  'pages.helpCenter.footer.showPaymentDescription': '显示支付描述',
  'pages.helpCenter.footer.showViewHelp': '显示查看帮助',
  'pages.helpCenter.footer.whatIsTodayMall': '什么是TodayMall',
  'pages.helpCenter.footer.whatIsTodayMallPlaceholder': '输入关于TodayMall的描述',
  'pages.helpCenter.footer.whatIsTodayMallRequired': '请输入TodayMall描述',
  'pages.helpCenter.footer.showWhatIsTodayMall': '显示什么是TodayMall',
  'pages.helpCenter.footer.companyTagline': '公司标语',
  'pages.helpCenter.footer.companyTaglinePlaceholder': '输入公司标语（例如：您的最佳在线购物选择）',
  'pages.helpCenter.footer.companyTaglineRequired': '请输入公司标语',
  'pages.helpCenter.footer.showCompanyTagline': '显示公司标语',
  'pages.helpCenter.footer.companyIntroduction': '公司介绍',
  'pages.helpCenter.footer.companyIntroductionPlaceholder': '输入公司介绍',
  'pages.helpCenter.footer.companyIntroductionRequired': '请输入公司介绍',
  'pages.helpCenter.footer.showCompanyIntroduction': '显示公司介绍',
  'pages.helpCenter.footer.sections.companyInfo': '公司信息',
  'pages.helpCenter.footer.sections.contactInfo': '联系信息',
  'pages.helpCenter.footer.sections.descriptions': '描述',
  'pages.helpCenter.footer.sections.viewHelp': '查看帮助',
  'pages.helpCenter.footer.companyNameRequired': '请输入公司名称',
  'pages.helpCenter.footer.representativeRequired': '请输入代表',
  'pages.helpCenter.footer.addressRequired': '请输入地址',
  'pages.helpCenter.footer.businessNumberRequired': '请输入营业执照号',
  'pages.helpCenter.footer.communicationNumberRequired': '请输入通信销售号',
  'pages.helpCenter.footer.phoneRequired': '请输入电话号码',
  'pages.helpCenter.footer.emailRequired': '请输入电子邮件',
  'pages.helpCenter.footer.complaintContactRequired': '请输入投诉联系人',
  'pages.helpCenter.footer.serviceDescriptionRequired': '请输入服务描述',
  'pages.helpCenter.footer.paymentDescriptionRequired': '请输入支付描述',
  'pages.helpCenter.languages.korean': '한국어',
  'pages.helpCenter.languages.english': 'English',
  'pages.helpCenter.languages.chinese': '中文',
  'pages.helpCenter.placeholders.koreanInput': '请输入韩语',
  'pages.helpCenter.placeholders.englishInput': 'Enter in English',
  'pages.helpCenter.placeholders.chineseInput': '请输入中文',
  'pages.helpCenter.placeholders.koreanHTML': '请输入韩语HTML内容...',
  'pages.helpCenter.placeholders.englishHTML': 'Enter HTML content in English...',
  'pages.helpCenter.placeholders.chineseHTML': '请输入中文HTML内容...',
  'pages.helpCenter.tooltips.bold': '粗体',
  'pages.helpCenter.tooltips.italic': '斜体',
  'pages.helpCenter.tooltips.underline': '下划线',
  'pages.helpCenter.tooltips.alignLeft': '左对齐',
  'pages.helpCenter.tooltips.alignCenter': '居中',
  'pages.helpCenter.tooltips.alignRight': '右对齐',
  'pages.helpCenter.tooltips.orderedList': '有序列表',
  'pages.helpCenter.tooltips.unorderedList': '无序列表',
  'pages.helpCenter.messages.footerLoadFailed': '加载页脚信息失败',
  'pages.helpCenter.messages.viewHelpSaved': '查看帮助内容已保存',
  'pages.helpCenter.messages.viewHelpSaveFailed': '保存查看帮助内容失败',
  'pages.helpCenter.messages.viewHelpLoadFailed': '加载查看帮助内容失败',
  'pages.helpCenter.messages.guideDeleted': '指南已删除',
  'pages.helpCenter.messages.guideDeleteFailed': '删除指南失败',
  'pages.helpCenter.messages.guideUpdated': '指南已更新',
  'pages.helpCenter.messages.guideAdded': '指南已添加',
  'pages.helpCenter.messages.guideSaveFailed': '保存指南失败',
  'pages.helpCenter.messages.categoryDeleteFailed': '删除类别失败',
  'pages.helpCenter.messages.categorySaveFailed': '保存类别失败',
  'pages.helpCenter.messages.categoryLoadFailed': '加载类别失败',
  'pages.helpCenter.messages.faqDeleted': 'FAQ已删除',
  'pages.helpCenter.messages.faqDeleteFailed': '删除FAQ失败',
  'pages.helpCenter.messages.faqUpdated': 'FAQ已更新',
  'pages.helpCenter.messages.faqAdded': 'FAQ已添加',
  'pages.helpCenter.messages.faqSaveFailed': '保存FAQ失败',
  'pages.helpCenter.messages.faqLoadFailed': '加载FAQ失败',
  'pages.helpCenter.messages.paymentMethodDeleted': '支付方式已删除',
  'pages.helpCenter.messages.paymentMethodDeleteFailed': '删除支付方式失败',
  'pages.helpCenter.messages.paymentMethodUpdated': '支付方式已更新',
  'pages.helpCenter.messages.paymentMethodAdded': '支付方式已添加',
  'pages.helpCenter.messages.paymentMethodSaveFailed': '保存支付方式失败',
  'pages.helpCenter.messages.paymentMethodLoadFailed': '加载支付方式失败',
  'pages.helpCenter.messages.paymentMethodStatusUpdated': '支付方式状态已更新',
  'pages.helpCenter.messages.socialLinkDeleted': '社交链接已删除',
  'pages.helpCenter.messages.socialLinkDeleteFailed': '删除社交链接失败',
  'pages.helpCenter.messages.socialLinkUpdated': '社交链接已更新',
  'pages.helpCenter.messages.socialLinkAdded': '社交链接已添加',
  'pages.helpCenter.messages.socialLinkSaveFailed': '保存社交链接失败',
  'pages.helpCenter.messages.socialLinkLoadFailed': '加载社交链接失败',
  'pages.helpCenter.messages.socialLinkStatusUpdated': '社交链接状态已更新',
  'pages.helpCenter.messages.footerSaved': '页脚信息已保存',
  'pages.helpCenter.messages.footerSaveFailed': '保存页脚信息失败',
  'pages.helpCenter.messages.guideStatusUpdated': '指南状态已更新',
  'pages.helpCenter.messages.faqStatusUpdated': 'FAQ状态已更新',
  'pages.helpCenter.messages.statusUpdateFailed': '更新状态失败',
  'pages.helpCenter.messages.guideLoadFailed': '加载指南失败',
  'pages.helpCenter.forms.viewHelpContent': '查看帮助内容',
  'pages.helpCenter.forms.viewHelpContentRequired': '请输入查看帮助内容',
  'pages.helpCenter.forms.viewHelpContentPlaceholder': '请输入查看帮助内容（支持HTML）',
  'pages.helpCenter.forms.preview': '预览',
  'pages.helpCenter.forms.enterContent': '请输入内容',
  'pages.helpCenter.forms.titleMinOneLanguage': '请至少用一种语言输入标题',
  'pages.helpCenter.forms.descriptionMinOneLanguage': '请至少用一种语言输入描述',

  // Administrators page
  'pages.administrators.title': '管理员管理',
  'pages.administrators.id': 'ID',
  'pages.administrators.adminInfo': '管理员信息',
  'pages.administrators.name': '姓名',
  'pages.administrators.email': '邮箱',
  'pages.administrators.role': '角色',
  'pages.administrators.role.superadmin': '超级管理员',
  'pages.administrators.role.admin': '管理员',
  'pages.administrators.role.manager': '经理',
  'pages.administrators.role.staff': '员工',
  'pages.administrators.status': '状态',
  'pages.administrators.status.active': '活跃',
  'pages.administrators.status.inactive': '未激活',
  'pages.administrators.status.locked': '已锁定',
  'pages.administrators.lastLogin': '最后登录',
  'pages.administrators.createdAt': '创建时间',
  'pages.administrators.actions': '操作',
  'pages.administrators.detail': '详情',
  'pages.administrators.edit': '编辑',
  'pages.administrators.password': '密码',
  'pages.administrators.deactivate': '停用',
  'pages.administrators.activate': '激活',
  'pages.administrators.delete': '删除',
  'pages.administrators.totalAdmins': '总管理员数',
  'pages.administrators.activeAccounts': '活跃账户',
  'pages.administrators.inactiveAccounts': '未激活账户',
  'pages.administrators.superAdmins': '超级管理员',
  'pages.administrators.list': '管理员列表',
  'pages.administrators.add': '添加管理员',
  'pages.administrators.adminIdNotFound': '未找到管理员ID',
  'pages.administrators.deleteConfirm': '删除管理员',
  'pages.administrators.deleteConfirmMessage': '确定要删除管理员 {name} 吗？',
  'pages.administrators.deleteKeepsLogs': '账号将从列表中移除并无法登录。该账号的工作日志和处理记录不会被删除，将全部保留。',
  'pages.administrators.permissions': '权限',
  'pages.administrators.selectAll': '全选',
  'pages.administrators.deselectAll': '取消全选',
  'pages.administrators.selected': '已选择',
  'pages.administrators.permissionsSection.todaymallCore': '今日商城核心',
  'pages.administrators.permissionsSection.storehouse': '仓库与物流',
  'pages.administrators.permissionsSection.settlement': '结算',
  'pages.administrators.permissionsSection.customerService': '客户服务',
  'pages.administrators.permissionsSection.system': '系统',
  'pages.administrators.permissions.orders': '订单管理',
  'pages.administrators.permissions.users': '用户管理',
  'pages.administrators.permissions.products': '商品管理',
  'pages.administrators.permissions.categories': '分类管理',
  'pages.administrators.permissions.warehouses': '仓库管理',
  'pages.administrators.permissions.racks': '货架管理',
  'pages.administrators.permissions.packages': '包裹管理',
  'pages.administrators.permissions.warehouse-transactions': '仓库交易',
  'pages.administrators.permissions.activity-logs': '活动日志',
  'pages.administrators.permissions.settlement': '结算管理',
  'pages.administrators.permissions.help-center': '帮助中心管理',
  'pages.administrators.permissions.banners': '横幅管理',
  'pages.administrators.permissions.content': '内容管理',
  'pages.administrators.permissions.general-inquiry': '一般咨询管理',
  'pages.administrators.permissions.system': '系统管理',
  'pages.administrators.noPermissions': '未分配权限',
  'pages.administrators.close': '关闭',
  'pages.administrators.passwordReset': '密码重置',
  'pages.administrators.currentPassword': '当前密码',
  'pages.administrators.newPassword': '新密码',
  'pages.administrators.confirmPassword': '确认密码',
  'pages.administrators.passwordMismatch': '密码不匹配',
  'pages.administrators.incorrectCurrentPassword': '当前密码不正确',
  'pages.administrators.permissionsMismatch': '警告：发送了 {sent} 个权限但收到了 {returned} 个。后端可能已修改。',
  'pages.administrators.form.passwordRequired': '请输入密码',
  'pages.administrators.form.passwordPlaceholder': '密码',
  'pages.administrators.form.nameRequired': '请输入姓名',
  'pages.administrators.form.namePlaceholder': '姓名',
  'pages.administrators.form.emailRequired': '请输入邮箱',
  'pages.administrators.form.emailInvalid': '请输入有效的邮箱',
  'pages.administrators.form.emailPlaceholder': '邮箱',
  'pages.administrators.form.newPasswordRequired': '请输入新密码',
  'pages.administrators.form.newPasswordPlaceholder': '新密码',
  'pages.administrators.form.confirmPasswordRequired': '请确认密码',
  'pages.administrators.form.confirmPasswordPlaceholder': '确认密码',
  'pages.administrators.form.passwordMinLength': '密码至少需要8个字符',
  'pages.administrators.form.currentPasswordRequired': '请输入当前密码',
  'pages.administrators.form.currentPasswordPlaceholder': '当前密码',
  'pages.administrators.form.rolePlaceholder': '选择角色',
  'pages.administrators.addMember': '添加成员账户',
  'pages.administrators.memberCode': '会员代码',
  'pages.administrators.memberLevel': '会员等级',
  'pages.administrators.memberName': '会员名称',
  'pages.administrators.userId': 'ID',
  'pages.administrators.centerInCharge': '负责中心',
  'pages.administrators.registrationDate': '登记日期',
  'pages.administrators.accessRights': '访问权限',
  'pages.administrators.deleteConfirmContent': '确定要删除此管理员吗？',
  'pages.administrators.modal.title': '编辑会员信息',
  'pages.administrators.modal.userId': 'id',
  'pages.administrators.modal.memberName': 'name',
  'pages.administrators.modal.memberLevel': 'Administrator level',
  'pages.administrators.modal.password': 'password',
  'pages.administrators.modal.centerInCharge': 'Center in charge',
  'pages.administrators.accessRightsModal.title': '修改访问权限',
  'pages.administrators.accessRightsModal.selectAll': '全选',
  'pages.administrators.accessRightsModal.accessRights': '访问权限',
  'pages.administrators.accessRightsModal.menu.agency': '代理综合管理 (101)',
  'pages.administrators.accessRightsModal.menu.rocket': '火箭订单管理 (116)',
  'pages.administrators.accessRightsModal.menu.trade': '贸易服务 (113)',
  'pages.administrators.accessRightsModal.menu.payment': '支付代理服务 (115)',
  
  // New granular permission structure
  'pages.administrators.selectAllSection': '选择此部分全部',
  'pages.administrators.clearAllSection': '清除此部分全部',
  'pages.administrators.pageName': '页面名称',
  'pages.administrators.viewPermission': '查看',
  'pages.administrators.editPermission': '编辑',
  
  // Sections
  'pages.administrators.sections.operation': '运营管理',
  'pages.administrators.sections.orders': '订单管理',
  'pages.administrators.sections.storehouse': '仓库管理',
  'pages.administrators.sections.logistics': '物流管理',
  'pages.administrators.sections.members': '会员管理',
  'pages.administrators.sections.settlement': '结算管理',
  'pages.administrators.sections.customerService': '客户服务',
  'pages.administrators.sections.system': '系统管理',
  
  // Pages
  'pages.administrators.pages.operationData': '运营数据',
  'pages.administrators.pages.categories': '分类管理',
  'pages.administrators.pages.companyMall': '自营商城',
  'pages.administrators.pages.liveSellers': '直播卖家',
  'pages.administrators.pages.couponPointSettings': '优惠券/积分设置',
  'pages.administrators.pages.rebateSettings': '返利设置',
  'pages.administrators.pages.searchManagement': '搜索管理',
  'pages.administrators.pages.orderStatistics': '订单统计',
  'pages.administrators.pages.userOrders': '用户订单',
  'pages.administrators.pages.pendingPayment': '待付款',
  'pages.administrators.pages.orderQuestions': '订单问题',
  'pages.administrators.pages.inspectionList': '检验列表',
  'pages.administrators.pages.rackManagement': '货架管理',
  'pages.administrators.pages.warehouseAddress': '仓库地址',
  'pages.administrators.pages.waybillInformations': '运单信息',
  'pages.administrators.pages.waybillBandwidth': '运单带宽',
  'pages.administrators.pages.transportationMethods': '运输方式',
  'pages.administrators.pages.regionalManagement': '区域管理',
  'pages.administrators.pages.internationalTracking': '国际追踪号',
  'pages.administrators.pages.hsProductCode': 'HS商品代码',
  'pages.administrators.pages.memberStatistics': '会员统计',
  'pages.administrators.pages.generalMembers': '普通会员',
  'pages.administrators.pages.promotionDetail': '促销详情',
  'pages.administrators.pages.settlementManagement': '结算管理',
  'pages.administrators.pages.memberRechargeReview': '会员充值审核',
  'pages.administrators.pages.memberWithdrawalReview': '会员提现审核',
  'pages.administrators.pages.financialRecords': '财务记录',
  'pages.administrators.pages.deposit': '存款',
  'pages.administrators.pages.coupons': '优惠券',
  'pages.administrators.pages.oneToOneInquiry': '1:1咨询',
  'pages.administrators.pages.notices': '公告',
  'pages.administrators.pages.suggestion': '建议',
  'pages.administrators.pages.review': '评论',
  'pages.administrators.pages.helpCenter': '帮助中心',
  'pages.administrators.pages.bannerEvent': '横幅/活动',
  'pages.administrators.pages.administrators': '管理员',
  'pages.administrators.pages.exchangeTariffSetting': '汇率/关税设置',
  'pages.administrators.pages.purchaseConditionSetting': '购买条件设置',
  'pages.administrators.pages.workerLog': '工作日志',
  'pages.administrators.pages.productPriceIncrease': '产品价格上涨',
  
  // Friendly date formats
  'pages.administrators.justNow': '刚刚',
  'pages.administrators.minutesAgo': '{count}分钟前',
  'pages.administrators.hoursAgo': '{count}小时前',
  'pages.administrators.daysAgo': '{count}天前',
  'pages.administrators.monthsAgo': '{count}个月前',
  'pages.administrators.yearsAgo': '{count}年前',
  
  // Individual permission labels
  'pages.roles.ordersread': '订单查看',
  'pages.roles.orderswrite': '订单编辑',
  'pages.roles.ordersdelete': '订单删除',
  'pages.roles.ordersfulfill': '订单处理',
  'pages.roles.ordersinquiry': '订单咨询',
  'pages.roles.usersread': '会员查看',
  'pages.roles.userswrite': '会员编辑',
  'pages.roles.usersdelete': '会员删除',
  'pages.roles.productsread': '商品查看',
  'pages.roles.productswrite': '商品创建',
  'pages.roles.productswriteedit': '商品编辑',
  'pages.roles.productsdelete': '商品删除',
  'pages.roles.productssync': '商品同步',
  'pages.roles.categoriesread': '分类查看',
  'pages.roles.categorieswrite': '分类编辑',
  'pages.roles.categoriesdelete': '分类删除',
  'pages.roles.warehousesread': '仓库查看',
  'pages.roles.warehouseswrite': '仓库编辑',
  'pages.roles.racksread': '货架查看',
  'pages.roles.rackswrite': '货架编辑',
  'pages.roles.packagesread': '包裹查看',
  'pages.roles.packageswrite': '包裹编辑',
  'pages.roles.warehousetransactionsread': '仓库交易查看',
  'pages.roles.activitylogsread': '活动日志查看',
  'pages.roles.settlementread': '结算查看',
  'pages.roles.settlementwrite': '结算处理',
  'pages.roles.helpcenterread': '帮助中心查看',
  'pages.roles.helpcenterwrite': '帮助中心编辑',
  'pages.roles.helpcenterdelete': '帮助中心删除',
  'pages.roles.bannersread': '横幅查看',
  'pages.roles.bannerswrite': '横幅编辑',
  'pages.roles.bannersdelete': '横幅删除',
  'pages.roles.contentwrite': '内容编辑',
  'pages.roles.contentdelete': '内容删除',
  'pages.roles.generalinquiry': '一般咨询',
  'pages.roles.adminsread': '管理员查看',
  'pages.roles.adminswrite': '管理员编辑',
  'pages.roles.adminsdelete': '管理员删除',
  'pages.roles.permissionsmanage': '权限管理',
  'pages.roles.settingsread': '设置查看',
  'pages.roles.settingswrite': '设置编辑',
  'pages.administrators.createSuccess': '管理员已添加',
  'pages.administrators.createFailed': '添加管理员失败',
  'pages.administrators.updateSuccess': '管理员信息已更新',
  'pages.administrators.updateFailed': '更新管理员失败',
  'pages.administrators.deleteSuccess': '管理员已删除',
  'pages.administrators.deleteFailed': '删除管理员失败',
  'pages.administrators.phone': '电话',
  'pages.administrators.username': '用户名',
  'pages.administrators.usernamePlaceholder': 'admin001',
  'pages.administrators.usernameRequired': '请输入用户名',
  'pages.administrators.department': '部门',
  'pages.administrators.department.management': '管理支持',
  'pages.administrators.department.sales': '销售',
  'pages.administrators.department.cs': '客户支持',
  'pages.administrators.department.logistics': '物流',
  'pages.administrators.department.it': 'IT',
  'pages.administrators.departmentPlaceholder': '选择部门',
  'pages.administrators.newThisMonth': '本月新增',
  'pages.administrators.detailTitle': '管理员详情',
  'pages.administrators.basicInfo': '基本信息',
  'pages.administrators.passwordChange': '密码（仅在更改时输入）',
  'pages.administrators.passwordChangePlaceholder': '如果要更改密码，请输入',
  'pages.administrators.rolePlaceholder': '选择角色',
  'pages.administrators.statusActive': '活跃',
  'pages.administrators.statusInactive': '非活跃',
  'pages.administrators.mock.name': '张三',
  'pages.admins.adminIdNotFound': '找不到管理员ID',
  'pages.admins.deleteAdmin': '删除管理员',
  'pages.admins.deleteAdminContent': '确定要删除管理员 "{name}" 吗？',
  'pages.admins.resetPassword': '重置密码',
  'pages.admins.resetPasswordContent': '确定要重置管理员 "{name}" 的密码吗？',
  'pages.admins.resetPasswordSuccess': '密码已重置',
  'pages.admins.adminInfo': '管理员信息',
  'pages.admins.email': '电子邮件',
  'pages.admins.role': '角色',
  'pages.admins.role.superadmin': '超级管理员',
  'pages.admins.role.admin': '管理员',
  'pages.admins.role.manager': '经理',
  'pages.admins.role.staff': '员工',
  'pages.admins.department': '部门',
  'pages.admins.department.management': '管理支持',
  'pages.admins.department.sales': '销售',
  'pages.admins.department.cs': '客户支持',
  'pages.admins.department.logistics': '物流',
  'pages.admins.department.it': 'IT',
  'pages.admins.status': '状态',
  'pages.admins.status.active': '活跃',
  'pages.admins.status.inactive': '非活跃',
  'pages.admins.lastLogin': '最后登录',
  'pages.admins.createdAt': '创建日期',
  'pages.admins.actions': '操作',
  'pages.admins.detail': '详情',
  'pages.admins.edit': '编辑',
  'pages.admins.delete': '删除',

  // Rates page
  'pages.rates.title': '汇率/关税设置',
  'pages.rates.currentExchangeRate': '当前汇率（海外直购 人民币）',
  'pages.rates.basicTariffRate': '基本关税率',
  'pages.rates.vatRate': '增值税率',
  'pages.rates.exchangeRateInfo': '汇率和关税信息',
  'pages.rates.exchangeRateInfoDesc': '汇率每天自动更新，可以手动调整。关税率可能因产品类别而异。',
  'pages.rates.exchangeRateSettings': '汇率设置',
  'pages.rates.tariffSettings': '关税设置',
  'pages.rates.exchangeRateHistory': '汇率变动历史',
  'pages.rates.date': '日期',
  'pages.rates.rate': '汇率',
  'pages.rates.change': '变动',
  'pages.rates.cny': '海外直购 人民币（CNY）',
  'pages.rates.cnyLive': '直播 人民币（CNY）',
  'pages.rates.cnyOwnmall': '自营商城 人民币（CNY）',
  'pages.rates.cnySegmentHint': '直播、自营商城汇率仅适用于新登记或修改成本的商品以及新订单，已登记商品的成本不会改变。',
  'pages.rates.cnyLiveShort': '直播',
  'pages.rates.cnyOwnmallShort': '自营商城',
  'pages.rates.usd': '美元（USD）',
  'pages.rates.jpy': '日元（JPY）',
  'pages.rates.eur': '欧元（EUR）',
  'pages.rates.basicTariff': '基本关税率',
  'pages.rates.vat': '增值税率（VAT）',
  'pages.rates.specialTariff': '特殊关税率（电子产品）',
  'pages.rates.luxuryTariff': '奢侈品关税率',
  'pages.rates.reset': '重置',
  'pages.rates.save': '保存',
  'pages.rates.saveSuccess': '汇率和关税设置已保存',
  'pages.rates.saveError': '保存汇率失败',
  'pages.rates.loadError': '加载汇率失败',
  'pages.rates.noRatesToUpdate': '没有要更新的汇率',
  'pages.rates.rateRequired': '请输入汇率',
  'pages.rates.saveExchangeRates': '保存汇率',
  'pages.rates.saveTariff': '保存关税设置',
  'pages.rates.resetTariff': '重置关税',
  'pages.rates.noTariffToUpdate': '没有要更新的关税率',
  'pages.rates.tariffSaveSuccess': '关税设置已保存',
  'pages.rates.tariffSaveError': '保存关税设置失败',

  // Additional Cost Settings page
  'pages.settings.additionalCost.title': '附加费用设置',
  'pages.settings.additionalCost.description': '配置将应用于订单的附加费用',
  'pages.settings.additionalCost.simplifiedCustomsClearance': '简易清关费用 (₩)',
  'pages.settings.additionalCost.simplifiedCustomsClearanceRequired': '请输入费用',
  'pages.settings.additionalCost.designatedShooting': '指定拍摄费用 (₩)',
  'pages.settings.additionalCost.designatedShootingRequired': '请输入费用',
  'pages.settings.additionalCost.saveSuccess': '设置已保存',
  'pages.settings.additionalCost.saveFailed': '保存设置失败',

  // Purchase Condition Settings page
  'pages.purchaseConditionSettings.title': '购买条件设置',
  'pages.purchaseConditionSettings.limitPrice.title': '价格限制',
  'pages.purchaseConditionSettings.limitPrice.label': '自动购买价格限制 (韩元)',
  'pages.purchaseConditionSettings.limitPrice.required': '请输入价格限制',
  'pages.purchaseConditionSettings.limitPrice.min': '价格限制必须大于或等于0',
  'pages.purchaseConditionSettings.limitPrice.tooltip': '超过此金额的订单将作为手动购买处理',
  'pages.purchaseConditionSettings.limitPrice.description': '金额等于或超过此值的订单将作为手动购买处理，而不是自动购买。',
  'pages.purchaseConditionSettings.userMemo.title': '用户备注状态',
  'pages.purchaseConditionSettings.userMemo.enabled': '启用基于用户备注的条件',
  'pages.purchaseConditionSettings.userMemo.keywords': '关键词 (逗号分隔)',
  'pages.purchaseConditionSettings.userMemo.keywordsTooltip': '用户备注包含这些关键词的订单将作为手动购买处理',
  'pages.purchaseConditionSettings.userMemo.keywordsPlaceholder': '例如：urgent, important, check',
  'pages.purchaseConditionSettings.userMemo.description': '用户备注包含指定关键词的订单将作为手动购买处理。',
  'pages.purchaseConditionSettings.sensitiveProducts.title': '敏感产品列表',
  'pages.purchaseConditionSettings.sensitiveProducts.add': '添加敏感产品',
  'pages.purchaseConditionSettings.sensitiveProducts.empty': '没有敏感产品',
  'pages.purchaseConditionSettings.sensitiveProducts.description': '在此列表中注册的产品将作为手动购买处理，而不是自动购买。',
  'pages.purchaseConditionSettings.table.productName': '产品名称',
  'pages.purchaseConditionSettings.table.productId': '产品ID',
  'pages.purchaseConditionSettings.table.url': 'URL',
  'pages.purchaseConditionSettings.table.reason': '原因',
  'pages.purchaseConditionSettings.modal.addTitle': '添加敏感产品',
  'pages.purchaseConditionSettings.modal.editTitle': '编辑敏感产品',
  'pages.purchaseConditionSettings.modal.productName': '产品名称',
  'pages.purchaseConditionSettings.modal.productNameRequired': '请输入产品名称',
  'pages.purchaseConditionSettings.modal.productId': '产品ID',
  'pages.purchaseConditionSettings.modal.url': '产品URL',
  'pages.purchaseConditionSettings.modal.reason': '原因',
  'pages.purchaseConditionSettings.saveSuccess': '购买条件设置已保存',
  'pages.purchaseConditionSettings.saveError': '保存购买条件设置失败',
  'pages.purchaseConditionSettings.productAdded': '敏感产品已添加',
  'pages.purchaseConditionSettings.productUpdated': '敏感产品已更新',
  'pages.purchaseConditionSettings.productDeleted': '敏感产品已删除',
  'pages.purchaseConditionSettings.deleteConfirm': '您确定要删除此敏感产品吗？',
  'pages.purchaseConditionSettings.amountThreshold.title': '金额阈值',
  'pages.purchaseConditionSettings.amountThreshold.label': '自动购买金额阈值 (韩元)',
  'pages.purchaseConditionSettings.amountThreshold.currentValue': '当前值',
  'pages.purchaseConditionSettings.amountThreshold.required': '请输入金额阈值',
  'pages.purchaseConditionSettings.amountThreshold.min': '金额阈值必须大于或等于0',
  'pages.purchaseConditionSettings.amountThreshold.tooltip': '超过此金额的订单将作为手动购买处理',
  'pages.purchaseConditionSettings.amountThreshold.description': '金额等于或超过此值的订单将作为手动购买处理，而不是自动购买。',
  'pages.purchaseConditionSettings.memoKeywords.title': '备注关键词',
  'pages.purchaseConditionSettings.memoKeywords.label': '备注关键词',
  'pages.purchaseConditionSettings.memoKeywords.tooltip': '备注包含这些关键词的订单将作为手动购买处理',
  'pages.purchaseConditionSettings.memoKeywords.placeholder': '输入关键词并按Enter或点击添加按钮',
  'pages.purchaseConditionSettings.memoKeywords.empty': '没有关键词',
  'pages.purchaseConditionSettings.memoKeywords.description': '备注包含指定关键词的订单将作为手动购买处理。',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.title': '敏感产品报价ID',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.label': '敏感产品报价ID',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.tooltip': '包含这些报价ID的订单将作为手动购买处理',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.placeholder': '输入报价ID并按Enter或点击添加按钮',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.empty': '没有报价ID',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.description': '包含此列表中注册的报价ID的订单将作为手动购买处理，而不是自动购买。',
  'pages.purchaseConditionSettings.info.title': '设置信息',
  'pages.purchaseConditionSettings.info.lastUpdatedBy': '最后更新者',
  'pages.purchaseConditionSettings.info.updatedAt': '最后更新时间',
  'pages.purchaseConditionSettings.loadError': '加载设置失败',

  // Shipping Rate page
  'pages.shippingRate.title': '配送费率',
  'pages.shippingRate.registrationButton': '配送费率登记',
  'pages.shippingRate.deleteCenterPlaceholder': '= 按中心删除费率',
  'pages.shippingRate.deleteButton': '删除',
  'pages.shippingRate.deleteConfirm': '确定要删除此中心的所有费率吗？',
  'pages.shippingRate.deleteSuccess': '费率删除成功',
  'pages.shippingRate.deleteError': '费率删除失败',
  'pages.shippingRate.selectCenterToDelete': '请选择要删除的中心',
  'pages.shippingRate.weight': '重量',
  'pages.shippingRate.basicMember': '基本会员',
  'pages.shippingRate.shippingAgencyVIP': '配送代理VIP',
  'pages.shippingRate.shippingAgencySVIP': '配送代理SVIP',
  'pages.shippingRate.purchasingAgent': '采购代理',
  'pages.shippingRate.vipPurchasingAgent': 'VIP采购代理',
  'pages.shippingRate.ttBusinessOperator': 'TT运营商',
  'pages.shippingRate.ttVIP': 'TT VIP',
  'pages.shippingRate.ttIndividual': 'TT个人',
  'pages.shippingRate.registrationModalTitle': '配送费率登记',
  'pages.shippingRate.centerShippingMethod': '中心/运输方式',
  'pages.shippingRate.centerRequired': '请选择中心/运输方式',
  'pages.shippingRate.selectCenter': '= 选择',
  'pages.shippingRate.membershipLevel': '会员等级',
  'pages.shippingRate.membershipLevelRequired': '请选择会员等级',
  'pages.shippingRate.selectMembershipLevel': '= 选择',
  'pages.shippingRate.startEndWeight': '起始 ~ 结束重量',
  'pages.shippingRate.startWeight': '起始重量',
  'pages.shippingRate.endWeight': '结束重量',
  'pages.shippingRate.startWeightRequired': '请输入起始重量',
  'pages.shippingRate.endWeightRequired': '请输入结束重量',
  'pages.shippingRate.weightInterval': '重量间隔',
  'pages.shippingRate.weightIntervalRequired': '请选择重量间隔',
  'pages.shippingRate.selectWeightInterval': '选择重量间隔',
  'pages.shippingRate.startingAmount': '起始金额',
  'pages.shippingRate.startingAmountRequired': '请输入起始金额',
  'pages.shippingRate.amountInterval': '金额间隔',
  'pages.shippingRate.amountIntervalRequired': '请输入金额间隔',
  'pages.shippingRate.registrationSuccess': '配送费率登记成功',
  'pages.shippingRate.registrationError': '配送费率登记失败',
  'pages.shippingRate.updateSuccess': '配送费率更新成功',
  'pages.shippingRate.updateError': '配送费率更新失败',
  'pages.shippingRate.deleteRuleConfirm': '确定要删除此配送费率规则吗？',
  'pages.shippingRate.editModalTitle': '编辑配送费率规则',
  'pages.shippingRate.noData': '尚未登记费率',
  'pages.shippingRate.selectRoute': '选择要编辑/删除的路线',
  'pages.shippingRate.route.weihaiShip': '中国/威海/海运',
  'pages.shippingRate.route.weihaiAir': '中国/威海/空运',
  'pages.shippingRate.route.qingdaoShip': '中国/青岛/海运',
  'pages.shippingRate.route.qingdaoAir': '中国/青岛/空运',
  'pages.shippingRate.route.guangzhouShip': '中国/广州/海运',
  'pages.shippingRate.route.guangzhouAir': '中国/广州/空运',

  // Roles page
  'pages.roles.title': '角色管理',
  'pages.roles.list': '角色列表',
  'pages.roles.add': '添加角色',
  'pages.roles.edit': '编辑角色',
  'pages.roles.delete': '删除角色',
  'pages.roles.id': 'ID',
  'pages.roles.name': '角色名称',
  'pages.roles.code': '角色代码',
  'pages.roles.description': '描述',
  'pages.roles.userCount': '用户数',
  'pages.roles.permissionCount': '权限数',
  'pages.roles.status': '状态',
  'pages.roles.createdAt': '创建日期',
  'pages.roles.actions': '操作',
  'pages.roles.permissionSettings': '权限设置',
  'pages.roles.ordersManagement': '订单管理',
  'pages.roles.ordersView': '查看订单',
  'pages.roles.ordersEdit': '编辑订单',
  'pages.roles.ordersDelete': '删除订单',
  'pages.roles.membersManagement': '会员管理',
  'pages.roles.membersView': '查看会员',
  'pages.roles.membersEdit': '编辑会员',
  'pages.roles.membersDelete': '删除会员',
  'pages.roles.productsManagement': '产品管理',
  'pages.roles.productsView': '查看产品',
  'pages.roles.productsCreate': '创建产品',
  'pages.roles.productsEdit': '编辑产品',
  'pages.roles.productsDelete': '删除产品',
  'pages.roles.settlementManagement': '结算管理',
  'pages.roles.settlementView': '查看结算',
  'pages.roles.settlementProcess': '处理结算',
  'pages.roles.systemManagement': '系统管理',
  'pages.roles.systemAdmins': '管理员管理',
  'pages.roles.systemRoles': '角色管理',
  'pages.roles.systemSettings': '系统设置',
  'pages.roles.status.active': '活跃',
  'pages.roles.status.inactive': '非活跃',
  'pages.roles.form.nameRequired': '请输入角色名称',
  'pages.roles.form.codeRequired': '请输入角色代码',
  'pages.roles.form.namePlaceholder': '例如：管理员',
  'pages.roles.form.codePlaceholder': '例如：ADMIN',
  'pages.roles.form.descriptionPlaceholder': '输入角色描述',
  'pages.roles.deleteConfirm': '删除角色',
  'pages.roles.deleteConfirmMessage': '确定要删除角色 "{name}" 吗？',
  'pages.roles.deleteSuccess': '角色已删除',
  'pages.roles.updateSuccess': '角色已更新',
  'pages.roles.createSuccess': '角色已添加',
  'pages.roles.unit.people': '人',
  'pages.roles.unit.items': '个',
  'pages.roles.mock.superAdmin': '超级管理员',
  'pages.roles.mock.superAdminDesc': '拥有所有权限的超级管理员',
  'pages.roles.mock.admin': '管理员',
  'pages.roles.mock.adminDesc': '拥有大部分管理权限的管理员',
  'pages.roles.mock.manager': '经理',
  'pages.roles.mock.managerDesc': '订单和会员管理权限',
  'pages.roles.mock.csStaff': '客服人员',
  'pages.roles.mock.csStaffDesc': '客户支持相关权限',

  // Additional permission keys
  'pages.roles.dashboard': '仪表盘',
  'pages.roles.dashboardView': '查看仪表盘',
  'pages.roles.todaymall': 'TodayMall',
  'pages.roles.todayggigu': 'TodayGgigu',
  'pages.roles.permissionView': '仅查看',
  'pages.roles.permissionEdit': '编辑',
  'pages.roles.productsCategory': '管理分类',
  'pages.roles.productsImport': '导入淘宝商品',
  'pages.roles.ordersUser': '用户订单',
  'pages.roles.ordersBusiness': '企业订单',
  'pages.roles.ordersVvic': 'VVIC订单',
  'pages.roles.ordersRocket': 'Rocket订单',
  'pages.roles.ordersPendingPayment': '待付款',
  'pages.roles.ordersPendingAddress': '待地址',
  'pages.roles.ordersInChinaWarehouse': '中国仓库',
  'pages.roles.ordersInKoreaDelivery': '韩国配送',
  'pages.roles.ordersCompleted': '已完成订单',
  'pages.roles.ordersNoData': '无数据订单',
  'pages.roles.ordersQuestions': '订单咨询',
  'pages.roles.ordersInventoryQuestions': '库存咨询',
  'pages.roles.membersGeneral': '普通会员',
  'pages.roles.membersBusiness': '企业会员',
  'pages.roles.membersBlacklist': '黑名单会员',
  'pages.roles.membersCoupons': '优惠券管理',
  'pages.roles.membersCouponPointSettings': '优惠券积分设置',
  'pages.roles.membersPoints': '积分管理',
  'pages.roles.membersRebate': '返利管理',
  'pages.roles.membersDeposit': '保证金管理',
  'pages.roles.storehouseManagement': '仓库管理',
  'pages.roles.storehouseView': '查看仓库',
  'pages.roles.storehouseExpressInspection': '快递检验',
  'pages.roles.storehouseNonMasterCourier': '非主快递',
  'pages.roles.storehouseInspectionList': '检验清单',
  'pages.roles.storehouseRack': '货架管理',
  'pages.roles.storehouseWarehouseAddress': '仓库地址',
  'pages.roles.logisticsManagement': '物流管理',
  'pages.roles.logisticsView': '查看物流',
  'pages.roles.logisticsBatchTracking': '批量跟踪',
  'pages.roles.logisticsForwarders': '货运代理',
  'pages.roles.logisticsShippingRate': '运费规则',
  'pages.roles.logisticsInternationalTracking': '国际跟踪',
  'pages.roles.settlementSellers': '卖家结算',
  'pages.roles.settlementPlatform': '平台结算',
  'pages.roles.settlementCoupons': '优惠券结算',
  'pages.roles.settlementPriceIncrease': '价格上涨',
  'pages.roles.settlementServiceFee': '服务费',
  'pages.roles.csManagement': '客服管理',
  'pages.roles.csView': '查看客服',
  'pages.roles.csInquiries': '咨询管理',
  'pages.roles.csNotices': '公告',
  'pages.roles.csLookingForOwner': '寻找主人',
  'pages.roles.csReviews': '评价管理',
  'pages.roles.csHelp': '帮助中心',
  'pages.roles.csBanners': '横幅管理',
  'pages.roles.csEmailManagement': '邮件管理',
  'pages.roles.systemRates': '汇率管理',
  'pages.roles.systemPurchaseCondition': '购买条件设置',
  'pages.roles.systemShippingRate': '运费设置',

  // System Settings page
  'pages.systemSettings.title': '系统管理',
  'pages.systemSettings.breadcrumb.system': '系统',
  'pages.systemSettings.breadcrumb.settings': '系统管理',
  'pages.systemSettings.tab.admins': '管理员账户',
  'pages.systemSettings.tab.roles': '权限管理',
  'pages.systemSettings.admins.title': '管理员账户管理',
  'pages.systemSettings.admins.description': '添加、编辑、删除管理员并设置权限',
  'pages.systemSettings.roles.title': '角色和权限管理',
  'pages.systemSettings.roles.description': '创建角色并分配权限',

  // Notification Icon
  'pages.notification.title': '通知',
  'pages.notification.orderInquiryMessage': '新的订单咨询消息已到达。',
  'pages.notification.generalInquiryMessage': '新的1:1咨询消息已到达。',
  'pages.notification.orderInquiries': '订单咨询',
  'pages.notification.generalInquiries': '1:1咨询',
  'pages.notification.inventoryInquiries': '库存咨询',
  'pages.notification.depositApplication': '存款申请',
  'pages.notification.bankTransferPayment': '银行转账付款',
  'pages.notification.unit.items': '项',
  'pages.notification.clickToView': '点击查看',

  // Additional Cost Modal
  'pages.additionalCost.title': '■ 代理附加费用登记',
  'pages.additionalCost.save': '保存',
  'pages.additionalCost.close': '关闭',
  'pages.additionalCost.saveSuccess': '附加费用已保存',
  'pages.additionalCost.orderInfo': '订单信息',
  'pages.additionalCost.orderNumberMemberName': '订单号 / 会员名',
  'pages.additionalCost.center': '中心',
  'pages.additionalCost.additionalCost': '附加费用',
  'pages.additionalCost.vvicCost': 'VVIC附加费用',
  'pages.additionalCost.purchaseCost': '购买代理附加费用',
  'pages.additionalCost.shippingCost': '配送代理附加费用',
  'pages.additionalCost.saved': '附加费用已保存',
  'pages.additionalCost.productInformation': '商品信息',
  'pages.additionalCost.productNo': '商品编号',
  'pages.additionalCost.productName': '商品名称',
  'pages.additionalCost.image': '图片',
  'pages.additionalCost.quantity': '数量',
  'pages.additionalCost.trackingNumber': '运单号',
  'pages.additionalCost.status': '状态',
  'pages.additionalCost.customsClearance': '清单通关',
  'pages.additionalCost.actualInspection': '实检',
  'pages.additionalCost.viewActualInspection': '查看实检',
  'pages.additionalCost.adminMemo': '管理员备注',
  'pages.additionalCost.additionalServices': '附加服务',
  'pages.additionalCost.boxCount': '箱数',
  'pages.additionalCost.box': '箱',
  'pages.additionalCost.appliedExchangeRate': '适用汇率',
  'pages.additionalCost.totalAmount': '总金额',
  'pages.additionalCost.totalQuantityAmount': '总数量 / 总金额',
  'pages.additionalCost.items': '个',
  'pages.additionalCost.recipientAddress': '收件人地址',
  'pages.additionalCost.destination': '韩国 - 仁川',
  'pages.additionalCost.smsNotSend': '不发送短信',
  'pages.additionalCost.smsSend': '发送短信',

  // Barcode Scan Modal
  'pages.barcodeScan.title.receiving': '入库扫描',
  'pages.barcodeScan.title.rackAssignment': '货架指定',
  'pages.barcodeScan.warehouse.guangzhou': '广州',
  'pages.barcodeScan.warehouse.weihai': '威海',
  'pages.barcodeScan.warehouse.qingdao': '青岛',
  'pages.barcodeScan.warehouse.yiwu': '义乌',
  'pages.barcodeScan.rackSize.small': '小',
  'pages.barcodeScan.rackSize.medium': '中',
  'pages.barcodeScan.rackSize.large': '大',
  'pages.barcodeScan.trackingNumber': '运单号',
  'pages.barcodeScan.trackingNumberPlaceholder': '运单号',
  'pages.barcodeScan.depositAmount': '到付金额 (元)',
  'pages.barcodeScan.orderNumber': '订单号',
  'pages.barcodeScan.orderNumberLabel': '订单号：',
  'pages.barcodeScan.rackNumber': '货架号',
  'pages.barcodeScan.changeRack': '变更货架',
  'pages.barcodeScan.receivedTime': '接收时间',
  'pages.barcodeScan.operator': '操作员',
  'pages.barcodeScan.scanComplete': '条码扫描完成：{value}',
  'pages.barcodeScan.scanError': '条码扫描时发生错误',
  'pages.barcodeScan.trackingNumberRequired': '请输入运单号',
  'pages.barcodeScan.ordersFound': '找到 {count} 个订单',
  'pages.barcodeScan.registered': '已注册：{value}',
  'pages.barcodeScan.scannerDeviceInstruction': '请使用扫描器设备扫描条码',
  'pages.barcodeScan.deleted': '已删除',
  'pages.barcodeScan.checkLabel': '{orderNo} 检查标签',
  'pages.barcodeScan.recheck': '重新检查',
  'pages.barcodeScan.rackSaveComplete': '{orderNo} 货架已保存',
  'pages.barcodeScan.reset': '重置',
  'pages.barcodeScan.selectWarehouse': '选择仓库',
  'pages.barcodeScan.warehouseLoadError': '加载仓库失败',
  'pages.barcodeScan.invoiceImages': '发票图片',
  'pages.barcodeScan.upload': '上传',
  'pages.barcodeScan.onlyImagesAllowed': '只允许图片文件',
  'pages.barcodeScan.imageSizeLimit': '图片必须小于10MB',
  'pages.barcodeScan.maxImagesReached': '最多允许10张图片',
  'pages.barcodeScan.takePhoto': '拍照',
  'pages.barcodeScan.capture': '拍摄',
  'pages.barcodeScan.cameraNotReady': '相机未准备好',
  'pages.barcodeScan.captureFailed': '拍照失败',
  'pages.barcodeScan.photoCaptured': '照片拍摄成功',
  'pages.barcodeScan.warehouseRequired': '请选择仓库',
  'pages.barcodeScan.registerError': '登记失败',
  'pages.barcodeScan.recheckButton': '重新检查',
  'pages.barcodeScan.save': '保存',
  'pages.barcodeScan.cancel': '取消',
  'pages.barcodeScan.register': '注册',
  'pages.barcodeScan.receivingScan': '入库扫描',
  'pages.barcodeScan.selectScanMethod': '选择扫描方法',
  'pages.barcodeScan.cameraScan': '📷 相机扫描',
  'pages.barcodeScan.scannerDevice': '🔫 扫描器设备',
  'pages.barcodeScan.scannerWaiting': '等待扫描器设备...',
  'pages.barcodeScan.scannerInstruction': '请使用条码扫描器扫描条码',
  'pages.barcodeScan.frameInstruction': '请将条码对准框架内',
  'pages.barcodeScan.close': '关闭',
  'pages.barcodeScan.search': '搜索 Q',
  'pages.barcodeScan.rackAssignment': '货架指定',
  'pages.barcodeScan.receiptLabel': '接收标签',
  'pages.barcodeScan.trackingNumberColon': '运单号：',

  // Label Management Modal
  'pages.labelManagement.title': '包装管理',
  'pages.labelManagement.orderNumberRequired': '请输入订单号',
  'pages.labelManagement.ordersFound': '找到 {count} 个订单',
  'pages.labelManagement.orderDetail': '{trackingNumber} 详细信息',
  'pages.labelManagement.orderNumber': '订单号',
  'pages.labelManagement.orderNumberPlaceholder': '订单号',
  'pages.labelManagement.orderNumberColon': '订单号：',
  'pages.labelManagement.search': '搜索 Q',
  'pages.labelManagement.detail': '详情',
  'pages.labelManagement.customer': '客户',
  'pages.labelManagement.recipient': '收件人',
  'pages.labelManagement.trackingNumber': '快递单号',
  'pages.labelManagement.searchInstruction': '搜索订单号以查看包装信息',
  'pages.labelManagement.menu.logout': '登出',
  'pages.labelManagement.menu.warehouseScan': '入库扫描/盘点',
  'pages.labelManagement.menu.rackManagement': '货架运输管理',
  'pages.labelManagement.menu.labelManagement': '包装管理',
  'pages.labelManagement.menu.shippingScan': '出库扫描',
  'pages.labelManagement.menu.title': '菜单',
  'pages.labelManagement.message.logout': '登出',
  'pages.labelManagement.message.warehouseScan': '转到入库扫描/盘点页面',
  'pages.labelManagement.message.rackManagement': '转到货架运输管理页面',
  'pages.labelManagement.message.labelManagement': '转到包装管理页面',
  'pages.labelManagement.message.shippingScan': '转到出库扫描页面',
  'pages.labelManagement.warehouse.guangzhou': '广州',
  'pages.labelManagement.warehouse.weihei': '威海',
  'pages.labelManagement.warehouse.qingdao': '青岛',
  'pages.labelManagement.warehouse.yiwu': '义乌',
  'pages.labelManagement.labelPrinting': '正在准备打印 {trackingNumber} 的标签...',
  'pages.labelManagement.mock.recipient1': '金德花',
  'pages.labelManagement.mock.recipient2': '金惠琳',
  'pages.labelManagement.mock.recipient3': '吴惠美',
  'pages.labelManagement.mock.recipient4': '方正英',

  // Order Log Modal
  'pages.orderLog.title': '■ 订单日志 - 订单号：{orderNo}',
  'pages.orderLog.close': '关闭',
  'pages.orderLog.columns.no': 'No',
  'pages.orderLog.columns.time': '时间',
  'pages.orderLog.columns.status': '状态',
  'pages.orderLog.columns.content': '内容',
  'pages.orderLog.columns.detail': '详情',
  'pages.orderLog.columns.processor': '处理者',
  'pages.orderLog.noLogs': '没有日志记录',
  'pages.orderLog.memo': '备注：',
  'pages.orderLog.system': '系统',
  'pages.orderLog.orderNotFound': '未找到订单',
  'pages.orderLog.orderIdNotFound': '未找到订单ID',
  'pages.orderLog.fetchError': '获取订单状态历史失败',

  // Output Scan Modal
  'pages.outputScan.title': '出库扫描',
  'pages.outputScan.searchPlaceholder': '搜索',
  'pages.outputScan.searchRequired': '请输入搜索词',
  'pages.outputScan.ordersFound': '找到 {count} 个订单',
  'pages.outputScan.paymentComplete': '支付完成',
  'pages.outputScan.waitingForOutput': '等待出库',
  'pages.outputScan.tab.pyeongtaek': '平泽',
  'pages.outputScan.tab.incheon': '仁川',
  'pages.outputScan.tab.air': '航空',
  'pages.outputScan.paymentCompleteSelected': '支付完成 - 已选择 {tab}',
  'pages.outputScan.waitingForOutputSelected': '等待出库 - 已选择 {tab}',
  'pages.outputScan.totalQuantity': '总数量',
  'pages.outputScan.totalWeight': '总重量',
  'pages.outputScan.trackingNumberPlaceholder': '运单号',
  'pages.outputScan.trackingNumberRequired': '请输入运单号',
  'pages.outputScan.moved': '已移动',
  'pages.outputScan.move': '移动',
  'pages.outputScan.orderNumberColon': '订单号：',
  'pages.outputScan.recipient': '收件人',
  'pages.outputScan.boxCountWeight': '箱数 / 重量',
  'pages.outputScan.trackingNumber': '运单号',
  'pages.outputScan.internationalTrackingNumber': '国际运单号',
  'pages.outputScan.locationCode': '位置代码',
  'pages.outputScan.locationCodePlaceholder': '输入位置代码 (例如: A-01-03-001)',
  'pages.outputScan.locationCodeRequired': '请输入位置代码',
  'pages.outputScan.cancel': '取消',
  'pages.outputScan.submit': '提交',

  // Product Log Modal
  'pages.productLog.title': '■ 商品日志 - 商品号：{productNo}',
  'pages.productLog.close': '关闭',
  'pages.productLog.columns.no': 'No',
  'pages.productLog.columns.operator': '操作员',
  'pages.productLog.columns.content': '内容',
  'pages.productLog.columns.registrationDate': '注册日期',
  'pages.productLog.noLogs': '没有日志记录',

  // Product Table Modal
  'pages.productTable.title': '订单商品列表 - {orderNo}',
  'pages.productTable.trackingNumberInput': '运单号输入:',
  'pages.productTable.trackingNumberPlaceholder': '运单号',
  'pages.productTable.register': '注册',
  'pages.productTable.columns.no': '编号',
  'pages.productTable.columns.checkbox': '复选框',
  'pages.productTable.columns.productStatus': '商品状态',
  'pages.productTable.columns.productLog': '商品日志',
  'pages.productTable.columns.image': '图片',
  'pages.productTable.columns.customsClearance': '[通关物品]',
  'pages.productTable.columns.productName': '商品名称',
  'pages.productTable.columns.color': '[颜色]',
  'pages.productTable.columns.size': '尺寸',
  'pages.productTable.columns.productCode': '品号 / 材质',
  'pages.productTable.columns.sellerInfo': '卖家信息',
  'pages.productTable.columns.trackingNo': '[运单号]',
  'pages.productTable.columns.orderNo': '订单号',
  'pages.productTable.columns.exposure': '(曝光O/X)',
  'pages.productTable.columns.shippingCost': '[运费] 实际(O) / 卖家(X)',
  'pages.productTable.columns.refundCost': '[退款费用] 卖家(X) / 会员(O)',
  'pages.productTable.columns.unitPriceQuantity': '单价 * 数量',
  'pages.productTable.columns.totalActualPayment': '总额 / 实付金额',
  'pages.productTable.columns.actualQuantity': '* 实际数量',
  'pages.productTable.columns.total': '总额',
  'pages.productTable.columns.rackNo': '[货架号]',
  'pages.productTable.columns.previousRackNo': '之前货架号',
  'pages.productTable.status.shipped': '出库',
  'pages.productTable.status.log': '日志',
  'pages.productTable.status.arrivalExpected': '预计到达',
  'pages.productTable.exposure.yes': '(曝光 O)',
  'pages.productTable.shipping': '运费:',
  'pages.productTable.refund': '退款:',
  'pages.productTable.actualPayment': '实付:',
  'pages.productTable.previous': '之前:',
  'pages.productTable.productNote': '商品备注:',
  'pages.productTable.productNotePlaceholder': '输入商品备注',
  'pages.productTable.sellerAddress': '卖家地址:',
  'pages.productTable.sellerAddressPlaceholder': '输入卖家地址',
  'pages.productTable.mock.furniture': '[家具]',
  'pages.productTable.mock.cotton': '棉',
  'pages.productTable.mock.sellerA': '卖家A',

  // Tracking Number Modal
  'pages.trackingNumber.title': '■ 运单号注册',
  'pages.trackingNumber.save': '保存',
  'pages.trackingNumber.close': '关闭',
  'pages.trackingNumber.trackingNumber': '运单号',
  'pages.trackingNumber.trackingNumberPlaceholder': '运单号',
  'pages.trackingNumber.shippingDate': '出库日期',
  'pages.trackingNumber.shippingDatePlaceholder': '出库日期',
  'pages.trackingNumber.trackingNumberRequired': '请输入运单号',
  'pages.trackingNumber.shippingDateRequired': '请输入出库日期',
  'pages.trackingNumber.registered': '运单号已注册',

  // Sub Waybill Modal
  'pages.subWaybill.title': '子运单号注册',
  'pages.subWaybill.save': '保存',
  'pages.subWaybill.close': '关闭',
  'pages.subWaybill.orderNumber': '订单号',
  'pages.subWaybill.mainWaybillNumber': '主运单号',
  'pages.subWaybill.subWaybillNumber': '运单号',
  'pages.subWaybill.subWaybillNumberPlaceholder': '请输入运单号',
  'pages.subWaybill.registered': '运单号已注册',
  'pages.subWaybill.registerFailed': '注册运单号失败',
  'pages.subWaybill.waybillNumberRequired': '需要运单号',
  'pages.subWaybill.orderNumberRequired': '需要订单号',
  'pages.subWaybill.warningMessage': '빈값의 운송장번호를 입력하면 해당 서브 운송장번호는 삭제됩니다.',

  // Bundle Orders Modal
  'pages.bundleOrders.title': '订单合并',
  'pages.bundleOrders.bundle': '合并',
  'pages.bundleOrders.close': '关闭',
  'pages.bundleOrders.orderNo': '订单号',
  'pages.bundleOrders.memberId': '会员号',
  'pages.bundleOrders.memberName': '会员名',
  'pages.bundleOrders.deliveryAddress': '收货地址',
  'pages.bundleOrders.shippingMethod': '运输方式',
  'pages.bundleOrders.productCount': '商品数量',
  'pages.bundleOrders.totalAmount': '总金额',
  'pages.bundleOrders.description': '同一个会员号、收货地址、运输方式的订单和订单合并，生成新的订单号。',
  'pages.bundleOrders.selectedCount': '已选择 {count} 个订单',
  'pages.bundleOrders.selectAtLeastTwo': '请至少选择2个订单进行合并',
  'pages.bundleOrders.bundled': '订单已合并，新订单号已生成',
  'pages.bundleOrders.noOrderInfo': '无订单信息',
  'pages.bundleOrders.noOrdersFound': '没有找到符合条件的订单',
  'pages.bundleOrders.select': '选择',
  'pages.bundleOrders.orderNumber': '订单号',
  'pages.bundleOrders.itemCount': '商品数量',
  'pages.bundleOrders.progressStatus': '状态',
  'pages.bundleOrders.createdAt': '创建时间',
  'pages.bundleOrders.selectAtLeastOne': '请至少选择一个订单进行合并',
  'pages.bundleOrders.orderIdRequired': '需要订单ID',
  'pages.bundleOrders.fetchError': '获取可合并订单失败',
  'pages.bundleOrders.bundleError': '合并订单失败，请重试',
  'pages.bundleOrders.currentOrder': '当前订单',
  // Split Order Modal
  'pages.splitOrder.title': '订单分单',
  'pages.splitOrder.split': '分单',
  'pages.splitOrder.close': '关闭',
  'pages.splitOrder.orderNo': '订单号',
  'pages.splitOrder.productNo': '商品编号',
  'pages.splitOrder.image': '图片',
  'pages.splitOrder.productName': '商品名称',
  'pages.splitOrder.variation': '规格',
  'pages.splitOrder.quantity': '数量',
  'pages.splitOrder.originalQuantity': '原数量',
  'pages.splitOrder.splitQuantity': '分单数量',
  'pages.splitOrder.originalTotal': '原总价',
  'pages.splitOrder.splitTotal': '分单总价',
  'pages.splitOrder.quantityMustBeGreaterThanZero': '分单数量必须大于0',
  'pages.splitOrder.quantityExceedsAvailable': '分单数量不能超过可用数量',
  'pages.splitOrder.unitPrice': '单价',
  'pages.splitOrder.totalPrice': '总价',
  'pages.splitOrder.description': '选择要分单的商品，选中的商品将创建新订单。',
  'pages.splitOrder.selectAtLeastOne': '请至少选择一个商品进行分单',
  'pages.splitOrder.cannotSelectAll': '不能选择所有商品，请至少保留一个商品在原订单',
  'pages.splitOrder.selectedTotal': '选中商品总金额',
  'pages.splitOrder.splitSuccess': '订单分单成功，新订单已创建',
  'pages.splitOrder.splitError': '分单失败，请重试',

  // Merge Order Modal
  'pages.mergeOrder.title': '合并订单',
  'pages.mergeOrder.currentOrder': '当前订单',
  'pages.mergeOrder.select': '选择',
  'pages.mergeOrder.orderNumber': '订单号',
  'pages.mergeOrder.memberName': '会员名',
  'pages.mergeOrder.itemCount': '商品数量',
  'pages.mergeOrder.totalAmount': '总金额',
  'pages.mergeOrder.progressStatus': '状态',
  'pages.mergeOrder.createdAt': '创建时间',
  'pages.mergeOrder.selectAtLeastOne': '请至少选择一个订单',
  'pages.mergeOrder.selectOnlyOne': '请只选择一个分单订单',
  'pages.mergeOrder.orderIdRequired': '需要订单ID',
  'pages.mergeOrder.fetchError': '获取可合并订单失败',
  'pages.mergeOrder.splitRefundSuccess': '分单退款订单已创建',
  'pages.mergeOrder.splitRefundError': '分单退款失败，请重试',
  'pages.mergeOrder.merge': '合并',
  'pages.mergeOrder.mergeSuccess': '订单合并成功，新订单已创建',
  'pages.mergeOrder.mergeError': '合并订单失败，请重试',
  'pages.mergeOrder.close': '关闭',
  'pages.mergeOrder.orderNo': '订单号',
  'pages.mergeOrder.memberId': '会员号',
  'pages.mergeOrder.deliveryAddress': '收货地址',
  'pages.mergeOrder.shippingMethod': '运输方式',
  'pages.mergeOrder.productCount': '商品数量',
  'pages.mergeOrder.selectAtLeastTwo': '请至少选择2个订单进行合并',
  'pages.mergeOrder.merged': '订单已合并，新订单号已生成',
  'pages.mergeOrder.selectedCount': '已选择 {count} 个订单',
  'pages.mergeOrder.noOrdersFound': '没有找到符合条件的订单',
  'pages.mergeOrder.splitFrom': '分单自',
  'pages.mergeOrder.hasSplitOrders': '已分单',

  // User Info Modal
  'pages.userInfo.title': '用户信息',
  'pages.userInfo.memberDetails': '会员详细信息',
  'pages.userInfo.memberType.general': '一般',
  'pages.userInfo.memberType.business': '企业',
  'pages.userInfo.memberTypeTag.general': '一般会员',
  'pages.userInfo.memberTypeTag.business': '企业会员',
  'pages.userInfo.mailbox': '信箱号',
  'pages.userInfo.businessNo': '企业注册号',
  'pages.userInfo.registrationDate': '注册日期',
  'pages.userInfo.totalOrders': '总订单数',
  'pages.userInfo.totalAmount': '总订单金额',
  'pages.userInfo.contact': '联系方式',
  'pages.userInfo.email': '电子邮件',
  'pages.userInfo.address': '地址',
  'pages.userInfo.memo': '备注',
  'pages.userInfo.unit.orders': '单',
  'pages.userInfo.unit.currency': '元',
  'pages.userInfo.actions.memberInfo': '会员信息',
  'pages.userInfo.actions.userUniqueId': '邮箱',
  'pages.userInfo.actions.inquiry': '咨询',
  'pages.userInfo.actions.notificationMessage': '通知消息',
  'pages.userInfo.actions.orders': '订单',
  'pages.userInfo.actions.paymentConfirmation': '付款确认',
  'pages.userInfo.actions.deposit': '押金',
  'pages.userInfo.actions.coupon': '优惠券',
  'pages.userInfo.actions.point': '积分',

  // Auth
  'pages.auth.loginSuccess': '登录成功！',
  'pages.auth.loginFailed': '登录失败',
  'pages.auth.loginFailedWithConsole': '登录失败。请查看控制台了解详细信息。',
  
  // Settlement - Dashboard
  'pages.settlement.dashboard.title': '财务仪表盘',
  'pages.settlement.dashboard.refresh': '刷新',
  'pages.settlement.dashboard.overview.totalUsers': '总用户数',
  'pages.settlement.dashboard.overview.totalOrders': '总订单数',
  'pages.settlement.dashboard.overview.totalRevenue': '总收入',
  'pages.settlement.dashboard.overview.totalProducts': '总商品数',
  'pages.settlement.dashboard.overview.activeProducts': '在售商品',
  'pages.settlement.dashboard.overview.pendingOrders': '待处理订单',
  'pages.settlement.dashboard.revenue.title': '收入',
  'pages.settlement.dashboard.revenue.today': '今日',
  'pages.settlement.dashboard.revenue.thisWeek': '本周',
  'pages.settlement.dashboard.revenue.thisMonth': '本月',
  'pages.settlement.dashboard.revenue.thisYear': '今年',
  'pages.settlement.dashboard.revenue.growth': '增长率',
  'pages.settlement.dashboard.orders.title': '订单',
  'pages.settlement.dashboard.orders.today': '今日',
  'pages.settlement.dashboard.orders.thisWeek': '本周',
  'pages.settlement.dashboard.orders.thisMonth': '本月',
  'pages.settlement.dashboard.orders.byStatus': '按状态',
  'pages.settlement.dashboard.topProducts.title': '热门商品',
  'pages.settlement.dashboard.topProducts.productId': '商品 ID',
  'pages.settlement.dashboard.topProducts.name': '商品名称',
  'pages.settlement.dashboard.topProducts.sales': '销量',
  'pages.settlement.dashboard.topProducts.revenue': '收入',
  'pages.settlement.dashboard.recentActivity.title': '最近活动',
  'pages.settlement.dashboard.recentActivity.empty': '暂无活动数据',

  // Settlement - Sellers
  'pages.settlement.sellers.title': '卖家结算',
  'pages.settlement.sellers.tableTitle': '卖家结算历史',
  'pages.settlement.sellers.processSettlement': '处理结算',
  'pages.settlement.sellers.processSettlementConfirm': '您要处理 {sellerName} 的结算吗？({amount}元)',
  'pages.settlement.sellers.processSettlementSuccess': '结算已处理',
  'pages.settlement.sellers.process': '处理',
  'pages.settlement.sellers.statement': '明细',
  'pages.settlement.sellers.exportExcel': '导出Excel',
  'pages.settlement.sellers.exportExcelSuccess': 'Excel文件下载已开始',
  'pages.settlement.sellers.downloadStatement': '下载明细',
  'pages.settlement.sellers.settlementRate': '结算率 {percent}%',
  'pages.settlement.sellers.stat.totalSettlementThisMonth': '本月总结算额',
  'pages.settlement.sellers.stat.pending': '待处理',
  'pages.settlement.sellers.stat.completed': '已完成',
  'pages.settlement.sellers.stat.avgSettlement': '平均结算额',
  'pages.settlement.sellers.alert.title': '结算通知',
  'pages.settlement.sellers.alert.description': '每月1日至月末的销售额在次月10日结算。结算金额是总销售额减去佣金、运费和其他费用后的金额。',
  'pages.settlement.sellers.column.id': 'ID',
  'pages.settlement.sellers.column.sellerInfo': '卖家信息',
  'pages.settlement.sellers.column.period': '结算期间',
  'pages.settlement.sellers.column.totalSales': '总销售额',
  'pages.settlement.sellers.column.commission': '佣金',
  'pages.settlement.sellers.column.shippingFee': '运费',
  'pages.settlement.sellers.column.settlementAmount': '结算金额',
  'pages.settlement.sellers.column.orderProduct': '订单/商品',
  'pages.settlement.sellers.column.status': '状态',
  'pages.settlement.sellers.column.requestDate': '申请日期',
  'pages.settlement.sellers.column.completedDate': '完成日期',
  'pages.settlement.sellers.column.action': '操作',
  'pages.settlement.sellers.status.pending': '待处理',
  'pages.settlement.sellers.status.processing': '处理中',
  'pages.settlement.sellers.status.completed': '已完成',
  'pages.settlement.sellers.status.failed': '失败',
  'pages.settlement.sellers.detailModal.title': '结算详情 - {sellerName}',
  'pages.settlement.sellers.tab.summary': '结算摘要',
  'pages.settlement.sellers.tab.account': '存款信息',
  'pages.settlement.sellers.detail.sellerId': '卖家ID',
  'pages.settlement.sellers.detail.sellerName': '卖家名称',
  'pages.settlement.sellers.detail.period': '结算期间',
  'pages.settlement.sellers.detail.orderCount': '订单数',
  'pages.settlement.sellers.detail.productCount': '商品数',
  'pages.settlement.sellers.detail.settlementAmountDetail': '结算金额详情',
  'pages.settlement.sellers.detail.totalSales': '总销售额',
  'pages.settlement.sellers.detail.platformCommission': '平台佣金 (10%)',
  'pages.settlement.sellers.detail.shippingFee': '运费',
  'pages.settlement.sellers.detail.otherDeduction': '其他扣除',
  'pages.settlement.sellers.detail.finalSettlementAmount': '最终结算金额',
  'pages.settlement.sellers.detail.bankName': '银行名称',
  'pages.settlement.sellers.detail.accountNumber': '账户号码',
  'pages.settlement.sellers.detail.accountHolder': '账户持有人',
  'pages.settlement.sellers.detail.requestDate': '申请日期',
  'pages.settlement.sellers.detail.completedDate': '完成日期',
  'pages.settlement.sellers.detail.status': '状态',
  'pages.settlement.sellers.mock.sellerName': '卖家',
  'pages.settlement.sellers.mock.bank.kb': '国民银行',
  'pages.settlement.sellers.mock.bank.shinhan': '新韩银行',
  'pages.settlement.sellers.mock.bank.woori': '友利银行',
  'pages.settlement.sellers.mock.bank.hana': '韩亚银行',
  
  // Settlement - Member Recharge Review
  'pages.settlement.memberRechargeReview.title': '存款申请记录',
  'pages.settlement.memberRechargeReview.memberName': '会员姓名',
  'pages.settlement.memberRechargeReview.applicationType': '申请类型',
  'pages.settlement.memberRechargeReview.typeDeposit': '申请',
  'pages.settlement.memberRechargeReview.typeRefund': '退款',
  'pages.settlement.memberRechargeReview.rejectReasonPlaceholder': '请输入拒绝理由',
  'pages.settlement.memberRechargeReview.depositAmount': '存款金额',
  'pages.settlement.memberRechargeReview.refundAmount': '退款金额',
  'pages.settlement.memberRechargeReview.depositor': '存款人（账户持有人）',
  'pages.settlement.memberRechargeReview.bankInfo': '账号',
  'pages.settlement.memberRechargeReview.status': '完成状态',
  'pages.settlement.memberRechargeReview.statusPending': '申请中',
  'pages.settlement.memberRechargeReview.statusApproved': '已完成',
  'pages.settlement.memberRechargeReview.statusRejected': '已取消',
  'pages.settlement.memberRechargeReview.applicationDate': '申请日期',
  'pages.settlement.memberRechargeReview.expectedDepositDate': '预计存款日期',
  'pages.settlement.memberRechargeReview.actions': '操作',
  'pages.settlement.memberRechargeReview.complete': '完成',
  'pages.settlement.memberRechargeReview.cancellation': '取消',
  'pages.settlement.memberRechargeReview.totalApplications': '总申请数',
  'pages.settlement.memberRechargeReview.pendingApplications': '待处理申请',
  'pages.settlement.memberRechargeReview.approvedApplications': '已完成',
  'pages.settlement.memberRechargeReview.totalAmount': '总金额',
  'pages.settlement.memberRechargeReview.approveConfirm': '确认批准？',
  'pages.settlement.memberRechargeReview.approveContent': '您要批准{name}的{amount}韩元存款吗？',
  'pages.settlement.memberRechargeReview.approved': '批准成功',
  'pages.settlement.memberRechargeReview.approveError': '批准失败',
  'pages.settlement.memberRechargeReview.rejectConfirm': '拒绝申请？',
  'pages.settlement.memberRechargeReview.rejectContent': '您要拒绝{name}的押金申请吗？',
  'pages.settlement.memberRechargeReview.rejected': '拒绝成功',
  'pages.settlement.memberRechargeReview.rejectError': '拒绝失败',
  'pages.settlement.memberRechargeReview.registrationSuccess': '注册成功',
  
  // Settlement - Member Withdrawal Review
  'pages.settlement.memberWithdrawalReview.title': '存款使用记录',
  'pages.settlement.memberWithdrawalReview.memberName': '会员姓名',
  'pages.settlement.memberWithdrawalReview.usageClassification': '使用类型',
  'pages.settlement.memberWithdrawalReview.classificationDepositTopup': '存款充值',
  'pages.settlement.memberWithdrawalReview.classificationRefund': '存款退款',
  'pages.settlement.memberWithdrawalReview.classificationPaymentCost': '支付费用',
  'pages.settlement.memberWithdrawalReview.classificationPaymentCancel': '支付取消',
  'pages.settlement.memberWithdrawalReview.classificationAdminAccrual': '管理员存款增加',
  'pages.settlement.memberWithdrawalReview.classificationAdminDeduction': '管理员存款扣除',
  'pages.settlement.memberWithdrawalReview.classificationProductRefund': '商品退款',
  'pages.settlement.memberWithdrawalReview.content': '内容',
  'pages.settlement.memberWithdrawalReview.transactionCode': '交易代码',
  'pages.settlement.memberWithdrawalReview.amount': '金额',
  'pages.settlement.memberWithdrawalReview.balance': '余额',
  'pages.settlement.memberWithdrawalReview.usageDate': '使用日期',
  'pages.settlement.memberWithdrawalReview.paymentOrderNumber': '支付订单号',
  'pages.settlement.memberWithdrawalReview.depositPaymentOrderNumber': '存款支付订单号',
  'pages.settlement.memberWithdrawalReview.totalUsage': '总使用次数',
  'pages.settlement.memberWithdrawalReview.totalAmount': '总金额',
  'pages.settlement.memberWithdrawalReview.averageAmount': '平均金额',
  'pages.settlement.memberWithdrawalReview.totalDeposit': '总存款',
  'pages.settlement.memberWithdrawalReview.depositRegistration': '存款登记',
  'pages.settlement.memberWithdrawalReview.memberSearch': '会员搜索',
  'pages.settlement.memberWithdrawalReview.searchByMemberId': '会员ID',
  'pages.settlement.memberWithdrawalReview.searchByMemberName': '会员姓名',
  'pages.settlement.memberWithdrawalReview.searchByMailbox': '邮箱号码',
  'pages.settlement.memberWithdrawalReview.searchRequired': '请输入搜索词',
  'pages.settlement.memberWithdrawalReview.searchPlaceholder': '输入搜索词',
  'pages.settlement.memberWithdrawalReview.search': '搜索',
  'pages.settlement.memberWithdrawalReview.memberSelect': '选择会员',
  'pages.settlement.memberWithdrawalReview.contentRequired': '请输入内容',
  'pages.settlement.memberWithdrawalReview.contentPlaceholder': '输入存款增加或扣除的原因',
  'pages.settlement.memberWithdrawalReview.amountRequired': '请输入金额',
  'pages.settlement.memberWithdrawalReview.amountMin': '金额必须至少为1韩元',
  'pages.settlement.memberWithdrawalReview.amountPlaceholder': '输入金额',
  'pages.settlement.memberWithdrawalReview.registrationSuccess': '注册成功',
  'pages.settlement.memberWithdrawalReview.registrationFailed': '注册失败',
  'pages.settlement.memberWithdrawalReview.direction': '累积/扣减',
  'pages.settlement.memberWithdrawalReview.direction.add': '累积',
  'pages.settlement.memberWithdrawalReview.direction.subtract': '扣减',
  'pages.settlement.memberWithdrawalReview.currentBalance': '当前预存款余额',
  'pages.settlement.memberWithdrawalReview.negativeWarning': '扣减后余额将为负数，服务器会拒绝此操作。',
  'pages.settlement.memberWithdrawalReview.submit': '注册',
  'pages.settlement.memberWithdrawalReview.memberRequired': '请选择会员',
  'pages.settlement.memberWithdrawalReview.noMemberFound': '未找到会员',
  
  // Settlement - Platform
  'pages.settlement.platform.title': '平台费用结算',
  'pages.settlement.platform.tableTitle': '月度费用历史',
  'pages.settlement.platform.exportExcel': '导出Excel',
  'pages.settlement.platform.exportExcelSuccess': 'Excel文件下载已开始',
  'pages.settlement.platform.downloadReport': '下载报告',
  'pages.settlement.platform.month': '{month}月',
  'pages.settlement.platform.year': '{year}年',
  'pages.settlement.platform.stat.totalRevenueThisMonth': '本月总收入',
  'pages.settlement.platform.stat.commissionRevenue': '佣金收入',
  'pages.settlement.platform.stat.shippingFeeRevenue': '运费收入',
  'pages.settlement.platform.stat.monthOverMonth': '环比',
  'pages.settlement.platform.chart.title': '月度收入趋势',
  'pages.settlement.platform.column.id': 'ID',
  'pages.settlement.platform.column.period': '结算期间',
  'pages.settlement.platform.column.year': '年份',
  'pages.settlement.platform.column.month': '月份',
  'pages.settlement.platform.column.totalSales': '总销售额',
  'pages.settlement.platform.column.commissionRate': '佣金率',
  'pages.settlement.platform.column.commissionAmount': '佣金收入',
  'pages.settlement.platform.column.shippingFee': '运费收入',
  'pages.settlement.platform.column.additionalFee': '其他收入',
  'pages.settlement.platform.column.totalFee': '总收入',
  'pages.settlement.platform.column.orderSeller': '订单/卖家',
  'pages.settlement.platform.column.avgOrderValue': '平均订单价值',
  'pages.settlement.platform.column.growthRate': '增长率',
  'pages.settlement.platform.column.action': '操作',
  'pages.settlement.platform.detailModal.title': '费用详情 - {period}',
  'pages.settlement.platform.detail.revenueSummary': '收入摘要',
  'pages.settlement.platform.detail.revenueDetail': '收入详情',
  'pages.settlement.platform.detail.growthMetrics': '增长指标',
  'pages.settlement.platform.detail.revenueComposition': '收入构成',
  'pages.settlement.platform.detail.period': '结算期间',
  'pages.settlement.platform.detail.totalSales': '总销售额',
  'pages.settlement.platform.detail.orderCount': '订单数',
  'pages.settlement.platform.detail.sellerCount': '卖家数',
  'pages.settlement.platform.detail.avgOrderValue': '平均订单价值',
  'pages.settlement.platform.detail.platformCommission': '平台佣金 ({rate}%)',
  'pages.settlement.platform.detail.shippingFeeRevenue': '运费收入',
  'pages.settlement.platform.detail.additionalRevenue': '其他收入',
  'pages.settlement.platform.detail.totalRevenue': '总收入',
  'pages.settlement.platform.detail.monthOverMonthGrowth': '环比增长率',
  'pages.settlement.platform.detail.profitRate': '利润率',
  'pages.settlement.platform.detail.platformCommissionLabel': '平台佣金',
  'pages.settlement.platform.detail.shippingFeeRevenueLabel': '运费收入',
  'pages.settlement.platform.detail.additionalRevenueLabel': '其他收入',

  // Settlement - Coupons (moved from members)
  'pages.settlement.coupons.title': '积分/优惠券设置',

  // Members - Statistics
  'pages.members.statistics.title': '会员统计',
  'pages.members.statistics.cumulativeRegisteredUsers': '累计注册用户',
  'pages.members.statistics.visitors': '访客数',
  'pages.members.statistics.newUsers': '新用户数',
  'pages.members.statistics.orderTransactionUsers': '订单交易用户数',
  'pages.members.statistics.waybillTransactionUsers': '运单交易用户数',
  'pages.members.statistics.dateRange': '查询期间',
  'pages.members.statistics.query': '查询',
  'pages.members.statistics.reset': '重置',
  'pages.members.statistics.pageViews': '浏览量',
  'pages.members.statistics.trendChart': '会员统计趋势',
  'pages.members.statistics.chart.cumulativeRegisteredUsers': '累计注册用户趋势',
  'pages.members.statistics.chart.visitors': '访客数趋势',
  'pages.members.statistics.chart.pageViews': '浏览量',
  'pages.members.statistics.chart.newUsers': '新用户数趋势',
  'pages.members.statistics.chart.orderTransactionUsers': '订单交易用户数趋势',
  'pages.members.statistics.chart.waybillTransactionUsers': '运单交易用户数趋势',

  // Settlement - Product Price Increase
  'pages.settlement.productPriceIncrease.title': '商品价格上调',
  'pages.settlement.productPriceIncrease.addTitle': '添加商品价格上调',
  'pages.settlement.productPriceIncrease.editTitle': '编辑商品价格上调',
  'pages.settlement.productPriceIncrease.deleteConfirm': '删除商品价格上调',
  'pages.settlement.productPriceIncrease.deleteConfirmContent': '确定要删除 ID "{id}" 价格范围的价格上调信息吗？',
  'pages.settlement.productPriceIncrease.deleteSuccess': '商品价格上调信息已删除',
  'pages.settlement.productPriceIncrease.deleteError': '删除价格上调设置失败',
  'pages.settlement.productPriceIncrease.fetchError': '获取价格上调设置失败',
  'pages.settlement.productPriceIncrease.updateSuccess': '商品价格上调信息已更新',
  'pages.settlement.productPriceIncrease.createSuccess': '商品价格上调信息已创建',
  'pages.settlement.productPriceIncrease.submitError': '保存商品价格上调信息时出错',
  'pages.settlement.productPriceIncrease.approve': '批准',
  'pages.settlement.productPriceIncrease.reject': '拒绝',
  'pages.settlement.productPriceIncrease.approveSuccess': '价格上调已批准',
  'pages.settlement.productPriceIncrease.rejectSuccess': '价格上调已拒绝',
  'pages.settlement.productPriceIncrease.statistics.total': '总计',
  'pages.settlement.productPriceIncrease.statistics.pending': '待处理',
  'pages.settlement.productPriceIncrease.statistics.approved': '已批准',
  'pages.settlement.productPriceIncrease.statistics.totalIncrease': '总上调额',
  'pages.settlement.productPriceIncrease.serviceFee.title': '服务费',
  'pages.settlement.productPriceIncrease.serviceFee.feeAmount': '服务费金额',
  'pages.settlement.productPriceIncrease.serviceFee.enterFee': '请输入服务费',
  'pages.settlement.productPriceIncrease.serviceFee.register': '登记',
  'pages.settlement.productPriceIncrease.serviceFee.required': '请输入服务费',
  'pages.settlement.productPriceIncrease.serviceFee.updateSuccess': '服务费已更新',
  'pages.settlement.productPriceIncrease.serviceFee.updateError': '更新服务费失败',
  'pages.settlement.productPriceIncrease.column.id': 'ID',
  'pages.settlement.productPriceIncrease.column.startingPrice': '起始价格',
  'pages.settlement.productPriceIncrease.column.endPrice': '结束价格',
  'pages.settlement.productPriceIncrease.column.increaseType': '价格上调类型',
  'pages.settlement.productPriceIncrease.column.addValue': '增加值',
  'pages.settlement.productPriceIncrease.column.operate': '操作',
  'pages.settlement.productPriceIncrease.column.productCode': '商品代码',
  'pages.settlement.productPriceIncrease.column.productName': '商品名称',
  'pages.settlement.productPriceIncrease.column.category': '类别',
  'pages.settlement.productPriceIncrease.column.currentPrice': '当前价格',
  'pages.settlement.productPriceIncrease.column.increaseValue': '上调值',
  'pages.settlement.productPriceIncrease.column.newPrice': '新价格',
  'pages.settlement.productPriceIncrease.column.effectiveDate': '生效日期',
  'pages.settlement.productPriceIncrease.column.reason': '原因',
  'pages.settlement.productPriceIncrease.column.status': '状态',
  'pages.settlement.productPriceIncrease.increaseType.percent': '百分比',
  'pages.settlement.productPriceIncrease.increaseType.fixed': '固定',
  'pages.settlement.productPriceIncrease.status.pending': '待处理',
  'pages.settlement.productPriceIncrease.status.approved': '已批准',
  'pages.settlement.productPriceIncrease.status.rejected': '已拒绝',
  'pages.settlement.productPriceIncrease.status.active': '激活',
  'pages.settlement.productPriceIncrease.form.startingPrice': '起始价格',
  'pages.settlement.productPriceIncrease.form.startingPriceRequired': '请输入起始价格',
  'pages.settlement.productPriceIncrease.form.endPrice': '结束价格',
  'pages.settlement.productPriceIncrease.form.endPriceRequired': '请输入结束价格',
  'pages.settlement.productPriceIncrease.form.endPricePlaceholder': '输入999999999表示无限制',
  'pages.settlement.productPriceIncrease.form.increaseType': '价格上调类型',
  'pages.settlement.productPriceIncrease.form.increaseTypeRequired': '请选择价格上调类型',
  'pages.settlement.productPriceIncrease.form.addValue': '增加值',
  'pages.settlement.productPriceIncrease.form.addValueRequired': '请输入增加值',
  'pages.settlement.productPriceIncrease.form.productCode': '商品代码',
  'pages.settlement.productPriceIncrease.form.productCodeRequired': '请输入商品代码',
  'pages.settlement.productPriceIncrease.form.productName': '商品名称',
  'pages.settlement.productPriceIncrease.form.productNameRequired': '请输入商品名称',
  'pages.settlement.productPriceIncrease.form.currentPrice': '当前价格',
  'pages.settlement.productPriceIncrease.form.currentPriceRequired': '请输入当前价格',
  'pages.settlement.productPriceIncrease.form.increaseValue': '上调值',
  'pages.settlement.productPriceIncrease.form.increaseValueRequired': '请输入上调值',
  'pages.settlement.productPriceIncrease.form.effectiveDate': '生效日期',
  'pages.settlement.productPriceIncrease.form.effectiveDateRequired': '请选择生效日期',
  'pages.settlement.productPriceIncrease.form.reason': '原因',
  'pages.settlement.productPriceIncrease.form.reasonRequired': '请输入原因',

  // Settlement - Service Fee
  'pages.settlement.serviceFee.title': '服务费',
  'pages.settlement.serviceFee.addTitle': '添加服务费',
  'pages.settlement.serviceFee.editTitle': '编辑服务费',
  'pages.settlement.serviceFee.deleteConfirm': '删除服务费',
  'pages.settlement.serviceFee.deleteConfirmContent': '确定要删除服务费 "{serviceName}" 吗？',
  'pages.settlement.serviceFee.deleteSuccess': '服务费已删除',
  'pages.settlement.serviceFee.updateSuccess': '服务费已更新',
  'pages.settlement.serviceFee.createSuccess': '服务费已创建',
  'pages.settlement.serviceFee.submitError': '保存服务费时出错',
  'pages.settlement.serviceFee.statistics.total': '总计',
  'pages.settlement.serviceFee.statistics.active': '激活',
  'pages.settlement.serviceFee.statistics.inactive': '未激活',
  'pages.settlement.serviceFee.column.serviceType': '服务类型',
  'pages.settlement.serviceFee.column.serviceName': '服务名称',
  'pages.settlement.serviceFee.column.usageType': '使用类型',
  'pages.settlement.serviceFee.column.operate': '操作',
  'pages.settlement.serviceFee.column.feeType': '费用类型',
  'pages.settlement.serviceFee.column.feeValue': '费用值',
  'pages.settlement.serviceFee.column.minAmount': '最小金额',
  'pages.settlement.serviceFee.column.maxAmount': '最大金额',
  'pages.settlement.serviceFee.column.applicableTo': '适用对象',
  'pages.settlement.serviceFee.column.isActive': '激活',
  'pages.settlement.serviceFee.column.effectiveDate': '生效日期',
  'pages.settlement.serviceFee.serviceType.payment': '支付',
  'pages.settlement.serviceFee.serviceType.shipping': '配送',
  'pages.settlement.serviceFee.serviceType.platform': '平台',
  'pages.settlement.serviceFee.serviceType.storage': '仓储',
  'pages.settlement.serviceFee.feeType.fixed': '固定',
  'pages.settlement.serviceFee.feeType.percent': '百分比',
  'pages.settlement.serviceFee.feeType.tiered': '分层',
  'pages.settlement.serviceFee.form.serviceType': '服务类型',
  'pages.settlement.serviceFee.form.serviceTypeRequired': '请选择服务类型',
  'pages.settlement.serviceFee.form.serviceName': '服务名称',
  'pages.settlement.serviceFee.form.serviceNameRequired': '请输入服务名称',
  'pages.settlement.serviceFee.form.feeType': '费用类型',
  'pages.settlement.serviceFee.form.feeTypeRequired': '请选择费用类型',
  'pages.settlement.serviceFee.form.feeValue': '费用值',
  'pages.settlement.serviceFee.form.feeValueRequired': '请输入费用值',
  'pages.settlement.serviceFee.form.minAmount': '最小金额',
  'pages.settlement.serviceFee.form.maxAmount': '最大金额',
  'pages.settlement.serviceFee.form.effectiveDate': '生效日期',
  'pages.settlement.serviceFee.form.effectiveDateRequired': '请选择生效日期',
  'pages.settlement.serviceFee.form.description': '描述',
  'pages.settlement.serviceFee.form.isActive': '激活',
  
  // Settlement - Member Recharge Review
  'pages.settlement.memberRechargeReview.filter.group.title': '状态',
  'pages.settlement.memberRechargeReview.filter.pendingReview': '审核待处理',
  'pages.settlement.memberRechargeReview.filter.approvalSuccessful': '审核成功',
  'pages.settlement.memberRechargeReview.filter.reviewFailed': '审核失败',
  'pages.settlement.memberRechargeReview.column.userId': '用户 ID',
  'pages.settlement.memberRechargeReview.column.user': '用户',
  'pages.settlement.memberRechargeReview.column.remittanceMethod': '汇款方式',
  'pages.settlement.memberRechargeReview.column.remitterName': '汇款人姓名',
  'pages.settlement.memberRechargeReview.column.rechargeCurrencyAndAmount': '充值货币金额',
  'pages.settlement.memberRechargeReview.column.receivedCurrencyAndAmount': '存款货币金额',
  'pages.settlement.memberRechargeReview.column.serviceFee': '服务费',
  'pages.settlement.memberRechargeReview.column.receivingBankInformation': '收款银行信息',
  'pages.settlement.memberRechargeReview.column.addTime': '添加时间',
  'pages.settlement.memberRechargeReview.approve': '审核成功',
  'pages.settlement.memberRechargeReview.reject': '审核失败',
  'pages.settlement.memberRechargeReview.rejectTitle': '输入拒绝原因',
  'pages.settlement.memberRechargeReview.rejectionReason': '拒绝原因',
  'pages.settlement.memberRechargeReview.rejectionReasonRequired': '请输入拒绝原因',
  'pages.settlement.memberRechargeReview.rejectionReasonPlaceholder': '请输入拒绝原因',
  'pages.settlement.memberRechargeReview.viewReason': '查看原因',
  'pages.settlement.memberRechargeReview.viewReasonTitle': '拒绝原因',
  'pages.settlement.memberRechargeReview.receivingAccount': '收款账户',
  'pages.settlement.memberRechargeReview.receivingAccountManagement': '收款账户管理',
  'pages.settlement.memberRechargeReview.bankName': '银行名称',
  'pages.settlement.memberRechargeReview.bankNameRequired': '请输入银行名称',
  'pages.settlement.memberRechargeReview.accountNumber': '账户号码',
  'pages.settlement.memberRechargeReview.accountNumberRequired': '请输入账户号码',
  'pages.settlement.memberRechargeReview.accountHolder': '账户持有人',
  'pages.settlement.memberRechargeReview.accountHolderRequired': '请输入账户持有人',
  'pages.settlement.memberRechargeReview.currency': '货币',
  'pages.settlement.memberRechargeReview.currencyRequired': '请选择货币',
  'pages.settlement.memberRechargeReview.isActive': '激活状态',
  'pages.settlement.memberRechargeReview.accountList': '账户列表',
  'pages.settlement.memberRechargeReview.accountAdded': '账户已添加',
  'pages.settlement.memberRechargeReview.accountUpdated': '账户已更新',
  'pages.settlement.memberRechargeReview.accountStatusUpdated': '状态已更新',
  'pages.settlement.memberRechargeReview.accountError': '发生错误',
  'pages.settlement.memberRechargeReview.selectOrDateRequired': '请选择日期或项目',
  'pages.settlement.memberRechargeReview.exportSuccess': '已导出 {count} 项',
  'pages.settlement.memberRechargeReview.receivingBankInfo': '收款银行信息',

  // Settlement - Member Withdrawal Review
  'pages.settlement.memberWithdrawalReview.filter.group.title': '状态',
  'pages.settlement.memberWithdrawalReview.filter.pendingReview': '审核待处理',
  'pages.settlement.memberWithdrawalReview.filter.approvalSuccessful': '审核成功',
  'pages.settlement.memberWithdrawalReview.filter.reviewFailed': '审核失败',
  'pages.settlement.memberWithdrawalReview.column.userId': '用户 ID',
  'pages.settlement.memberWithdrawalReview.column.user': '用户',
  'pages.settlement.memberWithdrawalReview.column.handlingFee': '手续费',
  'pages.settlement.memberWithdrawalReview.column.withdrawalAmount': '提现金额',
  'pages.settlement.memberWithdrawalReview.column.amountReceived': '存款金额',
  'pages.settlement.memberWithdrawalReview.column.bankCardName': '银行卡名称',
  'pages.settlement.memberWithdrawalReview.column.bankCardNumber': '银行卡账户号码',
  'pages.settlement.memberWithdrawalReview.column.bankCardHolder': '银行卡所有者',
  'pages.settlement.memberWithdrawalReview.column.withdrawalTime': '提现时间',
  'pages.settlement.memberWithdrawalReview.approve': '审核成功',
  'pages.settlement.memberWithdrawalReview.reject': '审核失败',
  'pages.settlement.memberWithdrawalReview.approveConfirm': '确定要批准吗？',
  'pages.settlement.memberWithdrawalReview.approveContent': '确定要批准用户 "{name}" 的 {amount} 提现吗？',
  'pages.settlement.memberWithdrawalReview.approved': '已批准',
  'pages.settlement.memberWithdrawalReview.rejectTitle': '输入拒绝原因',
  'pages.settlement.memberWithdrawalReview.rejectionReason': '拒绝原因',
  'pages.settlement.memberWithdrawalReview.rejectionReasonRequired': '请输入拒绝原因',
  'pages.settlement.memberWithdrawalReview.rejectionReasonPlaceholder': '请输入拒绝原因',
  'pages.settlement.memberWithdrawalReview.rejected': '已拒绝',
  'pages.settlement.memberWithdrawalReview.rejectError': '发生错误',
  'pages.settlement.memberWithdrawalReview.viewReason': '查看原因',
  'pages.settlement.memberWithdrawalReview.viewReasonTitle': '拒绝原因',
  'pages.settlement.memberWithdrawalReview.withdrawalFeeSettings': '提现手续费设置',
  'pages.settlement.memberWithdrawalReview.feeSettingName': '名称',
  'pages.settlement.memberWithdrawalReview.feeSettingNameRequired': '请输入名称',
  'pages.settlement.memberWithdrawalReview.feeType': '手续费类型',
  'pages.settlement.memberWithdrawalReview.feeTypeRequired': '请选择手续费类型',
  'pages.settlement.memberWithdrawalReview.feeTypeNone': '① 手续费=0',
  'pages.settlement.memberWithdrawalReview.feeTypePercentage': '② 手续费=提现金额×手续费比率',
  'pages.settlement.memberWithdrawalReview.feeTypeFixed': '③ 手续费=固定提现手续费',
  'pages.settlement.memberWithdrawalReview.feeRate': '手续费比率',
  'pages.settlement.memberWithdrawalReview.feeRateRequired': '请输入手续费比率',
  'pages.settlement.memberWithdrawalReview.fixedFee': '固定提现手续费',
  'pages.settlement.memberWithdrawalReview.fixedFeeRequired': '请输入固定提现手续费',
  'pages.settlement.memberWithdrawalReview.minWithdrawalAmount': '最小提现金额',
  'pages.settlement.memberWithdrawalReview.minWithdrawalAmountRequired': '请输入最小提现金额',
  'pages.settlement.memberWithdrawalReview.maxWithdrawalAmount': '最大提现金额',
  'pages.settlement.memberWithdrawalReview.maxWithdrawalAmountRequired': '请输入最大提现金额',
  'pages.settlement.memberWithdrawalReview.feeSettingsList': '手续费设置列表',
  'pages.settlement.memberWithdrawalReview.feeSettingAdded': '手续费设置已添加',
  'pages.settlement.memberWithdrawalReview.feeSettingError': '发生错误',
  'pages.settlement.memberWithdrawalReview.minMaxAmount': '最小/最大提现金额',
  'pages.settlement.memberWithdrawalReview.financialTaxReport': '财务税务报告',
  'pages.settlement.memberWithdrawalReview.taxReportDownloaded': '财务税务报告已下载',

  // ── Member Recharge Review (new design) ──────────────────────
  'pages.settlement.memberRechargeReview.header.title': '押金申请明细',
  'pages.settlement.memberRechargeReview.list.title': '押金申请明细列表',
  'pages.settlement.memberRechargeReview.period.today': '今日',
  'pages.settlement.memberRechargeReview.period.month': '本月',
  'pages.settlement.memberRechargeReview.period.quarter': '本季度',
  'pages.settlement.memberRechargeReview.period.year': '本年',
  'pages.settlement.memberRechargeReview.period.todayRecharge': '今日充值申请',
  'pages.settlement.memberRechargeReview.period.todayWithdraw': '今日提现申请',
  'pages.settlement.memberRechargeReview.stat.amount': '金额',
  'pages.settlement.memberRechargeReview.stat.count': '件数',
  'pages.settlement.memberRechargeReview.chart.rechargeAmount': '充值金额',
  'pages.settlement.memberRechargeReview.chart.withdrawAmount': '提现金额',
  'pages.settlement.memberRechargeReview.chart.rechargeCount': '充值件数',
  'pages.settlement.memberRechargeReview.chart.withdrawCount': '提现件数',
  'pages.settlement.memberRechargeReview.info.description': '本部分是押金充值及提现明细。',
  'pages.settlement.memberRechargeReview.info.relation': '与银行入金及提现相关。',
  'pages.settlement.memberRechargeReview.viewMode.detail': '详细查看',
  'pages.settlement.memberRechargeReview.viewMode.summary': '简要查看',
  'pages.settlement.memberRechargeReview.filter.startTime': '开始时间',
  'pages.settlement.memberRechargeReview.filter.endTime': '结束时间',
  'pages.settlement.memberRechargeReview.filter.applicationType': '申请类型',
  'pages.settlement.memberRechargeReview.filter.completionStatus': '处理状态',
  'pages.settlement.memberRechargeReview.filter.search': '搜索',
  'pages.settlement.memberRechargeReview.filter.mailbox': '邮箱',
  'pages.settlement.memberRechargeReview.filter.orderNumber': '订单号',
  'pages.settlement.memberRechargeReview.filter.memberName': '会员名',
  'pages.settlement.memberRechargeReview.filter.financeManager': '财务负责人',
  'pages.settlement.memberRechargeReview.applicationType.recharge': '充值',
  'pages.settlement.memberRechargeReview.applicationType.withdraw': '提现',
  'pages.settlement.memberRechargeReview.completionStatus.pending': '待审批',
  'pages.settlement.memberRechargeReview.completionStatus.completed': '已批准',
  'pages.settlement.memberRechargeReview.completionStatus.cancelled': '已拒绝',
  'pages.settlement.memberRechargeReview.completionStatus.rejected': '已拒绝',
  'pages.settlement.memberRechargeReview.column.no': '编号',
  'pages.settlement.memberRechargeReview.column.mailboxMember': '邮箱 / 会员',
  'pages.settlement.memberRechargeReview.column.applicationTypeAndDate': '申请类型 / 申请时间',
  'pages.settlement.memberRechargeReview.column.depositBalance': '押金余额',
  'pages.settlement.memberRechargeReview.column.rechargeAmountSerial': '[申请] 充值金额 / 流水号',
  'pages.settlement.memberRechargeReview.column.depositorName': '充值入金人',
  'pages.settlement.memberRechargeReview.column.matchedDepositorAdmin': '入金人匹配 / 管理员',
  'pages.settlement.memberRechargeReview.column.withdrawalAmountSerial': '[申请] 提现金额 / 流水号',
  'pages.settlement.memberRechargeReview.column.withdrawalRecipient': '提现收款人 / 银行 / 账号',
  'pages.settlement.memberRechargeReview.column.balanceAfter': '变动后余额',
  'pages.settlement.memberRechargeReview.column.completionStatusAndDate': '处理状态 / 处理时间',
  'pages.settlement.memberRechargeReview.column.financeAdminCheckedAt': '财务负责人确认时间',
  'pages.settlement.memberRechargeReview.action.edit': '编辑',
  'pages.settlement.memberRechargeReview.action.confirm': '批准',
  'pages.settlement.memberRechargeReview.action.cancel': '取消',
  'pages.settlement.memberRechargeReview.action.approve': '批准',
  'pages.settlement.memberRechargeReview.action.reject': '拒绝',
  'pages.settlement.memberRechargeReview.confirmInfoRequired': '需要确认信息和金额。',
  'pages.settlement.memberRechargeReview.fetchError': '获取押金申请数据失败',
  'pages.settlement.memberRechargeReview.updateRemitterError': '更新入金人姓名失败',
  'pages.settlement.memberRechargeReview.confirmModal.title': '批准押金申请',
  'pages.settlement.memberRechargeReview.confirmModal.mailbox': '邮箱',
  'pages.settlement.memberRechargeReview.confirmModal.memberName': '会员',
  'pages.settlement.memberRechargeReview.confirmModal.type': '类型',
  'pages.settlement.memberRechargeReview.confirmModal.amount': '金额',
  'pages.settlement.memberRechargeReview.confirmModal.amountRequired': '请输入金额。',
  'pages.settlement.memberRechargeReview.confirmModal.confirmInfo': '我已确认申请信息和金额',
  'pages.settlement.memberRechargeReview.confirmModal.confirmInfoRequired': '需要确认信息和金额。',
  'pages.settlement.memberRechargeReview.confirmModal.ok': '批准',
  'pages.settlement.memberRechargeReview.confirmModal.cancel': '取消',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.open': '代办提现登记',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.title': '代办提现登记',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.hint':
    '用于将无法登录的游客订单退款金额支付到银行账户。金额将从押金中冻结并生成提现申请，实际转账后审批即可完成。',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumber': '订单号',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumberPlaceholder': '退款订单号',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumberRequired': '请输入订单号',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.amount': '提现金额',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.amountRequired': '请输入提现金额',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.bankName': '银行',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.accountNumber': '账户号码',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.accountHolder': '账户名',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.description': '备注',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.descriptionPlaceholder': '账户确认方式等（选填）',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.ok': '登记',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.success': '代办提现已登记',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.error': '代办提现登记失败',
  'pages.settlement.memberRechargeReview.editDepositorModal.title': '入金人手动匹配',
  'pages.settlement.memberRechargeReview.editDepositorModal.original': '原入金人',
  'pages.settlement.memberRechargeReview.editDepositorModal.matched': '匹配入金人',
  'pages.settlement.memberRechargeReview.editDepositorModal.matchedPlaceholder': '请输入匹配入金人',
  'pages.settlement.memberRechargeReview.editDepositorModal.admin': '处理管理员',
  'pages.settlement.memberRechargeReview.editDepositorModal.adminPlaceholder': '管理员名',
  'pages.settlement.memberRechargeReview.editDepositorModal.success': '入金人手动匹配信息已保存。',
  'pages.settlement.memberRechargeReview.editDepositorModal.save': '保存',

  // ── Member Withdrawal Review (new design) ────────────────────
  'pages.settlement.memberWithdrawalReview.header.title': '押金使用明细',
  'pages.settlement.memberWithdrawalReview.list.title': '[税务结算管理用] 押金使用明细列表',
  'pages.settlement.memberWithdrawalReview.stat.todayBalance': '今日余额',
  'pages.settlement.memberWithdrawalReview.stat.lastMonthEndBalance': '上月末余额',
  'pages.settlement.memberWithdrawalReview.stat.monthlyBalance': '月度余额',
  'pages.settlement.memberWithdrawalReview.stat.todayRecharge': '今日充值',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthRecharge': '本月充值',
  'pages.settlement.memberWithdrawalReview.stat.monthlyRecharge': '月度充值',
  'pages.settlement.memberWithdrawalReview.stat.todayWithdraw': '今日提现',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthWithdraw': '本月提现',
  'pages.settlement.memberWithdrawalReview.stat.monthlyWithdraw': '月度提现',
  'pages.settlement.memberWithdrawalReview.stat.todayUse': '今日使用',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthUse': '本月使用',
  'pages.settlement.memberWithdrawalReview.stat.monthlyUse': '月度使用',
  'pages.settlement.memberWithdrawalReview.stat.todayDeduct': '今日扣减',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthDeduct': '本月扣减',
  'pages.settlement.memberWithdrawalReview.stat.monthlyDeduct': '月度扣减',
  'pages.settlement.memberWithdrawalReview.stat.todayEarn': '今日累积',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthEarn': '本月累积',
  'pages.settlement.memberWithdrawalReview.stat.monthlyEarn': '月度累积',
  'pages.settlement.memberWithdrawalReview.category.order': '订单',
  'pages.settlement.memberWithdrawalReview.category.bankRefund': '银行退款',
  'pages.settlement.memberWithdrawalReview.category.rebate': '返利',
  'pages.settlement.memberWithdrawalReview.category.share': '分享',
  'pages.settlement.memberWithdrawalReview.viewMode.detail': '详细查看',
  'pages.settlement.memberWithdrawalReview.viewMode.summary': '简要查看',
  'pages.settlement.memberWithdrawalReview.filter.startTime': '开始时间',
  'pages.settlement.memberWithdrawalReview.filter.endTime': '结束时间',
  'pages.settlement.memberWithdrawalReview.filter.earningCategory': '累积类型',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.bankRefund': '银行退款',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.rebate': '返利累积',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.share': '分享累积',
  'pages.settlement.memberWithdrawalReview.filter.deductionCategory': '扣减类型',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.order': '订单',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.rebate': '返利扣减',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.share': '分享扣减',
  'pages.settlement.memberWithdrawalReview.filter.bankCategory': '银行充值/提现',
  'pages.settlement.memberWithdrawalReview.filter.bankOption.recharge': '充值',
  'pages.settlement.memberWithdrawalReview.filter.bankOption.withdraw': '提现',
  'pages.settlement.memberWithdrawalReview.filter.serialSearch': '流水号搜索',
  'pages.settlement.memberWithdrawalReview.filter.serialPlaceholder': '选择筛选后输入流水号...',
  'pages.settlement.memberWithdrawalReview.filter.mailbox': '邮箱',
  'pages.settlement.memberWithdrawalReview.filter.orderNumber': '订单号',
  'pages.settlement.memberWithdrawalReview.filter.memberName': '会员名',
  'pages.settlement.memberWithdrawalReview.filter.memo': '备注',
  'pages.settlement.memberWithdrawalReview.filter.search': '搜索',
  'pages.settlement.memberWithdrawalReview.column.no': '编号',
  'pages.settlement.memberWithdrawalReview.column.mailboxMember': '邮箱 / 会员',
  'pages.settlement.memberWithdrawalReview.column.memo': '备注',
  'pages.settlement.memberWithdrawalReview.column.carryover': '结转余额',
  'pages.settlement.memberWithdrawalReview.column.bankRefund': '银行退款编号 / 金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.rebateEarn': '返利累积编号 / 金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.shareEarn': '分享累积编号 / 金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.bankRecharge': '银行充值编号 / 金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.order': '订单号 / 使用金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.rebateDeduct': '返利扣减编号 / 金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.shareDeduct': '分享扣减编号 / 金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.bankWithdraw': '银行提现编号 / 金额 / 时间',
  'pages.settlement.memberWithdrawalReview.column.balanceAfter': '变动后余额',
  'pages.settlement.memberWithdrawalReview.column.adminChangedAt': '管理员变动时间',
  'pages.settlement.memberWithdrawalReview.legend.earning': '● 累积（加）金额',
  'pages.settlement.memberWithdrawalReview.legend.deduction': '● 扣减（减）金额',

  // Settlement - Financial Tax Report
  'pages.settlement.financialTaxReport.title': '财务税务报告',
  'pages.settlement.financialTaxReport.column.date': '日期',
  'pages.settlement.financialTaxReport.column.transactionType': '交易类型',
  'pages.settlement.financialTaxReport.column.amount': '金额',
  'pages.settlement.financialTaxReport.column.description': '说明',
  'pages.settlement.financialTaxReport.column.taxAmount': '税额',
  'pages.settlement.financialTaxReport.download': '下载',
  'pages.settlement.financialTaxReport.downloadSuccess': '财务税务报告已下载',
  
  // Settlement - Management
  'pages.settlement.management.title': '财务管理',
  'pages.settlement.management.breadcrumb': '财务管理',
  'pages.settlement.management.tab.platformCommission': '平台手续费',
  'pages.settlement.management.tab.sellers': '卖家结算',
  'pages.settlement.management.platform.content': '平台手续费结算明细',
  'pages.settlement.management.platform.description': '月度手续费收入及统计',
  'pages.settlement.management.sellers.content': '卖家结算处理',
  'pages.settlement.management.sellers.description': '按卖家的结算明细及处理',
  
  // Logistics - Batch Tracking
  'pages.logistics.batchTracking.title': '批量运单录入',
  'pages.logistics.batchTracking.subTitle': '可以使用Excel文件一次性注册多个订单的运单',
  'pages.logistics.batchTracking.selectFile': '请选择文件',
  'pages.logistics.batchTracking.uploadSuccess': '文件上传完成',
  'pages.logistics.batchTracking.processSuccess': '运单注册完成',
  'pages.logistics.batchTracking.downloadTemplateSuccess': '模板文件下载已开始',
  'pages.logistics.batchTracking.downloadTemplate': '下载模板',
  'pages.logistics.batchTracking.uploadFile': '上传文件',
  'pages.logistics.batchTracking.manualInput': '手动输入',
  'pages.logistics.batchTracking.selectExcelFile': '选择Excel文件',
  'pages.logistics.batchTracking.noErrors': '没有错误',
  'pages.logistics.batchTracking.downloadErrorsSuccess': '正在下载 {count} 条错误数据',
  'pages.logistics.batchTracking.downloadErrors': '下载错误数据',
  'pages.logistics.batchTracking.customer': '客户{num}',
  'pages.logistics.batchTracking.error.emptyTrackingNumber': '运单号为空',
  'pages.logistics.batchTracking.notEntered': '未输入',
  'pages.logistics.batchTracking.step.upload.title': '文件上传',
  'pages.logistics.batchTracking.step.upload.description': '选择Excel文件',
  'pages.logistics.batchTracking.step.review.title': '数据确认',
  'pages.logistics.batchTracking.step.review.description': '验证上传的数据',
  'pages.logistics.batchTracking.step.complete.title': '注册完成',
  'pages.logistics.batchTracking.step.complete.description': '运单注册完成',
  'pages.logistics.batchTracking.uploadGuide.title': 'Excel文件上传指南',
  'pages.logistics.batchTracking.uploadGuide.format': '• 支持格式: .xlsx, .xls',
  'pages.logistics.batchTracking.uploadGuide.columns': '• 必需列: 订单号, 运单号, 快递公司, 发货日期',
  'pages.logistics.batchTracking.uploadGuide.maxCount': '• 最多可一次性注册1,000条',
  'pages.logistics.batchTracking.uploadGuide.template': '• 请下载模板文件并按格式填写',
  'pages.logistics.batchTracking.column.status': '状态',
  'pages.logistics.batchTracking.column.orderNo': '订单号',
  'pages.logistics.batchTracking.column.customerName': '客户名称',
  'pages.logistics.batchTracking.column.productCount': '商品数',
  'pages.logistics.batchTracking.column.trackingNumber': '运单号',
  'pages.logistics.batchTracking.column.carrier': '快递公司',
  'pages.logistics.batchTracking.column.shippingDate': '发货日期',
  'pages.logistics.batchTracking.column.errorMessage': '错误消息',
  'pages.logistics.batchTracking.status.success': '成功',
  'pages.logistics.batchTracking.status.error': '错误',
  'pages.logistics.batchTracking.status.pending': '待处理',
  'pages.logistics.batchTracking.stat.total': '总计',
  'pages.logistics.batchTracking.stat.success': '正常',
  'pages.logistics.batchTracking.stat.error': '错误',
  'pages.logistics.batchTracking.stat.pending': '待处理',
  'pages.logistics.batchTracking.errorsFound': '发现 {count} 条错误',
  'pages.logistics.batchTracking.errorsDescription': '有错误的项目不会被注册。请下载错误数据，修改后重新上传。',
  'pages.logistics.batchTracking.uploadedData': '上传的数据 ({count} 条)',
  'pages.logistics.batchTracking.reupload': '重新上传',
  'pages.logistics.batchTracking.registerTracking': '注册运单 ({count} 条)',
  'pages.logistics.batchTracking.completeTitle': '运单注册完成',
  'pages.logistics.batchTracking.completeDescription': '共有 {count} 条运单成功注册',
  'pages.logistics.batchTracking.errorsExist': '有 {count} 条错误',
  'pages.logistics.batchTracking.errorsNotRegistered': '有错误的项目未注册',
  'pages.logistics.batchTracking.registerAgain': '重新注册',
  'pages.logistics.batchTracking.goToOrders': '前往订单管理',
  'pages.logistics.batchTracking.resultDetail': '注册结果详情',
  'pages.logistics.batchTracking.manualInputModal.title': '手动输入运单',
  'pages.logistics.batchTracking.manualInputModal.orderNo': '订单号',
  'pages.logistics.batchTracking.manualInputModal.trackingNumber': '运单号',
  'pages.logistics.batchTracking.manualInputModal.selectCarrier': '选择快递公司',
  'pages.logistics.batchTracking.manualInputModal.shippingDate': '发货日期',
  'pages.logistics.batchTracking.manualInputModal.memo': '备注 (可选)',
  'pages.logistics.batchTracking.manualInputSuccess': '运单已注册',
  'pages.logistics.batchTracking.carrier.cj': 'CJ大韩通运',
  'pages.logistics.batchTracking.carrier.post': '邮局快递',
  'pages.logistics.batchTracking.carrier.hanjin': '韩进快递',
  'pages.logistics.batchTracking.carrier.logen': '乐天快递',
  'pages.logistics.batchTracking.carrier.kdexp': '京东快递',
  
  // Logistics - Forwarders
  'pages.logistics.forwarders.title': '转运商管理',
  'pages.logistics.forwarders.addForwarder': '添加转运商',
  'pages.logistics.forwarders.deleteTitle': '删除转运商',
  'pages.logistics.forwarders.deleteConfirm': '确定要删除转运商 "{name}" 吗？',
  'pages.logistics.forwarders.deleteSuccess': '转运商已删除',
  'pages.logistics.forwarders.updateSuccess': '转运商信息已更新',
  'pages.logistics.forwarders.createSuccess': '转运商已注册',
  'pages.logistics.forwarders.apiTestLoading': '正在测试API连接...',
  'pages.logistics.forwarders.apiTestSuccess': 'API连接成功！',
  'pages.logistics.forwarders.apiSaveSuccess': 'API设置已保存',
  'pages.logistics.forwarders.syncLoading': '正在同步...',
  'pages.logistics.forwarders.syncSuccess': '{name} 数据同步完成',
  'pages.logistics.forwarders.column.id': 'ID',
  'pages.logistics.forwarders.column.name': '转运商名称',
  'pages.logistics.forwarders.column.code': '转运商代码',
  'pages.logistics.forwarders.column.apiStatus': 'API状态',
  'pages.logistics.forwarders.column.shippingMethods': '配送方式',
  'pages.logistics.forwarders.column.pricePerKg': '单价（每公斤）',
  'pages.logistics.forwarders.column.contactPerson': '负责人',
  'pages.logistics.forwarders.column.phone': '联系电话',
  'pages.logistics.forwarders.column.totalOrders': '总订单数',
  'pages.logistics.forwarders.column.lastSync': '最后同步',
  'pages.logistics.forwarders.column.status': '状态',
  'pages.logistics.forwarders.column.action': '操作',
  'pages.logistics.forwarders.type.domestic': '国内',
  'pages.logistics.forwarders.type.international': '国际',
  'pages.logistics.forwarders.apiStatus.connected': '已连接',
  'pages.logistics.forwarders.apiStatus.disconnected': '未连接',
  'pages.logistics.forwarders.apiStatus.error': '错误',
  'pages.logistics.forwarders.status.active': '活跃',
  'pages.logistics.forwarders.status.inactive': '非活跃',
  'pages.logistics.forwarders.action.apiConfig': 'API设置',
  'pages.logistics.forwarders.action.sync': '同步',
  'pages.logistics.forwarders.stat.totalForwarders': '总转运商',
  'pages.logistics.forwarders.stat.apiConnected': 'API连接',
  'pages.logistics.forwarders.stat.ordersThisMonth': '本月订单',
  'pages.logistics.forwarders.stat.avgPrice': '平均单价',
  'pages.logistics.forwarders.stat.avgPriceSuffix': '元/公斤',
  'pages.logistics.forwarders.modal.addTitle': '添加转运商',
  'pages.logistics.forwarders.modal.editTitle': '修改转运商',
  'pages.logistics.forwarders.tab.basic': '基本信息',
  'pages.logistics.forwarders.tab.contact': '负责人信息',
  'pages.logistics.forwarders.tab.memo': '备注',
  'pages.logistics.forwarders.form.name': '转运商名称',
  'pages.logistics.forwarders.form.nameRequired': '请输入转运商名称',
  'pages.logistics.forwarders.form.namePlaceholder': '例如：CJ大韩通运',
  'pages.logistics.forwarders.form.code': '转运商代码',
  'pages.logistics.forwarders.form.codeRequired': '请输入代码',
  'pages.logistics.forwarders.form.codePlaceholder': '例如：CJ',
  'pages.logistics.forwarders.form.type': '类型',
  'pages.logistics.forwarders.form.typePlaceholder': '选择类型',
  'pages.logistics.forwarders.form.pricePerKg': '单价（每公斤）',
  'pages.logistics.forwarders.form.shippingMethods': '配送方式',
  'pages.logistics.forwarders.form.shippingMethodsPlaceholder': '选择配送方式',
  'pages.logistics.forwarders.form.address': '地址',
  'pages.logistics.forwarders.form.addressPlaceholder': '转运商地址',
  'pages.logistics.forwarders.form.status': '状态',
  'pages.logistics.forwarders.form.contactPerson': '负责人姓名',
  'pages.logistics.forwarders.form.contactPersonPlaceholder': '负责人姓名',
  'pages.logistics.forwarders.form.phone': '联系电话',
  'pages.logistics.forwarders.form.phonePlaceholder': '02-1234-5678',
  'pages.logistics.forwarders.form.email': '电子邮件',
  'pages.logistics.forwarders.form.emailPlaceholder': 'email@example.com',
  'pages.logistics.forwarders.form.memo': '管理员备注',
  'pages.logistics.forwarders.form.memoPlaceholder': '请输入备注',
  'pages.logistics.forwarders.shippingMethod.air': '航空',
  'pages.logistics.forwarders.shippingMethod.airExpress': '航空特快',
  'pages.logistics.forwarders.shippingMethod.ship': '海运',
  'pages.logistics.forwarders.shippingMethod.shipExpress': '海运特快',
  'pages.logistics.forwarders.apiModal.title': 'API设置 - {name}',
  'pages.logistics.forwarders.apiModal.alertTitle': 'API集成指南',
  'pages.logistics.forwarders.apiModal.alertDescription': '集成转运商API后，可以自动查询运单并实时更新配送状态。',
  'pages.logistics.forwarders.apiModal.apiKey': 'API密钥',
  'pages.logistics.forwarders.apiModal.apiKeyRequired': '请输入API密钥',
  'pages.logistics.forwarders.apiModal.apiKeyPlaceholder': '输入API密钥',
  'pages.logistics.forwarders.apiModal.trackingUrl': '运单查询URL',
  'pages.logistics.forwarders.apiModal.trackingUrlInvalid': '请输入有效的URL',
  'pages.logistics.forwarders.apiModal.trackingUrlPlaceholder': 'https://api.example.com/tracking',
  'pages.logistics.forwarders.apiModal.webhookUrl': 'Webhook URL（可选）',
  'pages.logistics.forwarders.apiModal.webhookUrlPlaceholder': 'https://your-domain.com/webhook',
  'pages.logistics.forwarders.apiModal.timeout': '超时（秒）',
  'pages.logistics.forwarders.apiModal.testButton': '测试API连接',
  'pages.logistics.forwarders.simple.title': '配送代理管理',
  'pages.logistics.forwarders.simple.breadcrumb.logistics': '物流管理',
  'pages.logistics.forwarders.simple.breadcrumb.forwarders': '配送代理管理',
  'pages.logistics.forwarders.simple.description': '配送代理信息管理',
  'pages.logistics.forwarders.simple.subDescription': '添加、编辑、删除配送代理并管理信息',
  'pages.logistics.forwarders.mock.cjName': 'CJ大韩通运',
  'pages.logistics.forwarders.mock.cjContact': '金代理',
  'pages.logistics.forwarders.mock.cjAddress': '首尔市中区世宗大路39号',
  'pages.logistics.forwarders.mock.cjMemo': 'CJ大韩通运主账户',
  'pages.logistics.forwarders.mock.postName': '邮局快递',
  'pages.logistics.forwarders.mock.postContact': '李科长',
  'pages.logistics.forwarders.mock.postAddress': '首尔市钟路区邮政局路26号',
  'pages.logistics.forwarders.mock.postMemo': '邮局快递账户',
  'pages.logistics.forwarders.mock.hanjinName': '韩进快递',
  'pages.logistics.forwarders.mock.hanjinContact': '朴部长',
  'pages.logistics.forwarders.mock.hanjinAddress': '首尔市江南区德黑兰路152号',
  'pages.logistics.forwarders.mock.hanjinMemo': '韩进快递账户',
  'pages.logistics.forwarders.mock.logenName': '乐天物流',
  'pages.logistics.forwarders.mock.logenContact': '崔代理',
  'pages.logistics.forwarders.mock.logenAddress': '首尔市松坡区奥林匹克路289号',
  'pages.logistics.forwarders.mock.logenMemo': 'API集成待处理',
  'pages.logistics.forwarders.mock.dhlAddress': '首尔市江南区永东大路517号',
  'pages.logistics.forwarders.mock.dhlMemo': 'DHL国际特快',
  'pages.logistics.forwarders.mock.fedexAddress': '首尔市中区世宗大路136号',
  'pages.logistics.forwarders.mock.fedexMemo': 'API错误 - 需要检查',
  
  // Logistics - Rack Management
  'pages.logistics.rack.title': '货架管理',
  'pages.logistics.rack.addRack': '添加货架',
  'pages.logistics.rack.addRackSingle': '添加单个货架',
  'pages.logistics.rack.batchCreate': '批量添加（列）',
  'pages.logistics.rack.batchUnavailable': '批量不可用',
  'pages.logistics.rack.batch.modalTitle': '批量添加货架（列）',
  'pages.logistics.rack.batch.columnFrom': '列起始',
  'pages.logistics.rack.batch.columnTo': '列结束',
  'pages.logistics.rack.batch.create': '创建',
  'pages.logistics.rack.batch.columnRangeError': '列起始必须小于或等于列结束',
  'pages.logistics.rack.batch.maxColumnsWarning': '一次创建超过100个货架可能需要较长时间。',
  'pages.logistics.rack.batch.createSuccess': '成功创建 {count} 个货架',
  'pages.logistics.rack.batch.createPartialError': '{count} 个货架创建失败',
  'pages.logistics.rack.exportStatus': '导出货架状态',
  'pages.logistics.rack.deleteTitle': '删除货架',
  'pages.logistics.rack.deleteConfirm': '确定要删除货架 "{code}" 吗？',
  'pages.logistics.rack.deleteSuccess': '货架已删除',
  'pages.logistics.rack.deleteError': '删除货架失败',
  'pages.logistics.rack.batchDelete': '批量删除',
  'pages.logistics.rack.batchDeleteTitle': '批量删除货架',
  'pages.logistics.rack.batchDeleteConfirm': '确定要删除 {count} 个货架吗？',
  'pages.logistics.rack.batchDeleteSuccess': '成功删除 {count} 个货架',
  'pages.logistics.rack.batchDeletePartialSuccess': '删除了 {deleted} 个货架，{failed} 个失败',
  'pages.logistics.rack.batchDeleteError': '删除货架失败',
  'pages.logistics.rack.selectRacksToDelete': '请选择要删除的货架',
  'pages.logistics.rack.cannotDeleteRacksWithProducts': '无法删除包含产品的 {count} 个货架',
  'pages.logistics.rack.cannotDeleteInactiveRacks': '无法删除 {count} 个未激活的货架',
  'pages.logistics.rack.noValidRacksToDelete': '没有有效的货架可删除',
  'pages.logistics.rack.updateSuccess': '货架信息已更新',
  'pages.logistics.rack.createSuccess': '货架已注册',
  'pages.logistics.rack.printQRSuccess': '正在准备 {code} 的QR码打印...',
  'pages.logistics.rack.column.id': 'ID',
  'pages.logistics.rack.column.rackCode': '货架代码',
  'pages.logistics.rack.column.warehouse': '仓库',
  'pages.logistics.rack.column.zone': '区域',
  'pages.logistics.rack.column.location': '位置',
  'pages.logistics.rack.column.trackingNumbers': '运单号',
  'pages.logistics.rack.column.row': '行',
  'pages.logistics.rack.column.column': '列',
  'pages.logistics.rack.column.level': '层',
  'pages.logistics.rack.column.capacity': '容量',
  'pages.logistics.rack.column.productCount': '商品数',
  'pages.logistics.rack.column.status': '状态',
  'pages.logistics.rack.column.environment': '环境',
  'pages.logistics.rack.column.lastUpdated': '最后更新',
  'pages.logistics.rack.column.action': '操作',
  'pages.logistics.rack.warehouse.weihai': '威海',
  'pages.logistics.rack.warehouse.qingdao': '青岛',
  'pages.logistics.rack.warehouse.guangzhou': '广州',
  'pages.logistics.rack.warehouse.yiwu': '义乌',
  'pages.logistics.rack.zone.A': 'A区',
  'pages.logistics.rack.zone.B': 'B区',
  'pages.logistics.rack.zone.C': 'C区',
  'pages.logistics.rack.zone.D': 'D区',
  'pages.logistics.rack.zone.E': 'E区',
  'pages.logistics.rack.location.row': '行',
  'pages.logistics.rack.location.column': '列',
  'pages.logistics.rack.location.level': '层',
  'pages.logistics.rack.capacity.inUse': '使用中',
  'pages.logistics.rack.status.available': '可用',
  'pages.logistics.rack.status.full': '已满',
  'pages.logistics.rack.status.maintenance': '使用中',
  'pages.logistics.rack.status.reserved': '已预订',
  'pages.logistics.rack.environment.temperature': '温度',
  'pages.logistics.rack.environment.humidity': '湿度',
  'pages.logistics.rack.action.viewInventory': '查看库存',
  'pages.logistics.rack.inventory.empty': '此货架没有库存项目。',
  'pages.logistics.rack.stat.totalRacks': '总货架',
  'pages.logistics.rack.stat.available': '可用',
  'pages.logistics.rack.stat.full': '已满',
  'pages.logistics.rack.stat.maintenance': '使用中',
  'pages.logistics.rack.modal.addTitle': '添加货架',
  'pages.logistics.rack.modal.editTitle': '修改货架信息',
  'pages.logistics.rack.form.warehouse': '仓库',
  'pages.logistics.rack.form.warehousePlaceholder': '选择仓库',
  'pages.logistics.rack.form.zone': '区域',
  'pages.logistics.rack.form.zonePlaceholder': '选择区域',
  'pages.logistics.rack.form.row': '行',
  'pages.logistics.rack.form.rowPlaceholder': '例如：01',
  'pages.logistics.rack.form.column': '列',
  'pages.logistics.rack.form.columnPlaceholder': '例如：05',
  'pages.logistics.rack.form.level': '层',
  'pages.logistics.rack.form.levelPlaceholder': '例如：3',
  'pages.logistics.rack.form.capacity': '最大容量',
  'pages.logistics.rack.form.capacityPlaceholder': '数量',
  'pages.logistics.rack.form.status': '状态',
  'pages.logistics.rack.form.statusPlaceholder': '选择状态',
  'pages.logistics.rack.form.sizeType': '尺寸类型',
  'pages.logistics.rack.form.sizeTypePlaceholder': '选择尺寸类型',
  'pages.logistics.rack.form.sizeTypeRequired': '请选择尺寸类型',
  'pages.logistics.rack.form.warehouseRequired': '请选择仓库',
  'pages.logistics.rack.form.notes': '备注',
  'pages.logistics.rack.form.notesPlaceholder': '输入备注（可选）',
  'pages.logistics.rack.location.zone': '区域',
  'pages.logistics.rack.fetchError': '获取货架失败',
  'pages.logistics.rack.createError': '创建货架失败',
  'pages.logistics.rack.updateError': '更新货架失败',
  'pages.logistics.rack.batchCreateTitle': '批量创建货架',
  'pages.logistics.rack.batchCreateSuccess': '货架批量创建成功',
  'pages.logistics.rack.batchCreateError': '批量创建货架失败',
  'pages.logistics.rack.batchCreateConfirmTitle': '确认批量创建',
  'pages.logistics.rack.batchCreateConfirm': '确定要创建 {count} 个货架吗？',
  'pages.logistics.rack.batchCreateNoRacks': '没有要创建的货架',
  'pages.logistics.rack.batchCreate.zoneStart': '区域起始编号',
  'pages.logistics.rack.batchCreate.zoneStartPlaceholder': '请输入区域起始编号',
  'pages.logistics.rack.batchCreate.zoneEnd': '区域结束编号',
  'pages.logistics.rack.batchCreate.zoneEndPlaceholder': '请输入区域结束编号',
  'pages.logistics.rack.batchCreate.rackStart': '货架起始编号',
  'pages.logistics.rack.batchCreate.rackStartPlaceholder': '请输入货架起始编号',
  'pages.logistics.rack.batchCreate.rackEnd': '货架结束编号',
  'pages.logistics.rack.batchCreate.rackEndPlaceholder': '请输入货架结束编号',
  'pages.logistics.rack.batchCreate.positionStart': '位置起始编号',
  'pages.logistics.rack.batchCreate.positionStartPlaceholder': '请输入位置起始编号',
  'pages.logistics.rack.batchCreate.positionEnd': '位置结束编号',
  'pages.logistics.rack.batchCreate.positionEndPlaceholder': '请输入位置结束编号',
  'pages.logistics.rack.batchUnavailableTitle': '批量设置为不可用',
  'pages.logistics.rack.batchUnavailableConfirm': '确定要将选中的 {count} 个货架设置为不可用吗？',
  'pages.logistics.rack.batchUnavailableSuccess': '货架已批量设置为不可用',
  'pages.logistics.rack.batchUnavailableError': '批量设置货架为不可用失败',
  'pages.logistics.rack.noSelection': '未选择任何项目',
  'pages.logistics.rack.barcodeError': '未找到条形码值',
  'pages.logistics.rack.printWindowError': '无法打开打印窗口。请允许此网站的弹出窗口。',
  'pages.logistics.rack.barcodeGenerationError': '生成条形码失败',
  'pages.logistics.rack.printBarcode': '打印条形码 (Code-128)',
  'pages.logistics.rack.bulkBarcode': '打印选中条形码',
  'pages.logistics.rack.noRacksSelected': '请至少选择一个货架以打印条形码',
  'pages.logistics.rack.bulkBarcodeSuccess': '已为 {count} 个货架生成条形码',

  // Logistics - Waybill Informations
  'pages.logistics.waybillInformations.title': '运单信息',
  'pages.logistics.waybillInformations.addTitle': '添加运单信息',
  'pages.logistics.waybillInformations.editTitle': '编辑运单信息',
  'pages.logistics.waybillInformations.deleteConfirm': '删除运单信息',
  'pages.logistics.waybillInformations.deleteConfirmContent': '确定要删除运单信息 "{zyid}" 吗？',
  'pages.logistics.waybillInformations.deleteSuccess': '运单信息已删除',
  'pages.logistics.waybillInformations.updateSuccess': '运单信息已更新',
  'pages.logistics.waybillInformations.createSuccess': '运单信息已创建',
  'pages.logistics.waybillInformations.submitError': '保存运单信息时出错',
  'pages.logistics.waybillInformations.exportSuccess': '已导出 {count} 条数据',
  'pages.logistics.waybillInformations.exportError': '导出时发生错误',
  'pages.logistics.waybillInformations.exporting': '正在导出...',
  'pages.logistics.waybillInformations.column.shippedAt': '出库完成时间',
  'pages.logistics.waybillInformations.column.secondPaidAt': '二次费用支付时间',
  'pages.logistics.waybillInformations.column.mailbox': '邮箱号',
  'pages.logistics.waybillInformations.column.recipient': '收件人',
  'pages.logistics.waybillInformations.column.secondPaymentStatus': '二次支付状态',
  'pages.logistics.waybillInformations.column.secondPaymentMethod': '二次支付方式',
  'pages.logistics.waybillInformations.column.progressStatus': '进行状态',
  'pages.logistics.waybillInformations.column.warehouse': '仓库',
  'pages.logistics.waybillInformations.column.transferMethod': '运输方式',
  'pages.logistics.waybillInformations.column.weight': '重量',
  'pages.logistics.waybillInformations.column.internationalShipping': '国际运费',
  'pages.logistics.waybillInformations.column.ruralShipping': '偏远地区费用',
  'pages.logistics.waybillInformations.column.simplifiedClearance': '通关手续费',
  'pages.logistics.waybillInformations.column.service': '服务费用',
  'pages.logistics.waybillInformations.column.deposit': '预存金',
  'pages.logistics.waybillInformations.column.coupon': '优惠券',
  'pages.logistics.waybillInformations.column.secondPaymentTotal': '二次支付费用',
  'pages.logistics.waybillInformations.filter.shippedStart': '出库开始日',
  'pages.logistics.waybillInformations.filter.shippedEnd': '出库截止日',
  'pages.logistics.waybillInformations.filter.secondPaidStart': '二次支付开始日',
  'pages.logistics.waybillInformations.filter.secondPaidEnd': '二次支付截止日',
  'pages.logistics.waybillInformations.paymentStatus.all': '二次支付状态全部',
  'pages.logistics.waybillInformations.paymentStatus.unpaid': '未支付',
  'pages.logistics.waybillInformations.paymentStatus.pending': '待支付',
  'pages.logistics.waybillInformations.paymentStatus.processing': '支付处理中',
  'pages.logistics.waybillInformations.paymentStatus.paid': '支付完成',
  'pages.logistics.waybillInformations.paymentStatus.failed': '支付失败',
  'pages.logistics.waybillInformations.paymentStatus.refunded': '已退款',
  'pages.logistics.waybillInformations.paymentMethod.all': '二次支付方式全部',
  'pages.logistics.waybillInformations.paymentMethod.card': '信用卡',
  'pages.logistics.waybillInformations.paymentMethod.bank': '无存折汇款',
  'pages.logistics.waybillInformations.paymentMethod.deposit': '预存金',
  'pages.logistics.waybillInformations.paymentMethod.points': '积分',
  'pages.logistics.waybillInformations.progressStatus.all': '进行状态全部',
  'pages.logistics.waybillInformations.progressStatus.WH_PAY_WAIT': '出库费待支付',
  'pages.logistics.waybillInformations.progressStatus.WH_PAY_DONE': '出库费支付完成',
  'pages.logistics.waybillInformations.progressStatus.WH_SHIPPED': '出库完成',
  'pages.logistics.waybillInformations.progressStatus.INTERNATIONAL_SHIPPING': '国际运输中',
  'pages.logistics.waybillInformations.progressStatus.INTERNATIONAL_SHIPPED': '国际运输完成',
  'pages.logistics.waybillInformations.transferMethod.all': '运输方式全部',
  'pages.logistics.waybillInformations.transferMethod.ship': '海运',
  'pages.logistics.waybillInformations.transferMethod.air': '空运',
  'pages.logistics.waybillInformations.transferMethod.shipExpress': '海运特快',
  'pages.logistics.waybillInformations.transferMethod.airExpress': '空运特快',
  'pages.logistics.waybillInformations.warehouse.all': '仓库全部',
  'pages.logistics.waybillInformations.column.id': 'ID',
  'pages.logistics.waybillInformations.column.orderNumber': '订单号',
  'pages.logistics.waybillInformations.column.totalProductPriceW': '商品总价 (元)',
  'pages.logistics.waybillInformations.column.shippingFeeWithinChinaW': '中国境内运费 (元)',
  'pages.logistics.waybillInformations.column.purchaseFeeW': '采购费 (元)',
  'pages.logistics.waybillInformations.column.secondaryPaymentW': '二次支付 (元)',
  'pages.logistics.waybillInformations.column.totalProductPriceYuan': '商品总价 (¥)',
  'pages.logistics.waybillInformations.column.shippingFeeWithinChinaYuan': '中国境内运费 (¥)',
  'pages.logistics.waybillInformations.column.purchaseFeeYuan': '采购费 (¥)',
  'pages.logistics.waybillInformations.column.secondaryPaymentYuan': '二次支付 (¥)',
  'pages.logistics.waybillInformations.column.waybillNumber': '运单号',
  'pages.logistics.waybillInformations.column.paymentMethod': '支付方式',
  'pages.logistics.waybillInformations.column.paymentType': '支付类型',
  'pages.logistics.waybillInformations.column.createdAt': '创建时间',
  'pages.logistics.waybillInformations.status.pending': '待处理',
  'pages.logistics.waybillInformations.status.inTransit': '运输中',
  'pages.logistics.waybillInformations.status.delivered': '已送达',
  'pages.logistics.waybillInformations.status.exception': '异常',
  'pages.logistics.waybillInformations.form.id': 'ID',
  'pages.logistics.waybillInformations.form.idRequired': '请输入ID',
  'pages.logistics.waybillInformations.form.totalProductPriceW': '商品总价 (元)',
  'pages.logistics.waybillInformations.form.totalProductPriceWRequired': '请输入商品总价 (元)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaW': '中国境内运费 (元)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaWRequired': '请输入中国境内运费 (元)',
  'pages.logistics.waybillInformations.form.purchaseFeeW': '采购费 (元)',
  'pages.logistics.waybillInformations.form.purchaseFeeWRequired': '请输入采购费 (元)',
  'pages.logistics.waybillInformations.form.secondaryPaymentW': '二次支付 (元)',
  'pages.logistics.waybillInformations.form.secondaryPaymentWRequired': '请输入二次支付 (元)',
  'pages.logistics.waybillInformations.form.totalProductPriceYuan': '商品总价 (¥)',
  'pages.logistics.waybillInformations.form.totalProductPriceYuanRequired': '请输入商品总价 (¥)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaYuan': '中国境内运费 (¥)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaYuanRequired': '请输入中国境内运费 (¥)',
  'pages.logistics.waybillInformations.form.purchaseFeeYuan': '采购费 (¥)',
  'pages.logistics.waybillInformations.form.purchaseFeeYuanRequired': '请输入采购费 (¥)',
  'pages.logistics.waybillInformations.form.secondaryPaymentYuan': '二次支付 (¥)',
  'pages.logistics.waybillInformations.form.secondaryPaymentYuanRequired': '请输入二次支付 (¥)',
  'pages.logistics.waybillInformations.form.waybillNumber': '运单号',
  'pages.logistics.waybillInformations.form.waybillNumberRequired': '请输入运单号',
  'pages.logistics.waybillInformations.form.paymentMethod': '支付方式',
  'pages.logistics.waybillInformations.form.paymentMethodRequired': '请选择支付方式',
  'pages.logistics.waybillInformations.form.paymentType': '支付类型',
  'pages.logistics.waybillInformations.form.paymentTypeRequired': '请选择支付类型',

  // Logistics - Waybill Bandwidth Management
  'pages.logistics.waybillBandwidthManagement.title': '运单带宽管理',
  'pages.logistics.waybillBandwidthManagement.column.no': '序号',
  'pages.logistics.waybillBandwidthManagement.column.centerTransportationMethod': '中心/运输方式',
  'pages.logistics.waybillBandwidthManagement.column.courier': '快递公司',
  'pages.logistics.waybillBandwidthManagement.column.title': '标题',
  'pages.logistics.waybillBandwidthManagement.column.waybillBandwidth': '运单带宽',
  'pages.logistics.waybillBandwidthManagement.column.totalBandwidth': '总带宽',
  'pages.logistics.waybillBandwidthManagement.column.waybillsUsed': '已使用运单数',
  'pages.logistics.waybillBandwidthManagement.column.waybillsAvailable': '可用运单数',
  'pages.logistics.waybillBandwidthManagement.column.waybillNumberStart': '运单号起始',
  'pages.logistics.waybillBandwidthManagement.column.waybillNumberEnd': '运单号结束',
  'pages.logistics.waybillBandwidthManagement.column.isInUse': '是否使用',
  'pages.logistics.waybillBandwidthManagement.column.registrationDate': '注册日期',
  'pages.logistics.waybillBandwidthManagement.inUse': '使用中',
  'pages.logistics.waybillBandwidthManagement.notInUse': '未使用',
  'pages.logistics.waybillBandwidthManagement.deleteConfirm': '删除运单带宽',
  'pages.logistics.waybillBandwidthManagement.deleteConfirmContent': '确定要删除"{title}"吗？',
  'pages.logistics.waybillBandwidthManagement.deleteSuccess': '删除成功',
  'pages.logistics.waybillBandwidthManagement.setInUseSuccess': '已设置为使用中',
  'pages.logistics.waybillBandwidthManagement.setNotInUseSuccess': '已设置为未使用',
  'pages.logistics.waybillBandwidthManagement.addComingSoon': '添加功能即将推出',
  'pages.logistics.waybillBandwidthManagement.addTitle': '添加运单带宽',
  'pages.logistics.waybillBandwidthManagement.editTitle': '编辑运单带宽',
  'pages.logistics.waybillBandwidthManagement.createSuccess': '运单带宽已创建',
  'pages.logistics.waybillBandwidthManagement.editSuccess': '运单带宽已更新',
  'pages.logistics.waybillBandwidthManagement.submitError': '操作失败，请重试。',
  'pages.logistics.waybillBandwidthManagement.column.includeInactive': '显示',
  'pages.logistics.waybillBandwidthManagement.showAll': '全部',
  'pages.logistics.waybillBandwidthManagement.showActiveOnly': '仅使用中',
  'pages.logistics.waybillBandwidthManagement.includeInactivePlaceholder': '按状态筛选',
  'pages.logistics.waybillBandwidthManagement.column.warehouse': '仓库',
  'pages.logistics.waybillBandwidthManagement.column.transportationMethod': '运输方式',
  'pages.logistics.waybillBandwidthManagement.form.warehouse': '仓库',
  'pages.logistics.waybillBandwidthManagement.form.warehouseRequired': '请选择仓库',
  'pages.logistics.waybillBandwidthManagement.form.warehousePlaceholder': '请选择仓库',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethod': '运输方式',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethodRequired': '请选择运输方式',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethodPlaceholder': '请选择运输方式',
  'pages.logistics.waybillBandwidthManagement.transportationMethod.ship': '船运',
  'pages.logistics.waybillBandwidthManagement.transportationMethod.air': '空运',
  'pages.logistics.waybillBandwidthManagement.form.courier': '快递公司',
  'pages.logistics.waybillBandwidthManagement.form.courierRequired': '请输入快递公司',
  'pages.logistics.waybillBandwidthManagement.form.courierPlaceholder': '例如：CJ 大韩通运',
  'pages.logistics.waybillBandwidthManagement.form.title': '标题',
  'pages.logistics.waybillBandwidthManagement.form.titleRequired': '请输入标题',
  'pages.logistics.waybillBandwidthManagement.form.titlePlaceholder': '例如：威海 RED - CJ - 航空',
  'pages.logistics.waybillBandwidthManagement.form.file': '文件',
  'pages.logistics.waybillBandwidthManagement.form.fileRequired': '请上传Excel文件',
  'pages.logistics.waybillBandwidthManagement.form.uploadFile': '上传文件',
  'pages.logistics.waybillBandwidthManagement.form.fileTypeError': '只能上传Excel文件（.xlsx, .xls）',
  'pages.logistics.waybillBandwidthManagement.form.isActive': '是否启用',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.title': '运单号列表',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.number': '运单号',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.used': '状态',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.usedYes': '已使用',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.usedNo': '未使用',
  'pages.logistics.waybillBandwidthManagement.uploadMore.title': '追加运单号 — {title}',
  'pages.logistics.waybillBandwidthManagement.uploadMore.titleFallback': '从文件追加运单号',
  'pages.logistics.waybillBandwidthManagement.uploadMore.hint':
    'Excel/CSV 读取第一列，TXT 每行一个号。重复或已在其他池中使用的单号会跳过。建议使用 .xlsx。',
  'pages.logistics.waybillBandwidthManagement.uploadMore.pickFile': '选择文件',
  'pages.logistics.waybillBandwidthManagement.uploadMore.submit': '上传',
  'pages.logistics.waybillBandwidthManagement.uploadMore.action': '上传追加单号',
  'pages.logistics.waybillBandwidthManagement.uploadMore.success': '已新增 {added} 个运单号。池中合计：{totalInPool}。',
  'pages.logistics.waybillBandwidthManagement.uploadMore.successWithSkipped':
    '新增 {added} 个；跳过 {skipped} 个（重复）。池中合计：{totalInPool}。',
  'pages.logistics.waybillBandwidthManagement.uploadMore.noNew':
    '未新增任何单号（{skipped} 条为重复或已在池中）。',
  'pages.logistics.waybillBandwidthManagement.uploadMore.fileTypeError': '仅支持 .xlsx、.csv、.txt。',

  // Logistics - Collect Orders
  'pages.logistics.collectOrders.title': '收集订单',
  'pages.logistics.collectOrders.statistics.total': '总计',
  'pages.logistics.collectOrders.statistics.pending': '待处理',
  'pages.logistics.collectOrders.statistics.processing': '处理中',
  'pages.logistics.collectOrders.statistics.completed': '已完成',
  'pages.logistics.collectOrders.column.waybillNumber': '运单号',
  'pages.logistics.collectOrders.column.uid': '用户信息 (UID)',
  'pages.logistics.collectOrders.column.productNumber': '商品编号',
  'pages.logistics.collectOrders.column.shippingMethod': '运输方式',
  'pages.logistics.collectOrders.column.overseasWarehouse': '海外仓库',
  'pages.logistics.collectOrders.column.paymentStatus': '支付状态',
  'pages.logistics.collectOrders.column.creationTime': '创建时间',
  'pages.logistics.collectOrders.column.updateTime': '更新时间',
  'pages.logistics.collectOrders.column.state': '状态',
  'pages.logistics.collectOrders.column.storageFees': '仓储费',
  'pages.logistics.collectOrders.column.work': '操作',
  'pages.logistics.collectOrders.paymentStatus.paid': '已支付',
  'pages.logistics.collectOrders.paymentStatus.unpaid': '未支付',
  'pages.logistics.collectOrders.paymentStatus.partial': '部分支付',
  'pages.logistics.collectOrders.paymentStatus.refunded': '已退款',
  'pages.logistics.collectOrders.state.pending': '待处理',
  'pages.logistics.collectOrders.state.processing': '处理中',
  'pages.logistics.collectOrders.state.completed': '已完成',
  'pages.logistics.collectOrders.state.cancelled': '已取消',
  'pages.logistics.collectOrders.deleteConfirm': '删除收集订单',
  'pages.logistics.collectOrders.deleteConfirmContent': '确定要删除收集订单 "{waybillNumber}" 吗？',
  'pages.logistics.collectOrders.deleteSuccess': '收集订单已删除',
  'pages.logistics.collectOrders.edit': '编辑',

  // Logistics - Transportation Methods
  'pages.logistics.transportationMethods.title': '运输方式',
  'pages.logistics.transportationMethods.addTitle': '添加运输方式',
  'pages.logistics.transportationMethods.editTitle': '编辑运输方式',
  'pages.logistics.transportationMethods.deleteConfirm': '删除运输方式',
  'pages.logistics.transportationMethods.deleteConfirmContent': '确定要删除运输方式 "{regionId}" 吗？',
  'pages.logistics.transportationMethods.deleteSuccess': '运输方式已删除',
  'pages.logistics.transportationMethods.column.isActive': '激活',
  'pages.logistics.transportationMethods.column.isInactive': '未激活',
  'pages.logistics.transportationMethods.updateSuccess': '运输方式已更新',
  'pages.logistics.transportationMethods.createSuccess': '运输方式已创建',
  'pages.logistics.transportationMethods.submitError': '保存运输方式时出错',
  'pages.logistics.transportationMethods.column.regionId': '区域ID',
  'pages.logistics.transportationMethods.column.icon': '图标',
  'pages.logistics.transportationMethods.column.userLevel': '用户等级',
  'pages.logistics.transportationMethods.userLevelAll': '全部',
  'pages.logistics.transportationMethods.column.areaName': '区域名称',
  'pages.logistics.transportationMethods.column.deliveryName': '配送名称',
  'pages.logistics.transportationMethods.column.customsClearanceFees': '通关费',
  'pages.logistics.transportationMethods.column.serviceFee': '服务费',
  'pages.logistics.transportationMethods.column.visible': '可见',
  'pages.logistics.transportationMethods.column.work': '操作',
  'pages.logistics.transportationMethods.form.regionId': '区域ID',
  'pages.logistics.transportationMethods.form.regionIdRequired': '请输入区域ID',
  'pages.logistics.transportationMethods.form.icon': '图标',
  'pages.logistics.transportationMethods.form.iconPlaceholder': '请输入图片URL',
  'pages.logistics.transportationMethods.form.userLevel': '用户等级',
  'pages.logistics.transportationMethods.form.userLevelPlaceholder': '例如：全部、高级、基础',
  'pages.logistics.transportationMethods.form.areaName': '区域名称',
  'pages.logistics.transportationMethods.form.areaNameRequired': '请输入区域名称',
  'pages.logistics.transportationMethods.form.deliveryName': '配送名称',
  'pages.logistics.transportationMethods.form.deliveryNameRequired': '请输入配送名称',
  'pages.logistics.transportationMethods.form.customsClearanceFees': '通关费',
  'pages.logistics.transportationMethods.form.customsClearanceFeesRequired': '请输入通关费',
  'pages.logistics.transportationMethods.form.serviceFee': '服务费',
  'pages.logistics.transportationMethods.form.serviceFeeRequired': '请输入服务费',
  'pages.logistics.transportationMethods.form.visible': '可见',
  'pages.logistics.transportationMethods.add': '添加运输方式',
  'pages.logistics.transportationMethods.stepWeight': '阶梯重量',
  'pages.logistics.transportationMethods.additionalWeight': '续重重量',
  'pages.logistics.transportationMethods.stepWeightPlaceholder': '阶梯重量设置 — 待实现。',
  'pages.logistics.transportationMethods.additionalWeightPlaceholder': '续重重量设置 — 待实现。',
  'pages.logistics.transportationMethods.transportationFeeTitle': '运输费用（阶梯重量与续重重量）',
  'pages.logistics.transportationMethods.form.serviceCostRatioOnly': '比例 (%)',
  'pages.logistics.transportationMethods.disable': '停用',
  'pages.logistics.transportationMethods.disableConfirm': '确定要停用吗？',
  'pages.logistics.transportationMethods.disableSuccess': '已停用',
  'pages.logistics.transportationMethods.column.id': 'ID',
  'pages.logistics.transportationMethods.column.serviceAreaName': '服务区域名称',
  'pages.logistics.transportationMethods.column.customsCost': '通关费用',
  'pages.logistics.transportationMethods.column.serviceCost': '服务费用',
  'pages.logistics.transportationMethods.column.isDisplayed': '显示状态',
  'pages.logistics.transportationMethods.tab.basicInfo': '基本信息',
  'pages.logistics.transportationMethods.tab.weightSettings': '重量设置',
  'pages.logistics.transportationMethods.tab.weightLimits': '重量限制',
  'pages.logistics.transportationMethods.tab.deviation': '重量/体积偏差值',
  'pages.logistics.transportationMethods.tab.actualWeight': '实际重量',
  'pages.logistics.transportationMethods.tab.tieredWeight': '阶梯重量设置',
  'pages.logistics.transportationMethods.stairWeight': '阶梯重量',
  'pages.logistics.transportationMethods.tieredPricing': '阶梯价格',
  'pages.logistics.transportationMethods.additionalWeightPrice': '续重价格',
  'pages.logistics.transportationMethods.registrationFee': '注册费',
  'pages.logistics.transportationMethods.tab.volumeWeight': '体积重量计算设置',
  'pages.logistics.transportationMethods.tab.billingCriteria': '其他计费标准',
  'pages.logistics.transportationMethods.tab.routeInfo': '路线信息',
  'pages.logistics.transportationMethods.tab.displayStatus': '显示状态',
  'pages.logistics.transportationMethods.form.serviceArea': '服务区域',
  'pages.logistics.transportationMethods.form.shippingWarehouse': '发货仓库',
  'pages.logistics.transportationMethods.form.shippingWarehousePlaceholder': '选择发货仓库',
  'pages.logistics.transportationMethods.form.customsCost': '通关费用',
  'pages.logistics.transportationMethods.form.serviceCostCalculationType': '服务费用计算方式',
  'pages.logistics.transportationMethods.form.serviceCostFixed': '固定服务费',
  'pages.logistics.transportationMethods.form.serviceCostRatio': '比例 (%)',
  'pages.logistics.transportationMethods.form.minWeight': '最小重量',
  'pages.logistics.transportationMethods.form.maxWeight': '最大重量',
  'pages.logistics.transportationMethods.form.minCalculationWeight': '最小计算重量',
  'pages.logistics.transportationMethods.form.sizeLimit': '尺寸限制',
  'pages.logistics.transportationMethods.form.weightDeviation': '重量偏差值 (0~1)',
  'pages.logistics.transportationMethods.form.lengthDeviation': '长度偏差值',
  'pages.logistics.transportationMethods.form.widthDeviation': '宽度偏差值',
  'pages.logistics.transportationMethods.form.heightDeviation': '高度偏差值',
  'pages.logistics.transportationMethods.form.volumeDeviation': '体积偏差值',
  'pages.logistics.transportationMethods.form.actualWeightForCustoms': '报关用重量 (kg)',
  'pages.logistics.transportationMethods.form.actualWeightForBilling': '财务对账用重量 (kg)',
  'pages.logistics.transportationMethods.form.weightUnit': '重量单位 (kg)',
  'pages.logistics.transportationMethods.form.actualWeightRules': '客户说明规则',
  'pages.logistics.transportationMethods.form.baseWeight': '快递基础重量 (kg)',
  'pages.logistics.transportationMethods.form.basePrice': '基础价格',
  'pages.logistics.transportationMethods.form.additionalWeight': '附加重量 (kg)',
  'pages.logistics.transportationMethods.form.additionalWeightPrice': '附加重量价格',
  'pages.logistics.transportationMethods.form.tieredWeights': '阶梯重量和价格',
  'pages.logistics.transportationMethods.form.volumeCoefficient': '体积系数',
  'pages.logistics.transportationMethods.form.volumeExpansionMode': '体积膨胀模式',
  'pages.logistics.transportationMethods.form.logisticsProcessingFee': '物流公司处理费',
  'pages.logistics.transportationMethods.form.fuelCost': '燃料费',
  'pages.logistics.transportationMethods.form.operatingCost': '运营费',
  'pages.logistics.transportationMethods.form.taxPaymentMethod': '税费支付方式',
  'pages.logistics.transportationMethods.form.taxDeclarationMethod': '申报方式',
  'pages.logistics.transportationMethods.form.shippingTime': '运输所需时间',
  'pages.logistics.transportationMethods.form.routeRiskNotice': '运输路线风险提示',
  'pages.logistics.transportationMethods.form.routeFeeStandard': '路线费用标准',
  'pages.logistics.transportationMethods.form.lineCharacteristics': '路线特性',
  'pages.logistics.transportationMethods.form.volumeBillingRules': '体积计费规则',
  'pages.logistics.transportationMethods.form.volumeBillingRulesPlaceholder': '仅输入数字',
  'pages.logistics.transportationMethods.form.deliveryNamePlaceholder': '请输入配送名称',
  'pages.logistics.transportationMethods.form.serviceAreaPlaceholder': '请输入服务区域',
  'pages.logistics.transportationMethods.form.shippingTimePlaceholder': '例如：2-3天',
  'pages.logistics.transportationMethods.form.routeRiskNoticePlaceholder': '请输入运输路线风险提示',
  'pages.logistics.transportationMethods.form.lineCharacteristicsPlaceholder': '请输入路线特性',
  'pages.logistics.transportationMethods.form.upload': '上传',
  'pages.logistics.transportationMethods.displayed': '显示',
  'pages.logistics.transportationMethods.hidden': '隐藏',
  'pages.logistics.transportationMethods.active': '激活',
  'pages.logistics.transportationMethods.inactive': '未激活',
  'pages.logistics.transportationMethods.form.isDisplayed': '前端用户显示状态',
  'pages.logistics.transportationMethods.form.isActive': '激活状态',

  // Logistics - Logistics Trajectory
  'pages.logistics.logisticsTrajectory.title': '物流轨迹',
  'pages.logistics.logisticsTrajectory.viewAll': '查看全部',
  'pages.logistics.logisticsTrajectory.column.waybillNumber': '运单号',
  'pages.logistics.logisticsTrajectory.column.uid': '用户信息 (UID)',
  'pages.logistics.logisticsTrajectory.column.productNumber': '商品编号',
  'pages.logistics.logisticsTrajectory.column.shippingMethod': '运输方式',
  'pages.logistics.logisticsTrajectory.column.overseasWarehouse': '海外仓库',
  'pages.logistics.logisticsTrajectory.column.paymentStatus': '支付状态',
  'pages.logistics.logisticsTrajectory.column.creationTime': '创建时间',
  'pages.logistics.logisticsTrajectory.column.updateTime': '更新时间',
  'pages.logistics.logisticsTrajectory.column.state': '状态',
  'pages.logistics.logisticsTrajectory.column.storageFees': '仓储费',
  'pages.logistics.logisticsTrajectory.column.work': '操作',
  'pages.logistics.logisticsTrajectory.paymentStatus.paid': '已支付',
  'pages.logistics.logisticsTrajectory.paymentStatus.unpaid': '未支付',
  'pages.logistics.logisticsTrajectory.paymentStatus.partial': '部分支付',
  'pages.logistics.logisticsTrajectory.paymentStatus.refunded': '已退款',
  'pages.logistics.logisticsTrajectory.viewTrajectory': '查看轨迹',
  'pages.logistics.logisticsTrajectory.filter.group.entire': '全部',
  'pages.logistics.logisticsTrajectory.filter.group.chinaWarehouse': '中国仓库',
  'pages.logistics.logisticsTrajectory.filter.group.chinaCustoms': '中国海关',
  'pages.logistics.logisticsTrajectory.filter.group.international': '国际运输',
  'pages.logistics.logisticsTrajectory.filter.group.destinationCustoms': '目的地海关',
  'pages.logistics.logisticsTrajectory.filter.group.destinationWarehouse': '目的地仓库',
  'pages.logistics.logisticsTrajectory.filter.group.transitCenter': '转运中心',
  'pages.logistics.logisticsTrajectory.filter.group.delivery': '配送',
  'pages.logistics.logisticsTrajectory.filter.group.completed': '已完成',
  'pages.logistics.logisticsTrajectory.filter.entire': '全部',
  'pages.logistics.logisticsTrajectory.filter.warehouseAwaiting': '中国仓库待发货',
  'pages.logistics.logisticsTrajectory.filter.shipmentCompleted': '中国仓库发货完成',
  'pages.logistics.logisticsTrajectory.filter.arrivalChineseCustoms': '到达中国海关',
  'pages.logistics.logisticsTrajectory.filter.customsReleased': '海关已放行',
  'pages.logistics.logisticsTrajectory.filter.internationalTransport': '国际运输',
  'pages.logistics.logisticsTrajectory.filter.arrivalDestinationCustoms': '到达目的地海关',
  'pages.logistics.logisticsTrajectory.filter.customsInspection': '目的地国家海关检查',
  'pages.logistics.logisticsTrajectory.filter.arrivalKoreanWarehouse': '到达韩国仓库',
  'pages.logistics.logisticsTrajectory.filter.pickingTransitCenter': '目的地转运中心取件',
  'pages.logistics.logisticsTrajectory.filter.deliveryBeginsTransit': '目的地转运中心开始配送',
  'pages.logistics.logisticsTrajectory.filter.localDelivery': '本地配送',
  'pages.logistics.logisticsTrajectory.filter.localDeliveryDestination': '目的地国家本地配送',
  'pages.logistics.logisticsTrajectory.filter.packageDelivered': '包裹已送达',
  'pages.logistics.logisticsTrajectory.filter.customerSigned': '客户已签收',

  // Logistics - Goods
  'pages.logistics.goods.title': '货物',
  'pages.logistics.goods.addTitle': '添加货物',
  'pages.logistics.goods.editTitle': '编辑货物',
  'pages.logistics.goods.detailTitle': '货物详情',
  'pages.logistics.goods.deleteConfirm': '删除货物',
  'pages.logistics.goods.deleteConfirmContent': '确定要删除货物 "{goodName}" 吗？',
  'pages.logistics.goods.deleteSuccess': '货物已删除',
  'pages.logistics.goods.updateSuccess': '货物已更新',
  'pages.logistics.goods.createSuccess': '货物已创建',
  'pages.logistics.goods.submitError': '保存货物时出错',
  'pages.logistics.goods.column.image': '图片',
  'pages.logistics.goods.column.goodCode': '货物代码',
  'pages.logistics.goods.column.goodName': '货物名称',
  'pages.logistics.goods.column.category': '类别',
  'pages.logistics.goods.column.weight': '重量',
  'pages.logistics.goods.column.dimensions': '尺寸',
  'pages.logistics.goods.column.volume': '体积',
  'pages.logistics.goods.column.unitPrice': '单价',
  'pages.logistics.goods.column.status': '状态',
  'pages.logistics.goods.column.description': '描述',
  'pages.logistics.goods.status.active': '激活',
  'pages.logistics.goods.status.inactive': '未激活',
  'pages.logistics.goods.status.discontinued': '已停产',
  'pages.logistics.goods.form.goodCode': '货物代码',
  'pages.logistics.goods.form.goodCodeRequired': '请输入货物代码',
  'pages.logistics.goods.form.goodName': '货物名称',
  'pages.logistics.goods.form.goodNameRequired': '请输入货物名称',
  'pages.logistics.goods.form.category': '类别',
  'pages.logistics.goods.form.categoryRequired': '请选择类别',
  'pages.logistics.goods.form.weight': '重量',
  'pages.logistics.goods.form.weightRequired': '请输入重量',
  'pages.logistics.goods.form.length': '长度',
  'pages.logistics.goods.form.lengthRequired': '请输入长度',
  'pages.logistics.goods.form.width': '宽度',
  'pages.logistics.goods.form.widthRequired': '请输入宽度',
  'pages.logistics.goods.form.height': '高度',
  'pages.logistics.goods.form.heightRequired': '请输入高度',
  'pages.logistics.goods.form.unitPrice': '单价',
  'pages.logistics.goods.form.unitPriceRequired': '请输入单价',
  'pages.logistics.goods.form.imageUrl': '图片URL',
  'pages.logistics.goods.form.description': '描述',
  'pages.logistics.goods.form.status': '状态',
  'pages.logistics.goods.form.statusRequired': '请选择状态',

  // Logistics - Logistics Trajectory
  'pages.logistics.logisticsTrajectory.searchPlaceholder': '请输入运单号',
  'pages.logistics.logisticsTrajectory.enterTrackingNumber': '请输入运单号',
  'pages.logistics.logisticsTrajectory.searchSuccess': '找到运单信息',
  'pages.logistics.logisticsTrajectory.searchNotFound': '未找到运单信息',
  'pages.logistics.logisticsTrajectory.refreshSuccess': '数据已刷新',
  'pages.logistics.logisticsTrajectory.trajectoryDetails': '轨迹详情 - {trackingNumber}',
  'pages.logistics.logisticsTrajectory.operator': '操作员',
  'pages.logistics.logisticsTrajectory.column.trackingNumber': '运单号',
  'pages.logistics.logisticsTrajectory.column.orderNumber': '订单号',
  'pages.logistics.logisticsTrajectory.column.carrier': '承运商',
  'pages.logistics.logisticsTrajectory.column.origin': '始发地',
  'pages.logistics.logisticsTrajectory.column.destination': '目的地',
  'pages.logistics.logisticsTrajectory.column.currentStatus': '当前状态',
  'pages.logistics.logisticsTrajectory.column.eventCount': '事件数',
  'pages.logistics.logisticsTrajectory.status.pending': '待处理',
  'pages.logistics.logisticsTrajectory.status.inTransit': '运输中',
  'pages.logistics.logisticsTrajectory.status.outForDelivery': '派送中',
  'pages.logistics.logisticsTrajectory.status.delivered': '已送达',
  'pages.logistics.logisticsTrajectory.status.exception': '异常',

  // Logistics - Regional Management
  'pages.logistics.regionalManagement.title': '区域国家管理',
  'pages.logistics.regionalManagement.addTitle': '添加新信息',
  'pages.logistics.regionalManagement.editTitle': '编辑区域信息',
  'pages.logistics.regionalManagement.add': '添加新信息',
  'pages.logistics.regionalManagement.deleteConfirm': '确定要删除吗？',
  'pages.logistics.regionalManagement.deleteConfirmContent': '确定要删除此区域信息吗？',
  'pages.logistics.regionalManagement.deleteSuccess': '已删除',
  'pages.logistics.regionalManagement.updateSuccess': '已更新',
  'pages.logistics.regionalManagement.createSuccess': '已创建',
  'pages.logistics.regionalManagement.submitError': '发生错误',
  'pages.logistics.regionalManagement.batchDelete': '批量删除信息',
  'pages.logistics.regionalManagement.batchDeleteConfirm': '批量删除',
  'pages.logistics.regionalManagement.batchDeleteConfirmContent': '确定要删除选中的 {count} 个项目吗？',
  'pages.logistics.regionalManagement.batchDeleteSuccess': '已删除',
  'pages.logistics.regionalManagement.selectItemsFirst': '请选择要删除的项目',
  'pages.logistics.regionalManagement.column.id': 'ID',
  'pages.logistics.regionalManagement.column.image': '图片',
  'pages.logistics.regionalManagement.column.region': '区域',
  'pages.logistics.regionalManagement.column.regionNameEn': '区域英文名',
  'pages.logistics.regionalManagement.column.countryCode': '国家代码',
  'pages.logistics.regionalManagement.column.destinationCountry': '目的地国家',
  'pages.logistics.regionalManagement.column.destinationCity': '目的地城市',
  'pages.logistics.regionalManagement.column.affiliationTag': '所属标签',
  'pages.logistics.regionalManagement.column.customRegionCode': '自定义区域代码',
  'pages.logistics.regionalManagement.column.countryPhoneCode': '国家电话代码',
  'pages.logistics.regionalManagement.column.createdAt': '创建时间',
  'pages.logistics.regionalManagement.filter.startDate': '开始日期',
  'pages.logistics.regionalManagement.filter.endDate': '结束日期',
  'pages.logistics.regionalManagement.filter.selectDate': '选择日期',
  'pages.logistics.regionalManagement.column.regionCode': '区域代码',
  'pages.logistics.regionalManagement.column.regionName': '区域名称',
  'pages.logistics.regionalManagement.column.country': '国家',
  'pages.logistics.regionalManagement.column.province': '省/市',
  'pages.logistics.regionalManagement.column.city': '市/县/区',
  'pages.logistics.regionalManagement.column.postalCode': '邮政编码',
  'pages.logistics.regionalManagement.column.timeZone': '时区',
  'pages.logistics.regionalManagement.column.currency': '货币',
  'pages.logistics.regionalManagement.column.isActive': '激活',
  'pages.logistics.regionalManagement.column.updatedAt': '更新时间',
  'pages.logistics.regionalManagement.treeTitle': '区域树',
  'pages.logistics.regionalManagement.detailsTitle': '区域详情',
  'pages.logistics.regionalManagement.selectAreaFirst': '请先选择一个区域',
  'pages.logistics.regionalManagement.selectAreaHint': '从左侧树中选择一个区域以查看详情',
  'pages.logistics.regionalManagement.form.region': '区域',
  'pages.logistics.regionalManagement.form.regionRequired': '请输入区域',
  'pages.logistics.regionalManagement.form.regionPlaceholder': '请输入区域',
  'pages.logistics.regionalManagement.form.regionNameEn': '区域英文名',
  'pages.logistics.regionalManagement.form.regionNameEnRequired': '请输入区域英文名',
  'pages.logistics.regionalManagement.form.regionNameEnPlaceholder': '请输入区域英文名',
  'pages.logistics.regionalManagement.form.countryCode': '国家代码',
  'pages.logistics.regionalManagement.form.countryCodeRequired': '请输入国家代码',
  'pages.logistics.regionalManagement.form.countryCodePlaceholder': '例如：KR, CN, US',
  'pages.logistics.regionalManagement.form.destinationCountry': '目的地国家',
  'pages.logistics.regionalManagement.form.destinationCountryRequired': '请输入目的地国家',
  'pages.logistics.regionalManagement.form.destinationCountryPlaceholder': '请输入目的地国家',
  'pages.logistics.regionalManagement.form.destinationCity': '目的地城市',
  'pages.logistics.regionalManagement.form.destinationCityRequired': '请输入目的地城市',
  'pages.logistics.regionalManagement.form.destinationCityPlaceholder': '请输入目的地城市',
  'pages.logistics.regionalManagement.form.affiliationTag': '所属标签',
  'pages.logistics.regionalManagement.form.affiliationTagPlaceholder': '请输入所属标签',
  'pages.logistics.regionalManagement.form.customRegionCode': '自定义区域代码',
  'pages.logistics.regionalManagement.form.customRegionCodePlaceholder': '请输入自定义区域代码',
  'pages.logistics.regionalManagement.form.countryPhoneCode': '国家电话代码',
  'pages.logistics.regionalManagement.form.countryPhoneCodeRequired': '请输入国家电话代码',
  'pages.logistics.regionalManagement.form.countryPhoneCodePlaceholder': '例如：+82, +86',
  'pages.logistics.regionalManagement.form.image': '图片',
  'pages.logistics.regionalManagement.form.regionCode': '区域代码',
  'pages.logistics.regionalManagement.form.regionCodeRequired': '请输入区域代码',
  'pages.logistics.regionalManagement.form.regionName': '区域名称',
  'pages.logistics.regionalManagement.form.regionNameRequired': '请输入区域名称',
  'pages.logistics.regionalManagement.form.country': '国家',
  'pages.logistics.regionalManagement.form.countryRequired': '请输入国家',
  'pages.logistics.regionalManagement.form.province': '省/市',
  'pages.logistics.regionalManagement.form.city': '市/县/区',
  'pages.logistics.regionalManagement.form.postalCode': '邮政编码',
  'pages.logistics.regionalManagement.form.timeZone': '时区',
  'pages.logistics.regionalManagement.form.timeZoneRequired': '请输入时区',
  'pages.logistics.regionalManagement.form.currency': '货币',
  'pages.logistics.regionalManagement.form.currencyRequired': '请输入货币',
  'pages.logistics.regionalManagement.form.description': '描述',
  'pages.logistics.regionalManagement.form.isActive': '激活',

  // Logistics - International Tracking Number Management
  'pages.logistics.internationalTrackingNumberManagement.title': '国际运单号管理',
  'pages.logistics.internationalTrackingNumberManagement.addTitle': '添加新运单号',
  'pages.logistics.internationalTrackingNumberManagement.editTitle': '编辑运单号',
  'pages.logistics.internationalTrackingNumberManagement.add': '添加新运单号',
  'pages.logistics.internationalTrackingNumberManagement.deleteConfirm': '确定要删除吗？',
  'pages.logistics.internationalTrackingNumberManagement.deleteConfirmContent': '确定要删除运单号 "{trackingNumber}" 吗？',
  'pages.logistics.internationalTrackingNumberManagement.deleteSuccess': '已删除',
  'pages.logistics.internationalTrackingNumberManagement.updateSuccess': '已更新',
  'pages.logistics.internationalTrackingNumberManagement.createSuccess': '已创建',
  'pages.logistics.internationalTrackingNumberManagement.submitError': '发生错误',
  'pages.logistics.internationalTrackingNumberManagement.selectItemsFirst': '请选择要导出的项目',
  'pages.logistics.internationalTrackingNumberManagement.exportSuccess': '已导出 {count} 个项目',
  'pages.logistics.internationalTrackingNumberManagement.importSea': '导入海运 Excel',
  'pages.logistics.internationalTrackingNumberManagement.importAir': '导入空运 Excel',
  'pages.logistics.internationalTrackingNumberManagement.importSeaTitle': '导入海运 Excel',
  'pages.logistics.internationalTrackingNumberManagement.importAirTitle': '导入空运 Excel',
  'pages.logistics.internationalTrackingNumberManagement.importSuccess': '{type} Excel 文件已导入',
  'pages.logistics.internationalTrackingNumberManagement.importError': '导入时发生错误',
  'pages.logistics.internationalTrackingNumberManagement.fileRequired': '请选择文件',
  'pages.logistics.internationalTrackingNumberManagement.uploadFile': '选择文件',
  'pages.logistics.internationalTrackingNumberManagement.column.id': 'ID',
  'pages.logistics.internationalTrackingNumberManagement.column.trackingNumber': '运单号',
  'pages.logistics.internationalTrackingNumberManagement.column.transportationType': '运输类型',
  'pages.logistics.internationalTrackingNumberManagement.column.status': '状态',
  'pages.logistics.internationalTrackingNumberManagement.column.createdAt': '创建时间',
  'pages.logistics.internationalTrackingNumberManagement.filter.selectDate': '选择日期',
  'pages.logistics.internationalTrackingNumberManagement.column.orderNumber': '订单号',
  'pages.logistics.internationalTrackingNumberManagement.column.state': '状态',
  'pages.logistics.internationalTrackingNumberManagement.column.time': '时间',
  'pages.logistics.internationalTrackingNumberManagement.column.operate': '操作',
  'pages.logistics.internationalTrackingNumberManagement.column.carrier': '承运商',
  'pages.logistics.internationalTrackingNumberManagement.transportationType.sea': '海运',
  'pages.logistics.internationalTrackingNumberManagement.transportationType.air': '空运',
  'pages.logistics.internationalTrackingNumberManagement.status.unused': '未使用',
  'pages.logistics.internationalTrackingNumberManagement.status.used': '已使用',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumber': '国际运单号',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumberRequired': '请输入运单号',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumberPlaceholder': '请输入运单号',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationType': '运输类型',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationTypeRequired': '请选择运输类型',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationTypePlaceholder': '请选择运输类型',
  'pages.logistics.internationalTrackingNumberManagement.form.excelFile': 'Excel 文件',
  'pages.logistics.internationalTrackingNumberManagement.form.excelFileRequired': '请选择 Excel 文件',

  // Logistics - HS Product Code Management
  'pages.logistics.hsProductCodeManagement.title': 'HS 商品代码管理',
  'pages.logistics.hsProductCodeManagement.addTitle': '添加新分类',
  'pages.logistics.hsProductCodeManagement.editTitle': '编辑 HS 商品代码',
  'pages.logistics.hsProductCodeManagement.add': '添加新分类',
  'pages.logistics.hsProductCodeManagement.deleteConfirm': '确定要删除吗？',
  'pages.logistics.hsProductCodeManagement.deleteSuccess': '已删除',
  'pages.logistics.hsProductCodeManagement.updateSuccess': '已更新',
  'pages.logistics.hsProductCodeManagement.createSuccess': '已创建',
  'pages.logistics.hsProductCodeManagement.submitError': '发生错误',
  'pages.logistics.hsProductCodeManagement.importBulk': '批量导入分类',
  'pages.logistics.hsProductCodeManagement.importSelective': '选择性导入分类',
  'pages.logistics.hsProductCodeManagement.importBulkTitle': '批量导入分类',
  'pages.logistics.hsProductCodeManagement.importSelectiveTitle': '选择性导入分类',
  'pages.logistics.hsProductCodeManagement.importSuccess': '{type} 导入已完成',
  'pages.logistics.hsProductCodeManagement.importError': '导入时发生错误',
  'pages.logistics.hsProductCodeManagement.importType.bulk': '批量',
  'pages.logistics.hsProductCodeManagement.importType.selective': '选择性',
  'pages.logistics.hsProductCodeManagement.export': '导出分类',
  'pages.logistics.hsProductCodeManagement.exportSuccess': '导出已完成',
  'pages.logistics.hsProductCodeManagement.fileRequired': '请选择文件',
  'pages.logistics.hsProductCodeManagement.uploadFile': '选择文件',
  'pages.logistics.hsProductCodeManagement.column.id': 'ID',
  'pages.logistics.hsProductCodeManagement.column.classificationName': '分类名称',
  'pages.logistics.hsProductCodeManagement.column.classificationNameEn': '分类英文名',
  'pages.logistics.hsProductCodeManagement.column.productCode': '商品代码',
  'pages.logistics.hsProductCodeManagement.column.simplifiedType': '简易/非简易',
  'pages.logistics.hsProductCodeManagement.column.createdAt': '添加时间',
  'pages.logistics.hsProductCodeManagement.simplifiedType.simplified': '简易',
  'pages.logistics.hsProductCodeManagement.simplifiedType.nonSimplified': '非简易',
  'pages.logistics.hsProductCodeManagement.form.classificationName': '分类名称',
  'pages.logistics.hsProductCodeManagement.form.classificationNameRequired': '请输入分类名称',
  'pages.logistics.hsProductCodeManagement.form.classificationNamePlaceholder': '请输入分类名称',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEn': '分类英文名',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEnRequired': '请输入分类英文名',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEnPlaceholder': '请输入分类英文名',
  'pages.logistics.hsProductCodeManagement.form.productCode': '商品代码',
  'pages.logistics.hsProductCodeManagement.form.productCodeRequired': '请输入商品代码',
  'pages.logistics.hsProductCodeManagement.form.productCodePlaceholder': '例如：HS6203.42.90',
  'pages.logistics.hsProductCodeManagement.form.simplifiedType': '简易/非简易',
  'pages.logistics.hsProductCodeManagement.form.simplifiedTypeRequired': '请选择简易类型',
  'pages.logistics.hsProductCodeManagement.form.referenceImage': '参考图片',
  'pages.logistics.hsProductCodeManagement.form.excelFile': 'Excel 文件',
  'pages.logistics.hsProductCodeManagement.form.excelFileRequired': '请选择 Excel 文件',
  'pages.logistics.internationalTrackingNumberManagement.column.originCountry': '始发国',
  'pages.logistics.internationalTrackingNumberManagement.column.destinationCountry': '目的国',
  'pages.logistics.internationalTrackingNumberManagement.column.shippingDate': '发货日期',
  'pages.logistics.internationalTrackingNumberManagement.column.estimatedDeliveryDate': '预计送达日期',
  'pages.logistics.internationalTrackingNumberManagement.column.actualDeliveryDate': '实际送达日期',
  'pages.logistics.internationalTrackingNumberManagement.column.customsStatus': '通关状态',
  'pages.logistics.internationalTrackingNumberManagement.status.pending': '待处理',
  'pages.logistics.internationalTrackingNumberManagement.status.inTransit': '运输中',
  'pages.logistics.internationalTrackingNumberManagement.status.customsClearance': '通关中',
  'pages.logistics.internationalTrackingNumberManagement.status.delivered': '已送达',
  'pages.logistics.internationalTrackingNumberManagement.status.exception': '异常',
  'pages.logistics.internationalTrackingNumberManagement.state.pending': '待处理',
  'pages.logistics.internationalTrackingNumberManagement.state.inTransit': '运输中',
  'pages.logistics.internationalTrackingNumberManagement.state.customsClearance': '通关中',
  'pages.logistics.internationalTrackingNumberManagement.state.delivered': '已送达',
  'pages.logistics.internationalTrackingNumberManagement.state.exception': '异常',
  'pages.logistics.internationalTrackingNumberManagement.form.orderNumber': '订单号',
  'pages.logistics.internationalTrackingNumberManagement.form.orderNumberRequired': '请输入订单号',
  'pages.logistics.internationalTrackingNumberManagement.form.carrier': '承运商',
  'pages.logistics.internationalTrackingNumberManagement.form.carrierRequired': '请选择承运商',
  'pages.logistics.internationalTrackingNumberManagement.form.originCountry': '始发国',
  'pages.logistics.internationalTrackingNumberManagement.form.originCountryRequired': '请输入始发国',
  'pages.logistics.internationalTrackingNumberManagement.form.destinationCountry': '目的国',
  'pages.logistics.internationalTrackingNumberManagement.form.destinationCountryRequired': '请输入目的国',
  'pages.logistics.internationalTrackingNumberManagement.form.status': '状态',
  'pages.logistics.internationalTrackingNumberManagement.form.statusRequired': '请选择状态',
  'pages.logistics.internationalTrackingNumberManagement.form.state': '状态',
  'pages.logistics.internationalTrackingNumberManagement.form.stateRequired': '请选择状态',
  'pages.logistics.internationalTrackingNumberManagement.form.time': '时间',
  'pages.logistics.internationalTrackingNumberManagement.form.timeRequired': '请输入时间',
  'pages.logistics.internationalTrackingNumberManagement.form.customsStatus': '通关状态',
  'pages.logistics.internationalTrackingNumberManagement.form.notes': '备注',

  // Article Management page
  'pages.articleManagement.title': '文章管理',
  'pages.articleManagement.add': '创建文章',
  'pages.articleManagement.edit': '编辑文章',
  'pages.articleManagement.delete': '删除文章',
  'pages.articleManagement.deleteConfirm': '删除文章',
  'pages.articleManagement.deleteConfirmMessage': '确定要删除文章 "{title}" 吗？',

  // Website Content Management
  'pages.system.websiteContentManagement.title': '网站内容管理',
  'pages.system.websiteContentManagement.tab.seoSettings': '网站SEO设置',
  'pages.system.websiteContentManagement.tab.emailConfiguration': '邮件配置',
  'pages.system.websiteContentManagement.tab.imageSettings': '图片设置',
  'pages.system.websiteContentManagement.tab.basicConfiguration': '网站基本配置',
  'pages.system.websiteContentManagement.tab.appSettings': '应用设置',

  // Website SEO Settings
  'pages.system.websiteSEOSettings.title': '网站SEO设置',
  'pages.system.websiteSEOSettings.websiteTitle': '网站标题:',
  'pages.system.websiteSEOSettings.websiteTitlePlaceholder': '网站标题',
  'pages.system.websiteSEOSettings.websiteKeywords': '网站关键词:',
  'pages.system.websiteSEOSettings.websiteKeywordsPlaceholder': '网站关键词',
  'pages.system.websiteSEOSettings.websiteDescription': '网站描述:',
  'pages.system.websiteSEOSettings.websiteDescriptionPlaceholder': '网站详细描述',
  'pages.system.websiteSEOSettings.googleAnalytics': 'Google Analytics:',
  'pages.system.websiteSEOSettings.googleAnalyticsDescription': '输入Google Analytics代码的令牌密钥',
  'pages.system.websiteSEOSettings.baiduStatistics': '百度统计:',
  'pages.system.websiteSEOSettings.baiduStatisticsDescription': '输入百度分析代码的令牌密钥',
  'pages.system.websiteSEOSettings.facebookStatistics': 'Facebook统计:',
  'pages.system.websiteSEOSettings.facebookStatisticsDescription': '设置Facebook跟踪代码，特别是Facebook像素跟踪代码，是为了方便在Facebook上进行推广。',
  'pages.system.websiteSEOSettings.javascriptCode': 'JavaScript代码:',
  'pages.system.websiteSEOSettings.javascriptCodeDescription': '需要执行的其他JavaScript代码',
  'pages.system.websiteSEOSettings.javascriptCodePlaceholder': '输入JavaScript代码',
  'pages.system.websiteSEOSettings.mapDomainSettings': '地图域名设置:',
  'pages.system.websiteSEOSettings.mapDomainSettingsDescription': '默认域名是网站域名。绑定正式域名后，网站地图中的域名将批量更改为正式域名。',
  'pages.system.websiteSEOSettings.mapDomainSettingsPlaceholder': '输入域名',
  'pages.system.websiteSEOSettings.pleaseEnter': '请输入',
  'pages.system.websiteSEOSettings.saveSuccess': '设置保存成功',
  'pages.system.websiteSEOSettings.saveError': '保存设置失败',

  // Email Configuration
  'pages.system.emailConfiguration.title': '邮件配置',
  'pages.system.emailConfiguration.emailSMTP': '邮件SMTP:',
  'pages.system.emailConfiguration.emailSMTPDescription': '发送邮件的服务器，例如 smtp.qq.com。',
  'pages.system.emailConfiguration.emailSMTPPlaceholder': '输入SMTP服务器',
  'pages.system.emailConfiguration.emailPort': '邮件端口:',
  'pages.system.emailConfiguration.emailPortDescription': '邮件地址对应的端口号，例如：465',
  'pages.system.emailConfiguration.emailPortPlaceholder': '输入端口号',
  'pages.system.emailConfiguration.senderName': '发件人名称:',
  'pages.system.emailConfiguration.senderNameDescription': '发件人名称',
  'pages.system.emailConfiguration.senderNamePlaceholder': '输入发件人名称',
  'pages.system.emailConfiguration.outboxPassword': '发件箱密码:',
  'pages.system.emailConfiguration.outboxPasswordDescription': '发件人的邮箱密码',
  'pages.system.emailConfiguration.outboxPasswordPlaceholder': '输入密码',
  'pages.system.emailConfiguration.outbox': '发件箱:',
  'pages.system.emailConfiguration.outboxDescription': '发件人的邮箱地址',
  'pages.system.emailConfiguration.outboxPlaceholder': '输入邮箱地址',
  'pages.system.emailConfiguration.backendInbox': '后端收件箱:',
  'pages.system.emailConfiguration.backendInboxDescription': '接收发送到后端的电子邮件的电子邮件地址（例如，"客户已下订单"）。',
  'pages.system.emailConfiguration.backendInboxPlaceholder': '输入邮箱地址',
  'pages.system.emailConfiguration.recipientName': '收件人名称:',
  'pages.system.emailConfiguration.recipientNameDescription': '接收后端电子邮件时的发件人名称',
  'pages.system.emailConfiguration.recipientNamePlaceholder': '输入收件人名称',
  'pages.system.emailConfiguration.platformAccount': '平台账号:',
  'pages.system.emailConfiguration.platformAccountDescription': '输入相关短信/翻译平台的登录账号。',
  'pages.system.emailConfiguration.platformAccountPlaceholder': '输入平台账号',
  'pages.system.emailConfiguration.platformPassword': '平台密码:',
  'pages.system.emailConfiguration.platformPasswordDescription': '输入相关短信/翻译平台的登录密码。',
  'pages.system.emailConfiguration.platformPasswordPlaceholder': '输入平台密码',
  'pages.system.emailConfiguration.emailSSL': '邮件SSL:',
  'pages.system.emailConfiguration.emailSSLDescription': 'ssl',
  'pages.system.emailConfiguration.emailSSLPlaceholder': '选择SSL选项',
  'pages.system.emailConfiguration.saveSuccess': '设置保存成功',
  'pages.system.emailConfiguration.saveError': '保存设置失败',

  // Image Settings
  'pages.system.imageSettings.title': '图片设置',
  'pages.system.imageSettings.websiteLogo': '网站Logo',
  'pages.system.imageSettings.websiteLogoDescription': '上传网站Logo图片',
  'pages.system.imageSettings.homepageQRCode': '首页二维码',
  'pages.system.imageSettings.homepageQRCodeDescription': '上传首页二维码图片',
  'pages.system.imageSettings.mobileLogo': '移动端Logo',
  'pages.system.imageSettings.mobileLogoDescription': '上传移动端Logo图片',
  'pages.system.imageSettings.pcWebsiteIcon': 'PC网站图标',
  'pages.system.imageSettings.pcWebsiteIconDescription': '上传PC网站图标（favicon）',
  'pages.system.imageSettings.pcPromotionalImage': 'PC促销图片',
  'pages.system.imageSettings.pcPromotionalImageDescription': '上传PC促销图片',
  'pages.system.imageSettings.appSharingImage': 'App分享图片',
  'pages.system.imageSettings.appSharingImageDescription': '上传App分享图片',
  'pages.system.imageSettings.pcRegistrationBackgroundImage': 'PC注册背景图片',
  'pages.system.imageSettings.pcRegistrationBackgroundImageDescription': '上传PC注册背景图片',
  'pages.system.imageSettings.pcLoginBackgroundImage': 'PC登录背景图片',
  'pages.system.imageSettings.pcLoginBackgroundImageDescription': '上传PC登录背景图片',
  'pages.system.imageSettings.defaultDetailImage': '详情默认图片',
  'pages.system.imageSettings.defaultDetailImageDescription': '上传商品详情默认图片',
  'pages.system.imageSettings.imageUrlPlaceholder': '图片URL',
  'pages.system.imageSettings.upload': '上传',
  'pages.system.imageSettings.uploadSuccess': '图片上传成功',
  'pages.system.imageSettings.uploadFailed': '图片上传失败',
  'pages.system.imageSettings.uploadImageOnly': '仅允许上传图片文件',
  'pages.system.imageSettings.imageSizeLimit': '图片大小必须小于10MB',
  'pages.system.imageSettings.saveSuccess': '设置保存成功',
  'pages.system.imageSettings.saveError': '保存设置失败',

  // Website Basic Configuration
  'pages.system.websiteBasicConfiguration.title': '网站基本配置',
  'pages.system.websiteBasicConfiguration.websiteName': '网站名称:',
  'pages.system.websiteBasicConfiguration.websiteNamePlaceholder': '输入网站名称',
  'pages.system.websiteBasicConfiguration.websiteHomepageName': '网站首页名称（欢迎来到xxxx）',
  'pages.system.websiteBasicConfiguration.websiteHomepageNameDescription': '欢迎来到xxxx',
  'pages.system.websiteBasicConfiguration.websiteHomepageNamePlaceholder': '输入首页名称',
  'pages.system.websiteBasicConfiguration.storageFees': '仓储费用:',
  'pages.system.websiteBasicConfiguration.storageFeesDescription': '仓储费用（单价/天）',
  'pages.system.websiteBasicConfiguration.storageFeesPlaceholder': '输入仓储费用',
  'pages.system.websiteBasicConfiguration.storageDays': '仓储天数:',
  'pages.system.websiteBasicConfiguration.storageDaysDescription': '仓库免费仓储天数（单位：天）',
  'pages.system.websiteBasicConfiguration.storageDaysPlaceholder': '输入仓储天数',
  'pages.system.websiteBasicConfiguration.expirationTime': '过期时间:',
  'pages.system.websiteBasicConfiguration.expirationTimeDescription': '购物车商品过期时间（单位：天）',
  'pages.system.websiteBasicConfiguration.expirationTimePlaceholder': '输入过期时间',
  'pages.system.websiteBasicConfiguration.deleteShoppingCart': '删除购物车:',
  'pages.system.websiteBasicConfiguration.deleteShoppingCartDescription': '购物车商品将在多长时间后被移除（单位：天）？',
  'pages.system.websiteBasicConfiguration.deleteShoppingCartPlaceholder': '输入天数',
  'pages.system.websiteBasicConfiguration.registrationAgreement': '注册协议:',
  'pages.system.websiteBasicConfiguration.registrationAgreementDescription': '注册页面隐私协议文章配置（需要填写在文章管理中添加的文章ID）',
  'pages.system.websiteBasicConfiguration.registrationAgreementPlaceholder': '输入文章ID',
  'pages.system.websiteBasicConfiguration.exportList': '导出列表:',
  'pages.system.websiteBasicConfiguration.exportListDescription': '美元汇率与主货币的比率',
  'pages.system.websiteBasicConfiguration.exportListPlaceholder': '输入汇率',
  'pages.system.websiteBasicConfiguration.customerServiceCode': '客服代码:',
  'pages.system.websiteBasicConfiguration.customerServiceCodeDescription': '设置客服JavaScript代码',
  'pages.system.websiteBasicConfiguration.customerServiceCodePlaceholder': '请输入',
  'pages.system.websiteBasicConfiguration.customerServiceHotline': '客服热线:',
  'pages.system.websiteBasicConfiguration.customerServiceHotlineDescription': '网站联系信息设置',
  'pages.system.websiteBasicConfiguration.customerServiceHotlinePlaceholder': '输入热线',
  'pages.system.websiteBasicConfiguration.customerServiceEmail': '客服邮箱:',
  'pages.system.websiteBasicConfiguration.customerServiceEmailDescription': '网站联系信息设置',
  'pages.system.websiteBasicConfiguration.customerServiceEmailPlaceholder': '输入邮箱',
  'pages.system.websiteBasicConfiguration.filingInformation': '备案信息:',
  'pages.system.websiteBasicConfiguration.filingInformationDescription': '网站页脚版权信息和备案设置',
  'pages.system.websiteBasicConfiguration.filingInformationPlaceholder': '输入备案信息',
  'pages.system.websiteBasicConfiguration.customerServiceWeChat': '客服微信:',
  'pages.system.websiteBasicConfiguration.customerServiceWeChatDescription': '网站联系信息设置',
  'pages.system.websiteBasicConfiguration.customerServiceWeChatPlaceholder': '输入微信',
  'pages.system.websiteBasicConfiguration.themeColorSettings': '主题颜色设置:',
  'pages.system.websiteBasicConfiguration.themeColorSettingsDescription': '网站主题颜色，不包括图标',
  'pages.system.websiteBasicConfiguration.shippingUnit': '运费单位:',
  'pages.system.websiteBasicConfiguration.shippingUnitDescription': '设置运费单位：输入kg/g。（主要显示页面显示：运费估算和下单。）',
  'pages.system.websiteBasicConfiguration.shippingUnitPlaceholder': '输入kg/g',
  'pages.system.websiteBasicConfiguration.frontEndHomepage': '前端首页:',
  'pages.system.websiteBasicConfiguration.frontEndHomepageDescription': '默认首页',
  'pages.system.websiteBasicConfiguration.frontEndHomepagePlaceholder': '输入首页路径',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCode': '区域行政代码:',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCodeDescription': '输入采购仓库地址行政代码的前6位数字（在以下网址查找区域代码：https://xingzhengquhua.bmcx.com/）',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCodePlaceholder': '输入6位数字代码',
  'pages.system.websiteBasicConfiguration.cancelOrder': '取消订单:',
  'pages.system.websiteBasicConfiguration.cancelOrderDescription': '设置采购订单将在多长时间后自动取消。',
  'pages.system.websiteBasicConfiguration.cancelOrderPlaceholder': '输入时间',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeout': '超时自动确认收货（小时）:',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeoutDescription': 'xxx小时后自动发货',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeoutPlaceholder': '输入小时数',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywords': '首页瀑布流布局关键词:',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywordsDescription': '仅允许中文关键词；可以输入多个关键词。',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywordsPlaceholder': '输入用逗号分隔的关键词',
  'pages.system.websiteBasicConfiguration.saveSuccess': '设置保存成功',
  'pages.system.websiteBasicConfiguration.saveError': '保存设置失败',

  // App Settings
  'pages.system.appSettings.title': '应用设置',
  'pages.system.appSettings.androidVersionNumber': 'Android版本号:',
  'pages.system.appSettings.androidVersionNumberDescription': '输入Android应用版本号',
  'pages.system.appSettings.androidVersionNumberPlaceholder': '例如：1.0.0',
  'pages.system.appSettings.iosVersionNumber': 'iOS版本号:',
  'pages.system.appSettings.iosVersionNumberDescription': '输入iOS应用版本号',
  'pages.system.appSettings.iosVersionNumberPlaceholder': '例如：1.0.0',
  'pages.system.appSettings.androidDownloadLink': 'Android下载链接:',
  'pages.system.appSettings.androidDownloadLinkDescription': '输入Android应用下载链接',
  'pages.system.appSettings.androidDownloadLinkPlaceholder': 'https://...',
  'pages.system.appSettings.iosDownloadLink': 'iOS下载链接:',
  'pages.system.appSettings.iosDownloadLinkDescription': '输入iOS应用下载链接',
  'pages.system.appSettings.iosDownloadLinkPlaceholder': 'https://...',
  'pages.system.appSettings.saveSuccess': '设置保存成功',
  'pages.system.appSettings.saveError': '保存设置失败',
  'pages.articleManagement.deleteSuccess': '文章已删除',
  'pages.articleManagement.updateSuccess': '文章已更新',
  'pages.articleManagement.createSuccess': '文章已创建',
  'pages.articleManagement.id': 'ID',
  'pages.articleManagement.titleColumn': '标题',
  'pages.articleManagement.category': '类别',
  'pages.articleManagement.category.notice': '公告',
  'pages.articleManagement.category.news': '新闻',
  'pages.articleManagement.category.guide': '使用指南',
  'pages.articleManagement.category.event': '活动',
  'pages.articleManagement.category.faq': '常见问题',
  'pages.articleManagement.author': '作者',
  'pages.articleManagement.status': '状态',
  'pages.articleManagement.status.published': '已发布',
  'pages.articleManagement.status.draft': '草稿',
  'pages.articleManagement.status.hidden': '隐藏',
  'pages.articleManagement.tags': '标签',
  'pages.articleManagement.views': '浏览量',
  'pages.articleManagement.likes': '点赞',
  'pages.articleManagement.comments': '评论',
  'pages.articleManagement.createdAt': '创建日期',
  'pages.articleManagement.updatedAt': '更新日期',
  'pages.articleManagement.actions': '操作',
  'pages.articleManagement.view': '查看',
  'pages.articleManagement.editButton': '编辑',
  'pages.articleManagement.deleteButton': '删除',
  'pages.articleManagement.form.title': '标题',
  'pages.articleManagement.form.titleRequired': '请输入标题',
  'pages.articleManagement.form.titlePlaceholder': '文章标题',
  'pages.articleManagement.form.category': '类别',
  'pages.articleManagement.form.categoryPlaceholder': '选择类别',
  'pages.articleManagement.form.content': '内容',
  'pages.articleManagement.form.contentRequired': '请输入内容',
  'pages.articleManagement.form.contentPlaceholder': '输入文章内容',
  'pages.articleManagement.form.tags': '标签',
  'pages.articleManagement.form.tagsPlaceholder': '输入标签（按Enter添加）',
  'pages.articleManagement.form.status': '状态',
  'pages.articleManagement.form.statusPlaceholder': '选择状态',
  'pages.articleManagement.mock.title1': '新服务上线通知',
  'pages.articleManagement.mock.title2': '配送延迟公告',
  'pages.articleManagement.mock.title3': '淘宝购买指南',
  'pages.articleManagement.mock.title4': '折扣活动',
  'pages.articleManagement.mock.title5': '常见问题更新',
  'pages.articleManagement.mock.author1': '管理员',
  'pages.articleManagement.mock.author2': '运营团队',
  'pages.articleManagement.mock.author3': '客户服务',
  'pages.articleManagement.mock.content': '文章内容...',
  'pages.articleManagement.mock.tag1': '重要',
  'pages.articleManagement.mock.tag2': '必读',
  'pages.articleManagement.mock.tag3': '活动',
  'pages.articleManagement.mock.tag4': '紧急',

  // Advertise Management
  'pages.advertise.title': '广告管理',
  'pages.advertise.list': '广告列表',
  'pages.advertise.add': '添加广告',
  'pages.advertise.edit': '编辑广告',
  'pages.advertise.delete': '删除广告',
  'pages.advertise.deleteConfirm': '确定要删除广告 "{title}" 吗？',
  'pages.advertise.deleteSuccess': '广告已删除',
  'pages.advertise.updateSuccess': '广告已更新',
  'pages.advertise.createSuccess': '广告已添加',
  'pages.advertise.column.id': 'ID',
  'pages.advertise.column.title': '广告名称',
  'pages.advertise.column.image': '广告图片',
  'pages.advertise.column.type': '广告类型',
  'pages.advertise.column.position': '显示位置',
  'pages.advertise.column.linkUrl': '链接地址',
  'pages.advertise.column.dateRange': '发布时间',
  'pages.advertise.column.startDate': '开始日期',
  'pages.advertise.column.endDate': '结束日期',
  'pages.advertise.column.status': '状态',
  'pages.advertise.column.order': '显示顺序',
  'pages.advertise.column.views': '浏览量',
  'pages.advertise.column.clicks': '点击量',
  'pages.advertise.column.action': '操作',
  'pages.advertise.type.banner': '横幅',
  'pages.advertise.type.popup': '弹窗',
  'pages.advertise.type.sidebar': '侧边栏',
  'pages.advertise.position.mainTop': '主页顶部',
  'pages.advertise.position.mainMiddle': '主页中部',
  'pages.advertise.position.mainBottom': '主页底部',
  'pages.advertise.position.productList': '商品列表',
  'pages.advertise.position.productDetail': '商品详情',
  'pages.advertise.position.orderPage': '订单页面',
  'pages.advertise.status.active': '启用',
  'pages.advertise.status.inactive': '禁用',
  'pages.advertise.action.preview': '预览',
  'pages.advertise.action.edit': '编辑',
  'pages.advertise.action.delete': '删除',
  'pages.advertise.form.title': '广告名称',
  'pages.advertise.form.titlePlaceholder': '广告名称',
  'pages.advertise.form.titleRequired': '请输入广告名称',
  'pages.advertise.form.type': '广告类型',
  'pages.advertise.form.typePlaceholder': '选择广告类型',
  'pages.advertise.form.position': '显示位置',
  'pages.advertise.form.positionPlaceholder': '选择显示位置',
  'pages.advertise.form.image': '广告图片',
  'pages.advertise.form.imageUpload': '上传图片',
  'pages.advertise.form.dateRange': '发布时间',
  'pages.advertise.form.dateRangeRequired': '请选择发布时间',
  'pages.advertise.form.linkUrl': '链接地址',
  'pages.advertise.form.linkUrlPlaceholder': 'https://example.com',
  'pages.advertise.form.linkUrlInvalid': '请输入有效的URL',
  'pages.advertise.form.order': '显示顺序',
  'pages.advertise.form.orderPlaceholder': '数字越小越先显示',
  'pages.advertise.form.status': '状态',
  'pages.advertise.form.statusPlaceholder': '选择状态',
  'pages.advertise.mock.newMemberDiscount': '新会员折扣',
  'pages.advertise.mock.freeShippingEvent': '免费配送活动',
  'pages.advertise.mock.timeSale': '限时特卖',
  'pages.advertise.mock.seasonSpecial': '季节特价',
  'pages.advertise.mock.adSuffix': '广告',

  // Banners Management
  'pages.banners.title': '横幅/活动管理',
  'pages.banners.list': '横幅列表',
  'pages.banners.add': '添加横幅',
  'pages.banners.edit': '编辑横幅',
  'pages.banners.delete': '删除横幅',
  'pages.banners.deleteConfirm': '确定要删除横幅 "{title}" 吗？',
  'pages.banners.deleteSuccess': '横幅已删除',
  'pages.banners.updateSuccess': '横幅已更新',
  'pages.banners.createSuccess': '横幅已添加',
  'pages.banners.column.id': 'ID',
  'pages.banners.column.image': '横幅图片',
  'pages.banners.column.title': '横幅名称',
  'pages.banners.column.position': '显示位置',
  'pages.banners.column.order': '显示顺序',
  'pages.banners.column.dateRange': '发布时间',
  'pages.banners.column.views': '浏览量',
  'pages.banners.column.clicks': '点击量',
  'pages.banners.column.status': '状态',
  'pages.banners.column.action': '操作',
  'pages.banners.position.mainTop': '主页顶部',
  'pages.banners.position.mainMiddle': '主页中部',
  'pages.banners.position.mainBottom': '主页底部',
  'pages.banners.position.sidebar': '侧边栏',
  'pages.banners.status.active': '启用',
  'pages.banners.status.inactive': '禁用',
  'pages.banners.status.expired': '已过期',
  'pages.banners.action.preview': '预览',
  'pages.banners.action.edit': '编辑',
  'pages.banners.action.delete': '删除',
  'pages.banners.form.title': '横幅名称',
  'pages.banners.form.titlePlaceholder': '横幅名称',
  'pages.banners.form.titleRequired': '请输入横幅名称',
  'pages.banners.form.position': '显示位置',
  'pages.banners.form.positionPlaceholder': '选择显示位置',
  'pages.banners.form.image': '横幅图片',
  'pages.banners.form.imageUpload': '上传图片',
  'pages.banners.form.linkUrl': '链接地址',
  'pages.banners.form.linkUrlPlaceholder': 'https://example.com',
  'pages.banners.form.linkUrlInvalid': '请输入有效的URL',
  'pages.banners.form.dateRange': '发布时间',
  'pages.banners.form.dateRangeRequired': '请选择发布时间',
  'pages.banners.form.order': '显示顺序',
  'pages.banners.form.orderPlaceholder': '数字越小越先显示',
  'pages.banners.form.status': '状态',
  'pages.banners.form.statusActive': '启用',
  'pages.banners.form.statusInactive': '禁用',
  'pages.banners.mock.newMemberDiscount': '新会员折扣',
  'pages.banners.mock.freeShipping': '免费配送',
  'pages.banners.mock.timeSale': '限时特卖',
  'pages.banners.mock.seasonSpecial': '季节特价',
  'pages.banners.mock.eventSuffix': '活动',

  // Banner Advertisement Management
  'pages.bannerAdvertisement.title': '横幅管理',
  'pages.bannerAdvertisement.list': '横幅列表',
  'pages.bannerAdvertisement.add': '添加横幅',
  'pages.bannerAdvertisement.edit': '编辑横幅',
  'pages.bannerAdvertisement.delete': '删除横幅',
  'pages.bannerAdvertisement.deleteConfirm': '确定要删除横幅 "{title}" 吗？',
  'pages.bannerAdvertisement.deleteSuccess': '横幅已删除',
  'pages.bannerAdvertisement.updateSuccess': '横幅已更新',
  'pages.bannerAdvertisement.createSuccess': '横幅已添加',
  'pages.bannerAdvertisement.loadBannerError': '加载横幅信息失败',
  'pages.bannerAdvertisement.deleteError': '删除失败',
  'pages.bannerAdvertisement.operationFailed': '操作失败',
  'pages.bannerAdvertisement.column.id': 'ID',
  'pages.bannerAdvertisement.column.image': '图片',
  'pages.bannerAdvertisement.column.title': '标题',
  'pages.bannerAdvertisement.column.category': '分类',
  'pages.bannerAdvertisement.column.exposureLocation': '显示位置',
  'pages.bannerAdvertisement.column.exposureOrder': '显示顺序',
  'pages.bannerAdvertisement.column.dateRange': '发布时间',
  'pages.bannerAdvertisement.column.views': '浏览量',
  'pages.bannerAdvertisement.column.clicks': '点击量',
  'pages.bannerAdvertisement.column.status': '状态',
  'pages.bannerAdvertisement.column.active': '启用',
  'pages.bannerAdvertisement.column.action': '操作',
  'pages.bannerAdvertisement.category.promotion': '促销',
  'pages.bannerAdvertisement.category.event': '活动',
  'pages.bannerAdvertisement.category.announcement': '公告',
  'pages.bannerAdvertisement.category.product': '商品',
  'pages.bannerAdvertisement.category.other': '其他',
  'pages.bannerAdvertisement.location.home': '首页',
  'pages.bannerAdvertisement.location.category': '分类',
  'pages.bannerAdvertisement.location.product': '商品',
  'pages.bannerAdvertisement.location.cart': '购物车',
  'pages.bannerAdvertisement.location.checkout': '结算',
  'pages.bannerAdvertisement.location.profile': '个人资料',
  'pages.bannerAdvertisement.location.other': '其他',
  'pages.bannerAdvertisement.situation.active': '启用',
  'pages.bannerAdvertisement.situation.inactive': '禁用',
  'pages.bannerAdvertisement.situation.scheduled': '已预约',
  'pages.bannerAdvertisement.situation.expired': '已过期',
  'pages.bannerAdvertisement.status.active': '启用',
  'pages.bannerAdvertisement.status.inactive': '禁用',
  'pages.bannerAdvertisement.action.edit': '编辑',
  'pages.bannerAdvertisement.action.delete': '删除',
  'pages.bannerAdvertisement.form.title': '标题',
  'pages.bannerAdvertisement.form.titleRequired': '请输入标题',
  'pages.bannerAdvertisement.form.titleAtLeastOneLanguage': '请至少用一种语言输入标题',
  'pages.bannerAdvertisement.form.titlePlaceholder': '横幅标题（最多200个字符）',
  'pages.bannerAdvertisement.form.imageUrl': '图片地址',
  'pages.bannerAdvertisement.form.imageUrlRequired': '请输入图片地址',
  'pages.bannerAdvertisement.form.imageUrlPlaceholder': 'https://example.com/banner.jpg',
  'pages.bannerAdvertisement.form.category': '分类',
  'pages.bannerAdvertisement.form.categoryRequired': '请选择分类',
  'pages.bannerAdvertisement.form.categoryPlaceholder': '选择分类',
  'pages.bannerAdvertisement.form.exposureLocation': '显示位置',
  'pages.bannerAdvertisement.form.exposureLocationRequired': '请选择显示位置',
  'pages.bannerAdvertisement.form.exposureLocationPlaceholder': '选择显示位置',
  'pages.bannerAdvertisement.form.exposureOrder': '显示顺序',
  'pages.bannerAdvertisement.form.exposureOrderRequired': '请输入显示顺序',
  'pages.bannerAdvertisement.form.exposureOrderPlaceholder': '数字越小越先显示（0或以上）',
  'pages.bannerAdvertisement.form.startDate': '开始时间',
  'pages.bannerAdvertisement.form.startDateRequired': '请选择开始时间',
  'pages.bannerAdvertisement.form.startDatePlaceholder': '选择开始时间',
  'pages.bannerAdvertisement.form.endDate': '结束时间',
  'pages.bannerAdvertisement.form.endDateRequired': '请选择结束时间',
  'pages.bannerAdvertisement.form.endDatePlaceholder': '选择结束时间',
  'pages.bannerAdvertisement.form.linkUrl': '链接地址',
  'pages.bannerAdvertisement.form.linkUrlInvalid': '请输入有效的URL格式',
  'pages.bannerAdvertisement.form.linkUrlPlaceholder': 'https://example.com（可选）',
  'pages.bannerAdvertisement.form.isActive': '启用状态',
  'pages.bannerAdvertisement.form.isActiveActive': '启用',
  'pages.bannerAdvertisement.form.isActiveInactive': '禁用',
  'pages.bannerAdvertisement.validation.startEndDateRequired': '请同时选择开始和结束时间',
  'pages.bannerAdvertisement.validation.endDateAfterStartDate': '结束时间必须晚于开始时间',
  'pages.bannerAdvertisement.validation.titleAtLeastOneLanguage': '请至少用一种语言输入标题',
  'pages.bannerAdvertisement.validation.imageUrlRequired': '请输入图片地址',
  'pages.bannerAdvertisement.validation.categoryRequired': '请选择分类',
  'pages.bannerAdvertisement.validation.exposureLocationRequired': '请选择显示位置',
  'pages.bannerAdvertisement.modal.edit': '编辑',
  'pages.bannerAdvertisement.modal.register': '注册',
  'pages.bannerAdvertisement.modal.cancel': '取消',
  'pages.bannerAdvertisement.image.noImage': '无图片',
  'pages.bannerAdvertisement.pagination.total': '共 {total} 个',
  'pages.bannerAdvertisement.multilingual.korean': '韩语',
  'pages.bannerAdvertisement.multilingual.koreanPlaceholder': '用韩语输入',
  'pages.bannerAdvertisement.multilingual.english': '英语',
  'pages.bannerAdvertisement.multilingual.englishPlaceholder': '用英语输入',
  'pages.bannerAdvertisement.multilingual.chinese': '中文',
  'pages.bannerAdvertisement.multilingual.chinesePlaceholder': '用中文输入',
  'pages.bannerAdvertisement.tabs.banners': '横幅',
  'pages.bannerAdvertisement.tabs.carousel': '轮播',
  'pages.bannerAdvertisement.tabs.popup': '弹窗（直播 / 卖家 / 商品）',
  'pages.bannerAdvertisement.popup.introTitle': '页面弹窗',
  'pages.bannerAdvertisement.popup.introDesc':
    '为直播页、卖家详情页、商品详情页配置可选弹窗。开启对应位置，上传图片、填写视频地址、文案与链接后保存。前台可通过 GET /admin/marketing-popups 读取相同 JSON。',
  'pages.bannerAdvertisement.popup.localOnlyTitle': '仅保存在本浏览器',
  'pages.bannerAdvertisement.popup.localOnlyDesc':
    'marketing-popups 接口不可用或请求失败，配置已写入 localStorage，仅本机管理员可见。接入后端后可对所有用户生效。',
  'pages.bannerAdvertisement.popup.slot.live': '直播页',
  'pages.bannerAdvertisement.popup.slot.sellerDetail': '卖家详情页',
  'pages.bannerAdvertisement.popup.slot.productDetail': '商品详情页',
  'pages.bannerAdvertisement.popup.image': '弹窗图片',
  'pages.bannerAdvertisement.popup.changeImage': '更换图片',
  'pages.bannerAdvertisement.popup.videoUrl': '视频地址',
  'pages.bannerAdvertisement.popup.videoUrlPlaceholder': 'https://…（mp4 或托管播放地址）',
  'pages.bannerAdvertisement.popup.videoHint': '若有专用视频上传接口，可与图片一致接入；当前请填写可直接访问的 URL。',
  'pages.bannerAdvertisement.popup.link': '点击跳转链接',
  'pages.bannerAdvertisement.popup.title': '标题（多语言）',
  'pages.bannerAdvertisement.popup.body': '正文（多语言）',
  'pages.bannerAdvertisement.popup.saveAll': '保存弹窗设置',
  'pages.bannerAdvertisement.popup.saveSuccess': '弹窗设置已保存',
  'pages.bannerAdvertisement.popup.saveLocalSuccess': '已仅在本地保存（接口未连通）',
  'pages.bannerAdvertisement.popup.saveFailed': '保存弹窗设置失败',
  'pages.bannerAdvertisement.carousel.manage': '轮播管理',
  'pages.bannerAdvertisement.carousel.title': '轮播管理',
  'pages.bannerAdvertisement.carousel.noItems': '暂无轮播项目',
  'pages.bannerAdvertisement.carousel.save': '保存',
  'pages.bannerAdvertisement.carousel.saveSuccess': '轮播已保存',
  'pages.bannerAdvertisement.carousel.item': '项目',
  'pages.bannerAdvertisement.carousel.remove': '移除',
  'pages.bannerAdvertisement.carousel.addItem': '添加轮播项目',
  'pages.bannerAdvertisement.carousel.imageTitle': '图片标题',
  'pages.bannerAdvertisement.carousel.imageTitleRequired': '请输入图片标题',
  'pages.bannerAdvertisement.carousel.imageTitleAtLeastOneLanguage': '请至少用一种语言输入图片标题',
  'pages.bannerAdvertisement.carousel.imageTitlePlaceholder': '输入图片标题',
  'pages.bannerAdvertisement.carousel.number': '编号（顺序）',
  'pages.bannerAdvertisement.carousel.numberTooltip': '根据用户设备上显示的顺序调整大小',
  'pages.bannerAdvertisement.carousel.numberRequired': '请输入顺序编号',
  'pages.bannerAdvertisement.carousel.link': '链接',
  'pages.bannerAdvertisement.carousel.linkTooltip': '在用户设备上点击轮播图片会跳转到相应链接',
  'pages.bannerAdvertisement.carousel.linkRequired': '请输入链接URL',
  'pages.bannerAdvertisement.carousel.linkInvalid': '请输入有效的URL',
  'pages.bannerAdvertisement.carousel.linkPlaceholder': 'https://example.com',
  'pages.bannerAdvertisement.carousel.active': '激活',
  'pages.bannerAdvertisement.carousel.displayLocation': '显示位置',
  'pages.bannerAdvertisement.carousel.desktopDisplaySize': '桌面显示尺寸',
  'pages.bannerAdvertisement.carousel.mobileDisplaySize': '移动显示尺寸',
  'pages.bannerAdvertisement.carousel.width': '宽度',
  'pages.bannerAdvertisement.carousel.height': '高度',
  'pages.bannerAdvertisement.carousel.imageUpload': '图片上传',
  'pages.bannerAdvertisement.carousel.desktopImageUpload': '上传桌面图片尺寸',
  'pages.bannerAdvertisement.carousel.mobileImageUpload': '上传移动图片尺寸',
  'pages.bannerAdvertisement.carousel.desktopImageRequired': '请上传桌面图片',
  'pages.bannerAdvertisement.carousel.mobileImageRequired': '请上传移动图片',
  'pages.bannerAdvertisement.carousel.imageUrlPlaceholder': '图片URL或上传图片',
  'pages.bannerAdvertisement.carousel.upload': '上传',
  'pages.bannerAdvertisement.carousel.uploadSuccess': '图片上传成功',
  'pages.bannerAdvertisement.carousel.uploadFailed': '图片上传失败',
  'pages.bannerAdvertisement.carousel.uploadImageOnly': '仅允许上传图片文件',
  'pages.bannerAdvertisement.carousel.imageSizeLimit': '图片大小必须小于10MB',
  'pages.bannerAdvertisement.carousel.masterImageUpload': '轮播图（单张上传）',
  'pages.bannerAdvertisement.carousel.masterImageRequired': '请上传轮播图',
  'pages.bannerAdvertisement.carousel.masterImageHint': '服务器会从此文件自动生成桌面端与移动端优化图。',
  'pages.bannerAdvertisement.carousel.savedPcMobileHint': '当前已保存的 PC / 移动端图（在上方上传新图可替换）。',

  // 仓库管理
  'pages.storehouse.expressInspection.title': '快递入库检验',
  'pages.storehouse.expressInspection.column.userInfo': '用户信息(UID)',
  'pages.storehouse.expressInspection.column.orderNo': '订单编号',
  'pages.storehouse.expressInspection.column.trackingNumber': '运单号',
  'pages.storehouse.expressInspection.column.courier': '快递公司',
  'pages.storehouse.expressInspection.column.status': '状态',
  'pages.storehouse.expressInspection.column.inboundWeight': '入仓重量',
  'pages.storehouse.expressInspection.column.inboundDimensions': '入仓长宽高',
  'pages.storehouse.expressInspection.column.locationInfo': '库位信息',
  'pages.storehouse.expressInspection.column.inspectionInfo': '验货信息',
  'pages.storehouse.expressInspection.column.orderService': '订单服务',
  'pages.storehouse.expressInspection.column.userRemarks': '用户备注',
  'pages.storehouse.expressInspection.column.warehouseRemarks': '仓库备注',
  'pages.storehouse.expressInspection.status.pending': '待处理',
  'pages.storehouse.expressInspection.status.inspected': '已检验',
  'pages.storehouse.expressInspection.status.error': '错误',
  'pages.storehouse.expressInspection.filter.total': '总计',
  'pages.storehouse.expressInspection.filter.notYetStored': '未入库',
  'pages.storehouse.expressInspection.filter.received': '已接收',
  'pages.storehouse.expressInspection.filter.inspected': '已检验',
  'pages.storehouse.expressInspection.filter.weightedAndStored': '已称重并入库',
  'pages.storehouse.expressInspection.filter.availableNow': '可用',
  'pages.storehouse.expressInspection.filter.removedFromShelves': '已下架',
  'pages.storehouse.expressInspection.filter.title': '筛选',
  'pages.storehouse.expressInspection.filterApplied': '已应用筛选: {label}',
  'pages.storehouse.expressInspection.filterCleared': '筛选已清除',
  'pages.storehouse.expressInspection.viewAll': '查看全部',
  'pages.storehouse.expressInspection.action.inspect': '检验',
  'pages.storehouse.expressInspection.action.batchInspect': '批量检验',
  'pages.storehouse.expressInspection.action.expand': '展开',
  'pages.storehouse.expressInspection.action.collapse': '收起',
  'pages.storehouse.expressInspection.expandIconTitle': '展开',
  'pages.storehouse.expressInspection.product.column.image': '商品图片',
  'pages.storehouse.expressInspection.product.column.name': '상품명',
  'pages.storehouse.expressInspection.product.column.specifications': '规格属性',
  'pages.storehouse.expressInspection.product.column.quantity': '수량',
  'pages.storehouse.expressInspection.product.column.cargoValue': '货物价值',
  'pages.storehouse.expressInspection.product.column.inboundWeight': '入库重量',
  'pages.storehouse.expressInspection.product.column.inboundDimensions': '入库长宽高',
  'pages.storehouse.expressInspection.product.column.location': '所在库位',
  'pages.storehouse.expressInspection.product.column.cargoAttributes': '货物属性',
  'pages.storehouse.expressInspection.product.column.inspectionPhotos': '精细验货照片',
  'pages.storehouse.expressInspection.product.unit.won': '원',
  'pages.storehouse.expressInspection.product.unit.cm': 'cm',

  'pages.storehouse.nonMasterCourier.title': '非主流快递入库',
  'pages.storehouse.nonMasterCourier.column.trackingNumber': '运单号',
  'pages.storehouse.nonMasterCourier.column.courier': '快递公司',
  'pages.storehouse.nonMasterCourier.column.enteredDate': '入库日期',
  'pages.storehouse.nonMasterCourier.column.orderNo': '订单号',
  'pages.storehouse.nonMasterCourier.column.customerName': '客户名称',
  'pages.storehouse.nonMasterCourier.column.productCount': '商品数量',
  'pages.storehouse.nonMasterCourier.column.status': '状态',
  'pages.storehouse.nonMasterCourier.status.pending': '待处理',
  'pages.storehouse.nonMasterCourier.status.processed': '已处理',
  'pages.storehouse.nonMasterCourier.status.error': '错误',
  'pages.storehouse.nonMasterCourier.viewUnclaimed': '查看未认领包裹入库记录',
  'pages.storehouse.nonMasterCourier.storehouse': '仓库',
  'pages.storehouse.nonMasterCourier.storehouseRequired': '请选择仓库',
  'pages.storehouse.nonMasterCourier.warehouseLocationType': '仓库位置类型',
  'pages.storehouse.nonMasterCourier.warehouseLocationTypeRequired': '请选择仓库位置类型',
  'pages.storehouse.nonMasterCourier.locationType.largeCargo': '大件货区',
  'pages.storehouse.nonMasterCourier.locationType.fileArea': '文件区',
  'pages.storehouse.nonMasterCourier.locationType.sensitiveGoods': '敏感货物区',
  'pages.storehouse.nonMasterCourier.locationType.generalGoods': '一般货物区',
  'pages.storehouse.nonMasterCourier.locationType.ecommerceSmall': '电商小件区',
  'pages.storehouse.nonMasterCourier.locationType.mixedBatch': '混批小包区',
  'pages.storehouse.nonMasterCourier.locationType.mediumContainer': '中件容器货区',
  'pages.storehouse.nonMasterCourier.locationType.smallOverweight': '小件超重区',
  'pages.storehouse.nonMasterCourier.locationType.largeUnusual': '大件异形区',
  'pages.storehouse.nonMasterCourier.stockLocation': '库位',
  'pages.storehouse.nonMasterCourier.stockLocationRequired': '请选择库位',
  'pages.storehouse.nonMasterCourier.print': '打印',
  'pages.storehouse.nonMasterCourier.userId': '用户ID',
  'pages.storehouse.nonMasterCourier.userIdRequired': '请输入用户ID',
  'pages.storehouse.nonMasterCourier.userName': '用户名',
  'pages.storehouse.nonMasterCourier.userNameRequired': '请输入用户名',
  'pages.storehouse.nonMasterCourier.invoiceNumber': '发票号',
  'pages.storehouse.nonMasterCourier.invoiceNumberRequired': '请输入发票号',
  'pages.storehouse.nonMasterCourier.weight': '重量(kg)',
  'pages.storehouse.nonMasterCourier.weightRequired': '请输入重量',
  'pages.storehouse.nonMasterCourier.length': '长度(cm)',
  'pages.storehouse.nonMasterCourier.lengthRequired': '请输入长度',
  'pages.storehouse.nonMasterCourier.width': '宽度(cm)',
  'pages.storehouse.nonMasterCourier.widthRequired': '请输入宽度',
  'pages.storehouse.nonMasterCourier.height': '高度(cm)',
  'pages.storehouse.nonMasterCourier.heightRequired': '请输入高度',
  'pages.storehouse.nonMasterCourier.confirmWarehousing': '确认入库',
  'pages.storehouse.nonMasterCourier.action.process': '处理',
  'pages.storehouse.nonMasterCourier.action.batchProcess': '批量处理',

  'pages.storehouse.inspectionList.title': '检验列表',
  'pages.storehouse.inspectionList.column.userInfo': '用户信息(UID)',
  'pages.storehouse.inspectionList.column.invoiceNumber': '发票号',
  'pages.storehouse.inspectionList.column.courier': '快递公司',
  'pages.storehouse.inspectionList.column.uniqueCode': '检验员',
  'pages.storehouse.inspectionList.column.status': '状态',
  'pages.storehouse.inspectionList.column.inboundWeight': '入库重量',
  'pages.storehouse.inspectionList.column.warehouseDimensions': '仓库尺寸(长×宽×高)',
  'pages.storehouse.inspectionList.column.storageLocation': '存储位置信息',
  'pages.storehouse.inspectionList.column.inspectionNo': '检验编号',
  'pages.storehouse.inspectionList.column.trackingNumber': '运单号',
  'pages.storehouse.inspectionList.filter.userName': '用户名',
  'pages.storehouse.inspectionList.filter.rackNumber': '货架编号',
  'pages.storehouse.inspectionList.column.inspectionDate': '检验日期',
  'pages.storehouse.inspectionList.column.orderNo': '订单号',
  'pages.storehouse.inspectionList.column.customerName': '客户名称',
  'pages.storehouse.inspectionList.column.customerEmail': '客户邮箱',
  'pages.storehouse.inspectionList.column.customerPhone': '客户电话',
  'pages.storehouse.inspectionList.column.inspector': '检验员',
  'pages.storehouse.inspectionList.column.notes': '备注',
  'pages.storehouse.inspectionList.status.passed': '通过',
  'pages.storehouse.inspectionList.status.failed': '未通过',
  'pages.storehouse.inspectionList.status.pending': '待处理',
  'pages.storehouse.inspectionList.action.export': '导出',
  'pages.storehouse.inspectionList.exporting': '导出中...',
  'pages.storehouse.inspectionList.exportSuccess': '导出成功完成',
  'pages.storehouse.inspectionList.exportError': '导出检验列表失败',
  'pages.storehouse.inspectionList.noDataToExport': '没有要导出的数据',
  'pages.storehouse.inspectionList.detailTitle': '检验详情',
  'pages.storehouse.inspectionList.products': '商品',
  'pages.storehouse.inspectionList.expandIconTitle': '展开',
  'pages.storehouse.inspectionList.noProducts': '无商品',
  'pages.storehouse.inspectionList.product.column.image': '商品图片',
  'pages.storehouse.inspectionList.product.column.name': '商品名称',
  'pages.storehouse.inspectionList.product.column.specifications': '规格属性',
  'pages.storehouse.inspectionList.product.column.quantity': '数量',
  'pages.storehouse.inspectionList.product.column.cargoValue': '货物价值',
  'pages.storehouse.inspectionList.product.column.inboundWeight': '入库重量',
  'pages.storehouse.inspectionList.product.column.inboundDimensions': '入库尺寸(长×宽×高)',
  'pages.storehouse.inspectionList.product.column.location': '所在库位',
  'pages.storehouse.inspectionList.product.column.cargoAttributes': '货物属性',
  'pages.storehouse.inspectionList.product.column.inspectionPhotos': '精细验货照片',
  'pages.storehouse.inspectionList.product.column.categoryName': '分类',
  'pages.storehouse.inspectionList.product.unit.won': '韩元',
  'pages.storehouse.inspectionList.product.unit.cny': '人民币',
  'pages.storehouse.inspectionList.product.unit.cm': 'cm',
  'pages.storehouse.inspectionList.recipient': '收件人信息',
  'pages.storehouse.inspectionList.recipient.name': '收件人姓名',
  'pages.storehouse.inspectionList.recipient.phone': '电话',
  'pages.storehouse.inspectionList.recipient.clearanceType': '清关类型',
  'pages.storehouse.inspectionList.recipient.customsCode': '个人通关代码',
  'pages.storehouse.inspectionList.recipient.address': '地址',
  'pages.storehouse.inspectionList.recipient.zipCode': '邮政编码',
  'pages.storehouse.inspectionList.recipient.postalCode': '邮政编码',
  'pages.storehouse.inspectionList.recipient.note': '配送备注',

  'pages.storehouse.warehouseSettings.title': '仓库设置',
  'pages.storehouse.warehouseSettings.tab.address': '仓库地址',
  'pages.storehouse.warehouseSettings.tab.chineseWarehousePosition': '中国仓库位置',

  'pages.storehouse.warehouseAddress.title': '仓库地址',
  'pages.storehouse.warehouseAddress.rackManagement': '货架管理',
  'pages.storehouse.warehouseAddress.racks': '货架',
  'pages.storehouse.warehouseAddress.noRacks': '此仓库暂无货架',
  'pages.storehouse.warehouseAddress.column.name': '名称',
  'pages.storehouse.warehouseAddress.column.address': '地址',
  'pages.storehouse.warehouseAddress.column.contactPerson': '联系人',
  'pages.storehouse.warehouseAddress.column.contactPhone': '联系电话',
  'pages.storehouse.warehouseAddress.column.isDefault': '默认',
  'pages.storehouse.warehouseAddress.column.createdAt': '创建时间',
  'pages.storehouse.warehouseAddress.addTitle': '添加仓库地址',
  'pages.storehouse.warehouseAddress.editTitle': '编辑仓库地址',
  'pages.storehouse.warehouseAddress.form.name': '名称',
  'pages.storehouse.warehouseAddress.form.nameRequired': '请输入名称',
  'pages.storehouse.warehouseAddress.form.address': '地址',
  'pages.storehouse.warehouseAddress.form.addressRequired': '请输入地址',
  'pages.storehouse.warehouseAddress.form.contactPerson': '联系人',
  'pages.storehouse.warehouseAddress.form.contactPersonRequired': '请输入联系人',
  'pages.storehouse.warehouseAddress.form.contactPhone': '联系电话',
  'pages.storehouse.warehouseAddress.form.contactPhoneRequired': '请输入联系电话',
  'pages.storehouse.warehouseAddress.confirmDelete': '确定要删除此仓库地址吗？',
  'pages.storehouse.warehouseAddress.deleteSuccess': '仓库地址已删除',
  'pages.storehouse.warehouseAddress.updateSuccess': '仓库地址已更新',
  'pages.storehouse.warehouseAddress.createSuccess': '仓库地址已创建',
  'pages.storehouse.warehouseAddress.addWarehouse': '添加仓库地址',
  'pages.storehouse.warehouseAddress.customizableParameters': '可以自定义的参数:',
  'pages.storehouse.warehouseAddress.noData': '暂无仓库地址信息。',
  'pages.storehouse.warehouseAddress.forwardingWarehouse': '转运仓库地址',
  'pages.storehouse.warehouseAddress.purchasingAgentWarehouse': '代购仓库地址',
  'pages.storehouse.warehouseAddress.consignee': '收货人',
  'pages.storehouse.warehouseAddress.consigneeRequired': '请输入收货人',
  'pages.storehouse.warehouseAddress.contactMethod': '联系方式',
  'pages.storehouse.warehouseAddress.contactMethodRequired': '请输入联系方式',
  'pages.storehouse.warehouseAddress.email': '邮箱',
  'pages.storehouse.warehouseAddress.emailRequired': '请输入邮箱',
  'pages.storehouse.warehouseAddress.emailInvalid': '请输入有效的邮箱地址',
  'pages.storehouse.warehouseAddress.warehouseName': '仓库名称',
  'pages.storehouse.warehouseAddress.defaultWarehouse': '默认仓库',
  'pages.storehouse.warehouseAddress.warehouseNameRequired': '请输入仓库名称',
  'pages.storehouse.warehouseAddress.postalCode': '仓库邮编',
  'pages.storehouse.warehouseAddress.postalCodeRequired': '请输入仓库邮编',
  'pages.storehouse.warehouseAddress.administrativeDivisionCode': '行政区划代码',
  'pages.storehouse.warehouseAddress.administrativeDivisionCodeRequired': '请输入行政区划代码',
  'pages.storehouse.warehouseAddress.warehouseAddress': '仓库地址',
  'pages.storehouse.warehouseAddress.warehouseAddressRequired': '请输入仓库地址',
  'pages.storehouse.warehouseAddress.procurementWarehouse': '采购仓',
  'pages.storehouse.warehouseAddress.convertSuccess': '成功转换为采购仓',
  'pages.storehouse.warehouseAddress.warehouseCode': '仓库代码',
  'pages.storehouse.warehouseAddress.warehouseCodeRequired': '请输入仓库代码',
  'pages.storehouse.warehouseAddress.warehouseCodePlaceholder': '例如：WH-QINGDAO-1',
  'pages.storehouse.warehouseAddress.phone': '电话',
  'pages.storehouse.warehouseAddress.phonePlaceholder': '例如：0631-5555001',
  'pages.storehouse.warehouseAddress.province': '省份',
  'pages.storehouse.warehouseAddress.provinceRequired': '请输入省份',
  'pages.storehouse.warehouseAddress.provincePlaceholder': '例如：山东省',
  'pages.storehouse.warehouseAddress.city': '城市',
  'pages.storehouse.warehouseAddress.cityRequired': '请输入城市',
  'pages.storehouse.warehouseAddress.cityPlaceholder': '例如：威海市',
  'pages.storehouse.warehouseAddress.district': '区县',
  'pages.storehouse.warehouseAddress.districtRequired': '请输入区县',
  'pages.storehouse.warehouseAddress.districtPlaceholder': '例如：环翠区',
  'pages.storehouse.warehouseAddress.town': '乡镇',
  'pages.storehouse.warehouseAddress.townPlaceholder': '例如：文泉镇',
  'pages.storehouse.warehouseAddress.addressCode': '地址代码',
  'pages.storehouse.warehouseAddress.addressCodePlaceholder': '例如：371002',
  'pages.storehouse.warehouseAddress.consigneePlaceholder': '例如：张伟',
  'pages.storehouse.warehouseAddress.contactMethodPlaceholder': '例如：18561073633',
  'pages.storehouse.warehouseAddress.warehouseNamePlaceholder': '例如：青岛仓库',
  'pages.storehouse.warehouseAddress.postalCodePlaceholder': '例如：264200',
  'pages.storehouse.warehouseAddress.administrativeDivisionCodePlaceholder': '例如：371002',
  'pages.storehouse.warehouseAddress.warehouseAddressPlaceholder': '例如：环翠区温泉镇新苑路2号',
  'pages.storehouse.warehouseAddress.createError': '创建仓库失败',
  'pages.storehouse.warehouseAddress.updateError': '更新仓库失败',
  'pages.storehouse.warehouseAddress.deleteError': '删除仓库失败',
  'pages.common.modify': '修改',
  'pages.common.today': '今天',
  'pages.common.last7Days': '最近7天',
  'pages.common.last30Days': '最近30天',
  'pages.common.thisMonth': '这个月',
  'pages.common.lastMonth': '上个月',
  'pages.common.exportingOrders': '正在导出...',
  'pages.common.exportError': '导出Excel失败',
  
  'pages.storehouse.chineseWarehousePosition.column.area': '区域',
  'pages.storehouse.chineseWarehousePosition.column.row': '行',
  'pages.storehouse.chineseWarehousePosition.column.column': '列',
  'pages.storehouse.chineseWarehousePosition.column.shelf': '货架',
  'pages.storehouse.chineseWarehousePosition.column.capacity': '容量',
  'pages.storehouse.chineseWarehousePosition.column.currentStock': '当前库存',
  'pages.storehouse.chineseWarehousePosition.column.createdAt': '创建时间',
  'pages.storehouse.chineseWarehousePosition.column.locationCode': '位置代码',
  'pages.storehouse.chineseWarehousePosition.column.stockLocation': '库存位置',
  'pages.storehouse.chineseWarehousePosition.column.warehouseLocationCode': '仓库位置代码',
  'pages.storehouse.chineseWarehousePosition.column.warehouseLocationType': '仓库位置类型',
  'pages.storehouse.chineseWarehousePosition.column.availableStock': '可用库存',
  'pages.storehouse.chineseWarehousePosition.stockLocation': '库存位置',
  'pages.storehouse.chineseWarehousePosition.warehouseLocationCode': '仓库位置代码',
  'pages.storehouse.chineseWarehousePosition.warehouseLocationType': '仓库位置类型',
  'pages.storehouse.chineseWarehousePosition.availableStock': '可用库存',
  'pages.storehouse.chineseWarehousePosition.currentStock': '当前库存',
  'pages.storehouse.chineseWarehousePosition.form.locationCode': '位置代码',
  'pages.storehouse.chineseWarehousePosition.form.locationCodeRequired': '请输入位置代码',
  'pages.storehouse.chineseWarehousePosition.form.warehouseLocationType': '仓库位置类型',
  'pages.storehouse.chineseWarehousePosition.form.warehouseLocationTypeRequired': '请输入仓库位置类型',
  'pages.storehouse.chineseWarehousePosition.form.availableStock': '可用库存',
  'pages.storehouse.chineseWarehousePosition.form.availableStockRequired': '请输入可用库存',
  'pages.storehouse.chineseWarehousePosition.form.currentStock': '当前库存',
  'pages.storehouse.chineseWarehousePosition.form.currentStockRequired': '请输入当前库存',
  'pages.storehouse.chineseWarehousePosition.addTitle': '添加仓库位置',
  'pages.storehouse.chineseWarehousePosition.editTitle': '编辑仓库位置',
  'pages.storehouse.chineseWarehousePosition.form.positionCode': '位置代码',
  'pages.storehouse.chineseWarehousePosition.form.positionCodeRequired': '请输入位置代码',
  'pages.storehouse.chineseWarehousePosition.form.positionName': '位置名称',
  'pages.storehouse.chineseWarehousePosition.form.positionNameRequired': '请输入位置名称',
  'pages.storehouse.chineseWarehousePosition.form.warehouseName': '仓库名称',
  'pages.storehouse.chineseWarehousePosition.form.warehouseNameRequired': '请输入仓库名称',
  'pages.storehouse.chineseWarehousePosition.form.area': '区域',
  'pages.storehouse.chineseWarehousePosition.form.areaRequired': '请输入区域',
  'pages.storehouse.chineseWarehousePosition.form.row': '行',
  'pages.storehouse.chineseWarehousePosition.form.rowRequired': '请输入行',
  'pages.storehouse.chineseWarehousePosition.form.column': '列',
  'pages.storehouse.chineseWarehousePosition.form.columnRequired': '请输入列',
  'pages.storehouse.chineseWarehousePosition.form.shelf': '货架',
  'pages.storehouse.chineseWarehousePosition.form.shelfRequired': '请输入货架',
  'pages.storehouse.chineseWarehousePosition.form.capacity': '容量',
  'pages.storehouse.chineseWarehousePosition.form.capacityRequired': '请输入容量',
  'pages.storehouse.chineseWarehousePosition.confirmDelete': '确定要删除此仓库位置吗？',
  'pages.storehouse.chineseWarehousePosition.deleteSuccess': '仓库位置已删除',
  'pages.storehouse.chineseWarehousePosition.createSuccess': '仓库位置已创建',
  'pages.storehouse.chineseWarehousePosition.updateSuccess': '仓库位置已更新',

  // 优惠券积分设置
  'pages.members.couponPointSettings.title': '优惠券积分设置',
  'pages.members.couponPointSettings.pointsPerCurrency': '每货币点数 (₩)',
  'pages.members.couponPointSettings.coupon': '优惠券',
  'pages.members.couponPointSettings.example': '例如：如果设置为100，则 ₩10,000 = 100点',
  'pages.members.couponPointSettings.freeEditingFunction': '用于添加/删除优惠券的免费编辑功能',
  'pages.members.couponPointSettings.distributionSystemCoupon': '分发系统优惠券',
  'pages.members.couponPointSettings.distributionSystemCouponDescription': '您可以选择在系统内均匀分发特定类型的优惠券。',
  'pages.members.couponPointSettings.pointSettings': '积分设置',
  'pages.members.couponPointSettings.pointSettingsDescription': '当收到您邀请的用户注册到本网站时，将授予积分。这些积分可以手动编辑和设置。',
  'pages.members.couponPointSettings.couponDetails': '优惠券详情',
  'pages.members.couponPointSettings.addCoupon': '添加优惠券',
  'pages.members.couponPointSettings.editCoupon': '编辑优惠券',
  'pages.members.couponPointSettings.deleteConfirm': '确定要删除此优惠券吗？',
  'pages.members.couponPointSettings.deleteSuccess': '优惠券删除成功',
  'pages.members.couponPointSettings.createSuccess': '优惠券创建成功',
  'pages.members.couponPointSettings.updateSuccess': '优惠券更新成功',
  'pages.members.couponPointSettings.pointUpdateSuccess': '积分设置更新成功',
  'pages.members.couponPointSettings.pointUpdateError': '更新推荐设置失败',
  'pages.members.couponPointSettings.fetchError': '加载数据失败',
  'pages.members.couponPointSettings.fetchCouponsError': '加载优惠券失败',
  'pages.members.couponPointSettings.deleteError': '删除优惠券失败',
  'pages.members.couponPointSettings.createError': '创建优惠券失败',
  'pages.members.couponPointSettings.updateError': '更新优惠券失败',
  'pages.members.couponPointSettings.referralPoints': '推荐积分',
  'pages.members.couponPointSettings.referralPointsRequired': '请输入推荐积分',
  'pages.members.couponPointSettings.referralPointsPlaceholder': '输入推荐成功时授予的积分',
  'pages.members.couponPointSettings.noCoupons': '暂无优惠券',
  'pages.members.couponPointSettings.signupPoints': '注册积分',
  'pages.members.couponPointSettings.signupPointsRequired': '请输入注册积分',
  'pages.members.couponPointSettings.signupPointsPlaceholder': '输入注册时授予的积分',
  'pages.members.couponPointSettings.promotionSuccessPoints': '促销成功积分',
  'pages.members.couponPointSettings.promotionSuccessPointsRequired': '请输入促销成功积分',
  'pages.members.couponPointSettings.promotionSuccessPointsPlaceholder': '输入促销成功时授予的积分',
  'pages.members.couponPointSettings.days': '天',
  'pages.members.couponPointSettings.column.couponName': '优惠券名称',
  'pages.members.couponPointSettings.column.amount': '金额',
  'pages.members.couponPointSettings.column.code': '代码',
  'pages.members.couponPointSettings.column.minPurchaseAmount': '最低购买金额',
  'pages.members.couponPointSettings.column.validityDays': '有效期（天）',
  'pages.members.couponPointSettings.column.remainingQuantity': '剩余数量',
  'pages.members.couponPointSettings.column.usedQuantity': '已使用数量',
  'pages.members.couponPointSettings.column.createdBy': '创建管理员',
  'pages.members.couponPointSettings.column.issuanceMethod': '发放方式',
  'pages.members.couponPointSettings.column.couponId': '优惠券ID',
  'pages.members.couponPointSettings.column.distributionEnabled': '启用分发',
  'pages.members.couponPointSettings.column.createdAt': '创建时间',
  'pages.members.couponPointSettings.issuanceMethodUser': '用户领取',
  'pages.members.couponPointSettings.issuanceMethodSystem': '系统分发',
  'pages.members.couponPointSettings.issuanceMethodSignup': '注册并领取优惠券',
  'pages.members.couponPointSettings.detail.addCouponName': '添加优惠券名称',
  'pages.members.couponPointSettings.detail.setCouponAmount': '设置优惠券金额',
  'pages.members.couponPointSettings.detail.enterCouponCode': '输入优惠券使用代码',
  'pages.members.couponPointSettings.detail.setMinPurchaseAmount': '设置最低购买金额',
  'pages.members.couponPointSettings.detail.setValidityDays': '优惠券有效期（天）',
  'pages.members.couponPointSettings.detail.remainingQuantity': '剩余优惠券数量',
  'pages.members.couponPointSettings.detail.usedQuantity': '已使用的优惠券数量',
  'pages.members.couponPointSettings.detail.issuanceMethod': '发放方式（详情：用户发放、系统发放、注册奖励）',
  'pages.members.couponPointSettings.detail.addCouponId': '添加优惠券ID（每个优惠券集都会生成唯一ID）',
  'pages.members.couponPointSettings.detail.couponSettings': '优惠券设置（选择注册完成后发放哪个优惠券。可以输入优惠券ID。）',
  'pages.members.couponPointSettings.form.couponName': '优惠券名称',
  'pages.members.couponPointSettings.form.couponNameRequired': '请输入优惠券名称',
  'pages.members.couponPointSettings.form.couponNamePlaceholder': '输入优惠券名称',
  'pages.members.couponPointSettings.form.amount': '优惠券金额',
  'pages.members.couponPointSettings.form.amountRequired': '请输入优惠券金额',
  'pages.members.couponPointSettings.form.discountMode': '折扣方式',
  'pages.members.couponPointSettings.form.discountModeRequired': '请选择折扣方式',
  'pages.members.couponPointSettings.discountModeFixed': '固定金额 (₩)',
  'pages.members.couponPointSettings.discountModePercentage': '商品金额比例 (%)',
  'pages.members.couponPointSettings.form.percentage': '折扣比例 (%)',
  'pages.members.couponPointSettings.form.percentageRequired': '请输入折扣比例',
  'pages.members.couponPointSettings.form.code': '优惠券使用代码',
  'pages.members.couponPointSettings.form.codeRequired': '请输入优惠券代码',
  'pages.members.couponPointSettings.form.codePattern': '优惠券代码只能包含大写字母和数字',
  'pages.members.couponPointSettings.form.codePlaceholder': '输入优惠券代码',
  'pages.members.couponPointSettings.form.minPurchaseAmount': '最低购买金额',
  'pages.members.couponPointSettings.form.minPurchaseAmountRequired': '请输入最低购买金额',
  'pages.members.couponPointSettings.form.validityDays': '有效期（天）',
  'pages.members.couponPointSettings.form.validityDaysRequired': '请输入有效期天数',
  'pages.members.couponPointSettings.form.remainingQuantity': '剩余数量',
  'pages.members.couponPointSettings.form.remainingQuantityRequired': '请输入剩余数量',
  'pages.members.couponPointSettings.form.remainingQuantityMinForCode': '会员优惠券码兑换至少需填写 1（管理员手动发放不消耗此库存）。',
  'pages.members.couponPointSettings.form.remainingQuantityTooltip': '会员通过优惠券码兑换时使用的库存。管理员手动发放不会扣减此数量。',
  'pages.members.couponPointSettings.form.usedQuantity': '已使用数量',
  'pages.members.couponPointSettings.form.issuanceMethod': '发放方式',
  'pages.members.couponPointSettings.form.issuanceMethodRequired': '请选择发放方式',
  'pages.members.couponPointSettings.form.couponId': '优惠券ID',
  'pages.members.couponPointSettings.form.couponIdTooltip': '每个优惠券集都会生成唯一ID',
  'pages.members.couponPointSettings.form.couponIdPlaceholder': '输入优惠券ID',
  'pages.members.couponPointSettings.form.signupCouponId': '注册优惠券ID',
  'pages.members.couponPointSettings.form.signupCouponIdTooltip': '选择注册完成后发放哪个优惠券。可以输入优惠券ID。',
  'pages.members.couponPointSettings.form.signupCouponIdPlaceholder': '输入注册后发放的优惠券ID',
  'pages.members.couponPointSettings.form.distributionEnabled': '启用分发系统',
  'pages.members.couponPointSettings.form.signupWelcome': '注册欢迎优惠券（数量不限）',
  'pages.members.couponPointSettings.form.couponType': '优惠券类型',
  'pages.members.couponPointSettings.form.couponTypeRequired': '请选择优惠券类型',
  'pages.members.couponPointSettings.couponTypeProduct': '商品优惠券',
  'pages.members.couponPointSettings.couponTypeTransportation': '运输优惠券',
  'pages.members.couponPointSettings.couponTypeLive': '直播优惠券',
  'pages.members.couponPointSettings.couponTypeReferral': '推荐人注册优惠券',
  'pages.members.couponPointSettings.column.platformScope': '平台',
  'pages.members.couponPointSettings.platformLive': '直播',
  'pages.members.couponPointSettings.platformEcommerce': '1688 / 淘宝 / VVIC',
  'pages.members.couponPointSettings.form.referralDiscountType': '折扣类型',
  'pages.members.couponPointSettings.form.platformScope': '适用平台',
  'pages.members.couponPointSettings.form.platformScopeRequired': '请选择平台',
  'pages.members.couponPointSettings.referralCouponHelp': '注册时填写推荐码的新会员将自动获得此优惠券。请选择商品/运费折扣及适用平台。',
  'pages.members.couponPointSettings.form.referralSignupEnabled': '推荐注册自动发放',
  'pages.members.couponPointSettings.form.referralSignupEnabledTooltip': '启用后，向使用推荐码注册的新会员自动发放此优惠券。',
  'pages.members.couponPointSettings.column.couponType': '优惠券类型',
  'pages.members.couponPointSettings.column.liveSeller': '直播卖家',
  'pages.members.couponPointSettings.form.liveSeller': '直播卖家 (LS 邮箱)',
  'pages.members.couponPointSettings.form.liveSellerRequired': '请选择直播卖家',
  'pages.members.couponPointSettings.form.liveSellerPlaceholder': '通过 LS 邮箱搜索 (例: LS123)',
  'pages.members.couponPointSettings.column.applicableStores': '适用商家',
  'pages.members.couponPointSettings.applicableStoresAll': '全部商家',
  'pages.members.couponPointSettings.applicableStoresCount': '{count} 个商家',
  'pages.members.couponPointSettings.form.applicableStores': '适用商家',
  'pages.members.couponPointSettings.form.applicableStoresHelp': '仅对所选商家（商家名）的商品打折，最低消费金额也按这些商品金额计算。留空则适用于该卖家的全部商品。',
  'pages.members.couponPointSettings.form.applicableStoresPlaceholder': '按商家名搜索选择（留空 = 全部商家）',
  'pages.members.couponPointSettings.form.applicableStoresNeedSeller': '请先选择直播卖家',
  'pages.members.couponPointSettings.form.applicableStoresEmpty': '没有找到商家',
  'pages.members.couponPointSettings.form.applicableStoresProductCount': '{count} 个商品',
  'pages.members.couponPointSettings.form.applicableStoresMissing': '该卖家的商品中目前没有此商家',

  // Point Rules Engine
  'pages.members.pointRules.tabTitle': '积分规则引擎',
  'pages.members.pointRules.management': '积分规则管理',
  'pages.members.pointRules.add': '添加积分规则',
  'pages.members.pointRules.edit': '编辑积分规则',
  'pages.members.pointRules.description': '根据用户事件配置自动和手动积分奖励规则。支持条件、限额和过期设置。',
  'pages.members.pointRules.noRules': '暂无积分规则',
  'pages.members.pointRules.deleteTitle': '删除积分规则',
  'pages.members.pointRules.deleteConfirm': '确定要删除此积分规则吗？',
  'pages.members.pointRules.deleteSuccess': '积分规则删除成功',
  'pages.members.pointRules.deleteError': '删除积分规则失败',
  'pages.members.pointRules.createSuccess': '积分规则创建成功',
  'pages.members.pointRules.updateSuccess': '积分规则更新成功',
  'pages.members.pointRules.createError': '创建积分规则失败',
  'pages.members.pointRules.updateError': '更新积分规则失败',
  'pages.members.pointRules.fetchError': '加载积分规则失败',
  'pages.members.pointRules.column.ruleName': '规则名称',
  'pages.members.pointRules.column.eventType': '事件类型',
  'pages.members.pointRules.column.points': '积分',
  'pages.members.pointRules.column.conditions': '条件',
  'pages.members.pointRules.column.type': '类型',
  'pages.members.pointRules.column.maxPerUser': '每用户最大',
  'pages.members.pointRules.column.validity': '有效期',
  'pages.members.pointRules.column.status': '状态',
  'pages.members.pointRules.eventType.signup': '注册',
  'pages.members.pointRules.eventType.reviewCreated': '创建评价',
  'pages.members.pointRules.eventType.orderCompleted': '商品购买',
  'pages.members.pointRules.eventType.attendance': '签到',
  'pages.members.pointRules.grantType.automatic': '自动',
  'pages.members.pointRules.grantType.manual': '手动',
  'pages.members.pointRules.unlimited': '无限制',
  'pages.members.pointRules.conditionMinChars': '最少{count}字',
  'pages.members.pointRules.conditionMinImages': '最少{count}张图片',
  'pages.members.pointRules.conditionMinOrder': '最低订单{amount}₩',
  'pages.members.pointRules.daysUnit': '{days}天',
  'pages.members.pointRules.form.ruleName': '规则名称',
  'pages.members.pointRules.form.ruleNameRequired': '请输入规则名称',
  'pages.members.pointRules.form.ruleNamePlaceholder': '例如：基础评价积分、注册奖励',
  'pages.members.pointRules.form.eventType': '事件类型',
  'pages.members.pointRules.form.eventTypeRequired': '请选择事件类型',
  'pages.members.pointRules.form.eventTypePlaceholder': '选择事件类型',
  'pages.members.pointRules.form.pointsToAward': '奖励积分',
  'pages.members.pointRules.form.pointsRequired': '请输入积分',
  'pages.members.pointRules.form.pointsPlaceholder': '例如：100',
  'pages.members.pointRules.form.reviewConditions': '评价条件',
  'pages.members.pointRules.form.minCharacters': '最低评价长度（字符数）',
  'pages.members.pointRules.form.minCharactersPlaceholder': '例如：20',
  'pages.members.pointRules.form.minImages': '最少图片数量',
  'pages.members.pointRules.form.minImagesPlaceholder': '例如：1',
  'pages.members.pointRules.form.orderConditions': '订单条件',
  'pages.members.pointRules.form.minOrderAmount': '最低订单金额 (₩)',
  'pages.members.pointRules.form.minOrderAmountPlaceholder': '例如：50000',
  'pages.members.pointRules.form.paymentSettings': '发放设置',
  'pages.members.pointRules.form.paymentType': '发放类型',
  'pages.members.pointRules.form.pointValidity': '积分有效期（天）',
  'pages.members.pointRules.form.pointValidityRequired': '请输入有效期天数',
  'pages.members.pointRules.form.pointValidityPlaceholder': '例如：365',
  'pages.members.pointRules.form.limits': '限额',
  'pages.members.pointRules.form.maxPerUser': '每用户最大',
  'pages.members.pointRules.form.maxPerDay': '每日最大',
  'pages.members.pointRules.form.maxPerMonth': '每月最大',
  'pages.members.pointRules.form.unlimitedTooltip': '留空表示无限制',
  'pages.members.pointRules.form.unlimitedPlaceholder': '留空表示无限制',
  'pages.members.pointRules.form.ruleStatus': '规则状态',
  'pages.members.pointRules.form.active': '启用',
  'pages.members.pointRules.form.inactive': '停用',
  'pages.members.pointRules.form.earnRatesTitle': '购买积分比例设置',
  'pages.members.pointRules.form.earnRatesDescription': '以购买金额为基准，按销售渠道分别设置积分比例。',
  'pages.members.pointRules.form.earnRateOwnmall': '自营商城',
  'pages.members.pointRules.form.earnRateLive': '直播商品',
  'pages.members.pointRules.form.earnRateOverseas': '海外代购 / 海外直购',
  'pages.members.pointRules.form.earnRateLabel': '购买金额积分比例',
  'pages.members.pointRules.form.earnRatePlaceholder': '例：{value}',
  'pages.members.pointRules.form.earnRateRequired': '请输入积分比例（不发放请填 0）',
  'pages.members.pointRules.form.earnRatesHint': '按 支付金额 × 积分比例 发放，小数部分舍去。一笔订单包含多个渠道的商品时，按各商品金额占比分别计算；直播(LS)订单整单按直播比例计算。',
  'pages.members.pointRules.form.purchaseConditions': '购买条件',
  'pages.members.pointRules.form.purchaseTimingHint': '积分在付款完成时发放，退款时按退款金额自动收回。',
  'pages.members.pointRules.form.attendanceConditions': '签到条件',
  'pages.members.pointRules.form.attendanceOncePerDay': '签到积分每位会员每天发放一次（以韩国时间为准）。',
  'pages.members.pointRules.form.streakBonusEnabled': '启用连续签到奖励',
  'pages.members.pointRules.form.streakBonusTitle': '连续签到奖励设置',
  'pages.members.pointRules.form.streak7Bonus': '连续 7 天奖励',
  'pages.members.pointRules.form.streak7BonusPlaceholder': '例：500',
  'pages.members.pointRules.form.streak30Bonus': '连续 30 天奖励',
  'pages.members.pointRules.form.streak30BonusPlaceholder': '例：3,000',
  'pages.members.pointRules.form.streakBonusHint': '每逢连续签到第 7 天、第 30 天，在签到积分之外额外发放（7 天奖励在第 14、21 天…，30 天奖励在第 60 天…再次发放）。中断一天则连续天数从 1 重新计算。留空或填 0 则不发放该奖励。',
  'pages.members.pointRules.earnRatesSummary': '自营 {ownmall}% · 直播 {live}% · 海外直购 {overseas}%',
  'pages.members.pointRules.conditionStreak7': '连续 7 天 +{points}P',
  'pages.members.pointRules.conditionStreak30': '连续 30 天 +{points}P',

  // Consumption Change Details
  'pages.members.consumptionChangeDetails.title': '消费变动详情',
  'pages.members.consumptionChangeDetails.tab.financial': '会员财务记录',
  'pages.members.consumptionChangeDetails.tab.consumption': '会员消费记录',
  'pages.members.consumptionChangeDetails.tab.rebate': '返利记录',
  'pages.members.consumptionChangeDetails.tab.points': '积分使用记录',
  'pages.members.consumptionChangeDetails.tab.coupon': '优惠券使用记录',
  'pages.members.consumptionChangeDetails.column.userId': '会员ID',
  'pages.members.consumptionChangeDetails.column.userName': '用户名',
  'pages.members.consumptionChangeDetails.column.userInfo': '用户信息',
  'pages.members.consumptionChangeDetails.column.memberLevel': '会员等级',
  'pages.members.consumptionChangeDetails.column.currentPoints': '当前剩余积分',
  'pages.members.consumptionChangeDetails.column.currentDeposit': '当前剩余预存款',
  'pages.members.consumptionChangeDetails.column.updateTime': '更新时间',
  'pages.members.consumptionChangeDetails.column.orderNo': '订单号',
  'pages.members.consumptionChangeDetails.column.paymentMethod': '用户支付方式',
  'pages.members.consumptionChangeDetails.column.paymentType': '支付类型',
  'pages.members.consumptionChangeDetails.column.amountBefore': '变更前金额',
  'pages.members.consumptionChangeDetails.column.changeAmount': '变动金额',
  'pages.members.consumptionChangeDetails.column.amountAfter': '变更后金额',
  'pages.members.consumptionChangeDetails.column.currentBalance': '当前剩余金额',
  'pages.members.consumptionChangeDetails.column.changeTime': '变动时间',
  'pages.members.consumptionChangeDetails.column.time': '时间',
  'pages.members.consumptionChangeDetails.column.rebateAmount': '返利金额',
  'pages.members.consumptionChangeDetails.column.type': '类型',
  'pages.members.consumptionChangeDetails.column.couponName': '优惠券名称',
  'pages.members.consumptionChangeDetails.column.couponCode': '优惠券兑换代码',
  'pages.members.consumptionChangeDetails.column.couponValue': '优惠券面值',
  'pages.members.consumptionChangeDetails.column.minOrderAmount': '最低使用金额',
  'pages.members.consumptionChangeDetails.column.receiveMethod': '领取方式',
  'pages.members.consumptionChangeDetails.column.validPeriod': '有效期',
  'pages.members.consumptionChangeDetails.column.status': '使用状态',
  'pages.members.consumptionChangeDetails.column.receiveTime': '领取时间',
  'pages.members.consumptionChangeDetails.column.usedTime': '使用时间',
  'pages.members.consumptionChangeDetails.status.used': '已使用',
  'pages.members.consumptionChangeDetails.status.unused': '未使用',
  'pages.members.consumptionChangeDetails.status.expired': '已过期',
  'pages.members.consumptionChangeDetails.exportSuccess': '数据已导出',

  // System - Work Log
  'pages.system.workLog.title': '工作日志',
  'pages.system.workLog.column.employeeId': '员工ID',
  'pages.system.workLog.column.employeeName': '员工姓名',
  'pages.system.workLog.deletedAccount': '已删除账号',
  'pages.system.workLog.column.workContent': '工作内容',
  'pages.system.workLog.column.workTime': '工作时间',
  'pages.system.workLog.exportSuccess': '工作日志数据已导出',

  // Shipping Cost Modal
  'pages.shippingCost.title': '配送费用重量测量',
  'pages.shippingCost.orderInformation': '订单信息',
  'pages.shippingCost.orderNoMemberName': '订单号/会员名',
  'pages.shippingCost.center': '中心',
  'pages.shippingCost.trackingCount': '运单数',
  'pages.shippingCost.items': '个',
  'pages.shippingCost.recipient': '收件人',
  'pages.shippingCost.mountainislandCost': '岛屿山区运费',
  'pages.shippingCost.recipientAddress': '收件人地址',
  'pages.shippingCost.totalQuantityAmount': '总数量/总金额',
  'pages.shippingCost.productInformation': '商品信息',
  'pages.shippingCost.productNo': '商品编号',
  'pages.shippingCost.productName': '商品名称',
  'pages.shippingCost.image': '图片',
  'pages.shippingCost.quantity': '数量',
  'pages.shippingCost.trackingNumber': '运单号',
  'pages.shippingCost.status': '状态',
  'pages.shippingCost.rackNumber': '货架号',
  'pages.shippingCost.actualInspection': '实检',
  'pages.shippingCost.viewActualInspection': '查看实检',
  'pages.shippingCost.adminMemo': '管理员备注',
  'pages.shippingCost.additionalServices': '附加服务',
  'pages.shippingCost.boxCount': '箱数',
  'pages.shippingCost.box': '箱',
  'pages.shippingCost.inspectionOptions': '检验选项',
  'pages.shippingCost.originMarkingOptions': '原产地标记选项',
  'pages.shippingCost.businessLCLCustomsOptions': '企业LCL海关选项',
  'pages.shippingCost.packagingOptions': '包装选项',
  'pages.shippingCost.otherOptions': '其他选项',
  'pages.shippingCost.additionalCosts': '附加费用',
  'pages.shippingCost.totalServiceAmount': '附加服务总额',
  'pages.shippingCost.weightInformation': '重量信息',
  'pages.shippingCost.actualWeight': '实际重量',
  'pages.shippingCost.applicableExchangeRate': '适用汇率',
  'pages.shippingCost.volumetricWeight': '体积重量',
  'pages.shippingCost.volume': '体积',
  'pages.shippingCost.applicableWeight': '适用重量（配送费用）',
  'pages.shippingCost.actual': '实际重量',
  'pages.shippingCost.volumetric': '体积重量',
  'pages.shippingCost.totalAmount': '总金额',
  'pages.shippingCost.save': '保存',
  'pages.shippingCost.close': '关闭',
  'pages.shippingCost.saved': '配送费用已保存',
  'pages.shippingCost.smsNotSend': '不发送短信',
  'pages.shippingCost.smsSend': '发送短信',
  'pages.shippingCost.cbmWeight': '体积重量(CBM)',
  'pages.shippingCost.additionalCost': '附加费用',
  'pages.shippingCost.weightCost': '重量费用',
  'pages.shippingCost.totalCost': '总费用',
  'pages.shippingCost.additionalPlusWeight': '附加+重量',
  'pages.shippingCost.calculatedWeight': '计算重量',
  'pages.shippingCost.selectWeight': '选择重量',
  'pages.shippingCost.boxNumber': '箱号',
  'pages.shippingCost.dimensions': '尺寸 (宽×长×高)',
  'pages.shippingCost.shippingCost': '配送费用',
  'pages.shippingCost.width': '宽度',
  'pages.shippingCost.length': '长度',
  'pages.shippingCost.height': '高度',
  'pages.shippingCost.warehouseComplete': '入库完成',

  // Packing Modal
  'pages.packing.title': '包装',
  'pages.packing.internationalTrackingNumber': '国际运单号',
  'pages.packing.recipientAddress': '收件人地址',
  'pages.packing.recipient': '收件人',
  'pages.packing.address': '地址',
  'pages.packing.phone': '电话',
  'pages.packing.weightAndDimensions': '重量和尺寸',
  'pages.packing.weight': '重量',
  'pages.packing.shippingMethod': '运输方式',
  'pages.packing.width': '宽度',
  'pages.packing.length': '长度',
  'pages.packing.height': '高度',
  'pages.packing.shippingFeeCalculation': '运费计算',
  'pages.packing.realWeight': '实际重量',
  'pages.packing.volumetricWeight': '体积重量 (CBM)',
  'pages.packing.chargeableWeight': '计费重量（适用）',
  'pages.packing.internationalShippingFee': '国际运费',
  'pages.packing.additionalCost': '额外费用',
  'pages.packing.simplifiedCustomsClearance': '简易清关',
  'pages.packing.designatedShooting': '指定拍摄',
  'pages.packing.totalCost': '总费用',
  'pages.packing.save': '保存',
  'pages.packing.close': '关闭',
  'pages.packing.saved': '包装成功完成',

  // Rack Designation Modal
  'pages.rackDesignation.title': '货架指定',
  'pages.rackDesignation.internationalTrackingNumber': '国际运单号',
  'pages.rackDesignation.rackNumber': '货架号',
  'pages.rackDesignation.save': '保存',
  'pages.rackDesignation.close': '关闭',

  // Return Cost Modal
  'pages.returnCost.title': '退货费用',
  'pages.returnCost.orderInformation': '订单信息',
  'pages.returnCost.orderNumber': '订单号',
  'pages.returnCost.deliveryCenter': '配送中心',
  'pages.returnCost.totalQuantityAmount': '总数量/总金额',
  'pages.returnCost.items': '个',
  'pages.returnCost.additionalServices': '附加服务',
  'pages.returnCost.costInformation': '费用信息',
  'pages.returnCost.weight': '重量',
  'pages.returnCost.returnTrackingNumber': '退货运单号',
  'pages.returnCost.returnTrackingNumberPlaceholder': '请输入退货运单号',
  'pages.returnCost.appliedExchangeRate': '适用汇率',
  'pages.returnCost.totalAmount': '总金额',
  'pages.returnCost.courierPaymentAmount': '快递公司支付金额',
  'pages.returnCost.save': '保存',
  'pages.returnCost.close': '关闭',
  'pages.returnCost.saved': '退货费用已保存',
  'pages.returnCost.smsNotSend': '不发送短信',
  'pages.returnCost.smsSend': '发送短信',
  'pages.refundSplit.title': '退款分拆',
  'pages.refundSplit.description': '部分错误导致需要退货/退款的订单，可以点击退款分拆，选择需要退款的子订单号和数量进行分拆。分拆后的订单将自动转换为"平台退款申请"状态，并与原订单关联。',
  'pages.refundSplit.orderNo': '订单号',
  'pages.refundSplit.select': '选择',
  'pages.refundSplit.image': '图片',
  'pages.refundSplit.productName': '商品名称',
  'pages.refundSplit.variation': '规格',
  'pages.refundSplit.originalQuantity': '原数量',
  'pages.refundSplit.refundQuantity': '退款数量',
  'pages.refundSplit.unitPrice': '单价',
  'pages.refundSplit.refundAmount': '退款金额',
  'pages.refundSplit.selectedTotal': '选中退款金额',
  'pages.refundSplit.confirm': '退款分拆确认',
  'pages.refundSplit.close': '取消',
  'pages.refundSplit.selectAtLeastOne': '请至少选择一个商品。',
  'pages.refundSplit.invalidQuantity': '请为所有选中的商品输入有效的退款数量。',
  'pages.refundSplit.quantityExceedsMax': '退款数量不能超过{max}件。',
  'pages.refundSplit.cannotRefundAll': '不能退款所有商品。至少有一个商品必须保留在原订单中。',
  'pages.refundSplit.noRefundProducts': '没有要退款的商品。',
  'pages.refundSplit.success': '退款分拆完成。',
  'pages.refundSplit.error': '退款分拆过程中发生错误。',
  // Tax Settlement Management
  'pages.members.taxSettlement.purchaseAmount': '购买金额',
  'pages.members.taxSettlement.purchaseFee': '购买代理费',
  'pages.members.taxSettlement.warehouseArea': '仓库地区',
  'pages.members.taxSettlement.transportationMethod': '运输方式',
  'pages.members.taxSettlement.mailboxNumber': '邮箱号码',
  'pages.members.taxSettlement.waybillNumber': '运单号',
  'pages.members.taxSettlement.orderNumber': '订单号',
  'pages.members.taxSettlement.paymentDate': '支付日期',
  'pages.members.taxSettlement.paymentMethod': '支付方式',
  'pages.members.taxSettlement.refundRoute': '退款路径',
  'pages.members.taxSettlement.paymentMethod.creditCard': '信用卡',
  'pages.members.taxSettlement.paymentMethod.deposit': '预存款',
  'pages.members.taxSettlement.paymentMethod.points': '积分',
  'pages.members.taxSettlement.paymentMethod.bankTransfer': '银行转账',
  'pages.members.taxSettlement.entryType.first_payment': '一次结算',
  'pages.members.taxSettlement.entryType.second_payment': '二次结算',
  'pages.members.taxSettlement.entryType.partial_refund': '部分退款',
  'pages.members.taxSettlement.entryType.full_refund': '全额退款',
  'pages.members.taxSettlement.col.orderDateTime': '订单日期',
  'pages.members.taxSettlement.col.userUniqueNo': '信箱编号',
  'pages.members.taxSettlement.col.userName': '会员姓名',
  'pages.members.taxSettlement.col.internationalTrackingNumber': '运单号',
  'pages.members.taxSettlement.col.customsItemNamesEn': '商品名称(英文)',
  'pages.members.taxSettlement.col.entryType': '类型',
  'pages.members.taxSettlement.col.bankAmount': '银行出入金额',
  'pages.members.taxSettlement.col.refundDepositCredit': '退款转入预存款',
  'pages.members.taxSettlement.col.purchaseEstimate': '采购预估',
  'pages.members.taxSettlement.col.firstTierPaymentCost': '一次结算费用',
  'pages.members.taxSettlement.col.firstTierProductAmount': '商品金额(一次结算)',
  'pages.members.taxSettlement.col.firstTierServiceFee': '商品手续费(一次结算)',
  'pages.members.taxSettlement.col.firstTierDomesticShipping': '国内运费(一次结算)',
  'pages.members.taxSettlement.col.couponUsed': '优惠券使用',
  'pages.members.taxSettlement.col.pointsUsed': '积分使用',
  'pages.members.taxSettlement.col.relatedOrderNumbers': '关联订单',
  'pages.members.taxSettlement.col.bankNetAfterRefund': '退款后银行金额',
  'pages.members.taxSettlement.col.firstTierAfterRefund': '退款后1次支付金额',
  'pages.members.taxSettlement.col.depositUsed': '预存款使用',
  'pages.members.taxSettlement.col.secondTierPaymentCost': '二次结算费用',
  'pages.members.taxSettlement.col.internationalShippingSecondTier': '国际运费(二次结算)',
  'pages.members.taxSettlement.col.ruralShippingSecondTier': '偏远地区费用(二次结算)',
  'pages.members.taxSettlement.col.simplifiedClearanceSecondTier': '简易通关费用(二次结算)',
  'pages.members.taxSettlement.col.addOnServicesSecondTier': '附加服务费用(二次结算)',
  'pages.members.taxSettlement.col.productPurchaseCNY': '商品采购 CNY',
  'pages.members.taxSettlement.col.exchangeRate': '汇率',
  'pages.members.taxSettlement.col.miscLoss': '杂项损失',
  'pages.members.taxSettlement.col.note': '备注',
  'pages.members.taxSettlement.receiver': '收件人',
  'pages.members.taxSettlement.receiverAddress': '收件人地址',
  'pages.members.taxSettlement.personalCustomsCode': '个人通关代码',
  'pages.members.taxSettlement.productNameEnglish': '商品名称（英文）',
  'pages.members.taxSettlement.ct': 'C/T',
  'pages.members.taxSettlement.weight': '重量',
  'pages.members.taxSettlement.shippingCosts': '运费',
  'pages.members.taxSettlement.additionalServices': '附加服务',
  'pages.members.taxSettlement.additionalCostPayment': '附加费用支付',
  'pages.members.taxSettlement.export': '导出Excel',
  'pages.members.taxSettlement.exportSuccess': 'Excel下载已开始。',
  'pages.members.taxSettlement.progressStatus': '进度状态',
  'pages.members.taxSettlement.tab.order': '订单',
  'pages.members.taxSettlement.tab.deposit': '押金',
  'pages.members.taxSettlement.order.orderDate': '下单时间',
  'pages.members.taxSettlement.order.orderNumber': '订单号',
  'pages.members.taxSettlement.order.memberName': '会员名',
  'pages.members.taxSettlement.order.waybillNumber': '运单号',
  'pages.members.taxSettlement.order.productNameEnglish': '商品英文名',
  'pages.members.taxSettlement.order.paymentMethod': '支付方式',
  'pages.members.taxSettlement.order.refundType': '退款/二次支付类型',
  'pages.members.taxSettlement.order.paymentAmounts': '一次/二次支付金额',
  'pages.members.taxSettlement.order.productAmount': '商品金额',
  'pages.members.taxSettlement.order.fee': '手续费',
  'pages.members.taxSettlement.order.domesticShippingFee': '国内运费',
  'pages.members.taxSettlement.order.sumAmount': '合计（商品+手续费+国内运费）',
  'pages.members.taxSettlement.order.internationalShippingFee': '国际运费',
  'pages.members.taxSettlement.order.secondaryPaymentAmount': '二次支付金额（国际运费除外）',
  'pages.members.taxSettlement.order.pointsUsed': '积分使用金额',
  'pages.members.taxSettlement.order.couponUsed': '优惠券使用金额',
  'pages.members.taxSettlement.order.depositUsed': '押金使用金额',
  'pages.members.taxSettlement.order.productPurchaseCost': '商品购入价（商品价格/汇率）',
  'pages.members.taxSettlement.order.exchangeRate': '汇率',
  'pages.members.taxSettlement.order.netFee': '手续费-积分-优惠券',
  'pages.members.taxSettlement.order.paymentMethod.bankTransfer': '银行转账',
  'pages.members.taxSettlement.order.paymentMethod.creditCard': '信用卡',
  'pages.members.taxSettlement.order.paymentMethod.deposit': '押金',
  'pages.members.taxSettlement.order.paymentMethod.points': '积分',
  'pages.members.taxSettlement.order.refundType.fullRefund': '全额退款',
  'pages.members.taxSettlement.order.refundType.partialRefund': '部分退款',
  'pages.members.taxSettlement.order.refundType.secondPayment': '二次支付',
  'pages.members.taxSettlement.deposit.memberName': '会员名',
  'pages.members.taxSettlement.deposit.carryoverBalance': '结转余额',
  'pages.members.taxSettlement.deposit.earning': '累积（退款替代/返利）',
  'pages.members.taxSettlement.deposit.depositRecharge': '押金充值',
  'pages.members.taxSettlement.deposit.deduction': '扣减（订单使用/返利扣减）',
  'pages.members.taxSettlement.deposit.depositWithdrawal': '押金提现',
  'pages.members.taxSettlement.deposit.balanceAfter': '变动后余额',

  // Store Management
  'pages.products.store.title': '店铺管理',
  'pages.products.store.edit': '编辑',
  'pages.products.store.delete': '删除',
  'pages.products.store.products': '商品',
  'pages.products.store.viewProducts': '查看此店铺的商品',
  'pages.products.store.editTitle': '编辑店铺',
  'pages.products.store.nameKo': '韩文名称',
  'pages.products.store.nameEn': '英文名称',
  'pages.products.store.nameZh': '中文名称',
  'pages.products.store.totalProducts': '总商品数',
  'pages.products.store.nameKoRequired': '请输入韩文名称',
  'pages.products.store.nameKoPlaceholder': '输入韩文店铺名称',
  'pages.products.store.translateFromThis': '从此值翻译到其他语言',
  'pages.products.store.nameEnPlaceholder': '输入英文店铺名称',
  'pages.products.store.nameZhPlaceholder': '输入中文店铺名称',
  'pages.products.store.image': '店铺图片',
  'pages.products.store.uploadImage': '上传图片',
  'pages.products.store.status': '状态',
  'pages.products.store.createdAt': '创建时间',
  'pages.products.store.actions': '操作',
  'pages.products.store.total': '总计',
  'pages.products.store.showInactive': '显示未激活',
  'pages.products.store.hideInactive': '隐藏未激活',
  'pages.products.store.createSuccess': '店铺创建成功',
  'pages.products.store.createFailed': '店铺创建失败',
  'pages.products.store.updateSuccess': '店铺更新成功',
  'pages.products.store.unsavedKeep': '继续编辑',
  'pages.products.store.unsavedDiscard': '关闭',
  'pages.products.store.unsavedBody': '关闭后本次修改将丢失。仍要关闭吗？',
  'pages.products.store.unsavedTitle': '有尚未保存的修改',
  'pages.products.store.updateFailed': '店铺更新失败',
  'pages.products.store.deleteSuccess': '店铺删除成功',
  'pages.products.store.deleteFailed': '店铺删除失败',
  'pages.products.store.deleteConfirm': '删除店铺',
  'pages.products.store.deleteContent': '确定要删除店铺"{name}"吗？',
  // 店铺 ↔ 会员关联
  'pages.products.store.owner': '会员',
  'pages.products.store.ownerNone': '未关联',
  'pages.products.store.ownerHint': '按信箱号（LS56、TM373）或昵称搜索并关联该店铺的会员。店铺返利中的卖家份额归此会员。',
  'pages.products.store.ownerPlaceholder': '搜索信箱号或昵称',
  'pages.products.store.ownerNotFound': '未找到会员',
  'pages.products.store.pointShop': '积分商店',
  'pages.products.store.pointShopHint': '开启后，该店铺的商品只能用积分购买。',

  // 店铺返利设置
  'pages.products.storeRebate.title': '店铺返利设置',
  'pages.products.storeRebate.store': '店铺',
  'pages.products.storeRebate.owner': '会员',
  'pages.products.storeRebate.ownerNone': '未关联会员',
  'pages.products.storeRebate.inactiveStore': '停用',
  'pages.products.storeRebate.sellerPercent': '卖家 %',
  'pages.products.storeRebate.companyPercent': '公司 %',
  'pages.products.storeRebate.configuredAt': '设置时间',
  'pages.products.storeRebate.actions': '操作',
  'pages.products.storeRebate.setting': '设置',
  'pages.products.storeRebate.delete': '删除',
  'pages.products.storeRebate.addRebate': '添加返利',
  'pages.products.storeRebate.addModalTitle': '添加店铺返利设置',
  'pages.products.storeRebate.editModalTitle': '修改店铺返利设置',
  'pages.products.storeRebate.storeRequired': '请选择店铺',
  'pages.products.storeRebate.storeSelectPlaceholder': '按店铺名称或会员搜索',
  'pages.products.storeRebate.noStoreLeft': '所有店铺都已设置返利',
  'pages.products.storeRebate.sellerPercentRequired': '请输入卖家比例',
  'pages.products.storeRebate.companyPercentRequired': '请输入公司比例',
  'pages.products.storeRebate.sumError': '卖家 % 与公司 % 之和必须为 100',
  'pages.products.storeRebate.sumHint': '输入卖家 % 后，公司 % 会自动填为 100 减去该值。',
  'pages.products.storeRebate.ownerMissingHint': '该店铺尚未关联会员。请先在店铺管理中关联会员，卖家份额才有收款人。',
  'pages.products.storeRebate.addSuccess': '店铺返利设置已添加',
  'pages.products.storeRebate.addFailed': '添加店铺返利设置失败',
  'pages.products.storeRebate.updateSuccess': '店铺返利设置已修改',
  'pages.products.storeRebate.updateFailed': '修改店铺返利设置失败',
  'pages.products.storeRebate.deleteSuccess': '店铺返利设置已删除',
  'pages.products.storeRebate.deleteFailed': '删除店铺返利设置失败',
  'pages.products.storeRebate.deleteConfirm': '删除店铺返利设置',
  'pages.products.storeRebate.deleteContent': '确定要删除店铺"{name}"的返利设置吗？',
  'pages.products.storeRebate.searchPlaceholder': '按店铺名称、信箱号或昵称搜索',
  'pages.products.storeRebate.search': '搜索',
  'pages.products.storeRebate.reset': '重置',
  'pages.products.storeRebate.batchUpdateTitle': '批量修改百分比',
  'pages.products.storeRebate.applySetting': '应用设置',
  'pages.products.storeRebate.cancel': '取消',
  'pages.products.storeRebate.batchUpdateSuccess': '批量修改完成',
  'pages.products.storeRebate.batchUpdateFailed': '批量修改失败',

  // 直播卖家
  'pages.live.sellers.title': '直播卖家管理',
  'pages.live.sellers.register': '注册卖家',
  'pages.live.sellers.sellerName': '卖家名称',
  'pages.live.sellers.id': 'ID',
  'pages.live.sellers.contact': '联系方式',
  'pages.live.sellers.liveCount': '直播次数',
  'pages.live.sellers.totalViews': '总浏览量',
  'pages.live.sellers.totalItemsSold': '总销售量',
  'pages.live.sellers.activeProducts': '进行中商品',
  'pages.live.sellers.status': '状态',
  'pages.live.sellers.status.active': '● 直播中',
  'pages.live.sellers.status.inactive': '○ 休息',
  'pages.live.sellers.top10': 'TOP10',
  'pages.live.sellers.popular': '人气',
  'pages.live.sellers.pointSeller': '积分',
  'pages.live.sellers.actions': '操作',
  'pages.live.sellers.detail': '详情',
  'pages.live.sellers.edit': '编辑',
  'pages.live.sellers.delete': '删除',
  'pages.live.sellers.deleteConfirm': '删除卖家',
  'pages.live.sellers.deleteContent': '确定要删除卖家"{name}"吗？',
  'pages.live.sellers.deleteSuccess': '卖家删除成功',
  'pages.live.sellers.deleteFailed': '卖家删除失败',
  'pages.live.sellers.updateSuccess': '卖家更新成功',
  'pages.live.sellers.updateFailed': '卖家更新失败',
  'pages.live.sellers.edit.topRank': 'TOP 10 排名',
  'pages.live.sellers.edit.topRankPlaceholder': '输入排名 (1-10)',
  'pages.live.sellers.edit.topRankTooltip': '为TOP 10卖家设置1-10之间的排名，非TOP 10则留空',
  'pages.live.sellers.edit.rankDelta': '排名变动',
  'pages.live.sellers.edit.rankDeltaHint': '+ 为上升，- 为下降，0 为无变动',
  'pages.live.sellers.edit.rankDeltaPlaceholder': '例如：2、-1、0',
  'pages.live.sellers.edit.liveCount': '直播次数',
  'pages.live.sellers.edit.liveCountPlaceholder': '输入直播次数',
  'pages.live.sellers.edit.totalViews': '总浏览量',
  'pages.live.sellers.edit.totalViewsPlaceholder': '输入总浏览量',
  'pages.live.sellers.edit.totalItemsSold': '总销售量',
  'pages.live.sellers.edit.totalItemsSoldPlaceholder': '输入总销售量',
  'pages.live.sellers.edit.popularStatus': '热门卖家状态',
  'pages.live.sellers.edit.pointSellerStatus': '积分卖家状态',
  'pages.live.sellers.loadFailed': '加载卖家列表失败',
  'pages.live.sellers.legend': '[图例] 🔥 人气卖家（最近30天直播5次以上）',
  'pages.live.sellers.top10Info': 'TOP10：根据本月直播次数/销售量自动计算',
  
  // 直播卖家注册
  'pages.live.sellers.register.title': '注册卖家',
  'pages.live.sellers.register.searchUser': '搜索用户',
  'pages.live.sellers.register.searchPlaceholder': '按姓名、邮箱、ID搜索',
  'pages.live.sellers.register.search': '搜索',
  'pages.live.sellers.register.searchResults': '搜索结果（现有用户）',
  'pages.live.sellers.register.noResults': '没有搜索结果',
  'pages.live.sellers.register.selectUser': '注册为卖家',
  'pages.live.sellers.register.selected': '已选择',
  'pages.live.sellers.register.registerAsSeller': '注册为卖家',
  'pages.live.sellers.register.selectedUser': '选择的用户',
  'pages.live.sellers.register.registrationInfo': '输入注册信息',
  'pages.live.sellers.register.nickname': '直播昵称',
  'pages.live.sellers.register.nicknamePlaceholder': '直播中使用的昵称',
  'pages.live.sellers.register.liveChannelLink': '直播频道链接',
  'pages.live.sellers.register.liveChannelLinkPlaceholder': '请输入直播频道 URL',
  'pages.live.sellers.channels.section': 'SNS 频道',
  'pages.live.sellers.channels.tiktok': 'TikTok 链接',
  'pages.live.sellers.channels.youtube': 'YouTube 链接',
  'pages.live.sellers.channels.tiktokPlaceholder': 'https://www.tiktok.com/@用户名 或 @用户名',
  'pages.live.sellers.channels.youtubePlaceholder': 'https://www.youtube.com/@账号名 或 @账号名',
  'pages.live.sellers.channels.tiktokInvalid': '请输入 tiktok.com 网址或 @用户名',
  'pages.live.sellers.channels.youtubeInvalid': '请输入 youtube.com / youtu.be 网址或 @账号名',
  'pages.live.sellers.channels.useLiveChannelLink': '填入直播频道链接',
  'pages.live.sellers.channels.hint': '填写的链接会以图标显示在卖家页面和直播页面的卖家卡片上。留空则不显示图标。',
  'pages.live.sellers.register.referralCode': '推荐码',
  'pages.live.sellers.register.referralCodePlaceholder': '请输入推荐码',
  'pages.live.sellers.register.referralCodeTooltip': '如有推荐人请输入其推荐码（可选）',
  'pages.live.sellers.detailInfo.title': '卖家详情',
  'pages.live.sellers.detailInfo.userId': '用户 ID',
  'pages.live.sellers.detailInfo.sellerId': '卖家 ID',
  'pages.live.sellers.detailInfo.recommender': '推荐人',
  'pages.live.sellers.detailInfo.rebate': '返利',
  'pages.live.sellers.detailInfo.teamRebate': '团队返利',
  'pages.live.sellers.detailInfo.deposit': '预存款',
  'pages.live.sellers.detailInfo.salesCount': '销售数量',
  'pages.live.sellers.detailInfo.salesAmount': '销售金额',
  'pages.live.sellers.detailInfo.rebateAccrued': '返利（累计）',
  'pages.live.sellers.detailInfo.avgOrderValue': '客单价',
  'pages.live.sellers.detailInfo.refundCount': '退货数量',
  'pages.live.sellers.detailInfo.refundAmount': '退货金额',
  'pages.live.sellers.detailInfo.rebateDeducted': '返利（扣除）',
  'pages.live.sellers.detailInfo.refundRate': '退货率',
  'pages.live.sellers.detailInfo.teamMembers': '团队成员',
  'pages.live.sellers.detailInfo.teamSalesAmount': '团队销售额',
  'pages.live.sellers.detailInfo.teamRebateAccrued': '团队返利（累计）',
  'pages.live.sellers.detailInfo.teamRebateDeducted': '团队返利（扣除）',
  'pages.live.sellers.detailInfo.teamRefundRate': '团队退货率',
  'pages.live.sellers.detailInfo.followers': '粉丝',
  'pages.live.sellers.detailInfo.teamFollowers': '团队粉丝',
  'pages.live.sellers.detailInfo.rank': '排名',
  'pages.live.sellers.detailInfo.regionDistribution': '地区分布',
  'pages.live.sellers.detailInfo.noData': '暂无数据',
  'pages.live.sellers.detailInfo.comparedToYesterday': '较昨日',
  'pages.live.sellers.detailInfo.comparedToLastMonth': '较上月',
  'pages.live.sellers.detailInfo.unitMan': '万',
  'pages.live.sellers.detailInfo.name': '姓名',
  'pages.live.sellers.detailInfo.miniHomepage': '迷你主页',
  'pages.live.sellers.detailInfo.liveChannel': '直播页面',
  'pages.live.sellers.detailInfo.personal': '个人',
  'pages.live.sellers.detailInfo.team': '团队',
  'pages.live.sellers.detailInfo.refunds': '退款',
  'pages.live.sellers.detailInfo.metric': '项目',
  'pages.live.sellers.products.batchUpdate': '批量修改',
  'pages.live.sellers.products.batchUpdate.placeholder.cny': '金额 (CNY)',
  'pages.live.sellers.products.batchUpdate.apply': '批量应用',
  'pages.live.sellers.products.batchUpdate.selectFirst': '请先选择要修改的商品。',
  'pages.live.sellers.products.batchUpdate.valueRequired': '请输入值。',
  'pages.live.sellers.products.batchUpdate.description': '同一值将应用于所选商品的所有 SKU。',
  'pages.live.sellers.products.batchUpdate.descriptionProduct': '同一值将应用于所有选中的商品。',
  'pages.live.sellers.products.batchUpdate.placeholder.companyName': '输入档口名',
  'pages.live.sellers.products.column.category': '类目',
  'pages.live.sellers.products.category.placeholder': '选择类目',
  'pages.live.sellers.products.category.wholeGroup': '{name}（全部）',
  'pages.live.sellers.products.category.sharedHint': '与自营商城共用类目。公司商城商品的类目在自营商城商品列表中也会一起变更。',
  'pages.live.sellers.products.applyToSelected.title': '应用到选中的 {count} 个商品？',
  'pages.live.sellers.products.category.applyToSelected.content': '选中的 {count} 个商品的类目将全部设为「{category}」。',
  'pages.live.sellers.products.applyToSelected.all': '全部应用（{count} 个）',
  'pages.live.sellers.products.applyToSelected.onlyThis': '仅此商品',
  'pages.live.sellers.products.category.none': '无类目',
  'pages.live.sellers.products.companyName.applyToSelected.content': '选中的 {count} 个商品的商家名将全部设为「{companyName}」。',
  'pages.live.sellers.products.companyName.none': '无商家名',
  'pages.live.sellers.products.flag.applyToSelected.content': '选中的 {count} 个商品的「{field}」将全部设为{state}。',
  'pages.live.sellers.products.flag.on': '开启',
  'pages.live.sellers.products.flag.off': '关闭',
  'pages.live.sellers.products.flag.liveOnly': '仅适用于简易登记商品。公司商城商品的显示请在自营商城商品管理中修改。',
  'pages.live.sellers.products.filter.categoryNone': '未设置类目',
  'pages.live.sellers.products.filter.category': '按类目筛选',
  'pages.live.sellers.products.selection.setCategory': '为所选商品设置类目',
  'pages.live.sellers.products.selection.clear': '取消选择',
  'pages.live.sellers.products.tab.simple': '简易登记商品',
  'pages.live.sellers.products.tab.company': '公司商城商品',
  'pages.live.sellers.products.headerTitle.simple': '简易登记商品',
  'pages.live.sellers.products.headerTitle.company': '公司商城商品',
  'pages.live.sellers.products.addCompanyProduct': '登记公司商城商品',
  'pages.live.sellers.products.addCompany.selectProduct': '请至少选择一个商品。',
  'pages.live.sellers.products.addCompany.registeredCount': '已为该卖家登记 {count} 个商品。',
  'pages.live.sellers.products.addCompany.failed': '登记失败。',
  'pages.live.sellers.products.addCompany.partialResult': '成功 {success} 个，失败 {failed} 个（{reasons}）',
  'pages.live.sellers.products.addCompany.failReason.item': '{label} {count} 个',
  'pages.live.sellers.products.addCompany.failReason.ownedByOtherSeller': '属于其他卖家的商品',
  'pages.live.sellers.products.addCompany.failReason.notFound': '商品不存在',
  'pages.live.sellers.products.addCompany.failReason.createFailed': '登记出错',
  'pages.live.sellers.products.addCompany.batchHint': '请为每一行搜索并选择商品。',
  'pages.live.sellers.products.addCompany.registerSelected': '登记所选商品 ({count})',
  'pages.live.sellers.products.loadFailed': '商品列表加载失败。',
  'pages.live.sellers.products.sortBy.createdAt_desc': '注册日期最新',
  'pages.live.sellers.products.sortBy.createdAt_asc': '注册日期最早',
  'pages.live.sellers.products.sortBy.updatedAt_desc': '最近更新',
  'pages.live.sellers.products.sortBy.updatedAt_asc': '最久未更新',
  'pages.live.sellers.products.filter.registeredFrom': '注册日期起',
  'pages.live.sellers.products.filter.registeredTo': '注册日期止',
  'pages.live.sellers.products.column.image': '图片',
  'pages.live.sellers.products.column.title': '商品名称',
  'pages.live.sellers.products.column.companyName': '商家名',
  'pages.live.sellers.products.column.offerId': 'Offer ID',
  'pages.live.sellers.products.column.productNo': '商品编号',
  'pages.live.sellers.products.column.userName': '用户名',
  'pages.live.sellers.products.column.userUniqueId': '用户唯一 ID',
  'pages.live.sellers.products.filter.userUniqueIdPlaceholder': '按用户唯一 ID 搜索',
  'pages.live.sellers.products.column.liveCode': '直播代码',
  'pages.live.sellers.products.column.registeredAt': '登记日期',
  'pages.live.sellers.products.column.salesQuantity': '销量',
  'pages.live.sellers.products.column.viewCount': '浏览量',
  'pages.live.sellers.products.column.hotProduct': '热卖',
  'pages.live.sellers.products.column.popularProduct': '人气商品',
  'pages.live.sellers.products.column.topFixed': '置顶',
  'pages.live.sellers.products.column.liveStatus': '直播显示',
  'pages.live.sellers.products.column.specialPrice': '特价',
  'pages.live.sellers.products.column.manage': '操作',
  'pages.live.sellers.products.tag.hot': '热',
  'pages.live.sellers.products.tag.popular': '人气',
  'pages.live.sellers.products.tag.special': '特价',
  'pages.live.sellers.products.delete.title': '删除商品',
  'pages.live.sellers.products.delete.content': '确定要删除该商品吗？',
  'pages.live.sellers.products.delete.notImplemented': '删除功能尚未开放。',
  'pages.live.sellers.products.delete.noStatus': '该商品没有关联的直播日程，无法删除',
  'pages.live.sellers.products.batchDelete': '批量删除',
  'pages.live.sellers.products.batchDelete.title': '删除所选商品',
  'pages.live.sellers.products.batchDelete.content': '将从该卖家页面删除所选 {count} 个商品，且无法恢复。',
  'pages.live.sellers.products.batchDelete.ok': '删除',
  'pages.live.sellers.products.batchDelete.selectFirst': '请先选择要删除的商品。',
  'pages.live.sellers.products.batchDelete.result': '已删除 {count} 个商品。',
  'pages.live.sellers.products.batchDelete.resultWithFailures': '已删除 {count} 个，失败 {failed} 个（{reasons}）',
  'pages.live.sellers.products.batchDelete.failReason.item': '{label} {count} 个',
  'pages.live.sellers.products.batchDelete.failReason.notRegistered': '该卖家页面中不存在的商品',
  'pages.live.sellers.products.batchDelete.failReason.notFound': '商品不存在',
  'pages.live.sellers.products.batchDelete.failReason.deleteFailed': '删除出错',
  'pages.live.sellers.products.copyLink.tooltip': '复制购买链接',
  'pages.live.sellers.products.copyLink.noStatus': '该商品没有关联的直播日程，无法生成链接',
  'pages.live.sellers.products.copyLink.success': '购买链接已复制到剪贴板',
  'pages.live.sellers.products.copyLink.failed': '生成购买链接失败',
  'pages.live.sellers.products.copyLink.empty': '服务端未返回链接',
  'pages.live.sellers.products.copyLink.manualTitle': '请手动复制下方链接',
  'pages.live.sellers.products.batchUpdate.modalTitle': '{batch}（{count}）',
  'pages.live.sellers.products.batchUpdate.field': '字段',
  'pages.live.sellers.products.batchUpdate.value': '数值',
  'pages.live.sellers.products.batchUpdate.field.productName': '商品名称',
  'pages.live.sellers.products.batchUpdate.productName.ko': '商品名称 (Ko)',
  'pages.live.sellers.products.batchUpdate.productName.en': '商品名称 (En)',
  'pages.live.sellers.products.batchUpdate.productName.zh': '商品名称 (Zh)',
  'pages.live.sellers.products.batchUpdate.productName.placeholder': '输入任一语言名称后，其他语言将自动翻译',
  'pages.live.sellers.products.batchUpdate.productName.koRequired': '韩文商品名称为必填项',
  'pages.live.sellers.products.batchUpdate.productName.translate': '从此值翻译到其他语言',
  'pages.live.sellers.products.batchUpdate.field.costPrice': '成本价（₩）',
  'pages.live.sellers.products.batchUpdate.field.costPriceCny': '成本价（CNY）',
  'pages.live.sellers.products.batchUpdate.field.salePrice': '售价（₩）',
  'pages.live.sellers.products.batchUpdate.field.tagPrice': '标价（₩）',
  'pages.live.sellers.products.batchUpdate.field.stock': '库存',
  'pages.live.sellers.products.batchUpdate.placeholder.amount': '金额',
  'pages.live.sellers.products.batchUpdate.placeholder.qty': '数量',
  'pages.live.sellers.products.batchUpdate.result': '已更新 {success} 个商品。',
  'pages.live.sellers.products.batchUpdate.resultWithFailures': '已更新 {success} 个商品。（{failed} 个失败）',
  'pages.live.sellers.products.simpleEdit.title': '快捷修改',
  'pages.live.sellers.products.simpleEdit.titleWithProduct': '快捷修改 — {name}',
  'pages.live.sellers.products.simpleEdit.productInfo': '商品信息',
  'pages.live.sellers.products.simpleEdit.productNo': '货号',
  'pages.live.sellers.products.simpleEdit.productNoPlaceholder': '请输入货号',
  'pages.live.sellers.products.simpleEdit.companyName': '商家名',
  'pages.live.sellers.products.simpleEdit.okSave': '确认保存',
  'pages.live.sellers.products.simpleEdit.attr': '属性',
  'pages.live.sellers.products.simpleEdit.attrColorSize': '颜色/尺码',
  'pages.live.sellers.products.simpleEdit.addColor': '添加颜色',
  'pages.live.sellers.products.simpleEdit.addSize': '添加尺码',
  'pages.live.sellers.products.simpleEdit.colorPlaceholder': '黑 / 白 …',
  'pages.live.sellers.products.simpleEdit.sizePlaceholder': 'S / M / L / XL …',
  'pages.live.sellers.products.simpleEdit.attrNamePlaceholder': '属性名',
  'pages.live.sellers.products.simpleEdit.addValuesPlaceholder': '添加{name}',
  'pages.live.sellers.products.simpleEdit.addValuesDefaultName': '值',
  'pages.live.sellers.products.simpleEdit.confirmAdd': '确认添加',
  'pages.live.sellers.products.simpleEdit.addAttr': '添加属性',
  'pages.live.sellers.products.simpleEdit.table.emptyText': '请添加颜色或尺码。',
  'pages.live.sellers.products.simpleEdit.column.image': '图片',
  'pages.live.sellers.products.simpleEdit.column.attrs': '属性',
  'pages.live.sellers.products.simpleEdit.column.costPrice': '成本价 (KRW)',
  'pages.live.sellers.products.simpleEdit.column.costPriceCny': '成本价 (CNY)',
  'pages.live.sellers.products.simpleEdit.column.salePrice': '售价',
  'pages.live.sellers.products.simpleEdit.column.tagPrice': '标价',
  'pages.live.sellers.products.simpleEdit.column.stock': '库存',
  'pages.live.sellers.products.simpleEdit.column.delete': '删除',
  'pages.live.sellers.products.simpleEdit.bulkTitleSelected': '批量修改（已选 {count}）',
  'pages.live.sellers.products.simpleEdit.bulkTitleAll': '批量修改（全部）',
  'pages.live.sellers.products.simpleEdit.bulkField.costPrice': '成本价',
  'pages.live.sellers.products.simpleEdit.bulkField.costPriceCny': '成本价 (CNY)',
  'pages.live.sellers.products.simpleEdit.bulkField.salePrice': '售价',
  'pages.live.sellers.products.simpleEdit.bulkField.tagPrice': '标价',
  'pages.live.sellers.products.simpleEdit.bulkField.stock': '库存',
  'pages.live.sellers.products.simpleEdit.bulkField.imageUrl': '图片',
  'pages.live.sellers.products.simpleEdit.bulkImagePlaceholder': '图片 URL',
  'pages.live.sellers.products.simpleEdit.bulkValuePlaceholder': '数值',
  'pages.live.sellers.products.simpleEdit.bulkApply': '批量应用',
  'pages.live.sellers.products.simpleEdit.clearSelection': '清除选择',
  'pages.live.sellers.products.simpleEdit.imageSwapTitle': '替换图片',
  'pages.live.sellers.products.simpleEdit.imageSwapUrlPlaceholder': '请输入图片 URL',
  'pages.live.sellers.products.simpleEdit.imageSwapNoPreview': '无预览',
  'pages.live.sellers.products.simpleEdit.gallery.label': '商品图片 ({count}/{max})',
  'pages.live.sellers.products.simpleEdit.gallery.required': '请至少保留一张商品图片。',
  'pages.live.sellers.products.simpleEdit.coverRemovePending': '保存后将删除封面图片。',
  'pages.live.sellers.products.simpleEdit.coverRemoveUndo': '撤销',
  'pages.live.sellers.products.simpleEdit.coverRemoveFailed': '封面图片删除失败，其他内容已保存。',
  'pages.productGallery.main': '主图',
  'pages.productGallery.view': '查看大图',
  'pages.productGallery.replace': '更换图片',
  'pages.productGallery.remove': '删除',
  'pages.productGallery.add': '添加图片',
  'pages.productGallery.hint': '第一张为主图 · 拖动可调整顺序',
  'pages.productGallery.limit': '最多可上传 {max} 张图片。',
  'pages.productGallery.notImage': '只能上传图片文件。',
  'pages.productGallery.uploadFailed': '图片上传失败。',
  'pages.productGallery.cover': '封面',
  'pages.productGallery.coverHint':
    '封面（落地图）：在前台页面设置中上传，会先于主图显示为商品详情首图和商品卡片图片。删除后将重新使用主图。',
  'pages.live.sellers.products.simpleEdit.noProductInfo': '缺少商品信息，请重新打开。',
  'pages.live.sellers.products.simpleEdit.noSkus': '没有可保存的 SKU。',
  'pages.live.sellers.products.simpleEdit.saveSuccess': '商品已更新。',
  'pages.live.sellers.products.simpleEdit.saveFailed': '商品更新失败。',
  'pages.live.sellers.products.simpleEdit.loadFailed': '商品加载失败。',
  'pages.live.sellers.products.simpleEdit.colorOrSizeRequired': '请输入颜色或尺码。',
  'pages.live.sellers.products.simpleEdit.bulkValueRequired': '请输入数值。',
  'pages.live.sellers.products.simpleEdit.bulkAppliedAll': '已批量应用到全部行。',
  'pages.live.sellers.products.simpleEdit.bulkAppliedSelected': '已批量应用到所选 {count} 行。',
  'pages.live.sellers.register.nicknameRequired': '请输入昵称',
  'pages.live.sellers.register.phone': '联系方式',
  'pages.live.sellers.register.phonePlaceholder': '010-1234-5678',
  'pages.live.sellers.register.platforms': '平台',
  'pages.live.sellers.register.instagram': 'Instagram @',
  'pages.live.sellers.register.tiktok': 'TikTok @',
  'pages.live.sellers.register.youtube': 'YouTube @',
  'pages.live.sellers.register.usernamePlaceholder': 'username',
  'pages.live.sellers.register.channelPlaceholder': 'channel',
  'pages.live.sellers.register.submit': '注册卖家',
  'pages.live.sellers.register.cancel': '取消',
  'pages.live.sellers.register.success': '卖家注册成功',
  'pages.live.sellers.register.failed': '卖家注册失败',
  'pages.live.sellers.register.selectUserFirst': '请选择用户',
  'pages.live.sellers.register.userInfo': '用户: {userId} | {email}',
  'pages.live.sellers.register.joinDate': '加入: {date} | 订单数: {count}次',
  'pages.live.sellers.register.searchFailed': '搜索用户失败',
  
  // 直播卖家详情
  'pages.live.sellers.detail.title': '卖家详情: {name}',
  'pages.live.sellers.detail.back': '返回',
  'pages.live.sellers.detail.list': '列表',
  'pages.live.sellers.detail.basicInfo': '基本信息',
  'pages.live.sellers.detail.name': '姓名',
  'pages.live.sellers.detail.contact': '联系方式',
  'pages.live.sellers.detail.uid': '会员ID',
  'pages.live.sellers.detail.nickname': '昵称',
  'pages.live.sellers.detail.userNumber': '编号',
  'pages.live.sellers.detail.joinDate': '加入日期',
  'pages.live.sellers.detail.orderCount': '订单数',
  'pages.live.sellers.detail.platforms': '平台',
  'pages.live.sellers.detail.status': '状态',
  'pages.live.sellers.detail.totalLiveCount': '总直播次数',
  'pages.live.sellers.detail.top10Rank': 'TOP10排名',
  'pages.live.sellers.detail.popularSeller': '人气卖家',
  'pages.live.sellers.detail.popular': '🔥 人气',
  'pages.live.sellers.detail.popularInfo': '🔥 (30天内{count}次)',
  'pages.live.sellers.detail.pointSeller': '积分卖家',
  'pages.live.sellers.detail.pointSellerLabel': '⭐ 积分卖家',
  'pages.live.sellers.detail.notFound': '未找到卖家信息',
  'pages.live.sellers.detail.loadFailed': '加载卖家信息失败',
  'pages.live.sellers.detail.times': '{count}次',
  'pages.live.sellers.detail.rank': '第{rank}名',
  'pages.live.sellers.userId': '用户 ID',
  'pages.live.sellers.sellerId': '卖家 ID',
  'pages.live.sellers.name': '卖家昵称',
  'pages.live.sellers.recommender': '推荐人',
  'pages.live.sellers.team': '团队人数',
  'pages.live.sellers.follower': '关注者',
  'pages.live.sellers.salesAmount': '销售金额',
  'pages.live.sellers.salesCount': '销售数量',
  'pages.live.sellers.rebate': '返利累计',
  'pages.live.sellers.refundAmount': '退款金额',
  'pages.live.sellers.rebateDeduction': '返利扣除',
  'pages.live.sellers.liveStatus': '直播状态',
  'pages.live.sellers.liveStatus.live': '直播中',
  'pages.live.sellers.liveStatus.idle': '待机',
  'pages.live.sellers.homepage': '主页',
  'pages.live.sellers.homepageLink': '链接',
  'pages.live.sellers.sellerMailbox': '卖家邮箱号',
  'pages.live.sellers.sellerNickname': '卖家昵称',
  'pages.live.sellers.rebateAccrued': '返利累计',
  'pages.live.sellers.rebateDeducted': '返利扣减',
  'pages.live.sellers.marginAmount': '毛利金额（韩元）',
  'pages.live.sellers.deposit': '保证金',
  'pages.live.sellers.livePage': '直播页',
  'pages.live.sellers.listSearchPlaceholder': '搜索卖家邮箱号或用户 ID',
  'pages.live.sellers.liveLinkCopy': '复制直播链接',
  'pages.live.sellers.liveLinkCopied': '直播链接已复制。',
  'pages.live.sellers.liveLinkCopyFailed': '复制链接失败。',

  // 直播返利设置
  'pages.live.rebate.title': '直播返利设置',
  'pages.live.rebate.liveTeamName': '直播团队名称',
  'pages.live.rebate.memberId': '会员ID',
  'pages.live.rebate.sellerId': '卖家ID',
  'pages.live.rebate.sellerPercent': '卖家%',
  'pages.live.rebate.companyPercent': '公司%',
  'pages.live.rebate.teamPercent': '团队%',
  'pages.live.rebate.teamRebatePercent': '团队返利%',
  'pages.live.rebate.settingTimeAdmin': '设置时间/管理员',
  'pages.live.rebate.actions': '操作',
  'pages.live.rebate.setting': '设置',
  'pages.live.rebate.detail': '详情',
  'pages.live.rebate.delete': '删除',
  'pages.live.rebate.addRebate': '添加返利',
  'pages.live.rebate.batchUpdate': '批量更新',
  'pages.live.rebate.selectFirst': '请先选择项目',
  'pages.live.rebate.addSuccess': '返利添加成功',
  'pages.live.rebate.addFailed': '添加返利失败',
  'pages.live.rebate.updateSuccess': '返利更新成功',
  'pages.live.rebate.updateFailed': '更新返利失败',
  'pages.live.rebate.deleteSuccess': '返利删除成功',
  'pages.live.rebate.deleteFailed': '删除返利失败',
  'pages.live.rebate.deleteConfirm': '删除返利',
  'pages.live.rebate.deleteContent': '确定要删除此返利设置吗？',
  'pages.live.rebate.addModalTitle': '添加返利设置',
  'pages.live.rebate.editModalTitle': '编辑返利设置',
  'pages.live.rebate.liveTeamNameRequired': '请输入直播团队名称',
  'pages.live.rebate.memberIdRequired': '请输入会员ID',
  'pages.live.rebate.sellerIdRequired': '请输入卖家ID',
  'pages.live.rebate.sellerPercentRequired': '请输入卖家百分比',
  'pages.live.rebate.companyPercentRequired': '请输入公司百分比',
  'pages.live.rebate.teamPercentRequired': '请输入团队百分比',
  'pages.live.rebate.teamRebatePercentRequired': '请输入团队返利百分比',
  'pages.live.rebate.loadFailed': '加载返利设置失败',
  'pages.live.rebate.selectAtLeastTwo': '请至少选择2个项目',
  'pages.live.rebate.batchSetting': '批量设置',
  'pages.live.rebate.batchUpdateTitle': '批量更新百分比',
  'pages.live.rebate.selectedItems': '个项目已选择',
  'pages.live.rebate.applySetting': '应用设置',
  'pages.live.rebate.cancel': '取消',
  'pages.live.rebate.batchUpdateSuccess': '批量更新成功完成',
  'pages.live.rebate.batchUpdateFailed': '批量更新失败',
  'pages.live.rebate.searchPlaceholder': '按直播团队名称、卖家ID或会员ID搜索',
  'pages.live.rebate.levelDetailTitle': '直播团队列表',
  'pages.live.rebate.levelDetail.column.teamName': '团队名称',
  'pages.live.rebate.levelDetail.column.depth': '级别',
  'pages.live.rebate.levelDetail.column.userUniqueId': '卖家邮箱',
  'pages.live.rebate.levelDetail.column.userId': '用户ID',
  'pages.live.rebate.levelDetail.column.userName': '卖家昵称',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': '下级团队成员',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': '团队销售金额',
  'pages.live.rebate.levelDetail.column.ownSalesAmountKrw': '本人销售金额',
  'pages.live.rebate.levelDetail.column.subordinateSalesAmountKrw': '下级卖家销售金额',
  'pages.live.rebate.levelDetail.split.own': '本人',
  'pages.live.rebate.levelDetail.split.team': '团队',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': '毛利金额（韩元）',
  'pages.live.rebate.levelDetail.column.salesQuantity': '销售数量',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': '退款金额（韩元）',
  'pages.live.rebate.levelDetail.column.refundQuantity': '退款数量',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': '团队返利累计（韩元）',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': '团队返利扣除（韩元）',
  'pages.live.rebate.levelDetail.column.rebateAccruedKrw': '返利累计（韩元）',
  'pages.live.rebate.levelDetail.column.rebateGrossAccruedKrw': '回收前累计总额（韩元）',
  'pages.live.rebate.levelDetail.column.rebateDeductedKrw': '返利扣除（韩元）',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': '退款后团队返利（韩元）',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': '公司累计（韩元）',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': '公司扣除（韩元）',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': '退款后公司（韩元）',
  'pages.live.rebate.levelDetail.column.level': '级别',
  'pages.live.rebate.levelDetail.column.mailbox': '邮箱',
  'pages.live.rebate.levelDetail.column.teamMemberCount': '团队成员数量',
  'pages.live.rebate.levelDetail.column.sellingPrice': '销售价格',
  'pages.live.rebate.levelDetail.column.sellingQuantity': '销售数量',
  'pages.live.rebate.levelDetail.column.companyProfit': '公司利润',
  'pages.live.rebate.levelDetail.column.refundPrice': '退款价格',
  'pages.live.rebate.levelDetail.column.refundAmount': '退款金额',
  'pages.live.rebate.levelDetail.column.remountRevenue': '公司收入',
  'pages.live.rebate.levelDetail.column.action': '操作',
  'pages.live.rebate.levelDetail.searchLabel': '搜索：',
  'pages.live.rebate.levelDetail.searchPlaceholder': '按卖家ID、用户ID或用户名搜索...',
  'pages.live.rebate.levelDetail.searchButton': '搜索',
  'pages.live.rebate.levelDetail.resetButton': '重置',
  'pages.live.rebate.levelDetail.reloadButton': '重新加载',
  'pages.live.rebate.levelDetail.detailButton': '详情',
  'pages.live.rebate.levelDetail.loadError': '加载直播返利详情数据失败',
  'pages.live.rebate.levelDetail.level1': '级别 1',
  'pages.live.rebate.levelDetail.level2': '级别 2',
  'pages.live.rebate.levelDetail.level3': '级别 3',
  'pages.live.rebate.levelDetail.level4': '级别 4',
  'pages.live.rebate.searchLabel': '搜索',
  'pages.live.rebate.search': '搜索',
  'pages.live.rebate.reset': '重置',
  'pages.live.rebate.teamLead': '团队负责人',
  'pages.live.rebate.teamLeadId': '团队负责人ID',
  'pages.live.rebate.teamLeadIdRequired': '请输入团队负责人ID',
  'pages.live.rebate.teamInternalSelfPercent': '团队内部自身%',
  'pages.live.rebate.teamInternalSelfPercentRequired': '请输入团队内部自身百分比',
  'pages.live.rebate.teamInternalUplinePercent': '团队内部上级%',
  'pages.live.rebate.teamRebate': '团队返利',
  'pages.live.rebate.memberSettings': '成员设置',
  'pages.live.rebate.memberSettingsTitle': '按卖家返利设置',
  'pages.live.rebate.memberSettingsHint': '设置单个卖家的返利比例。保存后该卖家的结算将使用此值而不是团队设置；"未设置"的卖家继续使用团队设置。',
  'pages.live.rebate.memberSource': '设置来源',
  'pages.live.rebate.memberSourceTeamCopy': '复制自团队',
  'pages.live.rebate.memberSourceAdmin': '单独设置',
  'pages.live.rebate.memberSourceNone': '未设置（使用团队设置）',
  'pages.live.rebate.memberSourceTeamConfig': '团队设置',
  'pages.live.rebate.memberSelfPercent': '自留 %',
  'pages.live.rebate.memberSave': '保存',
  'pages.live.rebate.memberSaveSuccess': '卖家返利设置已保存',
  'pages.live.rebate.memberSaveFailed': '保存卖家返利设置失败',
  'pages.live.rebate.memberLoadFailed': '加载团队成员失败',
  'pages.live.rebate.marginSumError': '卖家+公司+团队 % 之和必须为 100',
  'pages.live.rebate.teamLeadTag': '团长',
  'pages.live.rebate.teamInternalUplinePercentRequired': '请输入团队内部上级百分比',
  'pages.live.rebate.configuredAt': '配置时间',
  'pages.live.rebate.configuredAtRequired': '请选择配置时间',

  // 直播商品
  'pages.live.products.title': '直播商品管理',
  'pages.live.products.bulkUpdateTitle': '批量更新直播商品',
  'pages.live.products.bulkUpdateOnlineViews': '批量更新在线浏览量',
  'pages.live.products.bulkUpdateReviewScore': '批量更新评论评分',
  'pages.live.products.bulkUpdateReviewNumbers': '批量更新评论数量',
  'pages.live.products.bulkUpdateLivePeriods': '批量更新直播日期/时间',
  'pages.live.products.bulkUpdateIsHot': '批量更新热门状态',
  'pages.live.products.bulkUpdateDescription': '将更新已选 {count} 项',
  'pages.live.products.selectedCount': '已选 {count} 项',
  'pages.live.products.clearSelection': '清除选择',
  'pages.live.products.add': '添加新直播商品',
  'pages.live.products.addTitle': '添加新直播商品',
  'pages.live.products.editTitle': '编辑直播商品',
  'pages.live.products.quickEdit': '快速编辑',
  'pages.live.products.productNumber': '商品编号',
  'pages.live.products.offerId': 'OfferId',
  'pages.live.products.productName': '商品名称',
  'pages.live.products.productInformation': '商品信息',
  'pages.live.products.image': '图片',
  'pages.live.products.video': '视频',
  'pages.live.products.liveDateTime': '直播日期/时间',
  'pages.live.products.liveTitle': '直播标题',
  'pages.live.products.onlineViews': '在线浏览量',
  'pages.live.products.itemsSold': '销售量',
  'pages.live.products.reviewScore': '评分',
  'pages.live.products.reviewNumbers': '评论数',
  'pages.live.products.videoStatus.uploaded': '[已上传]',
  'pages.live.products.videoStatus.notUploaded': '[未上传]',
  'pages.live.products.status': '状态',
  'pages.live.products.status.scheduled': '○ 已安排',
  'pages.live.products.status.live': '● 直播中',
  'pages.live.products.status.completed': '○ 已完成',
  'pages.live.products.status.cancelled': '○ 已取消',
  'pages.live.products.isHot': '热门产品',
  'pages.live.products.setHot': '设为热门',
  'pages.live.products.removeHot': '取消热门',
  'pages.live.products.updatedAt': '更新时间',
  'pages.live.products.manage': '管理',
  'pages.live.products.edit': '编辑',
  'pages.live.products.delete': '删除',
  'pages.live.products.deleteConfirm': '删除商品',
  'pages.live.products.deleteContent': '确定要删除此直播商品吗？',
  'pages.live.products.deleteSuccess': '商品删除成功',
  'pages.live.products.deleteFailed': '删除失败',
  'pages.live.products.loadFailed': '加载商品列表失败',
  'pages.live.products.createSuccess': '商品注册成功',
  'pages.live.products.updateSuccess': '商品更新成功',
  'pages.live.products.saveFailed': '操作失败',
  'pages.live.products.bulkUpdate.liveTitleRequired': '请输入直播标题',
  'pages.live.products.bulkUpdate.onlineViewsRequired': '请输入在线浏览量',
  'pages.live.products.bulkUpdate.reviewScoreRequired': '请输入评分',
  'pages.live.products.bulkUpdate.reviewNumbersRequired': '请输入评论数',
  'pages.live.products.bulkUpdate.isHotRequired': '请选择热门状态',
  
  // 直播商品表单
  'pages.live.products.form.product': '商品',
  'pages.live.products.form.productPlaceholder': '按商品编号或名称搜索',
  'pages.live.products.form.productRequired': '请选择商品',
  'pages.live.products.form.searchFailed': '搜索商品失败',
  'pages.live.products.form.productNumber': '商品编号',
  'pages.live.products.form.productNumberPlaceholder': 'P00123',
  'pages.live.products.form.productNumberRequired': '请输入商品编号',
  'pages.live.products.form.liveDate': '直播日期',
  'pages.live.products.form.liveDatePeriod': '直播期间',
  'pages.live.products.form.liveDateRequired': '请选择日期',
  'pages.live.products.form.liveLink': '直播链接',
  'pages.live.products.form.liveLinkPlaceholder': '输入直播链接',
  'pages.live.products.form.startTime': '开始时间',
  'pages.live.products.form.startTimeRequired': '请选择开始时间',
  'pages.live.products.form.endTime': '结束时间',
  'pages.live.products.form.title': '直播标题',
  'pages.live.products.form.titlePlaceholder': '新款运动鞋特价',
  'pages.live.products.form.titleRequired': '请输入标题',
  'pages.live.products.form.onlineViews': '在线浏览量',
  'pages.live.products.form.onlineViewsPlaceholder': '输入在线浏览量',
  'pages.live.products.form.itemsSold': '销售量',
  'pages.live.products.form.itemsSoldPlaceholder': '输入销售量',
  'pages.live.products.form.reviewScore': '评分',
  'pages.live.products.form.reviewScorePlaceholder': '输入评分 (0-5)',
  'pages.live.products.form.reviewNumbers': '评论数',
  'pages.live.products.form.reviewNumbersPlaceholder': '输入评论数',
  'pages.live.products.form.image': '图片',
  'pages.live.products.form.uploadImage': '上传图片',
  'pages.live.products.form.videoUrl': '视频',
  'pages.live.products.form.videoUrlPlaceholder': 'https://...',
  'pages.live.products.form.uploadVideo': '上传视频',
  'pages.live.products.form.uploadMedia': '上传视频/图片',
  'pages.live.products.form.imageUrl': '图片URL',
  'pages.live.products.form.imageUrlPlaceholder': 'https://...',
  'pages.live.products.form.status': '状态',
  'pages.live.products.form.statusRequired': '请选择状态',
  'pages.live.products.form.submit': '提交',
  'pages.live.products.form.cancel': '取消',

  // Live Page Settings
  'pages.live.pageSettings.title': '直播页面设置',
  'pages.live.pageSettings.visible': '显示',
  'pages.live.pageSettings.hidden': '隐藏',
  'pages.live.pageSettings.col.actions': '操作',
  'pages.live.pageSettings.schedules.tab': '直播日程',
  'pages.live.pageSettings.schedules.add': '添加日程',
  'pages.live.pageSettings.schedules.addTitle': '添加直播日程',
  'pages.live.pageSettings.schedules.editTitle': '编辑直播日程',
  'pages.live.pageSettings.schedules.col.title': '标题',
  'pages.live.pageSettings.schedules.col.seller': '卖家',
  'pages.live.pageSettings.schedules.col.time': '日程时间',
  'pages.live.pageSettings.schedules.col.startTime': '开始时间',
  'pages.live.pageSettings.schedules.col.endTime': '结束时间',
  'pages.live.pageSettings.schedules.endAfterStart': '结束时间必须晚于开始时间',
  'pages.live.pageSettings.schedules.col.visible': '是否显示',
  'pages.live.pageSettings.schedules.sellerPlaceholder': '搜索卖家',
  'pages.live.pageSettings.schedules.created': '直播日程已添加',
  'pages.live.pageSettings.schedules.updated': '直播日程已更新',
  'pages.live.pageSettings.schedules.deleted': '直播日程已删除',
  'pages.live.pageSettings.schedules.saveFailed': '保存日程失败',
  'pages.live.pageSettings.schedules.deleteFailed': '删除日程失败',
  'pages.live.pageSettings.schedules.deleteConfirm': '确认删除此直播日程？',
  'pages.live.pageSettings.reels.tab': '直播短视频',
  'pages.live.sections.tab': '版块配置',
  'pages.live.sections.add': '添加版块',
  'pages.live.sections.addTitle': '添加版块',
  'pages.live.sections.editTitle': '编辑版块',
  'pages.live.sections.saved': '版块已保存',
  'pages.live.sections.saveFailed': '版块保存失败',
  'pages.live.sections.loadFailed': '版块列表加载失败',
  'pages.live.sections.reordered': '顺序已更新',
  'pages.live.sections.reorderFailed': '顺序更新失败',
  'pages.live.sections.deleted': '版块已删除',
  'pages.live.sections.deleteFailed': '版块删除失败',
  'pages.live.sections.deleteConfirm': '要删除此版块吗？',
  'pages.live.sections.dragHint': '拖动手柄可调整顺序',
  'pages.live.sections.autoOnlyHint': '该类型从其他页面管理的数据按规则取用。手动挑选适用于商品、卖家、横幅、限时抢购、优惠券和文字滚动条版块。',
  'pages.live.sections.column.title': '版块',
  'pages.live.sections.column.untitled': '(无标题)',
  'pages.live.sections.column.type': '类型',
  'pages.live.sections.column.source': '内容来源',
  'pages.live.sections.column.items': '项目',
  'pages.live.sections.column.itemCount': '已选 {count} 个',
  'pages.live.sections.column.limitCount': '最多 {count} 个',
  'pages.live.sections.column.device': '设备',
  'pages.live.sections.column.visible': '展示',
  'pages.live.sections.group.basic': '基本信息',
  'pages.live.sections.group.content': '内容来源',
  'pages.live.sections.group.style': '展示方式',
  'pages.live.sections.field.key': '版块标识',
  'pages.live.sections.field.keyHint': '仅限小写字母、数字和连字符（例：today-live-pick）',
  'pages.live.sections.field.type': '类型',
  'pages.live.sections.field.title': '标题',
  'pages.live.sections.field.subtitle': '副标题',
  'pages.live.sections.field.layout': '布局',
  'pages.live.sections.field.device': '设备',
  'pages.live.sections.field.itemLimit': '展示数量',
  'pages.live.sections.field.isVisible': '展示',
  'pages.live.sections.field.moreLink': '查看更多链接',
  'pages.live.sections.field.period': '展示期间',
  'pages.live.sections.field.periodHint': '留空表示长期展示',
  'pages.live.sections.field.sourceMode': '内容来源',
  'pages.live.sections.field.backgroundColor': '背景色',
  'pages.live.sections.field.fullBleed': '通栏宽度',
  'pages.live.sections.sourceMode.auto': '按条件自动',
  'pages.live.sections.sourceMode.manual': '手动挑选',
  'pages.live.sections.type.heroLive': '大图直播',
  'pages.live.sections.type.liveNow': '正在直播',
  'pages.live.sections.type.schedule': '直播时间表',
  'pages.live.sections.type.reels': '直播短视频',
  'pages.live.sections.type.sellerRail': '卖家横排',
  'pages.live.sections.type.productRail': '商品横排',
  'pages.live.sections.type.productGrid': '商品网格',
  'pages.live.sections.type.ranking': '排行榜',
  'pages.live.sections.type.categoryTabs': '分类标签',
  'pages.live.sections.type.banner': '横幅',
  'pages.live.sections.type.eventTicker': '活动条',
  'pages.live.sections.type.timeSale': '限时抢购',
  'pages.live.sections.type.coupon': '优惠券',
  'pages.live.sections.type.ticker': '文字滚动条',
  'pages.live.sections.layout.hero': '大图',
  'pages.live.sections.layout.rail': '横向滚动',
  'pages.live.sections.layout.grid': '网格',
  'pages.live.sections.layout.list': '列表',
  'pages.live.sections.layout.banner': '横幅',
  'pages.live.sections.device.all': '全部',
  'pages.live.sections.device.pc': '电脑',
  'pages.live.sections.device.mobile': '手机',
  'pages.live.sections.filter.productFlags': '商品条件',
  'pages.live.sections.filter.sellerFlags': '卖家条件',
  'pages.live.sections.filter.categories': '分类',
  'pages.live.sections.filter.categoryTabsHint': '留空则展示全部启用的一级分类',
  'pages.live.sections.filter.simpleAutoHint': '该类型自动取用进行中的列表 — 只需设置展示数量和排序。',
  'pages.live.sections.filter.liveState': '直播状态',
  'pages.live.sections.filter.sortBy': '排序',
  'pages.live.sections.filter.flagPopular': '人气',
  'pages.live.sections.filter.flagPoint': '积分',
  'pages.live.sections.filter.sortRank': '排名',
  'pages.live.sections.filter.flag_isPopular': '人气',
  'pages.live.sections.filter.flag_isFeatured': '推荐',
  'pages.live.sections.filter.flag_isBestSeller': '热卖',
  'pages.live.sections.filter.flag_isNewArrival': '新品',
  'pages.live.sections.filter.flag_isImportant': '置顶',
  'pages.live.sections.filter.flag_isPoint': '积分合作',
  'pages.live.sections.filter.liveState_all': '全部',
  'pages.live.sections.filter.liveState_live': '直播中',
  'pages.live.sections.filter.liveState_scheduled': '待开播',
  'pages.live.sections.filter.liveState_recent': '近期结束',
  'pages.live.sections.filter.sortBy_recent': '最新',
  'pages.live.sections.filter.sortBy_sold': '销量',
  'pages.live.sections.filter.sortBy_price_asc': '价格从低到高',
  'pages.live.sections.filter.sortBy_price_desc': '价格从高到低',
  'pages.live.sections.filter.sortBy_rank': '排名',
  'pages.live.sections.filter.sortBy_views': '浏览量',
  'pages.live.sections.items.remove': '移除',
  'pages.live.sections.items.bannerRow': '横幅 {index}',
  'pages.live.sections.items.imagePc': '电脑图片',
  'pages.live.sections.items.imageMobile': '手机图片',
  'pages.live.sections.items.linkUrl': '链接',
  'pages.live.sections.items.caption': '文案',
  'pages.live.sections.items.addProduct': '挑选商品',
  'pages.live.sections.items.addSeller': '挑选卖家',
  'pages.live.sections.items.addBanner': '添加横幅',
  'pages.live.sections.items.addTimeSale': '挑选限时抢购',
  'pages.live.sections.items.addCoupon': '挑选优惠券',
  'pages.live.sections.items.addMetric': '添加文字行',
  'pages.live.sections.items.metricRow': '文字 {index}',
  'pages.live.sections.items.metricCaption': '滚动文案',
  'pages.live.sections.items.metricLink': '链接',
  'pages.live.sections.items.timeSaleHidden': '未公开',
  'pages.live.sections.items.metricCaptionRequired': '第 {index} 条文字行至少需填写一种语言',
  'pages.live.sections.items.count': '{count} / {max}',
  'pages.live.sections.items.empty': '尚未添加项目',
  'pages.live.sections.picker.loadFailed': '列表加载失败',
  'pages.live.sections.picker.productTitle': '挑选直播商品',
  'pages.live.sections.picker.sellerTitle': '挑选直播卖家',
  'pages.live.sections.picker.confirm': '添加',
  'pages.live.sections.picker.searchPlaceholder': '按商品名或商品编号搜索',
  'pages.live.sections.picker.sellerSearchPlaceholder': '按卖家名搜索',
  'pages.live.sections.picker.image': '图片',
  'pages.live.sections.picker.product': '商品',
  'pages.live.sections.picker.productNo': '商品编号',
  'pages.live.sections.picker.uniqueNo': '唯一编号',
  'pages.live.sections.picker.seller': '卖家',
  'pages.live.sections.picker.sellerId': '卖家 ID',
  'pages.live.sections.picker.sellerFlags': '标识',
  // Live Time Sales
  'pages.live.timeSales.tab': '限时特卖',
  'pages.live.timeSales.add': '添加限时特卖',
  'pages.live.timeSales.addTitle': '添加限时特卖',
  'pages.live.timeSales.editTitle': '编辑限时特卖',
  'pages.live.timeSales.dragHint': '拖动手柄可调整顺序',
  'pages.live.timeSales.loadFailed': '限时特卖列表加载失败',
  'pages.live.timeSales.saved': '已保存',
  'pages.live.timeSales.saveFailed': '保存失败',
  'pages.live.timeSales.deleteConfirm': '确定删除该限时特卖吗？',
  'pages.live.timeSales.deleted': '已删除',
  'pages.live.timeSales.deleteFailed': '删除失败',
  'pages.live.timeSales.reordered': '顺序已更新',
  'pages.live.timeSales.reorderFailed': '顺序更新失败',
  'pages.live.timeSales.column.product': '商品',
  'pages.live.timeSales.column.title': '特卖标题',
  'pages.live.timeSales.column.period': '时间段',
  'pages.live.timeSales.column.progress': '销售进度',
  'pages.live.timeSales.column.salePrice': '特卖价',
  'pages.live.timeSales.column.visible': '显示',
  'pages.live.timeSales.column.untitled': '无标题',
  'pages.live.timeSales.status.scheduled': '未开始',
  'pages.live.timeSales.status.running': '进行中',
  'pages.live.timeSales.status.ended': '已结束',
  'pages.live.timeSales.progress.text': '{sold} / {target} 件',
  'pages.live.timeSales.salePrice.useProductPrice': '使用商品价格',
  'pages.live.timeSales.form.product': '商品',
  'pages.live.timeSales.form.productRequired': '请选择商品',
  'pages.live.timeSales.form.pickProduct': '选择商品',
  'pages.live.timeSales.form.changeProduct': '更换商品',
  'pages.live.timeSales.form.pickOneOnly': '限时特卖只能关联一个商品，已采用第一个选择',
  'pages.live.timeSales.form.noProduct': '尚未选择商品',
  'pages.live.timeSales.form.title': '特卖标题',
  'pages.live.timeSales.form.titlePlaceholder': '例如：今日限时特卖',
  'pages.live.timeSales.form.period': '特卖时间段',
  'pages.live.timeSales.form.periodRequired': '请填写开始与结束时间',
  'pages.live.timeSales.form.periodInvalid': '结束时间必须晚于开始时间',
  'pages.live.timeSales.form.targetQuantity': '目标数量',
  'pages.live.timeSales.form.soldQuantity': '已售数量',
  'pages.live.timeSales.form.salePrice': '特卖价（韩元）',
  'pages.live.timeSales.form.salePriceHint': '留空则使用商品价格',
  'pages.live.timeSales.form.isVisible': '显示',
  'pages.live.pageSettings.reels.add': '添加短视频',
  'pages.live.pageSettings.reels.addTitle': '添加直播短视频',
  'pages.live.pageSettings.reels.editTitle': '编辑直播短视频',
  'pages.live.pageSettings.reels.col.cover': '封面',
  'pages.live.pageSettings.reels.col.title': '标题',
  'pages.live.pageSettings.reels.col.seller': '卖家',
  'pages.live.pageSettings.reels.col.watchUserCount': '观看人数',
  'pages.live.pageSettings.reels.col.scheduledDate': '日期',
  'pages.live.pageSettings.reels.col.time': '时间',
  'pages.live.pageSettings.reels.col.video': '视频',
  'pages.live.pageSettings.reels.col.showOnFrontend': '前台显示',
  'pages.live.pageSettings.reels.timeFrom': '开始',
  'pages.live.pageSettings.reels.timeTo': '结束',
  'pages.live.pageSettings.reels.imageSection': '封面图片',
  'pages.live.pageSettings.reels.videoSection': '视频',
  'pages.live.pageSettings.reels.imageUrl': '图片URL',
  'pages.live.pageSettings.reels.videoUrl': '视频URL',
  'pages.live.pageSettings.reels.uploadImage': '上传图片',
  'pages.live.pageSettings.reels.uploadVideo': '上传视频',
  'pages.live.pageSettings.reels.clearFile': '清除上传文件',
  'pages.live.pageSettings.reels.open': '打开',
  'pages.live.pageSettings.reels.created': '短视频已添加',
  'pages.live.pageSettings.reels.updated': '短视频已更新',
  'pages.live.pageSettings.reels.deleted': '短视频已删除',
  'pages.live.pageSettings.reels.saveFailed': '保存短视频失败',
  'pages.live.pageSettings.reels.deleteFailed': '删除短视频失败',
  'pages.live.pageSettings.reels.deleteConfirm': '确认删除此短视频？',

  // ── [J5 条线] M2 §5-2 · §5-3 短视频/限时抢购卡片文案与商品关联 ──────────
  'pages.live.pageSettings.reels.col.cardText': '卡片文案',
  'pages.live.pageSettings.reels.col.product': '关联商品',
  'pages.live.pageSettings.reels.cardSection': '卡片文案 · 关联商品',
  'pages.live.pageSettings.reels.product': '关联商品',
  'pages.live.pageSettings.reels.productHint': '该短视频推广的商品。留空则不关联商品',
  'pages.live.pageSettings.reels.noProduct': '未选择商品',
  'pages.live.pageSettings.reels.pickProduct': '选择商品',
  'pages.live.pageSettings.reels.changeProduct': '更换商品',
  'pages.live.pageSettings.reels.clearProduct': '取消关联',
  'pages.live.pageSettings.reels.pickOneOnly': '短视频只能关联一个商品，已使用第一个商品',
  'pages.live.pageSettings.reels.priceLabel': '价格文案',
  'pages.live.pageSettings.reels.priceLabelHint':
    '不是计算得出的金额，而是原样显示在卡片上的文案（最多 60 字）',
  'pages.live.pageSettings.reels.priceLabelPlaceholder': '39,000韩元起',
  'pages.live.pageSettings.reels.caption': '说明文案',
  'pages.live.pageSettings.reels.captionHint': '显示在短视频下方的文案',
  'pages.live.pageSettings.reels.captionPlaceholder': '例：冬季新品直播',
  'pages.live.pageSettings.reels.eventText': '活动文案',
  'pages.live.pageSettings.reels.eventTextHint': '在卡片上以橙色显示的一行',
  'pages.live.pageSettings.reels.eventTextPlaceholder': '例：前 100 名赠送礼品',
  'pages.live.timeSales.column.cardText': '卡片文案',
  'pages.live.timeSales.form.products': '商品（最多 2 个）',
  'pages.live.timeSales.form.productsHint':
    '一张卡片最多放 2 个商品。点击选择商品后，所选结果将替换当前列表',
  'pages.live.timeSales.form.removeProduct': '移除该商品',
  'pages.live.timeSales.form.tooManyProducts': '最多只能添加 {max} 个商品',
  'pages.live.timeSales.form.caption': '说明文案',
  'pages.live.timeSales.form.captionHint': '卡片说明文案（每种语言 200 字）',
  'pages.live.timeSales.form.captionPlaceholder': '例：仅限今日此价',
  'pages.live.timeSales.form.eventText': '活动文案',
  'pages.live.timeSales.form.eventTextHint': '在卡片上以橙色显示的一行（每种语言 200 字）',
  'pages.live.timeSales.form.eventTextPlaceholder': '例：购买即赠礼品',
  // ── [J5 条线] 结束 ────────────────────────────────────────────────────

  // ── 前台页面设置 (M2, /operation/frontend-pages) ────────────────────────
  // 先放整屏通用文案。版块编辑、直播日程、店铺等细分键由各条线确定后追加到此块下方。
  'pages.frontendPages.carousel.changeImage': '更换图片',
  'pages.frontendPages.carousel.clearImage': '清除已选文件',
  'pages.frontendPages.carousel.heavyImage': '图片过大，建议上传更小的图片。',
  'pages.frontendPages.carousel.imagePicked': '已选择图片，保存后生效。',
  'pages.frontendPages.carousel.notImage': '只能上传图片文件。',
  'pages.frontendPages.carousel.recommendSize': '推荐',
  'pages.frontendPages.carousel.tooLarge': '文件过大。',
  'pages.frontendPages.carousel.variants': '变体',
  'pages.frontendPages.items.cropHint': '卡片中只显示橙色虚线内的区域。',
  'pages.frontendPages.items.heavyImage': '图片过大，建议上传更小的图片。',
  'pages.frontendPages.items.pickerAction': '操作',
  'pages.frontendPages.items.pickerAdd': '添加',
  'pages.frontendPages.items.pickerAddOnlyHint': '此窗口只负责添加。要移除请回到列表中操作。',
  'pages.frontendPages.items.pickerAlreadyAdded': '已添加',
  'pages.frontendPages.items.pickerClose': '关闭',
  'pages.frontendPages.items.pickerExcludedReason': '不在该插槽的商品范围内，无法添加。',
  'pages.frontendPages.items.pickerFull': '插槽已满。移除或隐藏卡片后才能继续添加。',
  'pages.frontendPages.items.pickerTrimmed': '超出插槽上限，有 {count} 个未添加（最多 {max} 个）。',
  'pages.frontendPages.items.recommendSize': '推荐',
  'pages.frontendPages.items.removeUnlistedBody': '该卡片指向的对象不在列表中，无法显示名称。仍要删除吗？',
  'pages.frontendPages.items.removeUnlistedTitle': '无法确认这张卡片指向什么',
  'pages.frontendPages.items.replaceSeller': '更换卖家',
  'pages.frontendPages.items.unlistedCoupon': '（列表中没有的优惠券）{id}',
  'pages.frontendPages.items.unlistedSession': '（列表中没有的往期场次）{id}',
  'pages.frontendPages.items.unlistedSessionHint': '该场次已结束，因此不在列表中。无法显示卖家、时间与商品数，但卡片仍会出现在前台。',
  'pages.frontendPages.items.unlistedTimeSale': '（列表中没有的往期限时抢购）{id}',
  'pages.frontendPages.items.unlistedTimeSaleHint': '该限时抢购已结束，因此不在列表中，无法显示标题。',
  'pages.frontendPages.items.variants': '变体',
  'pages.frontendPages.schedule.unsavedBody': '关闭后本次修改将丢失。仍要关闭吗？',
  'pages.frontendPages.schedule.unsavedDiscard': '关闭',
  'pages.frontendPages.schedule.unsavedKeep': '继续编辑',
  'pages.frontendPages.schedule.unsavedTitle': '有尚未保存的修改',
  'pages.frontendPages.slots.removeConfirmBody': '该插槽内的 {count} 张卡片会一并移除。',
  'pages.frontendPages.slots.removeConfirmOk': '删除',
  'pages.frontendPages.slots.removeConfirmTitle': '要删除该插槽吗？',
  'pages.frontendPages.title': '前台页面设置',
  'pages.frontendPages.page.site': '通用',
  'pages.frontendPages.page.home': '推荐',
  'pages.frontendPages.page.overseas': '海外直购',
  'pages.frontendPages.page.live': '直播',
  'pages.frontendPages.page.ownmall': '自营商城',
  'pages.frontendPages.tab.sections': '版块配置',
  'pages.frontendPages.tab.settings': '页面设置',
  'pages.frontendPages.tab.schedule': '直播日程',
  'pages.frontendPages.tab.reels': '短视频',
  'pages.frontendPages.tab.timeSales': '限时特卖',
  'pages.frontendPages.tab.layout': '页面构成',
  'pages.frontendPages.canvas.introHome': '这是推荐页的显示顺序。打开对应区块即可修改该位置的图片、商品和文案。',
  'pages.frontendPages.canvas.introLive': '这是直播页的显示顺序。直播日程在「直播卖家轮播」区块的「打开直播日程」里编辑，其余区块各自对应画面上的位置。',
  'pages.frontendPages.canvas.laterPages': '海外直购页面正文不在本次范围内。版块仍可保留。',
  'pages.frontendPages.canvas.introOwnmall': '这是自营商城页的显示顺序。打开对应区块即可修改该位置的图片、商品和文案。',
  'pages.frontendPages.canvas.introOverseas': '这是海外直购页的显示顺序。打开对应区块即可修改该位置的图片、商品和文案。',
  'pages.frontendPages.canvas.block.overseasHero.title': '首屏（横幅 + 轮播 + 横幅）',
  'pages.frontendPages.canvas.block.overseasHero.desc': '左右各一张图片横幅，中间是轮播。右侧使用“右上”栏位的第一张卡片。',
  'pages.frontendPages.canvas.block.ovBest.title': '当下热门商品（3 列）',
  'pages.frontendPages.canvas.block.ovBest.desc': '1688 · 淘宝 · VVIC 三列。每列放两张外部商品卡片；淘宝和 VVIC 列以排行卡片展示。',
  'pages.frontendPages.canvas.block.overseasMarket.title': '按供应平台的分类商品',
  'pages.frontendPages.canvas.block.overseasMarket.desc': '供应平台页签（1688 · 淘宝 · VVIC）→ 分类标签 → 子页签 → 商品行。标签从分类管理中选择，卡片通过商品链接或手动录入添加。没有卡片的标签会显示按分类名称在该平台搜索的结果。',
  'pages.frontendPages.canvas.block.overseasMore.title': '更多商品',
  'pages.frontendPages.canvas.block.overseasMore.desc': '持续加载 1688 新品的网格。可修改标题、首次展示数量和每次点击追加的数量。',
  'pages.frontendPages.canvas.block.ownmallHero.title': '首屏（横幅 + 轮播 + 促销卡片）',
  'pages.frontendPages.canvas.block.ownmallHero.desc': '左侧大图横幅、中间轮播、右侧两张促销卡片（小字·粗体·小字 + 图标）。',
  'pages.frontendPages.canvas.block.ownmallStores.title': '今日推荐店铺',
  'pages.frontendPages.canvas.block.ownmallStores.desc': '自营商城店铺卡片。“更多”链接会显示为右侧的“查看全部”。',
  'pages.frontendPages.canvas.block.ownmallPopular.title': '人气商品（标签）',
  'pages.frontendPages.canvas.block.ownmallPopular.desc': '一个标签就是一个页签。为每个页签选择商品条件（推荐·新品·人气…），符合条件的商品会排成一行。',
  'pages.frontendPages.canvas.block.ownmallCategories.title': '分类条 + 分类商品',
  'pages.frontendPages.canvas.block.ownmallCategories.desc': '自营商城页面的分类行（圆形分类按钮），以及下方所选分类的子页签和商品行。一个分类也不添加时，所有一级分类会自动显示。',
  'pages.frontendPages.canvas.block.ownmallMore.title': '更多商品',
  'pages.frontendPages.canvas.block.ownmallMore.desc': '持续加载自营商品的网格。可修改标题、首次展示数量和每次点击追加的数量。',
  'pages.frontendPages.canvas.visible': '展示',
  'pages.frontendPages.canvas.hidden': '隐藏',
  'pages.frontendPages.canvas.missing': '尚未创建',
  'pages.frontendPages.canvas.cardCount': '卡片 {cards}/{total}',
  'pages.frontendPages.canvas.edit': '编辑此区块',
  'pages.frontendPages.canvas.create': '创建此区块',
  'pages.frontendPages.canvas.showSchedule': '打开直播日程',
  'pages.frontendPages.canvas.hideSchedule': '收起直播日程',
  'pages.frontendPages.canvas.extras': '其他区块（短视频、限时特卖等）',
  'pages.frontendPages.canvas.extrasHint': '设计稿以外的旧版块。只有开启的才会出现在前台。',
  'pages.frontendPages.canvas.extraName.liveHeroM': '顶部横幅',
  'pages.frontendPages.canvas.extraName.liveWideBanners': '宽幅横幅',
  'pages.frontendPages.canvas.deviceOnly.mobile': '仅移动端',
  'pages.frontendPages.canvas.deviceOnly.pc': '仅 PC 端',
  'pages.frontendPages.canvas.advanced': '高级：以版块列表编辑',
  'pages.frontendPages.canvas.empty': '此页面没有指定区块。',
  'pages.frontendPages.canvas.editHint': '修改该设计位置的标题、商品和图片。版块键和类型保持不变。',
  'pages.frontendPages.canvas.block.hero.title': '主视觉（LIVE CHANNEL · 轮播 · 人气新品）',
  'pages.frontendPages.canvas.block.hero.desc': '左侧 LIVE CHANNEL 卡片、中间轮播、右侧人气新品与自营热销。标签、图标和商品在此修改。',
  'pages.frontendPages.canvas.block.homeCats.title': '分类分组',
  'pages.frontendPages.canvas.block.homeCats.desc': '选择左侧 HOT 分组后，右侧圆形分类会随之变化。每个圆包含图片、标题和搜索链接。',
  'pages.frontendPages.canvas.block.liveBest.title': '直播人气商品',
  'pages.frontendPages.canvas.block.liveBest.desc': '三列标题和商品。可放入直播商品和自营商城商品。在此上传的落地图会同时用于卡片和详情页首图。',
  'pages.frontendPages.canvas.block.homeStores.title': '今日推荐店铺',
  'pages.frontendPages.canvas.block.homeStores.desc': '自营店铺卡片。圆形图、主图、推荐页展示和代表商品也可在店铺管理与商品列表中设置。',
  'pages.frontendPages.canvas.block.overseasBest.title': '海外直购热搜商品',
  'pages.frontendPages.canvas.block.overseasBest.desc': '列标题以及商品图片、标题、价格、折扣价和链接。',
  'pages.frontendPages.canvas.block.more.title': '查看更多商品',
  'pages.frontendPages.canvas.block.more.desc': '标题、首次展示数量，以及每次点击“查看更多”追加的数量。',
  'pages.frontendPages.canvas.block.spotlight.title': '直播卖家轮播',
  'pages.frontendPages.canvas.block.spotlight.desc': '中间卖家的主图、时间、标题、口号和 3 件代表商品。左右箭头可切换卖家。',
  'pages.frontendPages.canvas.block.liveCats.title': '直播分类分组',
  'pages.frontendPages.canvas.block.liveCats.desc': '与推荐页相同的布局，但设置独立。点击圆形会进入直播商品搜索。',
  'pages.frontendPages.canvas.block.chance.title': '直播机会',
  'pages.frontendPages.canvas.block.chance.desc': '筛选标签、排序和当前直播卡片网格。',
  'pages.frontendPages.canvas.block.liveBestSellers.title': '人气 BEST 主播',
  'pages.frontendPages.canvas.block.liveBestSellers.desc': '放入主播后按该顺序展示。留空则按累计观看（或销量）自动填充。每张卡片下方的商品可单独选择。',
  'pages.frontendPages.canvas.block.liveRanking.title': '购物直播人气商品排行',
  'pages.frontendPages.canvas.block.liveRanking.desc': '带今日/3天/1周页签的排行商品网格（页签在手动模式下生效）。',
  'pages.frontendPages.canvas.block.liveStores.title': '今日推荐店铺（直播）',
  'pages.frontendPages.canvas.block.liveStores.desc': '直播页上的自营店铺横滑。可与推荐页使用不同列表。',
  'pages.frontendPages.canvas.block.liveBanners.title': '宽幅高亮横幅',
  'pages.frontendPages.canvas.block.liveBanners.desc': '通栏图片和链接。',
  'pages.frontendPages.canvas.block.liveReels.title': '人气急上升短视频',
  'pages.frontendPages.canvas.block.liveReels.desc': '与直播机会相同的直播卡片，带蓝色「短视频」标记。直接挑选时按所选顺序展示，自动时按观看数从高到低展示已结束的直播。',
  'pages.frontendPages.canvas.block.liveBenefits.title': '直播优惠',
  'pages.frontendPages.canvas.block.liveBenefits.desc': '像直播机会一样挑选直播，并为每张卡片设置倒计时结束时间。过了时间显示「时间结束」，留空则不显示倒计时。',
  'pages.frontendPages.canvas.block.partners.title': '积分合作卖家',
  'pages.frontendPages.canvas.block.partners.desc': '大图卖家照片、关注与代表商品组成的双列合作卡片。',
  'pages.frontendPages.canvas.block.liveSellerRail.title': '推荐卖家',
  'pages.frontendPages.canvas.block.liveSellerRail.desc':
    '直播卖家轮播下方的卖家头像行。只按添加顺序显示已添加的卖家，与卖家管理中的人气/积分卖家设置无关。要移除卖家请在[编辑]中删除，要整体隐藏请关闭显示开关。',
  'pages.frontendPages.action.preview': '预览（含隐藏）',
  'pages.frontendPages.action.invalidateCache': '立即刷新缓存',
  'pages.frontendPages.preview.unavailable': '预览服务器（Redis）不可用，无法签发预览链接。',
  'pages.frontendPages.readOnlyHint': '没有编辑权限',
  'pages.frontendPages.loadFailed': '加载前台页面设置失败',
  'pages.frontendPages.saved': '已保存',
  'pages.frontendPages.saveFailed': '保存失败',

  // ── 前台页面设置 (M2) — 版块配置、编辑抽屉、直播日程、店铺/轮播 ──
  // fp:action
  'pages.frontendPages.action.openStorefront': '在前台查看',
  'pages.frontendPages.action.previewHint': '在新窗口中按当前状态打开页面，包含隐藏的版块。',
  // fp:(top)
  'pages.frontendPages.addSection': '添加版块',
  // fp:blocked
  'pages.frontendPages.blocked.body':
    '版块设置与卡片已保存。请修正以下原因后重新保存。您自己关闭的卡片不会列在这里。',
  'pages.frontendPages.blocked.cardAt': '{slot} · 第 {index} 张卡片 — {reason}',
  'pages.frontendPages.blocked.cardAtNoSlot': '第 {index} 张卡片 — {reason}',
  'pages.frontendPages.blocked.goToCards': '查看卡片',
  'pages.frontendPages.blocked.more': '另有 {count} 张',
  'pages.frontendPages.blocked.title': '有 {count} 张卡片当前不会出现在前台',
  // fp:cache
  'pages.frontendPages.cache.failed': '清除缓存失败。',
  'pages.frontendPages.cache.invalidated': '缓存已清除。',
  'pages.frontendPages.cacheHint': '保存后服务器缓存立即清除。前台需要刷新，且前台会缓存该响应 30 秒，这段时间内可能仍显示旧值。若 30 秒后仍看不到，请检查版块的显示开关、投放时间以及实际展示的卡片数。',
  // fp:card
  'pages.frontendPages.card.basic': '基本',
  'pages.frontendPages.card.heading': '条带文案（可选）',
  'pages.frontendPages.card.headingHint':
    '只有需要在三个主视觉格子上方显示大标题时才填写。留空则只显示格子。',
  'pages.frontendPages.card.slots': '插槽',
  'pages.frontendPages.card.source': '来源',
  'pages.frontendPages.card.style': '样式',
  // fp:heroGuide
  'pages.frontendPages.heroGuide.introTitle': '推荐页顶部的三个格子',
  'pages.frontendPages.heroGuide.intro':
    '左侧是 1 张 LIVE CHANNEL 卡片，中间是横幅轮播，右侧是人气新品和自营热销。点地图选格子，再放入图片或商品即可。',
  'pages.frontendPages.heroGuide.howTo1': '在上方地图中点要修改的格子。',
  'pages.frontendPages.heroGuide.howTo2': '在打开的步骤里放入横幅或商品。',
  'pages.frontendPages.heroGuide.howTo3': '核对右侧布局后保存。',
  'pages.frontendPages.heroGuide.mapHint': '点要改的格子，下方会打开对应步骤。',
  'pages.frontendPages.heroGuide.step1': '左侧 · LIVE CHANNEL',
  'pages.frontendPages.heroGuide.step1Short': '横幅 1 张',
  'pages.frontendPages.heroGuide.step2': '中间 · 横幅轮播',
  'pages.frontendPages.heroGuide.step2Short': '多张横幅',
  'pages.frontendPages.heroGuide.step3': '右上 · 人气新品',
  'pages.frontendPages.heroGuide.step3Short': '最多 3 件商品',
  'pages.frontendPages.heroGuide.step4': '右下 · 自营热销',
  'pages.frontendPages.heroGuide.step4Short': '最多 3 件商品',
  'pages.frontendPages.heroGuide.hint.left':
    'LIVE CHANNEL 大卡。上传横幅图并填写标题和链接。只展示 1 张。',
  'pages.frontendPages.heroGuide.hint.carousel':
    '中间滑动横幅。可新建横幅或选择已有轮播。该列表与 CS › 横幅/轮播相同。',
  'pages.frontendPages.heroGuide.hint.rightTop':
    '人气新品栏。最多放入 3 件商品。不放的话保存后系统会自动填充。栏目标题可在下方修改。',
  'pages.frontendPages.heroGuide.hint.rightBottom':
    '自营热销栏。最多放入 3 件商品。留空则由系统填充。',
  'pages.frontendPages.heroGuide.stepTitle.left': '1. 左侧 LIVE CHANNEL 卡片',
  'pages.frontendPages.heroGuide.stepTitle.carousel': '2. 中间横幅轮播',
  'pages.frontendPages.heroGuide.stepTitle.rightTop': '3. 右上 · 人气新品',
  'pages.frontendPages.heroGuide.stepTitle.rightBottom': '4. 右下 · 自营热销',
  'pages.frontendPages.heroGuide.columnTitle': '栏目标题（会显示在前台）',
  'pages.frontendPages.heroGuide.when': '何时展示',
  'pages.frontendPages.heroGuide.places': '按格子编辑内容',
  'pages.frontendPages.heroGuide.optional': '颜色与背景（可选）',
  'pages.frontendPages.heroGuide.visibleHint': '关闭后推荐页会隐藏整个主视觉区块。',
  'pages.frontendPages.heroGuide.deviceHint':
    '手机上也要显示主视觉请选“全部”。“仅 PC”时移动端不会出现该区块。',
  'pages.frontendPages.heroGuide.preview.title': '布局预览',
  'pages.frontendPages.heroGuide.preview.left': 'LIVE CHANNEL',
  'pages.frontendPages.heroGuide.preview.carousel': '中间横幅',
  'pages.frontendPages.heroGuide.preview.rightTop': '人气新品',
  'pages.frontendPages.heroGuide.preview.rightBottom': '自营热销',
  'pages.frontendPages.heroGuide.preview.leftEmpty': '请放入 1 张横幅',
  'pages.frontendPages.heroGuide.preview.carouselEmpty': '请在轮播中选择横幅',
  'pages.frontendPages.heroGuide.preview.productsEmpty': '放入商品，或留空由系统填充',
  'pages.frontendPages.heroGuide.start.left': '点击下方「添加横幅」上传 LIVE CHANNEL 图片。',
  'pages.frontendPages.heroGuide.start.rightTop': '点击「添加商品」，或留空保存后由系统填充。',
  'pages.frontendPages.heroGuide.start.rightBottom': '点击「添加商品」，或留空保存后由系统填充。',
  // fp:blockGuide
  'pages.frontendPages.blockGuide.howTo1': '先在上方选择何时展示此区块。',
  'pages.frontendPages.blockGuide.howTo2': '在下方步骤中填写标题并放入内容。',
  'pages.frontendPages.blockGuide.howTo3': '点击保存后，前台会立即生效。',
  'pages.frontendPages.blockGuide.howToMap1': '在上方地图中点要修改的格子。',
  'pages.frontendPages.blockGuide.howToMap2': '在打开的步骤里填写标题并放入内容。',
  'pages.frontendPages.blockGuide.mapHint': '点要改的格子，下方会打开对应步骤。',
  'pages.frontendPages.blockGuide.productColumns.mapHint': '点要修改的那一列。',
  'pages.frontendPages.blockGuide.ranking.mapHint': '点「今天」「3天」或「1周」来编辑该页签。',
  'pages.frontendPages.blockGuide.categoryGroups.mapHint': '点要改的分组，设置圆形图后再为该组放入圆形分类。',
  'pages.frontendPages.blockGuide.liveChance.mapHint': '点筛选芯片，放入属于它的直播。',
  'pages.frontendPages.blockGuide.when': '何时展示',
  'pages.frontendPages.blockGuide.visibleHint': '关闭后本页会隐藏整个区块。',
  'pages.frontendPages.blockGuide.deviceHint': '选「全部」时手机也会显示。选「仅 PC」时移动端不显示该区块。',
  'pages.frontendPages.blockGuide.showOnMobileHint': '关闭后手机上不绘制此分类行。',
  'pages.frontendPages.blockGuide.showLoadMoreHint': '关闭后即使还有下一页也不显示该按钮。',
  'pages.frontendPages.blockGuide.heading': '区块标题',
  'pages.frontendPages.blockGuide.heading.sellerSpotlight': '轮播上方文案',
  'pages.frontendPages.blockGuide.headingHint': '显示在前台该区块上方。留空则不绘制标题行。',
  'pages.frontendPages.blockGuide.headingHint.sellerSpotlight':
    '对应设计稿中的橙色小字「今日特价」和黑色大标题「今天不要错过」。请填在眉题和标题里。',
  'pages.frontendPages.blockGuide.headingMore': '更多标题样式（可选）',
  'pages.frontendPages.blockGuide.fill': '如何填充内容',
  'pages.frontendPages.blockGuide.fillQuestion': '自己放入，还是让系统挑选？',
  'pages.frontendPages.blockGuide.fillQuestion.sellerSpotlight': '轮播要放哪些卖家？',
  'pages.frontendPages.blockGuide.fillQuestion.reels': '要把哪些直播作为短视频展示？',
  'pages.frontendPages.blockGuide.fillHint':
    '「自己放入」只展示下方添加的内容。「系统填充」会按条件自动挑选。',
  'pages.frontendPages.blockGuide.fillHint.sellerSpotlight':
    '自己挑选时按下方卖家顺序轮播（最上面是第一张）。每行所选商品会出现在卡片下方。自动填充会使用进行中或即将开始的场次。',
  'pages.frontendPages.blockGuide.fillHint.reels': '直接挑选时，下方放入的直播按顺序展示（已结束的也会展示）。自动时按观看数从高到低填入已结束的直播。放入直播后会切换为直接挑选。',
  'pages.frontendPages.blockGuide.fillHint.storeRail':
    '直接放入：放入的店铺按顺序优先展示，剩余位置从店铺管理中开启推荐展示的其他店铺中随机填充。填充数量在下方“随机填充的店铺数”中设置，填充的店铺每天更换一次（韩国时间零点）。隐藏的店铺不会用于填充。系统填充（或未放入任何店铺）：按店铺管理顺序展示推荐店铺。',
  'pages.frontendPages.blockGuide.autoFilters': '自动挑选条件（可选）',
  'pages.frontendPages.blockGuide.source.manual': '自己放入',
  'pages.frontendPages.blockGuide.source.manual.sellerSpotlight': '从列表中挑选',
  'pages.frontendPages.blockGuide.source.manual.reels': '直接挑选直播',
  'pages.frontendPages.blockGuide.source.auto': '系统填充',
  'pages.frontendPages.blockGuide.source.auto.sellerSpotlight': '自动填入进行中/即将开始的场次',
  'pages.frontendPages.blockGuide.source.auto.reels': '已结束直播按观看数自动',
  'pages.frontendPages.blockGuide.places': '放入什么',
  'pages.frontendPages.blockGuide.places.sellerSpotlight': '轮播出场的卖家',
  'pages.frontendPages.blockGuide.places.timeSale': '作为优惠展示的直播',
  'pages.frontendPages.blockGuide.places.reels': '作为短视频展示的直播',
  'pages.frontendPages.blockGuide.optional': '颜色与背景（可选）',
  'pages.frontendPages.blockGuide.columnTitle': '栏目标题（会显示在前台）',
  'pages.frontendPages.blockGuide.groupTitle': '分组名称（显示在圆形下方）',
  'pages.frontendPages.blockGuide.chipTitle': '芯片名称',
  'pages.frontendPages.blockGuide.tabTitle': '页签名称',
  'pages.frontendPages.blockGuide.addGroup': '添加分组',
  'pages.frontendPages.blockGuide.addChip': '添加筛选芯片',
  'pages.frontendPages.blockGuide.addSlot': '添加位置',
  'pages.frontendPages.blockGuide.emptySlots': '还没有位置。请用下方按钮创建。',
  'pages.frontendPages.blockGuide.noItems': '此区块不在这里放入商品。',
  'pages.frontendPages.blockGuide.variantHint': '可选择默认、直播机会或排行卡片样式。每列可以不同。',
  'pages.frontendPages.blockGuide.initialCountHint': '打开页面时先展示的件数。',
  'pages.frontendPages.blockGuide.loadMoreCountHint': '每次点「更多」再加载的件数。',
  'pages.frontendPages.blockGuide.rankingAutoHint':
    '选择「系统填充」时，不能在今天/3天/1周页签放入商品。改回「自己放入」后可再编辑。',
  'pages.frontendPages.blockGuide.hint.productColumns': '此列最多放入 2 件商品。留空则保存后由系统填充。',
  'pages.frontendPages.blockGuide.hint.productColumns.col1': '左列。最多 2 件商品，留空则由系统填充。',
  'pages.frontendPages.blockGuide.hint.productColumns.col2': '中列。最多 2 件商品，留空则由系统填充。',
  'pages.frontendPages.blockGuide.hint.productColumns.col3': '右列。最多 2 件商品，留空则由系统填充。',
  'pages.frontendPages.blockGuide.hint.ranking':
    '该时段页签要展示的商品，最多 10 件。若选择「系统填充」，此列表不会被使用。',
  'pages.frontendPages.blockGuide.hint.ranking.today': '今日排行商品，最多 10 件。',
  'pages.frontendPages.blockGuide.hint.ranking.3d': '近 3 日排行商品，最多 10 件。',
  'pages.frontendPages.blockGuide.hint.ranking.1w': '近 1 周排行商品，最多 10 件。',
  'pages.frontendPages.blockGuide.hint.categoryGroups': '点此分组会切换右侧圆形分类。最多放入 12 个圆。',
  'pages.frontendPages.blockGuide.hint.liveChance': '填写芯片名称。若不是「全部」，请先选分类再放入直播。',
  'pages.frontendPages.blockGuide.hint.liveChance.all': '「全部」芯片。不按分类，展示所有直播。',
  'pages.frontendPages.blockGuide.start.productColumns':
    '点击「添加商品」，或留空保存后由系统填充。每列最多 2 件。',
  'pages.frontendPages.blockGuide.start.ranking': '点击「添加商品」。若选择「系统填充」，此列表不会被使用。',
  'pages.frontendPages.blockGuide.start.categoryGroups': '用下方按钮添加分类圆。图片、名称和链接是一套。',
  'pages.frontendPages.blockGuide.start.liveChance': '用下方按钮添加直播卡片。',
  'pages.frontendPages.blockGuide.start.storeRail': '放入要推荐的店铺。放入的店铺优先展示，剩余位置由系统随机填充（每天更换一次）。留空则全部由系统填充。',
  'pages.frontendPages.blockGuide.start.moreToLove': '在下方放入商品，或留空由系统填充。可在上方设定首次展示件数。',
  'pages.frontendPages.blockGuide.start.sellerSpotlight':
    '1）上方选择「从列表中挑选」。2）用「添加卖家」放入直播卖家。3）每位卖家最多选 3 个商品展示在直播页卡片上。最上面是第一张，可用左侧手柄调整顺序。',
  'pages.frontendPages.blockGuide.start.banner': '放入全宽横幅图片。',
  'pages.frontendPages.blockGuide.start.sellerRail': '放入要展示的合作卖家。',
  'pages.frontendPages.blockGuide.hint.productTabs': '填写页签名称并选择此页签的商品条件。每个页签最多 20 件商品。',
  'pages.frontendPages.blockGuide.start.productTabs': '点击下方「添加商品」放入此页签的商品。',
  'pages.frontendPages.blockGuide.hint.categoryShowcase': '选择要显示在分类行中的分类。名称和图片直接使用分类管理中登记的内容。商品在下方“按页签放商品”中，按前台的页签（精选·子分类）分别放入。',
  'pages.frontendPages.blockGuide.hint.marketShowcase': '填写标签名称并选择此平台的分类。标签图片使用所选分类的图片。',
  'pages.frontendPages.blockGuide.start.marketShowcase': '点击下方「添加外部商品」放入商品，留空则显示按分类名称搜索到的商品。',
  'pages.frontendPages.blockGuide.addMarketChip': '添加分类标签',
  'pages.frontendPages.platform.1688': '1688',
  'pages.frontendPages.platform.taobao': '淘宝',
  'pages.frontendPages.platform.vvic': 'VVIC',
  'pages.frontendPages.slots.chipPlatformMissing': '此标签没有供应平台，不会在前台显示。请选择平台。',
  'pages.frontendPages.slots.chipImageFromSearch': '暂无图片，将使用搜索结果中的商品图片。上传后也会保存到分类管理。',
  'pages.frontendPages.slots.chipCategoryImage': '标签图片',
  'pages.frontendPages.slots.chipCategoryImageSync': '与分类管理中的图片相同。修改后立即保存，两处同步更新。',
  'pages.frontendPages.slots.chipCategoryImageSaved': '分类图片已保存，分类管理中也已更新。',
  'pages.frontendPages.slots.chipCategoryImageSaveFailed': '分类图片保存失败。',
  'pages.frontendPages.slots.chipCategoryImageNoPermission': '需要分类管理编辑权限才能修改。',
  'pages.frontendPages.slots.chipCategoryImagePc': '电脑端',
  'pages.frontendPages.slots.chipCategoryImageMobile': '移动端',
  'pages.frontendPages.slots.ownChipCategoryImageSync': '与自营商城分类管理中的图片相同。修改后立即保存，两处同步更新。只设置一张时两端都使用该图片。',
  'pages.frontendPages.slots.ownChipCategoryImageEmpty': '暂无图片，将以名称首字代替显示。上传后也会保存到自营商城分类管理。',
  'pages.frontendPages.slots.ownChipCategoryImageNoPermission': '需要自营商城编辑权限才能修改。',
  'pages.frontendPages.blockGuide.addCategory': '添加分类',
  'pages.frontendPages.blockGuide.emptyCategories': '尚未添加分类，所有一级分类会自动显示。如需自行选择，请点击「添加分类」。',
  'pages.frontendPages.slots.categoryNotPicked': '未选择分类',
  'pages.frontendPages.slots.categoryMissing': '已隐藏或删除的分类',
  'pages.frontendPages.slots.categoryPlaceholder': '请选择分类',
  'pages.frontendPages.slots.categoryRequired': '请选择分类。未选择时此位置不会在前台显示。',
  'pages.frontendPages.slots.categoryMissingHint': '所选分类已隐藏或删除，此位置不会在前台显示。请选择其他分类。',
  'pages.frontendPages.slots.ownCategoryImage': '分类图片',
  'pages.frontendPages.slots.subTabs': '按页签放商品',
  'pages.frontendPages.slots.subTabsHint': '在前台点击此分类时会出现下方页签。请为每个页签分别放入要展示的商品。',
  'pages.frontendPages.slots.subTabsNone': '此分类没有子分类，前台只显示“精选”页签。子分类可在自营商城分类管理中添加。',
  'pages.frontendPages.slots.subTabBest': '精选',
  'pages.frontendPages.slots.subTabOrphan': '已失效页签',
  'pages.frontendPages.slots.subTabOrphanHint': '此页签的子分类已被隐藏、删除或移到其他分类下，前台已没有该页签。这里的商品不会显示，请把需要的商品重新放入其他页签，再从这里移除。',
  'pages.frontendPages.slots.subTabOrphanDropTitle': '要移除此页签的全部商品吗？',
  'pages.frontendPages.slots.subTabOrphanDrop': '移除此页签的 {count} 个商品',
  'pages.frontendPages.slots.subTabHint.bestAuto': '前台点击此分类时最先看到的“精选”页签。放入的商品按顺序显示；留空时自动显示该分类下的全部商品。',
  'pages.frontendPages.slots.subTabHint.bestManual': '前台点击此分类时最先看到的“精选”页签。放入的商品按顺序显示；留空时显示各子页签中放入的全部商品。',
  'pages.frontendPages.slots.subTabHint.subAuto': '前台的“{name}”页签。放入的商品按顺序显示；留空时自动显示“{name}”分类的商品。',
  'pages.frontendPages.slots.subTabHint.subManual': '前台的“{name}”页签。放入的商品按顺序显示；留空时只显示“精选”中属于“{name}”分类的商品。',
  'pages.frontendPages.slots.subTabDropConfirmTitle': '要更换分类吗？',
  'pages.frontendPages.slots.subTabDropConfirmBody': '子页签中放入的 {count} 个商品在新分类下没有对应页签，将一并移除。“精选”中的商品保持不变。',
  'pages.frontendPages.slots.subTabDropConfirmOk': '更换',
  'pages.frontendPages.slots.chipItemCount': '商品 {count} 个',
  'pages.frontendPages.blockGuide.start.categoryTabs': '点击下方「添加商品」放入商品。选择「系统填充」时会自动填充。',
  'pages.frontendPages.blockGuide.start.productGrid': '点击下方「添加商品」放入商品。选择「系统填充」时会自动填充。',
  'pages.frontendPages.blockGuide.start.productRail': '点击下方「添加商品」放入商品。选择「系统填充」时会自动填充。',
  'pages.frontendPages.blockGuide.start.coupon': '用下方按钮放入可领取的优惠券。选择「系统填充」时会自动填充。',
  'pages.frontendPages.blockGuide.start.eventTicker': '放入要在条幅中滚动的活动横幅。选择「系统填充」时会自动填充。',
  'pages.frontendPages.blockGuide.start.heroLive': '放入顶部要展示的短视频。选择「系统填充」时会自动选择。',
  'pages.frontendPages.blockGuide.start.liveNow': '放入要显示为直播中的卖家。选择「系统填充」时会自动显示正在直播的卖家。',
  'pages.frontendPages.blockGuide.start.reels': '用下方 [添加直播场次] 放入要作为短视频展示的直播（最多 12 个）。已结束的直播也可以放入。在卖家详情 → 直播商品管理中为该直播上传视频后，卡片会播放该视频。',
  'pages.frontendPages.blockGuide.start.schedule': '放入要展示的直播日程。选择「系统填充」时会按时间顺序显示即将开播的节目。',
  'pages.frontendPages.blockGuide.start.ticker': '逐张卡片放入要滚动播放的短文案，每张一行。',
  'pages.frontendPages.blockGuide.start.timeSale': '用下方 [添加直播场次] 放入要展示优惠的直播（最多 12 个），并为每张卡片设置「倒计时结束」。留空则不显示倒计时，过了时间显示「时间结束」。已结束的直播也可以放入。',
  'pages.frontendPages.blockGuide.start.sellerRanking': '放入的主播按该顺序出现在直播页，未放入的不会出现。留空则按上方排序（观看量或销量）自动填充。每位主播的展示商品留空时，使用其主页销量排行的第一个商品。',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col1': '1. 左列',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col2': '2. 中列',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col3': '3. 右列',
  'pages.frontendPages.blockGuide.stepTitle.ranking.today': '1. 今天',
  'pages.frontendPages.blockGuide.stepTitle.ranking.3d': '2. 3天',
  'pages.frontendPages.blockGuide.stepTitle.ranking.1w': '3. 1周',
  'pages.frontendPages.blockGuide.stepTitle.liveChance.all': '1. 全部',
  'pages.frontendPages.slotPurpose.heroTriple.left': '左侧 LIVE CHANNEL 大卡',
  'pages.frontendPages.slotPurpose.heroTriple.carousel': '中间横幅轮播',
  'pages.frontendPages.slotPurpose.heroTriple.rightTop': '右上人气新品',
  'pages.frontendPages.slotPurpose.heroTriple.rightBottom': '右下自营热销',
  'pages.frontendPages.slotPurpose.productColumns.col1': '左列 · 最多 2 件商品',
  'pages.frontendPages.slotPurpose.productColumns.col2': '中列 · 最多 2 件商品',
  'pages.frontendPages.slotPurpose.productColumns.col3': '右列 · 最多 2 件商品',
  'pages.frontendPages.slotPurpose.ranking.today': '今日排行',
  'pages.frontendPages.slotPurpose.ranking.3d': '近 3 日排行',
  'pages.frontendPages.slotPurpose.ranking.1w': '近 1 周排行',
  // fp:carousel
  'pages.frontendPages.carousel.actions': '操作',
  'pages.frontendPages.carousel.add': '添加轮播',
  'pages.frontendPages.carousel.addTitle': '添加轮播',
  'pages.frontendPages.carousel.delete': '删除',
  'pages.frontendPages.carousel.deleteConfirm': '确认删除此轮播？',
  'pages.frontendPages.carousel.deleteFailed': '删除失败。',
  'pages.frontendPages.carousel.deleted': '已删除。',
  'pages.frontendPages.carousel.edit': '编辑',
  'pages.frontendPages.carousel.editTitle': '编辑轮播',
  'pages.frontendPages.carousel.imageHint': '新增时仅上传桌面端图片，服务器会自动生成移动端尺寸；两张都上传则各自原样使用。修改时只替换所更换的那一张。',
  'pages.frontendPages.carousel.imageMobile': '移动端图片',
  'pages.frontendPages.carousel.imagePc': '桌面端图片',
  'pages.frontendPages.carousel.imageRequired': '至少需要上传一张图片。',
  'pages.frontendPages.carousel.isActive': '启用',
  'pages.frontendPages.carousel.link': '链接',
  'pages.frontendPages.carousel.loadFailed': '加载轮播失败。',
  'pages.frontendPages.carousel.viewPermissionRequired': '没有横幅/活动查看权限，无法加载轮播列表。',
  'pages.frontendPages.carousel.editPermissionRequired': '编辑轮播需要横幅/活动编辑权限。',
  'pages.frontendPages.carousel.newTabShort': '（新标签页）',
  'pages.frontendPages.carousel.no': '序号',
  'pages.frontendPages.carousel.openInNewTab': '新标签页',
  'pages.frontendPages.carousel.period': '期间',
  'pages.frontendPages.carousel.periodAlways': '常驻',
  'pages.frontendPages.carousel.periodHint': '留空则常驻展示。时间以韩国时间为准。',
  'pages.frontendPages.carousel.permissionHint': '保存轮播需要横幅/活动的编辑权限。',
  'pages.frontendPages.carousel.pickImage': '选择图片',
  'pages.frontendPages.carousel.sameDataHint': '此列表与 客服 › 横幅/轮播管理 是同一份数据。',
  'pages.frontendPages.carousel.saveFailed': '保存失败。',
  'pages.frontendPages.carousel.saved': '已保存。',
  'pages.frontendPages.carousel.title': '标题',
  'pages.frontendPages.carousel.subtitle': '副标题',
  'pages.frontendPages.carousel.subtitleHint':
    '在App自营商城页面的卡片中以橙色显示在标题上方。留空则不显示。',
  // fp:categoryLink
  'pages.frontendPages.categoryLink.category': '分类',
  'pages.frontendPages.categoryLink.categoryOnly1688': '淘宝和 VVIC 仅按关键词搜索，分类会被忽略。',
  'pages.frontendPages.categoryLink.companymallCategoryFirst': '请先选择分类，之后才能填写关键词。',
  'pages.frontendPages.categoryLink.companymallKeywordHint': '关键词必须与所选分类名称完全一致，否则列表会为空。',
  'pages.frontendPages.categoryLink.companymallKeywordLock': '手动输入关键词',
  'pages.frontendPages.categoryLink.companymallLiveHint': '自营商城列表仅搜索自营商城商品。直播商品请使用“直播”方式。',
  'pages.frontendPages.categoryLink.customUrl': '自定义地址',
  'pages.frontendPages.categoryLink.keyword': '关键词',
  'pages.frontendPages.categoryLink.keywordMismatch': '与所选分类名称不一致，保存将被拒绝。',
  'pages.frontendPages.categoryLink.keywordRequired': '该来源平台需要填写关键词才能生成链接。',
  'pages.frontendPages.categoryLink.mode': '链接方式',
  'pages.frontendPages.categoryLink.mode_custom': '自定义地址',
  'pages.frontendPages.categoryLink.mode_live': '直播商品',
  'pages.frontendPages.categoryLink.mode_mall': '自营商城列表',
  'pages.frontendPages.categoryLink.mode_search': '开放平台搜索',
  'pages.frontendPages.categoryLink.preview': '链接预览',
  'pages.frontendPages.categoryLink.previewEmpty': '目前还不是可打开的链接。',
  'pages.frontendPages.categoryLink.provider': '来源平台',
  'pages.frontendPages.categoryLink.provider_1688': '1688',
  'pages.frontendPages.categoryLink.provider_companymall': '自营商城',
  'pages.frontendPages.categoryLink.provider_taobao': '淘宝',
  'pages.frontendPages.categoryLink.provider_vvic': 'VVIC',
  'pages.frontendPages.categoryLink.useCategoryName': '填入分类名称',
  // fp:column
  'pages.frontendPages.column.always': '常驻',
  'pages.frontendPages.column.autoLimit': '自动 {count} 个',
  'pages.frontendPages.column.cards': '卡片',
  'pages.frontendPages.column.cardsBlocked': '另有 {count} 张因原始数据被隐藏而不显示',
  'pages.frontendPages.column.cardsHint':
    '实际会出现在前台的卡片 / 全部卡片。您关闭的卡片，以及原始数据缺失或被隐藏的卡片，不计入前一个数字。',
  'pages.frontendPages.column.device': '设备',
  'pages.frontendPages.column.order': '序号',
  'pages.frontendPages.column.period': '期间',
  'pages.frontendPages.column.section': '版块',
  'pages.frontendPages.column.slots': '插槽',
  'pages.frontendPages.column.source': '来源',
  'pages.frontendPages.column.type': '类型',
  'pages.frontendPages.column.untitled': '（无标题）',
  'pages.frontendPages.column.usedElsewhere': '其他页面',
  'pages.frontendPages.column.visible': '展示',
  // fp:delete
  'pages.frontendPages.delete.confirmBody': '版块“{key}”及其中的卡片将一并删除，且无法恢复。',
  'pages.frontendPages.delete.confirmTitle': '确认删除此版块？',
  'pages.frontendPages.delete.done': '已删除。',
  'pages.frontendPages.delete.failed': '删除失败。',
  // fp:device
  'pages.frontendPages.device.all': '全部',
  'pages.frontendPages.device.mobile': '仅移动端',
  'pages.frontendPages.device.pc': '仅桌面端',
  // fp:(top)
  'pages.frontendPages.dragDisabled': '存在搜索或筛选条件时无法调整顺序。',
  'pages.frontendPages.dragHint': '拖动手柄可调整顺序。',
  // fp:duplicate
  'pages.frontendPages.duplicate.action': '复制',
  'pages.frontendPages.duplicate.body': '要将版块“{key}”复制到哪个页面？',
  'pages.frontendPages.duplicate.done': '已复制。',
  'pages.frontendPages.duplicate.failed': '复制失败。',
  'pages.frontendPages.duplicate.hiddenNotice': '副本将以隐藏状态创建。确认后再切换为展示。',
  'pages.frontendPages.duplicate.notAllowed': '不接受此类型',
  'pages.frontendPages.duplicate.target': '目标页面',
  'pages.frontendPages.duplicate.title': '复制版块',
  'pages.frontendPages.duplicate.tooltip': '复制到其他页面',
  // fp:(top)
  'pages.frontendPages.editTitle': '编辑版块',
  // fp:emptyBanner
  'pages.frontendPages.emptyBanner.action': '导入到列表',
  'pages.frontendPages.emptyBanner.body': '此页面尚未保存任何版块。导入默认布局后即可在此编辑。',
  'pages.frontendPages.emptyBanner.title': '当前页面正在使用内置的默认布局',
  // fp:field
  'pages.frontendPages.field.accentColor': '强调色',
  'pages.frontendPages.field.autoLoadPages': '自动加载次数',
  'pages.frontendPages.field.backgroundColor': '背景色',
  'pages.frontendPages.field.badge': '标题徽章',
  'pages.frontendPages.field.device': '设备',
  'pages.frontendPages.field.eyebrow': '橙色小标题',
  'pages.frontendPages.field.fullBleed': '通栏',
  'pages.frontendPages.field.initialCount': '初始数量',
  'pages.frontendPages.field.isVisible': '展示',
  'pages.frontendPages.field.itemLimit': '展示数量',
  'pages.frontendPages.field.autoFillCount': '随机填充的店铺数',
  'pages.frontendPages.field.autoFillCountPlaceholder': '填满剩余位置',
  'pages.frontendPages.field.autoFillCountHint':
    '系统在已放入的店铺之后随机追加的店铺数。留空则填满剩余位置，填 0 则只展示已放入的店铺。开启推荐展示的店铺不足时，有多少展示多少。',
  'pages.frontendPages.field.key': '键名',
  'pages.frontendPages.field.keyHint': '只能使用小写字母、数字以及 - 和 _，且在同一页面内不能重复。',
  'pages.frontendPages.field.layout': '布局',
  'pages.frontendPages.field.loadMoreCount': '每次加载数量',
  'pages.frontendPages.field.metaText': '辅助文案',
  'pages.frontendPages.field.moreLink': '更多链接',
  'pages.frontendPages.field.moreLinkHint': '留空则不绘制“更多”按钮。',
  'pages.frontendPages.field.period': '展示期间',
  'pages.frontendPages.field.periodHint': '留空则常驻展示。时间以韩国时间为准。',
  'pages.frontendPages.field.productScope': '商品范围',
  'pages.frontendPages.field.productScopeHint': '同时用于自动排列、商品选择器以及卡片是否展示的判定。',
  'pages.frontendPages.field.salesMetric': '销量显示',
  'pages.frontendPages.field.showOnMobile': '在移动端展示',
  'pages.frontendPages.field.showLoadMore': '显示加载更多按钮',
  'pages.frontendPages.field.singleSourceModeHint': '此类型的来源是固定的。',
  'pages.frontendPages.field.sortOptions': '排序选项',
  'pages.frontendPages.field.sortOptionsHint': '留空则不显示排序下拉框。',
  'pages.frontendPages.field.sourceMode': '来源',
  'pages.frontendPages.field.subtitle': '副标题',
  'pages.frontendPages.field.textColor': '文字颜色',
  'pages.frontendPages.field.title': '标题',
  'pages.frontendPages.field.titleIconHint': '填写一个表情符号或图片地址。',
  'pages.frontendPages.field.titleIconUrl': '标题图标',
  'pages.frontendPages.field.type': '类型',
  // fp:filter
  'pages.frontendPages.filter.categories': '分类',
  'pages.frontendPages.filter.liveState': '直播状态',
  'pages.frontendPages.filter.productFlags': '商品条件',
  'pages.frontendPages.filter.searchPlaceholder': '按键名或标题搜索',
  'pages.frontendPages.filter.sellerFlags': '卖家条件',
  'pages.frontendPages.filter.sortBy': '排序',
  'pages.frontendPages.filter.type': '全部类型',
  'pages.frontendPages.filter.visibleAll': '全部',
  'pages.frontendPages.filter.visibleOff': '仅隐藏',
  'pages.frontendPages.filter.visibleOn': '仅展示',
  // fp:flag
  'pages.frontendPages.flag.isBestSeller': '热销',
  'pages.frontendPages.flag.isFeatured': '推荐',
  'pages.frontendPages.flag.isImportant': '重点',
  'pages.frontendPages.flag.isNewArrival': '新品',
  'pages.frontendPages.flag.isPoint': '积分卖家',
  'pages.frontendPages.flag.isPopular': '人气',
  // fp:gallery
  'pages.frontendPages.gallery.createFailed': '添加版块失败。',
  'pages.frontendPages.gallery.created': '已添加版块。',
  'pages.frontendPages.gallery.empty': '此页面没有可用的版块。',
  'pages.frontendPages.gallery.intro': '仅显示此页面支持的版块。选择后在编辑窗口中填写内容。',
  'pages.frontendPages.gallery.perSlot': '每个插槽 {max} 个 · 移动端 {mobile} 个',
  'pages.frontendPages.gallery.slotsFixed': '固定 {count} 个插槽 · {keys}',
  'pages.frontendPages.gallery.slotsNone': '无插槽',
  'pages.frontendPages.gallery.slotsRange': '{min}~{max} 个插槽',
  'pages.frontendPages.gallery.title': '可添加到 {page} 页面的版块',
  // fp:hiddenReason
  'pages.frontendPages.hiddenReason.coupon_inactive': '该优惠券无法领取',
  'pages.frontendPages.hiddenReason.item_hidden': '此卡片已被设为隐藏',
  'pages.frontendPages.hiddenReason.live_status_ended': '场次已结束',
  'pages.frontendPages.hiddenReason.live_status_hidden': '场次已隐藏',
  'pages.frontendPages.hiddenReason.live_status_no_product': '场次内没有商品',
  'pages.frontendPages.hiddenReason.live_status_products_hidden': '{count} 个商品已隐藏',
  'pages.frontendPages.hiddenReason.product_hidden': '商品已隐藏',
  'pages.frontendPages.hiddenReason.product_not_on_sale': '商品不在售',
  'pages.frontendPages.hiddenReason.product_out_of_scope': '不在此插槽的商品范围内',
  'pages.frontendPages.hiddenReason.sub_category_missing': '子分类页签已失效（隐藏、删除或移到其他分类）',
  'pages.frontendPages.hiddenReason.reel_hidden': '短视频已隐藏',
  'pages.frontendPages.hiddenReason.ref_missing': '关联的原始数据已不存在',
  'pages.frontendPages.hiddenReason.schedule_hidden': '节目表已隐藏',
  'pages.frontendPages.hiddenReason.store_inactive': '店铺已停用',
  'pages.frontendPages.hiddenReason.store_product_hidden': '店铺代表商品已隐藏',
  'pages.frontendPages.hiddenReason.time_sale_ended': '限时特卖已结束',
  'pages.frontendPages.hiddenReason.time_sale_hidden': '限时特卖已隐藏',
  // fp:importDefaults
  'pages.frontendPages.importDefaults.action': '导入默认布局',
  'pages.frontendPages.importDefaults.confirmBody': '将默认版块加入列表。已存在的键名会被跳过，因此不会覆盖现有配置。导入的版块会直接处于显示状态 —— 这与从图库添加或复制的版块（默认隐藏）不同。',
  'pages.frontendPages.importDefaults.confirmTitle': '要导入默认布局吗？',
  'pages.frontendPages.importDefaults.failed': '导入默认布局失败。',
  'pages.frontendPages.importDefaults.nothingNew': '没有可导入的新版块，{skipped} 个已在列表中。',
  'pages.frontendPages.importDefaults.result': '已导入 {created} 个，跳过已存在的 {skipped} 个。',
  // fp:items
  'pages.frontendPages.items.add': '添加{refType}',
  'pages.frontendPages.items.addLiveSession': '添加直播',
  'pages.frontendPages.items.addSpotlightSeller': '添加卖家',
  'pages.frontendPages.items.addPartnerSeller': '添加卖家',
  'pages.frontendPages.items.autoSellersTitle': '当前前台展示的卖家',
  'pages.frontendPages.items.autoSellersHint':
    '此版块目前按条件自动收集卖家（例如积分合作卖家）。下方列表即为直播页正在展示的卖家。添加、删除或调整顺序后保存，列表将被固定，之后不再自动变化。',
  'pages.frontendPages.items.partnerEmpty':
    '还没有卖家。请用“添加卖家”，或等待符合条件（如积分合作）的卖家自动填入。',
  'pages.frontendPages.items.pickSeller': '选择卖家',
  'pages.frontendPages.items.spotlightProductsHint':
    '直播页卡片下方展示的商品。可按名称或直播代码搜索该卖家的快捷登记和公司商城商品，最多 3 个。留空则使用场次绑定的商品。',
  'pages.frontendPages.items.spotlightTitleHint':
    '选择商品后，卡片大标题为主播名称。商品留空时显示直播日程中的场次标题。',
  'pages.frontendPages.items.rankingProductHint':
    '卡片下方展示的商品。从该主播的快捷登记或公司商城商品中选 1 个。留空则使用主播主页销量排行的第一个商品（有置顶时优先置顶）。',
  'pages.frontendPages.items.partnerProductsHint':
    '积分合作卖家卡片上与卖家一起展示的代表商品。可按名称或直播代码搜索该卖家的快捷登记和公司商城商品，最多 3 个。留空则自动展示该卖家的直播商品。',
  'pages.frontendPages.items.productTypeOwn': '公司商城',
  'pages.frontendPages.items.productTypeLive': '直播',
  'pages.frontendPages.items.spotlightLandingHint':
    '可为每个已选商品更换主图（落地图）。商品详情及其他页面卡片也会同步更新。',
  'pages.frontendPages.items.spotlightProductsPlaceholder': '选择要展示的商品',
  'pages.frontendPages.items.spotlightProductsCount': '已选 {count}/{max} 个',
  'pages.frontendPages.items.spotlightProductsLoadFailed': '无法加载卖家商品。',
  'pages.frontendPages.items.spotlightBanner': '横幅图片',
  'pages.frontendPages.items.spotlightBannerHint':
    '直播页卡片上的大图（PC 为卡片左侧，移动端为大卡片和右侧缩略图）。与卖家头像分开上传，留空则显示卖家头像。建议竖版 3:4；只上传一张时 PC 和移动端共用同一张。',
  'pages.frontendPages.items.cardImage': '卡片图片',
  'pages.frontendPages.items.partnerCardImageHint':
    '积分合作卖家卡片左侧的大图。与卖家头像分开上传，留空则显示卖家头像（头像无法打开时显示默认头像）。建议使用正方形图片。',
  'pages.frontendPages.items.cardImageHint':
    '直播页卡片上的大图。与卖家头像分开上传，留空则显示卖家头像。PC 与移动端卡片形状相同，一张即可；建议竖版（约 3:4）。',
  'pages.frontendPages.items.clipCardImageHint':
    '短视频卡片上的大图。直播有视频时网页卡片会播放视频，此图片在视频加载前及 App 中显示。留空则显示卖家头像。建议竖版（约 3:4）。',
  'pages.frontendPages.items.benefitCardImageHint':
    '直播福利卡片上的大图。设置倒计时结束时间后，图片底部会叠加倒计时条，重要文字请避开底部。留空则显示卖家头像（没有时显示主商品图片）。建议竖版（约 3:4）。',
  'pages.frontendPages.items.unlistedSpotlightProduct': '（列表中没有的商品）{id}',
  'pages.frontendPages.items.addThisSession': '加入',
  'pages.frontendPages.items.alreadyAdded': '已加入',
  'pages.frontendPages.items.advisoryHint': '卡片会展示，但其中部分内容会被略去。',
  'pages.frontendPages.items.badgeText': '徽章文案',
  'pages.frontendPages.items.blockingHint': '此卡片目前不会展示在前台。',
  'pages.frontendPages.items.changeImage': '更换图片',
  'pages.frontendPages.items.changeLanding': '更换落地图',
  'pages.frontendPages.items.clearImage': '清除',
  'pages.frontendPages.items.clearLanding': '取消落地图',
  'pages.frontendPages.items.count': '{count}/{max} 个',
  'pages.frontendPages.items.discountLabel': '折扣文案',
  'pages.frontendPages.items.empty': '暂无卡片。',
  'pages.frontendPages.items.spotlightEmpty': '还没有卖家。请点击上方的「添加卖家」。',
  'pages.frontendPages.items.spotlightLegacySession':
    '这是旧方式（从直播场次选择）的卡片。请删除后用「添加卖家」重新加入，并选择直播页商品。',
  'pages.frontendPages.items.spotlightOrderHint':
    '拖动左侧手柄可调整顺序。最上面是第一张。请在每一行选择直播页要展示的商品。',
  'pages.frontendPages.items.sessionPickerTitle': '选择要放入的直播',
  'pages.frontendPages.items.countdownEndAt': '倒计时结束',
  'pages.frontendPages.items.countdownEndAtHint': '在此时间之前卡片图片下方显示剩余时间，之后显示「时间结束」。留空则不显示倒计时。按韩国时间。',
  'pages.frontendPages.items.countdownRunning': '倒计时中',
  'pages.frontendPages.items.countdownOver': '已过 — 显示「时间结束」',
  'pages.frontendPages.items.countdownNone': '无倒计时',
  'pages.frontendPages.items.countdownPreset1h': '1小时后',
  'pages.frontendPages.items.countdownPreset6h': '6小时后',
  'pages.frontendPages.items.countdownPreset24h': '24小时后',
  'pages.frontendPages.items.countdownPreset3d': '3天后',
  'pages.frontendPages.items.benefitExtra': '蓝色活动文案（留空则用直播标语）',
  'pages.frontendPages.items.reelsSwitchedToManual': '已放入直播，已切换为「直接挑选直播」。保存后将展示所选直播。',
  'pages.frontendPages.items.sessionPickerHint': '选择要加入的直播。已经在列表中的场次不能再加。',
  'pages.frontendPages.items.sessionPickerReplaceHint': '为这一格选择另一场直播。',
  'pages.frontendPages.items.sessionPickerEmpty': '没有可挑选的进行中或即将开始的场次。请先在直播日程中创建。',
  'pages.frontendPages.items.sessionPickerAllSellers': '全部卖家',
  'pages.frontendPages.items.sessionPickerSearch': '搜索商品编号、场次标题或卖家',
  'pages.frontendPages.items.sessionPickerNoMatch': '没有符合条件的场次。',
  'pages.frontendPages.items.changeSession': '更换直播',
  'pages.frontendPages.items.useThisSession': '换成这场',
  'pages.frontendPages.items.extraOptional': '折扣/活动文案（一般不用）',
  'pages.frontendPages.items.entityReadOnly': '这些内容只能在其原始页面中修改。',
  'pages.frontendPages.items.eventLinkUrl': '活动链接',
  'pages.frontendPages.items.eventText': '活动文案',
  'pages.frontendPages.items.externalId': '外部商品编号',
  'pages.frontendPages.items.externalLinkRequired': '必须填写“平台 + 外部商品编号”或链接其中之一。',
  'pages.frontendPages.items.imageMobile': '移动端图片',
  'pages.frontendPages.items.imagePc': '桌面端图片',
  'pages.frontendPages.items.circleImage': '圆形图片',
  'pages.frontendPages.items.circleImageHint':
    '会显示在前台分类圆中。正方形照片会裁成圆形。留空则显示灰色圆。',
  'pages.frontendPages.items.circleTitle': '圆下方的名称',
  'pages.frontendPages.items.circleBadgeHint': '留空则不显示徽章。请写短文案，如 HOT。',
  'pages.frontendPages.items.landingChanged': '落地图已更换。',
  'pages.frontendPages.items.landingClearBody': '取消后，卡片将使用商品的第一张图片。',
  'pages.frontendPages.items.landingClearTitle': '即将取消落地图',
  'pages.frontendPages.items.landingCleared': '已取消落地图。',
  'pages.frontendPages.items.landingFailed': '更换落地图失败。',
  'pages.frontendPages.items.landingHint': '卡片图片使用的是商品的落地图。若只想在此版块使用其他图片，请以外部卡片方式添加。',
  'pages.frontendPages.items.landingWarnBody': '该图片会保存到商品上，同时成为商品详情页的首图，并应用于该商品出现的其他页面卡片。',
  'pages.frontendPages.items.landingWarnOk': '确认更换',
  'pages.frontendPages.items.landingWarnTitle': '即将更换落地图',
  'pages.frontendPages.items.linkPreview': '链接预览',
  'pages.frontendPages.items.linkUrl': '链接',
  'pages.frontendPages.items.liveScheduleEditLink': '前往直播日程修改 →',
  'pages.frontendPages.items.metricCaption': '文案',
  'pages.frontendPages.items.mobileLimit': '移动端仅显示前 {count} 个。',
  'pages.frontendPages.items.notImage': '只能上传图片文件。',
  'pages.frontendPages.items.openInNewTab': '在新标签页打开',
  'pages.frontendPages.items.overLimit': '已超出插槽上限（{count}/{max}）。请减少或隐藏卡片后再保存。',
  'pages.frontendPages.items.pickCoupon': '选择优惠券',
  'pages.frontendPages.items.pickLiveSession': '选择直播场次',
  'pages.frontendPages.items.pickSeller': '选择卖家',
  'pages.frontendPages.items.pickStore': '选择店铺',
  'pages.frontendPages.items.pickTimeSale': '选择限时特卖',
  'pages.frontendPages.items.pickerExcluded': '不可用于卡片',
  'pages.frontendPages.items.pickerExcludedHint':
    '本页有 {count} 个商品不符合该范围的公开条件（是否展示、商品类型），无法添加。',
  'pages.frontendPages.items.pickerImage': '图片',
  'pages.frontendPages.items.pickerLoadFailed': '加载商品列表失败。',
  'pages.frontendPages.items.productViewRequired': '需要商品管理权限，无法加载商品列表。',
  'pages.frontendPages.items.productEditRequired': '此操作需要商品编辑权限。',
  'pages.frontendPages.items.productEditDenied': '此操作需要商品编辑权限 — 图片未被更改。',
  'pages.frontendPages.items.productNamesUnavailable':
    '没有商品查看权限，卡片显示 id 而非名称。卡片本身仍会正常展示。',
  'pages.frontendPages.items.sellerViewRequired': '需要直播卖家查看权限，无法加载卖家列表。',
  'pages.frontendPages.items.pickerProduct': '商品',
  'pages.frontendPages.items.pickerProductNo': '货号',
  'pages.frontendPages.items.pickerScopeHint': '仅显示{scope}范围内在售的商品。',
  'pages.frontendPages.items.pickerSearch': '按商品名称或货号搜索',
  'pages.frontendPages.items.pickerTitle': '选择商品',
  'pages.frontendPages.items.platform': '平台',
  'pages.frontendPages.items.price': '价格',
  'pages.frontendPages.items.rankDelta': '排名变化',
  'pages.frontendPages.items.rankDeltaPlaceholder': 'NEW / +2',
  'pages.frontendPages.items.rawRefHint': '暂无专用选择器，请从对应的管理页面复制 ID 填入。',
  'pages.frontendPages.items.reelId': '短视频 ID',
  'pages.frontendPages.items.remove': '删除',
  'pages.frontendPages.items.salePrice': '折后价',
  'pages.frontendPages.items.scheduleId': '节目表 ID',
  'pages.frontendPages.items.sessionHidden': '隐藏',
  'pages.frontendPages.items.sessionProducts': '{count} 个商品',
  'pages.frontendPages.items.storeCopyHint':
    '图片、名称、宣传文案和代表商品请在店铺管理中修改。卡片图片下方的蓝色一行是活动文案（点击打开活动链接），其下的黑色一行是徽章文案。二者仅作用于本区块。',
  'pages.frontendPages.items.storeEventLinkHint':
    '点击活动文案会打开这个地址。文案为空时，卡片会显示“活动”链接。',
  'pages.frontendPages.items.storeBadgeHint':
    '以黑色文字显示在卡片图片下方、活动文案的下一行。留空时显示店铺管理中的宣传文案。',
  'pages.frontendPages.items.storeEditLink': '前往店铺管理修改 →',
  'pages.frontendPages.items.storeEventText': '活动文案（仅本区块）',
  'pages.frontendPages.items.storeFeatured': '推荐展示',
  'pages.frontendPages.items.storeInactive': '停用',
  'pages.frontendPages.items.subtitle': '卡片副标题',
  'pages.frontendPages.items.timeSaleHidden': '隐藏',
  'pages.frontendPages.items.title': '卡片标题',
  'pages.frontendPages.items.tooLarge': '文件过大。',
  'pages.frontendPages.items.upload': '上传图片',
  'pages.frontendPages.items.uploadFailed': '图片上传失败。',
  'pages.frontendPages.items.uploadSuccess': '图片已上传。',
  'pages.frontendPages.items.usedElsewhere': '其他 {count} 个页面',
  // fp:layout
  'pages.frontendPages.layout.banner': '横幅',
  'pages.frontendPages.layout.grid': '网格',
  'pages.frontendPages.layout.hero': '主视觉',
  'pages.frontendPages.layout.list': '列表',
  'pages.frontendPages.layout.rail': '横向滚动',
  // fp:liveState
  'pages.frontendPages.liveState.all': '全部',
  'pages.frontendPages.liveState.live': '直播中',
  'pages.frontendPages.liveState.recent': '近期直播',
  'pages.frontendPages.liveState.scheduled': '即将开播',
  // fp:(top)
  'pages.frontendPages.metaMissing': '未能加载版块规则，无法保存。请稍后重新打开。',
  'pages.frontendPages.loadErrorNotice': '未能读取当前值，已锁定表单。此时保存会用空值覆盖 SEO 文案。请先重新加载再编辑。',
  'pages.frontendPages.loadErrorNoticeSite': '未能读取当前值，已锁定表单。此时保存会清空三种语言的标语，并把 Kakao 咨询链接还原为默认值；站点保存会清除所有页面的缓存，这些空值会立刻出现在页头。请先重新加载再编辑。',
  // fp:preview
  'pages.frontendPages.preview.autoHint': '此为自动排列，实际卡片将在保存后按规则填充。',
  'pages.frontendPages.preview.blocked': '此页面不允许嵌入框架，请在新窗口中打开查看。',
  'pages.frontendPages.preview.deviceHidden': '此设备上不展示',
  'pages.frontendPages.preview.deviceMobile': '移动端 {width}',
  'pages.frontendPages.preview.devicePc': '桌面 {width}',
  'pages.frontendPages.preview.emptySlot': '无卡片',
  'pages.frontendPages.preview.failed': '生成预览链接失败。',
  'pages.frontendPages.preview.frameTitle': '页面预览',
  'pages.frontendPages.preview.includeHidden': '包含隐藏',
  'pages.frontendPages.preview.includeHiddenHint': '开启后连隐藏的版块和卡片也一并渲染，访客仍看不到。',
  'pages.frontendPages.preview.mobile': '移动端',
  'pages.frontendPages.preview.mobileCut': '移动端不显示',
  'pages.frontendPages.preview.more': '更多',
  'pages.frontendPages.preview.noTitle': '（无标题）',
  'pages.frontendPages.preview.openNewWindow': '在新窗口打开',
  'pages.frontendPages.preview.originConfirmed': '当前框内地址：{origin} —— 已由后端预览响应确认。',
  'pages.frontendPages.preview.originSeed': '当前框内地址：{origin} —— 来自管理端构建注入的值。打开一次“包含隐藏”即可与后端实际使用的地址对齐。',
  'pages.frontendPages.preview.pc': '桌面端',
  'pages.frontendPages.preview.sectionHidden': '隐藏',
  'pages.frontendPages.preview.title': '卡片预览',
  // fp:(top)
  'pages.frontendPages.previewFailed': '生成预览链接失败。',
  'pages.frontendPages.previewUnavailable': '预览服务器（Redis）不可用，无法签发链接。',
  // fp:productScope
  'pages.frontendPages.productScope.all': '全部商品',
  'pages.frontendPages.productScope.live': '直播商品',
  'pages.frontendPages.productScope.own': '自营商城商品',
  // fp:(top)
  'pages.frontendPages.readOnlyNotice': '只读模式。可以查看内容，但无法保存。',
  // fp:refType
  'pages.frontendPages.refType.banner': '横幅',
  'pages.frontendPages.refType.categoryLink': '分类链接',
  'pages.frontendPages.refType.coupon': '优惠券',
  'pages.frontendPages.refType.external': '外部商品',
  'pages.frontendPages.refType.liveStatus': '直播场次',
  'pages.frontendPages.refType.metric': '文案行',
  'pages.frontendPages.refType.product': '商品',
  'pages.frontendPages.refType.reel': '短视频',
  'pages.frontendPages.refType.schedule': '节目表',
  'pages.frontendPages.refType.seller': '卖家',
  'pages.frontendPages.refType.store': '店铺',
  'pages.frontendPages.refType.timeSale': '限时特卖',
  // fp:(top)
  'pages.frontendPages.reorderFailed': '调整顺序失败。',
  'pages.frontendPages.reload': '重新加载',
  'pages.frontendPages.reordered': '顺序已更新。',
  // fp:salesMetric
  'pages.frontendPages.salesMetric.hidden': '不显示',
  'pages.frontendPages.salesMetric.liveSoldAmountSum': '直播销售金额',
  'pages.frontendPages.salesMetric.totalItemsSold': '累计销售件数',
  // fp:(top)
  'pages.frontendPages.saveAndPreview': '保存并预览页面',
  'pages.frontendPages.saveBlockedByLoad': '未能读取当前值，请先重新加载再保存。',
  'pages.frontendPages.savedWithAdvisory': '有 {count} 张卡片的部分商品未显示。',
  // fp:schedule
  'pages.frontendPages.schedule.addSession': '添加场次',
  'pages.frontendPages.schedule.assignTime': '设置时间',
  'pages.frontendPages.schedule.assignTimeTitle': '设置开始时间',
  'pages.frontendPages.schedule.cancel': '取消',
  'pages.frontendPages.schedule.column.actions': '操作',
  'pages.frontendPages.schedule.column.date': '日期',
  'pages.frontendPages.schedule.column.productCount': '商品数',
  'pages.frontendPages.schedule.column.seller': '卖家',
  'pages.frontendPages.schedule.column.source': '来源',
  'pages.frontendPages.schedule.column.time': '时间',
  'pages.frontendPages.schedule.column.title': '标题',
  'pages.frontendPages.schedule.column.visible': '显示',
  'pages.frontendPages.schedule.convert': '转为场次',
  'pages.frontendPages.schedule.convertHideFailed': '场次已创建，但未能隐藏旧日程。',
  'pages.frontendPages.schedule.convertHint': '用这条旧日程的内容创建新场次。',
  'pages.frontendPages.schedule.convertNotice': '保存后将创建新场次，并隐藏原有旧日程。',
  'pages.frontendPages.schedule.convertSuccess': '已转为场次。',
  'pages.frontendPages.schedule.delete': '删除',
  'pages.frontendPages.schedule.deleteConfirm': '要删除此日程吗？',
  'pages.frontendPages.schedule.deleteContentLegacy': '旧日程删除后无法恢复。',
  'pages.frontendPages.schedule.deleteContentSession': '删除后，该场次也会从前台的聚光位中消失。',
  'pages.frontendPages.schedule.deleteFailed': '删除失败。',
  'pages.frontendPages.schedule.deleteSuccess': '已删除。',
  'pages.frontendPages.schedule.edit': '编辑',
  'pages.frontendPages.schedule.editLegacy': '编辑旧日程',
  'pages.frontendPages.schedule.editSession': '编辑场次',
  'pages.frontendPages.schedule.emptyDay': '无',
  'pages.frontendPages.schedule.field.endAt': '结束时间',
  'pages.frontendPages.schedule.field.endAtPlaceholder': '选择结束时间',
  'pages.frontendPages.schedule.field.mainImage': '聚光位大图',
  'pages.frontendPages.schedule.field.mainImageHint': '聚光位中大幅展示的竖版图片，建议使用 3:4 比例。',
  'pages.frontendPages.schedule.field.periodHint': '以韩国时间为准。创建时不填开始时间会保存为“时间待定”。但已填写的开始时间无法在此清除 —— 清空后保存，服务器上原有的时间仍会保留。如需取消直播，请关闭其显示或删除该场次。',
  'pages.frontendPages.schedule.field.products': '直播商品',
  'pages.frontendPages.schedule.field.productsHint': '最多可挑选 3 件商品用于聚光位，按挑选顺序展示。',
  'pages.frontendPages.schedule.field.seller': '卖家',
  'pages.frontendPages.schedule.field.sellerPlaceholder': '按卖家名称或编号搜索',
  'pages.frontendPages.schedule.field.slogan': '标语',
  'pages.frontendPages.schedule.field.sloganHint': '叠加在聚光位图片上的短句。',
  'pages.frontendPages.schedule.field.sloganPlaceholder': '例如：仅限今日的价格',
  'pages.frontendPages.schedule.field.spotlightLabel': '聚光位标签',
  'pages.frontendPages.schedule.field.spotlightLabelHint': '显示在聚光位上方的短标签。',
  'pages.frontendPages.schedule.field.spotlightLabelPlaceholder': '例如：今日直播',
  'pages.frontendPages.schedule.field.startAt': '开始时间',
  'pages.frontendPages.schedule.field.startAtPlaceholder': '选择开始时间',
  'pages.frontendPages.schedule.field.thumbnail': '直播机会卡图片',
  'pages.frontendPages.schedule.field.thumbnailHint': '直播机会卡使用的方形图片，建议使用 1:1 比例。',
  'pages.frontendPages.schedule.field.title': '直播标题',
  'pages.frontendPages.schedule.field.titlePlaceholder': '输入直播标题',
  'pages.frontendPages.schedule.field.visible': '显示',
  'pages.frontendPages.schedule.filteredByDate': '仅看 {date}',
  'pages.frontendPages.schedule.intro': '这里是前台直播页展示的直播日程。',
  'pages.frontendPages.schedule.introDetail': '日期格显示十天，从今天前 3 天到今天后 6 天。场次与旧日程一并显示，所有时间均以韩国时间为准。',
  'pages.frontendPages.schedule.legacyHint': '这是卖家预先填写的旧日程，仅可修改标题、时间和显示状态。',
  'pages.frontendPages.schedule.legacyUnavailable': '未能加载旧日程列表，当前仅显示场次。',
  'pages.frontendPages.schedule.loadFailed': '日程加载失败。',
  'pages.frontendPages.schedule.missingAlert': '有 {count} 个场次未设置开始时间。',
  'pages.frontendPages.schedule.missingChipHint': '点击筛选',
  'pages.frontendPages.schedule.missingHint': '未设置开始时间的场次不会归入任何日期格。设置开始时间后即可归入对应日期。以韩国时间为准。',
  'pages.frontendPages.schedule.missingOnly': '仅看时间待定',
  'pages.frontendPages.schedule.nextWeek': '下一周',
  'pages.frontendPages.schedule.prevWeek': '上一周',
  'pages.frontendPages.schedule.productPicker.empty': '尚未添加商品。',
  'pages.frontendPages.schedule.productPicker.excluded': '卡片中排除',
  'pages.frontendPages.schedule.productPicker.excludedHint': '该商品已隐藏或非在售，不会显示在前台卡片中。',
  'pages.frontendPages.schedule.productPicker.limit': '最多可添加 {max} 件商品。',
  'pages.frontendPages.schedule.productPicker.moveDown': '下移',
  'pages.frontendPages.schedule.productPicker.moveUp': '上移',
  'pages.frontendPages.schedule.productPicker.remove': '移除',
  'pages.frontendPages.schedule.productPicker.search': '按商品名或商品编号搜索',
  'pages.frontendPages.schedule.readOnly':
    '当前为只读。编辑需要前端页面编辑或直播卖家编辑权限。',
  'pages.frontendPages.schedule.uploadNoPermission': '上传图片需要商品编辑权限。',
  'pages.frontendPages.schedule.productPicker.noPermission': '没有商品管理权限，无法选择商品。',
  'pages.frontendPages.schedule.refresh': '刷新',
  'pages.frontendPages.schedule.save': '保存',
  'pages.frontendPages.schedule.saveFailed': '保存失败。',
  'pages.frontendPages.schedule.saveSuccess': '已保存。',
  'pages.frontendPages.schedule.sellerFilterAll': '全部卖家',
  'pages.frontendPages.schedule.source.legacy': '旧日程',
  'pages.frontendPages.schedule.source.missing': '时间待定',
  'pages.frontendPages.schedule.source.session': '场次',
  'pages.frontendPages.schedule.stripHint': '点击某一格即可只看该日期。以韩国时间为准。',
  'pages.frontendPages.schedule.stripTitle': '按日期查看直播',
  'pages.frontendPages.schedule.tableEmpty': '暂无日程。',
  'pages.frontendPages.schedule.today': '今天',
  'pages.frontendPages.schedule.todayBadge': '今天',
  'pages.frontendPages.schedule.upload': '上传图片',
  'pages.frontendPages.schedule.uploadChange': '更换图片',
  'pages.frontendPages.schedule.uploadClear': '清除',
  'pages.frontendPages.schedule.uploadFailed': '图片上传失败。',
  'pages.frontendPages.schedule.uploadNotImage': '仅允许上传图片文件。',
  'pages.frontendPages.schedule.uploadSuccess': '图片已上传。',
  'pages.frontendPages.schedule.uploadTooLarge': '图片大小不能超过 10MB。',
  'pages.frontendPages.schedule.validate.periodOrder': '结束时间必须晚于开始时间。',
  'pages.frontendPages.schedule.validate.productRequired': '请至少挑选一件商品。',
  'pages.frontendPages.schedule.validate.sellerRequired': '请选择卖家。',
  'pages.frontendPages.schedule.validate.startRequired': '请选择开始时间。',
  'pages.frontendPages.schedule.validate.titleRequired': '请输入标题。',
  'pages.frontendPages.schedule.visibleUpdateFailed': '修改显示设置失败。',
  // fp:sectionType
  'pages.frontendPages.sectionType.banner.desc': '单张图片的条幅横幅。',
  'pages.frontendPages.sectionType.banner.name': '横幅',
  'pages.frontendPages.sectionType.categoryGroups.desc': '将分类链接卡片按组（插槽）展示，1~10 个插槽。',
  'pages.frontendPages.sectionType.categoryGroups.name': '分类组',
  'pages.frontendPages.sectionType.categoryTabs.desc': '点击分类标签可切换下方的商品列表。',
  'pages.frontendPages.sectionType.categoryTabs.name': '分类标签',
  'pages.frontendPages.sectionType.coupon.desc': '排列可领取的优惠券卡片。',
  'pages.frontendPages.sectionType.coupon.name': '优惠券',
  'pages.frontendPages.sectionType.eventTicker.desc': '活动横幅在窄条中滚动播放。',
  'pages.frontendPages.sectionType.eventTicker.name': '活动滚动条',
  'pages.frontendPages.sectionType.heroLive.desc': '直播页面顶部的大幅短视频。',
  'pages.frontendPages.sectionType.heroLive.name': '直播主视觉',
  'pages.frontendPages.sectionType.heroTriple.desc': '首屏分为左侧大图、轮播和右上右下两格，仅支持手动排列。',
  'pages.frontendPages.sectionType.heroTriple.name': '三分主视觉',
  'pages.frontendPages.sectionType.liveChance.desc': '按标签划分的直播场次卡片。第一个标签固定为“全部”，最多 6 个标签。',
  'pages.frontendPages.sectionType.liveChance.name': '直播机会',
  'pages.frontendPages.sectionType.liveNow.desc': '横向排列正在直播的卖家。',
  'pages.frontendPages.sectionType.liveNow.name': '正在直播',
  'pages.frontendPages.sectionType.moreToLove.desc': '位于页面底部、可持续加载的商品网格，最多 60 个。',
  'pages.frontendPages.sectionType.moreToLove.name': '猜你喜欢',
  'pages.frontendPages.sectionType.productColumns.desc': '三列，每列放置两个商品，仅支持手动排列。',
  'pages.frontendPages.sectionType.productColumns.name': '商品三列',
  'pages.frontendPages.sectionType.productGrid.desc': '以网格形式铺开商品卡片。',
  'pages.frontendPages.sectionType.productGrid.name': '商品网格',
  'pages.frontendPages.sectionType.productRail.desc': '商品卡片以单行横向滚动展示。',
  'pages.frontendPages.sectionType.productRail.name': '商品横排',
  'pages.frontendPages.sectionType.ranking.desc': '分为今日 / 3 天 / 1 周三个标签的排行榜。每个插槽 10 个，移动端 4 个。',
  'pages.frontendPages.sectionType.ranking.name': '排行榜',
  'pages.frontendPages.sectionType.reels.desc': '与直播机会相同的直播卡片（蓝色短视频标记），可横向滑动。最多 12 个。',
  'pages.frontendPages.sectionType.reels.name': '短视频',
  'pages.frontendPages.sectionType.schedule.desc': '按时间顺序排列即将开播的节目。',
  'pages.frontendPages.sectionType.schedule.name': '直播节目表',
  'pages.frontendPages.sectionType.sellerRail.desc': '横向排列卖家资料卡，可选择显示哪种销量数据。',
  'pages.frontendPages.sectionType.sellerRail.name': '卖家横排',
  'pages.frontendPages.sectionType.sellerRanking.desc': '带排名标记的主播直播卡片。放入主播则按该顺序，留空则按累计观看或销量自动排序，最多 20 位。',
  'pages.frontendPages.sectionType.sellerRanking.name': '人气 BEST 主播',
  'pages.frontendPages.sectionType.sellerSpotlight.desc':
    '以竖版大图展示直播卖家。可为每位卖家选择展示商品。最多 10 个。',
  'pages.frontendPages.sectionType.sellerSpotlight.name': '直播卖家轮播',
  'pages.frontendPages.sectionType.storeRail.desc': '横向排列店铺卡片，最多 12 个。',
  'pages.frontendPages.sectionType.storeRail.name': '推荐店铺',
  'pages.frontendPages.sectionType.productTabs.desc': '每个标签（页签）带有各自商品条件的商品行。1～8 个页签，每个最多 20 个。',
  'pages.frontendPages.sectionType.productTabs.name': '商品页签',
  'pages.frontendPages.sectionType.categoryShowcase.desc': '分类行加所选分类的子页签和商品行。最多 12 个分类；留空时显示所有一级分类。商品按子页签分别放入。',
  'pages.frontendPages.sectionType.categoryShowcase.name': '分类展示',
  'pages.frontendPages.sectionType.marketShowcase.desc': '供应平台页签（1688 · 淘宝 · VVIC）加平台分类标签、子页签和商品行。每个平台最多 20 个标签；没有卡片的标签会按分类名称在该平台搜索。',
  'pages.frontendPages.sectionType.marketShowcase.name': '平台分类商品',
  'pages.frontendPages.sectionType.ticker.desc': '短文案滚动播放的条幅，仅支持手动排列。',
  'pages.frontendPages.sectionType.ticker.name': '文字滚动条',
  'pages.frontendPages.sectionType.timeSale.desc': '优惠卡片：直播卡片图片下方带倒计时条，每张卡片单独设置结束时间。最多 12 个。',
  'pages.frontendPages.sectionType.timeSale.name': '直播优惠',
  // fp:settings
  'pages.frontendPages.settings.notSavedYet': '此页面尚未保存设置，当前显示的是默认值。',
  'pages.frontendPages.settings.previewCard': '预览',
  'pages.frontendPages.settings.seoCard': '搜索展示',
  'pages.frontendPages.settings.seoDescription': '页面描述',
  'pages.frontendPages.settings.seoDescriptionHint': '显示在搜索结果标题下方，约两行为宜。',
  'pages.frontendPages.settings.seoTitle': '页面标题',
  'pages.frontendPages.settings.seoTitleHint': '用于浏览器标签页和搜索结果标题。',
  // fp:site
  'pages.frontendPages.site.advanced': '高级',
  'pages.frontendPages.site.categoryLimit.en': '英语',
  'pages.frontendPages.site.categoryLimit.ko': '韩语',
  'pages.frontendPages.site.categoryLimit.zh': '中文',
  'pages.frontendPages.site.categoryLimitHint': '页头展示的分类数量。各语言名称长度不同，因此分别设置。',
  'pages.frontendPages.site.categorySourceHint': '分类本身请在商品管理 › 分类中修改。',
  'pages.frontendPages.site.headerTagline': '页头标语',
  'pages.frontendPages.site.headerTaglineHint': '显示在页头顶部，页面滚动后会隐藏。',
  'pages.frontendPages.site.headerTaglineMobile': '移动端标语（可选）',
  'pages.frontendPages.site.headerTaglineMobileHint': '留空则沿用上方标语。移动端宽度有限，请尽量简短。',
  'pages.frontendPages.site.headerTaglinePlaceholder': '例如：每天都有最低价的直播购物',
  'pages.frontendPages.site.kakaoInquiryUrl': 'KakaoTalk 咨询链接',
  'pages.frontendPages.site.kakaoInquiryUrlHint': '页头和页脚的咨询按钮将打开此地址。',
  'pages.frontendPages.site.notSavedYet': '尚未保存通用设置，当前显示的是默认值。',
  'pages.frontendPages.site.scopeNotice': '此处的修改将应用于所有页面。',
  'pages.frontendPages.site.urlWarning': '这不是以 http:// 或 https:// 开头的地址。',
  // fp:slotKey
  'pages.frontendPages.slotKey.1w': '1 周',
  'pages.frontendPages.slotKey.3d': '3 天',
  'pages.frontendPages.slotKey.all': '全部',
  'pages.frontendPages.slotKey.carousel': '轮播',
  'pages.frontendPages.slotKey.col1': '第 1 列',
  'pages.frontendPages.slotKey.col2': '第 2 列',
  'pages.frontendPages.slotKey.col3': '第 3 列',
  'pages.frontendPages.slotKey.left': '左侧大图',
  'pages.frontendPages.slotKey.rightBottom': '右下',
  'pages.frontendPages.slotKey.rightTop': '右上',
  'pages.frontendPages.slotKey.today': '今日',
  // fp:slotVariant
  'pages.frontendPages.slotVariant.chance': '直播机会',
  'pages.frontendPages.slotVariant.plain': '默认',
  'pages.frontendPages.slotVariant.ranking': '排行',
  'pages.frontendPages.slotVariant.store': '店铺',
  // fp:autoFill
  'pages.frontendPages.autoFill.title': '空位将由系统自动填充',
  'pages.frontendPages.autoFill.body':
    '这里还没有卡片。保存后服务器会按条件自动填充。若要手动挑选，请用下方按钮添加。',
  'pages.frontendPages.autoFill.tab': '自动',
  // fp:slots
  'pages.frontendPages.slots.allChipHint': '第一个标签是“全部”，不设分类，展示所有场次。',
  'pages.frontendPages.slots.allChipLocked': '“全部”标签不可删除。',
  'pages.frontendPages.slots.badgeText': '徽章',
  'pages.frontendPages.slots.chipCategories': '此标签的分类',
  'pages.frontendPages.slots.chipCategoryHint': '自动模式按场次商品的分类进行筛选。快速登记的商品可能没有分类，建议手动指定。',
  'pages.frontendPages.slots.tabFlags': '此页签的商品条件',
  'pages.frontendPages.slots.tabFlagsHint': '自动模式下，满足所有所选条件的商品会显示在此页签。留空则仅应用版块条件。',
  'pages.frontendPages.slots.chipRootCategory': '分类',
  'pages.frontendPages.slots.chipRootCategoryHint': '只能选择一级分类。前台子页签由该分类的子分类自动生成，各页签的商品在下方放入。',
  'pages.frontendPages.slots.chipPlatform': '此标签的供应平台',
  'pages.frontendPages.slots.chipMarketCategory': '分类',
  'pages.frontendPages.slots.chipMarketCategorySearch': '按分类名称搜索',
  'pages.frontendPages.slots.chipMarketCategoryHint': '列出分类管理中带子分类的分类（可按名称搜索）。子页签由其子分类自动生成；没有卡片时显示按分类名称搜索的商品。留空则按标签名称搜索。',
  'pages.frontendPages.items.importLink': '商品链接',
  'pages.frontendPages.items.importLinkAction': '获取',
  'pages.frontendPages.items.importLinkHint': '粘贴 1688 / 淘宝 / VVIC 商品链接并点击获取，即可填入平台、商品 id、标题、图片和价格。下方字段仍可手动修改。',
  'pages.frontendPages.items.importLinkInvalid': '不是 1688 / 淘宝 / VVIC 的商品链接。',
  'pages.frontendPages.items.importLinkDone': '已获取商品信息。',
  'pages.frontendPages.items.importLinkFailed': '获取商品信息失败。',
  'pages.frontendPages.slots.chipCategoryRequired': '自动模式至少需要选择一个分类。留空时该标签与“全部”展示相同的列表。',
  'pages.frontendPages.slots.duplicateKey': '该插槽键名已存在。',
  'pages.frontendPages.slots.iconUrl': '图标',
  'pages.frontendPages.slots.iconUrlHint': '前台会把该地址渲染为图片。请填写图片 URL，不要填表情符号。',
  'pages.frontendPages.slots.groupImage': '分组圆形图',
  'pages.frontendPages.slots.groupImageHint':
    '显示在前台分组圆上。正方形照片会裁成圆形。留空则在圆内显示名称。',
  'pages.frontendPages.slots.key': '插槽键名',
  'pages.frontendPages.slots.legacyNoSlots': '此版块尚无插槽。保存插槽后，现有卡片会归入第一个插槽；若超过单插槽上限，保存将被拒绝。',
  'pages.frontendPages.slots.minSlots': '至少需要 {min} 个插槽。',
  'pages.frontendPages.slots.moveLeft': '← 前移',
  'pages.frontendPages.slots.moveRight': '后移 →',
  'pages.frontendPages.slots.noItemsSection': '此版块不放置卡片，而是按规则从其他页面拉取数据。',
  'pages.frontendPages.slots.noItemsSlot': '此插槽不放置卡片。',
  'pages.frontendPages.slots.pickTypeFirst': '请先选择类型。',
  'pages.frontendPages.slots.productScope': '商品范围',
  'pages.frontendPages.slots.rankingAutoHint': '自动模式下期间标签（今日 / 3 天 / 1 周）不放置卡片。以下数值仅可查看，切换到手动模式后可继续编辑。',
  'pages.frontendPages.slots.scopeInherit': '沿用版块设置',
  'pages.frontendPages.slots.title': '标签',
  'pages.frontendPages.slots.subtitle': '副标题',
  'pages.frontendPages.slots.titleMobile': '移动端标签',
  'pages.frontendPages.slots.variant': '卡片样式',
  // fp:sortBy
  'pages.frontendPages.sortBy.price_asc': '价格从低到高',
  'pages.frontendPages.sortBy.price_desc': '价格从高到低',
  'pages.frontendPages.sortBy.rank': '推荐',
  'pages.frontendPages.sortBy.recent': '最新',
  'pages.frontendPages.sortBy.sold': '销量',
  'pages.frontendPages.sortBy.views': '观看量',
  // fp:sourceMode
  'pages.frontendPages.sourceMode.auto': '自动规则',
  'pages.frontendPages.sourceMode.manual': '手动排列',
  // fp:(top)
  'pages.frontendPages.typeChangeConfirmBody': '新类型不支持的 {count} 张卡片以及当前插槽配置将一并移除，且无法撤销。',
  'pages.frontendPages.typeChangeConfirmOk': '确认更改',
  'pages.frontendPages.typeChangeConfirmTitle': '更改板块类型',
  'pages.frontendPages.typeChangeDroppedItems': '新类型不支持的卡片已从列表中移除。',
  // fp:usedElsewhere
  'pages.frontendPages.unsaved.blockedNote': '还有 {count} 张不会出现在前台的卡片。',
  'pages.frontendPages.unsaved.body': '关闭后本次修改将丢失。仍要关闭吗？',
  'pages.frontendPages.unsaved.discard': '关闭',
  'pages.frontendPages.unsaved.keepEditing': '继续编辑',
  'pages.frontendPages.unsaved.title': '有尚未保存的修改',
  'pages.frontendPages.usedElsewhere.badge': '其他 {count} 个页面',
  'pages.frontendPages.usedElsewhere.failed': '未能读取其他页面的列表。',
  'pages.frontendPages.usedElsewhere.hint': '同一商品或店铺出现在多个页面。在此处删除不会影响其他页面。',
  'pages.frontendPages.usedElsewhere.pagesOnly': '目前仅显示页面，具体版块稍后展示。',
  'pages.frontendPages.usedElsewhere.retry': '重试',
  'pages.frontendPages.usedElsewhere.title': '这些卡片还出现在',
  // fp:validation
  'pages.frontendPages.validation.captionRequired': '请填写{card}的文案。',
  'pages.frontendPages.validation.cardAt': '{slot} · 第 {index} 张卡片',
  'pages.frontendPages.validation.cardAtNoSlot': '第 {index} 张卡片',
  'pages.frontendPages.validation.chipCategoryRequired': '标签“{slot}”至少需要选择一个分类。',
  'pages.frontendPages.validation.externalHalf': '{card}需要同时填写平台和外部商品编号。',
  'pages.frontendPages.validation.externalLink': '{card}没有可打开的链接。',
  'pages.frontendPages.validation.imageRequired': '请为{card}添加图片。',
  'pages.frontendPages.validation.linkRequired': '请设置{card}的链接目标。',
  'pages.frontendPages.validation.overLimit': '该版块的卡片已超出上限（{count}/{max}）。',
  'pages.frontendPages.validation.refRequired': '请为{card}选择关联对象。',
  'pages.frontendPages.validation.slotOverLimit': '插槽“{slot}”的卡片已超出上限（{count}/{max}）。',
  'pages.frontendPages.validation.sectionOverLimit': '此区块最多可放 {max} 张卡片（当前 {count} 张）。',
  'pages.frontendPages.validation.titleRequired': '请为{card}填写标题。',
  'pages.frontendPages.validation.unknownType': '未找到该类型的规则。',
  // fp:(top)
  'pages.frontendPages.viewOnlyTooltip': '以只读方式打开。可以查看内容，但无法保存。',
  // bannerAdvertisement:carousel
  'pages.bannerAdvertisement.carousel.openInNewTab': '新标签页',
  'pages.bannerAdvertisement.carousel.pageKey': '页面',
  'pages.bannerAdvertisement.carousel.pageKeyAll': '全部页面',
  'pages.bannerAdvertisement.carousel.pageKeyHome': '推荐',
  'pages.bannerAdvertisement.carousel.pageKeyLive': '直播',
  'pages.bannerAdvertisement.carousel.pageKeyOverseas': '海外直购',
  'pages.bannerAdvertisement.carousel.pageKeyOwnmall': '自营商城',
  'pages.bannerAdvertisement.carousel.pageKeyTooltip': '此横幅所属的公开页面。',
  'pages.bannerAdvertisement.carousel.period': '展示期间',
  'pages.bannerAdvertisement.carousel.periodAlways': '常驻',
  'pages.bannerAdvertisement.carousel.periodTooltip': '留空则常驻展示。时间以韩国时间为准。',
  // products:add
  'pages.products.add.landingImage': '落地代表图（可选）',
  'pages.products.add.landingImageAfterCreate': '将在保存商品后一并生效。',
  'pages.products.add.landingImageChange': '更换图片',
  'pages.products.add.landingImageClear': '取消',
  'pages.products.add.landingImageHeavy': '图片过大，建议上传更小的图片。',
  'pages.products.add.landingImageHint': '用于推荐和直播卡片以及详情页首图。留空则使用商品的第一张图片。',
  'pages.products.add.landingImageNotImage': '只能上传图片文件',
  'pages.products.add.landingImageRecommend': '推荐',
  'pages.products.add.landingImageSaveFailed': '落地代表图保存失败，但商品已保存。',
  'pages.products.add.landingImageTooLarge': '图片过大（最大 10MB）',
  'pages.products.add.landingImageVariants': '变体',
  'pages.products.add.requiredFieldsError': '请填写必填项',
  'pages.products.add.uploadError': '图片上传失败',
  // products:category
  'pages.products.category.addCategory': '添加分类',
  'pages.products.category.deleteError': '删除分类失败',
  'pages.products.category.level1Required': '请选择一级分类',
  // products:list
  'pages.products.list.landingBadge': '落地图',
  'pages.products.list.setStoreRepresentative': '店铺代表',
  'pages.products.list.setStoreRepresentativeConfirm': '将此商品设为店铺卡片上的代表商品吗？',
  'pages.products.list.setStoreRepresentativeFailed': '未能指定代表商品。',
  'pages.products.list.setStoreRepresentativeSuccess': '已设为推荐页代表商品。',
  'pages.products.list.storeRepresentativeBadge': '店铺代表',
  // products:store
  'pages.products.store.avatarImage': '圆形图片',
  'pages.products.store.avatarImageHint': '用于店铺卡片和卖家列表中的圆形位置。',
  'pages.products.store.basicSection': '基本信息',
  'pages.products.store.cardPreview': '卡片预览',
  'pages.products.store.cardSection': '推荐卡片',
  'pages.products.store.changeImage': '更换图片',
  'pages.products.store.clearImage': '清除',
  'pages.products.store.cropHint': '卡片只显示橙色虚线内的区域（316:185）。拖动图片以选择位置。',
  'pages.products.store.eventLinkInvalid': '地址格式不正确',
  'pages.products.store.eventLinkUrl': '活动链接',
  'pages.products.store.eventText': '活动文案',
  'pages.products.store.eventTextPlaceholder': '购买中的活动赠品',
  'pages.products.store.featuredHint': '仅当推荐店铺版块为自动模式时生效。',
  'pages.products.store.featuredOff': '不展示',
  'pages.products.store.featuredOn': '展示',
  'pages.products.store.featuredOnHome': '在推荐页面展示',
  'pages.products.store.heavyImage': '图片过大，建议上传更小的图片。',
  'pages.products.store.homeSortOrder': '排序',
  'pages.products.store.homeSortOrderHint': '数值越小越靠前。',
  'pages.products.store.orderButton': '调整顺序',
  'pages.products.store.orderTitle': '调整店铺顺序',
  'pages.products.store.orderHint': '拖动调整顺序后保存。全部店铺页面（推荐店铺「更多」）以及未放入店铺的推荐店铺栏将按此顺序展示。关闭推荐展示的店铺排在开启的店铺之后，停用的店铺不会列出。',
  'pages.products.store.orderFeatured': '推荐展示',
  'pages.products.store.orderNotFeatured': '未推荐展示',
  'pages.products.store.orderDragHandle': '拖动调整顺序',
  'pages.products.store.orderSaved': '店铺顺序已保存。',
  'pages.products.store.orderSaveFailed': '无法保存店铺顺序。',
  'pages.products.store.orderEmpty': '没有可调整顺序的启用店铺。',
  'pages.products.store.imageSection': '图片',
  'pages.products.store.imageTooLarge': '图片过大（最大 10MB）',
  'pages.products.store.mainImage': '主横向图片',
  'pages.products.store.mainImageHint': '推荐店铺卡片上的大幅横向照片。',
  'pages.products.store.promoText': '宣传文案',
  'pages.products.store.promoTextPlaceholder': '秋季新品直播中 10% 折扣',
  'pages.products.store.recommendSize': '推荐',
  'pages.products.store.representativeEmpty': '此店铺暂无商品。',
  'pages.products.store.representativeHint': '选择一个与店铺卡片一同展示的商品。商品列表中仅显示“店铺代表”徽章。',
  'pages.products.store.representativeNone': '不指定',
  'pages.products.store.representativeProduct': '代表商品',
  'pages.products.store.representativeSaveFirst': '请先保存店铺，之后即可选择代表商品。',
  'pages.products.store.uploadImageOnly': '只能上传图片文件',
  'pages.products.store.variants': '变体',

  // Main Rolling Banner
  'pages.homepage.mainRollingBanner.title': '主滚动横幅',
  'pages.homepage.mainRollingBanner.list': '横幅列表',
  'pages.homepage.banner.add': '添加横幅',
  'pages.homepage.banner.order': '更改顺序',
  'pages.homepage.banner.image': '图片',
  'pages.homepage.banner.title': '标题',
  'pages.homepage.banner.url': '链接',
  'pages.homepage.banner.displayType': '显示类型',
  'pages.homepage.banner.registrationType': '注册类型',
  'pages.homepage.banner.targetType': '目标',
  'pages.homepage.banner.actions': '操作',
  'pages.homepage.banner.edit': '编辑',
  'pages.homepage.banner.delete': '删除',
  'pages.homepage.banner.addModal': '添加/编辑横幅',
  'pages.homepage.banner.editModal': '编辑横幅',
  'pages.homepage.banner.orderModal': '重新排序横幅',
  'pages.homepage.banner.form.displayType': '显示类型',
  'pages.homepage.banner.form.displayTypePlaceholder': '主页>滚动横幅',
  'pages.homepage.banner.form.displayTypeRequired': '请选择显示类型',
  'pages.homepage.banner.form.registrationType': '注册类型',
  'pages.homepage.banner.form.registrationTypePlaceholder': '选择注册类型',
  'pages.homepage.banner.form.registrationTypeRequired': '请选择注册类型',
  'pages.homepage.banner.form.title': '标题',
  'pages.homepage.banner.form.titlePlaceholder': '请输入标题',
  'pages.homepage.banner.form.titleRequired': '请输入标题',
  'pages.homepage.banner.form.image': '图片',
  'pages.homepage.banner.form.imageUpload': '选择文件',
  'pages.homepage.banner.form.url': '链接',
  'pages.homepage.banner.form.urlPlaceholder': '请输入链接',
  'pages.homepage.banner.form.usageStatus': '使用状态',
  'pages.homepage.banner.form.usageStatusPlaceholder': '使用',
  'pages.homepage.banner.form.usageStatusRequired': '请选择使用状态',
  'pages.homepage.banner.form.usageStatus.use': '使用',
  'pages.homepage.banner.form.usageStatus.notUse': '不使用',
  'pages.homepage.banner.form.target': '目标',
  'pages.homepage.banner.form.targetPlaceholder': '请选择',
  'pages.homepage.banner.form.targetRequired': '请选择目标',
  'pages.homepage.banner.form.target.oneself': '当前窗口',
  'pages.homepage.banner.form.target.newWindow': '新窗口',
  'pages.homepage.banner.form.period': '期间',
  'pages.homepage.banner.orderModal.instruction': '拖放以重新排序横幅',
  'pages.homepage.banner.orderModal.header.management': '横幅管理',
  'pages.homepage.banner.orderModal.header.type': '主页>滚动横幅',
  'pages.homepage.banner.message.added': '横幅添加成功',
  'pages.homepage.banner.message.updated': '横幅更新成功',
  'pages.homepage.banner.message.deleted': '横幅删除成功',
  'pages.homepage.banner.message.orderChanged': '顺序已更改',
  'pages.homepage.banner.message.orderSaved': '顺序保存成功',
  'pages.homepage.banner.message.editInfo': '编辑功能',
  'pages.homepage.banner.confirm.deleteTitle': '确认删除',
  'pages.homepage.banner.confirm.deleteContent': '您确定要删除此横幅吗？',

  // Homepage - Recommended Products
  'pages.homepage.recommendedProducts.title': '推荐商品管理',
  'pages.homepage.product.order': '顺序',
  'pages.homepage.product.image': '图片',
  'pages.homepage.product.recommendationType': '推荐类型',
  'pages.homepage.product.name': '商品名称',
  'pages.homepage.product.country': '国家',
  'pages.homepage.product.price': '价格',
  'pages.homepage.product.category': '类别',
  'pages.homepage.product.actions': '操作',
  'pages.homepage.product.add': '添加/编辑推荐商品',
  'pages.homepage.product.edit': '编辑',
  'pages.homepage.product.delete': '删除',
  'pages.homepage.product.addModal': '添加/编辑推荐商品',
  'pages.homepage.product.editModal': '添加/编辑推荐商品',
  'pages.homepage.product.form.recommendationType': '推荐类型',
  'pages.homepage.product.form.recommendationTypePlaceholder': '选择',
  'pages.homepage.product.form.recommendationTypeRequired': '请选择推荐类型',
  'pages.homepage.product.form.productName': '商品名称',
  'pages.homepage.product.form.productNamePlaceholder': '请输入商品名称',
  'pages.homepage.product.form.productNameRequired': '请输入商品名称',
  'pages.homepage.product.form.productUrl': '商品URL',
  'pages.homepage.product.form.productUrlPlaceholder': '请输入商品URL',
  'pages.homepage.product.form.country': '国家',
  'pages.homepage.product.form.countryPlaceholder': '选择',
  'pages.homepage.product.form.countryRequired': '请选择国家',
  'pages.homepage.product.form.price': '价格',
  'pages.homepage.product.form.pricePlaceholder': '0',
  'pages.homepage.product.form.priceRequired': '请输入价格',
  'pages.homepage.product.form.category': '类别',
  'pages.homepage.product.form.categoryPlaceholder': '请输入类别',
  'pages.homepage.product.form.image': '商品图片',
  'pages.homepage.product.form.imageUpload': '选择文件',
  'pages.homepage.product.type.hotDeal': '热门优惠',
  'pages.homepage.product.type.newArrival': '新品上市',
  'pages.homepage.product.type.bestSeller': '畅销商品',
  'pages.homepage.product.type.featured': '推荐商品',
  'pages.homepage.product.country.china': '中国',
  'pages.homepage.product.country.korea': '韩国',
  'pages.homepage.product.country.usa': '美国',
  'pages.homepage.product.country.japan': '日本',
  'pages.homepage.product.message.added': '商品添加成功',
  'pages.homepage.product.message.updated': '商品更新成功',
  'pages.homepage.product.message.deleted': '商品删除成功',
  'pages.homepage.product.confirm.deleteTitle': '删除商品',
  'pages.homepage.product.confirm.deleteContent': '您确定要删除此商品吗？',

  // Homepage - Departure Schedule
  'pages.homepage.departureSchedule.title': '出航时间表管理',
  'pages.homepage.schedule.center': '中心',
  'pages.homepage.schedule.transportMethod': '运输方式',
  'pages.homepage.schedule.departureDate': '出航日期',
  'pages.homepage.schedule.departureTime': '出航时间',
  'pages.homepage.schedule.notes': '备注',
  'pages.homepage.schedule.actions': '操作',
  'pages.homepage.schedule.add': '添加出航时间表',
  'pages.homepage.schedule.edit': '编辑',
  'pages.homepage.schedule.delete': '删除',
  'pages.homepage.schedule.addModal': '添加出航时间表',
  'pages.homepage.schedule.editModal': '编辑出航时间表',
  'pages.homepage.schedule.form.center': '中心',
  'pages.homepage.schedule.form.centerRequired': '请选择中心',
  'pages.homepage.schedule.form.transportMethod': '运输方式',
  'pages.homepage.schedule.form.transportMethodRequired': '请选择运输方式',
  'pages.homepage.schedule.form.departureDate': '出航日期',
  'pages.homepage.schedule.form.departureDateRequired': '请选择出航日期',
  'pages.homepage.schedule.form.departureTime': '出航时间',
  'pages.homepage.schedule.form.departureTimeRequired': '请选择出航时间',
  'pages.homepage.schedule.form.notes': '备注',
  'pages.homepage.schedule.form.notesPlaceholder': '请输入备注',
  'pages.homepage.schedule.center.weihai': '威海',
  'pages.homepage.schedule.center.guangzhou': '广州',
  'pages.homepage.schedule.transport.seaIncheonCJ': '海运仁川(CJ)',
  'pages.homepage.schedule.transport.seaPyeongtaekHanjin': '海运平泽(韩进)',
  'pages.homepage.schedule.transport.lclMWF': 'LCL(周一/三/五货船)',
  'pages.homepage.schedule.transport.lclTThSun': 'LCL(周二/四/日威利船)',
  'pages.homepage.schedule.transport.air': '航空',
  'pages.homepage.schedule.transport.airExpress': '航空快递',
  'pages.homepage.schedule.transport.topitLCL': 'Topit LCL(周二/四)',
  'pages.homepage.schedule.transport.topitLCLGeneral': 'Topit LCL',
  'pages.homepage.schedule.message.added': '时间表添加成功',
  'pages.homepage.schedule.message.updated': '时间表更新成功',
  'pages.homepage.schedule.message.deleted': '时间表删除成功',
  'pages.homepage.schedule.confirm.deleteTitle': '删除时间表',
  'pages.homepage.schedule.confirm.deleteContent': '您确定要删除此时间表吗？',

  // Homepage - Shopping Information
  'pages.homepage.shoppingInformation.title': '购物信息管理',
  'pages.homepage.shopping.tab.category': '类别管理',
  'pages.homepage.shopping.tab.site': '网站管理',
  'pages.homepage.shopping.addCategory': '添加类别',
  'pages.homepage.shopping.addSite': '添加网站',
  'pages.homepage.shopping.addCategoryModal': '添加类别',
  'pages.homepage.shopping.editCategoryModal': '编辑类别',
  'pages.homepage.shopping.addSiteModal': '添加网站',
  'pages.homepage.shopping.editSiteModal': '编辑网站',
  'pages.homepage.shopping.category.name': '类别名称',
  'pages.homepage.shopping.category.order': '顺序',
  'pages.homepage.shopping.site.country': '国家',
  'pages.homepage.shopping.site.category': '类别',
  'pages.homepage.shopping.site.name': '网站名称',
  'pages.homepage.shopping.site.url': '网站网址',
  'pages.homepage.shopping.actions': '操作',
  'pages.homepage.shopping.edit': '编辑',
  'pages.homepage.shopping.delete': '删除',
  'pages.homepage.shopping.form.categoryName': '类别名称',
  'pages.homepage.shopping.form.categoryNameRequired': '请输入类别名称',
  'pages.homepage.shopping.form.categoryNamePlaceholder': '输入类别名称',
  'pages.homepage.shopping.form.country': '国家',
  'pages.homepage.shopping.form.countryRequired': '请选择国家',
  'pages.homepage.shopping.form.countryPlaceholder': '选择国家',
  'pages.homepage.shopping.form.category': '类别',
  'pages.homepage.shopping.form.categoryRequired': '请选择类别',
  'pages.homepage.shopping.form.categoryPlaceholder': '选择类别',
  'pages.homepage.shopping.form.siteName': '网站名称',
  'pages.homepage.shopping.form.siteNameRequired': '请输入网站名称',
  'pages.homepage.shopping.form.siteNamePlaceholder': '输入网站名称',
  'pages.homepage.shopping.form.siteUrl': '网站网址',
  'pages.homepage.shopping.form.siteUrlPlaceholder': '输入网站网址',
  'pages.homepage.shopping.form.image': '图片',
  'pages.homepage.shopping.form.imageUpload': '上传',
  'pages.homepage.shopping.country.china': '中国',
  'pages.homepage.shopping.country.korea': '韩国',
  'pages.homepage.shopping.country.usa': '美国',
  'pages.homepage.shopping.country.japan': '日本',
  'pages.homepage.shopping.message.categoryAdded': '类别添加成功',
  'pages.homepage.shopping.message.categoryUpdated': '类别更新成功',
  'pages.homepage.shopping.message.categoryDeleted': '类别删除成功',
  'pages.homepage.shopping.message.siteAdded': '网站添加成功',
  'pages.homepage.shopping.message.siteUpdated': '网站更新成功',
  'pages.homepage.shopping.message.siteDeleted': '网站删除成功',
  'pages.homepage.shopping.confirm.deleteCategoryTitle': '删除类别',
  'pages.homepage.shopping.confirm.deleteCategoryContent': '您确定要删除此类别吗？',
  'pages.homepage.shopping.confirm.deleteSiteTitle': '删除网站',
  'pages.homepage.shopping.confirm.deleteSiteContent': '您确定要删除此网站吗？',

  // Homepage - Event Management
  'pages.homepage.eventManagement.title': '活动管理',
  'pages.homepage.event.title': '标题',
  'pages.homepage.event.thumbnail': '缩略图',
  'pages.homepage.event.period': '期间',
  'pages.homepage.event.displayType': '使用状态',
  'pages.homepage.event.actions': '操作',
  'pages.homepage.event.add': '添加活动',
  'pages.homepage.event.edit': '编辑',
  'pages.homepage.event.delete': '删除',
  'pages.homepage.event.addModal': '添加/编辑活动',
  'pages.homepage.event.editModal': '添加/编辑活动',
  'pages.homepage.event.form.title': '标题',
  'pages.homepage.event.form.titleRequired': '请输入标题',
  'pages.homepage.event.form.titlePlaceholder': '输入标题',
  'pages.homepage.event.form.briefDescription': '简要说明',
  'pages.homepage.event.form.briefDescriptionRequired': '请输入简要说明',
  'pages.homepage.event.form.briefDescriptionPlaceholder': '输入简要说明',
  'pages.homepage.event.form.thumbnail': '缩略图',
  'pages.homepage.event.form.thumbnailUpload': '上传',
  'pages.homepage.event.form.externalLink': '外部链接',
  'pages.homepage.event.form.externalLinkPlaceholder': '输入外部链接',
  'pages.homepage.event.form.period': '期间',
  'pages.homepage.event.form.periodRequired': '请选择期间',
  'pages.homepage.event.form.exposurePeriod': '展示期间',
  'pages.homepage.event.form.exposurePeriodRequired': '请选择展示期间',
  'pages.homepage.event.form.displayType': '使用状态',
  'pages.homepage.event.form.displayTypeRequired': '请选择使用状态',
  'pages.homepage.event.form.displayTypePlaceholder': '选择使用状态',
  'pages.homepage.event.form.content': '内容',
  'pages.homepage.event.form.contentHint': '以HTML格式输入内容',
  'pages.homepage.event.displayType.active': '使用',
  'pages.homepage.event.displayType.inactive': '不使用',
  'pages.homepage.event.message.added': '活动添加成功',
  'pages.homepage.event.message.updated': '活动更新成功',
  'pages.homepage.event.message.deleted': '活动删除成功',
  'pages.homepage.event.confirm.deleteTitle': '删除活动',
  'pages.homepage.event.confirm.deleteContent': '您确定要删除此活动吗？',

  // Homepage - Popup Management
  'pages.homepage.popupManagement.title': '弹窗管理',
  'pages.homepage.popup.title': '标题',
  'pages.homepage.popup.coordinates': '坐标',
  'pages.homepage.popup.isCentered': '居中',
  'pages.homepage.popup.size': '尺寸',
  'pages.homepage.popup.isOpen': '打开状态',
  'pages.homepage.popup.period': '期间',
  'pages.homepage.popup.displayType': '使用状态',
  'pages.homepage.popup.actions': '操作',
  'pages.homepage.popup.add': '添加弹窗',
  'pages.homepage.popup.edit': '编辑',
  'pages.homepage.popup.delete': '删除',
  'pages.homepage.popup.addModal': '添加/编辑弹窗',
  'pages.homepage.popup.editModal': '添加/编辑弹窗',
  'pages.homepage.popup.form.title': '标题',
  'pages.homepage.popup.form.titleRequired': '请输入标题',
  'pages.homepage.popup.form.titlePlaceholder': '输入标题',
  'pages.homepage.popup.form.coordinates': '坐标',
  'pages.homepage.popup.form.isCentered': '居中',
  'pages.homepage.popup.form.isCenteredLabel': '居中显示',
  'pages.homepage.popup.form.size': '尺寸',
  'pages.homepage.popup.form.isOpen': '打开状态',
  'pages.homepage.popup.form.isOpenLabel': '弹窗打开',
  'pages.homepage.popup.form.period': '期间',
  'pages.homepage.popup.form.periodRequired': '请选择期间',
  'pages.homepage.popup.form.displayType': '使用状态',
  'pages.homepage.popup.form.displayTypeRequired': '请选择使用状态',
  'pages.homepage.popup.form.displayTypePlaceholder': '选择使用状态',
  'pages.homepage.popup.form.content': '内容',
  'pages.homepage.popup.form.contentPlaceholder': '输入内容',
  'pages.homepage.popup.form.contentHint': '以HTML格式输入内容',
  'pages.homepage.popup.displayType.active': '使用',
  'pages.homepage.popup.displayType.inactive': '不使用',
  'pages.homepage.popup.message.added': '弹窗添加成功',
  'pages.homepage.popup.message.updated': '弹窗更新成功',
  'pages.homepage.popup.message.deleted': '弹窗删除成功',
  'pages.homepage.popup.confirm.deleteTitle': '删除弹窗',
  'pages.homepage.popup.confirm.deleteContent': '您确定要删除此弹窗吗？',

  // Homepage - Page Management
  'pages.homepage.pageManagement.title': '页面管理',
  'pages.homepage.page.pageTitle': '页面标题',
  'pages.homepage.page.displayType': '使用状态',
  'pages.homepage.page.actions': '操作',
  'pages.homepage.page.add': '添加页面',
  'pages.homepage.page.edit': '编辑',
  'pages.homepage.page.delete': '删除',
  'pages.homepage.page.addModal': '添加/编辑HTML页面',
  'pages.homepage.page.editModal': '添加/编辑HTML页面',
  'pages.homepage.page.form.pageTitle': '页面标题',
  'pages.homepage.page.form.pageTitleRequired': '请输入页面标题',
  'pages.homepage.page.form.pageTitlePlaceholder': '输入页面标题',
  'pages.homepage.page.form.displayType': '使用状态',
  'pages.homepage.page.form.displayTypeRequired': '请选择使用状态',
  'pages.homepage.page.form.displayTypePlaceholder': '选择使用状态',
  'pages.homepage.page.form.content': '内容',
  'pages.homepage.page.form.contentPlaceholder': '输入内容',
  'pages.homepage.page.form.contentHint': '以HTML格式输入内容',
  'pages.homepage.page.displayType.active': '使用',
  'pages.homepage.page.displayType.inactive': '不使用',
  'pages.homepage.page.message.added': '页面添加成功',
  'pages.homepage.page.message.updated': '页面更新成功',
  'pages.homepage.page.message.deleted': '页面删除成功',
  'pages.homepage.page.confirm.deleteTitle': '删除页面',
  'pages.homepage.page.confirm.deleteContent': '您确定要删除此页面吗？',

  // Homepage - Mail Form Management
  'pages.homepage.mailFormManagement.title': '邮件表单管理',
  'pages.homepage.mailForm.title': '标题',
  'pages.homepage.mailForm.displayType': '使用状态',
  'pages.homepage.mailForm.actions': '操作',
  'pages.homepage.mailForm.add': '添加邮件表单',
  'pages.homepage.mailForm.edit': '编辑',
  'pages.homepage.mailForm.delete': '删除',
  'pages.homepage.mailForm.addModal': '添加/编辑邮件表单',
  'pages.homepage.mailForm.editModal': '添加/编辑邮件表单',
  'pages.homepage.mailForm.form.title': '标题',
  'pages.homepage.mailForm.form.titleRequired': '请输入标题',
  'pages.homepage.mailForm.form.titlePlaceholder': '输入标题',
  'pages.homepage.mailForm.form.displayType': '使用状态',
  'pages.homepage.mailForm.form.displayTypeRequired': '请选择使用状态',
  'pages.homepage.mailForm.form.displayTypePlaceholder': '选择使用状态',
  'pages.homepage.mailForm.form.content': '内容',
  'pages.homepage.mailForm.form.contentPlaceholder': '输入内容',
  'pages.homepage.mailForm.form.contentHint': '以HTML格式输入内容',
  'pages.homepage.mailForm.form.variablesHint': '网站名称：[$SITE_NAME]，姓名：[$MEMBER_NAME]，ID：[$MEMBER_ID]，手机号：[$MOBILE_NO]，密码：[$PASSWORD]',
  'pages.homepage.mailForm.displayType.active': '使用',
  'pages.homepage.mailForm.displayType.inactive': '不使用',
  'pages.homepage.mailForm.message.added': '邮件表单添加成功',
  'pages.homepage.mailForm.message.updated': '邮件表单更新成功',
  'pages.homepage.mailForm.message.deleted': '邮件表单删除成功',
  'pages.homepage.mailForm.confirm.deleteTitle': '删除邮件表单',
  'pages.homepage.mailForm.confirm.deleteContent': '您确定要删除此邮件表单吗？',

  // Coupon Issuance
  'pages.coupon.issuance.modalTitle': '发放优惠券',
  'pages.coupon.issuance.memberButton': '按会员发放优惠券',
  'pages.coupon.issuance.levelButton': '按等级发放优惠券',
  'pages.coupon.issuance.memberInfo': '会员信息（优惠券期限：无限制）',
  'pages.coupon.issuance.type': '类型',
  'pages.coupon.issuance.code': '优惠券代码',
  'pages.coupon.issuance.amount': '金额',
  'pages.coupon.issuance.method': '发放方式（会员ID）',
  'pages.coupon.issuance.usageStatus': '使用状态',
  'pages.coupon.issuance.date': '发放日期',
  'pages.coupon.issuance.memberSearch': '会员搜索',
  'pages.coupon.issuance.memberId': '会员ID',
  'pages.coupon.issuance.memberName': '会员姓名',
  'pages.coupon.issuance.phone': '手机',
  'pages.coupon.issuance.searchPlaceholder': '输入搜索词',
  'pages.coupon.issuance.selectMember': '会员姓名',
  'pages.coupon.issuance.selectMemberPlaceholder': '= 选择会员 =',
  'pages.coupon.issuance.couponType': '优惠券类型',
  'pages.coupon.issuance.shippingFee': '运费',
  'pages.coupon.issuance.discount': '折扣',
  'pages.coupon.issuance.count': '个',
  'pages.coupon.issuance.category': '发放类别',
  'pages.coupon.issuance.validDays': '有效天数',
  'pages.coupon.issuance.fromIssuanceDate': '从发放日期起',
  'pages.coupon.issuance.days': '天',
  'pages.coupon.issuance.smsOption': '短信选项',
  'pages.coupon.issuance.noSms': '不发送短信',
  'pages.coupon.issuance.sendSms': '发送短信',
  'pages.coupon.issuance.memberLevel': '会员等级',
  'pages.coupon.issuance.level.all': '所有会员等级',
  'pages.coupon.issuance.level.basic': '基础会员',
  'pages.coupon.issuance.level.shippingVip': '配送VIP',
  'pages.coupon.issuance.level.shippingSvip': '配送SVIP',
  'pages.coupon.issuance.level.purchaseBusiness': '采购业务',
  'pages.coupon.issuance.level.purchase': '采购',
  'pages.coupon.issuance.level.agencyVip': '代理VIP',
  'pages.coupon.issuance.level.ttBusiness': 'TT业务',
  'pages.coupon.issuance.level.ttVip': 'TT VIP',
  'pages.coupon.issuance.level.ttPersonal': 'TT个人',
  'pages.coupon.issuance.successMessage': '优惠券发放成功',
  'pages.coupon.issuance.table.couponType': '优惠券类型',
  'pages.coupon.issuance.table.issuanceType': '发放类型',
  'pages.coupon.issuance.table.amount': '金额',
  'pages.coupon.issuance.table.effectiveDate': '有效期',
  'pages.coupon.issuance.table.ownerMember': '所有会员',
  'pages.coupon.issuance.table.isUsed': '使用状态',
  'pages.coupon.issuance.table.issuanceDate': '发放日期',
  'pages.coupon.issuance.filter.period': '期间',
  'pages.coupon.issuance.filter.membershipEvent': '会员注册活动',
  'pages.coupon.issuance.filter.adminIssued': '管理员发放',
  'pages.coupon.issuance.filter.upgradeEvent': '会员升级优惠券',
  'pages.coupon.issuance.filter.used': '已使用',
  'pages.coupon.issuance.filter.unused': '未使用',
  'pages.coupon.issuance.filter.memberId': '会员ID',
  'pages.coupon.issuance.filter.memberIdPlaceholder': '输入会员ID',
  'pages.coupon.issuance.filter.memberNamePlaceholder': '输入会员姓名',
  'pages.coupon.issuance.filter.orderNumber': '订单号',
  'pages.coupon.issuance.filter.orderNumberPlaceholder': '输入订单号',
  'pages.coupon.issuance.deleteButton': '删除',
  'pages.coupon.issuance.selectToDelete': '请选择要删除的项目',
  'pages.coupon.issuance.deleteConfirmTitle': '删除优惠券',
  'pages.coupon.issuance.deleteConfirmContent': '您确定要删除{count}个优惠券吗？',
  'pages.coupon.issuance.deleteSuccess': '优惠券删除成功',
  'pages.coupon.issuance.selectedCount': '已选择{count}个',
  'pages.coupon.issuance.table.couponTypeAndIssuance': '优惠券类型（发放类型）',
  'pages.coupon.issuance.combined.shippingMembership': '运费 - 会员注册活动',
  'pages.coupon.issuance.combined.shippingAdmin': '运费 - 管理员发放',
  'pages.coupon.issuance.combined.shippingUpgrade': '运费 - 会员升级',
  'pages.coupon.issuance.searchResults': '搜索结果',
  'pages.coupon.issuance.selectedMember': '选定会员',
  'pages.coupon.issuance.price': '价格',
  'pages.coupon.issuance.pieces': '个',
  'pages.coupon.issuance.issuanceType': '发放类型',
  'pages.coupon.issuance.filter.startDate': '开始日期',
  'pages.coupon.issuance.filter.endDate': '结束日期',

  // Event Coupon
  'pages.coupon.event.couponType': '优惠券类型',
  'pages.coupon.event.issuanceType': '发放类型',
  'pages.coupon.event.amount': '金额',
  'pages.coupon.event.validDays': '有效天数',
  'pages.coupon.event.eventPeriod': '活动期间',
  'pages.coupon.event.createdAt': '创建时间',
  'pages.coupon.event.priceRequired': '请输入金额',
  'pages.coupon.event.countRequired': '请输入数量',
  'pages.coupon.event.validDaysRequired': '请输入有效天数',
  'pages.coupon.event.eventPeriodRequired': '请选择活动期间',
  'pages.coupon.event.saveSuccess': '活动优惠券创建成功',
  'pages.coupon.event.deleteConfirmTitle': '删除优惠券',
  'pages.coupon.event.deleteConfirmContent': '您确定要删除此优惠券吗？',
  'pages.coupon.event.deleteSuccess': '优惠券删除成功',

  // SMS
  'pages.sms.title': '发送短信',
  'pages.sms.tabs.storage': '短信存储',
  'pages.sms.tabs.members': '会员列表',
  'pages.sms.storage.title': '短信存储',
  'pages.sms.form.recipient': '收件人',
  'pages.sms.form.individual': '个人',
  'pages.sms.form.group': '群组',
  'pages.sms.form.phonePlaceholder': '请输入电话号码',
  'pages.sms.form.selectGroup': '请选择群组',
  'pages.sms.form.allMembers': '全部',
  'pages.sms.form.sender': '发件人',
  'pages.sms.form.message': '短信内容',
  'pages.sms.form.messagePlaceholder': '请输入消息',
  'pages.sms.form.currentLength': '当前长度',
  'pages.sms.form.bytes': '字节',
  'pages.sms.form.smsInfo': '短信为30字节，以发件人姓名 | MS发送。',
  'pages.sms.form.lmsInfo': '短信消息费用为15P。',
  'pages.sms.form.mmsInfo': 'LMS消息费用为35P。MMS消息费用为100P（带图片附件）。',
  'pages.sms.form.send': '发送',
  'pages.sms.member.memberId': '会员（ID）',
  'pages.sms.member.name': '等级',
  'pages.sms.member.phone': '电话',
  'pages.sms.member.createdAt': '创建时间',
  'pages.sms.member.emptyText': '请搜索会员。',
  'pages.sms.history.title': '短信发送历史',
  'pages.sms.history.sendInfo': '发送信息',
  'pages.sms.history.date': '日期',
  'pages.sms.history.datePlaceholder': '请选择日期',
  'pages.sms.history.phone': '电话',
  'pages.sms.history.phonePlaceholder': '请输入电话号码',
  'pages.sms.history.message': '内容',
  'pages.sms.history.type': '类型',
  'pages.sms.history.status': '状态',
  'pages.sms.history.pageSize': '每页显示',

  // Kakao SMS Management
  'pages.kakao.title': 'Kakao短信管理',
  'pages.kakao.table.name': '名称',
  'pages.kakao.table.kakaoContent': '[KakaoTalk]',
  'pages.kakao.table.replacementText': '短信 [KakaoTalk消息未发送时的替代文本]',
  'pages.kakao.table.bytes': '字节',
  'pages.kakao.table.useStatus': '使用状态',
  'pages.kakao.status.active': '使用',
  'pages.kakao.status.inactive': '未使用',
  'pages.kakao.placeholder.replacementText': '请输入替代文本',

  // SMS Point Details
  'pages.smsPoint.title': '积分详情',
  'pages.smsPoint.filter.year': '年份',
  'pages.smsPoint.filter.month': '月份',
  'pages.smsPoint.table.chargingPoint': '充值积分',
  'pages.smsPoint.table.location': '位置',
  'pages.smsPoint.table.date': '日期',

  // Member Grades
  'pages.member.grade.basic': '基础会员',
  'pages.member.grade.shippingAgency': '配送代理',
  'pages.member.grade.shippingVip': '配送代理VIP',
  'pages.member.grade.shippingSvip': '配送代理SVIP',
  'pages.member.grade.purchaseBusiness': '采购业务',
  'pages.member.grade.purchaseVip': '采购代理VIP',
  'pages.member.grade.ttBusiness': 'TT业务',
  'pages.member.grade.ttVip': 'TT VIP',
  'pages.member.grade.ttSvip': 'TT SVIP',

  // Rack Usage Management
  'pages.rack.usage.title': '货架使用管理',
  'pages.rack.usage.rackCode': '货架代码',
  'pages.rack.usage.rackNumber': '货架编号',
  'pages.rack.usage.size': '尺寸',
  'pages.rack.usage.registrant': '追踪号码',
  'pages.rack.usage.stockNumber': '库存编号',
  'pages.rack.usage.locationNumber': '位置编号',
  'pages.rack.usage.registrationDate': '登记日期',
  'pages.rack.usage.detail': '详情',

  // Rack Management
  'pages.rack.management.title': '货架管理',
  'pages.rack.management.register': '货架登记',
  'pages.rack.management.rackDefinition': '货架定义',
  'pages.rack.management.rackCode': '货架代码',
  'pages.rack.management.size': '尺寸',
  'pages.rack.management.range': '开始~结束编号',
  'pages.rack.management.totalRacks': '总货架数',
  'pages.rack.management.usedRacks': '已用货架数',
  'pages.rack.management.isActive': '是否使用',
  'pages.rack.management.rackDetails': '货架编号详情',
  'pages.rack.management.addRack': '添加货架编号',
  'pages.rack.management.correction': '修改',
  'pages.rack.management.registerModal': '货架登记',
  'pages.rack.management.detailsModal': '货架编号详情',
  'pages.rack.management.addRackModal': '添加货架编号',
  'pages.rack.management.correctionModal': '货架信息修改',
  'pages.rack.management.rackCode1': '货架代码_1',
  'pages.rack.management.rackCode2': '货架代码_2',
  'pages.rack.management.startNumber': '开始编号',
  'pages.rack.management.endNumber': '结束编号',
  'pages.rack.management.useCategory': '使用分类',
  'pages.rack.management.combination': '组合形式',
  'pages.rack.management.availableRacks': '可用货架数',
  'pages.rack.management.rackNumber': '货架编号',
  'pages.rack.management.status': '状态',
  'pages.rack.management.inquiry': '查询',
  'pages.rack.management.addRackCount': '添加货架数',
  'pages.rack.management.maxAddable': '最大可添加货架数',
  'pages.rack.management.sizeSmall': '小',
  'pages.rack.management.sizeMedium': '中',
  'pages.rack.management.sizeLarge': '大',
  'pages.rack.management.sizeLCL': 'LCL',
  'pages.rack.management.use': '使用',
  'pages.rack.management.notUse': '未使用',
  'pages.rack.management.notInUse': '未使用',
  'pages.rack.management.reset': '重置',
  'pages.rack.management.detail': '详情',
  'pages.rack.management.registrationDate': '登记日期',
  'pages.rack.management.enterAddCount': '请输入要添加的货架数',
  'pages.rack.management.registerSuccess': '货架登记成功',
  'pages.rack.management.addSuccess': '货架添加成功',
  'pages.rack.management.editSuccess': '货架更新成功',

  // Rack Information Log
  'pages.rack.log.title': '货架信息日志',
  'pages.rack.log.logNumber': '日志编号',
  'pages.rack.log.rackNumber': '货架编号',
  'pages.rack.log.trackingNumber': '跟踪编号',
  'pages.rack.log.stockNumber': '库存编号',
  'pages.rack.log.noDataNumber': '无数据编号',
  'pages.rack.log.registrationCode': '登记代码',
  'pages.rack.log.memberName': '会员名称',
  'pages.rack.log.registrationDate': '登记日期',
  'pages.rack.log.filter.first': '首',
  'pages.rack.log.filter.date': '日期',
  'pages.rack.log.filter.rackNumber': '货架编号',
  'pages.rack.log.filter.trackingNumber': '跟踪编号',
  'pages.rack.log.filter.stockNumber': '库存编号',
  'pages.rack.log.filter.noDataNumber': '无数据编号',
  'pages.rack.log.filter.memberName': '会员名称',

  // Membership Level Management
  'pages.membership.level.title': '会员等级管理',
  'pages.membership.level.register': '等级登记',
  'pages.membership.level.gradeNumber': '等级编号',
  'pages.membership.level.gradeName': '等级名称',
  'pages.membership.level.numberOfDeliveries': '配送次数',
  'pages.membership.level.purchaseFee': '购买费用(%)',
  'pages.membership.level.serviceFee': '服务费用(%)',
  'pages.membership.level.levelUpCoupon': '升级优惠券',
  'pages.membership.level.pointAccumulation': '积分累积(%)',
  'pages.membership.level.exchangeRates': '按等级适用汇率',
  'pages.membership.level.usageStatus': '使用状态',
  'pages.membership.level.deleteConfirmContent': '确定要删除此等级吗？',
  'pages.membership.level.modal.title': '会员等级管理',
  'pages.membership.level.modal.gradeName': '等级名称',
  'pages.membership.level.modal.purchaseFee': '购买费用(%)',
  'pages.membership.level.modal.serviceFee': '服务费用(%)',
  'pages.membership.level.modal.numberOfDeliveries': '配送次数',
  'pages.membership.level.modal.levelUpCoupon': '升级优惠券',
  'pages.membership.level.modal.pointAccumulation': '积分累积(%)',
  'pages.membership.level.modal.exchangeRates': '按等级适用汇率',
  'pages.membership.level.modal.usageStatus': '使用状态',
  'pages.membership.level.modal.active': '使用',
  'pages.membership.level.modal.inactive': '未使用',

  // Center Management
  'pages.center.title': '中心管理',
  'pages.center.centerRegistration': '中心登记',
  'pages.center.centerAlignment': '中心对齐',
  'pages.center.nation': '国家',
  'pages.center.center': '中心',
  'pages.center.centerCode': '中心代码',
  'pages.center.unitOfMeasurement': '计量单位（重量）',
  'pages.center.transportationMethod': '运输方式',
  'pages.center.address': '地址',
  'pages.center.phoneNumber': '电话号码',
  'pages.center.shippingCenter': '配送中心',
  'pages.center.whetherToUse': '是否使用',
  'pages.center.deleteConfirmContent': '确定要删除此中心吗？',
  'pages.center.modal.title': '中心登记/修改',
  'pages.center.modal.nation': '国家',
  'pages.center.modal.centerName': '中心名称',
  'pages.center.modal.centerCode': '中心代码',
  'pages.center.modal.postalCode': '邮政编码',
  'pages.center.modal.city': '城市',
  'pages.center.modal.state': '州/省',
  'pages.center.modal.address1': '地址 1',
  'pages.center.modal.address2': '地址 2',
  'pages.center.modal.phoneNumber': '电话号码',
  'pages.center.modal.weightUnit': '重量',
  'pages.center.modal.transportationMethod': '运输方式',
  'pages.center.modal.image': '图片 (417 x 235)',
  'pages.center.modal.chooseFile': '选择文件',
  'pages.center.modal.whetherToUse': '是否使用',
  'pages.center.modal.briefSummary': '简要说明',
  'pages.center.alignmentModal.title': '中心对齐',
  'pages.center.alignmentModal.centerManagement': '中心管理',
  'pages.center.alignmentModal.order': '顺序',
  'pages.center.alignmentModal.dragToReorder': '拖动以重新排序',
  'pages.center.alignmentModal.center1': 'Republic of Korea (Incheon)',
  'pages.center.alignmentModal.center2': 'China (for)',
  'pages.center.alignmentModal.center3': 'China (Qingdao)',
  'pages.center.alignmentModal.center4': 'China (Guangzhou)',
  'pages.center.alignmentModal.center5': 'China (Yiwu)',
  'pages.center.alignmentModal.center6': 'China (Hangzhou)',

  // Deposit Account Management
  'pages.depositAccount.title': '预存款账户管理',
  'pages.depositAccount.register': '注册预存款账户',
  'pages.depositAccount.id': 'ID',
  'pages.depositAccount.bankName': '银行名称',
  'pages.depositAccount.accountNumber': '账号',
  'pages.depositAccount.depositor': '存款人',
  'pages.depositAccount.whetherToUse': '是否使用',
  'pages.depositAccount.deleteConfirmContent': '确定要删除此账户吗？',
  'pages.depositAccount.modal.title': '注册/编辑预存款账户',
  'pages.depositAccount.modal.bankName': '银行名称',
  'pages.depositAccount.modal.accountNumber': '账号',
  'pages.depositAccount.modal.depositor': '存款人',
  'pages.depositAccount.modal.whetherToUse': '是否使用',

  // Exchange Rate (Customs & Applicable)
  'pages.customsExchangeRate.title': '关税汇率',
  'pages.applicableExchangeRate.title': '适用汇率',
  'pages.exchangeRate.register': '汇率登记',
  'pages.exchangeRate.id': 'ID',
  'pages.exchangeRate.nation': '国家',
  'pages.exchangeRate.period': '期间（标题）',
  'pages.exchangeRate.exchangeRate': '汇率',
  'pages.exchangeRate.deleteConfirmContent': '确定要删除此汇率吗？',
  'pages.exchangeRate.modal.title': '汇率登记',
  'pages.exchangeRate.modal.nation': '国家',
  'pages.exchangeRate.modal.period': '期间（标题）',
  'pages.exchangeRate.modal.periodPlaceholder': '例如：October 1, 2022 - October 31, 2022',
  'pages.exchangeRate.modal.exchangeRate': '汇率',

  // Additional Service Management
  'pages.additionalService.title': '附加服务管理',
  'pages.additionalService.note1': '订购时会自动添加附加服务费用。',
  'pages.additionalService.note2': '¥ = 人民币 / ₩ = 韩元 / $ = 美元',
  'pages.additionalService.saveChanges': '保存更改',
  'pages.additionalService.additionalServices': '附加服务',
  'pages.additionalService.amount': '金额',
  'pages.additionalService.explanation': '说明',
  'pages.additionalService.serviceNameKo': '服务（韩文）',
  'pages.additionalService.serviceNameZh': '服务（中文）',
  'pages.additionalService.serviceNameEn': '服务（英文）',
  'pages.additionalService.localShippingFee': '当地运费',
  'pages.additionalService.additionalCosts': '附加费用',
  'pages.additionalService.excessCostOfItems': '物品超额费用',
  'pages.additionalService.uninspectedShipment': '未检验发货',
  'pages.additionalService.uninspectedShipmentExplanation': '不检查产品数量/尺寸/颜色/选项的服务。但会检查外部损坏。',
  'pages.additionalService.finishworkCostVVIC': '完工费用（VVIC必需）',
  'pages.additionalService.finishworkCostVVICExplanation': '批发产品完工费用',
  'pages.additionalService.precisionInspection': '精密检验',
  'pages.additionalService.precisionInspectionExplanation': '如果您想要详细检查产品尺寸/颜色，计费时将添加精密检验费。检验后可能会产生额外费用。将提供智能手机拍摄的检验照片。',
  'pages.additionalService.doNotOpenTheProduct': '请勿打开产品盒',
  'pages.additionalService.businessInspection': '商业检验',
  'pages.additionalService.businessInspectionExplanation': '商业检验服务。',
  'pages.additionalService.noNeedToCheckQuantity': '无需检查数量',
  'pages.additionalService.noNeedToCheckQuantityExplanation': '不需要检查数量的服务。',
  'pages.additionalService.customerRequestReview': '客户要求审查',
  'pages.additionalService.customerRequestReviewExplanation': '审查客户要求的项目。',
  'pages.additionalService.noInspectionRequired': '无需检验',
  'pages.additionalService.noInspectionRequiredExplanation': '不需要检验的服务。',
  'pages.additionalService.bubbleWrapPackaging': '气泡膜包装',
  'pages.additionalService.bubbleWrapPackagingExplanation': '用气泡膜包装产品。',
  'pages.additionalService.indivBox': '单独盒子',
  'pages.additionalService.indivBoxExplanation': '将产品包装在单独的盒子中。',
  'pages.additionalService.usdExchangeRate': 'USD汇率（人民币金额除以汇率）',
  'pages.additionalService.example': '例如）',
  'pages.additionalService.serviceName': '服务名称',
  'pages.additionalService.serviceNamePlaceholder': '请输入服务名称',
  'pages.additionalService.unit': '单位',
  'pages.additionalService.unitPlaceholder': '例如：个、箱',
  'pages.additionalService.unitPrice': '单价 (₩)',
  'pages.additionalService.unitPricePlaceholder': '请输入单价',
  'pages.additionalService.sortOrder': '排序',
  'pages.additionalService.sortOrderPlaceholder': '请输入排序',
  'pages.additionalService.code': '代码',
  'pages.additionalService.codePlaceholder': '请输入服务代码（可选）',
  'pages.additionalService.requiresQuantity': '需要数量',
  'pages.additionalService.status': '状态',
  'pages.additionalService.addService': '添加服务',
  'pages.additionalService.editService': '编辑服务',

  // Island and Mountain Cost Management
  'pages.islandMountainCost.import': '文件上传',
  'pages.islandMountainCost.import.title': '岛屿山区费用文件上传',
  'pages.islandMountainCost.import.selectFile': '选择 Excel 文件',
  'pages.islandMountainCost.import.fileHint': '岛屿山区 Excel（.xlsx）。首行需有邮编标题（우편번호 或 국가기초코드）和渡船费标题（도선료 或 도선료금）。',
  'pages.excelFormat.title': '上传文件示例',
  'pages.excelFormat.download': '下载样例',
  'pages.excelFormat.downloadFailed': '样例文件生成失败',
  'pages.excelFormat.headerRequired': '第一行必须是标题行。',
  'pages.excelFormat.noHeaderRow': '从第一行开始直接填数据，不要标题行。若有标题行会被跳过。',
  'pages.excelFormat.aliases': '可用的标题名称：',
  'pages.islandMountainCost.import.formatNote': '可以有多余的列，也可以有多个工作表。',
  'pages.islandMountainCost.import.modeTitle': '应用方式',
  'pages.islandMountainCost.import.mode.merge': '合并',
  'pages.islandMountainCost.import.mode.mergeHint': '仅更新和新增文件中的邮编，文件中没有的邮编保持不变。',
  'pages.islandMountainCost.import.mode.replace': '全部替换',
  'pages.islandMountainCost.import.mode.replaceHint': '将文件视为完整清单，删除文件中没有的邮编。',
  'pages.islandMountainCost.import.fileRequired': '请选择文件',
  'pages.islandMountainCost.import.analyzing': '正在检查文件...',
  'pages.islandMountainCost.import.applying': '正在应用...',
  'pages.islandMountainCost.import.analyze': '检查文件',
  'pages.islandMountainCost.import.apply': '应用',
  'pages.islandMountainCost.import.reselect': '选择其他文件',
  'pages.islandMountainCost.import.failed': '文件处理失败',
  'pages.islandMountainCost.import.previewTitle': '应用后将发生的变化',
  'pages.islandMountainCost.import.sheetsTitle': '各工作表读取内容',
  'pages.islandMountainCost.import.sheetName': '工作表',
  'pages.islandMountainCost.import.sheetRows': '行数',
  'pages.islandMountainCost.import.sheetUnique': '邮政编码',
  'pages.islandMountainCost.import.sheetFees': '渡轮费',
  'pages.islandMountainCost.import.sheetKind.fee': '费用工作表',
  'pages.islandMountainCost.import.sheetKind.mixed': '混合地区(不登记)',
  'pages.islandMountainCost.import.sheetKind.empty': '无可读内容',
  'pages.islandMountainCost.import.toCreate': '新增',
  'pages.islandMountainCost.import.toUpdate': '金额变更',
  'pages.islandMountainCost.import.unchanged': '无变更',
  'pages.islandMountainCost.import.toDelete': '删除',
  'pages.islandMountainCost.import.toKeep': '保留',
  'pages.islandMountainCost.import.keepNotice.count': '文件中没有的 {count} 个邮编保持不变，不会删除。',
  'pages.islandMountainCost.import.deleteWarning': '文件中没有的 {count} 个邮政编码将被删除，包括手动登记的项目。',
  'pages.islandMountainCost.import.deleteSamples': '将被删除的项目(部分)',
  'pages.islandMountainCost.import.mixedNotice': '混合地区 {count} 行没有渡轮费，不予登记。',
  'pages.islandMountainCost.import.conflictNotice': '{count} 个邮政编码在两个工作表中金额不同，采用较大金额。',
  'pages.islandMountainCost.import.invalidNotice': '{count} 行无法读取，已跳过。',
  'pages.islandMountainCost.import.keepNotice': '附加费用和备注不在文件中，已登记的邮政编码保留原值。',
  'pages.islandMountainCost.import.done': '应用完成 — 新增 {created} / 变更 {updated} / 删除 {deleted}',
  'pages.islandMountainCost.import.doneMerge': '应用完成 — 新增 {created} / 变更 {updated} / 保留 {kept}',
  'pages.islandMountainCost.title': '岛屿和山区费用管理',
  'pages.islandMountainCost.from': '从',
  'pages.islandMountainCost.all': '全部',
  'pages.islandMountainCost.resetAbove': '重置上述条件',
  'pages.islandMountainCost.register': '注册',
  'pages.islandMountainCost.no': 'No',
  'pages.islandMountainCost.postalCode': '邮政编码',
  'pages.islandMountainCost.ferryFare': '渡船费',
  'pages.islandMountainCost.additionalFare': '附加费用',
  'pages.islandMountainCost.memo': '备注',
  'pages.islandMountainCost.registrationDate': '注册日期（修改日期）',
  'pages.islandMountainCost.deleteConfirmContent': '确定要删除此项吗？',
  'pages.islandMountainCost.modal.title': '注册/修改引航费',
  'pages.islandMountainCost.modal.postalCode': '邮政编码',
  'pages.islandMountainCost.modal.postalCodeExample': '例如）5位数道路名称邮政编码',
  'pages.islandMountainCost.modal.ferryFare': '渡船费',
  'pages.islandMountainCost.modal.additionalFare': '附加费用',
  'pages.islandMountainCost.modal.memo': '备注',

  // Item Management
  'pages.itemManagement.title': '项目管理',
  'pages.itemManagement.customsClearanceItems': '清关项目',
  'pages.itemManagement.customsClearanceItemCategories': '清关项目类别',
  'pages.itemManagement.registerItem': '注册项目',
  'pages.itemManagement.categoryRegistration': '类别注册',
  'pages.itemManagement.itemNumber': '项目编号',
  'pages.itemManagement.hsCode': 'HS CODE',
  'pages.itemManagement.category': '类别',
  'pages.itemManagement.itemName': '项目名称',
  'pages.itemManagement.itemNameEnglish': '项目名称（英文）',
  'pages.itemManagement.itemNameChinese': '项目名称（中文）',
  'pages.itemManagement.whetherOrNotToClearTheList': '是否清关清单',
  'pages.itemManagement.tariffRate': '关税率',
  'pages.itemManagement.vatRate': '增值税率',
  'pages.itemManagement.categorySymbol': '类别符号',
  'pages.itemManagement.categoryNumber': '类别编号',
  'pages.itemManagement.categoryName': '类别名称',
  'pages.itemManagement.categoryNameEnglish': '类别名称（英文）',
  'pages.itemManagement.whetherToUse': '是否使用',
  'pages.itemManagement.deleteItemConfirm': '确定要删除此项目吗？',
  'pages.itemManagement.deleteCategoryConfirm': '确定要删除此类别吗？',
  'pages.itemManagement.itemModal.title': '注册/修改清关项目',
  'pages.itemManagement.modal.category': '类别',
  'pages.itemManagement.modal.hsCode': 'HS CODE',
  'pages.itemManagement.modal.itemName': '项目名称',
  'pages.itemManagement.modal.itemNameEnglish': '项目名称（英文）',
  'pages.itemManagement.modal.itemNameChinese': '项目名称（中文）',
  'pages.itemManagement.modal.whetherOrNotToClearTheList': '是否清关清单',
  'pages.itemManagement.modal.tariffRate': '关税率',
  'pages.itemManagement.modal.vatRate': '增值税率',
  'pages.itemManagement.categoryModal.title': '注册/编辑类别',
  'pages.itemManagement.categoryModal.category': '类别',
  'pages.itemManagement.categoryModal.categoryEnglish': '类别（英文）',
  'pages.itemManagement.categoryModal.whetherToUse': '是否使用',
  'pages.itemManagement.categoryId': '分类 ID',
  'pages.itemManagement.parentId': '上级 ID',
  'pages.itemManagement.chineseName': '中文名称',
  'pages.itemManagement.englishName': '英文名称',
  'pages.itemManagement.simpleNonSimple': '简易/非简易',
  'pages.itemManagement.source': '来源',
  'pages.itemManagement.addTime': '添加时间',
  'pages.itemManagement.title.hsCode': 'HS CODE 管理',
  'pages.itemManagement.importExcel': '导入 Excel',
  'pages.itemManagement.exportExcel': '导出 Excel',
  'pages.itemManagement.importSuccess': '成功导入 {count} 条数据',
  'pages.itemManagement.importFailed': 'Excel 导入失败',
  'pages.itemManagement.exportFailed': 'Excel 导出失败',

  // Waybill Bandwidth Management
  'pages.waybillBandwidth.title': '运单带宽管理',
  'pages.waybillBandwidth.registerWaybillBandwidth': '注册运单带宽',
  'pages.waybillBandwidth.no': '序号',
  'pages.waybillBandwidth.centerTransportationMethod': '中心/运输方式',
  'pages.waybillBandwidth.osxId': 'OSX ID',
  'pages.waybillBandwidth.info': '信息',
  'pages.waybillBandwidth.waybillBandwidth': '运单带宽',
  'pages.waybillBandwidth.shipCondition': '发货条件',
  'pages.waybillBandwidth.numberOfAvailable': '可用数量',
  'pages.waybillBandwidth.numberOfAvailableWaybills': '可用运单数量',
  'pages.waybillBandwidth.whetherToUse': '是否使用',
  'pages.waybillBandwidth.registrationDate': '注册日期',
  'pages.waybillBandwidth.notInUse': '不使用',
  'pages.waybillBandwidth.deleteConfirmContent': '确定要删除此运单带宽吗？',
  'pages.waybillBandwidth.modal.title': '运单带宽注册',
  'pages.waybillBandwidth.modal.center': '中心',
  'pages.waybillBandwidth.modal.for': '威海',
  'pages.waybillBandwidth.modal.guangzhou': '广州',
  'pages.waybillBandwidth.modal.transportationMethod': '运输方式',
  'pages.waybillBandwidth.modal.domesticTransportationCompany': '国内运输公司',
  'pages.waybillBandwidth.modal.bandwidth': '带宽',

  // Order Statistics
  'pages.orderStatistics.title': '订单统计',
  'pages.orderStatistics.annualOrderStatistics': '年度订单统计',
  'pages.orderStatistics.monthlyOrderStatistics': '月度订单统计',
  'pages.orderStatistics.applicationItem': '申请项目',
  'pages.orderStatistics.costClassification': '费用分类',
  'pages.orderStatistics.january': '1月',
  'pages.orderStatistics.february': '2月',
  'pages.orderStatistics.march': '3月',
  'pages.orderStatistics.april': '4月',
  'pages.orderStatistics.may': '5月',
  'pages.orderStatistics.june': '6月',
  'pages.orderStatistics.july': '7月',
  'pages.orderStatistics.august': '8月',
  'pages.orderStatistics.september': '9月',
  'pages.orderStatistics.october': '10月',
  'pages.orderStatistics.november': '11月',
  'pages.orderStatistics.december': '12月',
  'pages.orderStatistics.days': '日',
  'pages.orderStatistics.year': '年',
  'pages.orderStatistics.month': '月',
  'pages.orderStatistics.center': '中心',
  'pages.orderStatistics.all': '全部',
  'pages.orderStatistics.for': '威海',
  'pages.orderStatistics.guangzhou': '广州',
  'pages.orderStatistics.centerNote': '* 选择中心后，将根据该中心的订单统计显示（未选择则显示所有中心）',
  'pages.orderStatistics.annualPaymentCost': '年度支付费用',
  'pages.orderStatistics.monthlyPaymentFee': '月度支付费用',

  // Member Statistics
  'pages.memberStatistics.title': '会员统计',
  'pages.memberStatistics.annualMembershipStatistics': '年度会员统计',
  'pages.memberStatistics.monthlyMembershipStatistics': '月度会员统计',
  'pages.memberStatistics.memberType': '会员类型',
  'pages.memberStatistics.applicationItem': '申请项目',
  'pages.memberStatistics.memberName': '会员姓名',
  'pages.memberStatistics.leeSeomHo': 'Lee Seom-Ho',
  'pages.memberStatistics.leeSeomBark': 'Lee Seom-Bark',
  'pages.memberStatistics.memberNote': '* 选择会员后，将根据该会员的订单统计显示（未选择则显示所有会员）',

  // Worker Statistics
  'pages.workerStatistics.title': '工作人员统计',
  'pages.workerStatistics.workerName': '工作人员姓名',
  'pages.workerStatistics.numberOfActualCases': '实际案例数',
  'pages.workerStatistics.actualAverage': '实际平均',
  'pages.workerStatistics.numberOfPackages': '包裹数量',
  'pages.workerStatistics.packagingAverage': '包装平均',
  'pages.workerStatistics.workerOfOrderClass': '订单类别的工作人员',

  // Worker Log
  'pages.workerLog.title': '工作人员日志',
  'pages.workerLog.no': '序号',
  'pages.workerLog.trackingNumber': '追踪号码',
  'pages.workerLog.orderNumber': '订单号',
  'pages.workerLog.operationLog': '操作日志',
  'pages.workerLog.workerName': '工作人员姓名',
  'pages.workerLog.recipientName': '收件人姓名',
  'pages.workerLog.memberNamePostOffice': '会员姓名/邮局',
  'pages.workerLog.waybillNumber': '运单号',
  'pages.workerLog.packagingDate': '包装日期',
  'pages.workerLog.shippingDate': '发货日期',

  // Tax Settlement Management
  'pages.taxSettlement.title': '税务结算管理',
  'pages.taxSettlement.no': '序号',
  'pages.taxSettlement.agencyClassification': '代理分类',
  'pages.taxSettlement.purchaseAmount': '采购金额',
  'pages.taxSettlement.purchaseFee': '采购费用',
  'pages.taxSettlement.region': '地区',
  'pages.taxSettlement.transportationMethod': '运输方式',
  'pages.taxSettlement.mailboxNumber': '邮箱号码',
  'pages.taxSettlement.waybillNumber': '运单号',
  'pages.taxSettlement.orderNumber': '订单号',
  'pages.taxSettlement.receiver': '收件人',
  'pages.taxSettlement.recipientAddress': '收件人地址',
  'pages.taxSettlement.personalCustomsCode': '个人海关代码',
  'pages.taxSettlement.productNameEnglish': '产品名称（英文）',
  'pages.taxSettlement.ct': 'C/T',
  'pages.taxSettlement.weight': '重量',
  'pages.taxSettlement.shippingCosts': '运费',
  'pages.taxSettlement.additionalServices': '附加服务',
  'pages.taxSettlement.additionalCostPayment': '附加费用支付',
  'pages.taxSettlement.memberName': '会员姓名',
  'pages.taxSettlement.federalCode': '联邦代码',
  'pages.taxSettlement.excelDownload': 'Excel下载',

  // Purchase Cost Statistics
  'pages.purchaseCost.title': '采购成本统计',
  'pages.purchaseCost.costItems': '成本项目',
  'pages.purchaseCost.totalWon': '总计 (₩)',
  'pages.purchaseCost.yuanAmount': '元 (¥)',
  'pages.purchaseCost.no': '序号',
  'pages.purchaseCost.purchaseCompletionDate': '采购完成日期',
  'pages.purchaseCost.orderNumber': '订单号',
  'pages.purchaseCost.transportationMethod': '运输方式',
  'pages.purchaseCost.productPurchaseCost': '产品采购成本',
  'pages.purchaseCost.localShippingFee': '本地运费',
  'pages.purchaseCost.purchaseFee': '采购费用',
  'pages.purchaseCost.additionalCost': '附加费用',
  'pages.purchaseCost.excessCostOfItems': '物品超额费用',
  'pages.purchaseCost.productPurchaseCostPercent': '产品采购成本 (%)',
  'pages.purchaseCost.localShippingFeePercent': '本地运费 (%)',
  'pages.purchaseCost.purchaseFeePercent': '采购费用 (%)',
  'pages.purchaseCost.additionalCostPercent': '附加费用 (%)',
  'pages.purchaseCost.excessCostOfItemsPercent': '物品超额费用 (%)',
  'pages.purchaseCost.yuan': '元 (¥)',

  // Trade Cost Statistics
  'pages.tradeCost.title': '贸易成本统计',
  'pages.tradeCost.applicationType': '申请类型',
  'pages.tradeCost.chibaYonggun1': '1 千叶用军 (gun)',
  'pages.tradeCost.chibayong1': '1 千叶用 (₩)',
  'pages.tradeCost.chibaYonggun2': '2-千叶用军 (gun)',
  'pages.tradeCost.chiba2': '2 千叶 (₩)',
  'pages.tradeCost.chibaYonggun3': '3-千叶用军 (gun)',
  'pages.tradeCost.pieceSet3': '3件套 (₩)',
  'pages.tradeCost.totalAmount': '总金额 (₩)',
  'pages.tradeCost.no': '序号',
  'pages.tradeCost.tradeNumber': '交易号',
  'pages.tradeCost.endDate': '结束日期',
  'pages.tradeCost.memberName': '会员姓名',
  'pages.tradeCost.mailboxNumber': '邮箱号码',
  'pages.tradeCost.firstCost': '第一成本 (₩)',
  'pages.tradeCost.secondaryCost': '第二成本 (₩)',
  'pages.tradeCost.thirdCost': '第三成本 (₩)',
  'pages.tradeCost.select': '= 选择',
  'pages.tradeCost.detailList': '详细列表',
  'pages.tradeCost.noData': '无数据',

  // Payment Agency Statistics
  'pages.paymentAgency.title': '支付代理统计',
  'pages.paymentAgency.annualPaymentAgencyStatistics': '年度支付代理统计',
  'pages.paymentAgency.monthlyPaymentAgencyStatistics': '月度支付代理统计',
  'pages.paymentAgency.applicationItem': '申请项目',
  'pages.paymentAgency.note': '* 计算基于订单数量和金额，统计基于完成时间（配送/采购，广州/海外），退货（退货完成）',
  'pages.paymentAgency.monthlyNote': '* 计算基于订单数量和金额，统计基于完成时间（支付代理，代理完成）',
  'pages.paymentAgency.annualPaymentCost': '年度支付费用',
  'pages.paymentAgency.monthlyPaymentFee': '月度支付费用',

  // Solution Inquiry
  'pages.solutionInquiry.title': 'Today Direct Purchase Co., Ltd.',
  'pages.solutionInquiry.announcement': '公告',
  'pages.solutionInquiry.workRequest': '工作请求',
  'pages.solutionInquiry.administratorGuide': '管理员指南',
  'pages.solutionInquiry.num': '序号',
  'pages.solutionInquiry.author': '作者',
  'pages.solutionInquiry.dateOfWriting': '撰写日期',
  'pages.solutionInquiry.check': '查看',
  'pages.solutionInquiry.menu': '菜单',
  'pages.solutionInquiry.submenu': '子菜单',
  'pages.solutionInquiry.submenuFilter': '= 子菜单',
  'pages.solutionInquiry.detail': '详情',
  'pages.solutionInquiry.noContent': '无内容',
  'pages.solutionInquiry.depositInfo': '存款账户信息：国民银行 984784307598 Areum Solution Co., Ltd.',
  'pages.solutionInquiry.copyright': '©Copyright 2014 — 2026 Arum Solution. All rights reserved. Go to',
  'pages.solutionInquiry.requestNumber': '请求编号',
  'pages.solutionInquiry.requestType': '请求类型',
  'pages.solutionInquiry.status': '状态',
  'pages.solutionInquiry.requestDate': '请求日期',
  'pages.solutionInquiry.completionDate': '完成日期',
  'pages.solutionInquiry.description': '描述',

  'pages.common.ok': '确定',

  // Trade Services
  'pages.orders.tradeServices.serviceType': '服务类型',
  'pages.orders.tradeServices.type': '类型',
  'pages.orders.tradeServices.tradeNumber': '贸易编号',
  'pages.orders.tradeServices.tradeNumberPlaceholder': '输入贸易编号',
  'pages.orders.tradeServices.applicationDate': '申请日期',
  'pages.orders.tradeServices.typeCenter': '类型/中心',
  'pages.orders.tradeServices.title': '标题',
  'pages.orders.tradeServices.progress': '进度',
  'pages.orders.tradeServices.progressApplication': '申请',
  'pages.orders.tradeServices.progressQuotation': '报价',
  'pages.orders.tradeServices.progressPayment': '待付款',
  'pages.orders.tradeServices.progressInProgress': '进行中',
  'pages.orders.tradeServices.progressCompleted': '已完成',
  'pages.orders.tradeServices.paymentInfo': '付款信息',
  'pages.orders.tradeServices.quotationAmount': '报价',
  'pages.orders.tradeServices.paidAmount': '已付',
  'pages.orders.tradeServices.documents': '报价单/报告',
  'pages.orders.tradeServices.viewQuotation': '查看报价单',
  'pages.orders.tradeServices.viewCompletionReport': '查看报告',
  'pages.orders.tradeServices.viewApplication': '查看申请',
  'pages.orders.tradeServices.delete': '删除',
  'pages.orders.tradeServices.viewingApplication': '查看申请 {number}',
  'pages.orders.tradeServices.deleteConfirm': '删除 {number}？',
  'pages.orders.tradeServices.sampleTitle1': '服装出口代理申请',
  'pages.orders.tradeServices.sampleTitle2': '电子产品进口清关代理',
  'pages.orders.tradeServices.sampleTitle3': '贸易咨询请求',
  'pages.orders.tradeServices.export': '出口',
  'pages.orders.tradeServices.import': '进口',
  'pages.orders.tradeServices.customs': '报关',
  'pages.orders.tradeServices.consulting': '咨询',
  'pages.orders.tradeServices.amount': '金额',
  'pages.orders.tradeServices.requestDate': '申请日期',
  'pages.orders.tradeServices.completionDate': '完成日期',
  'pages.orders.tradeServices.totalServices': '总服务数',
  'pages.orders.tradeServices.processingServices': '处理中服务',
  'pages.orders.tradeServices.completedServices': '已完成服务',
  'pages.orders.tradeServices.totalAmount': '总金额',
  'pages.orders.tradeServices.pendingCount': '待处理',
  'pages.orders.tradeServices.overdueCount': '已逾期',
  'pages.orders.tradeServices.totalPendingAmount': '待处理总金额',
  'pages.orders.tradeServices.dueDate': '截止日期',
  'pages.orders.tradeServices.processPayment': '处理付款',
  'pages.orders.tradeServices.paymentProcessed': '付款已处理',
  'pages.orders.tradeServices.sampleMemo': '示例备注',
  
  // Trade Services - Comprehensive Management Filter
  'pages.orders.tradeServices.marketResearchUnitPrice': '市场调研（产品单价）',
  'pages.orders.tradeServices.marketResearchOEM': '市场调研（OEM工厂）',
  'pages.orders.tradeServices.productionAgency': '生产代理',
  'pages.orders.tradeServices.exportAgency': '出口代理',
  'pages.orders.tradeServices.oneStopGuide': '一站式指南',
  'pages.orders.tradeServices.applicationReception': '申请接收',
  'pages.orders.tradeServices.confirmationReceipt': '确认收据',
  'pages.orders.tradeServices.paymentWaiting1st': '等待付款（第1次）',
  'pages.orders.tradeServices.inProgress': '进行中',
  'pages.orders.tradeServices.1stCompletion': '第1次完成',
  'pages.orders.tradeServices.paymentWaiting2nd': '等待付款（第2次）',
  'pages.orders.tradeServices.paymentCompleted2nd': '付款完成（第2次）',
  'pages.orders.tradeServices.paymentCompleted3rd': '付款完成（第3次）',
  'pages.orders.tradeServices.shipmentCompleted': '发货完成',
  'pages.orders.tradeServices.cancelApplication': '取消申请',
  
  // Payment Agency - Comprehensive Management Filter
  'pages.orders.paymentAgency.title': '付款代理',
  'pages.orders.paymentAgency.waitingForPayment': '等待付款',
  'pages.orders.paymentAgency.depositCompleted': '存款完成',
  'pages.orders.paymentAgency.paymentCompletedAtPurchase': '购买时付款完成',
  'pages.orders.paymentAgency.agencyCompleted': '代理完成',
  'pages.orders.paymentAgency.paymentRefundRequest': '付款退款请求',
  'pages.orders.paymentAgency.paymentRefundCompleted': '付款退款完成',
  'pages.orders.paymentAgency.cancellation': '取消',

  // Trade Service Application Modal
  'pages.orders.tradeServices.applicationModal.title': '贸易服务 - 市场调研（产品单价）',
  'pages.orders.tradeServices.applicationModal.basicInfo': '基本信息',
  'pages.orders.tradeServices.applicationModal.centerName': '中心名称',
  'pages.orders.tradeServices.applicationModal.quotationReport': '报价单/完成报告',
  'pages.orders.tradeServices.applicationModal.chooseFile': '选择文件',
  'pages.orders.tradeServices.applicationModal.fileSelect': '文件选择',
  'pages.orders.tradeServices.applicationModal.fileUpload': '文件上传',
  'pages.orders.tradeServices.applicationModal.applicationInfo': '申请信息',
  'pages.orders.tradeServices.applicationModal.client': '客户',
  'pages.orders.tradeServices.applicationModal.totalQuantity': '总数量',
  'pages.orders.tradeServices.applicationModal.totalAmount': '总金额',
  'pages.orders.tradeServices.applicationModal.contact': '联系方式',
  'pages.orders.tradeServices.applicationModal.email': '电子邮件',
  'pages.orders.tradeServices.applicationModal.address': '地址',
  'pages.orders.tradeServices.applicationModal.productInfo': '产品信息',
  'pages.orders.tradeServices.applicationModal.productName': '产品名称',
  'pages.orders.tradeServices.applicationModal.productUrl': '产品网址',
  'pages.orders.tradeServices.applicationModal.material': '材质/材料',
  'pages.orders.tradeServices.applicationModal.estimatedUnitPrice': '预估单价',
  'pages.orders.tradeServices.applicationModal.quantity': '数量',
  'pages.orders.tradeServices.applicationModal.productImage': '产品图片',
  'pages.orders.tradeServices.applicationModal.downloadImage': '下载图片',
  'pages.orders.tradeServices.applicationModal.adminMemo': '管理员备注',

  // Payment Agency
  'pages.orders.paymentAgency.paymentType': '支付类型',
  'pages.orders.paymentAgency.alipay': '支付宝',
  'pages.orders.paymentAgency.wechat': '微信支付',
  'pages.orders.paymentAgency.unionpay': '银联',
  'pages.orders.paymentAgency.bank': '银行转账',
  'pages.orders.paymentAgency.amount': '金额',
  'pages.orders.paymentAgency.requestDate': '申请日期',
  'pages.orders.paymentAgency.completionDate': '完成日期',
  'pages.orders.paymentAgency.totalPayments': '总支付数',
  'pages.orders.paymentAgency.processingPayments': '处理中支付',
  'pages.orders.paymentAgency.completedPayments': '已完成支付',
  'pages.orders.paymentAgency.totalAmount': '总金额',
  'pages.orders.paymentAgency.pendingCount': '待处理',
  'pages.orders.paymentAgency.overdueCount': '已逾期',
  'pages.orders.paymentAgency.totalPendingAmount': '待处理总金额',
  'pages.orders.paymentAgency.dueDate': '截止日期',
  'pages.orders.paymentAgency.processPayment': '处理付款',
  'pages.orders.paymentAgency.paymentProcessed': '付款已处理',
  'pages.orders.paymentAgency.sampleMemo': '示例备注',

  // Order Finance
  'pages.orderFinance.headerTitle': '订单财务列表',
  'pages.orderFinance.modal.title': '订单财务详情',
  'pages.orderFinance.column.orderNumber': '订单号',
  'pages.orderFinance.column.user': '用户',
  'pages.orderFinance.column.progressStatus': '进度状态',
  'pages.orderFinance.column.firstTierStatus': '一次付款状态',
  'pages.orderFinance.column.firstTierPaymentMethod': '一次付款方式',
  'pages.orderFinance.column.firstTierPaidAt': '一次付款日期',
  'pages.orderFinance.column.secondTierStatus': '二次付款状态',
  'pages.orderFinance.column.secondTierPaymentMethod': '二次付款方式',
  'pages.orderFinance.column.secondTierPaidAt': '二次付款日期',
  'pages.orderFinance.column.firstTierAmountKRW': '一次金额 (₩)',
  'pages.orderFinance.column.secondTierAmountKRW': '二次金额 (₩)',
  'pages.orderFinance.column.totalChargeKRW': '总应收金额 (₩)',
  'pages.orderFinance.column.totalCollectedKRW': '总收款金额 (₩)',
  'pages.orderFinance.column.outstandingKRW': '未收款 (₩)',
  'pages.orderFinance.column.hasRefundRisk': '退款风险',
  'pages.orderFinance.column.updatedAt': '最近更新 ',
  'pages.orderFinance.column.createdAt': '创建时间',
  'pages.orderFinance.refundRisk.danger': '风险',
  'pages.orderFinance.refundRisk.normal': '正常',
  'pages.orderFinance.modal.userId': '用户',
  'pages.orderFinance.modal.memberId': '会员ID',
  'pages.orderFinance.modal.email': '邮箱',
  'pages.orderFinance.modal.progressStatus': '进度状态',
  'pages.orderFinance.modal.firstTierStatus': '一次付款状态',
  'pages.orderFinance.modal.firstTierPaymentMethod': '一次付款方式',
  'pages.orderFinance.modal.firstTierAmount': '一次金额',
  'pages.orderFinance.modal.firstTierBeforeDiscount': '一次折前金额',
  'pages.orderFinance.modal.firstTierPaidAt': '一次付款日期',
  'pages.orderFinance.modal.secondTierStatus': '二次付款状态',
  'pages.orderFinance.modal.secondTierPaymentMethod': '二次付款方式',
  'pages.orderFinance.modal.secondTierAmount': '二次金额',
  'pages.orderFinance.modal.secondTierBeforeDiscount': '二次折前金额',
  'pages.orderFinance.modal.secondTierPaidAt': '二次付款日期',
  'pages.orderFinance.modal.totalCharge': '总应收金额',
  'pages.orderFinance.modal.totalCollected': '总收款金额',
  'pages.orderFinance.modal.outstanding': '未收款',
  'pages.orderFinance.modal.createdAt': '创建时间',
  'pages.orderFinance.modal.updatedAt': '最近更新',
  'pages.orderFinance.progressStatus.BUY_PAY_WAIT': '等待购买付款',
  'pages.orderFinance.progressStatus.BUY_PAY_DONE': '购买付款完成',
  'pages.orderFinance.progressStatus.BUYING_AUTO': '自动购买中',
  'pages.orderFinance.progressStatus.BUYING_MANUAL': '手动购买中',
  'pages.orderFinance.progressStatus.BUYING_PROBLEM': '购买问题',
  'pages.orderFinance.progressStatus.BUYING_FINANCIAL_SETTLEMENT': '购买结算中',
  'pages.orderFinance.progressStatus.BUY_FINAL_DONE': '购买完成',
  'pages.orderFinance.progressStatus.WH_IN_DONE': '入库完成',
  'pages.orderFinance.progressStatus.WH_PAY_WAIT': '等待国际运费付款',
  'pages.orderFinance.progressStatus.WH_PAY_DONE': '国际运费付款完成',
  'pages.orderFinance.paymentStatus.pending': '待付款',
  'pages.orderFinance.paymentStatus.processing': '处理中',
  'pages.orderFinance.paymentStatus.paid': '已付款',
  'pages.orderFinance.paymentStatus.failed': '付款失败',
  'pages.orderFinance.paymentStatus.refunded': '已退款',
  'pages.orderFinance.paymentMethod.card': '信用卡',
  'pages.orderFinance.paymentMethod.bank': '银行转账',
  'pages.orderFinance.paymentMethod.deposit': '预存款',
  'pages.orderFinance.paymentMethod.points': '积分',

  // Refund Records
  'pages.refundRecords.headerTitle': '退款记录',
  'pages.refundRecords.column.status': '状态',
  'pages.refundRecords.column.gateway': '支付网关',
  'pages.refundRecords.column.reason': '退款原因',
  'pages.refundRecords.column.refundAmountKRW': '退款金额 (₩)',
  'pages.refundRecords.column.refundCount': '退款笔数',
  'pages.refundRecords.summary.totalRefundAmountKRW': '总退款金额',
  'pages.refundRecords.summary.totalRefundCount': '总退款笔数',
  'pages.refundRecords.summary.paidRefundCount': '已完成退款笔数',
  'pages.refundRecords.summary.refundSuccessRate': '退款成功率',
  'pages.refundRecords.status.paid': '已完成',
  'pages.refundRecords.status.pending': '待处理',
  'pages.refundRecords.status.failed': '失败',
  'pages.refundRecords.gateway.deposit': '预存款',
  'pages.refundRecords.gateway.billgate': 'Billgate',
  'pages.refundRecords.gateway.card': '信用卡',
  'pages.refundRecords.gateway.bank': '银行转账',
  'pages.refundRecords.filter.startDate': '开始日期',
  'pages.refundRecords.filter.endDate': '结束日期',

  // Refund Records (settlement page — new design)
  'pages.refundRecords.title': '退款记录',
  'pages.refundRecords.listTitle': '退款记录列表',
  'pages.refundRecords.period.todayRefundAmount': '今日退款金额',
  'pages.refundRecords.period.month': '本月',
  'pages.refundRecords.period.quarter': '本季度',
  'pages.refundRecords.period.year': '本年',
  'pages.refundRecords.unit.count': '件',
  'pages.refundRecords.unit.qty': '个',
  'pages.refundRecords.stat.total': '全部',
  'pages.refundRecords.stat.partial': '部分退款',
  'pages.refundRecords.stat.bankWithdrawal': '银行转账提现',
  'pages.refundRecords.stat.member': '会员退款',
  'pages.refundRecords.stat.deposit': '押金',
  'pages.refundRecords.stat.card': '信用卡',
  'pages.refundRecords.stat.full': '全额退款',
  'pages.refundRecords.stat.platform': '平台退款',
  'pages.refundRecords.stat.lostCoupon': '失效优惠券',
  'pages.refundRecords.stat.final': '最终退款',
  'pages.refundRecords.stat.lostPoints': '失效积分',
  'pages.refundRecords.viewMode.detail': '详细查看',
  'pages.refundRecords.viewMode.summary': '简要查看',
  'pages.refundRecords.filter.page': '每页',
  'pages.refundRecords.filter.startTime': '开始时间',
  'pages.refundRecords.filter.endTime': '结束时间',
  'pages.refundRecords.filter.domesticTrackingNo': '国内运单号',
  'pages.refundRecords.filter.refundReason': '退款原因',
  'pages.refundRecords.filter.platform': '平台',
  'pages.refundRecords.filter.errorType': '错误类型',
  'pages.refundRecords.filter.refundType': '退款类型',
  'pages.refundRecords.filter.refundRoute': '退款路径',
  'pages.refundRecords.filter.refundStatus': '退款状态',
  'pages.refundRecords.filter.mailbox': '邮箱',
  'pages.refundRecords.filter.sellerMailbox': '卖家信箱',
  'pages.refundRecords.filter.orderNumber': '订单号',
  'pages.refundRecords.filter.returnDomesticTrackingNo': '退货国内运单号',
  'pages.refundRecords.filter.refundSerialNo': '退款流水号',
  'pages.refundRecords.filter.memberName': '会员名',
  'pages.refundRecords.filter.asManager': '售后负责人',
  'pages.refundRecords.filter.returnInternationalTrackingNo': '退货国际运单号',
  'pages.refundRecords.filter.financeManager': '财务负责人',
  'pages.refundRecords.filter.returnManager': '退货负责人',
  'pages.refundRecords.platform.1688': '1688',
  'pages.refundRecords.platform.taobao': '淘宝',
  'pages.refundRecords.platform.vvic': 'vvic',
  'pages.refundRecords.platform.self': '自营商城',
  'pages.refundRecords.platform.ownmall': '自营商城',
  'pages.refundRecords.platform.live': '直播频道',
  'pages.refundRecords.errorType.member': '会员退款',
  'pages.refundRecords.errorType.platform': '平台退款',
  'pages.refundRecords.errorType.final': '最终退款',
  'pages.refundRecords.errorType.user_refund': '会员退款',
  'pages.refundRecords.errorType.platform_refund': '平台退款',
  'pages.refundRecords.errorType.final_refund': '最终退款',
  'pages.refundRecords.refundType.partial': '部分',
  'pages.refundRecords.refundType.full': '全部',
  'pages.refundRecords.paymentMethod.deposit': '预存款',
  'pages.refundRecords.paymentMethod.points': '积分',
  'pages.refundRecords.paymentMethod.bank': '银行转账',
  'pages.refundRecords.paymentMethod.card': '信用卡',
  'pages.refundRecords.paymentMethod.billgate': 'Billgate',
  'pages.refundRecords.refundRoute.cardCard': '信用卡→信用卡',
  'pages.refundRecords.refundRoute.bankDeposit': '银行→押金',
  'pages.refundRecords.refundRoute.depositDeposit': '押金→押金',
  'pages.refundRecords.refundRoute.depositBank': '押金→银行',
  'pages.refundRecords.refundRoute.pointsPoints': '积分→积分',
  'pages.refundRecords.refundRoute.applying': '申请中',
  'pages.refundRecords.refundRoute.user_refund': '会员退款',
  'pages.refundRecords.refundRoute.platform_refund': '平台退款',
  'pages.refundRecords.refundRoute.final_refund': '最终退款',
  'pages.refundRecords.recordStatus.pending': '待处理',
  'pages.refundRecords.recordStatus.completed': '已完成',
  'pages.refundRecords.status.done': '已完成',
  'pages.refundRecords.status.asInProgress': '售后中',
  'pages.refundRecords.action.search': '搜索',
  'pages.refundRecords.action.download': '下载',
  'pages.refundRecords.action.confirm': '确认',
  'pages.refundRecords.action.cancel': '取消',
  'pages.refundRecords.note.asInputArea': '售后负责人填写部分: 退款原因、售后历史、银行信息、退货国内国际运单号',
  'pages.refundRecords.note.autoAccumulate': '退款完成时数据自动累计',
  'pages.refundRecords.col.no': '编号',
  'pages.refundRecords.col.mailboxMember': '邮箱 / 会员',
  'pages.refundRecords.col.refundOrderProduct': '退款流水号 / 订单号 / 英文商品名',
  'pages.refundRecords.col.relatedOrderNumbers': '关联订单号',
  'pages.refundRecords.col.routeStatus': '退款路径 / 状态',
  'pages.refundRecords.col.platformRefundNo': '平台 / 平台退款号',
  'pages.refundRecords.col.priceFeeShipping': '商品价格 / 手续费 / 国内运费',
  'pages.refundRecords.col.lostCouponPoints': '失效优惠券 / 失效积分',
  'pages.refundRecords.col.firstPayment': '一次支付 / 方式 / 下单时间',
  'pages.refundRecords.col.secondPayment': '二次支付 / 方式 / 下单时间',
  'pages.refundRecords.col.refundAmountRate': '退款金额 / 汇率',
  'pages.refundRecords.col.tracking': '国内 / 国际运单号',
  'pages.refundRecords.col.reasonErrorType': '错误类型 / 退款类型',
  'pages.refundRecords.col.asInfo': '售后负责人 / 历史 / 节点变更时间',
  'pages.refundRecords.col.bankWithdrawal': '[银行提现] / 收款人 / 账号',
  'pages.refundRecords.col.returnTracking': '[售后填写] / 退货国内 / 国际运单号',
  'pages.refundRecords.col.returnManager': '退货负责人 / 确认时间',
  'pages.refundRecords.col.refundChannel': '[押金退款] / [信用卡退款]',
  'pages.refundRecords.col.financeManager': '财务负责人 / 出金时间',
  'pages.refundRecords.col.action': '操作',

  // Points (settlement page — new design)
  'pages.points.title': '积分明细',
  'pages.points.listTitle': '积分使用明细列表',
  'pages.points.period.today': '今日',
  'pages.points.period.month': '本月',
  'pages.points.period.quarter': '本季度',
  'pages.points.period.year': '本年',
  'pages.points.label.earnPoints': '累积积分',
  'pages.points.label.deductPoints': '扣减积分',
  'pages.points.chart.monthlyAccrual': '月度累积',
  'pages.points.chart.monthlyDeduction': '月度扣减',
  'pages.points.chart.accrualPoints': '累积积分',
  'pages.points.chart.deductionPoints': '扣减积分',
  'pages.points.chart.dayAxis': '日',
  'pages.points.filter.accrualType': '累积类型',
  'pages.points.filter.deductionType': '扣减类型',
  'pages.points.accrualType.join': '注册赠送',
  'pages.points.accrualType.review': '评价赠送',
  'pages.points.accrualType.orderDone': '订单完成赠送',
  'pages.points.accrualType.attendance': '签到赠送',
  'pages.points.accrualType.share': '分享赠送',
  'pages.points.accrualType.admin': '管理员累积',
  'pages.points.deductionType.orderDeduct': '订单扣减',
  'pages.points.deductionType.adminDeduct': '管理员扣减',
  'pages.points.deductionType.expired': '过期删除',
  'pages.points.action.search': '搜索',
  'pages.points.action.download': '下载',
  'pages.points.filter.page': '每页',
  'pages.points.filter.startTime': '开始时间',
  'pages.points.filter.endTime': '结束时间',
  'pages.points.filter.mailbox': '邮箱',
  'pages.points.filter.serialNo': '流水号',
  'pages.points.filter.memberName': '会员名',
  'pages.points.filter.orderNumber': '订单号',
  'pages.points.col.no': '编号',
  'pages.points.col.mailboxMember': '邮箱 / 会员',
  'pages.points.col.remainingPoints': '剩余积分',
  'pages.points.col.serialNo': '流水号',
  'pages.points.col.category': '分类',
  'pages.points.col.earnedPoints': '累积积分',
  'pages.points.col.orderInfo': '订单号 / 下单时间',
  'pages.points.col.deductedPoints': '扣减积分',
  'pages.points.col.afterChange': '变动后积分 / 变动时间',
  'pages.points.col.adminAction': '管理员 / 操作',
  'pages.points.action.addOrDeduct': '增加 / 扣减',
  'pages.points.modal.title': '管理员积分操作',
  'pages.points.modal.label.mailbox': '邮箱',
  'pages.points.modal.label.memberName': '会员',
  'pages.points.modal.placeholder.reason': '请输入原因...',
  'pages.points.modal.button.addPoints': '积分 +',
  'pages.points.modal.button.deductPoints': '积分 -',
  'pages.points.modal.checkbox.confirmRequired': '信息和积分确认必选',
  'pages.points.modal.button.confirm': '确认',
  'pages.points.modal.button.cancel': '取消',
  'pages.points.modal.error.reasonRequired': '请输入原因',
  'pages.points.modal.error.confirmRequired': '需要确认',
  'pages.points.message.operationDone': '积分操作完成',
  'pages.points.message.fetchError': '加载积分明细失败',
  'pages.points.message.exportSuccess': 'Excel导出完成',
  'pages.points.message.exportError': '导出失败',

  // Coupon Usage (settlement page — new design)
  'pages.couponUsage.title': '优惠券使用明细',
  'pages.couponUsage.listTitle': '优惠券使用明细列表',
  'pages.couponUsage.period.today': '今日',
  'pages.couponUsage.period.month': '本月',
  'pages.couponUsage.period.quarter': '本季度',
  'pages.couponUsage.period.year': '本年',
  'pages.couponUsage.label.usedAmount': '使用金额',
  'pages.couponUsage.label.usedCount': '使用数量',
  'pages.couponUsage.label.monthlyUsedAmount': '月度使用金额',
  'pages.couponUsage.label.monthlyUsedCount': '月度使用数量',
  'pages.couponUsage.label.issueAmountQty': '发放金额/数量',
  'pages.couponUsage.label.useAmountQty': '使用金额/数量',
  'pages.couponUsage.label.remainAmountQty': '剩余金额/数量',
  'pages.couponUsage.chart.legend.amount': '使用金额',
  'pages.couponUsage.chart.legend.count': '使用次数',
  'pages.couponUsage.chart.daily': '日度',
  'pages.couponUsage.chart.monthly': '月度',
  'pages.couponUsage.viewMode.detail': '详细搜索',
  'pages.couponUsage.viewMode.summary': '简要搜索',
  'pages.couponUsage.filter.page': '每页',
  'pages.couponUsage.filter.startTime': '开始时间',
  'pages.couponUsage.filter.endTime': '结束时间',
  'pages.couponUsage.filter.couponType': '优惠券类型',
  'pages.couponUsage.filter.issueMethod': '发放方式',
  'pages.couponUsage.couponType.product': '商品优惠券',
  'pages.couponUsage.couponType.shipping': '运输优惠券',
  'pages.couponUsage.couponType.system': '系统优惠券',
  'pages.couponUsage.issueMethod.voucher': '兑换券',
  'pages.couponUsage.issueMethod.systemIssue': '系统发放',
  'pages.couponUsage.action.search': '搜索',
  'pages.couponUsage.action.download': '下载',
  'pages.couponUsage.filter.mailbox': '邮箱',
  'pages.couponUsage.filter.orderNumber': '订单号',
  'pages.couponUsage.filter.couponCode': '优惠券码',
  'pages.couponUsage.filter.memberName': '会员名',
  'pages.couponUsage.filter.createdAt': '创建时间',
  'pages.couponUsage.filter.couponName': '优惠券名称',
  'pages.couponUsage.col.no': '编号',
  'pages.couponUsage.col.mailboxMember': '邮箱 / 会员',
  'pages.couponUsage.col.orderInfo': '订单号 / 下单时间',
  'pages.couponUsage.col.typeMethod': '优惠券类型 / 发放方式',
  'pages.couponUsage.col.nameCode': '优惠券名称 / 编码',
  'pages.couponUsage.col.faceValueMin': '面值 / 最低订单金额',
  'pages.couponUsage.col.serialCreated': '流水号 / 创建时间',

  // Financial Records (settlement page — new design)
  'pages.financialRecords.title': '财务记录',
  'pages.financialRecords.listTitle': '财务记录列表',
  'pages.financialRecords.listNote': '一次支付费用 = 押金 / 优惠券 / 积分 + 一次银行入金 · 二次支付费用 = 押金 / 优惠券 + 二次银行入金',
  'pages.financialRecords.viewMode.detail': '详细查看',
  'pages.financialRecords.viewMode.summary': '简要查看',
  'pages.financialRecords.period.todayPaymentAmount': '今日支付金额',
  'pages.financialRecords.period.month': '本月',
  'pages.financialRecords.period.quarter': '本季度',
  'pages.financialRecords.period.year': '本年',
  'pages.financialRecords.stat.total': '全部',
  'pages.financialRecords.stat.bank': '银行转账',
  'pages.financialRecords.stat.card': '信用卡',
  'pages.financialRecords.stat.deposit': '押金',
  'pages.financialRecords.stat.first': '一次',
  'pages.financialRecords.stat.second': '二次',
  'pages.financialRecords.info.defaultIsTodayDone': '默认显示今日支付完成金额',
  'pages.financialRecords.info.clickShowsCorrespondingTime': '点击显示对应时段的支付完成金额',
  'pages.financialRecords.info.totalEqFirstSecond': '全部 = 一次 + 二次',
  'pages.financialRecords.info.totalEqBankCard': '全部 = 银行转账 + 信用卡',
  'pages.financialRecords.info.depositSeparate': '押金单独计算',
  'pages.financialRecords.info.systemTimeUtc9': '系统时间设为 UTC+9',
  'pages.financialRecords.info.shownAsCurrentResults': '以当日当时结果显示',
  'pages.financialRecords.info.recordedAsDailyAfter24h': '24小时后记录为当日数据',
  'pages.financialRecords.filter.page': '每页',
  'pages.financialRecords.filter.startTime': '开始时间',
  'pages.financialRecords.filter.endTime': '结束时间',
  'pages.financialRecords.filter.paymentSerialNo': '支付流水号',
  'pages.financialRecords.filter.platform': '平台',
  'pages.financialRecords.filter.region': '地区',
  'pages.financialRecords.filter.orderType': '订单类型',
  'pages.financialRecords.filter.shippingMethod': '运输方式',
  'pages.financialRecords.filter.appliedOrder': '适用订单',
  'pages.financialRecords.filter.depositUsage': '押金使用',
  'pages.financialRecords.filter.specialCase': '特殊件',
  'pages.financialRecords.filter.warehouseService': '仓库服务',
  'pages.financialRecords.filter.paymentNode': '支付节点',
  'pages.financialRecords.filter.paymentStatus': '支付状态',
  'pages.financialRecords.filter.matching': '匹配',
  'pages.financialRecords.filter.paymentMethod': '支付方式',
  'pages.financialRecords.filter.mailbox': '邮箱',
  'pages.financialRecords.filter.orderNumber': '订单号',
  'pages.financialRecords.filter.memberName': '会员名',
  'pages.financialRecords.filter.paymentAmount': '支付金额',
  'pages.financialRecords.filter.domesticTrackingNo': '国内运单号',
  'pages.financialRecords.filter.internationalTrackingNo': '国际运单号',
  'pages.financialRecords.filter.warehouseCode': '仓库代码',
  'pages.financialRecords.filter.includeMergedSourceOrders': '包含合并订单',
  'pages.financialRecords.filter.paymentAmountMin': '最小金额',
  'pages.financialRecords.filter.paymentAmountMax': '最大金额',
  'pages.financialRecords.includeMergedSourceOrders.yes': '包含',
  'pages.financialRecords.includeMergedSourceOrders.no': '不包含',
  'pages.financialRecords.platform.taobao': '淘宝',
  'pages.financialRecords.platform.self': '自营商城',
  'pages.financialRecords.platform.live': '直播频道',
  'pages.financialRecords.region.weihai': '威海',
  'pages.financialRecords.region.yiwu': '义乌',
  'pages.financialRecords.region.guangzhou': '广州',
  'pages.financialRecords.shippingMethod.air': '空运',
  'pages.financialRecords.shippingMethod.sea': '海运',
  'pages.financialRecords.shippingMethod.airExpress': '空运快递',
  'pages.financialRecords.shippingMethod.shipExpress': '海运快递',
  'pages.financialRecords.appliedOrder.coupon': '优惠券',
  'pages.financialRecords.appliedOrder.point': '积分',
  'pages.financialRecords.appliedOrder.both': '优惠券 + 积分',
  'pages.financialRecords.depositUsage.yes': '有',
  'pages.financialRecords.depositUsage.no': '无',
  'pages.financialRecords.specialCase.remote': '偏远',
  'pages.financialRecords.specialCase.simple': '简易',
  'pages.financialRecords.specialCase.remoteSimple': '偏远 + 简易',
  'pages.financialRecords.warehouseService.photo': '指定拍摄',
  'pages.financialRecords.warehouseService.smallBox': '小箱包装',
  'pages.financialRecords.warehouseService.bigBox': '大箱包装',
  'pages.financialRecords.warehouseService.sticker': '贴纸',
  'pages.financialRecords.warehouseService.split': '分拆出库',
  'pages.financialRecords.warehouseService.extra': '额外费用',
  'pages.financialRecords.paymentNode.first': '一次银行入金',
  'pages.financialRecords.paymentNode.second': '二次银行入金',
  'pages.financialRecords.paymentNode.integrated': '综合',
  'pages.financialRecords.paymentStatusOpt.done': '已支付',
  'pages.financialRecords.paymentStatusOpt.wait': '待支付',
  'pages.financialRecords.paymentStatusOpt.processing': '处理中',
  'pages.financialRecords.paymentStatusOpt.failed': '失败',
  'pages.financialRecords.paymentStatusOpt.refunded': '已退款',
  'pages.financialRecords.orderType.general': '普通',
  'pages.financialRecords.orderType.vvic': 'VVIC',
  'pages.financialRecords.orderType.rocket': '火箭',
  'pages.financialRecords.matching.auto': '自动匹配',
  'pages.financialRecords.matching.manual': '手动匹配',
  'pages.financialRecords.paymentMethodOpt.card': '信用卡',
  'pages.financialRecords.paymentMethodOpt.bank': '银行转账',
  'pages.financialRecords.paymentMethodOpt.deposit': '押金',
  'pages.financialRecords.action.search': '搜索',
  'pages.financialRecords.action.reset': '重置',
  'pages.financialRecords.action.download': '下载',
  'pages.financialRecords.col.no': '编号',
  'pages.financialRecords.col.orderNumber': '订单号',
  'pages.financialRecords.col.mailboxMember': '邮箱 / 会员',
  'pages.financialRecords.col.platformProduct': '平台 / 英文商品名',
  'pages.financialRecords.col.priceFeeShipping': '商品价格 / 手续费 / 国内运费',
  'pages.financialRecords.col.firstTotalRate': '一次支付费用 / 汇率',
  'pages.financialRecords.col.depositCouponPoint': '押金 / 优惠券 / 积分',
  'pages.financialRecords.col.firstFinal': '一次银行入金 / 状态 / 国内运单号',
  'pages.financialRecords.col.firstPayment': '一次方式 / 入金人 / 流水号',
  'pages.financialRecords.col.firstTimes': '申请时间 / 支付时间',
  'pages.financialRecords.col.routing': '路线',
  'pages.financialRecords.col.shippingCosts': '国际运费 / 偏远费 / 简易通关费',
  'pages.financialRecords.col.serviceCost': '服务费',
  'pages.financialRecords.col.secondTotalRate': '二次支付费用 / 汇率',
  'pages.financialRecords.col.depositOnly': '押金 / 优惠券',
  'pages.financialRecords.col.secondFinal': '二次银行入金 / 状态 / 国际运单号',
  'pages.financialRecords.col.secondPayment': '二次方式 / 入金人 / 流水号',
  'pages.financialRecords.col.secondTimes': '申请时间 / 支付时间',
  'pages.financialRecords.col.assignee': '类型 / 负责人 / 操作时间',
  'pages.financialRecords.related.mergedInto': '合并至',
  'pages.financialRecords.related.mergedFrom': '原订单',
  'pages.financialRecords.related.splitInto': '拆分为',
  'pages.financialRecords.cell.paymentDone': '已支付',
  'pages.financialRecords.cell.firstTeamLead': '一次大组长',
  'pages.live.sellers.products.column.originalPriceKrw': '原价',
  'pages.live.sellers.products.column.salePriceKrw': '销售价',
  'pages.live.sellers.products.column.amountOnSale': '库存',
  'pages.live.sellers.products.inlineEdit.editTitle': '修改商品名称',
  'pages.live.sellers.products.inlineEdit.editPrice': '修改价格',
  'pages.live.sellers.products.inlineEdit.editCompanyName': '修改商家名',
  'pages.live.sellers.products.inlineEdit.save': '保存',
  'pages.live.sellers.products.inlineEdit.cancel': '取消',
  'pages.live.sellers.products.inlineEdit.success': '已修改',
  'pages.live.sellers.products.inlineEdit.failed': '修改失败',
  'pages.orders.detail.firstPayment': '一次支付',
  'pages.orders.detail.firstPaymentForMergedOrder': '一次支付 ({orderNumber})',
  'pages.orders.detail.secondPayment': '二次支付',
  'pages.orders.detail.paymentMethod.bank': '银行转账',
  'pages.orders.detail.paymentMethod.bankDeposit': '银行转账+余额',
  'pages.orders.detail.paymentMethod.billgate': 'Billgate',
  'pages.orders.detail.paymentMethod.cardDeposit': '卡支付+余额',
  'pages.orders.detail.paymentMethod.deposit': '余额',
  'pages.orders.detail.paymentMethod.points': '积分',
  'pages.orders.detail.netPaymentAmount': '1次支付合计',
  'pages.orders.detail.depositUsedAmount': '余额',
  'pages.orders.detail.bankDepositAmount': '银行转账金额',
  'pages.members.activeUsers.title': '活跃用户',
  'pages.members.activeUsers.currentActive': '当前活跃',
  'pages.members.activeUsers.loggedInUsers': '登录用户',
  'pages.members.activeUsers.anonymousVisitors': '匿名访客',
  'pages.members.activeUsers.lastSample': '最后采样',
  'pages.members.activeUsers.historyTitle': '活跃用户历史',
  'pages.members.activeUsers.total': '总计',
  'pages.members.activeUsers.loggedIn': '已登录',
  'pages.members.activeUsers.anonymous': '匿名',
  'pages.members.activeUsers.loggedInTableTitle': '当前活跃登录用户',
  'pages.members.activeUsers.anonymousTableTitle': '匿名访客',
  'pages.members.activeUsers.anonymousHint': '按 visitorId 最多显示 50 个活跃匿名访客。',
  'pages.members.activeUsers.memberId': '会员 ID',
  'pages.members.activeUsers.name': '姓名',
  'pages.members.activeUsers.email': '邮箱',
  'pages.members.activeUsers.platform': '平台',
  'pages.members.activeUsers.category': '分类',
  'pages.members.activeUsers.lastActive': '最后活跃',
  'pages.members.activeUsers.visitorId': '访客 ID',
  'pages.members.activeUsers.platform.web': '网页',
  'pages.members.activeUsers.platform.android': 'Android',
  'pages.members.activeUsers.platform.ios': 'iOS',
  'pages.members.activeUsers.platform.unknown': '未知',
  'pages.members.activeUsers.category.seller': '卖家',
  'pages.members.activeUsers.category.business': '企业',
  'pages.members.activeUsers.category.general': '普通',
  'pages.members.activeUsers.granularity.hour': '按小时',
  'pages.members.activeUsers.granularity.day': '按天',
  'pages.members.activeUsers.granularity.month': '按月',
  'pages.members.activeUsers.granularity.year': '按年',
  'pages.members.activeUsers.botSuspectedCard': '疑似机器人',
  'pages.members.activeUsers.botSuspected': '疑似机器人',
  'pages.members.activeUsers.verdict': '判定',
  'pages.members.activeUsers.verdictNormal': '正常',
  'pages.members.activeUsers.requestsLastHour': '近1小时请求',
  'pages.members.activeUsers.requestsTotal': '请求总数(7天)',
  'pages.members.activeUsers.topEndpoint': '主要接口',
  'pages.members.activeUsers.botReason.highRate': '请求过多',
  'pages.members.activeUsers.botReason.botUserAgent': '机器人UA',
  'pages.members.activeUsers.botReason.endpointConcentration': '集中单一接口',
  'pages.members.activeUsers.ipStatsTitle': '按IP请求排行',
  'pages.members.activeUsers.ipStatsHint':
    '全站 API 请求量最高的 IP，不是 1688/淘宝详情专项。封禁爬虫请用上方表格。',
  'pages.members.activeUsers.currentlyActive': '当前在线',
  'pages.members.activeUsers.currentlyActiveYes': '在线',
  'pages.members.activeUsers.currentlyActiveNo': '无socket',
  'pages.members.activeUsers.lastRequestAt': '最后请求',
  'pages.members.activeUsers.adminTraffic': '管理后台流量',
  'pages.members.activeUsers.purposeAlert':
    '本页用于发现并封禁大量调用 1688/淘宝商品详情 API 的 IP。Socket 在线人数仅供参考。',
  'pages.members.activeUsers.marketplaceTitle': '1688/淘宝商品详情超量 IP',
  'pages.members.activeUsers.marketplaceHint':
    '只统计 1688/淘宝的 GET /v1/products/detail 以及对应详情路径。搜索、帮助中心、管理后台 API 不计入。近 1 小时详情超过 80 次，或不同商品超过 40 个即标记超量。封禁后该 IP 无法访问 /v1/products 市场 API。',
  'pages.members.activeUsers.detailLastHour': '详情（1小时）',
  'pages.members.activeUsers.detailTotal': '详情（7天）',
  'pages.members.activeUsers.uniqueLastHour': '独立商品（1小时）',
  'pages.members.activeUsers.uniqueTotal': '独立商品（7天）',
  'pages.members.activeUsers.detail1688Hour': '1688详情（1小时）',
  'pages.members.activeUsers.detailTaobaoHour': '淘宝详情（1小时）',
  'pages.members.activeUsers.abusiveCount': '超量可疑 IP',
  'pages.members.activeUsers.blockedCount': '已封禁 IP',
  'pages.members.activeUsers.verdictAbuse': '详情超量',
  'pages.members.activeUsers.abuseReason.high-detail-rate': '详情请求过多',
  'pages.members.activeUsers.abuseReason.many-unique-products': '独立商品过多',
  'pages.members.activeUsers.block7d': '封禁7天',
  'pages.members.activeUsers.blockPermanent': '永久封禁',
  'pages.members.activeUsers.unblock': '解除封禁',
  'pages.members.activeUsers.blockConfirm7d': '将该 IP 的 1688/淘宝商品 API 封禁 7 天？',
  'pages.members.activeUsers.blockConfirmPermanent': '永久封禁该 IP 的 1688/淘宝商品 API？',
  'pages.members.activeUsers.unblockConfirm': '解除该 IP 的封禁？',
  'pages.members.activeUsers.blockSuccess': '已封禁，商品 API 立即拒绝该 IP。',
  'pages.members.activeUsers.unblockSuccess': '已解除封禁。',
  'pages.members.activeUsers.blockedListTitle': '已封禁 IP',
  'pages.members.activeUsers.blockedUntil': '到期',
  'pages.members.activeUsers.blockedUntilPermanent': '永久',
  'pages.members.activeUsers.blockedBy': '操作管理员',
  'pages.members.activeUsers.blockedReason': '原因',
  'pages.members.activeUsers.action': '操作',
  'pages.financialRecords.message.exportError': 'Excel导出失败',

  // 库存管理（自营商城仓库）
  'pages.ownWarehouse.title': '仓库管理',
  'pages.ownWarehouse.subtitle': '仓库列表及管理',
  'pages.ownWarehouse.loadFailed': '数据加载失败。',
  'pages.ownWarehouse.saveFailed': '保存失败。',
  'pages.ownWarehouse.deleteFailed': '删除失败。',
  'pages.ownWarehouse.createSuccess': '仓库已添加。',
  'pages.ownWarehouse.updateSuccess': '仓库信息已修改。',
  'pages.ownWarehouse.deleteSuccess': '仓库已删除。',
  'pages.ownWarehouse.deleteConfirmTitle': '删除仓库',
  'pages.ownWarehouse.deleteConfirmContent': '确定删除仓库"{name}"？仍有库存时无法删除。',
  'pages.ownWarehouse.addWarehouse': '添加仓库',
  'pages.ownWarehouse.editWarehouse': '修改仓库',
  'pages.ownWarehouse.save': '保存',
  'pages.ownWarehouse.cancel': '取消',
  'pages.ownWarehouse.searchPlaceholder': '搜索仓库名称',
  'pages.ownWarehouse.totalWarehouses': '共 {total} 个仓库',
  'pages.ownWarehouse.status.all': '全部状态',
  'pages.ownWarehouse.status.active': '使用中',
  'pages.ownWarehouse.status.inactive': '停用',
  'pages.ownWarehouse.columns.name': '仓库名称',
  'pages.ownWarehouse.columns.address': '仓库地址',
  'pages.ownWarehouse.columns.productKinds': '商品种类',
  'pages.ownWarehouse.columns.totalStock': '总库存数量',
  'pages.ownWarehouse.columns.createdAt': '创建日期',
  'pages.ownWarehouse.columns.updatedAt': '最近修改日',
  'pages.ownWarehouse.columns.status': '状态',
  'pages.ownWarehouse.columns.actions': '管理',
  'pages.ownWarehouse.columns.image': '商品图片',
  'pages.ownWarehouse.columns.productTitle': '商品名 / 选项',
  'pages.ownWarehouse.columns.productNo': '商品编号',
  'pages.ownWarehouse.columns.inboundTotal': '入库总数量',
  'pages.ownWarehouse.columns.stock': '当前库存数量',
  'pages.ownWarehouse.columns.costPrice': '原价',
  'pages.ownWarehouse.columns.salePrice': '售价',
  'pages.ownWarehouse.columns.stockStatus': '库存状态',
  'pages.ownWarehouse.columns.mallLink': '商城链接',
  'pages.ownWarehouse.columns.skuCount': 'SKU数量',
  'pages.ownWarehouse.columns.option': '选项',
  'pages.ownWarehouse.actions.detail': '仓库详情',
  'pages.ownWarehouse.actions.edit': '修改',
  'pages.ownWarehouse.actions.delete': '删除',
  'pages.ownWarehouse.form.name': '仓库名称',
  'pages.ownWarehouse.form.namePlaceholder': '请输入仓库名称',
  'pages.ownWarehouse.form.nameRequired': '请输入仓库名称。',
  'pages.ownWarehouse.form.address': '仓库地址',
  'pages.ownWarehouse.form.addressPlaceholder': '请输入仓库地址',
  'pages.ownWarehouse.form.addressRequired': '请输入仓库地址。',
  'pages.ownWarehouse.form.manager': '负责人',
  'pages.ownWarehouse.form.managerPlaceholder': '请输入负责人姓名',
  'pages.ownWarehouse.form.contact': '联系方式',
  'pages.ownWarehouse.form.contactPlaceholder': '请输入联系方式',
  'pages.ownWarehouse.form.memo': '备注',
  'pages.ownWarehouse.form.memoPlaceholder': '请输入备注（可选）',
  'pages.ownWarehouse.stockStatus.normal': '正常',
  'pages.ownWarehouse.stockStatus.lowStock': '库存不足',
  'pages.ownWarehouse.stockStatus.outOfStock': '售罄',
  'pages.ownWarehouse.tabs.items': '库存商品列表',
  'pages.ownWarehouse.tabs.info': '仓库信息',
  'pages.ownWarehouse.stats.productKinds': '商品种类 (SKU)',
  'pages.ownWarehouse.stats.totalInbound': '总入库数量',
  'pages.ownWarehouse.stats.totalStock': '总库存数量',
  'pages.ownWarehouse.stats.outOfStock': '售罄商品',
  'pages.ownWarehouse.stats.kindsUnit': '种',
  'pages.ownWarehouse.stats.piecesUnit': '个',
  'pages.ownWarehouse.addProducts': '添加商品',
  'pages.ownWarehouse.itemSearchPlaceholder': '搜索商品名或商品编号',
  'pages.ownWarehouse.totalItems': '共 {total} 个商品',
  'pages.ownWarehouse.removeConfirmTitle': '移除商品',
  'pages.ownWarehouse.removeConfirmContent': '确定将"{name}"从该仓库移除？其剩余库存记录（{stock}）也将一并移除。',
  'pages.ownWarehouse.removeSuccess': '商品已从仓库移除。',
  'pages.ownWarehouse.bulkRemove': '批量删除 ({count})',
  'pages.ownWarehouse.bulkRemoveConfirmTitle': '批量移除商品',
  'pages.ownWarehouse.bulkRemoveConfirmContent': '确定将所选的 {count} 个商品从该仓库移除？其剩余库存记录（{stock}）也将一并移除。',
  'pages.ownWarehouse.bulkRemoveSuccess': '已从仓库移除 {count} 个商品。',
  'pages.ownWarehouse.picker.title': '注册自营商城商品',
  'pages.ownWarehouse.picker.loadFailed': '商品列表加载失败。',
  'pages.ownWarehouse.picker.noneSelected': '请选择要添加的商品。',
  'pages.ownWarehouse.picker.addResult': '已添加 {added} 个商品。（{skipped} 个已注册，跳过）',
  'pages.ownWarehouse.picker.addFailed': '添加商品失败。',
  'pages.ownWarehouse.picker.addSelected': '添加所选商品 ({count})',
  'pages.ownWarehouse.picker.searchPlaceholder': '按商品名 / OfferId / UniqueNo 搜索',
  'pages.ownWarehouse.picker.totalProducts': '共 {total} 个',
  'pages.ownWarehouse.picker.columns.image': '图片',
  'pages.ownWarehouse.picker.columns.title': '商品名',
  'pages.ownWarehouse.picker.columns.productNo': '商品编号',
  'pages.ownWarehouse.picker.columns.salePrice': '售价',
  'pages.ownWarehouse.txn.inboundTitle': '库存入库',
  'pages.ownWarehouse.txn.outboundTitle': '库存出库',
  'pages.ownWarehouse.txn.confirm': '确认',
  'pages.ownWarehouse.txn.reason': '事由',
  'pages.ownWarehouse.txn.noQuantity': '请至少输入1个数量。',
  'pages.ownWarehouse.txn.inboundSuccess': '入库已处理。',
  'pages.ownWarehouse.txn.outboundSuccess': '出库已处理。',
  'pages.ownWarehouse.txn.failed': '处理失败。',
  'pages.ownWarehouse.txn.inboundQty': '入库数量',
  'pages.ownWarehouse.txn.outboundQty': '出库数量',
  'pages.ownWarehouse.reason.normalInbound': '正常入库',
  'pages.ownWarehouse.reason.returnInbound': '退货入库',
  'pages.ownWarehouse.reason.correction': '误操作修正',
  'pages.ownWarehouse.reason.saleOutbound': '销售出库',
  'pages.ownWarehouse.reason.disposal': '废弃',
  'pages.ownWarehouse.reason.inboundTypo': '入库误记更正',
  'pages.ownWarehouse.reason.outboundTypo': '出库误记更正',
  'pages.ownWarehouse.reason.stocktaking': '库存盘点',
  'pages.ownWarehouse.reason.damageLoss': '破损·遗失',
  'pages.ownWarehouse.adjust.title': '库存修改',
  'pages.ownWarehouse.adjust.hint': '用于更正误记的入库或出库。只修改错误的数值即可，所有修改都会连同事由记入日志。',
  'pages.ownWarehouse.adjust.newInbound': '入库总数（修改后）',
  'pages.ownWarehouse.adjust.newStock': '库存数量（修改后）',
  'pages.ownWarehouse.adjust.memoPlaceholder': '备注（例：误记为入库11件，实际10件）',
  'pages.ownWarehouse.adjust.noChanges': '没有任何数值被更改。',
  'pages.ownWarehouse.adjust.reasonRequired': '请选择修改事由。',
  'pages.ownWarehouse.adjust.stockOverInbound': '{option}：库存数量不能超过入库总数。',
  'pages.ownWarehouse.adjust.success': '库存已修改。',
  'pages.ownWarehouse.log.title': '■ 出入库日志 - 仓库 : {name}',
  'pages.ownWarehouse.log.productTitle': '■ 出入库日志 - 商品 : {name}',
  'pages.ownWarehouse.log.button': '出入库日志',
  'pages.ownWarehouse.log.warehouseButton': '出入库记录',
  'pages.ownWarehouse.log.loadFailed': '日志加载失败。',
  'pages.ownWarehouse.log.noLogs': '暂无日志。',
  'pages.ownWarehouse.log.system': '系统',
  'pages.ownWarehouse.log.orderNo': '订单号',
  'pages.ownWarehouse.log.columns.processor': '处理者',
  'pages.ownWarehouse.log.columns.content': '内容',
  'pages.ownWarehouse.log.columns.detail': '详细',
  'pages.ownWarehouse.log.columns.time': '时间',
  'pages.ownWarehouse.log.type.productAdd': '商品注册',
  'pages.ownWarehouse.log.type.productRemove': '商品移除',
  'pages.ownWarehouse.log.type.inbound': '入库',
  'pages.ownWarehouse.log.type.outbound': '出库',
  'pages.ownWarehouse.log.type.orderOutbound': '订单出库',
  'pages.ownWarehouse.log.type.adjust': '库存修改',
  'pages.ownWarehouse.orderOutbound.button': '库存出库',
  'pages.ownWarehouse.orderOutbound.title': '库存出库 - 选择仓库',
  'pages.ownWarehouse.orderOutbound.loadFailed': '仓库信息加载失败。',
  'pages.ownWarehouse.orderOutbound.noWarehouse': '没有仓库持有该商品。',
  'pages.ownWarehouse.orderOutbound.noMatch': '选项未匹配',
  'pages.ownWarehouse.orderOutbound.stockLabel': '持有库存',
  'pages.ownWarehouse.orderOutbound.confirmTitle': '确认库存出库',
  'pages.ownWarehouse.orderOutbound.confirmContent': '确定从仓库"{warehouse}"出库 {option} {qty} 个？',
  'pages.ownWarehouse.orderOutbound.success': '已从"{warehouse}"出库。（剩余库存 {stockAfter} 个）',
  'pages.ownWarehouse.orderOutbound.insufficient': '仓库"{warehouse}"的库存（{stock}个）少于订单数量（{qty}个）。',
  'pages.ownWarehouse.orderOutbound.loading': '正在查询仓库...',
  'pages.ownWarehouse.orderOutbound.showOtherOptions': '查看其他选项（{count}）',
  'pages.ownWarehouse.orderOutbound.done': '已库存出库',
  'pages.ownWarehouse.orderOutbound.doneTooltip': '已从仓库"{warehouse}"出库 {qty} 个 · {time}',
  'pages.ownWarehouse.orderOutbound.movedToPacking': '订单所有商品均已库存出库，订单已转为仓打包中。',

  // 상품 등록 다국어 입력 언어 탭
  'pages.products.add.langTab.ko': '韩语',
  'pages.products.add.langTab.cn': '中文',
  'pages.products.add.langTab.en': '英语',
  'pages.products.add.langTab.all': '全部语言',
  'pages.products.add.langTab.hint': '适用于标题、选项、规格输入框。输入中文时自动翻译韩语/英语。',
  'pages.products.add.bulkBar.scopeAll': '列标题的批量按钮将应用到全部行',
  'pages.products.add.bulkBar.scopeSelected':
    '列标题的批量按钮仅应用到所选 {count} 行',
  'pages.products.add.bulkBar.apply': '应用',
  'pages.products.add.marketplaceCategoryMissing': '未获取到',
  'pages.products.add.categoryNotDetermined': '未能获取原站类目 — 请手动选择类目。',
  'pages.products.add.categoryAutoCreated':
    '已新建并选择类目“{path}”— 名称可在类目管理中修改。',
  'pages.products.add.categoryAutoCreateFailed': '类目自动新建失败 — 请手动选择。',
  'pages.products.add.marketplaceCategoryPath': '原站类目：{path}',
  'pages.products.add.newCategory.marketplacePath': '原站类目：{path}',
  'pages.products.add.newCategory.open': '没有合适的类目？新建一个',
  'pages.products.add.newCategory.title': '新建类目',
  'pages.products.add.newCategory.ok': '新建并选择',
  'pages.products.add.newCategory.levelHint': '将新建 {level} 级类目 — {path}',
  'pages.products.add.newCategory.rootLevel': '顶级',
  'pages.products.add.newCategory.rootPlaceholder': '留空则新建顶级类目',
  'pages.products.add.newCategory.level2Placeholder': '留空则新建 2 级类目',
  'pages.products.add.newCategory.nameKo': '类目名称（韩语）',
  'pages.products.add.newCategory.nameKoRequired': '请填写韩语名称。',
  'pages.products.add.newCategory.nameZh': '中文名称',
  'pages.products.add.newCategory.nameZhHint':
    '填写原网站常用词（连衣裙·运动鞋…），以后导入时会自动匹配到该类目。',
  'pages.products.add.newCategory.nameEn': '英文名称',
  'pages.products.add.newCategory.duplicate': '同一位置已存在同名类目。',
  'pages.products.add.newCategory.created': '已新建类目“{path}”。',
  'pages.products.add.newCategory.failed': '类目新建失败。',
  'pages.products.add.categoryAutoPicked':
    '已将类目设为“{path}”— 不合适请手动修改。',
  'pages.products.add.bulkBar.valueRequired': '请输入要应用的值。',
  'pages.products.add.bulkBar.setPlaceholder': '设定值',
  'pages.products.add.bulkBar.salePriceUpdated': '已批量修改售价',
  'pages.products.add.bulkBar.originalKrwUpdated': '已批量修改原价（₩）',
  'pages.products.add.bulkBar.originalCnyUpdated': '已批量修改原价（人民币）',
  'pages.products.add.bulkBar.tagPriceUpdated': '已批量修改标价',
  'pages.products.add.bulkBar.stockUpdated': '已批量修改库存',
  'pages.products.add.skuTable.originalCny': '原价（人民币）',
  'pages.products.add.skuTable.originalKrw': '原价（₩）',
  'pages.products.add.skuTable.salePrice': '售价（₩）',
  'pages.products.add.skuTable.tagPrice': '标价（₩）',
  'pages.products.add.skuTable.image': '图片',
  'pages.ownWarehouse.picker.allStores': '全部店铺',
  'pages.products.add.editor.translateDescription': '中→韩 翻译',
  'pages.products.add.descTranslateDone': '已翻译 {count} 处详情文本。',
  'pages.products.add.descTranslateNone': '没有需要翻译的中文文本。',
  'pages.products.add.descTranslateFailed': '翻译失败，请稍后重试。',
  'pages.products.add.refineTitle.button': 'AI 标题精简',
  'pages.products.add.refineTitle.restore': '恢复原标题',
  'pages.products.add.refineTitle.tooltip': '去掉长标题中的多余词语，只保留商品名。三种语言会一起更新。',
  'pages.products.add.refineTitle.empty': '请先输入要精简的标题。',
  'pages.products.add.refineTitle.unchanged': '标题无法进一步精简，已保留原标题。',
  'pages.products.add.refineTitle.done': '标题已精简，可恢复为原标题。',
  'pages.products.add.refineTitle.failed': '标题精简失败，请稍后重试。',
  // 공유 리베이트 (share rebate) — 설정 · 모니터링 · 주문 상세 공유 귀속 카드
  'pages.shareRebate.status.pending': '待入账',
  'pages.shareRebate.status.held': '暂扣',
  'pages.shareRebate.status.confirmed': '已确认',
  'pages.shareRebate.status.paid': '已发放',
  'pages.shareRebate.status.cancelled': '已取消',
  'pages.shareRebate.status.reversed': '已追回',
  'pages.shareRebate.source.live': '直播',
  'pages.shareRebate.source.ownmall': '自营商城',
  'pages.shareRebate.source.1688': '1688',
  'pages.shareRebate.source.taobao': '淘宝',
  'pages.shareRebate.source.vvic': 'VVIC',
  'pages.shareRebate.tier.label': '第{tier}层',
  'pages.shareRebate.tier.role.1': '分享者',
  'pages.shareRebate.tier.role.2': '分享者的上级',
  'pages.shareRebate.tier.role.3': '上级的上级',
  'pages.shareRebate.attributionStatus.awaiting_payment': '待付款',
  'pages.shareRebate.attributionStatus.active': '进行中',
  'pages.shareRebate.attributionStatus.settled': '已结算',
  'pages.shareRebate.attributionStatus.void': '无效',
  'pages.shareRebate.attributionStatus.needs_review': '需审核',
  'pages.shareRebate.risk.missing_user_price': '缺少售价',
  'pages.shareRebate.risk.failed_external_orders': '外部下单失败',
  'pages.shareRebate.risk.same_phone': '分享者与买家手机号相同',
  'pages.shareRebate.risk.recipient_is_sharer': '收件人为分享者',
  'pages.shareRebate.risk.family_too_large': '订单家族超过200单',
  'pages.shareRebate.risk.marker_gap': '归属标记缺失',
  'pages.shareRebate.risk.refund_reason_unparsed': '无法解析退款原因',
  'pages.shareRebate.risk.markers_missing': '无归属标记',
  'pages.shareRebate.reason.risk': '风险标记',
  'pages.shareRebate.reason.admin': '管理员',
  'pages.shareRebate.reason.released': '解除暂扣',
  'pages.shareRebate.reason.sharer_suspended': '分享者被停用',
  'pages.shareRebate.reason.monthly_cap': '超过月上限',
  'pages.shareRebate.reason.order_cancelled_or_refunded': '订单取消/退款',
  'pages.shareRebate.reason.zero_amount': '金额为0',
  'pages.shareRebate.reason.below_minimum': '低于最低发放额',
  'pages.shareRebate.skip.buyer_in_chain': '买家本人在链条中',
  'pages.shareRebate.skip.guest_account': '游客账号',
  'pages.shareRebate.skip.suspended': '已停用的分享者',
  'pages.shareRebate.skip.user_missing': '会员不存在',
  'pages.shareRebate.skip.user_deleted': '已注销会员',
  'pages.shareRebate.skip.user_blacklisted': '黑名单会员',
  'pages.shareRebate.relationSource.signup': '分享访问期间注册',
  'pages.shareRebate.relationSource.first_purchase': '分享归属的首次付款',
  'pages.shareRebate.relationSource.admin': '管理员指定',
  'pages.shareRebate.relationAction.sponsor_assigned': '指定上级',
  'pages.shareRebate.relationAction.sponsor_changed': '变更上级',
  'pages.shareRebate.relationAction.suspended': '停用',
  'pages.shareRebate.relationAction.unsuspended': '解除停用',
  'pages.shareRebate.taskType.reconcile_order': '订单复核',
  'pages.shareRebate.taskType.reconcile_attribution': '归属复核',
  'pages.shareRebate.taskType.checkout_incident': '结账异常记录',
  'pages.shareRebate.scope.all_items': '归属订单的全部商品',
  'pages.shareRebate.scope.shared_product_only': '仅分享的商品',
  'pages.shareRebate.payoutMode.auto': '自动发放',
  'pages.shareRebate.payoutMode.manual_approval': '管理员审批后发放',
  'pages.shareRebate.lang.ko': '韩语',
  'pages.shareRebate.lang.en': '英语',
  'pages.shareRebate.lang.zh': '中文',
  'pages.shareRebate.reasonModal.label': '原因',
  'pages.shareRebate.reasonModal.placeholder': '请输入原因，将记录在操作日志和历史中。',
  'pages.shareRebate.reasonModal.required': '请输入原因。',
  'pages.shareRebate.reasonModal.ok': '确认',
  'pages.shareRebate.settings.featureOff': '服务器功能开关(FEATURE_SHARE_REBATE)已关闭，保存后也不会生效',
  'pages.shareRebate.settings.readOnly': '只读。如需修改，需要分享返利设置的编辑权限。',
  'pages.shareRebate.settings.loadFailed': '无法加载分享返利设置。',
  'pages.shareRebate.settings.section.program': '方案',
  'pages.shareRebate.settings.section.rates': '普通费率 — 层级 × 来源 (%)',
  'pages.shareRebate.settings.section.periods': '期限·上限',
  'pages.shareRebate.settings.section.sponsor': '上级指定',
  'pages.shareRebate.settings.section.disclosure': '公开文案（经济利益披露）',
  'pages.shareRebate.settings.state.live': '运行中',
  'pages.shareRebate.settings.state.off': '已关闭',
  'pages.shareRebate.settings.lastUpdated': 'v{version} · 最后保存 {time} · {admin}',
  'pages.shareRebate.settings.enabled': '开启分享返利',
  'pages.shareRebate.settings.enabledHelp': '开启后，分享链接访问和付款将产生返利。服务器功能开关也必须开启。',
  'pages.shareRebate.settings.payoutMode': '发放方式',
  'pages.shareRebate.settings.payoutModeHelp': '自动：确认后立即存入预存款。审批：需管理员在明细中批准发放后才入账。',
  'pages.shareRebate.settings.scope': '归属范围',
  'pages.shareRebate.settings.scopeHelp': '决定通过分享链接进入的买家在期限内订单中，哪些商品计入返利。',
  'pages.shareRebate.settings.grid.tier': '层级',
  'pages.shareRebate.settings.grid.rowTotal': '行合计',
  'pages.shareRebate.settings.grid.columnTotal': '来源合计',
  'pages.shareRebate.settings.grid.columnTotalHint': '同一来源第1~3层合计（最多{max}%）',
  'pages.shareRebate.settings.grid.hint': '已付款商品金额（优惠券后，不含运费·手续费）× %。每格0~{max}%，最多两位小数，同一来源第1~3层合计不得超过{total}%。0%表示该层·来源不发放。',
  'pages.shareRebate.settings.grid.legalNote': '第2层及以上的发放可能被《访问销售法》认定为多层次销售，正式上线前需进行法律审查',
  'pages.shareRebate.settings.field.rate': '{tier} · {source}',
  'pages.shareRebate.settings.field.disclosureText': '公开文案（{lang}）',
  'pages.shareRebate.settings.windowDays': '归属期限',
  'pages.shareRebate.settings.windowDaysHelp': '访问分享链接后此期限内的付款计入归属（1~30天，最后点击优先）。',
  'pages.shareRebate.settings.creditOnShipmentNote': '订单出库完成后返利立即确认并入账（无签收等待和暂扣期）。出库前会员页面显示为“未入账”。',
  'pages.shareRebate.settings.holdDays': '暂扣期限',
  'pages.shareRebate.settings.holdDaysHelp': '签收后经过此期限才确认·发放（0~60天）。',
  'pages.shareRebate.settings.deliveredFallbackDays': '视为签收',
  'pages.shareRebate.settings.deliveredFallbackDaysHelp': '无签收记录时，出库后经过此期限视为已签收（1~120天）。',
  'pages.shareRebate.settings.perOrderCapKRW': '单笔订单上限',
  'pages.shareRebate.settings.perOrderCapKRWHelp': '每位领取人在一笔订单中可获得的最高金额。0 = 无上限。',
  'pages.shareRebate.settings.monthlyCapKRW': '月上限',
  'pages.shareRebate.settings.monthlyCapKRWHelp': '每位领取人每月（KST）可获得的最高金额，超出部分作废。0 = 无上限。',
  'pages.shareRebate.settings.minPayoutKRW': '最低发放额',
  'pages.shareRebate.settings.minPayoutKRWHelp': '确认时低于此金额的不发放。0 = 1韩元以上全部发放。',
  'pages.shareRebate.settings.unit.days': '天',
  'pages.shareRebate.settings.unit.krw': '韩元',
  'pages.shareRebate.settings.sponsorOnSignup': '分享访问期间注册时指定上级',
  'pages.shareRebate.settings.sponsorOnSignupHelp': '通过分享链接进入并注册的会员，其上级设为该分享者。',
  'pages.shareRebate.settings.sponsorOnFirstPurchase': '分享归属的首次付款时指定上级',
  'pages.shareRebate.settings.sponsorOnFirstPurchaseHelp': '没有上级的会员在首次归属付款时，将第1层分享者设为上级。以先发生者为准，不会自动变更。默认关闭 — 老会员需在讲师链接上点击［加入团队］才会加入团队。',
  'pages.shareRebate.settings.friendCoupon.title': '好友首单优惠券',
  'pages.shareRebate.settings.friendCoupon.label': '发给好友的优惠券',
  'pages.shareRebate.settings.friendCoupon.help': '通过分享链接进入且从未付款的会员，每人自动发放1次。只能选择启用中、数量不限的普通商品优惠券。选中的优惠券不会出现在公开优惠券列表中，也不能通过券码领取。',
  'pages.shareRebate.settings.friendCoupon.none': '不使用',
  'pages.shareRebate.settings.friendCoupon.benefitFixed': '减{amount}韩元',
  'pages.shareRebate.settings.friendCoupon.benefitPercent': '{percent}%折扣',
  'pages.shareRebate.settings.friendCoupon.minPurchase': '满{amount}韩元',
  'pages.shareRebate.settings.friendCoupon.validity': '{n}天',
  'pages.shareRebate.settings.friendCoupon.unavailable': '该优惠券目前无法使用',
  'pages.shareRebate.settings.friendCoupon.unavailableHelp': '已保存的优惠券已停用或不再符合条件（数量不限、普通商品优惠），目前不会发给好友。请选择其他优惠券或改为［不使用］后保存。',
  'pages.shareRebate.settings.friendCoupon.unavailableOption': '无法使用的优惠券（{id}）',
  'pages.shareRebate.settings.friendCoupon.noCandidates': '没有可选的优惠券。请先在优惠券管理中创建启用中、数量不限的普通商品优惠券（注册或推荐自动发放券除外）。',
  'pages.shareRebate.settings.friendCoupon.loadFailed': '无法加载优惠券列表。',
  'pages.shareRebate.settings.banner.title': '商品详情分享横幅',
  'pages.shareRebate.settings.banner.help': '在商品详情页代替分享按钮显示此图片，点击后打开分享窗口。仅在分享可获返利的商品上显示（计划已开启且该商品来源的第1层比例大于0），其他商品仍显示原分享按钮。保存后最多可能需要5分钟才会在商城显示。',
  'pages.shareRebate.settings.banner.enabled': '显示横幅',
  'pages.shareRebate.settings.banner.state.on': '开启',
  'pages.shareRebate.settings.banner.state.off': '关闭',
  'pages.shareRebate.settings.banner.pcImage': 'PC图片（必填）',
  'pages.shareRebate.settings.banner.mobileImage': '手机图片（可选）',
  'pages.shareRebate.settings.banner.pcHint': '显示在PC购买按钮下方，按其宽度（约350~366px）缩放，不会裁剪，高度按图片比例。上传时会裁掉透明边距，并转为宽度最大1200px的WebP保存。建议：约{size}的横向长图。',
  'pages.shareRebate.settings.banner.mobileHint': '在手机上显示于数量下方，按屏幕宽度（最大480px）缩放。留空则使用PC图片。',
  'pages.shareRebate.settings.banner.mobileFallback': '使用PC图片',
  'pages.shareRebate.settings.banner.uploadInfo': '已保存：{size} · {kb}KB WebP',
  'pages.shareRebate.settings.banner.uploadInfoTrimmed': '已保存：{size} · {kb}KB WebP（已裁掉透明边距）',
  'pages.shareRebate.settings.banner.upload': '上传图片',
  'pages.shareRebate.settings.banner.change': '更换图片',
  'pages.shareRebate.settings.banner.clear': '删除',
  'pages.shareRebate.settings.banner.uploaded': '图片已上传。需点击[保存横幅]才会生效。',
  'pages.shareRebate.settings.banner.uploadFailed': '图片上传失败。',
  'pages.shareRebate.settings.banner.notImage': '只能上传JPG、PNG、GIF、WEBP图片。',
  'pages.shareRebate.settings.banner.tooLarge': '只能上传{max}MB以下的图片。',
  'pages.shareRebate.settings.banner.save': '保存横幅',
  'pages.shareRebate.settings.banner.reset': '还原',
  'pages.shareRebate.settings.banner.saved': '横幅已保存。',
  'pages.shareRebate.settings.banner.saveFailed': '横幅保存失败。',
  'pages.shareRebate.settings.banner.needPcImage': '开启横幅前请先上传PC图片。',
  'pages.shareRebate.settings.banner.programOff': '分享返利计划已关闭，目前商城不会显示横幅。计划开启后，会在分享可获返利的商品上显示。',
  'pages.shareRebate.settings.banner.unsaved': '有未保存的横幅修改。',
  'pages.shareRebate.settings.banner.separateSave': '横幅与上方比例设置分开保存，不记录变更历史和原因。',
  'pages.shareRebate.settings.banner.lastUpdated': '最后保存 {time} · {admin}',
  'pages.shareRebate.settings.disclosureHelp': '附加在分享消息首行的经济利益披露（推荐·代言审查指南）。“可能获得”等附条件表述不被认可。最多300字。',
  'pages.shareRebate.settings.error.intRange': '请输入{min}~{max}之间的整数。',
  'pages.shareRebate.settings.error.rateRange': '{cell}：必须在0~{max}%之间。',
  'pages.shareRebate.settings.error.ratePrecision': '{cell}：最多可输入两位小数。',
  'pages.shareRebate.settings.error.sourceTotal': '{source}：第1~3层合计{total}超过{max}%。',
  'pages.shareRebate.settings.error.gridInvalid': '请修正比例表。',
  'pages.shareRebate.settings.error.disclosureRequired': '请输入公开文案。',
  'pages.shareRebate.settings.error.disclosureTooLong': '最多可输入{max}字。',
  'pages.shareRebate.settings.error.fixFirst': '请先修正输入错误。',
  'pages.shareRebate.settings.noChanges': '没有变更内容。',
  'pages.shareRebate.settings.unsaved': '未保存的变更 {n} 项',
  'pages.shareRebate.settings.noUnsaved': '无变更',
  'pages.shareRebate.settings.reset': '还原',
  'pages.shareRebate.settings.save': '保存',
  'pages.shareRebate.settings.saveSuccess': '已保存分享返利设置。',
  'pages.shareRebate.settings.saveFailed': '保存失败。',
  'pages.shareRebate.settings.confirm.title': '确认设置变更',
  'pages.shareRebate.settings.confirm.intro': '以下 {n} 项将被变更。',
  'pages.shareRebate.settings.confirm.reason': '变更原因',
  'pages.shareRebate.settings.confirm.reasonPlaceholder': '请填写变更原因，将记录在变更历史中。',
  'pages.shareRebate.settings.confirm.appliesToNew': '变更后的比例从保存后新归属的订单开始适用，已归属的订单保持当时的比例。',
  'pages.shareRebate.settings.conflict.title': '其他管理员已先保存',
  'pages.shareRebate.settings.conflict.content': '其他管理员已先保存了设置。请刷新加载最新值后再保存。（当前输入的值将丢失）',
  'pages.shareRebate.settings.conflict.reload': '刷新',
  'pages.shareRebate.settings.change.field': '项目',
  'pages.shareRebate.settings.change.before': '变更前',
  'pages.shareRebate.settings.change.after': '变更后',
  'pages.shareRebate.settings.history.title': '变更历史',
  'pages.shareRebate.settings.history.version': '版本',
  'pages.shareRebate.settings.history.changes': '变更项目',
  'pages.shareRebate.settings.history.more': '等{n}项',
  'pages.shareRebate.settings.history.noChanges': '无变更项目',
  'pages.shareRebate.settings.history.admin': '管理员',
  'pages.shareRebate.settings.history.reason': '原因',
  'pages.shareRebate.settings.history.time': '时间 (KST)',
  'pages.shareRebate.settings.value.on': '开启',
  'pages.shareRebate.settings.value.off': '关闭',
  'pages.shareRebate.settings.value.none': '无',
  'pages.shareRebate.settings.value.days': '{n}天',
  'pages.shareRebate.settings.value.krw': '{amount}韩元',
  'pages.shareRebate.monitor.tab.dashboard': '仪表盘',
  'pages.shareRebate.monitor.tab.records': '明细',
  'pages.shareRebate.monitor.tab.sharers': '分享者',
  'pages.shareRebate.monitor.loadFailed': '加载失败。',
  'pages.shareRebate.monitor.dashboard.range': '期间',
  'pages.shareRebate.monitor.dashboard.last30': '最近30天',
  'pages.shareRebate.monitor.dashboard.kstNote': '日期按韩国时间（KST）计算。',
  'pages.shareRebate.monitor.kpi.visits': '访问',
  'pages.shareRebate.monitor.kpi.uniqueVisitors': '独立访客',
  'pages.shareRebate.monitor.kpi.attributedOrders': '归属订单',
  'pages.shareRebate.monitor.kpi.conversionRate': '转化率',
  'pages.shareRebate.monitor.kpi.conversionHint': '归属订单 ÷ 访问',
  'pages.shareRebate.monitor.kpi.attributedGmv': '归属销售额',
  'pages.shareRebate.monitor.kpi.attributedGmvHint': '优惠券后商品金额合计（进行中·已结算）',
  'pages.shareRebate.monitor.kpi.pending': '待入账（含暂扣）',
  'pages.shareRebate.monitor.kpi.confirmed': '已确认',
  'pages.shareRebate.monitor.kpi.paid': '已发放（扣除追回）',
  'pages.shareRebate.monitor.kpi.reversed': '已追回',
  'pages.shareRebate.monitor.chart.title': '每日趋势',
  'pages.shareRebate.monitor.chart.visits': '访问',
  'pages.shareRebate.monitor.chart.orders': '归属订单',
  'pages.shareRebate.monitor.chart.rebate': '返利金额（韩元）',
  'pages.shareRebate.monitor.byTier.title': '按层级',
  'pages.shareRebate.monitor.byTier.tier': '层级',
  'pages.shareRebate.monitor.byTier.rows': '笔数',
  'pages.shareRebate.monitor.byTier.open': '未发放',
  'pages.shareRebate.monitor.byTier.paid': '已发放',
  'pages.shareRebate.monitor.top.recipientsTitle': '领取人 TOP',
  'pages.shareRebate.monitor.top.productsTitle': '商品 TOP',
  'pages.shareRebate.monitor.top.member': '会员',
  'pages.shareRebate.monitor.top.product': '商品',
  'pages.shareRebate.monitor.top.source': '来源',
  'pages.shareRebate.monitor.top.orders': '订单',
  'pages.shareRebate.monitor.top.net': '归属金额',
  'pages.shareRebate.monitor.health.title': '结算状态',
  'pages.shareRebate.monitor.health.failedTasks': '失败任务',
  'pages.shareRebate.monitor.health.needsReview': '需审核',
  'pages.shareRebate.monitor.health.awaitingPayment': '待付款归属',
  'pages.shareRebate.monitor.health.runNow': '立即执行结算',
  'pages.shareRebate.monitor.health.runNowConfirm': '现在执行结算吗？',
  'pages.shareRebate.monitor.health.runNowContent': '执行一次付款确认·确认判定·发放（自动发放模式）。每2分钟也会自动执行。',
  'pages.shareRebate.monitor.health.runNowDone': '结算执行完成 — 任务 {tasks} · 激活 {activated} · 复核 {reconciled} · 发放 {paid}（{ms}ms）',
  'pages.shareRebate.monitor.health.runNowSkipped': '结算正在执行中，请稍后再试。',
  'pages.shareRebate.monitor.health.attributionsInRange': '期间内归属：',
  'pages.shareRebate.monitor.tasks.title': '失败任务',
  'pages.shareRebate.monitor.tasks.type': '类型',
  'pages.shareRebate.monitor.tasks.ref': '对象',
  'pages.shareRebate.monitor.tasks.attempts': '尝试',
  'pages.shareRebate.monitor.tasks.lastError': '最后错误',
  'pages.shareRebate.monitor.tasks.updatedAt': '时间',
  'pages.shareRebate.monitor.tasks.retry': '重试',
  'pages.shareRebate.monitor.tasks.retrySuccess': '已预约重试，将在下一个结算周期执行。',
  'pages.shareRebate.monitor.tasks.empty': '没有失败任务。',
  'pages.shareRebate.monitor.review.title': '需审核归属',
  'pages.shareRebate.monitor.review.order': '订单',
  'pages.shareRebate.monitor.review.riskFlags': '风险标记',
  'pages.shareRebate.monitor.review.reconcile': '复核',
  'pages.shareRebate.monitor.review.reconcileSuccess': '已重新复核。',
  'pages.shareRebate.monitor.review.empty': '没有需审核的归属。',
  'pages.shareRebate.monitor.records.filter.from': '开始日期 (KST)',
  'pages.shareRebate.monitor.records.filter.to': '结束日期 (KST)',
  'pages.shareRebate.monitor.records.filter.statusAll': '全部状态',
  'pages.shareRebate.monitor.records.filter.tier': '层级',
  'pages.shareRebate.monitor.records.filter.source': '来源',
  'pages.shareRebate.monitor.records.filter.recipient': '领取人（会员编号·姓名）',
  'pages.shareRebate.monitor.records.filter.sharer': '分享者（会员编号·姓名）',
  'pages.shareRebate.monitor.records.filter.buyer': '买家（会员编号·姓名）',
  'pages.shareRebate.monitor.records.filter.orderNo': '订单号',
  'pages.shareRebate.monitor.records.filter.code': '明细编码',
  'pages.shareRebate.monitor.records.filter.attribution': '仅显示归属 …{id} 的各层明细',
  'pages.shareRebate.monitor.records.totals': '筛选合计',
  'pages.shareRebate.monitor.records.col.code': '编码',
  'pages.shareRebate.monitor.records.col.createdAt': '创建时间',
  'pages.shareRebate.monitor.records.col.status': '状态',
  'pages.shareRebate.monitor.records.col.tier': '层级',
  'pages.shareRebate.monitor.records.col.recipient': '领取人',
  'pages.shareRebate.monitor.records.col.sharer': '分享者',
  'pages.shareRebate.monitor.records.col.buyer': '买家',
  'pages.shareRebate.monitor.records.col.orderNo': '订单号',
  'pages.shareRebate.monitor.records.col.sources': '来源 %',
  'pages.shareRebate.monitor.records.col.base': '基准金额',
  'pages.shareRebate.monitor.records.col.amount': '当前金额',
  'pages.shareRebate.monitor.records.col.paid': '已发放',
  'pages.shareRebate.monitor.records.col.forfeited': '上限作废',
  'pages.shareRebate.monitor.records.col.reversed': '已追回',
  'pages.shareRebate.monitor.records.col.eligibleAt': '出库完成（入账依据）',
  'pages.shareRebate.monitor.records.col.paidAt': '发放时间',
  'pages.shareRebate.monitor.records.col.actions': '操作',
  'pages.shareRebate.monitor.records.productMore': '{title} 等{n}件',
  'pages.shareRebate.monitor.records.amountReduced': '计提 {gross} · 扣减 {reduction}',
  'pages.shareRebate.monitor.records.sourceTooltip': '基准 ₩{base} → 返利 ₩{amount}',
  'pages.shareRebate.monitor.records.deemed': '视为签收',
  'pages.shareRebate.monitor.records.deemedHint': '没有签收记录，按出库后期限视为已签收。',
  'pages.shareRebate.monitor.records.manualConfirm': '手动确认',
  'pages.shareRebate.monitor.records.sameAttribution': '只看同一归属的各层明细',
  'pages.shareRebate.monitor.records.action.hold': '暂扣',
  'pages.shareRebate.monitor.records.action.release': '解除暂扣',
  'pages.shareRebate.monitor.records.action.cancel': '取消',
  'pages.shareRebate.monitor.records.action.confirm': '立即确认',
  'pages.shareRebate.monitor.records.action.reverse': '追回',
  'pages.shareRebate.monitor.records.action.pay': '批准发放',
  'pages.shareRebate.monitor.records.action.holdDesc': '暂扣 {code}。暂扣期间不会确认·发放。',
  'pages.shareRebate.monitor.records.action.releaseDesc': '解除 {code} 的暂扣并恢复为待入账。若订单已出库，将在下次检查时确认·发放。',
  'pages.shareRebate.monitor.records.action.cancelDesc': '取消 {code}。待发放金额 ₩{amount} 将不再发放，且无法撤销。',
  'pages.shareRebate.monitor.records.action.confirmDesc': '不等待出库，直接确认 {code} 所属的整个归属（自动发放模式下立即发放）。退款处理中的订单无法确认。',
  'pages.shareRebate.monitor.records.action.reverseDesc': '从预存款中追回 {code} 已发放中剩余的 ₩{outstanding}。无法撤销。',
  'pages.shareRebate.monitor.records.action.payDesc': '现在将 {code} 的 ₩{amount} 发放到预存款。',
  'pages.shareRebate.monitor.records.action.payConfirmTitle': '批准发放',
  'pages.shareRebate.monitor.records.action.modalTitle': '{action} — {code}',
  'pages.shareRebate.monitor.records.action.success': '{code}：{action} 完成',
  'pages.shareRebate.monitor.sharers.searchPlaceholder': '会员编号·账号·昵称·邮箱',
  'pages.shareRebate.monitor.sharers.col.member': '会员',
  'pages.shareRebate.monitor.sharers.col.sponsor': '上级',
  'pages.shareRebate.monitor.sharers.col.suspended': '状态',
  'pages.shareRebate.monitor.sharers.col.directDownline': '直接团队成员',
  'pages.shareRebate.monitor.sharers.col.visits': '访问',
  'pages.shareRebate.monitor.sharers.col.rows': '明细',
  'pages.shareRebate.monitor.sharers.col.open': '未发放',
  'pages.shareRebate.monitor.sharers.col.paid': '已发放',
  'pages.shareRebate.monitor.sharers.col.actions': '操作',
  'pages.shareRebate.monitor.sharers.noSponsor': '无',
  'pages.shareRebate.monitor.sharers.suspendedTag': '已停用',
  'pages.shareRebate.monitor.sharers.activeTag': '正常',
  'pages.shareRebate.monitor.sharers.detail': '详情',
  'pages.shareRebate.monitor.sharers.drawerTitle': '分享者详情',
  'pages.shareRebate.monitor.sharers.member': '会员',
  'pages.shareRebate.monitor.sharers.userId': '账号',
  'pages.shareRebate.monitor.sharers.email': '邮箱',
  'pages.shareRebate.monitor.sharers.phone': '电话',
  'pages.shareRebate.monitor.sharers.joinedAt': '注册日期',
  'pages.shareRebate.monitor.sharers.shareLinks': '分享链接',
  'pages.shareRebate.monitor.sharers.visits': '访问',
  'pages.shareRebate.monitor.sharers.visitsValue': '{total}（最近30天 {recent}）',
  'pages.shareRebate.monitor.sharers.attributedOrders': '归属订单',
  'pages.shareRebate.monitor.sharers.cancelled': '已取消',
  'pages.shareRebate.monitor.sharers.suspendedInfo': '已停用 — {time} · {admin} · {reason}',
  'pages.shareRebate.monitor.sharers.sponsorTitle': '上级',
  'pages.shareRebate.monitor.sharers.sponsorCurrent': '当前上级',
  'pages.shareRebate.monitor.sharers.sponsorSource': '指定方式',
  'pages.shareRebate.monitor.sharers.sponsorAssignedAt': '指定时间',
  'pages.shareRebate.monitor.sharers.sponsorPick': '搜索新上级（会员编号·昵称）',
  'pages.shareRebate.monitor.sharers.sponsorNotFound': '未找到会员',
  'pages.shareRebate.monitor.sharers.sponsorChange': '变更上级',
  'pages.shareRebate.monitor.sharers.sponsorClear': '清除上级',
  'pages.shareRebate.monitor.sharers.sponsorSelf': '不能将自己指定为上级。',
  'pages.shareRebate.monitor.sharers.sponsorHint': '变更上级后从之后归属的订单开始适用，已有明细不变。服务器会阻止循环关系。',
  'pages.shareRebate.monitor.sharers.sponsorChangeDesc': '将 {member} 的上级从 {from} 变更为 {to}。',
  'pages.shareRebate.monitor.sharers.sponsorClearDesc': '清除 {member} 的上级（{from}）。之后的归属将不再有第2·3层。',
  'pages.shareRebate.monitor.sharers.suspend': '停用分享者',
  'pages.shareRebate.monitor.sharers.suspendDesc': '停用 {member}。所有待入账·已确认明细将被暂扣，停用期间无法获得分享返利。',
  'pages.shareRebate.monitor.sharers.unsuspend': '解除停用',
  'pages.shareRebate.monitor.sharers.unsuspendDesc': '解除 {member} 的停用。被暂扣的明细不会自动解除，请在明细标签中逐条解除暂扣。',
  'pages.shareRebate.monitor.sharers.actionSuccess': '已生效。',
  'pages.shareRebate.monitor.sharers.actionFailed': '处理失败。',
  'pages.shareRebate.monitor.sharers.downlineTab': '团队（{tier1}/{tier2}/{tier3}）',
  'pages.shareRebate.monitor.sharers.downlineCounts': '直接 {tier1}人 · 第2级 {tier2}人 · 第3级 {tier3}人（下方为直接邀请的团队成员，最多100人）',
  'pages.shareRebate.monitor.sharers.visitsTab': '最近访问',
  'pages.shareRebate.monitor.sharers.visitTime': '时间',
  'pages.shareRebate.monitor.sharers.visitLanding': '落地路径',
  'pages.shareRebate.monitor.sharers.visitChannel': '渠道',
  'pages.shareRebate.monitor.sharers.visitBuyer': '买家',
  'pages.shareRebate.monitor.sharers.visitAttributed': '归属',
  'pages.shareRebate.monitor.sharers.rowsTab': '最近明细',
  'pages.shareRebate.monitor.sharers.viewAllRows': '查看该会员的全部明细',
  'pages.shareRebate.monitor.sharers.historyTab': '关系历史',
  'pages.shareRebate.monitor.sharers.historyTime': '时间',
  'pages.shareRebate.monitor.sharers.historyAction': '类型',
  'pages.shareRebate.monitor.sharers.historyChange': '变更',
  'pages.shareRebate.monitor.sharers.historySource': '方式',
  'pages.shareRebate.monitor.sharers.historyAdmin': '管理员',
  'pages.shareRebate.monitor.sharers.historyReason': '原因',
  'pages.orders.detail.shareAttribution.title': '分享归属',
  'pages.orders.detail.shareAttribution.sharer': '分享者',
  'pages.orders.detail.shareAttribution.buyer': '买家',
  'pages.orders.detail.shareAttribution.attributedAt': '归属时间',
  'pages.orders.detail.shareAttribution.visit': '访问',
  'pages.orders.detail.shareAttribution.visitId': '访问 ID {id}',
  'pages.orders.detail.shareAttribution.delivered': '签收',
  'pages.orders.detail.shareAttribution.deemed': '视为',
  'pages.orders.detail.shareAttribution.eligible': '出库完成',
  'pages.orders.detail.shareAttribution.manualConfirm': '手动确认',
  'pages.orders.detail.shareAttribution.totalNet': '归属金额',
  'pages.orders.detail.shareAttribution.riskFlags': '风险标记',
  'pages.orders.detail.shareAttribution.none': '无',
  'pages.orders.detail.shareAttribution.skipped': '跳过的层级',
  'pages.orders.detail.shareAttribution.viewRecords': '在分享返利明细中查看',
  'pages.orders.detail.shareAttribution.tier': '层级',
  'pages.orders.detail.shareAttribution.recipient': '领取人',
  'pages.orders.detail.shareAttribution.rate': '比例',
  'pages.orders.detail.shareAttribution.amount': '金额',
  'pages.orders.detail.shareAttribution.paid': '已发放',
  'pages.orders.detail.shareAttribution.status': '状态',
  'pages.orders.detail.shareAttribution.noRows': '尚无各层明细（付款确认前）',
  'pages.orders.detail.shareAttribution.lines': '归属商品',
  'pages.orders.detail.shareAttribution.product': '商品',
  'pages.orders.detail.shareAttribution.source': '来源',
  'pages.orders.detail.shareAttribution.quantity': '数量',
  'pages.orders.detail.shareAttribution.net': '归属金额',
  'pages.orders.detail.shareAttribution.netHint': '商品金额 ₩{gross} × 优惠券系数 {factor}',
  // 分享返利 round 2 — 讲师 · 团队 · 业绩（漏斗）
  'pages.orders.detail.shareAttribution.instructorRate': '讲师费率',
  'pages.orders.detail.shareAttribution.instructorRateHint': '下单时领取人是讲师，因此该层按讲师费率计算。',
  'pages.shareRebate.role.member': '普通',
  'pages.shareRebate.role.instructor': '讲师',
  'pages.shareRebate.relationSource.join': '加入讲师团队',
  'pages.shareRebate.reasonModal.labelOptional': '原因（选填）',
  'pages.shareRebate.reasonModal.memoLabel': '内部备注',
  'pages.shareRebate.reasonModal.memoHelp': '仅管理员可见，不会显示给会员。',
  'pages.shareRebate.reasonModal.memoPlaceholder': '审核备注、联系记录等',
  'pages.shareRebate.settings.section.instructorRates': '讲师费率 — 层级 × 来源 (%)',
  'pages.shareRebate.settings.field.memberRate': '普通费率 · {tier} · {source}',
  'pages.shareRebate.settings.field.instructorRate': '讲师费率 · {tier} · {source}',
  'pages.shareRebate.settings.instructor.hint': '领取人是已批准的讲师时，该层按此表计算。角色在下单（结算）时确定，因此取消讲师后已产生的返利保持不变。初始值与普通费率相同。',
  'pages.shareRebate.settings.instructor.diffCount': '与普通费率不同的格子 {n} 个',
  'pages.shareRebate.settings.instructor.sameAsMember': '与普通费率相同',
  'pages.shareRebate.settings.instructor.copyFromMember': '复制普通费率',
  'pages.shareRebate.settings.instructor.copyHint': '把讲师表设为与当前普通费率表相同。保存后生效。',
  'pages.shareRebate.settings.instructor.cellDiff': '普通费率 {member}',
  'pages.shareRebate.settings.instructor.tableTotal': '讲师表合计',
  'pages.shareRebate.settings.instructor.mixedTotal': '混合最大合计',
  'pages.shareRebate.settings.instructor.mixedTotalHint': '一笔订单的链条中可能同时有普通会员和讲师（例如第1层是普通会员、第2层是讲师）。因此对每个来源，按层取普通与讲师费率中较大者相加的合计，也不能超过 {max}%。',
  'pages.shareRebate.settings.instructor.legalBoth': '同时检查普通费率和讲师费率两张表。',
  'pages.shareRebate.settings.error.mixedTotal': '{source}：混合最大合计 {total} 超过 {max}%。请降低讲师费率，或点击［复制普通费率］。',
  'pages.shareRebate.monitor.tab.instructors': '讲师',
  'pages.shareRebate.monitor.tab.instructorsPending': '待审核 {n} 件',
  'pages.shareRebate.monitor.instructors.title': '讲师',
  'pages.shareRebate.monitor.instructors.approved': '已批准讲师',
  'pages.shareRebate.monitor.instructors.pending': '待审核',
  'pages.shareRebate.monitor.instructors.viewList': '讲师列表',
  'pages.shareRebate.monitor.instructors.review': '去审核',
  'pages.shareRebate.monitor.instructors.byRoleHint': '期间内产生的返利按领取人角色汇总（不含取消）',
  'pages.shareRebate.monitor.instructors.role': '类别',
  'pages.shareRebate.monitor.instructors.topTitle': '讲师排行',
  'pages.shareRebate.monitor.instructors.member': '讲师',
  'pages.shareRebate.monitor.instructors.rowsHint': '期间内按讲师费率产生的返利笔数',
  'pages.shareRebate.monitor.instructors.teamRows': '经团队',
  'pages.shareRebate.monitor.instructors.teamRowsHint': '其中通过团队成员链接进来的订单（第2·3层）笔数',
  'pages.shareRebate.monitor.instructors.topEmpty': '期间内没有按讲师费率产生的返利。',
  'pages.shareRebate.monitor.records.filter.recipientRole': '领取人类别',
  'pages.shareRebate.monitor.records.col.recipientRole': '领取人类别',
  'pages.shareRebate.monitor.records.col.recipientRoleHint': '下单时的角色。讲师行按讲师费率计算。',
  'pages.shareRebate.monitor.records.via': '经由',
  'pages.shareRebate.monitor.records.viaHint': '领取人直接邀请的团队成员。订单来自该成员（第2层）或该成员邀请的人（第3层）的链接。',
  'pages.shareRebate.monitor.sharers.col.role': '角色',
  'pages.shareRebate.monitor.sharers.col.roleHint': '当前是否为已批准的讲师。',
  'pages.shareRebate.monitor.sharers.filter.role': '角色',
  'pages.shareRebate.monitor.sharers.performanceTab': '业绩',
  'pages.shareRebate.instructor.tag': '讲师',
  'pages.shareRebate.instructor.tagTooltip': '讲师名称：{name}',
  'pages.shareRebate.instructor.status.pending': '待审核',
  'pages.shareRebate.instructor.status.approved': '已批准',
  'pages.shareRebate.instructor.status.rejected': '已驳回',
  'pages.shareRebate.instructor.status.revoked': '已取消资格',
  'pages.shareRebate.instructor.status.withdrawn': '已撤回申请',
  'pages.shareRebate.instructor.status.none': '未申请',
  'pages.shareRebate.instructor.filter.all': '全部',
  'pages.shareRebate.instructor.history.applied': '申请',
  'pages.shareRebate.instructor.history.updated': '修改申请',
  'pages.shareRebate.instructor.history.approved': '批准',
  'pages.shareRebate.instructor.history.rejected': '驳回',
  'pages.shareRebate.instructor.history.revoked': '取消资格',
  'pages.shareRebate.instructor.history.withdrawn': '撤回申请',
  'pages.shareRebate.instructor.history.designated': '管理员指定',
  'pages.shareRebate.instructor.searchPlaceholder': '讲师名称·会员编号·账号·昵称·邮箱',
  'pages.shareRebate.instructor.pendingHint': '待审核的申请按申请时间从早到晚排列。',
  'pages.shareRebate.instructor.empty': '没有符合条件的讲师。',
  'pages.shareRebate.instructor.emptyPending': '没有待审核的讲师申请。',
  'pages.shareRebate.instructor.col.member': '会员',
  'pages.shareRebate.instructor.col.displayName': '讲师名称',
  'pages.shareRebate.instructor.col.application': '申请内容',
  'pages.shareRebate.instructor.col.status': '状态',
  'pages.shareRebate.instructor.col.team': '团队（直接/第2级/第3级）',
  'pages.shareRebate.instructor.col.teamHint': '该讲师的团队成员数 — 直接邀请的人 / 他们邀请的人 / 再下一级',
  'pages.shareRebate.instructor.col.mine30': '30天 本人链接',
  'pages.shareRebate.instructor.col.mine30Hint': '最近30天打开该讲师链接的人、其中付款的人，以及该讲师的第1层返利',
  'pages.shareRebate.instructor.col.team30': '30天 团队',
  'pages.shareRebate.instructor.col.team30Hint': '最近30天打开团队成员（直接·第2级）链接的人、其中付款的人，以及该讲师的第2·3层返利',
  'pages.shareRebate.instructor.col.totals': '累计返利',
  'pages.shareRebate.instructor.col.totalsHint': '全部期间 — 已发放（扣除追回）与未发放（待入账·暂扣·已确认）',
  'pages.shareRebate.instructor.col.actions': '处理',
  'pages.shareRebate.instructor.perf.counts': '访客 {visitors} · 付款 {payers}',
  'pages.shareRebate.instructor.perf.rebate': '返利',
  'pages.shareRebate.instructor.perf.activeSharers': '活跃团队成员 {n} 人',
  'pages.shareRebate.instructor.teamTooltip': '直接 {tier1} 人 · 第2级 {tier2} 人 · 第3级 {tier3} 人',
  'pages.shareRebate.instructor.displayNamePreview': '通过链接进来的人看到的是“{name} 讲师”。',
  'pages.shareRebate.instructor.noIntro': '无简介',
  'pages.shareRebate.instructor.appliedAt': '申请 {time}',
  'pages.shareRebate.instructor.decidedAt': '{time} · {admin}',
  'pages.shareRebate.instructor.memberReason': '向会员显示的原因：{reason}',
  'pages.shareRebate.instructor.memoTooltip': '内部备注：{memo}',
  'pages.shareRebate.instructor.memberVisibleNotice': '此原因会显示在会员的“我的页面”上。',
  'pages.shareRebate.instructor.action.approve': '批准',
  'pages.shareRebate.instructor.action.reject': '驳回',
  'pages.shareRebate.instructor.action.revoke': '取消讲师',
  'pages.shareRebate.instructor.action.designate': '指定为讲师',
  'pages.shareRebate.instructor.action.designateNew': '直接指定讲师',
  'pages.shareRebate.instructor.action.memo': '备注',
  'pages.shareRebate.instructor.action.failed': '处理失败。',
  'pages.shareRebate.instructor.approve.title': '批准讲师 — {member}',
  'pages.shareRebate.instructor.approve.desc': '批准 {member} 为讲师。此后的新订单按讲师费率计算，通过链接进来的人看到的是“{name} 讲师”。没有邀请人的老会员打开该链接时，也会看到加入团队的提示。',
  'pages.shareRebate.instructor.approve.reasonPlaceholder': '批准备注（选填）。只记录在处理历史中，会员看不到。',
  'pages.shareRebate.instructor.approve.success': '已批准 {member} 为讲师。',
  'pages.shareRebate.instructor.reject.title': '驳回讲师申请 — {member}',
  'pages.shareRebate.instructor.reject.desc': '驳回 {member} 的讲师申请。会员可以看到原因并重新申请。',
  'pages.shareRebate.instructor.reject.reasonPlaceholder': '请填写给会员看的原因。例：无法确认频道地址。',
  'pages.shareRebate.instructor.reject.success': '已驳回 {member} 的讲师申请。',
  'pages.shareRebate.instructor.revoke.title': '取消讲师 — {member}',
  'pages.shareRebate.instructor.revoke.desc': '取消讲师“{name}”。新订单起按普通费率计算，链接上也不再显示加入团队的提示。已产生的返利和团队（邀请人关系）保持不变。',
  'pages.shareRebate.instructor.revoke.reasonPlaceholder': '请填写给会员看的原因。',
  'pages.shareRebate.instructor.revoke.success': '已取消 {member} 的讲师资格。',
  'pages.shareRebate.instructor.memo.title': '内部备注 — {member}',
  'pages.shareRebate.instructor.memo.help': '会员看不到。清空后保存即删除备注。',
  'pages.shareRebate.instructor.memo.success': '已保存内部备注。',
  'pages.shareRebate.instructor.designate.title': '直接指定讲师',
  'pages.shareRebate.instructor.designate.ok': '指定为讲师',
  'pages.shareRebate.instructor.designate.intro': '无需申请，直接批准。之前的申请或驳回记录会被替换，此后的新订单按讲师费率计算。',
  'pages.shareRebate.instructor.designate.member': '会员',
  'pages.shareRebate.instructor.designate.memberPlaceholder': '按会员编号·昵称·账号搜索',
  'pages.shareRebate.instructor.designate.memberRequired': '请选择会员。',
  'pages.shareRebate.instructor.designate.reasonHelp': '只记录在处理历史中。',
  'pages.shareRebate.instructor.designate.success': '已指定为讲师。',
  'pages.shareRebate.instructor.designate.footnote': '已批准的讲师不能再次指定。',
  'pages.shareRebate.instructor.field.displayName': '讲师名称',
  'pages.shareRebate.instructor.field.displayNameHelp': '通过链接进来的人看到的公开名称，显示为“OOO 讲师”。2~20个字，结尾不要加“강사”或“강사님”。',
  'pages.shareRebate.instructor.field.intro': '简介',
  'pages.shareRebate.instructor.field.introOptional': '简介（选填）',
  'pages.shareRebate.instructor.field.channel': '频道',
  'pages.shareRebate.instructor.field.channelOptional': '频道地址（选填）',
  'pages.shareRebate.instructor.field.phone': '联系方式',
  'pages.shareRebate.instructor.field.phoneOptional': '联系方式（选填）',
  'pages.shareRebate.instructor.field.phoneHelp': '仅管理员可见。',
  'pages.shareRebate.instructor.field.appliedAt': '申请日期',
  'pages.shareRebate.instructor.field.decided': '处理',
  'pages.shareRebate.instructor.field.memberReason': '向会员显示的原因',
  'pages.shareRebate.instructor.error.displayNameLength': '讲师名称请填写 {min}~{max} 个字。',
  'pages.shareRebate.instructor.error.displayNameSuffix': '名称结尾不要加“강사”或“강사님”，页面会自动加上称呼。',
  'pages.shareRebate.instructor.error.introLength': '简介请填写 {min}~{max} 个字。',
  'pages.shareRebate.instructor.error.channel': '请填写以 http:// 或 https:// 开头、不超过 {max} 个字符的地址。',
  'pages.shareRebate.instructor.error.phone': '请用数字和连字符（-）填写 {min}~{max} 个字符。',
  'pages.shareRebate.instructor.card.title': '讲师',
  'pages.shareRebate.instructor.card.none': '该会员没有讲师申请记录。',
  'pages.shareRebate.instructor.card.history': '处理历史',
  'pages.shareRebate.funnel.period.today': '今天',
  'pages.shareRebate.funnel.period.7d': '7天',
  'pages.shareRebate.funnel.period.30d': '30天',
  'pages.shareRebate.funnel.period.90d': '90天',
  'pages.shareRebate.funnel.period.all': '全部',
  'pages.shareRebate.funnel.scope.mine': '本人链接',
  'pages.shareRebate.funnel.scope.team': '团队',
  'pages.shareRebate.funnel.scope.mineHint': '期间内打开该会员链接的人带来的注册·下单·付款，以及该会员的第1层返利。期间结束后才下的单也计入当次访问。',
  'pages.shareRebate.funnel.scope.teamHint': '期间内打开直接团队成员及其邀请的人的链接的人带来的下单·付款，以及该会员的第2·3层返利。',
  'pages.shareRebate.funnel.range': '{from} ~ {to}（KST）',
  'pages.shareRebate.funnel.rangeAll': '全部期间 ~ {to}（KST）',
  'pages.shareRebate.funnel.team.counts': '团队：直接 {tier1} 人 · 第2级 {tier2} 人 · 第3级 {tier3} 人 · 期间内有链接访问的成员 {active} 人',
  'pages.shareRebate.funnel.step.visitors': '访客',
  'pages.shareRebate.funnel.step.visitsSub': '访问 {n} 次',
  'pages.shareRebate.funnel.step.orderers': '下单人',
  'pages.shareRebate.funnel.step.ordersSub': '订单 {n} 笔',
  'pages.shareRebate.funnel.step.payers': '付款人',
  'pages.shareRebate.funnel.step.paidSub': '付款 {n} 笔',
  'pages.shareRebate.funnel.step.paidGmvSub': '付款 {n} 笔 · ₩{amount}',
  'pages.shareRebate.funnel.orderRate': '下单转化',
  'pages.shareRebate.funnel.orderRateHint': '下单人 ÷ 访客',
  'pages.shareRebate.funnel.payRate': '付款转化',
  'pages.shareRebate.funnel.payRateHint': '付款人 ÷ 下单人',
  'pages.shareRebate.funnel.joins': '这些访问带来新注册 {signups} 人 · 加入团队 {joins} 人',
  'pages.shareRebate.funnel.rebate.total': '返利合计',
  'pages.shareRebate.funnel.rebate.totalHint': '待入账 + 已确认 + 已发放（扣除追回）。不含已取消的返利。',
  'pages.shareRebate.funnel.rebate.pending': '待入账',
  'pages.shareRebate.funnel.rebate.confirmed': '已确认',
  'pages.shareRebate.funnel.rebate.paid': '已发放',
  'pages.shareRebate.funnel.rebate.reversed': '追回 ₩{amount}',
  'pages.shareRebate.funnel.chart.daily': '每日趋势',
  'pages.shareRebate.funnel.chart.monthly': '每月趋势',
  'pages.shareRebate.funnel.chart.rebate': '返利（韩元）',
  'pages.shareRebate.funnel.empty': '该期间没有通过链接进来的访问。',
  'pages.shareRebate.funnel.emptyTeam': '该期间没有通过团队成员链接进来的访问。',
  'pages.shareRebate.funnel.cohortNote': '按访问日期归集的数字（之后发生的订单·返利也计入该次访问）。截至 {time}',
  'pages.shareRebate.funnel.notSupported': '服务器尚未提供业绩统计。',
  'pages.shareRebate.picks.tab': '推荐商品',
  'pages.shareRebate.picks.notSupported': '服务器尚未支持推荐商品页面。',
  'pages.shareRebate.picks.empty': '尚未创建推荐商品页面。',
  'pages.shareRebate.picks.emptyHint': '讲师在“我的页面”首次打开推荐商品时会创建页面。',
  'pages.shareRebate.picks.visible': '现在任何人都可以通过链接查看此页面。',
  'pages.shareRebate.picks.notVisible': '现在无法通过链接查看此页面。',
  'pages.shareRebate.picks.visibilityRule': '仅当讲师设为公开且管理员未隐藏时才会显示。否则通过链接进入的人会看到“无法查看的页面”。',
  'pages.shareRebate.picks.field.link': '页面链接',
  'pages.shareRebate.picks.field.published': '公开状态',
  'pages.shareRebate.picks.published': '公开',
  'pages.shareRebate.picks.unpublished': '不公开（讲师设置）',
  'pages.shareRebate.picks.field.adminHidden': '管理员隐藏',
  'pages.shareRebate.picks.adminHiddenOn': '已隐藏',
  'pages.shareRebate.picks.adminHiddenOff': '未隐藏',
  'pages.shareRebate.picks.adminHiddenSwitchHint': '打开即隐藏公开页面（必须填写原因）。关闭即取消隐藏。',
  'pages.shareRebate.picks.adminHiddenInfo': '{time} · {admin} · 原因：{reason}',
  'pages.shareRebate.picks.field.title': '页面标题',
  'pages.shareRebate.picks.defaultTitle': '{name} 讲师的推荐商品',
  'pages.shareRebate.picks.defaultTitleTag': '默认标题',
  'pages.shareRebate.picks.field.intro': '简介',
  'pages.shareRebate.picks.field.items': '商品',
  'pages.shareRebate.picks.counts': '固定 {pinned} · 自动 {auto} · 未显示 {off}',
  'pages.shareRebate.picks.field.autoSyncedAt': '自动列表计算时间',
  'pages.shareRebate.picks.field.autoSyncedAtHint': '讲师分享商品的排名（最近180天按付款人 → 访客 → 最近分享排序）会在上次计算10分钟后打开页面时重新计算。',
  'pages.shareRebate.picks.itemsTitle': '商品列表',
  'pages.shareRebate.picks.itemsHint': '先显示固定商品（讲师设定的顺序），再显示自动商品（按排名）。讲师隐藏、管理员隐藏或已停售的商品不会出现在公开页面。',
  'pages.shareRebate.picks.itemsEmpty': '暂无商品。',
  'pages.shareRebate.picks.col.image': '图片',
  'pages.shareRebate.picks.col.source': '来源',
  'pages.shareRebate.picks.col.title': '商品',
  'pages.shareRebate.picks.col.price': '价格',
  'pages.shareRebate.picks.col.origin': '类型',
  'pages.shareRebate.picks.col.status': '状态',
  'pages.shareRebate.picks.col.stats': '访客 · 付款人',
  'pages.shareRebate.picks.col.statsHint': '自动商品的排名依据 — 最近180天通过该商品分享链接进入的人数和付款人数',
  'pages.shareRebate.picks.col.adminHidden': '管理员隐藏',
  'pages.shareRebate.picks.col.adminHiddenHint': '打开后该商品不会出现在公开页面，讲师页面中仍保留。',
  'pages.shareRebate.picks.openProduct': '打开商品页面',
  'pages.shareRebate.picks.price.unknown': '未知',
  'pages.shareRebate.picks.price.unknownHint': '暂无价格信息，公开页面显示为“请在商品页面确认”。',
  'pages.shareRebate.picks.price.at': '截至 {time}',
  'pages.shareRebate.picks.origin.pinned': '固定',
  'pages.shareRebate.picks.origin.auto': '自动',
  'pages.shareRebate.picks.tag.instructorHidden': '讲师隐藏',
  'pages.shareRebate.picks.tag.soldOut': '已停售',
  'pages.shareRebate.picks.tag.adminHidden': '管理员隐藏',
  'pages.shareRebate.picks.tag.shown': '显示',
  'pages.shareRebate.picks.stats': '访客 {visitors} · 付款 {payers}',
  'pages.shareRebate.picks.hide.title': '隐藏推荐商品页面',
  'pages.shareRebate.picks.hide.desc': '隐藏 {name} 讲师的推荐商品页面。通过链接进入的人会看到“无法查看的页面”。商品和讲师设置保持不变，取消隐藏后即可恢复。',
  'pages.shareRebate.picks.hide.notice': '原因仅保留在管理员记录中，讲师看不到。',
  'pages.shareRebate.picks.hide.ok': '隐藏',
  'pages.shareRebate.picks.hide.success': '已隐藏推荐商品页面。',
  'pages.shareRebate.picks.unhide.title': '取消隐藏推荐商品页面',
  'pages.shareRebate.picks.unhide.desc': '取消隐藏 {name} 讲师的推荐商品页面，可再次通过链接查看。',
  'pages.shareRebate.picks.unhide.descUnpublished': '取消隐藏 {name} 讲师的推荐商品页面。讲师已设为不公开，取消后仍无法通过链接查看。',
  'pages.shareRebate.picks.unhide.ok': '取消隐藏',
  'pages.shareRebate.picks.unhide.success': '已取消隐藏推荐商品页面。',
  'pages.shareRebate.picks.item.hideSuccess': '已将该商品从公开页面移除。',
  'pages.shareRebate.picks.item.unhideSuccess': '该商品已重新显示在公开页面。',
  'pages.shareRebate.picks.actionFailed': '处理失败。',
};

